const languages = {
  en:{
	   reporting_center:"Reporting Center", 
	   grade_reports:"Grade Reports", 
	   user_reports:"User Reports", 
	   learning_reports:"Learning Reports", 
	   administrative_reports:"Administrative Reports", 
	   progress_report:"Progress Report", 
	   full_progress_report:"Full Progress Report", 
	   grade_report:"Grade Report", 
	   roster_report:"Roster Report", 
	   parent_report:"Parent Report", 
	   teacher_report:"Teacher Report", 
	   student_report:"Student Report", 
	   log_in_report:"Log In Report", 
	   enrollmentreport:"Enrollment Report", 
	   enrollment_summary:"Enrollment Summary", 
	   student_enrollment_summary:"Student Enrollment Summary", 
	   attendance_report:"Attendance Report", 
	   attendance_summary_report:"Attendance Summary Report", 
	   log_In_Credentials:"Log In Credentials", 
	   application_report:"Application Report", 
	   section_report:"Section Report", 
	   course_report:"Course Report", 
	   communication_summary:"Communication Summary", 
	   comments_and_Document_Report:"Comments and Document Report", 
	   School_Calendar:"School Calendar", 
	   bell_Schedule:"Bell Schedule", 
	   student_Contract:"Student Contract", 
	   eOS_Report:"EOS Report", 
	   active_Enrollments_Per_Term_Report:"Active Enrollments Per Term Report", 
	   active_Student_Enrollments_with_As_Report:"Active Student Enrollments with As Report", 
	   active_Student_Enrollments_Report:"Active Student Enrollments Report", 
	   all_Students_GPA_Report:"All Students GPA Report", 
	   old_All_Student_GPA_Report:"Old All Student GPA Report", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + Engagement Type Report", 
	   enrollment_Confirmation_Report:"Enrollment Confirmation Report", 
	   eOS_College_Matriculations_Report:"EOS College Matriculations Report", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Student Enrollment History To Date w Term Report", 
	   student_Information_Report:"Student Information Report", 
	   ran_by:"ran by", 
	   Show_Filter:"Show Filter", 
	   School_Group:"School Group", 
	   school:"School", 
	   department:"Department", 
	   student:"Student", 
	   student_status:"Student Status", 
	   course:"Course", 
	   course_level:"Course Level", 
	   section:"Section", 
	   teacher:"Teacher", 
	   primary_teacher:"Primary Teacher", 
	   secondary_teacher:"Secondary Teacher", 
	   completion_Date_Range:"Completion Date Range", 
	   from_date:"From Date", 
	   to_date:"To Date", 
	   status:"Status", 
	   gender:"Gender", 
	   final_grade:"Final Grade", 
	   advisor:"Advisor", 
	   grade_level:"Grade Level", 
	   specific_mark:"Specific Mark", 
	   track:"Track", 
	   ethnicity:"Ethnicity", 
	   additional_fields:"Additional Fields", 
	   school_sessions:"School Sessions", 
	   gradebook:"Gradebook", 
	   submit:"Submit", 
	   reset:"Reset", 
	   show_hide_columns:"Show/Hide Columns", 
	   select_all:"Select All", 
	   student_id:"Student ID", 
	   last_name:"Last Name", 
	   first_name:"First Name", 
	   start_date:"Start Date", 
	   end_date:"End Date", 
	   grade_final:"Grade Final", 
	   percent:"Percent", 
	   credit:"Credit", 
	   download_excel:"Download Excel", 
	   print:"Print", 
	   no_data:"No data.", 
	   view:"View", 
	   showing:"Showing", 
	   of:"of", 
	   other_grade:"Other Grade", 
	   level:"Level", 
	   date:"Date", 
	   grade:"Grade", 
	   enrollment_Change_Status:"Enrollment Change Status", 
	   close:"Close", 
	   select_Enrollment_Status:"Select Enrollment Status", 
	   select:"Select...", 
	   cancel:"Cancel", 
	   save:"Save", 
	   students:"Students", 
	   Course_Status:"Course Status", 
	   Closed_courses:"Closed courses", 
	   Section_Status:"Section Status", 
	   Closed_sections:"Closed sections", 
	   Transferred_From:"Transferred From", 
	   Graduation_From_Date:"Graduation From Date", 
	   Graduation_To_Date:"Graduation To Date", 
	   Enrollment_From_Date:"Enrollment From Date", 
	   Enrollment_To_Date:"Enrollment To Date", 
	   Enrollment_Status:"Enrollment Status", 
	   Transfer_From_Date:"Transfer From Date", 
	   Transfer_To_Date:"Transfer To Date", 
	   Custom_Query:"Custom Query", 
	   Last_Access_Date:"Last Access Date", 
	   Total_Session_Time:"Total Session Time", 
	   Quality_of_Work:"Quality of Work", 
	   Grade_to_Date:"Grade to Date", 
	   Overall_Percent:"Overall Percent", 
	   On_Schedule_Percent:"On Schedule Percent", 
	   Activity_Count_Complete:"Activity Count Complete", 
	   Activity_Count_Total:"Activity Count Total", 
	   Overdue_Activitie:"Overdue Activitie", 
	   Section_Course_Additional_Fields:"Section/Course Additional Fields", 
	   Create_On_Date:"Create On Date", 
	   Last_Status_Update_Date:"Last Status Update Date", 
	   Transferred_In:"Transferred In", 
	   Transferred_In_Date:"Transferred In Date", 
	   email:"Email", 
	   birth_date:"Birth date", 
	   course_name:"Course Name", 
	   section_name:"Section Name", 
	   school_name:"School Name", 
	   Graduation_Date:"Graduation Date", 
	   Created_on:"Created on", 
	   mentor_Advisor:"Mentor/Advisor", 
	   sections:"Sections", 
	   roster:"Roster", 
	   relationship:"Relationship", 
	   Email_or_Phone:"Email or Phone", 
	   Enter_any_text:"Enter any text", 
	   Advisor_Success_Manager:"Advisor / Success Manager", 
	   User_Id:"User ID", 
	   phone_number:"Phone Number", 
	   Student_Last_Name:"Student Last Name", 
	   Student_First_Name:"Student First Name", 
	   Student_Email:"Student Email", 
	   credentials:"Credentials", 
	   availability:"Availability", 
	   enrollments:"Enrollments", 
	   Datea_Created_on:"Date Created on", 
	   country:"Country", 
	   state:"State", 
	   zipcode:"Zipcode", 
	   Enter_any_zipcode:"Enter any zipcode", 
	   address:"Address", 
	   zip_Code:"Zip Code", 
	   Login_Report:"Login Report", 
	   user_Type:"User Type", 
	   user_Name:"User Name", 
	   Show_last_log_in_only:"Show last log in only", 
	   Username:"Username", 
	   Date_Time:"Date/Time", 
	   Ip_Address:"Ip Address", 
	   city:"City", 
	   Enrollment_Start_Date:"Enrollment Start Date", 
	   Enrollment_End_Date:"Enrollment End Date", 
	   Completion_Date:"Completion Date", 
	   section_Type:"Section Type", 
	   student_Enrolled:"Student Enrolled", 
	   content_Provider:"Content Provider", 
	   student_Additional_Fields:"Student Additional Fields",
	   type:"Type", 
	   in_Class_Information:"In Class Information", 
	   Enrollment_Summary_Report:"Enrollment Summary Report", 
	   Transferred_From_School:"Transferred From School", 
	   Total_Enrollments:"Total Enrollments", 
	   content_Type:"Content Type", 
	   active_Course_Progress:"Active Course Progress", 
	   Grades:"Grades", 
	   attendance:"Attendance", 
	   student_Absences:"Student Absences", 
	   total_Absence:"Total Absence", 
	   section_Absences:"Section Absences", 
	   Grade_Level_Absences:"Grade Level Absences", 
	   Gender_Absences:"Gender Absences", 
	   Login_credentials:"Login credentials", 
	   names:"Names", 
	   user_status_admin_teacher_parent:"User Status (Admin, Teacher, Parent)", 
	   show_title:"Show Title", 
	   midle_name:"Middle Name", 
	   password:"Password", 
	   parent_name:"Parent Name", 
	   linked_to_parent:"Linked To Parent", 
	   linked_to_student:"Linked To Student", 
	   login_credentials_Report:"Login credentials Report", 
	   app_id:"App Id", 
	   created:"Created", 
	   modified:"Modified", 
	   select_level:"Select level", 
	   select_additional_fields:"Section Additional Fields", 
	   title:"Title", 
	   credits:"Credits", 
	   section_ID:"Section ID", 
	   content:"Content", 
	   course_additional_fields:"Course Additional Fields", 
	   course_id:"Course ID", 
	   communication_summary_report:"Communication Summary Report", 
	   method:"Method", 
	   create_date:"Create Date", 
	   subject:"Subject", 
	   make_from_id:"Make From ID", 
	   make_to:"Make To", 
	   attachments:"Attachments", 
	   comment_and_document_summary_report:"Comment and Document Summary Report", 
	   comment_type:"Comment Type", 
	   flagged:"Flagged", 
	   sharing_target:"Sharing Target", 
	   show_on_transcript:"Show On Transcript", 
	   by:"By", 
	   comment:"Comment", 
	   type_name:"Type Name", 
	   effective_from_date:"Effective From Date", 
	   effective_to_date:"Effective To Date", 
	   count_docs:"Count Docs", 
	   school_calendar_report:"School Calendar Report", 
	   event_Id:"Event Id", 
	   date_start:"Date Start", 
	   date_end:"Date End", 
	   posted_last_name:"Posted Last Name", 
	   posted_first_name:"Posted First Name", 
	   bell_schedule_report:"Bell schedule Report", 
	   period:"Period", 
	   start:"Start", 
	   end:"End", 
	   student_contract_report:"Student Contract Report", 
	   begin_date:"Begin Date", 
	   contracts:"Contracts", 
	   contract_name:"Contract Name", 
	   contract_begin_date:"Contract Begin Date", 
	   contract_end_date:"Contract End Date", 
	   active_enrollments_per_term_report:"Active Enrollments Per Term Report", 
	   entry_date:"Entry Date", 
	   teachers:"Teachers", 
	   term:"Term", 
	  
	   sections:"Sections", 
	   showing_of:"Showing 10 of 20", 
	   filter:"Filter", 
	   students:"Students", 
	   school:"School", 
	   all_school:"All Schools", 
	   student:"Student", 
	   email:"Email", 
	   grade_level:"Grade Level", 
	   status:"Status", 
	   seach_for_a_student_or_id:"Search for a student or ID …", 
	   search:"Search …", 
	   message_student:"Message student", 
	   request_enrollment:"Request Enrollment", 
	   print_schedule:"Print Schedule", 
	   view:"View", 
	   no_data:"No data.", 
	   views:"Views", 
	   enrollment:"Enrollment", 
	   schedule:"Schedule", 
	   transferred_grades:"Transferred Grades", 
	   comments_ocuments:"Comments & Documents", 
	   academic_records:"Academic Records", 
	   compliance_log:"Compliance Log", 
	   unofficial_transcript:"Unofficial Transcript", 
	   iD_card:"ID Card", 
	   student_number_id_information:"Student Number #29561 Information", 
	   student_number:"Student Number", 
	   gender:"Gender", 
	   goes_by:"Goes by", 
	   date_of_birth:"Date of Birth", 
	   ethnicity:"Ethnicity", 
	   mobile:"Mobile", 
	   academic_track:"Academic Track", 
	   learning_path_template:"Learning Path Template", 
	   graduation_date:"Graduation Date", 
	   comments:"Comments", 
	   transfer_information:"Transfer Information", 
	   enrollment_date:"Enrollment Date", 
	   transfer_date:"Transfer Date", 
	   transfer_student:"Transfer Student", 
	   parent_mentor_contact:"Parent / Mentor Contact", 
	   mentor:"Mentor", 
	   parent_phone:"Parent's Phone", 
	   emergency_contact:"Emergency contact", 
	   academic_advisor_ssm:"Academic Advisor / SSM", 
	   student_success_manager:"Student Success Manager", 
	   academic_avisor:"Academic Advisor", 
	   address:"Address", 
	   address_01_Default:"Address 01 (Default)", 
	   street:"Street", 
	   city:"City", 
	   state:"State", 
	   zip:"Zip", 
	   hide_Detailed_information:"Hide Detailed information", 	    
	   current_course_progress:"Current Course Progress", 	    
	   full_Path_Progress:"Full Path Progress", 	    
	   print:"Print", 	    
	   avg_graduation_progress:"Avg. Graduation Progress", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Graduation Status", 	    
	   on_track:"On Track", 	    
	   show_detailed_information:"Show Detailed information", 	    
	   communication:"Communication", 	    
	   student_advisors:"Student Advisors", 	    
	   country:"Country", 	    
	   grade:"Grade", 	    
	   credits:"Credits", 	    
	   sort:"Sort", 	    
	   course_progress:"Course progress", 	    
	   overall_GPA:"Overall GPA", 	    
	   current_graduation_progress:"Current Graduation Progress", 	    
	   individual_course_progress:"*Individual course progress varies, this is your overall progress", 	    
	   subject:"Subject",
	   online_sections:"Online Sections",
	   course:"Course",
	   section:"Section", 
	   actions:"Actions", 
	   view_event:"View Event", 
	   in_class_section:"In Class Section",
	   calendar:"Calendar", 
	   access_link:"Access link", 
	   online_link:"Online link",
	   launch_course:"Launch Course", 
	   start_class:"Start Class", 
	   level:"Level", 
	   date:"Date", 
	   transferred_in:"Transferred In", 
	   tranferred_grades:"Transferred Grades", 
	   Searchs:"Search", 
	   Search_department_course:"Search department course, src…", 
	   archived:"Archived", 
	   add_comment:"Add Comment", 
	   created_date:"Created date", 
	   by:"By", 
	   type:"Type", 
	   comment:"Comment", 
	   from_date:"From Date", 
	   to_date:"To Date", 
	   documents:"Documents", 
	   edit:"Edit", 
	   delete:"Delete", 
	   communications:"Communications", 
	   add_communications:"Add Communication", 
	   made_from:"Made From", 
	   made_to:"Made To", 
	   means:"Means", 
	   attachments:"Attachments", 
	   content:"Content", 
	   compliance_logs:"Compliance Logs", 
	   messageID:"Message ID", 
	   agree:"Agree", 
	   dateTime:"Date Time", 
	   iPAddress:"IP Address", 
	   add_idit_comment_document:"Add/Edit Comment & Document", 
	   document_type:"Document Type", 
	   show_on_transcript:"Show On Transcript", 
	   select_users_to:"Select users to", 
	   teacher:"Teacher", 
	   parent:"Parent", 
	   flag:"Flag", 
	   none:"None", 
	   link:"Link", 
	   label:"Label", 
	   add_more_link:"Add More Link", 
	   save:"Save", 
	   add_edit_communication:"Add/Edit Communication", 
	   made_by:"Made By", 
	   date_time:"Date/Time", 
	   length:"Length", 
	   select:"Select", 
	   select_users_to_view:"Select users to view communication", 
	   add_more:"Add More", 
	   communication_summary:"Communication Summary", 
	   close:"Close", 
	   new_type:"New Type", 
	   select_user_to_view_comment:"Select users to view comment", 
	   flag_comment:"Flag comment", 
	   teacher_page:"Teacher Page", 
	   edit_information:"Edit information", 
	   phone:"Phone",
	   add_credential:"Add Credential",
	   add_edit_credential:"Add/Edit Credential",
	   first_name:"First Name",
	   midle_name:"Middle Name",
	   last_name:"Last Name",
	   cancel:"Cancel",
	   add_new:"Add New",
	   phone_type:"Phone Type",
	   zipCode:"Zip Code",
	   phone_number:"Phone Number",
	   default:"Default",
	   please_select_country:"Please select Country",
	   student_information:"Student Information",
	   username:"Username",
	   user_directory:"User Directory",
	   add_teacher:"Add Teacher",
	   add_admin:"Add Admin",
	   export_to_excel:"Export to Excel",
	   export_to_pdf:"Export to PDF",
	   send_login_credentials:"Send Login Credentials",
	   search_for_a_user_or_id:"Search for a user or ID …",
	   user:"User",
	   school_admin:"School Admin",
	   change_password:"Change Password",
	   set_password_expiration_date:"Set Password Expiration Date",
	   impersonate_user:"Impersonate User",
	   edit_user_tags:"Edit user tags",
	   add_or_edit_users_schoo_assign:"Add or edit users school assign",
	   assign_content_access:"Assign Content Access",
	   add_student:"Add Student",
	   add_parent_mentor:"Add Parent / Mentor",
	   showing:"Showing",
	   of:"of",
	   school_name:"School Name",
	   edit_user_school_tags:"Edit User-School Tags",
	   personal_information:"Personal Information",
	   contacted_load:"Contacted Load",
	   maximum_of_active_students:"Maximum # of Active Students",
	   teacher_since:"Teacher Since",
	   login_infomation:"Login Information",
	   username:"Username",
	   password :"Password",
	   avatar :"Avatar",
	   teachers :"Teachers",
	   change_status:"Change Status",
	   add_admin:"Add Admin",
	   name:"Name",
	   create_on:"Create On",
	   registrar:"Registrar",
	   birthday:"Birthday",
	   signature:"Signature",
	   photo:"Photo",
	   designated_registrar:"Designated Registrar",
	   track:"Track",
	   select_existing_track:"Select existing track",
	   available:"Available",
	   parent_mentor:"Parent / Mentor",
	   relationship:"Relationship",
	   email_address:"Email Address",
	   academic_mentor:"Academic Mentor",
	   no_data_available_in_table:"No data available in table",
	   primary_language:"Primary Language",
	   add_into_parent_or_mentor:"Add into Parent / Mentor",
	   add_into_phone:"Add into Phone",
	   add_into_address:"Add into Address",
	   select_one:"Select one",
	   login:"Login",
	   plese_select_country:"Please choose country",
	   edit_student:"Edit Student",
	   academic_advisor_or_student_success_manager:"Academic Advisor / Student Success Manager",
	   role:"Role",
	   link_parent:"Link Parent",
	   link_advisor_sms:"Link Advisor/SSM",
	   save_into_parent_mentor:"Save into Parent / Mentor",
	   save_into_parent_phone:"Save into Phone",
	   save_into_parent_address:"Save into Address",
	   bulk_information_update:"Bulk Information Update",
	   enrollments:"Enrollments",
	   email_student:"Email Student",
	   unofficial_transcripts:"Unofficial Transcripts",
	   official_transcripts:"Official Transcripts",
	   email_students_schedule:"Email Student's Schedule",
	   export_students_to_excel:"Export Students to Excel",
	   export_parent_list_to_excel:"Export Parent list to Excel",
	   assign_learning_path_template:"Assign Learning Path Template",
	   promote_student_to_the_next_grade_level:"Promote student to the next grade level",
	   batch_upload_students:"Batch Upload Students",
	   batch_upload_transfer_grades:"Batch Upload Transfer Grades",
	   transfer_apex_only:"Transfer (APEX Only)",
	   transfer_content_providers:"Transfer (All Content Providers)",
	   batch_enrollments:"Batch Enrollments",
	   send_message:"Send Message",
	   impersonate:"Impersonate",
	   change_login_credentials:"Change Login Credentials",
	   request_enrollment:"Request Enrollment",
	   send_weekly_status_report:"Send Weekly Progress Report",
	   please_select_student:"Please select Students.",
	   student_status_will_be_changed_to_status_withdraw:"Student status will be changed to 111, and all enrollments will be withdrawn.  Are you sure you want to continue?",
	   student_status_will_be_changed_to_status:"Student status will be changed to 111. Are you sure you want to continue?",
	   value:"Value",
	   student_success_manager_or_acdemic:"Student Success Manager / Academic Advisor",
	   enroll_students_to_section:"Enroll Students To Section",
	   department:"Department",
	   refresh:"Refresh",
	   select_department:"Select department",
	   select_course:"Select course",
	   select_section:"Select Section",
	   start_date:"Start Date",
	   end_date:"End Date",
	   ID:"ID",
	   action:"Action",
	   enrollment_period:"Enrollment period",
	   select_a_course_to_register_ilp:"Select a course to register ilp",
	   period:"Period",
	   credit:"Credit",
	   year:"Year",
	   enroll:"Enroll",
	   recipient_transcript:"Recipient Transcript",
	   select_all_or_unselect_all:"select all / unselect all",
	   include_in_progress_sections:"Include In Progress Sections",
	   show_satisfaction_of_program:"Show Satisfaction of Program",
	   show_total_credit:"Show Total Credits",
	   show_student_info:"Show Student Info",
	   show_academic_info:"Show Academic Info",
	   show_school_names_from_orther_grades:"Show school names from other grades",
	   show_school_contact:"Show school contact",
	   include_transferred_grades_in_gpa:"Include Transferred Grades in GPA",
	   include_in_progress_grade:"Include In Progress Grade",
	   include_grade_scales:"Include Grade Scales",
	   show_graduation_date:"Show Graduation Date",
	   show_weighted_gpa:"Show Weighted GPA",
	   show_grade_level_gpa:"Show Grade Level GPA",
	   show_comletion_date:"Show Completion Date",
	   show_withdraw_classes:"Show Withdrawn Classes",
	   show_withdraw_date:"Show Withdrawn Date",
	   show_transfered_in_classes:"Show transferred in classes",
	   show_digital_seal:"Show Digital Seal",
	   show_singnature:"Show Signature",
	   group_by:"Group By",
	   school_year:"School Year",
	   school_level:"School Level",
	   notes:"Notes",
	   ok:"Ok",
	   are_you_sure_to_send:"Are you sure to send?",
	   assign_learning_path_templete:"Assign Learning Path Template",
	   assign_student_to_selected_learning:"Assign Student To Selected Learning Path Template",
	   assign:"Assign",
	   are_you_sure_to_promote_to_level:"Are you sure to Promote to next grade level?",
	   data_process:"Data Process",
	   upload_and_import_data:"Upload & Import Data",
	   download_user_information:"Download user information",
	   here:"here",
	   select_student_upload_file:"Select Student Upload File",
	   local_drive:"Local Drive",
	   the_file_is_uploaded:"The file is uploaded",
	   template_name:"Template Name",
	   Here:"Here",
	   sample_file_excel:"sample file excel.",
	   file_type:"File Type",
	   delimited:"Delimited",
	   delimited_chars:"Delimited Chars",
	   fixed_width:"Fixed Width",
	   first_line_header:"First Line Header",
	   loader_field:"Load Field",
	   Header:"Header",
	   sample_data:"Sample Data",
	   column_width:"Colunm Width",
	   save_tamplate:"Save Template",
	   save_and_upload_data:"Save & Upload Data",
	   result:"Result",
	   upload_and_import_data_orther_grade:"Upload & Import Data Other Grade",
	   select_upload_file:"Select Upload File",
	   student_id:"Student ID",
	   uploadAnd_import_data_enrollment:"Upload & Import Data Enrollment",
	   section_id:"Section ID",
	   title:"Title",
	   recipient:"Recipient",
	   same_current_address:"Same as Current Address",
	   add_more_reciptient:"Add more Recipient",
	   issuse_date:"Issue Date",
	   show_total_unapplied_credits:"Show Total Unapplied Credits",
	   reconcile_another_student_record:"Reconcile with Another Student Record",
	   please_choose_one_student_to_reconcile:"Please choose one student to reconcile.",
	   yes:"Yes",
	   no:"No",
	   apex_classroom_sync:"Apex Classroom Sync",
	   next:"Next",
	   apex_classrooms:"APEX Classrooms",
	   online_user_id:"Online User Id",
	   enter_online_user_id:"Enter Online User Id",
	   online_section_id:"Online Section Id",
	   online_section_name:"Online Section Name",
	   online_course_name:"Online Course Name",
	   enrollment_date:"Enrollment Date",
	   back:"Back",
	   import:"Import",
	   offical_transcipt:"Official Transcript",
	   email_schedule:"Email Schedule",
	   reconcile_with_another_records:"Reconcile with Another Record",
	   online_sync_and_update:"Online Progress Sync & Update",
	   download_all_completion_cretification:"Download All Completion Certification",
	   orther_grade:"Other Grades",
	   medical:"Medical",
	   comments_and_documents:"Comments and Documents",
	   contracts:"Contracts",
	   invoices:"Invoices",
	   audit_logs:"Audit Logs",
	   edit_logs:"Edit Logs",
	   grade_to_date:"Grade To Date",
	   quality_of_work:"Quality Of Work",
	   last_access:"Last Access",
	   gradebook:"Gradebook",
	   transfer:"Transfer",
	   completion_certification:"Completion Certification",
	   tranfer_user_school:"Transfer user school",
	   tranfer_to_school:"Transfer To School",
	   tranfer_apex_classrooms:"Transfer APEX Classrooms",
	   course_to_moved:"Course To Moved",
	   current_teacher:"Current Teacher",
	   future_section:"Future Section",
	   future_program:"Future Program",
	   future_teacher:"Future Teacher",
	   enrollment_start_date_end_date:"Enrollment Start Date - End Date",
	   no_more_option:"No more options",
	   create_new:"Create New",
	   transfer_classrooms:"Transfer Classrooms",
	   tyler_synchronization_for_az_school:"Tyler Synchronization for AZ Schools",
	   synchronize:"Synchronize",
	   individual_course_progress_varies:"Individual course progress varies. This is your overall progress toward graduation.",
	   edit_ilp:"Edit ILP",
	   add_academic_record:"Add Academic Record",
	   edit_all_records:"Edit All Records",
	   search_corse_department_src:"Search course, department, src…",
	   message_id:"Message ID",
	   add_new_contract:"Add New Contract",
	   contract_id:"Contract ID",
	   contract_name:"Contract Name",
	   first_date:"First Date",
	   last_date:"Last Date",
	   amount_per_period:"Amount Per Period",
	   terminating_status:"Terminating Status",
	   payment_history:"Payment History",
	   record_payment:"Record Payment",
	   payment_method:"Payment Method",
	   invoice_id:"Invoice ID",
	   show_all:"Show All",
	   invoice_date:"Invoice Date",
	   from:"From…",
	   to:"To…",
	   amount:"Amount",
	   paid:"Paid",
	   due:"Due",
	   date_paid:"Date Paid",
	   apply_payments:"Apply Payments",
	   mark_as_paid:"Mark As Paid",
	   void:"Void",
	   audit_log:"Audit Log",
	   object:"Object",
	   changes_made:"Changes Made",
	   create_time:"Create Time",
	   time_stamp:"Time Stamp",
	   user_creare:"User Create",
	   edit_log:"Edit Log",
	   field_name:"Field Name",
	   old_value:"Old Value",
	   new_value:"New Value",
	   date_time_update:"Date/Time Update",
	   updater:"Updater",
	   add_edit_academic_records:"Add/Edit Academic Record",
	   select_flag:"Select Flag ...",
	   edit_all_tranferred_grades:"Edit All Tranferred Grades",
	   save_records:"Save Records",
	   possible_credits:"Possible Credits",
	   select_level:"Select level",
	   select_grade_level:"Select grade level",
	   select_status:"Select status",
	   add_more_row:"Add More Row",
	   full_screen:"Full Screen",
	   course_code:"Course code",
	   add_order_grades:"Add Other Grades",
	   select_credit:"Select credit",
	   select_default:"Select default",
	   credits_possible:"Credits possible",
	   select_possible_credit:"Select possible credit",
	   product:"Product",
	   fromn:"From",
	   ton:"To",
	   last_invoice_date:"Last Invoice Date",
	   please_select_stu:"Please select Student",
	   payer:"Payer",
	   amount_per_billing_period:"Amount Per Billing Period",
	   price_unit:"Price Unit",
	   billing_period:"Billing Period",
	   automatic_renewal:"Automatic Renewal",
	   automatic_payment:"Automatic Billing",
	   contract_template:"Contract Template",
	   accept:"Accept",
	   reject:"Reject",
	   duration_of_period:"Duration (# of periods)",
	   payment_id:"Payment ID",
	   payment_date:"Payment Date",
	   payment_amount:"Payment Amount",
	   applied:"Applied",
	   available:"Available",
	   unApply:"UnApply",
	   refund:"Refund",
	   add_new_teacher:"Add New Teacher",
	   change_teacher_status:"Change Teacher Status",
	   search_for_a_teacher_or_id:"Search for a teacher or ID …",
	   flags:"Flags",
	   tags:"Tags",
	   allowed:"Allowed",
	   message_teacher:"Message Teacher",
	   impersonate_teacher:"Impersonate Teacher",
	   add_teacher_qualification:"Add Teacher Qualification",
	   profile:"Profile",
	   teacher_schedule:"Teacher Schedule",
	   qualifications:"Qualifications",
	   student_actions:"Student Actions",
	   linking_parents_to:"Linking Parents to",
	   select_do:"Select ...",
	   see_edit_logs:"See Edit logs",
	   see_qualifications:"See Qualifications",
	   link_academic_advisor:"Link Academic Advisor",
	   student_success:"Student Success",
	   linking_academic_advisor_or_student_success:"Linking Academic Advisor / Student Success to",
	   staff:"Staff",
	   teacher_status:"Teacher Status",
	   school_admin_status:"School Admin Status",
	   global_user_directory:"Global User Directory",
	   edit_teacher:"Edit Teacher",
	   contracted:"Contracted",
	   add_comments_and_documents:"Add Comments and Documents",
	   edit_comments_and_documents:"Edit Comments and Documents",
	   parents_or_mentor:"Parents / Mentor",
	   send_mail:"Send Mail",
	   are_you_sure_to_delete_this_teacher:"Are you sure to delete this Teacher.",
	   edit_user_password:"Edit Username & Password",
	   add_qualifications:"Add Qualifications",
	   please_select_a_least_on_teacher:"Please select at least one teacher.",
	   edit_parent_mentor:"Edit Parent / Mentor",
	   parent_mentor_information:"Parent / Mentor Information",
	   send:"Send",
	   are_you_surse_to_delete_this_parent:"Are you sure to delete this  Parent.",
	   home:"Home",	   
	   //auto_promotion:"Auto Promotion",
	   auto_promotion:"Student Grade Level Promotion",
	   Promote:"Promote",
	   search_for_a_name:"Search for a name …",
	   download_to_excel:"Download to Excel",
	   download_to_pdf:"Download to Pdf",
	   User_ID:"User ID",
	   User_type:"User type",
	   communication_log:"Communication Log",
	   Student_Status:"Student Status",
	   Users:"Users",
	   Staff_Reassignment:"Staff Reassignment",
	   Select_Staff:"Select Staff",
	   select_asset_type_to_reassign:"select asset type to reassign",
	   transfer_all_to:"Transfer all to",
	   transfer_selectively:"Transfer selectively",
	   remove_all:"Remove all",
	   remove_selectively:"Remove selectively",
	   Event:"Event",
	   Time:"Time",
	   Participants:"Participants",
	   new_staff:"New Staff",
	   Remove:"Remove",
	   Profile_Page:"Profile Page",
	   settings:"Settings",
	   security:"Security",
	   timezone:"Timezone",
	   notifications:"Notifications",
	   check_for_feature_availability_at_your_school:"Check for feature availability at your school.",
	   current_password:"Current Password",
	   new_password:"New Password",
	   confirm_password:"Confirm Password",
	   updte_password:"Update Password",
	   change_timezone:"Change Timezone",
	   time_zone:"Time zone",
	   please_select_time_zone:"Please select time zone",
	   notification_settings:"Notification Settings",
	   level_of_urgency:"Level of Urgency",
	   email_destination:"Email Destination",
	   SMS_Destination:"SMS Destination",
	   app:"App",
	   please_select_level_of_urgency:"Please select level of urgency",  
	   reset_filters:"Reset filters",
	   batch_data_update:"Student Data Update", 
	   view_roles:"View Roles", 
	   administrator_information:"Administrator Information", 
	   account_reation_date:"Account Creation Date", 
	   expiration_date:"Expiration date", 
	   schools:"Schools", 
	   advisees:"Advisees", 
	   message:"Message", 
	   see_comments_and_documents:"See Comments and Documents", 
	   restore_APEX_Classrooms:"Restore APEX Classrooms", 
	   teacher_information:"Teacher Information", 
	   teacher_number:"Teacher Number", 
	   departmens:"Departments", 
	   global_capacity:"Global Capacity", 
	   local_contracted_load:"Local Contracted Load", 
	   parents:"Parents", 
	   parent_information:"Parent Information", 
	   linked_students:"Linked Students", 
	   link_student:"Link Student", 
	   unlink_student:"Unlink Student", 
	   search_dot:"Search…", 
	   view_local:"View local", 
	   view_global:"View global", 
	   resource:"Resource", 
	   current_grade:"Current Grade", 
	   affiliation:"Affiliation", 
	   current_assignment:"Current Assignment", 
	   total_assignments:"Total assignmentst", 
	   percent_completed:"Percent Completed", 
	   semester:"semester", 
	   graduation_year:"Graduation Year", 
	   student_name:"Student Name", 
	   credits_earned:"Credits Earned", 
	   exit:"exit", 
	   engagement_type:"Engagement type", 
	   college_admitted:"College admitted", 
	   college_attending:"College attending", 
	   major:"Major", 
	   report_card:"Report Card", 
	   academic_term:"Academic Term", 
	   show_average:"Show Average", 
	   school_information:"School Information", 
	   school_misc_configuration:"School Misc Configuration", 
	   school_tags:"School Tags", 
	   role_tags:"Role Tags", 
	   content_integration:"Content Integration", 
	   user_roles:"User Roles", 
	   communication_user_rules:"Communication User Rules", 
	   school_administrators:"School Administrators", 
	   school_year_configuration:"School Year Configuration", 
	   A_R_payment_configuration:"A/R Payment Configuration", 
	   facility:"Facility", 
	   enrollment_rules:"Enrollment Rules", 
	   student_contract_rules:"Student Contract Rules", 
	   products:"Products", 
	   notification_templates:"Notification Templates", 
	   transcript_viewer_options:"Transcript Viewer Options", 
	   feature_configuration:"Feature Configuration", 
	   feature_settings:"Feature Settings", 
	   communication_rules:"Communication Rules", 
	   object_state:"Object State", 
	   departments:"Departments", 
	   grading_scales:"Grading Scales", 
	   grading_periods:"Grading Periods", 
	   academic_tracks:"Academic Tracks", 
	   learning_path_templates:"Learning Path Templates", 
	   grade_book_activity_descriptions:"Grade Book Activity Descriptions", 
	   academic_terms:"Academic Terms", 
	   academic_system:"Academic System", 
	   address_line_1:"Address Line 1", 
	   country_code:"Country Code", 
	   address_line_2:"Address Line 2", 
	   school_title:"School Title", 
	   CEEB_code:"CEEB Code", 
	   zip_postal_code:"Zip/Postal Code", 
	   state_province:"State/Province", 
	   website:"Website", 
	   subdomain:"Subdomain", 
	   success_manager:"Success Manager", 
	   school_logo:"School Logo", 
	   digital_seal:"Digital Seal", 
	   password_exception_rule:"Password Exception Rule", 
	   change_password_first_login:"Change password first login", 
	   password_expires_after_days:"Password expires after days", 
	   enforcement_of_teachers_load:"Enforcement of Teacher's Load", 
	   in_house_handling_of_transcript_requests:"In House Handling of Transcript Requests", 
	   display_mobile_app_link:"Display Mobile App Link", 
	   display_weekly_progress_goal:"Display Weekly Progress Goal", 
	   turn_on_notification:"Turn On Notification", 
	   classic_letter:"Classic Letter", 
	   automatic_parent_account_creation:"Automatic Parent Account Creation", 
	   default_parent_account_status:"Default Parent Account Status", 
	   default_time_zone:"Default Time Zone", 
	   link_to_transcript_vendor_help:"Link to Transcript Vendor Help", 
	   link_to_transcript_vendor:"Link to Transcript Vendor", 
	   link_for_help_system:"Link for Help System", 
	   student_enrollment_limit:"Student Enrollment Limit", 
	   default_section_type:"Default Section Type", 
	   default_section_capacity:"Default Section Capacity", 
	   transcript_template:"Transcript Template", 
	   edit_security_school_tags:"Edit Security School Tags", 
	   security_school_tags:"Security School Tags", 
	   tags_name:"Tags Name", 
	   edit_role_tags:"Edit Role Tags", 
	   add_school_based_tags:"Add School Based Tags", 
	   description:"Description", 
	   applied_to_roles:"Applied To Roles", 
	   teacher:"Teacher", 
	   edit_security_role_tags_for:"Edit Security Role Tags for", 
	   school_admins:"School Admins", 
	   school_begin_date:"School Begin Date", 
	   school_end_date:"School End Date", 
	   automatic_control_of_teacher_s_load:"Automatic Control Of Teacher's Load", 
	   A_R_payment_gateway_configuration:"A/R Payment Gateway Configuration", 
	   payment_processing_vendor:"Payment Processing Vendor", 
	   secret_key:"Secret Key", 
	   publishable_key:"Publishable Key", 
	   account_id:"Account ID", 
	   updating_tudents:"Updating Students", 
	   delete_selected_records:"Delete Selected Records", 
	   attribute_name:"Attribute Name", 
	   applied_for:"Applied For", 
	   add_school:"Add School", 
	   overview:"Overview", 
	   search_for_school:"Search for school…", 
	   search_for_student:"Search for student…", 
	   attribute_type:"Attribute Type", 
	   select_school_group:"Select School Group", 
	   access_rights:"Access Rights", 
	   create:"Create", 
	   read:"Read", 
	   facility_management:"Facility Management", 
	   facility_name:"Facility Name", 
	   capacity:"Capacity", 
	   enrollment_allowance_period_days:"Enrollment Allowance Period (days)", 
	   maximum_enrollment_duration_days:"Maximum Enrollment Duration (days)", 
	   start_date_of_the_week:"Start Date of the Week", 
	   end_date_of_the_week:"End Date of the Week", 
	   lookup_name:"Lookup Name", 
	   duration:"Duration", 
	   time_unit:"Time Unit", 
	   round_up_to_end_of_time_unit:"Round Up to End of Time Unit", 
	   product_name:"Product Name", 
	   product_ID:"Product ID", 
	   price_offer:"Price Offer", 
	   price:"Price", 
	   frequency:"Frequency", 
	   effective_from:"Effective From", 
	   effective_to:"Effective To", 
	   active:"Active", 
	   drag_drop_to_text_cursor_in_content:"Drag & drop to text cursor in content", 
	   event_type:"Event Type", 
	   notification_rule:"Notification Rule", 
	   level_or_ugency:"Level or Ugency", 
	   user_role:"User Role", 
	   edit_security_user_tags:"Edit Security User Tags", 
	   content_access:"Content Access", 
	   content_access_for:"Content Access for", 
	   add_new_access:"Add New Access", 
	   date_assigned:"Date Assigned", 
	   enrollment_request:"Enrollment Request", 
	   enrollment_request_for:"Enrollment Request for", 
	   mentors:"Mentors", 
	   options:"Options", 
	   department_name:"Department Name", 
	   universal_department:"Universal Department", 
	   open:"Open", 
	   min_point:"Min Point", 
	   max_point:"Max Point", 
	   grade_point:"Grade Point", 
	   honors:"Honors", 
	   college:"College", 
	   order:"Order", 
	   start_time:"Start Time", 
	   end_time:"End Time", 
	   period_name:"Period Name", 
	   grading_periods_head:"Grading Periods Head", 
	   grading_period:"Grading Period", 
	   weight:"Weight", 
	   track_name:"Track Name", 
	   academic_track_requirement:"Academic Track Requirement", 
	   of_required_credits:"# of Required Credits", 
	   individual_learning_plan_template:"Individual Learning Plan Template", 
	   ILP_name:"ILP Name", 
	   remove_requirement:"Remove Requirement", 
	   reset_requirement:"Reset Requirement", 
	   add_requirement:"Add Requirement", 
	   must_end_date:"Must End Date", 
	   courses_open_date:"Courses Open Date", 
	   signup_end_date:"Signup End Date", 
	   signup_start_date:"Signup Start Date", 
	   section_period:"Section Period", 
	   
	   weeks:"Weeks", 
	   search_for_a_section_or_id:"Search for a section or ID …", 
	   search_for_a_deft:"Search for a dept…", 	   
	    launch_course:"Launch course", 
	   start_class:"Start Class", 	   
	   weekly_progress_goal:"Weekly Progress Goal", 	 
	   send_message_to_all_section_students:"Send Message to All Section Students", 
	   monitor_live_sessions:"Monitor Live Sessions", 
	   average_section_grade:"Average Section Grade", 	   
	   resources:"Resources", 
	   activities:"activities", 	   
	   course_attendance_today:"Course Attendance Today", 	   
	   staffs:"Staffs", 
	   units:"Units", 
	   view_all_15_resources:"View all 15 resources", 
	   Class_discussions:"Class discussions", 
	   recent_discussions:"Recent Discussions", 	   
	   go_to_class_discussions:"Go to class discussions", 
	   show_my_class_attendance:"Show my class attendance", 
	   add_section:"Add Section",
	   add_global_section:"Add Global Section",
	   close_section:"Close Sections",
	   open_section:"Open Sections",
	   batch_upload:"Batch Upload",
	   finalize:"Finalize",
	   add_tearcger:"Add Teacher(s)",
	   remove_tearcger:"Remove Teacher(s)",
	   uploadSectionStatusUpdates:"Upload Section Status Updates",
	   status_count:"Status Count",
	   reactivate:"Reactivate",
	   clone:"Clone",
	   enroll_into_Section:"Enroll into Section",
	   bulk_enrollment:"Bulk Enrollment",
	   general_Information:"General Information",
	   online_content_source:"Online Content Source",
	   second_teacher:"Second Teacher",
	   today:"today",
	   calendar:"Calendar",
	   week:"week",
	   month:"Month",
	   section_progress:"Section Progress",
	   complete:"complete",
	   section_title:"Section Title",
	   enter_section_title:"Enter section title",
	   select_teacher:"Select teacher",
	   select_weeks:"Select weeks",
	   select_credits:"Select credits",
	   select_type:"Select type",
	   global_section:"Global Section",
	   enrollment_capacity:"Enrollment Capacity",
	   enter_enrollment_capacity:"Enter enrollment capacity",
	   in_class_information:"In Class Information",
	   Start:"Start",
	   End:"End",
	   recurrencePattern:"Recurrence Pattern",
	   recurrenceFrequency:"Recurrence Frequency",
	   Weekly:"Weekly",
	   Monthly:"Monthly",
	   Recur_every:"Recur every",
	   Weeks_on:"Weeks on",
	   day_of_week:"Day Of Week",
	   daily_period:"Daily Period",
	   select_daily_period:"Select daily period",
	   Day:"Day",
	   The:"The",
	   of_every:"of every",
	   month_s:"month(s)",
	   add:"Add",
	   course_prequisites :"Course prerequisites",
	   select_status:"Select status",
	   select_school:"Select Schools",
	   select_period:"Select Period",
	   room_number:"Room Number",
	   select_room_number:"Select Room Number",
	   Service:"Service",
	   enter_url:"Enter Url",
	   edit_section:"Edit Section",
	   activity_templates:"Activity templates",
	   select_activity_templates:"Select activity template",
	   link_section:"Link Section",
	   select_link_section:"Select link section",
	   please_select_sections:"Please select sections.",
	   if_you_change_your_status_of_inactivity:"If you change your status of inactivity, the student will be affected.",
	   closing_the_global_section_will_cause:"Closing the global section will cause closure in all schools, and withdrawal of all students in them. Please click Confirm if you want to proceed.",
	   upload_import_data:"Upload & Import Data",
	   here:"Here",
	   no_data_avalable_in_table:"No data available in table",
	   add_teacher_to_multiple_section:"Add Teacher(S) To Multiple Sections",
	   select_teachers_to_add_to_multiple_section:"Select teachers to add to multiple selections",
	   selected:"Selected",
	   selected_all:"Select All",
	   deselected_all:"Deselect All",
	   remove_teacher_from_multiple_section:"Remove Teacher(S) From Multiple Sections",
	   select_teacher_to_remove_to:"Select teachers to remove to multiple selections",
	   process_removal:"Process Removal",	   
	   clone_section:"Clone Section",
	   enroll_student:"Enroll Student",
	   enroll_student_to:"Enroll Students to",
	   name:"Name",
	   search_for_a_student_or_id:"Search for a student or ID …",
	   confirmation_of_enrollment:"CONFIRMATION OF ENROLLMENT",
	   please_review_and_confirm_enrollments_for:"Please review and confirm enrollments for",
	   confirm:"Confirm",
	   //enroll_students_to_section:"ENROLL STUDENTS TO SECTION",
	   enrollment_period:"Enrollment period",
	   days:"days",
	    no_data_avalible:"No data available.",
	   number_of_primary_teacher:"Number of Primary Teachers",
	   secondary_teachers:"Secondary Teachers",
	   department_head:"Department Head",
	   section_enroll:"Section Enroll",
	   load_from_file:"Load from File",
	   see_sections:"See Sections",
	   change_enrollment_status:"Change Enrollment Status",
	   mentor_s:"Mentor(s)",
	   overdue_activities:"Overdue Activities",
	   total_session_time_and_last_log:"Total Session Time and last log",
	   course_name_on_transcript:"Course Name on Transcript",
	   edit_other_grades:"Edit Other Grades",
	   save_as:"Save As",
	   account_receivable_dashboard:"Account Receivable Dashboard",
	   key_performance_indicators:"Key Performance Indicators",
	   a_r_dashboard:"A/R Dashboard",
	   payments_credits:"Payments / Credits",
	   contract_templates:"Contract Templates",
	   master_contracts:"Master Contracts",
	   a_r_configuration:"A/R Configuration",
	   a_r_processing:"A/R Processing",
	   aging:"Aging",
	   receivable:"Receivable",
	   account_receivable_by_program:"Account Receivable by Program",
	   request_detail:"Request Detail",
	   request_information:"Request Information",
	   requested_by:"Requested By",
	   approved_by:"Approved By",
	   approve:"Approve",
	   phone_name:"Phone Name",
	   phone_carrier:"Phone Carrier",
	   area_code:"Area Code",
	   address_lable:"Address Lable",
	   address_default:"Address Default",
	   new_photo:"New Photo",
	   current_of_wweeks:"Current # of weeks",
	   select_enrollment_period:"Select Enrollment Period",
	   enter_rejection_reason:"Enter rejection reason...",
	   comments_and_documents:"Comments & Documents",
	   enrollment_history:"Enrollment History",
	   request_extension_for:"Request Extension for",
	   extended_of_weeks:"Extended # of weeks",
	   current_enrollment_status:"Current Enrollment Status",
	   select_extension_option:"Select Extension Option",
	   extend_current_enrollment_until:"Extend current enrollment until",
	   transfer_to_new_section:"Transfer to new Section",
	   transcript_requests:"Transcript Requests",
	   person_requesting_transcript:"Person Requesting Transcript",
	   telephone_number:"Telephone Number",
	   number_of_copies:"Number of Copies",
	   special_instructions:"Special Instructions",
	   last_school_attendance:"Last School Attendance",
	   year_last_attended:"Year Last Attended",
	   current_address:"Current Address",
	   relationship_to_student:"Relationship To Student",
	   method_of_delivery:"Method of Delivery",
	   instructions:"*Instructions",
	   previous_requests:"Previous requests",
	   additional_info:"Additional Info",
	   receive:"Receive",
	   process:"Process",
	   add_to_school_group:"Add To School Group",
	   submit_romote:"Submit Promote",
	   next_grade_level:"Next Grade Level",
	   please_select_a_school_for_promotion_and_transfer:"Please select a school for promotion and transfer",
	   write_off:"Write Off",
	   amount_due:"Amount Due",
	   open_amount:"Open Amount",
	   payment_application:"Payment Application",
	   use_credit_openBalance:"Use Credit $111",
	   payment_amount_usd:"Payment Amount (USD)",
	   check_number:"Check Number",
	   confirmation_number:"Confirmation Number",
	   apply_payment:"Apply Payment",
	   amount_paid:"Amount Paid",
	   applied_payment:"Applied Payment",
	   payer_id:"Payer ID",
	   view_detail:"View Detail",
	   master_contract:"Master Contract",
	   copy:"Copy",
	   contract_user_detail:"Contract User Detail",
	   follow_product_cost:"Follow Product Cost",
	   default_cost:"Default Cost",
	   offered_cost:"Offered Cost",
	   contract_detail:"Contract Detail",
	   contract_template_name:"Contract Template Name",
	   master_contract_name:"Master Contract Name",
	   view_students:"View Students ", 
	   make_payment:"Make Payment", 
	   parent_page:"Parent Page", 
	   edit_parent:"Edit Parent", 
	   edit_profile:"Edit Profile", 
	   account_receivable_configuration:"Account Receivable Configuration", 
	   invoice_generation_date:"Invoice Generation Date", 
	   invoice_generation:"Invoice Generation", 
	   number_of_days_until_due_date:"Number of Days until Due Date", 
	   account_receivable_processing:"Account Receivable Processing", 
	   generate_invoices:"Generate Invoices", 
	   process_automatic_payments:"Process Automatic Payments", 
	   send_late_notices:"Send Late Notices", 
	   course:"Course", 
	   copy_courses:"Copy Courses", 
	   copy_to_school:"Copy To School", 
	   originating_program_code:"Originating Program Code", 
	   destinating_program_code:"Destinating Program Code", 
	   status_error:"Status/Error", 
	   add_prerequisite:"Add Prerequisite", 
	   group_name:"Group Name", 
	   enter_group_name:"Enter Group Name", 
	   select_a_department_to_display_courses:"Select a department to display courses", 
	   edit_tranferred_grades:"Edit Other Grades", 
	   showing_num_records:"Showing 000 records", 
	   edit_all_other_grades:"Edit All Other Grades", 
	   upload_student_documents:"Upload Student Documents", 
	   select_an_official_transcript_option:"Select an official transcript option", 
	   for_schools_or_personal_copy:"For Schools or Personal Copy", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"For student use, send to another school, or to verify enrollment.", 
	   request_official_transcript:"Request Official Transcript", 
	   PARCHMENT_for_colleges_or_universities:"PARCHMENT For Colleges or Universities", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"For application to a college/university and to verify completion of your diploma.", 
	   request_transcript:"Request Transcript", 
	   Learn_more_about_how_to_use_PARCHMENT:"Learn more about how to use PARCHMENT", 
	   print_PDF:"Print PDF", 
	   user_school:"User School", 
	   filter:"Filter", 
	   GENERAL:"GENERAL", 
	   STUDENT_INFO:"STUDENT INFO", 
	   list:"List", 
	   last_school_name:"Last School Name", 
	   TEACHER_INFO:"TEACHER INFO", 
	   contracted_load:"Contracted Load", 
	   ARENT_INFO:"PARENT INFO", 
	   add_credential:"Add Credential", 
	   edit_credential:"Edit Credential", 
	   add_comment_document:"Add Comment & Document", 
	   add_comment_document_for:"Add Comment & Document for", 
	   state_province:"State/ Province", 
	   post_code:"Post Code", 
	   linking_students_to:"Linking Students to", 
	   change_expiration_date:"Change Expiration Date", 
	   expiry_date:"Expiry Date", 
	   please_select_department:"Please select Department.", 
	   please_select_course:"Please select Course.", 
	   please_select_title:"Please enter Title.", 
	   please_select_primary_teacher:"Please select Primary Teacher.", 
	   please_select_weeks:"Please select Weeks.", 
	   please_select_level:"Please select Level.", 
	   please_select_credits:"Please select credits.", 
	   please_select_type:"Please select Type.", 
	   please_select_daily_period:"Please select Daily Period.", 
	   please_enter_link_section:"Please enter link section.", 
	   please_enter_first_name:"Please enter First Name.", 
	   please_enter_last_name:"Please enter Last Name.", 
	   please_enter_contracted:"Please enter Contracted.", 
	   please_enter_email:"Please enter Email.", 
	   please_enter_phone:"Please enter Phone.", 
	   please_enter_username:"Please enter Username.", 
	   please_enter_password:"Please enter password.", 
	   please_enter_status:"Please select status.", 
	   save_successful:"Save Successful!.", 
	   please_add_student_address:"Please add student address.", 
	   please_enter_email_address:"Please enter Email Address.", 
	   please_select_relationship:"Please select relationship.", 
	   please_select_parent_status:"Please select Parent Status.", 
	   please_enter_label:"Please enter Label.", 
	   please_enter_address:"Please enter Address.", 
	   please_enter_city:"Please enter City.", 
	   please_enter_state:"Please enter State.", 
	   please_enter_zip_code:"Please enter Zip Code.", 
	   please_select_date_of_birth:"Please select Date Of Birth.", 
	   please_select_track:"Please select Track.", 
	   please_enter_graduation_date:"Please enter Graduation Date.", 
	   please_enter_country:"Please enter Country .", 
	   please_enter_phone_number:"Please enter Phone Number.", 
	   please_enter_parent_first_name:"Please enter Parent First Name.", 
	   please_enter_parent_last_name:"Please enter Parent Last Name.", 
	   please_enter_parent_email_address:"Please enter Parent Email Address.", 
	   please_enter_parent_username:"Please enter Parent Username.", 
	   please_select_parent_relationship:"Please select Parent relationship.", 
	   please_enter_phone_label:"Please enter Phone Label.", 
	   student_address_canot_be_empty:"Student address cannot be empty.", 
	   please_select_document_type:"Please select Document type.", 
	   please_enter_new_type:"Please enter New type.", 
	   please_enter_comment:"Please enter comment.", 
	   link_is_not_a_valid_url:"Link is not a valid url.", 
	   please_enter_link_and_label:"Please enter link and label.", 
	   are_you_sure_to_delete_this_student:"Are you sure to delete this Student.", 
	   please_select_gender:"Please select gender.", 
	   school_contracted_load:"School Contracted Load", 
	   global_contracted_load:"Global Contracted Load", 
	   please_enter_label_for_attachments:"Please enter label for attachments.", 
	   please_select_section:"Please select Section.", 
	   enrollment_completed_successfully:"Enrollment completed successfully.", 
	   delete_this_comment:"Delete this comment ?", 
	   please_enter_course_name:"Please Enter Course name.", 
	   please_select_credits_possible:"Please select Credits possible.", 
	   can_save_record:"Can't save record:", 
	   are_you_sure_to_delete_this_tranferred_grade:"Are you sure to delete this  Tranferred Grade?", 
	   are_you_sure_to_delete_num_tranferred_grade:"Are you sure to delete 11 Tranferred Grade?", 
	   please_select_tranferred_grade:"Please select Tranferred Grade.", 
	   please_ente_subject:"Please enter subject.", 
	   please_select_made_to:"Please select Made To.", 
	   delete_this_communication:"Delete this communication ?", 
	   please_select_school:"Please select school.", 
	   please_enter_name:"Please enter name.", 
	   please_enter_group_name:"Please enter Group Name.", 
	   you_have_some_form_errors_please_check_above:"You have some form errors. Please check above.", 
	   please_select_recipient:"Please select recipient.", 
	   please_enter_description:"Please enter description.", 
	   delete_this_resource:"Delete this resource ?", 
	   please_enter_activity_name:"Please enter Activity Name.", 
	   please_select_activity_type:"Please select Activity Type.", 
	   please_enter_max_score:"Please enter Max Score.", 
	   please_enter_due_date:"Please enter Due Date.", 
	   please_enter_unit_name:"Please enter Unit Name.", 
	   are_you_sure_to_clear_this_unit:"Are you sure to clear this Unit?", 
	   please_enter_score:"Please enter Score.", 
	   delete_this_credential:"Delete this Credential ?", 
	   plase_select_period:"Please select Period", 
	   plase_select_start_date:"Please select Start Date", 
	   plase_select_end_date:"Please select End Date", 
	   select_to_register_course_to_students_individual_learning_path_view:"Select to Register Course to Students Individual Learning Path View", 
	   delete_this_request:"Delete this request ?", 
	   please_enter_fname:"Please enter fname.", 
	   please_enter_lname:"Please enter lname.", 
	   please_enter_birthday:"Please enter birthday.", 
	   please_enter_address:"Please enter address.", 
	   please_enter_zip:"Please enter Zip.", 
	   please_enter_country:"Please select country.", 
	   please_enter_ethnicity:"Please enter ethnicity.", 
	   please_enter_grade:"Please select grade.", 
	   please_enter_mobile:"Please enter mobile.", 
	   please_enter_hear_about_us:"Please select hear about us.", 
	   please_enter_program_of_interest:"Please select program of interest.", 
	   please_enter_course_level:"Please enter course level.", 
	   please_enter_guardian_1_name:"Please enter Guardian 1 Name.", 
	   please_enter_guardian_1_email:"Please enter Guardian 1 Email.", 
	   please_enter_guardian_1_home_phone:"Please enter Guardian 1 Home Phone.", 
	   please_enter_guardian_1_relation:"Please enter Guardian 1 Relation.", 
	   please_select_parents:"Please select Parents.", 
	   transfer_classroom:"Transfer classroom", 
	   please_choose_one_section_to_transfer:"Please Choose one section to transfer.", 
	   transfer:"Transfer", 
	   assigning_multiple_users_to_a_school_or_school_group:"Assigning multiple users to a school or school group", 
	   add_to_school_or_school_group:"Add To School or School Group", 
	   please_select_school_or_school_group:"Please select school or school group.", 
	   print_student_progress_report:"Print Student Progress Report", 
	  
 },
 ar: {
	   reporting_center:"مركز التقارير", 
	   grade_reports:"تقارير الصف", 
	   user_reports:"تقارير المستخدم", 
	   learning_reports:"تقارير التعلم", 
	   administrative_reports:"التقارير الإدارية", 
	   progress_report:"تقرير التطور", 
	   full_progress_report:"التقرير التقدمي الكامل", 
	   grade_report:"تقرير الصف", 
	   roster_report:"تقرير قائمة", 
	   parent_report:"تقرير الوالدين", 
	   teacher_report:"تقرير المعلم", 
	   student_report:"تقرير الطالب", 
	   log_in_report:"تسجيل الدخول", 
	   enrollmentreport:"تقرير الالتحاق", 
	   enrollment_summary:"ملخص التسجيل", 
	   student_enrollment_summary:"ملخص تسجيل الطلاب", 
	   attendance_report:"تقرير الحضور", 
	   attendance_summary_report:"تقرير ملخص الحضور", 
	   log_In_Credentials:"تسجيل الدخول في بيانات الاعتماد", 
	   application_report:"تقرير التطبيق", 
	   section_report:"تقرير القسم", 
	   course_report:"تقرير بالطبع", 
	   communication_summary:"ملخص الاتصال", 
	   comments_and_Document_Report:"التعليقات وتقرير الوثيقة", 
	   School_Calendar:"التقويم المدرسي", 
	   bell_Schedule:"جدول الجرس", 
	   student_Contract:"عقد الطالب", 
	   eOS_Report:"تقرير EOS", 
	   active_Enrollments_Per_Term_Report:"التسجيل النشط لكل تقرير", 
	   active_Student_Enrollments_with_As_Report:"تسجيلات الطلاب النشطة مع التقرير", 
	   active_Student_Enrollments_Report:"تقرير تسجيل الطلاب النشط", 
	   all_Students_GPA_Report:"تقرير جميع الطلاب GPA", 
	   old_All_Student_GPA_Report:"تقرير Old All Student GPA", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + تقرير نوع المشاركة", 
	   enrollment_Confirmation_Report:"تقرير تأكيد الالتحاق", 
	   eOS_College_Matriculations_Report:"تقرير مجاديات كلية EOS", 
	   student_Enrollment_History_To_Date_w_Term_Report:"تاريخ تسجيل الطلاب حتى الآن تقرير مصطلح",
	   student_Information_Report:"تقرير معلومات الطالب", 
	   ran_by:"ركض من قبل", 
	   Show_Filter:"عرض مرشح", 
	   School_Group:"مجموعة المدرسة", 
	   school:"مدرسة", 
	   department:"قسم", 
	   student:"طالب", 
	   student_status:"حالة الطالب", 
	   course:"دورة", 
	   course_level:"مستوى الدورة", 
	   section:"قسم", 
	   teacher:"مدرس", 
	   primary_teacher:"مدرس ابتدائي", 
	   secondary_teacher:"مدرس ثانوي", 
	   completion_Date_Range:"نطاق تاريخ الانتهاء", 
	   from_date:"من التاريخ", 
	   to_date:"ان يذهب في موعد", 
	   status:"حالة", 
	   gender:"جنس", 
	   final_grade:"الدرجة النهائية", 
	   advisor:"مستشار", 
	   grade_level:"مستوى الصف", 
	   specific_mark:"علامة محددة", 
	   track:"مسار", 
	   ethnicity:"عِرق", 
	   additional_fields:"حقول إضافية", 
	   school_sessions:"جلسات المدرسة", 
	   gradebook:"دفتر الصف", 
	   submit:"يُقدِّم", 
	   reset:"إعادة ضبط", 
	   show_hide_columns:"إظهار/إخفاء الأعمدة", 
	   select_all:"اختر الكل", 
	   student_id:"هوية الطالب", 
	   last_name:"اسم العائلة", 
	   first_name:"الاسم الأول", 
	   start_date:"تاريخ البدء", 
	   end_date:"تاريخ الانتهاء", 
	   grade_final:"نهائي الصف", 
	   percent:"نسبه مئويه", 
	   credit:"ائتمان", 
	   download_excel:"تنزيل Excel", 
	   print:"مطبعة", 
	   no_data:"لايوجد بيانات.", 
	   view:"منظر", 
	   showing:"تظهر", 
	   of:"ل", 
	   other_grade:"درجة أخرى", 
	   level:"مستوى", 
	   date:"تاريخ", 
	   grade:"درجة",
	   enrollment_Change_Status:"حالة تغيير الالتحاق", 
	   close:"يغلق", 
	   select_Enrollment_Status:"حدد حالة الالتحاق", 
	   select:"يختار...", 
	   cancel:"يلغي", 
	   save:"يحفظ", 
	   students:"طلاب", 
	   Course_Status:"حالة الدورة", 
	   Closed_courses:"دورات مغلقة", 
	   Section_Status:"حالة القسم", 
	   Closed_sections:"أقسام مغلقة", 
	   Transferred_From:"نقل من", 
	   Graduation_From_Date:"التخرج من التاريخ", 
	   Graduation_To_Date:"التخرج حتى الآن", 
	   Enrollment_From_Date:"التسجيل من التاريخ", 
	   Enrollment_To_Date:"التسجيل حتى الآن", 
	   Enrollment_Status:"حالة الالتحاق", 
	   Transfer_From_Date:"نقل من التاريخ", 
	   Transfer_To_Date:"نقل إلى التاريخ", 
	   Custom_Query:"استعلام مخصص", 
	   Last_Access_Date:"آخر تاريخ وصول", 
	   Total_Session_Time:"إجمالي وقت الجلسة", 
	   Quality_of_Work:"جودة العمل", 
	   Grade_to_Date:"الصف حتى الآن", 
	   Overall_Percent:"بشكل عام في المئة", 
	   On_Schedule_Percent:"في الموعد المحدد في المئة", 
	   Activity_Count_Complete:"عدد النشاط الكامل", 
	   Activity_Count_Total:"إجمالي عدد النشاط", 
	   Overdue_Activitie:"تأخرت", 
	   Section_Course_Additional_Fields:"القسم/الدورة الحقول الإضافية", 
	   Create_On_Date:"إنشاء في التاريخ", 
	   Last_Status_Update_Date:"تاريخ تحديث الحالة الأخيرة", 
	   Transferred_In:"نقل في", 
	   Transferred_In_Date:"نقل في التاريخ", 
	   email:"بريد إلكتروني", 
	   birth_date:"تاريخ الميلاد", 
	   course_name:"اسم الدورة التدريبية", 
	   section_name:"اسم القسم", 
	   school_name:"اسم المدرسة", 
	   Graduation_Date:"تاريخ التخرج", 
	   Created_on:"تم إنشاؤها على", 
	   mentor_Advisor:"معلم/مستشار", 
	   sections:"أقسام", 
	   roster:"قائمة", 
	   relationship:"علاقة", 
	   Email_or_Phone:"بريد الكتروني او هاتف", 
	   Enter_any_text:"أدخل أي نص", 
	   Advisor_Success_Manager:"مستشار / مدير نجاح", 
	   User_Id:"معرف المستخدم", 
	   phone_number:"رقم التليفون", 
	   Student_Last_Name:"الاسم الأخير للطلاب", 
	   Student_First_Name:"الاسم الأول للطالب", 
	   Student_Email:"البريد الإلكتروني الطالب", 
	   credentials:"أوراق اعتماد", 
	   availability:"توافر", 
	   enrollments:"التسجيلات", 
	   Datea_Created_on:"التاريخ الذي تم إنشاؤه على", 
	   country:"دولة", 
	   state:"ولاية", 
	   zipcode:"الرمز البريدي", 
	   Enter_any_zipcode:"أدخل أي zipcode", 
	   address:"عنوان",
	   zip_Code:"الرمز البريدي",
	   Login_Report:"تقرير تسجيل الدخول", 
	   user_Type:"نوع المستخدم", 
	   user_Name:"اسم المستخدم", 
	   Show_last_log_in_only:"إظهار تسجيل الدخول الأخير فقط", 
	   Username:"اسم المستخدم", 
	   Date_Time:"التاريخ/الوقت", 
	   Ip_Address:"عنوان IP", 
	   city:"مدينة", 
	   Enrollment_Start_Date:"تاريخ بدء التسجيل", 
	   Enrollment_End_Date:"تاريخ نهاية التسجيل", 
	   Completion_Date:"موعد الإكمال", 
	   section_Type:"نوع القسم", 
	   student_Enrolled:"التحق الطالب", 
	   content_Provider:"مزود المحتوى", 
	   student_Additional_Fields:"الطالب حقول إضافية",
	   type:"يكتب", 
	   in_Class_Information:"في معلومات الفصل",
	   Enrollment_Summary_Report:"تقرير ملخص التسجيل", 
	   Transferred_From_School:"نقل من المدرسة",
	   Total_Enrollments:"إجمالي التسجيلات", 
	   content_Type:"نوع المحتوى", 
	   active_Course_Progress:"التقدم النشط للدورة", 
	   Grades:"درجات", 
	   attendance:"حضور",
	   student_Absences:"غياب الطالب", 
	   total_Absence:"الغياب التام", 
	   section_Absences:"الغياب القسم", 
	   Grade_Level_Absences:"الغياب مستوى الصف", 
	   Gender_Absences:"الغياب بين الجنسين", 
	   Login_credentials:"بيانات الاعتماد تسجيل الدخول", 
	   names:"أسماء", 
	   user_status_admin_teacher_parent:"حالة المستخدم (المسؤول ، المعلم ، الوالد)", 
	   show_title:"عرض العنوان", 
	   midle_name:"الاسم الأوسط", 
	   password:"كلمة المرور", 
	   parent_name:"اسم الوالدين", 
	   linked_to_parent:"مرتبط بالوالد", 
	   linked_to_student:"مرتبط الطالب", 
	   login_credentials_Report:"تقرير بيانات الاعتماد تسجيل الدخول", 
	   app_id:"معرف التطبيق", 
	   created:"مخلوق", 
	   modified:"معدل", 
	   select_level:"اختار مستوى", 
	   select_additional_fields:"قسم الحقول الإضافية", 
	   title:"عنوان", 
	   credits:"الاعتمادات", 
	   section_ID:"معرف القسم", 
	   content:"محتوى", 
	   course_additional_fields:"مسار حقول إضافية", 
	   course_id:"معرف بالطبع", 
	   communication_summary_report:"تقرير ملخص الاتصال", 
	   method:"طريقة", 
	   create_date:"إنشاء تاريخ", 
	   subject:"موضوع", 
	   make_from_id:"جعل من الهوية", 
	   make_to:"جعل ل", 
	   attachments:"المرفقات", 
	   comment_and_document_summary_report:"تقرير ملخص التعليق والوثيقة", 
	   comment_type:"نوع التعليق", 
	   flagged:"وضع علامة", 
	   sharing_target:"مشاركة الهدف", 
	   show_on_transcript:"عرض على النص", 
	   by:"بواسطة", 
	   comment:"تعليق", 
	   type_name:"أكتب اسم", 
	   effective_from_date:"اعتبارا من التاريخ", 
	   effective_to_date:"ساري المفعول حتى الآن", 
	   count_docs:"عدد المستندات",
	   school_calendar_report:"تقرير التقويم المدرسي", 
	   event_Id:"معرف الحدث", 
	   date_start:"تاريخ البدء", 
	   date_end:"نهاية التاريخ", 
	   posted_last_name:"نشر الاسم الأخير", 
	   posted_first_name:"نشر الاسم الأول",
	   bell_schedule_report:"تقرير جدول الجرس", 
	   period:"فترة", 
	   start:"يبدأ", 
	   end:"نهاية",
	   student_contract_report:"تقرير عقد الطالب", 
	   begin_date:"تاريخ البدء", 
	   contracts:"انكماش", 
	   contract_name:"اسم العقد", 
	   contract_begin_date:"تاريخ بدء العقد", 
	   contract_end_date:"تاريخ نهاية العقد", 
	   active_enrollments_per_term_report:"التسجيل النشط لكل تقرير", 
	   entry_date:"موعد الدخول", 
	   teachers:"معلمون", 
	   term:"شرط", 
	    sections:"المقاطع",
	   showing_of:"يظهر 10 من 20",
	   filter:"منقي",
	   students:"الطلاب",
	   school:"المدرسة",
	   all_school:"جميع المدارس",
	   student:"طالب علم",
	   email:"البريد الإلكتروني",
	   grade_level:"مستوى الصف",
	   status:"حالة",
	   seach_for_a_student_or_id:"ابحث عن طالب أو بطاقة هوية ...",
	   search:"يبحث …",
	   message_student:"رسالة الطالب",
	   request_enrollment:"طلب التسجيل",
	   print_schedule:"جدول الطباعة",
	   view:"رأي",
	   no_data:"لايوجد بيانات.",
	   views:"الآراء", 
	   enrollment:"التسجيل", 
	   schedule:"برنامج", 
	   transferred_grades:"الدرجات المنقولة", 
	   comments_ocuments:"التعليقات والوثائق", 
	   academic_records:"السجلات الأكاديمية", 
	   compliance_log:"سجل الامتثال", 
	   unofficial_transcript:"نص غير رسمي", 
	   iD_card:"بطاقة التعريف", 
	   student_number_id_information:"رقم الطالب # 29561 المعلومات", 
	   student_number:"رقم الطالب", 
	   gender:"جنس", 
	   goes_by:"يمر", 
	   date_of_birth:"تاريخ الولادة", 
	   ethnicity:"عِرق", 
	   mobile:"التليفون المحمول", 
	   academic_track:"المسار الأكاديمي", 
	   learning_path_template:"قالب مسار التعلم", 
	   graduation_date:"تاريخ التخرج", 
	   comments:"تعليقات", 
	   transfer_information:"نقل المعلومات", 
	   enrollment_date:"تاريخ التسجيل", 
	   transfer_date:"تاريخ التحويل", 
	   transfer_student:"الطالب المنتقل", 
	   parent_mentor_contact:"الوالد / المرشد الاتصال", 
	   mentor:"مُرشِد", 
	   parent_phone:"هاتف الوالدين", 
	   emergency_contact:"الاتصال بالطوارىء", 
	   academic_advisor_ssm:"مرشد أكاديمي / SSM", 
	   student_success_manager:"مدير نجاح الطالب", 
	   academic_avisor:"المرشد الأكاديمي", 
	   address:"تبوك", 
	   address_01_Default:"العنوان 01 (افتراضي)", 
	   street:"شارع", 
	   city:"مدينة", 
	   state:"حالة", 
	   zip:"أَزِيز", 
	   hide_Detailed_information:"إخفاء المعلومات التفصيلية", 	    
	   current_course_progress:"تقدم الدورة الحالية", 	    
	   full_Path_Progress:"تقدم المسار الكامل", 	    
	   print:"مطبعة", 	    
	   avg_graduation_progress:"متوسط تقدم التخرج", 	    
	   GPA:"المعدل التراكمي", 	    
	   graduation_Status:"حالة التخرج", 	    
	   on_track:"على الطريق", 
	   show_detailed_information:"إظهار المعلومات التفصيلية",
       communication:"الاتصالات",
	   student_advisors:"مستشاري الطلاب", 	    
	   country:"دولة", 	    
	   grade:"صف دراسي", 	    
	   credits:"الاعتمادات", 	    
	   sort:"فرز", 	    
	   course_progress:"تقدم الدورة",
	   overall_GPA:"GPA العام",
	   current_graduation_progress:"تقدم التخرج الحالي",
	   individual_course_progress:"* يختلف تقدم الدورة الفردية ، وهذا هو تقدمك العام", 
	   subject:"موضوعات",
	   online_sections:"أقسام عبر الإنترنت",
	   course:"مسار", 
	   section:"الجزء", 
	   actions:"أجراءات", 
	   view_event:"عرض المناسبة",
	   in_class_section:"في قسم الفصل",
	   calendar:"تقويم",
	   access_link:"رابط الوصول", 
	   online_link:"رابط عبر الإنترنت",
	   launch_course:"دورة الإطلاق", 
	   start_class:"أبدا الدرس",
	   level:"مستوى", 
	   date:"تاريخ", 
	   transferred_in:"تم التحويل في",
	   tranferred_grades:"الدرجات المنقولة",
	   Searchs:"يبحث", 
	   Search_department_course:"بحث في دورة القسم ، src ...",
	   archived:"مؤرشف", 
	   add_comment:"أضف تعليق", 
	   created_date:"تاريخ الإنشاء", 
	   by:"بواسطة", 
	   type:"يكتب", 
	   comment:"تعليق", 
	   from_date:"من التاريخ", 
	   to_date:"حتي اليوم", 
	   documents:"وثائق", 
	   edit:"يحرر", 
	   delete:"حذف",
	   communications:"مجال الاتصالات", 
	   add_communications:"أضف التواصل", 
	   made_from:"مصنوع من", 
	   made_to:"مصنوع ل", 
	   means:"وسائل", 
	   attachments:"المرفقات", 
	   content:"محتوى",
	   compliance_logs:"سجلات الامتثال", 
	   messageID:"معرف الرسالة", 
	   agree:"يوافق على", 
	   dateTime:"تاريخ الوقت", 
	   iPAddress:"عنوان IP", 
	   add_idit_comment_document:"إضافة / تحرير تعليق ووثيقة", 
	   document_type:"نوع الوثيقة", 
	   show_on_transcript:"إظهار في النص", 
	   select_users_to:"حدد المستخدمي", 
	   teacher:"معلم", 
	   parent:"الأبوين", 
	   flag:"علَم", 
	   none:"لا أحد", 
	   link:"نهاية لهذه الغاية", 
	   label:"مُلصَق", 
	   add_more_link:"إضافة المزيد من الارتباط", 
	   save:"يحفظ", 
	   add_edit_communication:"إضافة / تحرير الاتصال", 
	   made_by:"مصنوع بواسطة", 
	   date_time:"التاريخ / الوقت", 
	   length:"طول", 
	   select:"يختار", 
	   select_users_to_view:"حدد المستخدمين لعرض الاتصال", 
	   add_more:"أضف المزيد", 
	   communication_summary:"ملخص الاتصال",
	   close:"قريب",
	   new_type:"نوع جديد",
	   select_user_to_view_comment:"حدد المستخدمين لعرض التعليق",
	   flag_comment:"الإبلاغ عن التعليق",
	   teacher_page:"صفحة المعلم",
	   edit_information:"تعديل المعلومات",
	   phone:"هاتف",
	   add_credential:"أضف بيانات الاعتماد",
	   add_edit_credential:"إضافة / تحرير بيانات الاعتماد",
	   first_name:"الاسم الاول",
	   midle_name:"الاسم الوسطى",
	   last_name:"الكنية",
	   cancel:"يلغي",
	   add_new:"اضف جديد",
	   phone_type:"نوع الهاتف",
	   zipCode:"الرمز البريدي",
	   phone_number:"رقم الهاتف",
	   default:"تقصير",
	   please_select_country:"الرجاء تحديد الدولة",
	   student_information:"بيانات الطالب",
	   username:"اسم المستخدم",
	   user_directory:"دليل المستخدم",
	   add_teacher:"اضافة مدرس",
	   add_admin:"إضافة المسؤول",
	   export_to_excel:"تصدير إلى Excel",
	   export_to_pdf:"تصدير إلى PDF",
	   send_login_credentials:"إرسال بيانات اعتماد تسجيل الدخول",
	   search_for_a_user_or_id:"البحث عن مستخدم أو معرّف ...",
	   user:"المستعمل",
	   school_admin:"مدير المدرسة",
	   change_password:"تغيير كلمة المرور",
	   set_password_expiration_date:"تعيين تاريخ انتهاء صلاحية كلمة المرور",
	   impersonate_user:"انتحال شخصية المستخدم",
	   edit_user_tags:"تحرير علامات المستخدم",
	   add_or_edit_users_schoo_assign:"إضافة أو تحرير المستخدمين تعيين المدرسة",
	   assign_content_access:"قم بتعيين الوصول إلى المحتوى",
	   add_student:"أضف طالب",
	   add_parent_mentor:"إضافة الوالد / المرشد",
	   showing:"عرض",
	   of:"من",
	   school_name:"اسم المدرسة",
	   edit_user_school_tags:"تحرير علامات المستخدم والمدرسة",
	   personal_information:"معلومات شخصية",
	   contacted_load:"تحميل المتصل",
	   maximum_of_active_students:"الحد الأقصى لعدد الطلاب النشطين",
	   teacher_since:"مدرس منذ",
	   login_infomation:"معلومات تسجيل الدخول",
	   username:"اسم المستخدم ",
	   password :"كلمة المرور",
	   avatar :"الصورة الرمزية",
	   teachers :"معلمون",
	   change_status :"تغيير الوضع",
	   add_admin:"إضافة المسؤول",
	   name:"اسم",
	   create_on:"أنشئ في",
	   registrar:"المسجل",
	   birthday:"عيد ميلاد",
	   signature:"التوقيع",
	   photo:"صورة",
	   designated_registrar:"المسجل المعين",
	   track:"مسار",
	   select_existing_track:"حدد المسار الحالي",
	   available:"متاح",
	   parent_mentor:"الوالد / المرشد",
	   relationship:"علاقة",
	   email_address:"عنوان البريد الإلكتروني",
	   academic_mentor:"المرشد الأكاديمي",
	   no_data_available_in_table:" لا توجد بيانات متوفرة في الجدول",
	   primary_language:"اللغة الأساسية",
	   add_into_parent_or_mentor:"إضافة إلى الأم / المرشد",
	   add_into_phone:"إضافة إلى الهاتف",
	   add_into_address:"أضف إلى العنوان",
	   select_one:"اختر واحدة",
	   login:"تسجيل الدخول",
	   plese_select_country:"الرجاء اختيار الدولة",
	   edit_student:"تحرير الطالب",
	   academic_advisor_or_student_success_manager:"مرشد أكاديمي / مدير نجاح طلابي",
	   role:"دور",
	   link_parent:"رابط الأصل",
	   link_advisor_sms:"مستشار الارتباط / SSM",
	   save_into_parent_mentor:"حفظ في الوالد / المرشد",
	   save_into_parent_phone:"حفظ في الهاتف",
	   save_into_parent_address:"حفظ في العنوان",
	   bulk_information_update:"تحديث المعلومات بالجملة",
	   enrollments:"التسجيلات",
	   email_student:" إرسال بريد إلكتروني إلى الطالب",
	   unofficial_transcripts:"محاضر غير رسمية",
	   official_transcripts:"المستندات الرسمية",
	   email_students_schedule:"إرسال جدول الطالب بالبريد الإلكتروني",
	   export_students_to_excel:"تصدير الطلاب إلى Excel",
	   export_parent_list_to_excel:"تصدير قائمة الأصل إلى Excel",
	   assign_learning_path_template:"تعيين قالب مسار التعلم",
	   promote_student_to_the_next_grade_level:"ترقية الطالب إلى الصف التالي",
	   batch_upload_students:"دفعة تحميل الطلاب",
	   batch_upload_transfer_grades:"درجات نقل تحميل دفعة",
	   transfer_apex_only:"نقل (APEX فقط)",
	   transfer_content_providers:" نقل (جميع مزودي المحتوى)",
	   batch_enrollments:"عمليات التسجيل دفعة",
	   send_message:"إرسال رسالة",
	   impersonate:"انتحال الشخصية",
	   change_login_credentials:"تغيير بيانات اعتماد تسجيل الدخول",
	   request_enrollment:"طلب التسجيل",
	   send_weekly_status_report:"إرسال تقرير الحالة الأسبوعي",
	   please_select_student:"الرجاء تحديد الطلاب.",
	   student_status_will_be_changed_to_status_withdraw:"سيتم تغيير حالة الطالب إلى 111 ، وسيتم سحب جميع التسجيلات. هل أنت متأكد أنك تريد المتابعة؟",
	   student_status_will_be_changed_to_status:"سيتم تغيير حالة الطالب إلى 111. هل أنت متأكد من أنك تريد المتابعة؟",
	   value:"قيمة",
	   student_success_manager_or_acdemic:"مدير نجاح الطلاب / المستشار الأكاديمي",
	   enroll_students_to_section:"تسجيل الطلاب على القسم",
	   department:"قسم",
	   refresh:"تحديث",
	   select_department:"الرجاء تحديد القسم",
	   select_course:"حدد دورة",
	   select_section:"حدد القسم",
	   start_date:"تاريخ البدء",
	   end_date:"تاريخ الانتهاء",
	   ID:"بطاقة تعريف",
	   action:"فعل",
	   enrollment_period:"فترة الالتحاق",
	   select_a_course_to_register_ilp:"حدد دورة لتسجيل ILP",
	   period:"فترة",
	   credit:"ائتمان",
	   year:"سنة",
	   enroll:"يتسجل، يلتحق",
	   recipient_transcript:"نص مستلم",
	   select_all_or_unselect_all:"حدد الكل / إلغاء تحديد الكل",
	   include_in_progress_sections:"تشمل أقسام التقدم",
	   show_satisfaction_of_program:"إظهار رضا البرنامج",
	   show_total_credit:"إظهار الاعتمادات الكلية",
	   show_student_info:"عرض معلومات الطالب",
	   show_academic_info:"إظهار المعلومات الأكاديمية",
	   show_school_names_from_orther_grades:"عرض أسماء المدارس من الدرجات الأخرى",
	   show_school_contact:"عرض الاتصال بالمدرسة",
	   include_transferred_grades_in_gpa:"تشمل الدرجات المنقولة في المعدل التراكمي",
	   include_in_progress_grade:"تشمل درجة التقدم",
	   include_grade_scales:"تشمل جداول الصف",
	   show_graduation_date:"عرض تاريخ التخرج",
	   show_weighted_gpa:"إظهار المعدل التراكمي المرجح",
	   show_grade_level_gpa:"إظهار مستوى مستوى الصفوف المعدل التراكمي",
	   show_comletion_date:"عرض تاريخ الانتهاء",
	   show_withdraw_classes:"عرض الفصول المسحوبة",
	   show_withdraw_date:"عرض تاريخ سحب",
	   show_transfered_in_classes:"تم نقلها في الفصول الدراسية",
	   show_digital_seal:"إظهار الختم الرقمي",
	   show_singnature:"عرض التوقيع",
	   group_by:"مجموعة من",
	   school_year:"السنة الدراسية",
	   school_level:"مستوى المدرسة",
	   notes:"ملحوظات",
	   ok:"موافق",
	   are_you_sure_to_send:"هل أنت متأكد من إرسال؟",
	   assign_learning_path_templete:"تعيين قالب مسار التعلم",
	   assign_student_to_selected_learning:"تعيين الطالب إلى قالب مسار التعلم المحدد",
	   assign:"تعيين",
	   are_you_sure_to_promote_to_level:"هل أنت متأكد من الترويج لمستوى الصف التالي؟",
	   data_process:"عملية البيانات",
	   upload_and_import_data:"تحميل البيانات واستيرادها",
	   download_user_information:"قم بتنزيل معلومات المستخدم",
	   here:"هنا",
	   select_student_upload_file:"حدد ملف تحميل الطالب",
	   local_drive:"محرك محلي",
	   the_file_is_uploaded:"تم تحميل الملف",
	   template_name:"اسم القالب",
	   Here:"هنا",
	   sample_file_excel:"عينة ملف Excel.",
	   file_type:"نوع الملف",
	   delimited:"محدد",
	   delimited_chars:"محدد الشارز",
	   fixed_width:"عرض ثابت",
	   first_line_header:"رأس الخط الأول",
	   loader_field:"حقل التحميل",
	   Header:"رأس",
	   sample_data:"عينة البيانات",
	   column_width:"عرض colunm",
	   save_tamplate:"حفظ القالب",
	   save_and_upload_data:"حفظ وتحميل البيانات",
	   result:"نتيجة",
	   upload_and_import_data_orther_grade:"تحميل واستيراد البيانات الدرجة الأخرى",
	   select_upload_file:"حدد ملف تحميل",
	   student_id:"هوية الطالب",
	   uploadAnd_import_data_enrollment:"تحميل واستيراد تسجيل البيانات",
	   section_id:"معرف القسم",
	   title:"عنوان",
	   recipient:"متلقي",
	   same_current_address:"نفس العنوان الحالي",
	   add_more_reciptient:"أضف المزيد من المستلم",
	   issuse_date:"تاريخ الإصدار",
	   show_total_unapplied_credits:"إظهار إجمالي الاعتمادات غير المطالبة",
	   reconcile_another_student_record:"التوفيق مع سجل طالب آخر",
	   please_choose_one_student_to_reconcile:"الرجاء اختيار طالب واحد للتوفيق.",
	   yes:"نعم",
	   no:"لا",
	   apex_classroom_sync:"Apex Classroom Sync",
	   next:"التالي",
	   apex_classrooms:"الفصول الدراسية Apex",
	   online_user_id:"معرف المستخدم عبر الإنترنت",
	   enter_online_user_id:"أدخل معرف المستخدم عبر الإنترنت",
	   online_section_id:"معرف القسم عبر الإنترنت",
	   online_section_name:"اسم القسم عبر الإنترنت",
	   online_course_name:"اسم الدورة عبر الإنترنت",
	   enrollment_date:"تاريخ الالتحاق",
	   back:"خلف",
	   import:"يستورد",
	   offical_transcipt:"النسخة الرسمية",
	   email_schedule:"جدول البريد الإلكتروني",
	   reconcile_with_another_records:"التوفيق مع سجل آخر",
	   online_sync_and_update:"التقدم عبر الإنترنت تزامن وتحديث",
	   download_all_completion_cretification:"قم بتنزيل جميع شهادة الانتهاء",
	   orther_grade:"درجات أخرى",
	   medical:"طبي",
	   comments_and_documents:"التعليقات والوثائق",
	   contracts:"انكماش",
	   invoices:"فواتير",
	   audit_logs:"سجلات التدقيق",
	   edit_logs:"تحرير سجلات",
	   grade_to_date:"الصف حتى الآن",
	   quality_of_work:"جودة العمل",
	   last_access:"آخر ولوج",
	   gradebook:"دفتر الصف",
	   transfer:"تحويل",
	   completion_certification:"شهادة الانتهاء",
	   tranfer_user_school:"نقل مدرسة المستخدم",
	   tranfer_to_school:"نقل إلى المدرسة",
	   tranfer_apex_classrooms:"نقل الفصول الدراسية Apex",
	   course_to_moved:"مسار للانتقال",
	   current_teacher:"المعلم الحالي",
	   future_section:"القسم المستقبلي",
	   future_program:"برنامج المستقبل",
	   future_teacher:"مدرس المستقبل",
	   enrollment_start_date_end_date:"تاريخ بدء التسجيل - تاريخ الانتهاء",
	   no_more_option:"لا مزيد من الخيارات",
	   create_new:"خلق جديد إبداع جديد",
	   transfer_classrooms:"نقل الفصول الدراسية",
	   tyler_synchronization_for_az_school:"تزامن تايلر لمدارس الألف إلى الياء",
	   synchronize:"تزامن",
	   individual_course_progress_varies:"يختلف تقدم الدورة الفردية. هذا هو تقدمك العام نحو التخرج.",
	   edit_ilp:"تحرير ILP",
	   add_academic_record:"إضافة سجل أكاديمي",
	   edit_all_records:"تحرير جميع السجلات",
	   search_corse_department_src:"دورة البحث ، القسم ، SRC ...",
	   message_id:"معرف الرسالة",
	   add_new_contract:"أضف عقدًا جديدًا",
	   contract_id:"معرف العقد",
	   contract_name:"اسم العقد",
	   first_date:"الموعد الاول",
	   last_date:"اخر موعد",
	   amount_per_period:"المبلغ لكل فترة",
	   terminating_status:"إنهاء الحالة",
	   payment_history:"سجل الدفع",
	   record_payment:"تسجيل السجل",
	   payment_method:"طريقة الدفع او السداد",
	   invoice_id:"هوية صوتية",
	   show_all:"عرض الكل",
	   invoice_date:"تاريخ الفاتورة",
	   from:"من…",
	   to:"ل…",
	   amount:"كمية",
	   paid:"مدفوع",
	   due:"حق",
	   date_paid:"تاريخ الدفع",
	   apply_payments:"تطبيق المدفوعات",
	   mark_as_paid:"مارك كما دفعت",
	   void:"فارغ",
	   audit_log:"سجل التدقيق",
	   object:"هدف",
	   changes_made:"التغييرات التي تم إجراؤها",
	   create_time:"خلق الوقت",
	   time_stamp:"طابع زمني",
	   user_creare:"إنشاء المستخدم",
	   edit_log:"تحرير السجل",
	   field_name:"اسم الحقل",
	   old_value:"القيمة القديمة",
	   new_value:"قيمة جديدة",
	   date_time_update:"تحديث التاريخ/الوقت",
	   updater:"محدث",
	   add_edit_academic_records:"إضافة/تحرير السجل الأكاديمي",
	   select_flag:"حدد العلم ...",
	   edit_all_tranferred_grades:"تحرير جميع الدرجات المدفوعة",
	   save_records:"حفظ السجلات",
	   possible_credits:"الاعتمادات المحتملة",
	   select_level:"اختار مستوى",
	   select_grade_level:"حدد مستوى الصف",
	   select_status:"حدد الحالة",
	   add_more_row:"أضف المزيد من الصف",
	   full_screen:"تكبير الشاشة",
	   course_code:"أضف درجات أخرى",
	   add_order_grades:"رمز الدورة",
	   select_credit:"حدد الائتمان",
	   select_default:"حدد الافتراضي",
	   credits_possible:"الاعتمادات ممكنة",
	   select_possible_credit:"حدد الائتمان المحتمل",
	   product:"منتج",
	   fromn:"من",
	   ton:"ل",
	   last_invoice_date:"آخر تاريخ الفاتورة",
	   please_select_stu:"الرجاء تحديد الطالب",
	   payer:"دافع",
	   amount_per_billing_period:"المبلغ لكل فترة الفواتير",
	   price_unit:"وحدة السعر",
	   billing_period:"فترة الفواتير",
	   automatic_renewal:"تجديد تلقائي",
	   automatic_payment:"الفواتير التلقائية",
	   duration_of_period:"المدة (# من الفترات)",
	   payment_id:"معرف الدفع",
	   payment_date:"تاريخ الدفع",
	   payment_amount:"مبلغ الدفع",
	   applied:"مُطبَّق",
	   available:"متاح",
	   unApply:"عدم التشكيل",
	   refund:"استرداد",
	   add_new_teacher:"أضف مدرسًا جديدًا",
	   change_teacher_status:"تغيير حالة المعلم",
	   search_for_a_teacher_or_id:"ابحث عن معلم أو معرف ...",
	   flags:"أعلام",
	   tags:"العلامات",
	   allowed:"مسموح",
	   message_teacher:"مدرس الرسالة",
	   impersonate_teacher:"انتحال شخصية المعلم",
	   add_teacher_qualification:"إضافة مؤهلات المعلم",
	   profile:"حساب تعريفي",
	   teacher_schedule:"جدول المعلم",
	   qualifications:"مؤهلات",
	   student_actions:"تصرفات الطلاب",
	   linking_parents_to:"ربط الوالدين",
	   select_do:"يختار ...",
	   see_edit_logs:"انظر تحرير سجلات",
	   see_qualifications:"انظر المؤهلات",
	   link_academic_advisor:"ربط المستشار الأكاديمي",
	   student_success:"نجاح الطالب",
	   linking_academic_advisor_or_student_success:"ربط المستشار الأكاديمي / نجاح الطالب",
	   staff:"طاقم عمل",
	   teacher_status:"حالة المعلم",
	   school_admin_status:"حالة مسؤول المدرسة",
	   global_user_directory:"دليل المستخدم العالمي",
	   edit_teacher:"تحرير المعلم",
	   contracted:"تعاقد",
	   add_comments_and_documents:"التعليقات والوثائق",
	   edit_comments_and_documents:"تحرير التعليقات والوثائق",
	   parents_or_mentor:"الآباء / المعلم",
	   send_mail:"ارسل بريد",
	   are_you_sure_to_delete_this_teacher:"هل أنت متأكد من حذف هذا المعلم.",
	   edit_user_password:"تحرير اسم المستخدم وكلمة المرور",
	   add_qualifications:"إضافة مؤهلات",
	   please_select_a_least_on_teacher:"الرجاء تحديد ما لا يقل عن مدرس واحد.",
	   edit_parent_mentor:"تحرير الوالد / المعلم",
	   parent_mentor_information:"معلومات الوالدين / المعلم",
	   send:"يرسل",
	   are_you_surse_to_delete_this_parent:"هل أنت متأكد من حذف هذا الوالد.",
	   home:"بيت",	   
	 //  auto_promotion:"الترويج التلقائي",
	   auto_promotion:"ترويج مستوى الصف الطالب",
	   Promote:"يرقي",
	   search_for_a_name:"ابحث عن اسم ...",
	   download_to_excel:"تنزيل إلى Excel",
	   download_to_pdf:"تنزيل إلى PDF",
	   User_ID:"معرف المستخدم",
	   User_type:"نوع المستخدم",
	   communication_log:"سجل الاتصال",
	   Student_Status:"حالة الطالب",
	   Users:"المستخدمون",
	   Staff_Reassignment:"إعادة تعيين الموظفين",
	   Select_Staff:"حدد الموظفين",
	   select_asset_type_to_reassign:"حدد نوع الأصول لإعادة تعيينه",
	   transfer_all_to:"نقل كل شيء إلى",
	   transfer_selectively:"نقل بشكل انتقائي",
	   remove_all:"حذف الكل",
	   remove_selectively:"إزالة بشكل انتقائي",
	   Event:"حدث",
	   Time:"وقت",
	   Participants:"مشاركون",
	   new_staff:"موظفين جدد",
	   Remove:"يزيل",
	   Profile_Page:"الصفحة الشخصية",
	   settings:"إعدادات",
	   security:"حماية",
	   timezone:"وحدة زمنية",
	   notifications:"إشعارات",
	   check_for_feature_availability_at_your_school:"تحقق من توافر الميزة في مدرستك.",
	   current_password:"كلمة السر الحالية",
	   new_password:"كلمة المرور الجديدة",
	   confirm_password:"تأكيد كلمة المرور",
	   updte_password:"تطوير كلمة السر",
	   change_timezone:"تغيير المنطقة الزمنية",
	   time_zone:"وحدة زمنية",
	   please_select_time_zone:"الرجاء تحديد المنطقة الزمنية",
	   notification_settings:"إعدادات الإشعار",
	   level_of_urgency:"مستوى الإلحاح",
	   email_destination:"وجهة البريد الإلكتروني",
	   SMS_Destination:"وجهة الرسائل القصيرة",
	   app:"برنامج",
	   please_select_level_of_urgency:"الرجاء تحديد مستوى الإلحاح",	   
	   reset_filters:"إعادة تعيين المرشحات",
	   batch_data_update:"تحديث بيانات الطالب",
	   contract_template:"قالب العقد",
	   accept:"يقبل",
	   reject:"يرفض",
	   view_roles:"عرض الأدوار",
	   administrator_information:"معلومات المسؤول", 
	   account_reation_date:"تاريخ إنشاء الحساب", 
	   expiration_date:"تاريخ انتهاء الصلاحية", 
	   schools:"المدارس", 
	   advisees:"ينصح",
	   message:"رسالة",
	   see_comments_and_documents:"انظر التعليقات والوثائق",
	   restore_APEX_Classrooms:"استعادة الفصول الدراسية Apex",
	   teacher_information:"معلومات المعلم", 
	   teacher_number:"رقم المعلم", 
	   departmens:"المغادرون", 
	   global_capacity:"القدرة العالمية", 
	   local_contracted_load:"الحمل المحلي المتعاقد", 
	   parents:"آباء", 
	   parent_information:"معلومات الوالدين",
	   linked_students:"الطلاب المرتبطين", 
	   link_student:"ربط الطالب", 
	   unlink_student:"طالب غير مرن", 
	   search_dot:"يبحث…", 
	   view_local:"عرض محلي", 
	   view_global:"عرض عالمي", 
	   resource:"الموارد", 
	   current_grade:"الصف الحالي", 
	   affiliation:"انتساب", 
	   current_assignment:"المهمة الحالية", 
	   total_assignments:"إجمالي الواجبات", 
	   percent_completed:"الانتهاء في المئة",
	   semester:"نصف السنة",
	   graduation_year:"سنة التخرج", 
	   student_name:"الاعتمادات حصل", 
	   credits_earned:"الاعتمادات حصل",
	   exit:"مخرج",
	   engagement_type:"نوع المشاركة",
	   college_admitted:"اعترفت الكلية", 
	   college_attending:"الكلية حضور", 
	   major:"رئيسي", 
	   report_card:"بطاقة تقرير", 
	   academic_term:"مصطلح أكاديمي", 
	   show_average:"عرض المتوسط", 
	   school_information:"معلومات المدرسة", 
	   school_misc_configuration:"تكوين MISC للمدرسة", 
	   school_tags:"علامات المدرسة", 
	   role_tags:"علامات الدور", 
	   content_integration:"تكامل المحتوى", 
	   user_roles:"أدوار المستخدمين", 
	   communication_user_rules:"قواعد مستخدم الاتصالات", 
	   school_administrators:"مديري المدارس", 
	   school_year_configuration:"تكوين السنة الدراسية", 
	   A_R_payment_configuration:"تكوين الدفع A/R", 
	   facility:"منشأة", 
	   enrollment_rules:"قواعد الالتحاق", 
	   student_contract_rules:"قواعد عقد الطالب", 
	   products:"منتجات", 
	   notification_templates:"قوالب الإخطار", 
	   transcript_viewer_options:"خيارات عارض النص", 
	   feature_configuration:"تكوين الميزة", 
	   feature_settings:"إعدادات الميزة", 
	   communication_rules:"قواعد الاتصال", 
	   object_state:"حالة الكائن", 
	   departments:"الإدارات", 
	   grading_scales:"مقاييس الدرجات", 
	   grading_periods:"فترات الدرجات", 
	   academic_tracks:"المسارات الأكاديمية", 
	   learning_path_templates:"قوالب مسار التعلم", 
	   grade_book_activity_descriptions:"أوصاف نشاط كتاب الصف", 
	   academic_terms:"الشروط الأكاديمية",
	   academic_system:"النظام الأكاديمي",
	   address_line_1:"العنوان سطر 1", 
	   country_code:"الرقم الدولي", 
	   address_line_2:"سطر العنوان 2", 
	   school_title:"لقب المدرسة",
	   CEEB_code:"رمز CEEB", 
	   zip_postal_code:"الرمز البريدي / الرمز البريدي", 
	   state_province:"الدولة/المقاطعة", 
	   website:"موقع إلكتروني", 
	   subdomain:"نطاق فرعي", 
	   success_manager:"مدير النجاح", 
	   school_logo:"شعار المدرسة", 
	   digital_seal:"الختم الرقمي",
	   password_exception_rule:"قاعدة استثناء كلمة المرور",
	   change_password_first_login:"تغيير كلمة المرور أولاً تسجيل الدخول", 
	   password_expires_after_days:"تنتهي كلمة المرور بعد أيام", 
	   enforcement_of_teachers_load:"إنفاذ تحميل المعلم", 
	   in_house_handling_of_transcript_requests:"في معالجة المنزل لطلبات النص", 
	   display_mobile_app_link:"عرض رابط تطبيق الجوال", 
	   display_weekly_progress_goal:"عرض هدف التقدم الأسبوعي", 
	   turn_on_notification:"تشغيل الإخطار", 
	   classic_letter:"رسالة كلاسيكية", 
	   automatic_parent_account_creation:"إنشاء حساب الأصل التلقائي", 
	   default_parent_account_status:"حالة حساب الوالد الافتراضي", 
	   default_time_zone:"المنطقة الزمنية الافتراضية", 
	   link_to_transcript_vendor_help:"ارتباط بمساعدة بائع النسخ", 
	   link_to_transcript_vendor:"ارتباط ببائع النص", 
	   link_for_help_system:"رابط لنظام المساعدة", 
	   student_enrollment_limit:"حد تسجيل الطلاب", 
	   default_section_type:"نوع القسم الافتراضي", 
	   default_section_capacity:"سعة القسم الافتراضي", 
	   transcript_template:"قالب النص", 
	   edit_security_school_tags:"تحرير علامات مدرسة الأمن", 
	   security_school_tags:"علامات مدرسة الأمن",
	   tags_name:"اسم العلامات", 
	   edit_role_tags:"تحرير علامات الدور",
	   add_school_based_tags:"أضف العلامات المستندة إلى المدرسة", 
	   description:"وصف", 
	   applied_to_roles:"تنطبق على الأدوار", 
	   teacher:"مدرس", 
	   edit_security_role_tags_for:"تحرير علامات دور الأمان ل", 
	   school_admins:"مدراء المدارس",
	   school_begin_date:"تاريخ بدء المدرسة", 
	   school_end_date:"تاريخ نهاية المدرسة", 
	   automatic_control_of_teacher_s_load:"التحكم التلقائي في تحميل المعلم",
	   A_R_payment_gateway_configuration:"تكوين بوابة الدفع A/R", 
	   payment_processing_vendor:"بائع معالجة الدفع", 
	   secret_key:"المفتاح السري", 
	   publishable_key:"المفتاح القابل للنشر", 
	   account_id:"معرف الحساب",
	   updating_tudents:"تحديث الطلاب", 
	   delete_selected_records:"حذف السجلات المحددة",
	   attribute_name:"اسم السمة", 
	   applied_for:"قدم على",
	   add_school:"أضف المدرسة", 
	   overview:"ملخص", 
	   search_for_school:"ابحث عن المدرسة ...", 
	   search_for_student:"ابحث عن الطالب ...",
	   attribute_type:"نوع السمة", 
	   select_school_group:"حدد مجموعة المدرسة", 
	   access_rights:"حقوق الوصول", 
	   create:"يخلق", 
	   read:"يقرأ",
	   facility_management:"إدارة المرافق", 
	   facility_name:"إسم المنشأة", 
	   capacity:"سعة",
	   enrollment_allowance_period_days:"فترة بدل الالتحاق (أيام)", 
	   maximum_enrollment_duration_days:"مدة الالتحاق القصوى (أيام)", 
	   start_date_of_the_week:"تاريخ بدء الأسبوع", 
	   end_date_of_the_week:"تاريخ نهاية الأسبوع", 
	   lookup_name:"اسم البحث", 
	   duration:"مدة", 
	   time_unit:"وحدة الوقت", 
	   round_up_to_end_of_time_unit:"حول وحدة الوقت إلى نهاية الوقت",
	   product_name:"اسم المنتج",
	   product_ID:"معرف المنتج", 
	   price_offer:"سعر العرض", 
	   price:"سعر", 
	   frequency:"تكرار", 
	   effective_from:"فعالة من", 
	   effective_to:"فعالة ل", 
	   active:"نشيط", 
	   drag_drop_to_text_cursor_in_content:"سحب وإسقاط إلى مؤشر النص في المحتوى", 
	   event_type:"نوع الحدث", 
	   notification_rule:"قاعدة الإخطار", 
	   level_or_ugency:"المستوى أو القغرة", 
	   user_role:"دور المستخدم",
	   edit_security_user_tags:"تحرير علامات مستخدم الأمان",
	   content_access:"الوصول إلى المحتوى", 
	   content_access_for:"وصول المحتوى ل", 
	   add_new_access:"أضف وصول جديد", 
	   date_assigned:"التاريخ المعين",
	   enrollment_request:"التاريخ المعين", 
	   enrollment_request_for:"طلب التسجيل", 
	   mentors:"الموجهين", 
	   options:"خيارات",
	   department_name:"اسم القسم", 
	   universal_department:"قسم عالمي", 
	   open:"يفتح",
	   min_point:"مين بوينت", 
	   max_point:"ماكس بوينت", 
	   grade_point:"تراكمي", 
	   honors:"مرتبة الشرف", 
	   college:"كلية", 
	   order:"طلب", 
	   start_time:"وقت البدء", 
	   end_time:"وقت النهاية",
	   period_name:"اسم الفترة",
	   grading_periods_head:"فترات الدرجات",
	   grading_period:"فترة التقدير", 
	   weight:"وزن", 
	   track_name:"اسم المسار", 
	   academic_track_requirement:"متطلبات المسار الأكاديمي", 
	   of_required_credits:"# من الاعتمادات المطلوبة",
	   individual_learning_plan_template:"قالب خطة التعلم الفردية",
	   ILP_name:"اسم ILP",
		remove_requirement:"إزالة المتطلبات", 
	   reset_requirement:"إعادة تعيين متطلبات", 
	   add_requirement:"أضف المتطلبات",
	   must_end_date:"يجب أن ينتهي تاريخ الانتهاء", 
	   courses_open_date:"دورات مفتوحة", 
	   signup_end_date:"تاريخ نهاية التسجيل", 
	   signup_start_date:"تاريخ بدء التسجيل", 
	   section_period:"فترة القسم",
	   
	   weeks:"أسابيع", 
	   search_for_a_section_or_id:"ابحث عن قسم أو معرف ...",
	   search_for_a_deft:"ابحث عن قسم ...", 
	   launch_course:"دورة الإطلاق", 
	   start_class:"أبدا الدرس", 
	   weekly_progress_goal:"هدف التقدم الأسبوعي", 
	   send_message_to_all_section_students:"أرسل رسالة إلى جميع طلاب القسم", 	   
	   monitor_live_sessions:"مراقبة الجلسات الحية", 	   
	   average_section_grade:"متوسط ​​درجة القسم", 
	   resources:"موارد",	   
	   activities:"أنشطة", 	   
	   course_attendance_today:"حضور الدورة اليوم", 
	   staffs:"الموظفين", 
	   units:"الوحدات", 	   
	   view_all_15_resources:"عرض جميع الموارد الخمسة عشر", 
	   Class_discussions:"مناقشات الفصل", 
	   recent_discussions:"المناقشات الأخيرة", 
	   go_to_class_discussions:"انتقل إلى مناقشات الفصل", 	   
	   show_my_class_attendance:"أظهر حضور الفصل", 
	   add_section:"إضافة قسم",
	   add_global_section:"إضافة قسم عمومي",
	   close_section:"اغلاق الاقسام",
	   open_section:"افتح الأقسام",
	   batch_upload:"تحميل دفعة واحدة",
	   finalize:"وضع اللمسات الأخيرة",	   
	   add_tearcger:"إضافة مدرس (مدرسين)",
	   remove_tearcger:"إزالة المدرس (المدرسين)",
	   uploadSectionStatusUpdates:"تحميل تحديثات حالة القسم",
	   status_count:"عدد الحالة",	   
	   reactivate:"اعادة تفعيل",
	   clone:"استنساخ",
	   enroll_into_Section:"التسجيل في القسم",
	   bulk_enrollment:"التسجيل الجماعي",
	   general_Information:"معلومات عامة",	   
	   online_content_source:"مصدر المحتوى عبر الإنترنت",
	   second_teacher:"المعلم الثاني",	   
	   today:"اليوم",
	   calendar:"تقويم",
	   week:"أسبوع",
	   month:"شهر",
	   section_progress:"تقدم القسم",
	   complete:"مكتمل",	   
	   section_title:"عنوان القسم",
	   enter_section_title:"أدخل عنوان القسم",
	   select_teacher:"حدد المعلم",	   
	   select_weeks:"حدد الأسابيع",	   
	   select_credits:"حدد الاعتمادات",
	   select_type:"اختر صنف",
	   global_section:"القسم العالمي",	   
	   enrollment_capacity:"القدرة على التسجيل",	   
	   enter_enrollment_capacity:"أدخل القدرة على الالتحاق",
	   in_class_information:"في معلومات الفصل",	   
	   Start:"بداية",
	   End:"نهاية",	   
	   recurrencePattern:"نمط التكرار",
	   recurrenceFrequency:"تكرار التكرار",	   
	   Weekly:"أسبوعي",
	   Monthly:"شهريا",
	   Recur_every:"العناية بالكل",
	   Weeks_on:"على مدار أسابيع",
	   day_of_week:"يوم من الأسبوع",
	   daily_period:"الفترة اليومية",
	   select_daily_period:"حدد الفترة اليومية",
	   Day:"يوم",
	   The:"ال",
	   of_every:"كل",
	   month_s:"الشهور)",	   
	   add:"يضيف",	   
	   course_prequisites:"متطلبات الدورة",	   
	   select_status:"حدد الحالة",
	   select_school:"حدد المدارس",	   
	   select_period:"حدد الفترة",	   
	   room_number:"رقم الغرفة",	   
	   select_room_number:"حدد رقم الغرفة",	   
	   Service:"خدمة",
	   enter_url:"إدخال عنوان الموقع",	   
	   edit_section:"تحرير القسم",
	   activity_templates:"قوالب النشاط",	   
	   select_activity_templates:"حدد قالب النشاط",
	   link_section:"قسم الارتباط",
	   select_link_section:"حدد قسم الارتباط",	   
	   please_select_sections:"الرجاء تحديد الأقسام",
	   if_you_change_your_status_of_inactivity:"إذا قمت بتغيير حالة عدم نشاطك ، فسوف يتأثر الطالب.",
	   closing_the_global_section_will_cause:"سيؤدي إغلاق القسم العالمي إلى إغلاق جميع المدارس وسحب جميع الطلاب فيها. الرجاء النقر فوق تأكيد إذا كنت تريد المتابعة.",
	   upload_import_data:"تحميل واستيراد البيانات",
	   here:"هنا",	   	   
	   no_data_avalable_in_table:"لا توجد بيانات متوفرة في الجدول",
	   add_teacher_to_multiple_section:"إضافة المعلم (المعلمين) إلى أقسام متعددة",
	   select_teachers_to_add_to_multiple_section:"حدد المعلمين لإضافتهم إلى تحديدات متعددة",
	   selected:"المحدد",
	   selected_all:"اختر الكل",
	   deselected_all:"الغاء تحديد الكل",
	   remove_teacher_from_multiple_section:"إزالة المعلم (المعلمين) من أقسام متعددة",
	   select_teacher_to_remove_to:"حدد المعلمين لإزالتهم إلى تحديدات متعددة",
	   process_removal:"إزالة العملية",	   
	   clone_section:"قسم الاستنساخ",
	   enroll_student:"تسجيل الطالب",	   
	   enroll_student_to:"تسجيل الطلاب في",	   
	   name:"اسم",	   
	   search_for_a_student_or_id:"البحث عن طالب أو هوية ...",	   
	   confirmation_of_enrollment:"تأكيد التسجيل",	   
	   please_review_and_confirm_enrollments_for:"يرجى مراجعة وتأكيد التسجيل ل",	   
	   confirm:"يتأكد",	   
	   enroll_students_to_section:"إلحاق الطلاب بالقسم",	   
	   enrollment_period:"فترة التسجيل",	   
	   days:"أيام",	   
	   no_data_avalible:"لا تتوافر بيانات.",	   
	   number_of_primary_teacher:"عدد معلمي المرحلة الابتدائية",	   
	   secondary_teachers:"المعلمين الثانوية",	   
	   department_head:"رئيس القسم",	   
	   section_enroll:"تسجيل القسم",	   
	   load_from_file:"تحميل من ملف",
	   see_sections:"انظر الأقسام",
	   change_enrollment_status:"تغيير حالة الالتحاق",
	   mentor_s:"المرشد (ق)",
	   overdue_activities:"الأنشطة المتأخرة",
	   total_session_time_and_last_log:"إجمالي وقت الجلسة والسجل الأخير",
	   course_name_on_transcript:"اسم الدورة على النص",
	   edit_other_grades:"تحرير الدرجات الأخرى",
	   save_as:"حفظ كما",
	   account_receivable_dashboard:"حساب لوحة القيادة القبض",
	   key_performance_indicators:"مؤشرات الأداء الرئيسية",
	   a_r_dashboard:"لوحة القيادة A/R",
	   payments_credits:"المدفوعات /الاعتمادات",
	   contract_templates:"قوالب العقود",
	   master_contracts:"العقود الرئيسية",
	   a_r_configuration:"تكوين A/R",
	   a_r_processing:"معالجة A/R",
	   aging:"شيخوخة",
	   receivable:"القبض",
	   account_receivable_by_program:"الحساب المستحق حسب البرنامج",
	   request_detail:"طلب التفاصيل",
	   request_information:"طلب معلومات",
	   requested_by:"بتوصية من",
	   approved_by:"تمت الموافقة عليه من قبل",
	   approve:"يعتمد",
	   phone_name:"اسم الهاتف",
	   phone_carrier:"حامل الهاتف",
	   area_code:"رمز المنطقة",
	   address_lable:"عنوان lable",
	   address_default:"العنوان الافتراضي",
	   new_photo:"صوره جديده",
	   current_of_wweeks:"رقم الأسابيع الحالي",
	   select_enrollment_period:"حدد فترة الالتحاق",
	   enter_rejection_reason:"أدخل سبب الرفض ...",
	   comments_and_documents:"التعليقات والوثائق",
	   enrollment_history:"تاريخ الالتحاق",
	   request_extension_for:"طلب تمديد ل",
	   extended_of_weeks:"تمتد رقم الأسابيع",
	   current_enrollment_status:"حالة الالتحاق الحالية",
	   select_extension_option:"حدد خيار الامتداد",
	   extend_current_enrollment_until:"تمديد الالتحاق الحالي حتى",
	   transfer_to_new_section:"نقل إلى قسم جديد",
	   transcript_requests:"طلبات النص",
	   person_requesting_transcript:"شخص يطلب النص",
	   telephone_number:"رقم هاتف",
	   number_of_copies:"عدد النسخ",
	   special_instructions:"تعليمات خاصة",
	   last_school_attendance:"آخر حضور المدرسة",
	   year_last_attended:"عام آخر حضر",
	   current_address:"العنوان الحالي",
	   relationship_to_student:"العلاقة مع الطالب",
	   method_of_delivery:"طريقة التوصيل",
	   instructions:"*تعليمات",
	   previous_requests:"الطلبات السابقة",
	   additional_info:"معلومات إضافية",
	   receive:"يستلم",
	   process:"عملية",
	   add_to_school_group:"أضف إلى مجموعة المدرسة",
	   submit_romote:"إرسال الترويج",
	   next_grade_level:"مستوى الصف التالي",
	   please_select_a_school_for_promotion_and_transfer:"يرجى اختيار مدرسة للترقية والتحويل",
	   write_off:"لا تصلح",
	   amount_due:"المبلغ المستحق",
	   open_amount:"مبلغ مفتوح",
	   payment_application:"تطبيق الدفع",
	   use_credit_openBalance:"استخدام الائتمان 111 دولار",
	   payment_amount_usd:"مبلغ الدفع (USD)",
	   check_number:"رقم الشيك",
	   confirmation_number:"رقم التأكيد",
	   apply_payment:"تطبيق الدفع",
	   amount_paid:"المبلغ المدفوع",
	   applied_payment:"الدفع التطبيقي",
	   payer_id:"معرف الدافع",
	   view_detail:"عرض التفاصيل",
	   master_contract:"العقد الرئيسي",
	   copy:"ينسخ",
	   contract_user_detail:"تفاصيل المستخدم العقد",
	   follow_product_cost:"اتبع تكلفة المنتج",
	   default_cost:"التكلفة الافتراضية",
	   offered_cost:"التكلفة المقدمة",
	   contract_detail:"تفاصيل العقد",
	   contract_template_name:"اسم قالب العقد",
	   master_contract_name:"اسم العقد الرئيسي",
	    view_students:"عرض الطلاب",
		make_payment:"قم بالدفع",
		parent_page:"صفحة الوالدين",
		edit_parent:"تحرير الوالد",
		edit_profile:"تعديل الملف الشخصي",
		account_receivable_configuration:"حساب تكوين القبض",
		invoice_generation_date:"تاريخ توليد الفاتورة", 
	   invoice_generation:"جيل الفاتورة", 
	   number_of_days_until_due_date:"عدد الأيام حتى تاريخ الاستحقاق",
	   account_receivable_processing:"حساب المعالجة القبض",
	   generate_invoices:"توليد الفواتير", 
	   process_automatic_payments:"معالجة المدفوعات التلقائية", 
	   send_late_notices:"أرسل الإشعارات المتأخرة", 
	   course:"مسار",  
	   copy_courses:"نسخ الدورات", 
	   copy_to_school:"نسخ إلى المدرسة", 
	   originating_program_code:"رمز البرنامج الناشئ", 
	   destinating_program_code:"رمز البرنامج", 
	   status_error:"الحالة/الخطأ",
	   add_prerequisite:"أضف الشرط المسبق", 
	   group_name:"أسم المجموعة", 
	   enter_group_name:"أدخل اسم المجموعة", 
	   select_a_department_to_display_courses:"حدد قسمًا لعرض الدورات التدريبية", 
	   edit_tranferred_grades:"تحرير الدرجات الأخرى", 
	   showing_num_records:"عرض 000 سجل",
	   edit_all_other_grades:"تحرير جميع الدرجات الأخرى",
	   upload_student_documents:"تحميل مستندات الطالب",
	   select_an_official_transcript_option:"حدد خيار النص الرسمي", 
	   for_schools_or_personal_copy:"للمدارس أو النسخة الشخصية", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"لاستخدام الطالب ، أرسل إلى مدرسة أخرى ، أو للتحقق من التسجيل.", 
	   request_official_transcript:"طلب النص الرسمي", 
	   PARCHMENT_for_colleges_or_universities:"شهادة جامعية للكليات أو الجامعات", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"لتقديم طلب إلى كلية/جامعة والتحقق من الانتهاء من دبلومك.", 
	   request_transcript:"طلب نسخة", 
	   Learn_more_about_how_to_use_PARCHMENT:"تعرف على المزيد حول كيفية استخدام الرق",
	   print_PDF:"طباعة PDF",
	   user_school:"مدرسة المستخدم",
	   filter:"منقي",
	   GENERAL:"عام", 
	   STUDENT_INFO:"معلومات الطالب", 
	   list:"قائمة", 
	   last_school_name:"اسم المدرسة الأخيرة", 
	   TEACHER_INFO:"معلومات المعلم", 
	   contracted_load:"الحمل المتعاقد", 
	   ARENT_INFO:"معلومات الوالدين",
	   add_credential:"إضافة بيانات الاعتماد",
	   edit_credential:"تحرير بيانات الاعتماد",
	   add_comment_document:"أضف التعليق والوثيقة",
	   add_comment_document_for:"إضافة تعليق ووثقة ل",
	    state_province:"الدولة/ المقاطعة", 
	   post_code:"شفرة البريد", 
	   linking_students_to:"ربط الطلاب بـ", 
	   change_expiration_date:"تغيير تاريخ انتهاء الصلاحية", 
	   expiry_date:"تاريخ الانتهاء", 
	   please_select_department:"الرجاء اختيار القسم.", 
	   please_select_course:"الرجاء تحديد الدورة.", 
	   please_select_title:"الرجاء إدخال العنوان.", 
	   please_select_primary_teacher:"الرجاء تحديد المعلم الأساسي.", 
	   please_select_weeks:"الرجاء اختيار الأسابيع.", 
	   please_select_level:"الرجاء تحديد المستوى.", 
	   please_select_credits:"الرجاء تحديد الاعتمادات.", 
	   please_select_type:"الرجاء تحديد النوع.", 
	   please_select_daily_period:"الرجاء اختيار الفترة اليومية.",
	   please_enter_link_section:"الرجاء إدخال قسم الارتباط.",
	   please_enter_first_name:"الرجاء إدخال الاسم الأول.", 
	   please_enter_last_name:"الرجاء إدخال الاسم الأخير.", 
	   please_enter_contracted:"الرجاء إدخال التعاقد.", 
	   please_enter_email:"الرجاء إدخال البريد الإلكتروني.", 
	   please_enter_phone:"الرجاء إدخال الهاتف.", 
	   please_enter_username:"الرجاء إدخال اسم المستخدم.", 
	   please_enter_password:"الرجاء إدخال كلمة المرور.", 
	   please_enter_status:"الرجاء تحديد الحالة.", 
	   save_successful:"تم الحفظ بنجاح!.", 
	   please_add_student_address:"الرجاء إضافة عنوان الطالب.", 
	   please_enter_email_address:"الرجاء إدخال عنوان البريد الإلكتروني.", 
	   please_select_relationship:"الرجاء تحديد العلاقة.", 
	   please_select_parent_status:"الرجاء تحديد حالة الوالدين.", 
	   please_enter_label:"الرجاء إدخال التسمية.", 
	   please_enter_address:"الرجاء إدخال العنوان.", 
	   please_enter_city:"الرجاء إدخال المدينة.", 
	   please_enter_state:"الرجاء إدخال الدولة.", 
	   please_enter_zip_code:"الرجاء إدخال الرمز البريدي.", 
	   please_select_date_of_birth:"الرجاء تحديد تاريخ الميلاد.", 
	   please_select_track:"الرجاء تحديد المسار.", 
	   please_enter_graduation_date:"الرجاء إدخال تاريخ التخرج.", 
	   please_enter_country:"الرجاء إدخال البلد.", 
	   please_enter_phone_number:"الرجاء إدخال رقم الهاتف.", 
	   please_enter_parent_first_name:"الرجاء إدخال الاسم الأول للوالدين.", 
	   please_enter_parent_last_name:"الرجاء إدخال الاسم الأخير للوالدين.", 
	   please_enter_parent_email_address:"الرجاء إدخال عنوان البريد الإلكتروني للوالدين.", 
	   please_enter_parent_username:"الرجاء إدخال اسم مستخدم الوالدين.", 
	   please_select_parent_relationship:"الرجاء تحديد علاقة الوالدين.", 
	   please_enter_phone_label:"الرجاء إدخال تسمية الهاتف.", 
	   student_address_canot_be_empty:"لا يمكن أن يكون عنوان الطالب فارغًا.",
	   please_select_document_type:"الرجاء تحديد نوع المستند.", 
	   please_enter_new_type:"الرجاء إدخال نوع جديد.", 
	   please_enter_comment:"الرجاء إدخال التعليق.", 
	   link_is_not_a_valid_url:"الرابط ليس عنوان URL صالحًا.",
	   please_enter_link_and_label:"الرجاء إدخال الرابط والتسمية.",
	   are_you_sure_to_delete_this_student:"هل أنت متأكد من حذف هذا الطالب.",
	   please_select_gender:"يرجى تحديد الجنس.",
	   school_contracted_load:"الحمل المتعاقد مع المدرسة", 
	   global_contracted_load:"الحمل العالمي المتعاقد عليه", 
	   please_enter_label_for_attachments:"الرجاء إدخال التسمية للمرفقات.",
	    please_select_section:"الرجاء تحديد القسم.", 
	   enrollment_completed_successfully:"الانتهاء من الالتحاق بنجاح.",
	   delete_this_comment:"حذف هذا التعليق؟",
	   please_enter_course_name:"الرجاء إدخال اسم الدورة.", 
	   please_select_credits_possible:"يرجى تحديد الاعتمادات الممكنة.", 
	   can_save_record:"لا يمكن حفظ السجل:",
	   are_you_sure_to_delete_this_tranferred_grade:"هل أنت متأكد من حذف هذا الدرجة المقلقة؟",
	   are_you_sure_to_delete_num_tranferred_grade:"هل أنت متأكد من حذف 11 درجة tranferred؟", 
	   please_select_tranferred_grade:"يرجى تحديد درجة tranferred.",
	   please_ente_subject:"الرجاء إدخال الموضوع.", 
	   please_select_made_to:"الرجاء تحديد صنع إلى.", 
	   delete_this_communication:"حذف هذا الاتصال؟",
	   please_select_school:"الرجاء اختيار المدرسة.",
	   please_enter_name:"الرجاء إدخال الاسم.",
	   please_enter_group_name:"الرجاء إدخال اسم المجموعة.",
	   you_have_some_form_errors_please_check_above:"لديك بعض أخطاء النماذج. يرجى التحقق أعلاه.",
	   please_select_recipient:"الرجاء تحديد المستلم.", 
	   please_enter_description:"الرجاء إدخال الوصف.",
	   delete_this_resource:"حذف هذا المورد؟",
	   please_enter_activity_name:"الرجاء إدخال اسم النشاط.", 
	   please_select_activity_type:"الرجاء تحديد نوع النشاط.", 
	   please_enter_max_score:"الرجاء إدخال النتيجة القصوى.", 
	   please_enter_due_date:"الرجاء إدخال تاريخ الاستحقاق.", 
	   please_enter_unit_name:"الرجاء إدخال اسم الوحدة.",
	   are_you_sure_to_clear_this_unit:"هل أنت متأكد من مسح هذه الوحدة؟",
	   please_enter_score:"الرجاء إدخال النتيجة.",
	   delete_this_credential:"حذف بيانات الاعتماد هذه؟",
	   plase_select_period:"الرجاء تحديد الفترة", 
	   plase_select_start_date:"الرجاء تحديد تاريخ البدء", 
	   plase_select_end_date:"الرجاء تحديد تاريخ الانتهاء", 
	   select_to_register_course_to_students_individual_learning_path_view:"اختر لتسجيل دورة للطلاب عرض مسار التعلم الفردي",
	   delete_this_request:"حذف هذا الطلب؟",
	   please_enter_fname:"الرجاء إدخال الاسم الأول.", 
	   please_enter_lname:"الرجاء إدخال الاسم الأخير.", 
	   please_enter_birthday:"الرجاء الدخول إلى عيد ميلاد.", 
	   please_enter_address:"الرجاء إدخال العنوان.", 
	   please_enter_zip:"الرجاء إدخال Zip.", 
	   please_enter_country:"الرجاء إدخال البلد.", 
	   please_enter_ethnicity:"الرجاء إدخال العرق.", 
	   please_enter_grade:"الرجاء إدخال الصف.", 
	   please_enter_mobile:"الرجاء إدخال الهاتف المحمول.", 
	   please_enter_hear_about_us:"الرجاء إدخال اسمع عنا.", 
	   please_enter_program_of_interest:"الرجاء إدخال برنامج الاهتمام.", 
	   please_enter_course_level:"الرجاء إدخال مستوى الدورة.", 
	   please_enter_guardian_1_name:"الرجاء إدخال اسم الجارديان 1.", 
	   please_enter_guardian_1_email:"الرجاء إدخال البريد الإلكتروني الوصي 1.", 
	   please_enter_guardian_1_home_phone:"الرجاء إدخال Guardian 1 Home Phone.", 
	   please_enter_guardian_1_relation:"الرجاء إدخال علاقة الوصي 1.",
	   please_select_parents:"الرجاء تحديد أولياء الأمور.",
	   transfer_classroom:"نقل الفصل الدراسي", 
	   please_choose_one_section_to_transfer:"الرجاء اختيار قسم واحد للنقل.", 
	   transfer:"تحويل", 
	   assigning_multiple_users_to_a_school_or_school_group:"تعيين مستخدمين متعددين لمجموعة المدرسة أو المدارس", 
	   add_to_school_or_school_group:"أضف إلى المدرسة أو المجموعة المدرسية", 
	   please_select_school_or_school_group:"الرجاء اختيار مجموعة المدرسة أو المدرسة.",
	   print_student_progress_report:"طباعة تقرير تقدم الطالب",
 },
 zh: {
	   reporting_center:"报告中心", 
	   grade_reports:"年级报告", 
	   user_reports:"用户报告", 
	   learning_reports:"学习报告", 
	   administrative_reports:"行政报告", 
	   progress_report:"进度报告", 
	   full_progress_report:"完整进度报告", 
	   grade_report:"等级报告", 
	   roster_report:"名册报告", 
	   parent_report:"父报告", 
	   teacher_report:"教师报告", 
	   student_report:"学生报告", 
	   log_in_report:"登录报告", 
	   enrollmentreport:"注册报告", 
	   enrollment_summary:"注册摘要", 
	   student_enrollment_summary:"学生招生摘要", 
	   attendance_report:"出勤报告", 
	   attendance_summary_report:"出勤摘要报告", 
	   log_In_Credentials:"登录信息", 
	   application_report:"申请报告", 
	   section_report:"部分报告", 
	   course_report:"课程报告", 
	   communication_summary:"沟通摘要", 
	   comments_and_Document_Report:"评论和文件报告", 
	   School_Calendar:"学校日历", 
	   bell_Schedule:"钟表", 
	   student_Contract:"学生合同", 
	   eOS_Report:"EOS报告", 
	   active_Enrollments_Per_Term_Report:"每学期的主动招生", 
	   active_Student_Enrollments_with_As_Report:"有活跃的学生入学率", 
	   active_Student_Enrollments_Report:"活跃的学生入学报告", 
	   all_Students_GPA_Report:"所有学生GPA报告", 
	   old_All_Student_GPA_Report:"旧学生GPA报告", 
	   billingGroup_Engagement_Type_Report:"BillingGroup +参与类型报告", 
	   enrollment_Confirmation_Report:"注册确认报告", 
	   eOS_College_Matriculations_Report:"EOS大学入学报告", 
	   student_Enrollment_History_To_Date_w_Term_Report:"学生招生历史记录到日期w期限报告",
	   student_Information_Report:"学生信息报告", 
	   ran_by:"跑了",
	   Show_Filter:"显示过滤器", 
	   School_Group:"学校小组", 
	   school:"学校", 
	   department:"部门", 
	   student:"学生", 
	   student_status:"学生身份", 
	   course:"课程", 
	   course_level:"课程水平", 
	   section:"部分", 
	   teacher:"老师", 
	   primary_teacher:"小学老师", 
	   secondary_teacher:"中学老师", 
	   completion_Date_Range:"完成日期范围", 
	   from_date:"从日期", 
	   to_date:"迄今为止", 
	   status:"地位", 
	   gender:"性别", 
	   final_grade:"最终成绩", 
	   advisor:"顾问", 
	   grade_level:"年级水平", 
	   specific_mark:"特定标记", 
	   track:"追踪", 
	   ethnicity:"种族", 
	   additional_fields:"其他字段", 
	   school_sessions:"学校会议", 
	   gradebook:"年级", 
	   submit:"提交", 
	   reset:"重置", 
	   show_hide_columns:"显示/隐藏列", 
	   select_all:"全选", 
	   student_id:"学生卡", 
	   last_name:"姓", 
	   first_name:"名", 
	   start_date:"开始日期", 
	   end_date:"结束日期", 
	   grade_final:"成绩决赛", 
	   percent:"百分", 
	   credit:"信用", 
	   download_excel:"下载Excel", 
	   print:"打印", 
	   no_data:"没有数据。", 
	   view:"看法", 
	   showing:"展示", 
	   of:"的", 
	   other_grade:"其他年级", 
	   level:"等级", 
	   date:"日期", 
	   grade:"年级",
	   enrollment_Change_Status:"入学变更状态", 
	   close:"关闭", 
	   select_Enrollment_Status:"选择注册状态", 
	   select:"选择...", 
	   cancel:"取消", 
	   save:"节省", 
	   students:"学生", 
	   Course_Status:"课程状态", 
	   Closed_courses:"封闭的课程", 
	   Section_Status:"部分状态", 
	   Closed_sections:"封闭部分", 
	   Transferred_From:"从",
	   Graduation_From_Date:"从日期开始毕业", 
	   Graduation_To_Date:"迄今为止的毕业", 
	   Enrollment_From_Date:"从日期起入学", 
	   Enrollment_To_Date:"迄今为止的注册", 
	   Enrollment_Status:"入学状态", 
	   Transfer_From_Date:"从日期开始转移", 
	   Transfer_To_Date:"转移到日期", 
	   Custom_Query:"自定义查询", 
	   Last_Access_Date:"最后访问日期", 
	   Total_Session_Time:"总会话时间", 
	   Quality_of_Work:"工作质量", 
	   Grade_to_Date:"迄今为止的等级", 
	   Overall_Percent:"总体百分比", 
	   On_Schedule_Percent:"按计划百分比", 
	   Activity_Count_Complete:"活动数量完成", 
	   Activity_Count_Total:"活动数量总数", 
	   Overdue_Activitie:"逾期活动",
	   Section_Course_Additional_Fields:"部分/课程其他字段", 
	   Create_On_Date:"创建日期", 
	   Last_Status_Update_Date:"最后状态更新日期", 
	   Transferred_In:"转入", 
	   Transferred_In_Date:"转移日期", 
	   email:"电子邮件", 
	   birth_date:"出生日期", 
	   course_name:"课程名", 
	   section_name:"部分名称", 
	   school_name:"学校名称", 
	   Graduation_Date:"毕业日期", 
	   Created_on:"创建于", 
	   mentor_Advisor:"导师/顾问",
	   sections:"部分", 
	   roster:"名册", 
	   relationship:"关系", 
	   Email_or_Phone:"邮件或者电话", 
	   Enter_any_text:"输入任何文本", 
	   Advisor_Success_Manager:"顾问 /成功经理", 
	   User_Id:"用户身份", 
	   phone_number:"电话号码", 
	   Student_Last_Name:"学生姓", 
	   Student_First_Name:"学生名字", 
	   Student_Email:"学生电子邮件", 
	   credentials:"证书", 
	   availability:"可用性",
	   enrollments:"注册", 
	   Datea_Created_on:"创建的日期",
	   country:"国家", 
	   state:"状态", 
	   zipcode:"邮政编码", 
	   Enter_any_zipcode:"输入任何邮政编码", 
	   address:"地址",
	   zip_Code:"邮政编码",
	   Login_Report:"登录报告", 
	   user_Type:"用户类型", 
	   user_Name:"用户名", 
	   Show_last_log_in_only:"仅显示最后登录", 
	   Username:"用户名", 
	   Date_Time:"约会时间", 
	   Ip_Address:"IP地址", 
	   city:"城市",
	   Enrollment_Start_Date:"入学开始日期", 
	   Enrollment_End_Date:"注册结束日期", 
	   Completion_Date:"完成日期", 
	   section_Type:"部分类型", 
	   student_Enrolled:"学生注册", 
	   content_Provider:"内容提供商", 
	   student_Additional_Fields:"学生其他领域",
	   type:"类型", 
	   in_Class_Information:"在课堂信息中", 
	   Enrollment_Summary_Report:"注册摘要报告", 
	   Transferred_From_School:"从学校转移",
	   Total_Enrollments:"总入学人数", 
	   content_Type:"内容类型", 
	   active_Course_Progress:"积极的课程进步", 
	   Grades:"等级", 
	   attendance:"出勤",
	   student_Absences:"学生缺席", 
	   total_Absence:"完全缺席", 
	   section_Absences:"部分缺席",
	   Grade_Level_Absences:"年级缺席",
	   Gender_Absences:"性别缺席",
	   Login_credentials:"登录信息", 
	   names:"名称", 
	   user_status_admin_teacher_parent:"用户状态（管理员，老师，父母）", 
	   show_title:"表演标题", 
	   midle_name:"中间名字", 
	   password:"密码", 
	   parent_name:"父母名字", 
	   linked_to_parent:"链接到父母", 
	   linked_to_student:"链接到学生",
	   login_credentials_Report:"登录凭据报告", 
	   app_id:"应用ID", 
	   created:"创建", 
	   modified:"修改的",
	   select_level:"选择级别", 
	   select_additional_fields:"节其他字段", 
	   title:"标题", 
	   credits:"学分", 
	   section_ID:"章节ID", 
	   content:"内容", 
	   course_additional_fields:"课程其他字段",
	   course_id:"课程ID", 
	   communication_summary_report:"沟通摘要报告", 
	   method:"方法", 
	   create_date:"创建日期", 
	   subject:"主题", 
	   make_from_id:"从ID制作", 
	   make_to:"做", 
	   attachments:"附件", 
	   comment_and_document_summary_report:"评论和文件摘要报告", 
	   comment_type:"评论类型", 
	   flagged:"标记", 
	   sharing_target:"共享目标", 
	   show_on_transcript:"在成绩单上显示", 
	   by:"经过", 
	   comment:"评论", 
	   type_name:"类型名称", 
	   effective_from_date:"从日期起生效", 
	   effective_to_date:"迄今为止有效", 
	   count_docs:"计数文档",
	   school_calendar_report:"学校日历报告", 
	   event_Id:"事件ID", 
	   date_start:"日期开始", 
	   date_end:"日期结束", 
	   posted_last_name:"发布姓氏", 
	   posted_first_name:"发布名字",
	   bell_schedule_report:"贝尔时间表报告", 
	   period:"时期", 
	   start:"开始", 
	   end:"结尾",
	   student_contract_report:"学生合同报告", 
	   begin_date:"开始日期", 
	   contracts:"合同", 
	   contract_name:"合同名称", 
	   contract_begin_date:"合同开始日期", 
	   contract_end_date:"合同结束日期",
	   active_enrollments_per_term_report:"每学期的主动招生", 
	   entry_date:"输入日期", 
	   teachers:"教师", 
	   term:"学期", 
	   sections:"部分",
	   showing_of:"显示20个中的10个",
	   filter:"筛选",
	   students:"学生",
	   school:"学校",
	   all_school:"所有学校",
	   student:"学生",
	   email:"电子邮件",
	   grade_level:"年级",
	   status:"地位",
	   seach_for_a_student_or_id:"搜索学生或 ID ...",
	   search:"搜索 …",
	   message_student:"消息学生",
	   request_enrollment:"申请注册",
	   print_schedule:"打印时间表",
	   view:"看法",
	   no_data:"没有数据。",
	   views:"意见", 
	   enrollment:"注册", 
	   schedule:"日程", 
	   transferred_grades:"转学分", 
	   comments_ocuments:"评论和文件", 
	   academic_records:"学术记录", 
	   compliance_log:"合规日志", 
	   unofficial_transcript:"非官方成绩单", 
	   iD_card:"身份证", 
	   student_number_id_information:"学生编号 #29561 信息", 
	   student_number:"学生号码", 
	   gender:"性别", 
	   goes_by:"路过", 
	   date_of_birth:"出生日期", 
	   ethnicity:"种族", 
	   mobile:"移动的", 
	   academic_track:"学术轨道", 
	   learning_path_template:"学习路径模板", 
	   graduation_date:"毕业日期", 
	   comments:"注释", 
	   transfer_information:"传输信息", 
	   enrollment_date:"注册日期", 
	   transfer_date:"转让日期", 
	   transfer_student:"转学学生", 
	   parent_mentor_contact:"家长/导师联系方式", 
	   mentor:"导师", 
	   parent_phone:"家长电话", 
	   emergency_contact:"紧急联系人", 
	   academic_advisor_ssm:"学术顾问/ SSM", 
	   student_success_manager:"学生成功经理", 
	   academic_avisor:"学术顾问", 
	   address:"地址", 
	   address_01_Default:"地址 01（默认）", 
	   street:"街道", 
	   city:"城市", 
	   state:"状态", 
	   zip:"压缩", 
	   hide_Detailed_information:"隐藏详细信息", 	    
	   current_course_progress:"当前课程进度", 	    
	   full_Path_Progress:"全路径进度", 	    
	   print:"打印", 	    
	   avg_graduation_progress:"平均毕业进度", 	    
	   GPA:"平均绩点", 	    
	   graduation_Status:"毕业状态", 	    
	   on_track:"在轨道上", 
	   show_detailed_information:"显示详细信息",
		communication:"沟通",
		student_advisors:"学生顾问", 	    
	   country:"国家", 	    
	   grade:"年级", 	    
	   credits:"学分", 	    
	   sort:"种类", 	    
	   course_progress:"课程进度",
	   overall_GPA:"总GPA",
	    current_graduation_progress:"当前的毕业进度",
		individual_course_progress:"*个别课程进度会有所不同，这是您的整体进度", 
		subject:"主题",
		online_sections:"在线部分",
	   course:"课程", 
	   section:"部分", 
	   actions:"动作", 
	   view_event:"查看事件",
	   in_class_section:"在班级部分",
	   calendar:"日历",
	   access_link:"访问链接", 
	   online_link:"在线链接",
	   launch_course:"发射课程", 
	   start_class:"开始课程",
	   level:"等级", 
	   date:"日期", 
	   transferred_in:"转入",
	   tranferred_grades:"转移成绩",
	   Searchs:"搜索", 
	   Search_department_course:"搜索部门课程，src...",
	   archived:"存档", 
	   add_comment:"添加评论", 
	   created_date:"创建日期", 
	   by:"经过", 
	   type:"类型", 
	   comment:"评论", 
	   from_date:"从日期", 
	   to_date:"迄今为止", 
	   documents:"文件", 
	   edit:"编辑", 
	   delete:"删除", 
	   communications:"通讯", 
	   add_communications:"添加通讯", 
	   made_from:"由", 
	   made_to:"用作", 
	   means:"方法", 
	   attachments:"附件", 
	   content:"内容",
	   compliance_logs:"合规日志", 
	   messageID:"消息标识", 
	   agree:"同意", 
	   dateTime:"约会时间", 
	   iPAddress:"IP地址", 
	   add_idit_comment_document:"添加/编辑评论和文档", 
	   document_type:"文档类型", 
	   show_on_transcript:"在成绩单上显示", 
	   select_users_to:"选择用户", 
	   teacher:"老师", 
	   parent:"家长", 
	   flag:"旗帜", 
	   none:"没有任何", 
	   link:"关联", 
	   label:"标签", 
	   add_more_link:"添加更多链接", 
	   save:"节省", 
	   add_edit_communication:"添加/编辑通讯", 
	   made_by:"由制成", 
	   date_time:"约会时间", 
	   length:"长度", 
	   select:"选择", 
	   select_users_to_view:"选择用户以查看通信", 
	   add_more:"添加更多", 
	   communication_summary:"通讯摘要",
	   close:"关",
	   new_type:"新型",
	   select_user_to_view_comment:"选择用户查看评论",
	   flag_comment:"标记评论",
	   teacher_page:"教师页",
	   edit_information:"编辑资料",
	   phone:"电话",
	   add_credential:"添加凭据",
	   add_edit_credential:"添加/编辑凭证",
	   first_name:"名",
	   midle_name:"中间名字",
	   last_name:"姓",
	   cancel:"取消",
	   add_new:"新",
	   phone_type:"电话类型",
	   zipCode:"邮政编码",
	   phone_number:"电话号码",
	   default:"默认",
	   please_select_country:"请选择国家",
	   student_information:"学生信息",
	   username:"用户名",
	   user_directory:"用户目录",
	   add_teacher:"添加老师",
	   add_admin:"添加管理员",
	   export_to_excel:"导出到 Excel",
	   export_to_pdf:"导出为 PDF",
	   send_login_credentials:"发送登录凭证",
	   search_for_a_user_or_id:"搜索用户或 ID …",
	   user:"用户",
	   school_admin:"学校管理员",
	   change_password:"更改密码",
	   set_password_expiration_date:"设置密码到期日期",
	   impersonate_user:"冒充用户",
	   edit_user_tags:"编辑用户标签",
	   add_or_edit_users_schoo_assign:"添加或编辑用户学校分配",
	   assign_content_access:"分配内容访问权限",
	   add_student:"添加学生",
	   add_parent_mentor:"添加家长/导师",
	   showing:"显示",
	   of:"的",
	   school_name:"学校名称",
	   edit_user_school_tags:"编辑用户学校标签",
	   personal_information:"个人信息",
	   contacted_load:"接触负载",
	   maximum_of_active_students:"活动学生的最大数量",
	   teacher_since:"老师以来",
	   login_infomation:"登录信息",
	   username:"用户名",
	   password :"密码",
	   avatar :"阿凡达",
	   teachers :"教师",
	   change_status :"改变状态",
	   add_admin:"添加管理员",
	   name:"名称",
	   create_on:"创建于",
	   registrar:"登记员",
	   birthday:"生日",
	   signature:"签名",
	   photo:"照片",
	   designated_registrar:"指定注册商",
	   track:"追踪",
	   select_existing_track:"选择现有轨道",
	   available:"可用的",
	   parent_mentor:"家长/导师",
	   relationship:"关系",
	   email_address:"电子邮件地址",
	   academic_mentor:"学术导师",
	   no_data_available_in_table:"表中无可用数据",
	   primary_language:"主要语言",
	   add_into_parent_or_mentor:"添加到家长/导师",
	   add_into_phone:"添加到手机",
	   add_into_address:"添加到地址",
	   select_one:"选择一个",
	   login:"登录",
	   plese_select_country:"请选择国家",
	   edit_student:"编辑学生",
	   academic_advisor_or_student_success_manager:"学术顾问/学生成功经理",
	   role:"角色",
	   link_parent:"链接父级",
	   link_advisor_sms:"链接顾问/SSM",
	   save_into_parent_mentor:"保存到父母/导师",
	   save_into_parent_phone:"保存到手机",
	   save_into_parent_address:"保存到地址",
	   bulk_information_update:"批量信息更新",
	   enrollments:"招生",
	   email_student:"电子邮件学生",
	   unofficial_transcripts:"非官方成绩单",
	   official_transcripts:"官方成绩单",
	   email_students_schedule:"电子邮件学生的时间表",
	   export_students_to_excel:"将学生导出到 Excel",
	   export_parent_list_to_excel:"将父列表导出到 Excel",
	   assign_learning_path_template:"分配学习路径模板",
	   promote_student_to_the_next_grade_level:"将学生提升到下一个年级",
	   batch_upload_students:"批量上传学生",
	   batch_upload_transfer_grades:"批量上传传输成绩",
	   transfer_apex_only:"转移（仅限 APEX）",
	   transfer_content_providers:"转移（所有内容提供商）",
	   batch_enrollments:"批量注册",
	   send_message:"发信息",
	   impersonate:"冒充",
	   change_login_credentials:"更改登录凭据",
	   request_enrollment:"请求注册",
	   send_weekly_status_report:"发送每周状态报告",
	   please_select_student:"请选择学生.",
	   student_status_will_be_changed_to_status_withdraw:"学生身份将更改为111，所有入学率都将被撤回。你确定你要继续吗？",
	   student_status_will_be_changed_to_status:"学生身份将更改为111。您确定要继续吗？",
	   value:"价值",
	   student_success_manager_or_acdemic:"学生成功经理 /学术顾问",
	   enroll_students_to_section:"注册学生",
	   department:"部门",
	   refresh:"刷新",
	   select_department:"请选择部门",
	   select_course:"选择课程",
	   select_section:"选择部分",
	   start_date:"开始日期",
	   end_date:"结束日期",
	   ID:"ID",
	   action:"行动",
	   enrollment_period:"入学期",
	   select_a_course_to_register_ilp:"选择一门注册ILP的课程",
	   period:"时期",
	   credit:"信用",
	   year:"年",
	   enroll:"注册",
	   recipient_transcript:"收件人成绩单",
	   select_all_or_unselect_all:"选择全部 /取消选择全部",
	   include_in_progress_sections:"包括在进行部分",
	   show_satisfaction_of_program:"表现出对计划的满意",
	   show_total_credit:"显示总学分",
	   show_student_info:"显示学生信息",
	   show_academic_info:"显示学术信息",
	   show_school_names_from_orther_grades:"展示其他等级的学校名字",
	   show_school_contact:"展示学校联系",
	   include_transferred_grades_in_gpa:"包括在GPA中转移的成绩",
	   include_in_progress_grade:"包括进度等级",
	   include_grade_scales:"包括等级量表",
	   show_graduation_date:"展示毕业日期",
	   show_weighted_gpa:"显示加权GPA",
	   show_grade_level_gpa:"显示年级GPA",
	   show_comletion_date:"展示完成日期",
	   show_withdraw_classes:"显示撤回的课程",
	   show_withdraw_date:"显示撤回日期",
	   show_transfered_in_classes:"表演在课堂上转移",
	   show_digital_seal:"显示数字密封",
	   show_singnature:"显示签名",
	   group_by:"通过...分组",
	   school_year:"学年",
	   school_level:"学校级别",
	   notes:"笔记",
	   ok:"行",
	   are_you_sure_to_send:"您一定会发送吗？",
	   assign_learning_path_templete:"分配学习路径模板",
	   assign_student_to_selected_learning:"分配学生为选定的学习路径模板",
	   assign:"分配",
	   are_you_sure_to_promote_to_level:"您一定会提升到下一个年级吗？",
	   data_process:"数据过程",
	   upload_and_import_data:"上传和导入数据",
	   download_user_information:"下载用户信息",
	   here:"这里",
	   select_student_upload_file:"选择学生上传文件",
	   local_drive:"本地驱动器",
	   the_file_is_uploaded:"该文件已上传",
	   template_name:"模板名称",
	   Here:"这里",
	   sample_file_excel:"示例文件Excel。",
	   file_type:"文件类型",
	   delimited:"划界",
	   delimited_chars:"划界字符",
	   fixed_width:"固定宽度",
	   first_line_header:"第一线标题",
	   loader_field:"负载字段",
	   Header:"标题",
	   sample_data:"样本数据",
	   column_width:"Colunm宽度",
	   save_tamplate:"保存模板",
	   save_and_upload_data:"保存和上传数据",
	   result:"结果",
	   upload_and_import_data_orther_grade:"上传和导入数据其他等级",
	   select_upload_file:"选择上传文件",
	   student_id:"学生卡",
	   uploadAnd_import_data_enrollment:"上传和导入数据注册",
	   section_id:"章节ID",
	   title:"标题",
	   recipient:"接受者",
	   same_current_address:"与当前地址相同",
	   add_more_reciptient:"添加更多收件人",
	   issuse_date:"签发日期",
	   show_total_unapplied_credits:"显示总未应用的积分",
	   reconcile_another_student_record:"与另一个学生记录和解",
	   please_choose_one_student_to_reconcile:"请选择一个学生和解。",
	   yes:"是的",
	   no:"不",
	   apex_classroom_sync:"Apex教室同步",
	   next:"下一个",
	   apex_classrooms:"Apex教室",
	   online_user_id:"在线用户ID",
	   enter_online_user_id:"输入在线用户ID",
	   online_section_id:"在线部分ID",
	   online_section_name:"在线部分名称",
	   online_course_name:"在线课程名称",
	   enrollment_date:"开学报道日",
	   back:"后退",
	   import:"进口",
	   offical_transcipt:"官方记录",
	   email_schedule:"电子邮件时间表",
	   reconcile_with_another_records:"与另一个记录调和",
	   online_sync_and_update:"在线进度同步和更新",
	   download_all_completion_cretification:"下载所有完成认证",
	   orther_grade:"其他等级",
	   medical:"医疗的",
	   comments_and_documents:"评论和文件",
	   contracts:"合同",
	   invoices:"发票",
	   audit_logs:"审核日志",
	   edit_logs:"编辑日志",
	   grade_to_date:"迄今为止的等级",
	   quality_of_work:"工作质量",
	   last_access:"最后访问",
	   gradebook:"年级",
	   transfer:"转移",
	   completion_certification:"完成认证",
	   tranfer_user_school:"转移用户学校",
	   tranfer_to_school:"转移到学校",
	   tranfer_apex_classrooms:"转移顶点教室",
	   course_to_moved:"当然要移动",
	   current_teacher:"现任老师",
	   future_section:"未来部分",
	   future_program:"未来计划",
	   future_teacher:"未来的老师",
	   enrollment_start_date_end_date:"入学开始日期 - 结束日期",
	   no_more_option:"没有更多选择",
	   create_new:"创建新的",
	   transfer_classrooms:"转移教室",
	   tyler_synchronization_for_az_school:"亚利桑那州学校的泰勒同步",
	   synchronize:"同步",
	   individual_course_progress_varies:"个人课程进展各不相同。这是您毕业的总体进步。",
	   edit_ilp:"编辑ILP",
	   add_academic_record:"添加学术记录",
	   edit_all_records:"编辑所有记录",
	   search_corse_department_src:"搜索课程，部门，SRC…",
	   message_id:"消息ID",
	   add_new_contract:"添加新合同",
	   contract_id:"合同ID",
	   contract_name:"合同名称",
	   first_date:"第一次约会",
	   last_date:"最后日期",
	   amount_per_period:"每个时期的金额",
	   terminating_status:"终止状态",
	   payment_history:"支付历史",
	   record_payment:"记录付款",
	   payment_method:"付款方式",
	   invoice_id:"发票ID",
	   show_all:"显示所有",
	   invoice_date:"发票日期",
	   from:"从…",
	   to:"到…",
	   amount:"数量",
	   paid:"有薪酬的",
	   due:"到期的",
	   date_paid:"已付日期",
	   apply_payments:"申请付款",
	   mark_as_paid:"标记为付费",
	   void:"空白",
	   audit_log:"审核日志",
	   object:"目的",
	   changes_made:"做出的更改",
	   create_time:"创建时间",
	   time_stamp:"时间戳记",
	   user_creare:"用户创建",
	   edit_log:"编辑日志",
	   field_name:"字段名称",
	   old_value:"旧价值",
	   new_value:"新价值",
	   date_time_update:"日期/时间更新",
	   updater:"更新者",
	   add_edit_academic_records:"添加/编辑学术记录",
	   select_flag:"选择标志...",
	   edit_all_tranferred_grades:"编辑所有转换等级",
	   save_records:"保存记录",
	   possible_credits:"可能的积分",
	   select_level:"选择级别",
	   select_grade_level:"选择年级水平",
	   select_status:"选择状态",
	   add_more_row:"添加更多行",
	   full_screen:"全屏",
	   course_code:"添加其他等级",
	   add_order_grades:"科目编号",
	   select_credit:"选择信用",
	   select_default:"选择默认值",
	   credits_possible:"学分可能",
	   select_possible_credit:"选择可能的信用",
	   product:"产品",
	   fromn:"从",
	   ton:"到",
	   last_invoice_date:"最后发票日期",
	   please_select_stu:"请选择学生",
	   payer:"付款人",
	   amount_per_billing_period:"每个计费期的金额",
	   price_unit:"价格单位",
	   billing_period:"结算期",
	   automatic_renewal:"自动续订",
	   automatic_payment:"自动计费",
	   duration_of_period:"持续时间（时期＃）",
	   payment_id:"付款ID",
	   payment_date:"付款日期",
	   payment_amount:"支付金额",
	   applied:"应用",
	   available:"可用的",
	   unApply:"不使用",
	   refund:"退款",
	   add_new_teacher:"加入新老师",
	   change_teacher_status:"改变教师身份",
	   search_for_a_teacher_or_id:"搜索老师或ID…",
	   flags:"标志",
	   tags:"标签",
	   allowed:"允许",
	   message_teacher:"消息老师",
	   impersonate_teacher:"模仿老师",
	   add_teacher_qualification:"添加教师资格",
	   profile:"轮廓",
	   teacher_schedule:"教师时间表",
	   qualifications:"资格",
	   student_actions:"学生行动",
	   linking_parents_to:"将父母联系到",
	   select_do:"选择 ...",	   
	   see_edit_logs:"请参阅编辑日志",	   
	   see_qualifications:"参见资格",
	   link_academic_advisor:"链接学术顾问",
	   student_success:"学生的成功",
	   linking_academic_advisor_or_student_success:"将学术顾问 /学生的成功链接到",
	   staff:"职员",
	   teacher_status:"老师身份",
	   school_admin_status:"学校管理员身份",
	   global_user_directory:"全局用户目录",
	   edit_teacher:"编辑老师",
	   contracted:"签约",
	   add_comments_and_documents:"评论和文件",
	   edit_comments_and_documents:"编辑评论和文件",
	   parents_or_mentor:"父母 /导师",
	   send_mail:"发送邮件",
	   are_you_sure_to_delete_this_teacher:"您一定会删除这个老师吗？",
	   edit_user_password:"编辑用户名和密码",
	   add_qualifications:"添加资格",
	   please_select_a_least_on_teacher:"请选择至少一位老师。",
	   edit_parent_mentor:"编辑父母 /导师",
	   parent_mentor_information:"家长 /导师信息",
	   send:"发送",
	   are_you_surse_to_delete_this_parent:"您一定要删除这个父母吗？",
	   home:"家",
	  // auto_promotion:"自动促销",
	   auto_promotion:"学生等级晋升",
	   Promote:"推动",
	   search_for_a_name:"搜索名称…",
	   download_to_excel:"下载到Excel",
	   download_to_pdf:"下载到PDF",
	   User_ID:"用户身份",
	   User_type:"用户类型",
	   communication_log:"通信日志",
	   Student_Status:"学生身份",
	   Users:"用户",
	   Staff_Reassignment:"员工重新分配",
	   Select_Staff:"选择员工",
	   select_asset_type_to_reassign:"选择资产类型重新分配",
	   transfer_all_to:"将全部转移到",
	   transfer_selectively:"选择性转移",
	   remove_all:"移除所有",
	   remove_selectively:"选择性删除",
	   Event:"事件",
	   Time:"时间",
	   Participants:"参与者",
	   new_staff:"新员工",
	   Remove:"消除",
	   Profile_Page:"个人资料页",
	   settings:"设置",
	   security:"安全",
	   timezone:"时区",
	   notifications:"通知",
	   check_for_feature_availability_at_your_school:"检查学校的功能可用性。",
	   current_password:"当前密码",
	   new_password:"新密码",
	   confirm_password:"确认密码",
	   updte_password:"更新密码",
	   change_timezone:"更改时区",
	   time_zone:"时区",
	   please_select_time_zone:"请选择时区",
	   notification_settings:"通知设置",
	   level_of_urgency:"紧迫水平",
	   email_destination:"电子邮件目的地",
	   SMS_Destination:"SMS目的地",
	   app:"应用程序",
	   please_select_level_of_urgency:"请选择紧迫水平",	  
	   reset_filters:"重置过滤器",
	   batch_data_update:"学生数据更新",
	   contract_template:"合同模板",
	   accept:"接受",
	   reject:"拒绝",
	   view_roles:"查看角色",
	   administrator_information:"管理员信息", 
	   account_reation_date:"帐户创建日期", 
	   expiration_date:"截止日期", 
	   schools:"学校", 
	   advisees:"建议",
	   message:"信息",
	   see_comments_and_documents:"请参阅评论和文件",
	   restore_APEX_Classrooms:"还原顶点教室",
	   teacher_information:"教师信息", 
	   teacher_number:"老师编号", 
	   departmens:"部门", 
	   global_capacity:"全球能力", 
	   local_contracted_load:"本地收缩负载", 
	   parents:"父母", 
	   parent_information:"家长信息", 
	   linked_students:"链接的学生", 
	   link_student:"链接学生", 
	   unlink_student:"Unlink学生", 
	   search_dot:"搜索…", 
	   view_local:"查看本地", 
	   view_global:"查看全球",
	   resource:"资源",
	   current_grade:"当前的等级", 
	   affiliation:"联系", 
	   current_assignment:"当前任务", 
	   total_assignments:"总分配", 
	   percent_completed:"百分比完成了",
	   semester:"学期",
	   graduation_year:"毕业年", 
	   student_name:"获得的积分", 
	   credits_earned:"获得的积分",
	   exit:"出口",
	   engagement_type:"参与类型",
	   college_admitted:"大学承认", 
	   college_attending:"大学参加", 
	   major:"主要的", 
	   report_card:"报告卡", 
	   academic_term:"学术术语", 
	   show_average:"显示平均值", 
	   school_information:"学校信息", 
	   school_misc_configuration:"学校杂项配置", 
	   school_tags:"学校标签", 
	   role_tags:"角色标签", 
	   content_integration:"内容集成", 
	   user_roles:"用户角色", 
	   communication_user_rules:"通信用户规则", 
	   school_administrators:"学校管理员", 
	   school_year_configuration:"学年配置", 
	   A_R_payment_configuration:"A/R付款配置", 
	   facility:"设施", 
	   enrollment_rules:"入学规则", 
	   student_contract_rules:"学生合同规则", 
	   products:"产品", 
	   notification_templates:"通知模板", 
	   transcript_viewer_options:"成绩单查看器选项", 
	   feature_configuration:"功能配置", 
	   feature_settings:"功能设置", 
	   communication_rules:"沟通规则", 
	   object_state:"对象状态", 
	   departments:"部门", 
	   grading_scales:"评分量表", 
	   grading_periods:"评分期", 
	   academic_tracks:"学术轨道", 
	   learning_path_templates:"学习路径模板", 
	   grade_book_activity_descriptions:"年级活动描述", 
	   academic_terms:"学术术语",
	   academic_system:"学术系统",
	   address_line_1:"地址第一行", 
	   country_code:"国家代码", 
	   address_line_2:"地址第2行", 
	   school_title:"学校头衔",
	   CEEB_code:"CEEB代码", 
	   zip_postal_code:"邮编/邮政编码", 
	   state_province:"州/省", 
	   website:"网站", 
	   subdomain:"子域", 
	   success_manager:"成功经理", 
	   school_logo:"学校徽标", 
	   digital_seal:"数字密封",
	   password_exception_rule:"密码异常规则",
	   change_password_first_login:"更改密码首先登录", 
	   password_expires_after_days:"密码几天后到期", 
	   enforcement_of_teachers_load:"执行教师的负担", 
	   in_house_handling_of_transcript_requests:"在房屋处理笔录请求中", 
	   display_mobile_app_link:"显示移动应用链接", 
	   display_weekly_progress_goal:"显示每周进度目标", 
	   turn_on_notification:"打开通知", 
	   classic_letter:"经典信", 
	   automatic_parent_account_creation:"自动父母帐户创建", 
	   default_parent_account_status:"默认父级帐户状态", 
	   default_time_zone:"默认时区", 
	   link_to_transcript_vendor_help:"链接到成绩单供应商帮助", 
	   link_to_transcript_vendor:"链接到成绩单供应商", 
	   link_for_help_system:"帮助系统链接", 
	   student_enrollment_limit:"学生入学率限制", 
	   default_section_type:"默认部分类型", 
	   default_section_capacity:"默认部分容量",
	   transcript_template:"成绩单模板",
	   edit_security_school_tags:"编辑安全学校标签", 
	   security_school_tags:"安全学校标签",
	   tags_name:"标签名称", 
	   edit_role_tags:"编辑角色标签",
	   add_school_based_tags:"添加基于学校的标签", 
	   description:"描述", 
	   applied_to_roles:"应用于角色", 
	   teacher:"老师",
	   edit_security_role_tags_for:"编辑安全角色标签",
	   school_admins:"学校管理员",
	   school_begin_date:"学校开始日期", 
	   school_end_date:"学校结束日期", 
	   automatic_control_of_teacher_s_load:"自动控制教师的负担",
	   A_R_payment_gateway_configuration:"A/R支付网关配置", 
	   payment_processing_vendor:"付款处理供应商", 
	   secret_key:"密钥", 
	   publishable_key:"可发布的密钥", 
	   account_id:"帐户ID",
	   updating_tudents:"更新学生", 
	   delete_selected_records:"删除选定的记录",
	   attribute_name:"属性名称", 
	   applied_for:"应用于",
	   add_school:"加入学校", 
	   overview:"概述", 
	   search_for_school:"搜索学校…", 
	   search_for_student:"搜索学生…",
	   attribute_type:"属性类型", 
	   select_school_group:"选择学校小组", 
	   access_rights:"访问权", 
	   create:"创造", 
	   read:"读",
	   facility_management:"设施管理", 
	   facility_name:"设备名称", 
	   capacity:"容量",
	   enrollment_allowance_period_days:"入学津贴期（天数）", 
	   maximum_enrollment_duration_days:"最大入学持续时间（天）", 
	   start_date_of_the_week:"一周的开始日期", 
	   end_date_of_the_week:"一周结束日期",
	   lookup_name:"查找名称", 
	   duration:"期间", 
	   time_unit:"时间单元", 
	   round_up_to_end_of_time_unit:"围绕时间到末期单元",
	   product_name:"产品名称",
	   product_ID:"产品ID", 
	   price_offer:"价格优惠", 
	   price:"价格", 
	   frequency:"频率", 
	   effective_from:"从", 
	   effective_to:"有效", 
	   active:"积极的",
	   drag_drop_to_text_cursor_in_content:"将内容拖放到文本光标中", 
	   event_type:"事件类型", 
	   notification_rule:"通知规则", 
	   level_or_ugency:"水平或丑陋", 
	   user_role:"用户角色",
	   edit_security_user_tags:"编辑安全用户标签",
	   content_access:"内容访问", 
	   content_access_for:"内容访问", 
	   add_new_access:"添加新访问", 
	   date_assigned:"分配的日期",
	   enrollment_request:"分配的日期", 
	   enrollment_request_for:"注册请求", 
	   mentors:"导师",
	   options:"选项",
	   department_name:"部门名称", 
	   universal_department:"世界部门", 
	   open:"打开",
	   min_point:"最小点", 
	   max_point:"最大点", 
	   grade_point:"等级", 
	   honors:"荣誉", 
	   college:"大学",
	   order:"命令", 
	   start_time:"开始时间", 
	   end_time:"时间结束",
	   period_name:"周期名称",
	   grading_periods_head:"评分期负责人",
	   grading_period:"评分期", 
	   weight:"重量",
	   track_name:"曲目名称",
	   academic_track_requirement:"学术轨道要求", 
	   of_required_credits:"所需学分的＃",
	   individual_learning_plan_template:"个人学习计划模板",
	   ILP_name:"ILP名称",
	   remove_requirement:"删除要求", 
	   reset_requirement:"重置要求", 
	   add_requirement:"添加要求",
	   must_end_date:"必须结束日期", 
	   courses_open_date:"课程开放日期", 
	   signup_end_date:"注册结束日期", 
	   signup_start_date:"注册开始日期", 
	   section_period:"部分期",
	   
	    weeks:"几周", 
	   search_for_a_section_or_id:"搜索部分或ID…",	   
	   search_for_a_deft:"搜索部门…", 	  
	   launch_course:"发射课程", 	   
	   start_class:"开始课程", 
	   weekly_progress_goal:"每周进度目标",  
	   send_message_to_all_section_students:"向所有部分学生发送消息", 	   
	   monitor_live_sessions:"监视现场会议", 
	   average_section_grade:"平均截面等级", 
	   resources:"资源", 	   
	   activities:"活动", 	   
	   course_attendance_today:"今天的课程出勤", 	   
	   staffs:"工作人员", 
	   units:"单位", 	   
	   view_all_15_resources:"查看所有15个资源", 
	   Class_discussions:"课堂讨论", 
	   recent_discussions:"最近的讨论", 
	   go_to_class_discussions:"参加课堂讨论", 	   
	   show_my_class_attendance:"展示我的上课",	   
	   add_section:"添加部分",
	   add_global_section:"添加全局部分",
	   close_section:"关闭部分",
	   open_section:"打开部分",
	   batch_upload:"批量上传",
	   finalize:"敲定",	   
	   add_tearcger:"添加教师",
	   remove_tearcger:"删除教师",
	   uploadSectionStatusUpdates:"上传部分状态更新",
	   status_count:"状态计数",	   
	   reactivate:"重新激活",
	   clone:"克隆",
	   enroll_into_Section:"注册到部门",
	   bulk_enrollment:"批量注册",
	   general_Information:"一般信息",
	   online_content_source:"在线内容源",	   
	   second_teacher:"二师",
	   today:"今天",
	   calendar:"日历",
	   week:"星期",
	   month:"月",	   
	   section_progress:"部分进度",
	   complete:"完全的",	   
	   section_title:"章节标题",
	   enter_section_title:"输入章节标题",
	   select_teacher:"选老师",	   
	   select_weeks:"选择周",
	   select_credits:"选择学分",	   
	   select_type:"选择类型",
	   global_section:"全球科",	   
	   enrollment_capacity:"招生能力",
	   enter_enrollment_capacity:"输入注册容量",
	   in_class_information:"在类信息中",
	   Start:"开始",
	   End:"结尾",
	   recurrencePattern:"重复模式",
	   recurrenceFrequency:"复发频率",
	   Weekly:"每周",
	   Monthly:"每月",
	   Recur_every:"复现每",
	   Weeks_on:"几个星期了",
	   day_of_week:"星期几",
	   daily_period:"每日期间",
	   select_daily_period:"选择每日时段",
	   Day:"天",
	   The:"这",
	   of_every:"每个",
	   month_s:"个月",
	   add:"添加",	   
	   course_prequisites :"课程先决条件",
	   select_status :"选择状态",
	   select_school:"选择学校",	   
	   select_period:"选择期间",
	    room_number:"房间号",
	   select_room_number:"选择房间号",
	   Service:"服务",
	   enter_url:"输入网址",
	   edit_section:"编辑部分",	   
	   activity_templates:"活动模板",
	   select_activity_templates:"选择活动模板",
	   link_section:"链接部分",
	   select_link_section:"选择链接部分",
	   please_select_sections:"请选择栏目.",
	   if_you_change_your_status_of_inactivity:"如果您更改不活动状态，学生将受到影响。",
	   closing_the_global_section_will_cause:"关闭全球部分将导致所有学校关闭，并导致所有学生退学。如果您想继续，请点击确认。",	   
	   upload_import_data:"上传和导入数据",
	   here:"这里",	   
	   no_data_avalable_in_table:"表中无可用数据",
	   add_teacher_to_multiple_section:"将教师添加到多个部分",
	   select_teachers_to_add_to_multiple_section:"选择教师以添加到多项选择中",
	   selected:"选中",
	   selected_all:"全选",
	   deselected_all:"取消选择全部",
	   remove_teacher_from_multiple_section:"从多个部分中删除教师",
	   select_teacher_to_remove_to:"选择要删除的教师以进行多项选择",
	   process_removal:"进程删除",	   
	   clone_section:"克隆部分",
	   enroll_student:"招收学生",
	   enroll_student_to:"招收学生",	   
	   name:"姓名",
	   search_for_a_student_or_id:"搜索学生或 ID ……",
	   confirmation_of_enrollment:"注册确认",
	   please_review_and_confirm_enrollments_for:"请查看并确认 的注册",
	   confirm:"确认",
	   enroll_students_to_section:"招收学生到部分",
	   enrollment_period:"报名时间",
	   days:"天",
	   no_data_avalible:"无可用数据。",
	   number_of_primary_teacher:"小学教师人数",
	   secondary_teachers:"中学教师",
	   department_head:"部门主管",
	   section_enroll:"部分报名",
	   load_from_file:"从文件加载",
	   see_sections:"参见部分", 
	   change_enrollment_status:"更改注册状态", 
	   mentor_s:"导师", 
	   overdue_activities:"逾期活动", 
	   total_session_time_and_last_log:"总会话时间和最后日志", 
	   course_name_on_transcript:"笔录上的课程名称", 
	   edit_other_grades:"编辑其他等级", 
	   save_as:"另存为",
	   account_receivable_dashboard:"帐户应收仪表板",
	   key_performance_indicators:"关键绩效指标",
	   a_r_dashboard:"A/R仪表板",
	   payments_credits:"付款/积分",
	   contract_templates:"合同模板",
	   master_contracts:"主合同",
	   a_r_configuration:"A/R配置",
	   a_r_processing:"A/R处理",
	   aging:"老化",
	   receivable:"应收",
	   account_receivable_by_program:"按计划收款",
	   request_detail:"请求细节",
	    request_information:"请求信息",
	    requested_by:"被要求",
	    approved_by:"由...批准",
	    approve:"批准",
	    phone_name:"电话名称",
	    phone_carrier:"电话营运商",
		area_code:"区号",
	   address_lable:"地址lable",
	   address_default:"地址默认值",
	   new_photo:"新照片",
	   current_of_wweeks:"当前的数周",
	   select_enrollment_period:"选择入学期",
	   enter_rejection_reason:"输入拒绝原因...",
	   comments_and_documents:"评论和文件",
	   enrollment_history:"入学历史",
	   request_extension_for:"请求扩展",
	   extended_of_weeks:"延长数周",
	   current_enrollment_status:"当前的注册状态",
	   select_extension_option:"选择扩展选项",
	   extend_current_enrollment_until:"扩展当前注册直到",
	   transfer_to_new_section:"转移到新部分",
	   transcript_requests:"成绩单请求",
	   person_requesting_transcript:"要求成绩单的人",
	   telephone_number:"电话号码",
	   number_of_copies:"复印数量",
	   special_instructions:"特别说明",
	   last_school_attendance:"上学上学",
	   year_last_attended:"上一年参加",
	   current_address:"目前的地址",
	   relationship_to_student:"和学生的关系",
	   method_of_delivery:"交付方法",
	   instructions:"*指示",
	   previous_requests:"以前的请求",
	   additional_info:"附加信息",
	   receive:"收到",
	   process:"过程",
	   add_to_school_group:"添加到学校小组",
	   submit_romote:"提交晋升",
	   next_grade_level:"下一个年级",
	   please_select_a_school_for_promotion_and_transfer:"请选择一所学校进行晋升和转学",
	   write_off:"注销",
	   amount_due:"应付金额",
	   open_amount:"开放金额",
	   payment_application:"付款申请",
	   use_credit_openBalance:"使用信用$ 111",
	   payment_amount_usd:"付款金额（美元）",
	   check_number:"检查号码",
	   confirmation_number:"确认号码",
	   apply_payment:"申请付款",
	   amount_paid:"支付的金额",
	   applied_payment:"应用付款",
	   payer_id:"付款人ID",
	   view_detail:"查看详情",
	   master_contract:"主合同",
	   copy:"复制",
	   contract_user_detail:"合同用户细节",
	   follow_product_cost:"遵循产品成本",
	   default_cost:"默认成本",
	   offered_cost:"提供成本",
	   contract_detail:"合同细节",
	   contract_template_name:"合同模板名称",
	    master_contract_name:"主合同名称",
		 view_students:"查看学生",
		 make_payment:"付款",
		 parent_page:"父页面",
		 edit_parent:"编辑父母",
		 edit_profile:"编辑个人资料",
		 account_receivable_configuration:"帐户应收配置",
		 invoice_generation_date:"发票生成日期", 
	   invoice_generation:"发票生成", 
	   number_of_days_until_due_date:"截止日期的天数",
	   account_receivable_processing:"帐户应收处理",
	   generate_invoices:"生成发票", 
	   process_automatic_payments:"处理自动付款", 
	   send_late_notices:"发送迟到的通知", 
	   course:"课程", 
	   copy_courses:"复制课程", 
	   copy_to_school:"复制到学校", 
	   originating_program_code:"原始程序代码", 
	   destinating_program_code:"确定程序代码", 
	   status_error:"状态/错误",
	   add_prerequisite:"添加先决条件", 
	   group_name:"团队名字", 
	   enter_group_name:"输入组名称", 
	   select_a_department_to_display_courses:"选择一个部门展示课程", 
	   edit_tranferred_grades:"编辑其他等级", 
	   showing_num_records:"显示000记录",
	   edit_all_other_grades:"编辑所有其他等级",
	   upload_student_documents:"上传学生文件",	   
	   select_an_official_transcript_option:"选择官方成绩单选项", 
	   for_schools_or_personal_copy:"用于学校或个人副本", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"供学生使用，送到另一所学校或验证注册。", 
	   request_official_transcript:"请求官方成绩单", 
	   PARCHMENT_for_colleges_or_universities:"学院或大学的羊皮纸", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"申请大学/大学并验证文凭完成。", 
	   request_transcript:"请求成绩单", 
	   Learn_more_about_how_to_use_PARCHMENT:"了解有关如何使用羊皮纸的更多信息",
	   print_PDF:"打印PDF",
	   user_school:"用户学校",
	   filter:"筛选",
	   GENERAL:"一般的", 
	   STUDENT_INFO:"学生信息", 
	   list:"列表", 
	   last_school_name:"最后的学校名称", 
	   TEACHER_INFO:"老师信息", 
	   contracted_load:"收缩负载", 
	   ARENT_INFO:"父信息",
	   add_credential:"添加凭据",
	   edit_credential:"编辑凭据",
	   add_comment_document:"添加评论和文档",
	   add_comment_document_for:"添加评论和文档",
	   state_province:"州/省", 
	   post_code:"邮政编码", 
	   linking_students_to:"将学生链接到", 
	   change_expiration_date:"更改到期日期", 
	   expiry_date:"到期日", 
	   please_select_department:"请选择部门。", 
	   please_select_course:"请选择课程。", 
	   please_select_title:"请输入标题。", 
	   please_select_primary_teacher:"请选择小学老师。", 
	   please_select_weeks:"请选择周。", 
	   please_select_level:"请选择级别。", 
	   please_select_credits:"请选择积分。", 
	   please_select_type:"请选择类型。", 
	   please_select_daily_period:"请选择每日期。",
	   please_enter_link_section:"请输入链接部分。",
	   please_enter_first_name:"请输入名字。", 
	   please_enter_last_name:"请输入姓氏。", 
	   please_enter_contracted:"请输入合同。", 
	   please_enter_email:"请输入电子邮件。", 
	   please_enter_phone:"请输入电话。", 
	   please_enter_username:"请输入用户名。",
	   please_enter_password:"请输入密码。", 
	   please_enter_status:"请选择状态。", 
	   save_successful:"保存成功！",
	   please_add_student_address:"请添加学生地址。", 
	   please_enter_email_address:"请输入电子邮件地址。", 
	   please_select_relationship:"请选择关系。", 
	   please_select_parent_status:"请选择父状态。", 
	   please_enter_label:"请输入标签。", 
	   please_enter_address:"请输入地址。", 
	   please_enter_city:"请进入城市。", 
	   please_enter_state:"请输入状态。", 
	   please_enter_zip_code:"请输入邮政编码。", 
	   please_select_date_of_birth:"请选择出生日期。", 
	   please_select_track:"请选择轨道。", 
	   please_enter_graduation_date:"请输入毕业日期。", 
	   please_enter_country:"请进入国家。", 
	   please_enter_phone_number:"请输入电话号码。", 
	    please_enter_parent_first_name:"请输入父姓。", 
	   please_enter_parent_last_name:"请输入父姓。", 
	   please_enter_parent_email_address:"请输入家长电子邮件地址。", 
	   please_enter_parent_username:"请输入家用用户名。", 
	   please_select_parent_relationship:"请选择父母关系。", 
	   please_enter_phone_label:"请输入电话标签。", 
	   student_address_canot_be_empty:"学生地址不能为空。", 
	   please_select_document_type:"请选择文档类型。", 
	   please_enter_new_type:"请输入新类型。", 
	   please_enter_comment:"请输入评论。", 
	   link_is_not_a_valid_url:"链接不是有效的URL。",
	   please_enter_link_and_label:"请输入链接和标签。",
	   are_you_sure_to_delete_this_student:"您一定会删除这个学生吗？",
	   please_select_gender:"请选择性别。",
	   school_contracted_load:"学校签约负载", 
	   global_contracted_load:"全球合同负载",
	   please_enter_label_for_attachments:"请输入标签以获取附件。",
	   please_select_section:"请选择部分。", 
	   enrollment_completed_successfully:"入学人数成功完成。",
	   delete_this_comment:"删除此评论？",
	   please_enter_course_name:"请输入课程名称。", 
	   please_select_credits_possible:"请选择积分。",
	   can_save_record:"无法保存记录：",
	   are_you_sure_to_delete_this_tranferred_grade:"您一定会删除这个换档的成绩吗？",
	   are_you_sure_to_delete_num_tranferred_grade:"您一定会删除11个二等成绩吗？", 
	   please_select_tranferred_grade:"请选择二级成绩。",
	   please_ente_subject:"请输入主题。", 
	   please_select_made_to:"请选择制作。", 
	   delete_this_communication:"删除此通信？",
	   please_select_school:"请选择学校。",
	   please_enter_name:"请输入名称。",
	   please_enter_group_name:"请输入组名。",
	   you_have_some_form_errors_please_check_above:"您有一些形式错误。请检查上面。",
	   please_select_recipient:"请选择收件人。", 
	   please_enter_description:"请输入说明。",
	   delete_this_resource:"删除此资源？",
	   please_enter_activity_name:"请输入活动名称。", 
	   please_select_activity_type:"请选择活动类型。", 
	   please_enter_max_score:"请输入最大分数。", 
	   please_enter_due_date:"请输入到期日。",
	   please_enter_unit_name:"请输入单位名称。",
	   are_you_sure_to_clear_this_unit:"您一定要清除此单元吗？",
	   please_enter_score:"请输入分数。",
	   delete_this_credential:"删除此凭据？",
	   plase_select_period:"请选择时期", 
	   plase_select_start_date:"请选择开始日期", 
	   plase_select_end_date:"请选择结束日期",
	   select_to_register_course_to_students_individual_learning_path_view:"选择向学生注册课程个人学习路径视图",
	   delete_this_request:"删除此请求？",
	   please_enter_fname:"请输入名字。", 
	   please_enter_lname:"请输入姓氏。", 
	   please_enter_birthday:"请输入生日。", 
	   please_enter_address:"请输入地址。", 
	   please_enter_zip:"请输入Zip。", 
	   please_enter_country:"请进入国家。", 
	   please_enter_ethnicity:"请输入种族。", 
	   please_enter_grade:"请输入等级。", 
	   please_enter_mobile:"请输入手机。", 
	   please_enter_hear_about_us:"请输入有关我们的消息。", 
	   please_enter_program_of_interest:"请输入感兴趣的程序。", 
	   please_enter_course_level:"请输入课程级别。", 
	   please_enter_guardian_1_name:"请输入Guardian 1名称。", 
	   please_enter_guardian_1_email:"请输入Guardian 1电子邮件。", 
	   please_enter_guardian_1_home_phone:"请输入Guardian 1家用电话。", 
	   please_enter_guardian_1_relation:"请输入Guardian 1关系。",
	   please_select_parents:"请选择父母。",
	   transfer_classroom:"转移教室", 
	   please_choose_one_section_to_transfer:"请选择一个要转移的部分。", 
	   transfer:"转移",
	   assigning_multiple_users_to_a_school_or_school_group:"将多个用户分配给学校或学校小组", 
	   add_to_school_or_school_group:"添加到学校或学校小组", 
	   please_select_school_or_school_group:"请选择学校或学校小组。",
	   print_student_progress_report:"打印学生进度报告",
 },
 fr: {
	   reporting_center:"Centre de reportage", 
	   grade_reports:"Rapports de notes", 
	   user_reports:"Rapports d'utilisateurs", 
	   learning_reports:"Rapports d'apprentissage", 
	   administrative_reports:"Rapports administratifs", 
	   progress_report:"Rapport d'étape", 
	   full_progress_report:"Rapport d'avancement complet", 
	   grade_report:"Rapport de note", 
	   roster_report:"Rapport de liste", 
	   parent_report:"Rapport parent", 
	   teacher_report:"Rapport des enseignants", 
	   student_report:"Rapport étudiant", 
	   log_in_report:"Se connecter", 
	   enrollmentreport:"Rapport d'inscription", 
	   enrollment_summary:"Résumé des inscriptions", 
	   student_enrollment_summary:"Résumé des inscriptions aux étudiants", 
	   attendance_report:"Rapport de fréquentation", 
	   attendance_summary_report:"Rapport de résumé", 
	   log_In_Credentials:"Connexion des informations d'identification", 
	   application_report:"Rapport de demande", 
	   section_report:"Rapport de section", 
	   course_report:"Rapport de cours", 
	   communication_summary:"Résumé de la communication", 
	   comments_and_Document_Report:"Rapport de commentaires et de documents", 
	   School_Calendar:"Calendrier scolaire", 
	   bell_Schedule:"Calendrier", 
	   student_Contract:"Contrat étudiant", 
		eOS_Report:"Rapport EOS", 
	   active_Enrollments_Per_Term_Report:"Inscriptions actives par rapport", 
	   active_Student_Enrollments_with_As_Report:"Inscriptions des étudiants actifs avec AS Rapport", 
	   active_Student_Enrollments_Report:"Rapport actif des inscriptions aux étudiants", 
	   all_Students_GPA_Report:"Tous les étudiants GPA Rapport", 
	   old_All_Student_GPA_Report:"Old All Student GPA Rapport", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + Type d'engagement Rapport", 
	   enrollment_Confirmation_Report:"Rapport de confirmation d'inscription", 
	   eOS_College_Matriculations_Report:"Rapport d'immatriculation des collèges EOS", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Historique des inscriptions aux étudiants à ce jour W",
	   student_Information_Report:"Rapport d'information sur les étudiants", 	   
	   ran_by:"passer par",
	   Show_Filter:"Montrer le filtre", 
	   School_Group:"Groupe scolaire", 
	   school:"École", 
	   department:"Département", 
	   student:"Étudiant", 
	   student_status:"Statut d'étudiant", 
	   course:"Cours", 
	   course_level:"Niveau de cours", 
	   section:"Section", 
	   teacher:"Professeur", 
	   primary_teacher:"Instituteur", 
	   secondary_teacher:"Secondaire", 
	   completion_Date_Range:"Plage de dates d'achèvement", 
	   from_date:"Partir de la date", 
	   to_date:"À ce jour", 
	   status:"Statut", 
	   gender:"Genre", 
	   final_grade:"Note finale", 
	   advisor:"Conseiller", 
	   grade_level:"Niveau scolaire", 
	   specific_mark:"Marque spécifique", 
	   track:"Piste", 
	   ethnicity:"Ethnique", 
	   additional_fields:"Champs supplémentaires", 
	   school_sessions:"Séances scolaires", 
	   gradebook:"bulletin de notes", 
	   submit:"Soumettre", 
	   reset:"Réinitialiser", 
	   show_hide_columns:"Afficher / masquer les colonnes", 
	   select_all:"Tout sélectionner", 
	   student_id:"Carte d'étudiant", 
	   last_name:"Nom de famille", 
	   first_name:"Prénom", 
	   grade_level:"Niveau scolaire", 
	   start_date:"Date de début", 
	   end_date:"Date de fin", 
	   grade_final:"Finale", 
	   percent:"Pour cent", 
	   credit:"Crédit", 
	   download_excel:"Télécharger Excel", 
	   print:"Imprimer", 
	   no_data:"Pas de données.", 
	   view:"Voir", 
	   showing:"Projection", 
	   of:"de", 
	   other_grade:"Autre année", 
	   level:"Niveau", 
	   date:"Date", 
	   grade:"Grade",
	   enrollment_Change_Status:"Statut de changement d'inscription", 
	   close:"Fermer", 
	   select_Enrollment_Status:"Sélectionnez l'état d'inscription", 
	   select:"Sélectionner...", 
	   cancel:"Annuler", 
	   save:"Sauvegarder", 
	   students:"Étudiants", 
	   Course_Status:"Statut de cours", 
	   Closed_courses:"Cours fermés", 
	   Section_Status:"Statut de section", 
	   Closed_sections:"Sections fermées", 
	   Transferred_From:"Transféré de",
	   Graduation_From_Date:"Graduation de la date", 
	   Graduation_To_Date:"Graduation à ce jour", 
	   Enrollment_From_Date:"Inscription à partir de la date", 
	   Enrollment_To_Date:"Inscription à ce jour", 
	   Enrollment_Status:"État de l'inscription", 
	   Transfer_From_Date:"Transfert de la date", 
	   Transfer_To_Date:"Transfert à ce jour", 
	   Custom_Query:"Requête personnalisée", 
	   Last_Access_Date:"Dernière date d'accès", 
	   Total_Session_Time:"Temps de session total", 
	   Quality_of_Work:"Qualité de travail", 
	   Grade_to_Date:"Grade à ce jour", 
	   Overall_Percent:"Pourcentage global", 
	   On_Schedule_Percent:"Sur le pourcentage du calendrier", 
	   Activity_Count_Complete:"Compte d'activité complet", 
	   Activity_Count_Total:"Nombre d'activités total", 
	   Overdue_Activitie:"Activité en retard",
	   Section_Course_Additional_Fields:"Section / cours Fields supplémentaires", 
	   Create_On_Date:"Créer à la date", 
	   Last_Status_Update_Date:"Créer à la date", 
	   Transferred_In:"Date de mise à jour du dernier statut", 
	   Transferred_In_Date:"Transféré dans", 
	   email:"E-mail", 
	   birth_date:"Date de naissance", 
	   course_name:"Nom du cours", 
	   section_name:"Nom de la section", 
	   school_name:"Nom de l'école", 
	   Graduation_Date:"Date de remise des diplômes", 
	   Created_on:"Créé sur", 
	   mentor_Advisor:"Mentor / conseiller",
	   sections:"Sections", 
	   roster:"Liste", 
	   relationship:"Relation", 
	   Email_or_Phone:"Email ou téléphone", 
	   Enter_any_text:"Entrez n'importe quel texte", 
	   Advisor_Success_Manager:"Conseiller / gestionnaire de réussite", 
	   User_Id:"ID de l'utilisateur", 
	   phone_number:"Numéro de téléphone", 
	   Student_Last_Name:"Nom de famille étudiant", 
	   Student_First_Name:"Prénom de l'étudiant", 
	   Student_Email:"E-mail étudiant",
	   credentials:"Crédits", 
	   availability:"Disponibilité",
	   enrollments:"Inscription", 
	   Datea_Created_on:"Date créée sur",
	   country:"Pays", 
	   state:"État", 
	   zipcode:"Code postal", 
	   Enter_any_zipcode:"Entrez n'importe quel code postal", 
	   address:"Adresse",
	   zip_Code:"Code postal",
	   Login_Report:"Rapport de connexion", 
	   user_Type:"Type d'utilisateur", 
	   user_Name:"Nom d'utilisateur", 
	   Show_last_log_in_only:"Afficher le dernier connexion uniquement", 
	   Username:"Nom d'utilisateur", 
	   Date_Time:"Date / heure", 
	   Ip_Address:"Adresse IP", 
	   city:"Ville",
	   Enrollment_Start_Date:"Date de début d'inscription", 
	   Enrollment_End_Date:"Date de fin d'inscription", 
	   Completion_Date:"Date d'achèvement", 
	   section_Type:"Type de section", 
	   student_Enrolled:"Étudiant inscrit", 
	   content_Provider:"Fournisseur de contenu", 
	   student_Additional_Fields:"Étudiants champs supplémentaires",
	   type:"Taper", 
	   in_Class_Information:"Dans les informations de la classe",
	   Enrollment_Summary_Report:"Rapport de résumé des inscriptions", 
	   Transferred_From_School:"Transféré de l'école",
	   Total_Enrollments:"Inscriptions totales", 
	   content_Type:"Type de contenu", 
	   active_Course_Progress:"Progrès du cours actif",
	   Grades:"Notes", 
	   attendance:"Présence",
	   student_Absences:"Absences étudiants", 
	   total_Absence:"Absence totale", 
	   section_Absences:"Absence de section",
	   Grade_Level_Absences:"Absences de niveau scolaire",
	   Gender_Absences:"Absences de genre",
	   Login_credentials:"Connexion de connexion", 
	   names:"Des noms", 
	   user_status_admin_teacher_parent:"Statut de l'utilisateur (administrateur, enseignant, parent)", 
	   show_title:"Montrer le titre", 
	   midle_name:"Deuxième nom", 
	   password:"Mot de passe", 
	   parent_name:"Nom du parent", 
	   linked_to_parent:"Liné au parent", 
	   linked_to_student:"Lié à l'étudiant",
	   login_credentials_Report:"Rapport de connexion des informations d'identification", 
	   app_id:"Identifiant d'application", 
	   created:"Créé", 
	   modified:"Modifié",
	   select_level:"Choisir le niveau", 
	   select_additional_fields:"Section Champs supplémentaires", 
	   title:"Titre", 
	   credits:"Crédits", 
	   section_ID:"ID de section", 
	   content:"Contenu", 
	   course_additional_fields:"Cours de terrains supplémentaires",
	   course_id:"ID de cours", 
	   communication_summary_report:"Rapport de résumé de la communication", 
	   method:"Méthode", 
	   create_date:"créer un rendez-vous", 
	   subject:"Sujet", 
	   make_from_id:"Faire de l'identification", 
	   make_to:"Apporter à", 
	   attachments:"Attachements", 
	   comment_and_document_summary_report:"Rapport de résumé des commentaires et des documents", 
	   comment_type:"Type de commentaire", 
	   flagged:"Signalé", 
	   sharing_target:"Partage de la cible", 
	   show_on_transcript:"Afficher sur la transcription", 
	   by:"Par", 
	   comment:"Commentaire", 
	   type_name:"Nom de type", 
	   effective_from_date:"À compter de la date", 
	   effective_to_date:"Efficace à ce jour", 
	   count_docs:"Docs de comte",
	   school_calendar_report:"Rapport du calendrier scolaire", 
	   event_Id:"ID d'événement", 
	   date_start:"date de depart", 
	   date_end:"Fin", 
	   posted_last_name:"Publié le nom de famille", 
	   posted_first_name:"Prénom posté",
	   bell_schedule_report:"Rapport du calendrier des cloches", 
	   period:"Période", 
	   start:"Commencer", 
	   end:"Fin",
	   student_contract_report:"Rapport de contrat étudiant", 
	   begin_date:"Date de début", 
	   contracts:"Contractes", 
	   contract_name:"Nom de contrat", 
	   contract_begin_date:"Date de début du contrat", 
	   contract_end_date:"Date de fin du contrat",
	   active_enrollments_per_term_report:"Inscriptions actives par rapport", 
	   entry_date:"Date d'entrée", 
	   teachers:"Enseignants", 
	   term:"Terme",
	   sections:"Sections",	   
	   showing_of:"Montrant 10 sur 20",	   
	   filter:"Filtre",	   
	   students:"Étudiants",
	   school:"école",
	   all_school:"Toutes les écoles",
	   student:"Étudiant",
	   email:"E-mail",
	   grade_level:"Niveau scolaire",
	   status:"Statut",
	   seach_for_a_student_or_id:"Rechercher un étudiant ou une pièce d'identité…",
	   search:"Chercher …",
	   message_student:"Message étudiant",
	   request_enrollment:"Demande d'inscription",
	   print_schedule:"Horaire d'impression",
	   view:"Voir",
	   no_data:"Pas de données.",
	   views:"Vues", 
	   enrollment:"Inscription", 
	   schedule:"Programme", 
	   transferred_grades:"Notes transférées", 
	   comments_ocuments:"Commentaires et documents", 
	   academic_records:"Dossiers académiques", 
	   compliance_log:"Journal de conformité", 
	   unofficial_transcript:"Transcription non officielle", 
	   iD_card:"Carte d'identité", 
	   student_number_id_information:"Numéro d'étudiant #29561 Informations", 
	   student_number:"Numéro d'étudiant", 
	   gender:"Le genre", 
	   goes_by:"Passe", 
	   date_of_birth:"Date de naissance", 
	   ethnicity:"Ethnicité", 
	   mobile:"Mobile", 
	   academic_track:"Parcours Académique", 
	   learning_path_template:"Modèle de parcours d'apprentissage", 
	   graduation_date:"Date d'obtention du diplôme", 
	   comments:"Commentaires", 
	   transfer_information:"Informations de transfert", 
	   enrollment_date:"Date de l'inscription", 
	   transfer_date:"Date de transfert", 
	   transfer_student:"Étudiant transféré", 
	   parent_mentor_contact:"Contact parent/mentor", 
	   mentor:"Mentor", 
	   parent_phone:"Téléphone des parents", 
	   emergency_contact:"Personne à contacter en cas d'urgence", 
	   academic_advisor_ssm:"Conseiller académique / SSM", 
	   student_success_manager:"Responsable de la réussite étudiante", 
	   academic_avisor:"Conseiller académique", 
	   address:"Adresse", 
	   address_01_Default:"Adresse 01 (par défaut)", 
	   street:"Rue", 
	   city:"Ville", 
	   state:"État", 
	   zip:"Zipper", 
	   hide_Detailed_information:"Masquer les informations détaillées", 	    
	   current_course_progress:"Progrès du cours actuel", 	    
	   full_Path_Progress:"Progression du chemin complet", 	    
	   print:"Imprimer", 	    
	   avg_graduation_progress:"Moy. Progression de l'obtention du diplôme", 	    
	   GPA:"AMP", 	    
	   graduation_Status:"Statut d'obtention du diplôme", 	    
	   on_track:"Sur la bonne voie",
	   show_detailed_information:"Afficher les informations détaillées",
	   communication:"Communication",
	   student_advisors:"Conseillers étudiants", 	    
	   country:"Pays", 	    
	   grade:"Noter", 	    
	   credits:"Crédits", 	    
	   sort:"Trier", 	    
	   course_progress:"Progression du cours",
	   overall_GPA:"GPA globale",
	    current_graduation_progress:"Progression actuelle de l'obtention du diplôme",
		individual_course_progress:"*La progression de chaque cours varie, il s'agit de votre progression globale", 
		subject:"Matière",
		online_sections:"Sections en ligne",
	   course:"Cours", 
	   section:"Section", 
	   actions:"Actions", 
	   view_event:"Voir l'événement",
	   in_class_section:"Dans la section des classes",
	   calendar:"Calendrier",
	   access_link:"Lien d'accès", 
	   online_link:"Lien en ligne",
	   launch_course:"Cours de lancement", 
	   start_class:"Commencer les cours",
	   level:"Niveau", 
	   date:"Date", 
	   transferred_in:"Transféré dans",
	   tranferred_grades:"Notes transférées",
	   Searchs:"Chercher", 
	   Search_department_course:"Recherche département cours, src…",
	   archived:"Archivé", 
	   add_comment:"Ajouter un commentaire", 
	   created_date:"Date de création", 
	   by:"Par", 
	   type:"Taper", 
	   comment:"Commentaire", 
	   from_date:"Partir de la date", 
	   to_date:"À ce jour", 
	   documents:"Documents", 
	   edit:"Éditer", 
	   delete:"Effacer",
	   communications:"Communications", 
	   add_communications:"Ajouter Communication", 
	   made_from:"Fait à partir de", 
	   made_to:"A été fait pour", 
	   means:"Moyens", 
	   attachments:"Pièces jointes", 
	   content:"Contenu",
	   compliance_logs:"Journaux de conformité", 
	   messageID:"ID du message", 
	   agree:"Accepter", 
	   dateTime:"Date Heure", 
	   iPAddress:"Adresse IP", 
	   add_idit_comment_document:"Ajouter/Modifier un commentaire et un document", 
	   document_type:"Type de document", 
	   show_on_transcript:"Afficher sur la transcription", 
	   select_users_to:"Sélectionnez les utilisateurs auxquels", 
	   teacher:"Prof", 
	   parent:"Parent", 
	   flag:"Drapeau", 
	   none:"Aucun", 
	   link:"Lien", 
	   label:"Étiquette", 
	   add_more_link:"Ajouter plus de lien", 
	   save:"Sauvegarder", 
	   add_edit_communication:"Ajouter/modifier communication", 
	   made_by:"Faite par", 
	   date_time:"Date/Heure", 
	   length:"Longueur", 
	   select:"Sélectionner", 
	   select_users_to_view:"Sélectionnez les utilisateurs pour afficher la communication", 
	   add_more:"Ajouter plus", 
	   communication_summary:"Résumé des communications",
	   close:"proche",
	   new_type:"Nouveau type",
	   select_user_to_view_comment:"Sélectionnez les utilisateurs pour afficher le commentaire",
	   flag_comment:"Signaler un commentaire",
	   teacher_page:"Page Enseignant",
	   edit_information:"Modifier les informations",
	   phone:"Téléphoner",
	   add_credential:"Ajouter des informations d'identification",
	   add_edit_credential:"Ajouter/Modifier les informations d'identification",
	   first_name:"Prénom",
	   midle_name:"Deuxième nom",
	   last_name:"Nom de famille",
	   cancel:"Annuler",
	   add_new:"Ajouter nouveau",
	   phone_type:"Type de téléphone",
	   zipCode:"Code postal",
	   phone_number:"Numéro de téléphone",
	   default:"Défaut",
	   please_select_country:"Veuillez sélectionner le pays",
	   student_information:"Informations sur les étudiants",
	   username:"Nom d'utilisateur",
	   user_directory:"Répertoire des utilisateurs",
	   add_teacher:"Ajouter un enseignant",
	   add_admin:"Ajouter un administrateur",
	   export_to_excel:"Exporter vers Excel",
	   export_to_pdf:"Exporter au format PDF",
	   send_login_credentials:"Envoyer les identifiants de connexion",
	   search_for_a_user_or_id:"Rechercher un utilisateur ou un identifiant…",
	   user:"Utilisateur",
	   school_admin:"Administrateur de l'école",
	   change_password:"Changer le mot de passe",
	   set_password_expiration_date:"Définir la date d'expiration du mot de passe",
	   impersonate_user:"Utilisateur usurpé",
	   edit_user_tags:"Modifier les balises utilisateur",
	   add_or_edit_users_schoo_assign:"Ajoutez ou modifiez l'affectation scolaire des utilisateurs",
	   assign_content_access:"Attribuez un accès au contenu",
	   add_student:"Ajouter un étudiant",
	   add_parent_mentor:"Ajouter un parent/mentor",
	   showing:"Montrant",
	   of:"de",
	   school_name:"Nom de l'école",
	   edit_user_school_tags:"Modifier les balises de l'école de l'utilisateur",
	   personal_information:"Informations personnelles",
	   contacted_load:"Charge contactée",
	   maximum_of_active_students:"Nombre maximal d'étudiants actifs",
	   teacher_since:"Enseignant depuis",
	   login_infomation:"Informations de connexion",
	   username:"Nom d'utilisateur",
	   password :"Mot de passe",
	   avatar :"Avatar",
	   teachers :"Enseignants",
	   change_status :"Modifier le statut",
	   add_admin:"Ajouter un administrateur",
	   name:"Nom",
	   create_on:"Créer sur",
	   registrar:"Greffier",
	   birthday:"Anniversaire",
	   signature:"Signature",
	   photo:"Photo",
	   designated_registrar:"Registraire désigné",
	   track:"Piste",
	   select_existing_track:"Sélectionnez une piste existante",
	   available:"Disponible",
	   parent_mentor:"Parent / Mentor",
	   relationship:"Relation amoureuse",
	   email_address:"Adresse e-mail",
	   academic_mentor:"Mentor académique",
	   no_data_available_in_table:"Aucune donnée disponible",
	   primary_language:"Langue principale",
	   add_into_parent_or_mentor:"Ajouter dans Parent / Mentor",
	   add_into_phone:"Ajouter au téléphone",
	   add_into_address:"Ajouter à l'adresse",
	   select_one:"Sélectionnez-en un",
	   login:"Connexion",
	   plese_select_country:"Veuillez choisir le pays",
	   edit_student:"Modifier l'élève",
	   academic_advisor_or_student_success_manager:"Conseiller pédagogique / Responsable de la réussite étudiante",
	   role:"Rôle",
	   link_parent:"Lien parent",
	   link_advisor_sms:"Conseiller de liaison/SSM",
	   save_into_parent_mentor:"Enregistrer dans Parent / Mentor",
	   save_into_parent_phone:"Enregistrer dans le téléphone",
	   save_into_parent_address:"Enregistrer dans l'adresse",
	   bulk_information_update:"Mise à jour des informations en vrac",
	   enrollments:"Inscriptions",
	   email_student:"Envoyer un e-mail à l'étudiant",
	   unofficial_transcripts:"Transcriptions non officielles",
	   official_transcripts:"Transcriptions officielles",
	   email_students_schedule:"Calendrier de l'étudiant par e-mail",
	   export_students_to_excel:"Exporter les étudiants vers Excel",
	   export_parent_list_to_excel:"Exporter la liste des parents vers Excel",
	   assign_learning_path_template:"Attribuer un modèle de parcours d'apprentissage",
	   promote_student_to_the_next_grade_level:"Faire passer l'élève au niveau supérieur",
	   batch_upload_students:"Téléchargement groupé d'étudiants",
	   batch_upload_transfer_grades:"Notes de transfert de téléchargement par lots",
	   transfer_apex_only:"Transfert (APEX uniquement)",
	   transfer_content_providers:"Transfert (tous les fournisseurs de contenu)",
	   batch_enrollments:"Inscriptions par lots",
	    send_message:"Envoyer le message",
	   impersonate:"Usurper l'identité",
	   change_login_credentials:"Modifier les identifiants de connexion",
	   request_enrollment:"Demande d'inscription",
	   send_weekly_status_report:"Envoyer un rapport d'état hebdomadaire",
	   please_select_student:"Veuillez sélectionner les étudiants.",
	   student_status_will_be_changed_to_status_withdraw:"Le statut étudiant sera passé à 111 et toutes les inscriptions seront retirées. Es-tu sur de vouloir continuer?",
	   student_status_will_be_changed_to_status:"Le statut d'étudiant sera passé à 111. Êtes-vous sûr de vouloir continuer?",
	   value:"Évaluer",
	   student_success_manager_or_acdemic:"Student Success Manager / Conseiller académique",
	   enroll_students_to_section:"Inscrire les étudiants à la section",
	   department:"département",
	   refresh:"Rafraîchir",
	   select_department:"Veuillez sélectionner le département",
	   select_course:"Sélectionner le cours",
	   select_section:"Sélection de la section",
	   start_date:"Date de début",
	   end_date:"Date de fin",
	   ID:"IDENTIFIANT",
	   action:"Action",
	   enrollment_period:"Période d'inscription",
	   select_a_course_to_register_ilp:"Sélectionnez un cours pour enregistrer l'ILP",
	   period:"Période",
	   credit:"Crédit",
	   year:"Année",
	   enroll:"Inscrire",
	   recipient_transcript:"Transcription du receveur",
	   select_all_or_unselect_all:"Sélectionnez tout / non sélectionné",
	   include_in_progress_sections:"Inclure dans les sections",
	   show_satisfaction_of_program:"Montrer la satisfaction du programme",
	   show_total_credit:"Afficher les crédits totaux",
	   show_student_info:"Afficher les informations des élèves",
	   show_academic_info:"Afficher les informations académiques",
	   show_school_names_from_orther_grades:"Montrer les noms d'école des autres notes",
	   show_school_contact:"Afficher les contacts de l'école",
	   include_transferred_grades_in_gpa:"Inclure les notes transférées en GPA",
	   include_in_progress_grade:"Inclure en progrès Grade",
	   include_grade_scales:"Inclure des échelles de qualité",
	   show_graduation_date:"Afficher la date de remise des diplômes",
	   show_weighted_gpa:"Montrer GPA pondéré",
	   show_grade_level_gpa:"Afficher GPA au niveau scolaire",
	   show_comletion_date:"Afficher la date d'achèvement",
	   show_withdraw_classes:"Montrer les cours retirés",
	   show_withdraw_date:"Afficher la date retirée",
	   show_transfered_in_classes:"Show Transféré dans les classes",
	   show_digital_seal:"Afficher le sceau numérique",
	   show_singnature:"Montrer la signature",
	   group_by:"Par groupe",
	   school_year:"Année scolaire",
	   school_level:"Niveau scolaire",
	   notes:"Remarques",
	   ok:"D'accord",
	   are_you_sure_to_send:"Êtes-vous sûr d'envoyer?",
	   assign_learning_path_templete:"Attribuer un modèle de chemin d'apprentissage",
	   assign_student_to_selected_learning:"Affecter l'élève à un modèle de chemin d'apprentissage sélectionné",
	   assign:"Attribuer",
	   are_you_sure_to_promote_to_level:"Êtes-vous sûr de promouvoir au niveau supérieur?",
	   data_process:"Processus de données",
	   upload_and_import_data:"Télécharger et importer des données",
	   download_user_information:"Télécharger les informations utilisateur",
	   here:"ici",
	   select_student_upload_file:"Sélectionnez le fichier de téléchargement des étudiants",
	   local_drive:"Entraînement local",
	   the_file_is_uploaded:"Le fichier est téléchargé",
	   template_name:"Nom de modèle",
	   Here:"Ici",
	   sample_file_excel:"Exemple de fichier Excel.",
	   file_type:"Type de fichier",
	   delimited:"Délimité",
	   delimited_chars:"Chars délimités",
	   fixed_width:"Largeur fixe",
	   first_line_header:"En-tête de première ligne",
	   loader_field:"Champ de chargement",
	   Header:"Entête",
	   sample_data:"Échantillons de données",
	   column_width:"Colunm Largeur",
	   save_tamplate:"Enregistrer le modèle",
	   save_and_upload_data:"Enregistrer et télécharger des données",
	   result:"Résultat",
	   upload_and_import_data_orther_grade:"Télécharger et importer des données Autre note",
	   select_upload_file:"Sélectionnez Télécharger le fichier",
	   student_id:"Carte d'étudiant",
	   uploadAnd_import_data_enrollment:"Téléchargez et importez l'inscription des données",
	   section_id:"ID de section",
	   title:"Titre",
	   recipient:"Destinataire",
	   same_current_address:"Identique à l'adresse actuelle",
	   add_more_reciptient:"Ajouter plus de destinataire",
	   issuse_date:"Date d'émission",
	   show_total_unapplied_credits:"Afficher les crédits totaux non appliqués",
	   reconcile_another_student_record:"Réconcilier avec un autre enregistrement étudiant",
	   please_choose_one_student_to_reconcile:"Veuillez choisir un étudiant à réconcilier.",
	   yes:"Oui",
	   no:"Non",
	   apex_classroom_sync:"Sync de classe Apex",
	   next:"Suivant",
	   apex_classrooms:"Salles de classe Apex",
	   online_user_id:"ID utilisateur en ligne",
	   enter_online_user_id:"Entrez l'ID utilisateur en ligne",
	   online_section_id:"ID de section en ligne",
	   online_section_name:"Nom de la section en ligne",
	   online_course_name:"Nom du cours en ligne",
	   enrollment_date:"Date de l'inscription",
	   back:"Dos",
	   import:"Importer",
	   offical_transcipt:"Transcription officielle",
	   email_schedule:"Calendrier par e-mail",
	   reconcile_with_another_records:"Réconcilier avec un autre record",
	   online_sync_and_update:"Synchronisation et mise à jour des progrès en ligne",
	   download_all_completion_cretification:"Téléchargez toutes les certifications d'achèvement",
	   orther_grade:"Autres notes",
	   medical:"Médical",
	   comments_and_documents:"Commentaires et documents",
	   contracts:"Contractes",
	   invoices:"Facture",
	   audit_logs:"Journaux d'audit",
	   edit_logs:"Modifier les journaux",
	   grade_to_date:"Grade à ce jour",
	   quality_of_work:"Qualité de travail",
	   last_access:"Dernier accès",
	   gradebook:"bulletin de notes",
	   transfer:"Transfert",
	   completion_certification:"Certification d'achèvement",
	   tranfer_user_school:"Transférer une école d'utilisateurs",
	   tranfer_to_school:"Transférer à l'école",
	   tranfer_apex_classrooms:"Transférer les salles de classe Apex",
	   course_to_moved:"Cours pour déplacer",
	   current_teacher:"Professeur actuel",
	   future_section:"Future Section",
	   future_program:"Programme futur",
	   future_teacher:"Futur professeur",
	   enrollment_start_date_end_date:"Date de début d'inscription - Date de fin",
	   no_more_option:"Plus d'options",
	   create_new:"créer un nouveau",
	   transfer_classrooms:"Transférer des salles de classe",
	   tyler_synchronization_for_az_school:"Synchronisation de Tyler pour les écoles AZ",
	   synchronize:"Synchroniser",
	   individual_course_progress_varies:"Les progrès des cours individuels varient. Ceci est votre progrès global vers l'obtention du diplôme.",
	   edit_ilp:"Modifier l'ILP",
	   add_academic_record:"Ajouter un dossier académique",
	   edit_all_records:"Modifier tous les enregistrements",
	   search_corse_department_src:"Cours de recherche, département, SRC…",
	   message_id:"ID du message",
	   add_new_contract:"Ajouter un nouveau contrat",
	   contract_id:"ID de contrat",
	   contract_name:"Nom de contrat",
	   first_date:"Premier rendez-vous",
	   last_date:"Dernier rendez-vous",
	   amount_per_period:"Montant par période",
	   terminating_status:"Statut de terminaison",
	    payment_history:"historique de paiement",
	   record_payment:"Enregistrement du paiement",
	   payment_method:"Mode de paiement",
	   invoice_id:"ID de facture",
	   show_all:"Afficher tout",
	   invoice_date:"Date de facture",
	   from:"Depuis…",
	   to:"Pour…",
	   amount:"Montant",
	   paid:"Payé",
	   due:"Exigible",
	   date_paid:"Date payée",
	   apply_payments:"Appliquer les paiements",
	   mark_as_paid:"Marquez comme payé",
	   void:"Annuler",
	   audit_log:"Journal d'audit",
	   object:"Objet",
	   changes_made:"Modifications effectuées",
	   create_time:"Créer du temps",
	   time_stamp:"Horodatage",
	   user_creare:"Création de l'utilisateur",
	   edit_log:"Modifier le journal",
	   field_name:"Nom de domaine",
	   old_value:"Valeur ancienne",
	   new_value:"Nouvelle valeur",
	   date_time_update:"Mise à jour de la date / heure",
	   updater:"Mise à jour",
	   add_edit_academic_records:"Ajouter / modifier le dossier académique",
	   select_flag:"Sélectionnez Flag ...",
	   edit_all_tranferred_grades:"Modifier toutes les notes transmises",
	   save_records:"Sauver les enregistrements",
	   possible_credits:"Crédits possibles",
	   select_level:"Choisir le niveau",
	   select_grade_level:"Sélectionner le niveau scolaire",
	   select_status:"Sélectionner l'état",
	   add_more_row:"Ajouter plus de ligne",
	   full_screen:"Plein écran",
	   course_code:"Ajouter d'autres notes",
	   add_order_grades:"Code de cours",
	   select_credit:"Sélectionner le crédit",
	   select_default:"Sélectionnez par défaut",
	   credits_possible:"Crédits possibles",
	   select_possible_credit:"Sélectionnez un crédit possible",
	   product:"Produit",
	   fromn:"Depuis",
	   ton:"Pour",
	   last_invoice_date:"Dernière date de facture",
	   please_select_stu:"Veuillez sélectionner l'étudiant",
	   payer:"Payeur",
	   amount_per_billing_period:"Montant par période de facturation",
	   price_unit:"Prix ​​à l'unité",
	   billing_period:"Période de facturation",
	   automatic_renewal:"Renouvellement automatique",
	   automatic_payment:"Facturation automatique",
	   duration_of_period:"Durée (# des périodes)",
	   payment_id:"ID de paiement",
	   payment_date:"Date de paiement",
	   payment_amount:"Montant du paiement",
	   applied:"Appliqué",
	   available:"Disponible",
	   unApply:"Non d'application",
	   refund:"Remboursement",
	   add_new_teacher:"Ajouter un nouvel enseignant",
	   change_teacher_status:"Changer le statut de l'enseignant",
	   search_for_a_teacher_or_id:"Recherchez un enseignant ou une pièce d'identité…",
	   flags:"Drapeaux",
	   tags:"Mots clés",
	   allowed:"Autorisé",
	   message_teacher:"Professeur de message",
	   impersonate_teacher:"Professeur d'identité",
	   add_teacher_qualification:"Ajouter la qualification des enseignants",
	   profile:"Profil",
	   teacher_schedule:"Calendrier des enseignants",
	   qualifications:"Qualifications",
	   student_actions:"Actions des étudiants",
	   linking_parents_to:"Lier les parents à",
	   select_do:"Sélectionner ...",	   
	   see_edit_logs:"Voir les journaux d'édition",	   
	   see_qualifications:"Voir les qualifications",
		link_academic_advisor:"Lien conseiller académique",
	   student_success:"Réussite",
	   linking_academic_advisor_or_student_success:"Lier le conseiller académique / la réussite des étudiants à",
	   staff:"Personnel",
	   teacher_status:"Statut de l'enseignant",
	   school_admin_status:"Statut administrateur scolaire",
	   global_user_directory:"Répertoire des utilisateurs mondiaux",
	   edit_teacher:"Éditer le professeur",
	   contracted:"Contracté",
	   add_comments_and_documents:"Commentaires et documents",
	   edit_comments_and_documents:"Modifier les commentaires et les documents",
	   parents_or_mentor:"Parents / mentor",
	   send_mail:"Envoyer un mail",
	   are_you_sure_to_delete_this_teacher:"Êtes-vous sûr de supprimer ce professeur.",
	   edit_user_password:"Modifier le nom d'utilisateur et le mot de passe",
	   add_qualifications:"Ajouter des qualifications",
	   please_select_a_least_on_teacher:"Veuillez sélectionner au moins un enseignant.",
	   edit_parent_mentor:"Modifier le parent / mentor",
	   parent_mentor_information:"Informations sur les parents / mentor",
	   send:"Envoyer",
	   are_you_surse_to_delete_this_parent:"Êtes-vous sûr de supprimer ce parent.",
	   home:"Maison",
	   
	  // auto_promotion:"Promotion automatique",
	   auto_promotion:"Promotion de niveau scolaire",
	   Promote:"Promouvoir",
	   search_for_a_name:"Recherchez un nom…",
	   download_to_excel:"Télécharger pour Excel",
	   download_to_pdf:"Télécharger sur PDF",
	   User_ID:"ID de l'utilisateur",
	   User_type:"Type d'utilisateur",
	   communication_log:"Journal de communication",
	   Student_Status:"Statut d'étudiant",
	   Users:"Utilisateurs",
	   Staff_Reassignment:"Réaffectation du personnel",
	   Select_Staff:"Sélectionner le personnel",
	   select_asset_type_to_reassign:"Sélectionnez le type d'actif pour réaffecter",
	   transfer_all_to:"Transférer tout à",
	   transfer_selectively:"Transférer sélectivement",
	   remove_all:"Enlever tout",
	   remove_selectively:"Supprimer sélectivement",
	   Event:"Événement",
	   Time:"Temps",
	   Participants:"Participants",
	   new_staff:"Nouvelle équipe",
	   Remove:"Retirer",
	   Profile_Page:"Page de profil",
	   settings:"Paramètres",
	   security:"Sécurité",
	   timezone:"Fuseau horaire",
	   notifications:"Notifications",
	   check_for_feature_availability_at_your_school:"Vérifiez la disponibilité des fonctionnalités dans votre école.",
	   current_password:"Mot de passe actuel",
	   new_password:"nouveau mot de passe",
	   confirm_password:"Confirmez le mot de passe",
	   updte_password:"Mettre à jour le mot de passe",
	   change_timezone:"Changer la fuseau horaire",
	   time_zone:"Fuseau horaire",
	   please_select_time_zone:"Veuillez sélectionner le fuseau horaire",
	   notification_settings:"Paramètres de notification",
	   level_of_urgency:"Niveau d'urgence",
	   email_destination:"Destination par e-mail",
	   SMS_Destination:"Destination SMS",
	   app:"Appliquer",
	   please_select_level_of_urgency:"Veuillez sélectionner le niveau d'urgence",	   
	   reset_filters:"Réinitialiser les filtres",
	   batch_data_update:"Mise à jour des données des étudiants",
	   contract_template:"Modèle de contrat",
	   accept:"Accepter",
	   reject:"Rejeter",
	   view_roles:"Voir les rôles",
	   administrator_information:"Informations sur l'administrateur", 
	   account_reation_date:"Date de création de compte", 
	   expiration_date:"Date d'expiration", 
	   schools:"Écoles", 
	   advisees:"Avis",
	   message:"Message",
	   see_comments_and_documents:"Voir commentaires et documents",
	   restore_APEX_Classrooms:"Restaurer les salles de classe Apex",
	   teacher_information:"Information des enseignants", 
	   teacher_number:"Numéro d'enseignant", 
	   departmens:"Départements", 
	   global_capacity:"Capacité mondiale", 
	   local_contracted_load:"Charge contractée locale", 
	   parents:"Parents", 
	   parent_information:"Informations sur les parents",
	   linked_students:"Étudiants liés", 
	   link_student:"Étudiant en liaison", 
	   unlink_student:"Étudiant non lié", 
	   search_dot:"Rechercher…", 
	   view_local:"Voir local", 
	   view_global:"Voir Global",
	   resource:"Ressource",
	   current_grade:"Classe actuelle", 
	   affiliation:"Affiliation", 
	   current_assignment:"Affectation actuelle", 
	   total_assignments:"Total des affectations", 
	   percent_completed:"Pourcentage terminé",
	   semester:"semestre",
	   graduation_year:"Année de remise des diplômes", 
	   student_name:"Crédits gagnés", 
	   credits_earned:"Crédits gagnés",
	   exit:"sortie",
	   engagement_type:"Type d'engagement",
	   college_admitted:"Collège admis", 
	   college_attending:"Collège fréquenté", 
	   major:"Majeur", 
	   report_card:"Bulletin scolaire", 
	   academic_term:"Terme académique", 
	   show_average:"Afficher la moyenne",
	   school_information:"École",
	   school_misc_configuration:"Configuration de la mission scolaire", 
	   school_tags:"Étiquettes scolaires", 
	   role_tags:"Tags de rôle", 
	   content_integration:"Intégration de contenu", 
	   user_roles:"Rôles des utilisateurs", 
	   communication_user_rules:"Règles des utilisateurs de communication", 
	   school_administrators:"Administrateurs scolaires", 
	   school_year_configuration:"Configuration de l'année scolaire", 
	   A_R_payment_configuration:"Configuration de paiement A / R", 
	   facility:"Facilité", 
	   enrollment_rules:"Règles d'inscription", 
	   student_contract_rules:"Règles de contrat étudiant", 
	   products:"Des produits", 
	   notification_templates:"Modèles de notification", 
	   transcript_viewer_options:"Options de la visionneuse de transcription", 
	   feature_configuration:"Configuration des fonctionnalités", 
	   feature_settings:"Paramètres des fonctionnalités", 
	   communication_rules:"Règles de communication", 
	   object_state:"État d'objet", 
	   departments:"Départements", 
	   grading_scales:"Échelles de notation", 
	   grading_periods:"Périodes de notation", 
	   academic_tracks:"Tracks académiques", 
	   learning_path_templates:"Modèles de chemin d'apprentissage", 
	   grade_book_activity_descriptions:"Descriptions d'activité du livre de notes", 
	   academic_terms:"Termes académiques",
	   academic_system:"Système académique",
	   address_line_1:"Adresse 1", 
	   country_code:"Code postal", 
	   address_line_2:"Adresse Ligne 2", 
	   school_title:"Titre d'école",
	   CEEB_code:"Code du CEEB", 
	   zip_postal_code:"Zip / code postal", 
	   state_province:"État / province", 
	   website:"Site Internet", 
	   subdomain:"Sous-domaine", 
	   success_manager:"Success Manager", 
	   school_logo:"Logo de l'école", 
	   digital_seal:"Sceau numérique",
	   password_exception_rule:"Règle d'exception de mot de passe",
	   change_password_first_login:"Modifier la connexion du mot de passe", 
	   password_expires_after_days:"Le mot de passe expire après les jours", 
	   enforcement_of_teachers_load:"Application de la charge de l'enseignant", 
	   in_house_handling_of_transcript_requests:"Dans la gestion de la maison des demandes de transcription", 
	   display_mobile_app_link:"Afficher le lien d'application mobile", 
	   display_weekly_progress_goal:"Afficher l'objectif de progrès hebdomadaire", 
	   turn_on_notification:"Activer la notification", 
	   classic_letter:"Lettre classique", 
	   automatic_parent_account_creation:"Création automatique du compte parent", 
	   default_parent_account_status:"État du compte parent par défaut", 
	   default_time_zone:"Fuseau horaire par défaut", 
	   link_to_transcript_vendor_help:"Lien vers une aide au fournisseur de transcription", 
	   link_to_transcript_vendor:"Lien vers le fournisseur de transcription", 
	   link_for_help_system:"Lien pour le système d'aide", 
	   student_enrollment_limit:"Limite d'inscription des étudiants", 
	   default_section_type:"Type de section par défaut", 
	   default_section_capacity:"Capacité de section par défaut",
	   transcript_template:"Modèle de transcription",
	   edit_security_school_tags:"Modifier les balises de l'école de sécurité", 
	   security_school_tags:"Tags d'école de sécurité",
	   tags_name:"Nom des tags", 
	   edit_role_tags:"Modifier les tags de rôle",
	   add_school_based_tags:"Ajouter des étiquettes en milieu scolaire", 
	   description:"Description", 
	   applied_to_roles:"Appliqué aux rôles", 
	   teacher:"Professeur",
	   edit_security_role_tags_for:"Modifier les étiquettes de rôle de sécurité pour",
	   school_admins:"Administrateurs scolaires",
	   school_begin_date:"Date de début scolaire", 
	   school_end_date:"Date de fin de l'école", 
	   automatic_control_of_teacher_s_load:"Contrôle automatique de la charge de l'enseignant",
	   A_R_payment_gateway_configuration:"Configuration de la passerelle de paiement A / R", 
	   payment_processing_vendor:"Vendeur de traitement des paiements", 
	   secret_key:"Clef secrète", 
	   publishable_key:"Clé publiable", 
	   account_id:"identifiant de compte",
	   updating_tudents:"Mise à jour des étudiants", 
	   delete_selected_records:"Supprimer les enregistrements sélectionnés",
	   attribute_name:"Nom d'attribut", 
	   applied_for:"Appliqué pour",
	   add_school:"Ajouter l'école", 
	   overview:"Aperçu", 
	   search_for_school:"Recherche d'école…", 
	   search_for_student:"Recherche d'étudiant…",
	   attribute_type:"Type d'attribut", 
	   select_school_group:"Sélectionner un groupe scolaire", 
	   access_rights:"Des droits d'accès", 
	   create:"Créer", 
	   read:"Lire",
	   facility_management:"Gestion des installations", 
	   facility_name:"Nom de l'installation", 
	   capacity:"Capacité",
	   enrollment_allowance_period_days:"Période d'allocation d'inscription (jours)", 
	   maximum_enrollment_duration_days:"Durée maximale d'inscription (jours)", 
	   start_date_of_the_week:"Date de début de la semaine", 
	   end_date_of_the_week:"Date de fin de la semaine",
	   lookup_name:"Nom de recherche", 
	   duration:"Durée", 
	   time_unit:"Time", 
	   round_up_to_end_of_time_unit:"Arrondir à l'unité de fin des temps",
	   product_name:"Nom de produit",
	   product_ID:"ID de produit", 
	   price_offer:"Offre de prix", 
	   price:"Prix", 
	   frequency:"Fréquence", 
	   effective_from:"À compter de", 
	   effective_to:"Efficace à", 
	   active:"Actif",
	   drag_drop_to_text_cursor_in_content:"Dragage et passer au curseur de texte dans le contenu", 
	   event_type:"Type d'événement", 
	   notification_rule:"Règle de notification", 
	   level_or_ugency:"Niveau ou usage", 
	   user_role:"Rôle d'utilisateur",
	   edit_security_user_tags:"Modifier les balises utilisateur de sécurité",
	   content_access:"Accès au contenu", 
	   content_access_for:"Accès au contenu pour", 
	   add_new_access:"Ajouter un nouvel accès", 
	   date_assigned:"Date attribuée",
	   enrollment_request:"Date attribuée", 
	   enrollment_request_for:"Demande d'inscription", 
	   mentors:"Mentors",
	   options:"Options",
	   department_name:"Nom du département", 
	   universal_department:"Département universel", 
	   open:"Ouvrir",
	   min_point:"Point min", 
	   max_point:"Point maximal", 
	   grade_point:"Note", 
	   honors:"Honneurs", 
	   college:"Collège",
	   order:"Commande", 
	   start_time:"Heure de début", 
	   end_time:"Heure de fin",
	   period_name:"Nom de période",
	   grading_periods_head:"Période de classement tête",
	   grading_period:"Période de notation", 
	   weight:"Lester",
	   track_name:"Nom de piste",
	   academic_track_requirement:"Exigence de piste académique", 
	   of_required_credits:"# des crédits requis",
	   individual_learning_plan_template:"Modèle de plan d'apprentissage individuel",
	   ILP_name:"Nom ILP",
	   remove_requirement:"Supprimer les besoins", 
	   reset_requirement:"Réinitialiser l'exigence", 
	   add_requirement:"Ajouter une exigence",
	   must_end_date:"Doit terminer la date", 
	   courses_open_date:"Cours Open Date", 
	   signup_end_date:"Date de fin d'inscription", 
	   signup_start_date:"Date de début d'inscription", 
	   section_period:"Période de section",
	   
	   weeks:"Semaines", 
	   search_for_a_section_or_id:"Recherchez une section ou une pièce d'identité…",
	   search_for_a_deft:"Recherchez un département…", 	   
	   launch_course:"Cours de lancement", 
	   start_class:"Commencer les cours", 	   
	   weekly_progress_goal:"Objectif de progrès hebdomadaire",
	   send_message_to_all_section_students:"Envoyer un message à tous les étudiants de la section", 
	   monitor_live_sessions:"Surveiller les séances en direct", 
	   average_section_grade:"Grade de section moyenne", 
	   resources:"Ressources", 
	   activities:"Activités", 	   
	   course_attendance_today:"Présistance au cours aujourd'hui", 
	   staffs:"Personnel", 
	   units:"Unités", 
	   online_sections:"Sections en ligne", 
	   view_all_15_resources:"Voir les 15 ressources", 
	   Class_discussions:"Discussions de classe", 
	   recent_discussions:"Discussions récentes", 
	   go_to_class_discussions:"Aller aux discussions de classe", 	   
	   show_my_class_attendance:"Montrez ma présence à ma classe", 
	   add_section:"Ajouter une rubrique",
	   add_new:"Ajouter nouveau",
	   add_global_section:"Ajouter une section globale",
	   close_section:"Fermer les rubriques",
	   open_section:"Rubriques ouvertes",
	   batch_upload:"Téléchargement par lots",
	   finalize:"Finaliser",	   
	   download_to_excel:"Télécharger vers Excel",
	   download_to_pdf:"Télécharger au format PDF",
	   add_tearcger:"Ajouter des enseignants",
	   remove_tearcger:"Supprimer le(s) professeur(s)",
	   uploadSectionStatusUpdates:"Téléchargez les mises à jour de l'état de la section",
	   status_count:"Compte d'état",	   
	   reactivate:"Réactiver",
	   clone:"Cloner",
	   enroll_into_Section:"Inscrivez-vous à la section",
	   bulk_enrollment:"Inscription groupée",
	   general_Information:"Informations générales",	   
	   online_content_source:"Source de contenu en ligne",
	   second_teacher:"Deuxième professeur",
	   today:"aujourd'hui",
	   calendar:"Calendrier",
	   week:"la semaine",
	   month:"Mois",
	   section_progress:"Avancement de la section",
	   complete:"achevée",	   
	   section_title:"Section titre",
	   enter_section_title:"Entrez le titre de la section",
	   select_teacher:"Sélectionnez l'enseignant",	   
	   select_weeks:"Sélectionnez des semaines",
	   select_credits:"Sélectionnez les crédits",
	   select_type:"Sélectionner le genre",
	   global_section:"Section mondiale",	   
	   enrollment_capacity:"Capacité d'inscription",
	   enter_enrollment_capacity:"Entrez la capacité d'inscription",
	   in_class_information:"Dans les informations sur la classe",
	   show_all:"Afficher tout",
	   Start:"Commencer",
	   End:"Fin",
	   recurrencePattern:"Modèle de récurrence",
	   recurrenceFrequency:"Fréquence de récurrence",
	   Weekly:"Hebdomadaire",
	   Monthly:"Mensuel",
	   Recur_every:"Reproduire tous les",
	   Weeks_on:"Des semaines plus tard",
	   day_of_week:"Jour de la semaine",
	   daily_period:"Période quotidienne",
	   select_daily_period:"Sélectionnez la période quotidienne",
	   Day:"Jour",
	   The:"La",
	   of_every:"de chaque",
	   month_s:"mois) ",
	   add:"Ajouter",	   	  
	   course_prequisites:"Prérequis du cours",
	   select_status:"Sélectionnez le statut",
	   select_school:"Sélectionnez les écoles",	   
	   select_period:"Sélectionnez la période",
	    room_number:"Numéro de chambre",
	   select_room_number:"Sélectionnez Numéro de chambre",
	   Service:"Service",
	   enter_url:"Entrer l'URL",
	   edit_section:"Modifier la section",
	   activity_templates:"Modèles d'activité",
	   select_activity_templates:"Sélectionnez le modèle d'activité",
	   link_section:"Rubrique Lien",
	   select_link_section:"Sélectionnez la section du lien",
	   please_select_sections:"Veuillez sélectionner les rubriques.",
	   if_you_change_your_status_of_inactivity:"Si vous modifiez votre statut d'inactivité, l'étudiant sera affecté.",
	   closing_the_global_section_will_cause:"La fermeture de la section globale entraînera la fermeture de toutes les écoles et le retrait de tous leurs élèves. Veuillez cliquer sur Confirmer si vous souhaitez continuer.",
	   upload_import_data:"Télécharger et importer des données",
	   here:"Ici",	   
	   no_data_avalable_in_table:"aucune donnée disponible",
	   add_teacher_to_multiple_section:"Ajouter des enseignants à plusieurs sections",
	   select_teachers_to_add_to_multiple_section:"Sélectionnez les enseignants à ajouter à plusieurs sélections",
	   selected:"Choisi",
	   selected_all:"Tout sélectionner",
	   deselected_all:"Tout déselectionner",
	   remove_teacher_from_multiple_section:"Supprimer les enseignants de plusieurs sections",
	   select_teacher_to_remove_to:"Sélectionnez les enseignants à supprimer dans plusieurs sélections",
	   process_removal:"Processus de suppression",	   
	   clone_section:"Cloner la section",
	   enroll_student:"Inscrire l'étudiant",
 	   enroll_student_to:"Inscrire les étudiants à",
	   name:"Nom",	   
	   search_for_a_student_or_id:"Rechercher un étudiant ou une pièce d'identité…",
	   confirmation_of_enrollment:"CONFIRMATION D'INSCRIPTION",
	   please_review_and_confirm_enrollments_for:"Veuillez vérifier et confirmer les inscriptions pour",
	   confirm:"Confirmer",
	   enroll_students_to_section:"INSCRIVEZ LES ÉLÈVES À LA SECTION",
	   enrollment_period:"Période d'inscription",
	   days:"jours",
	   no_data_avalible:"Pas de données disponibles.",
	   number_of_primary_teacher:"Nombre d'enseignants du primaire",
	   secondary_teachers:"Enseignants du secondaire",
	   department_head:"Chef de département",
	   section_enroll:"Inscription à la section",
	   load_from_file:"Charger à partir du fichier",
	   see_sections:"Voir sections",
	   change_enrollment_status:"Modifier le statut d'inscription",
	   mentor_s:"Mentor (s)",
	   overdue_activities:"Activités en retard",
	   total_session_time_and_last_log:"Temps de session total et dernier journal",
	   course_name_on_transcript:"Nom du cours sur la transcription",
	   edit_other_grades:"Modifier d'autres notes",
	   save_as:"Enregistrer sous",
	   account_receivable_dashboard:"Tableau de tableau de bord à recevoir le compte",
	   key_performance_indicators:"Indicateurs de performance clés",
	   a_r_dashboard:"Tableau de bord A / R",
	   payments_credits:"Paiements / crédits",
	   contract_templates:"Modèles de contrat",
	   master_contracts:"Master Contracts",
	   a_r_configuration:"Configuration A / R",
	   a_r_processing:"Traitement A / R",
	   aging:"Vieillissement",
	   receivable:"Recevable",
	   account_receivable_by_program:"Compte à recevoir par programme",
	   request_detail:"Demander des détails",
	    request_information:"Informations requises",
	    requested_by:"Demandé par",
	    approved_by:"Approuvé par",
	    approve:"Approuver",
	    phone_name:"Nom de téléphone",
	    phone_carrier:"Support de téléphone",
		area_code:"Indicatif régional",
	   address_lable:"Adressez Lable",
	   address_default:"Adressez par défaut",
	   new_photo:"Nouvelle photo",
	   current_of_wweeks:"# Actuel des semaines",
	   select_enrollment_period:"Sélectionnez la période d'inscription",
	   enter_rejection_reason:"Entrez la raison de rejet ...",
	   comments_and_documents:"Commentaires et documents",
	   enrollment_history:"Histoire des inscriptions",
	   request_extension_for:"Demander une extension pour",
	   extended_of_weeks:"# Prolongé de semaines",
	   current_enrollment_status:"Statut d'inscription actuel",
	   select_extension_option:"Sélectionnez l'option d'extension",
	   extend_current_enrollment_until:"Prolonger l'inscription actuelle jusqu'à ce que",
	   transfer_to_new_section:"Transférer vers une nouvelle section",
	   transcript_requests:"Demandes de transcription",
	   person_requesting_transcript:"Personne demandant la transcription",
	   telephone_number:"Numéro de téléphone",
	   number_of_copies:"Nombre de copies",
	   special_instructions:"instructions spéciales",
	   last_school_attendance:"Dernière fréquentation scolaire",
	   year_last_attended:"L'année dernière",
	   current_address:"Adresse actuelle",
	   relationship_to_student:"Relation avec l'étudiant",
	   method_of_delivery:"Mode de livraison",
	   instructions:"*Instructions",
	   previous_requests:"Demandes précédentes",
	   additional_info:"Information additionnelle",
	   receive:"Recevoir",
	   process:"Processus",
	   add_to_school_group:"Ajouter au groupe scolaire",
	   submit_romote:"Soumettre la promotion",
	   next_grade_level:"Niveau prochain",
	   please_select_a_school_for_promotion_and_transfer:"Veuillez sélectionner une école de promotion et de transfert",
	   write_off:"Écrire",
	   amount_due:"Montant dû",
	   open_amount:"Montant ouvert",
	   payment_application:"Demande de paiement",
	   use_credit_openBalance:"Utiliser le crédit 111 $",
	   payment_amount_usd:"Montant de paiement (USD)",
	   check_number:"Numéro de vérification",
	   confirmation_number:"Numéro de confirmation",
	   apply_payment:"Appliquer le paiement",
	   amount_paid:"Le montant payé",
	   applied_payment:"Paiement appliqué",
	   payer_id:"Identifiant",
	   view_detail:"Voir les détails",
	   master_contract:"Contrat de maîtrise",
	   copy:"Copie",
	   contract_user_detail:"Détails des utilisateurs contractuels",
	   follow_product_cost:"Suivez le coût du produit",
	   default_cost:"Coût par défaut",
	   offered_cost:"Coût offert",
	   contract_detail:"Détail du contrat",
	   contract_template_name:"Nom du modèle de contrat",
	    master_contract_name:"Nom du contrat de maître",
		 view_students:"Voir les étudiants",
		 make_payment:"Effectuer le paiement",
		 parent_page:"Page parent",
		 edit_parent:"Modifier le parent",
		 edit_profile:"Editer le profil",
		 account_receivable_configuration:"Configuration de la créance du compte",
		 invoice_generation_date:"Date de génération de factures", 
	   invoice_generation:"Génération de factures", 
	   number_of_days_until_due_date:"Nombre de jours jusqu'à la date d'échéance",
	   account_receivable_processing:"Traitement des débiteurs",
	   generate_invoices:"Générer des factures", 
	   process_automatic_payments:"Traiter les paiements automatiques", 
	   send_late_notices:"Envoyer des avis tardifs", 
	   course:"Cours",
	   copy_courses:"Copier les cours", 
	   copy_to_school:"Copier à l'école", 
	   originating_program_code:"Code de programme d'origine", 
	   destinating_program_code:"Distination du code du programme", 
	   status_error:"État / erreur",
	   add_prerequisite:"Ajouter une condition préalable", 
	   group_name:"Nom de groupe", 
	   enter_group_name:"Entrez le nom du groupe", 
	   select_a_department_to_display_courses:"Sélectionnez un département pour afficher des cours", 
	   edit_tranferred_grades:"Modifier d'autres notes", 
	   showing_num_records:"Affichage 000 enregistrements",
	   edit_all_other_grades:"Modifier toutes les autres notes",
	   upload_student_documents:"Télécharger les documents des étudiants",
	   select_an_official_transcript_option:"Sélectionnez une option de transcription officielle", 
	   for_schools_or_personal_copy:"Pour les écoles ou la copie personnelle", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Pour l'usage des élèves, envoyez une autre école ou pour vérifier l'inscription.", 
	   request_official_transcript:"Demander la transcription officielle", 
	   PARCHMENT_for_colleges_or_universities:"Parchemin pour collèges ou universités", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Pour une demande à un collège / université et pour vérifier l'achèvement de votre diplôme.", 
	   request_transcript:"Demander la transcription", 
	   Learn_more_about_how_to_use_PARCHMENT:"En savoir plus sur la façon d'utiliser le parchemin",
	   print_PDF:"Imprimer PDF",
	   user_school:"École utilisateur",
	   filter:"Filtre",
	   GENERAL:"GÉNÉRAL", 
	   STUDENT_INFO:"Informations sur les étudiants", 
	   list:"Liste", 
	   last_school_name:"Dernier nom de l'école", 
	   TEACHER_INFO:"Informations sur les enseignants", 
	   contracted_load:"Charge contractée", 
	   ARENT_INFO:"Informations sur les parents",
	   add_credential:"Ajouter des pouvoirs",
	   edit_credential:"Modifier les informations d'identification",
	   add_comment_document:"Ajouter le commentaire et le document",
	   add_comment_document_for:"Ajouter un commentaire et un document pour",
	   state_province:"État / province", 
	   post_code:"Code postal", 
	   linking_students_to:"Lier les étudiants à", 
	   change_expiration_date:"Modifier la date d'expiration", 
	   expiry_date:"Date d'expiration", 
	   please_select_department:"Veuillez sélectionner le département.", 
	   please_select_course:"Veuillez sélectionner le cours.", 
	   please_select_title:"Veuillez entrer le titre.", 
	   please_select_primary_teacher:"Veuillez sélectionner le professeur primaire.", 
	   please_select_weeks:"Veuillez sélectionner des semaines.", 
	   please_select_level:"Veuillez sélectionner le niveau.", 
	   please_select_credits:"Veuillez sélectionner les crédits.", 
	   please_select_type:"Veuillez sélectionner le type.", 
	   please_select_daily_period:"Veuillez sélectionner la période quotidienne.",
	   please_enter_link_section:"Veuillez saisir la section des liens.",
	   please_enter_first_name:"Veuillez saisir le prénom.", 
	   please_enter_last_name:"Veuillez saisir le nom de famille.", 
	   please_enter_contracted:"Veuillez entrer sous contrat.", 
	   please_enter_email:"Veuillez saisir le courrier électronique.", 
	   please_enter_phone:"Veuillez saisir le téléphone.", 
	   please_enter_username:"Veuillez saisir le nom d'utilisateur.",
	   please_enter_password:"Veuillez entrer le mot de passe.", 
	   please_enter_status:"Veuillez sélectionner l'état.", 
	   save_successful:"Sauver succès!.",
	   please_add_student_address:"Veuillez ajouter l'adresse de l'élève.", 
	   please_enter_email_address:"Veuillez saisir l'adresse e-mail.", 
	   please_select_relationship:"Veuillez sélectionner la relation.", 
	   please_select_parent_status:"Veuillez sélectionner l'état du parent.", 
	   please_enter_label:"Veuillez entrer l'étiquette.", 
	   please_enter_address:"Veuillez saisir l'adresse.", 
	   please_enter_city:"Veuillez entrer la ville.", 
	   please_enter_state:"Veuillez saisir l'état.", 
	   please_enter_zip_code:"Veuillez saisir le code postal.", 
	   please_select_date_of_birth:"Veuillez sélectionner la date de naissance.", 
	   please_select_track:"Veuillez sélectionner la piste.", 
	   please_enter_graduation_date:"Veuillez saisir la date de remise des diplômes.", 
	   please_enter_country:"Veuillez entrer dans le pays.", 
	   please_enter_phone_number:"Veuillez saisir le numéro de téléphone.", 
	    please_enter_parent_first_name:"Veuillez saisir le prénom parent.", 
	   please_enter_parent_last_name:"Veuillez entrer le nom de famille des parents.", 
	   please_enter_parent_email_address:"Veuillez saisir l'adresse e-mail parent.", 
	   please_enter_parent_username:"Veuillez saisir le nom d'utilisateur parent.", 
	   please_select_parent_relationship:"Veuillez sélectionner la relation parent.", 
	   please_enter_phone_label:"Veuillez saisir l'étiquette du téléphone.", 
	   student_address_canot_be_empty:"L'adresse de l'élève ne peut pas être vide.", 
	   please_select_document_type:"Veuillez sélectionner le type de document.", 
	   please_enter_new_type:"Veuillez saisir un nouveau type.", 
	   please_enter_comment:"Veuillez saisir le commentaire.", 
	   link_is_not_a_valid_url:"Le lien n'est pas une URL valide.",
	   please_enter_link_and_label:"Veuillez saisir le lien et l'étiquette.",
	   are_you_sure_to_delete_this_student:"Êtes-vous sûr de supprimer cet étudiant.",
	   please_select_gender:"Veuillez sélectionner le sexe.",
	   school_contracted_load:"Charge contractée à l'école", 
	   global_contracted_load:"Charge contractuelle mondiale",
	   please_enter_label_for_attachments:"Veuillez saisir l'étiquette des pièces jointes.",
	   please_select_section:"Veuillez sélectionner la section.", 
	   enrollment_completed_successfully:"L'inscription s'est terminée avec succès.",
	   delete_this_comment:"Supprimer ce commentaire?",
	   please_enter_course_name:"Veuillez saisir le nom du cours.", 
	   please_select_credits_possible:"Veuillez sélectionner les crédits possibles.",
	   can_save_record:"Impossible d'enregistrer un enregistrement:",
	   are_you_sure_to_delete_this_tranferred_grade:"Êtes-vous sûr de supprimer ce grade transmissible?",
	   are_you_sure_to_delete_num_tranferred_grade:"Êtes-vous sûr de supprimer 11 grade transmissible?", 
	   please_select_tranferred_grade:"Veuillez sélectionner Tranferred Grade.",
	   please_ente_subject:"Veuillez saisir le sujet.", 
	   please_select_made_to:"Veuillez sélectionner fait à.", 
	   delete_this_communication:"Supprimer cette communication?",
	   please_select_school:"Veuillez sélectionner l'école.",
	   please_enter_name:"Veuillez saisir le nom.",
	   please_enter_group_name:"Veuillez saisir le nom du groupe.",
	   you_have_some_form_errors_please_check_above:"Vous avez quelques erreurs de formulaire. Veuillez vérifier ci-dessus.",
	   please_select_recipient:"Veuillez sélectionner le destinataire.", 
	   please_enter_description:"Veuillez saisir la description.",
	   delete_this_resource:"Supprimer cette ressource?",
	   please_enter_activity_name:"Veuillez saisir le nom de l'activité.", 
	   please_select_activity_type:"Veuillez sélectionner le type d'activité.", 
	   please_enter_max_score:"Veuillez saisir le score Max.", 
	   please_enter_due_date:"Veuillez saisir la date d'échéance.",
	   please_enter_unit_name:"Veuillez saisir le nom de l'unité.",
	   are_you_sure_to_clear_this_unit:"Êtes-vous sûr d'effacer cette unité?",
	   please_enter_score:"Veuillez saisir le score.",
	   delete_this_credential:"Supprimer ces informations d'identification?",
	   plase_select_period:"Veuillez sélectionner la période", 
	   plase_select_start_date:"Veuillez sélectionner la date de début", 
	   plase_select_end_date:"Veuillez sélectionner la date de fin",
	   select_to_register_course_to_students_individual_learning_path_view:"Sélectionnez pour enregistrer le cours aux étudiants Voir le chemin d'apprentissage individuel",
	   delete_this_request:"Supprimer cette demande?",
	   please_enter_fname:"Veuillez saisir le prénom.", 
	   please_enter_lname:"Veuillez saisir le nom de famille.", 
	   please_enter_birthday:"Veuillez entrer l'anniversaire.", 
	   please_enter_address:"Veuillez saisir l'adresse.", 
	   please_enter_zip:"Veuillez entrer Zip.", 
	   please_enter_country:"Veuillez entrer dans le pays.", 
	   please_enter_ethnicity:"Veuillez saisir l'origine ethnique.", 
	   please_enter_grade:"Veuillez saisir la note.", 
	   please_enter_mobile:"Veuillez entrer le mobile.", 
	   please_enter_hear_about_us:"Veuillez entendre parler de nous.", 
	   please_enter_program_of_interest:"Veuillez saisir le programme d'intérêt.", 
	   please_enter_course_level:"Veuillez saisir le niveau de cours.", 
	   please_enter_guardian_1_name:"Veuillez entrer le nom du Guardian 1.", 
	   please_enter_guardian_1_email:"Veuillez saisir un e-mail Guardian 1.", 
	   please_enter_guardian_1_home_phone:"Veuillez entrer le téléphone à domicile Guardian 1.", 
	   please_enter_guardian_1_relation:"Veuillez entrer la relation Guardian 1.",
	   please_select_parents:"Veuillez sélectionner les parents.",
	   transfer_classroom:"Transfert de classe", 
	   please_choose_one_section_to_transfer:"Veuillez choisir une section à transférer.", 
	   transfer:"Transfert",
	   assigning_multiple_users_to_a_school_or_school_group:"Attribuer plusieurs utilisateurs à une école ou à un groupe scolaire", 
	   add_to_school_or_school_group:"Ajouter à l'école ou au groupe scolaire", 
	   please_select_school_or_school_group:"Veuillez sélectionner l'école ou le groupe scolaire.",
	   print_student_progress_report:"Rapport d'avancement des étudiants imprimé",
 },
 it: {
	   reporting_center:"Centro di reporting", 
	   grade_reports:"Rapporti di grado", 
	   user_reports:"Rapporti sugli utenti", 
	   learning_reports:"Rapporti di apprendimento", 
	   administrative_reports:"Rapporti amministrativi", 
	   progress_report:"Rapporto sui progressi", 
	   full_progress_report:"Rapporto sullo stato di avanzamento completo", 
	   grade_report:"Rapporto di grado", 
	   roster_report:"Rapporto del roster", 
	   parent_report:"Rapporto dei genitori", 
	   teacher_report:"Rapporto dell'insegnante", 
	   student_report:"Rapporto degli studenti", 
	   log_in_report:"Accedi Report", 
	   enrollmentreport:"Rapporto di iscrizione", 
	   enrollment_summary:"Riepilogo delle iscrizioni", 
	   student_enrollment_summary:"Riepilogo dell'iscrizione agli studenti", 
	   attendance_report:"Rapporto di partecipazione", 
	   attendance_summary_report:"Rapporto di riepilogo delle presenze", 
	   log_In_Credentials:"Credenziali di accesso", 
	   application_report:"Rapporto sull'applicazione", 
	   section_report:"Rapporto di sezione", 
	   course_report:"Rapporto sul corso", 
	   communication_summary:"Riepilogo della comunicazione", 
	   comments_and_Document_Report:"Commenti e rapporto sui documenti", 
	   School_Calendar:"Calendario scolastico", 
	   bell_Schedule:"Programma della campana", 
	   student_Contract:"Contratto studentesco",
	   eOS_Report:"Rapporto EOS", 
	   active_Enrollments_Per_Term_Report:"Iscrizioni attive per termine Rapporto", 
	   active_Student_Enrollments_with_As_Report:"Iscrizioni attivo degli studenti con AS Report", 
	   active_Student_Enrollments_Report:"Rapporto di iscrizione agli studenti attivi", 
	   all_Students_GPA_Report:"Tutti gli studenti Rapporto GPA", 
	   old_All_Student_GPA_Report:"Rapporto GPA di Old All Student", 
	   billingGroup_Engagement_Type_Report:"Rapporto di tipo di coinvolgimento BillingGroup +", 
	   enrollment_Confirmation_Report:"Rapporto di conferma delle iscrizioni", 
	   eOS_College_Matriculations_Report:"Rapporto sulle immatricolazioni del college EOS", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Cronologia delle iscrizioni degli studenti fino ad oggi W Rapporto del termine",
	   student_Information_Report:"Rapporto sulle informazioni degli studenti", 
	   ran_by:"corse da",
	   Show_Filter:"Show Filter", 
	   School_Group:"Gruppo scolastico", 
	   school:"Scuola", 
	   department:"Dipartimento", 
	   student:"Alunno", 
	   student_status:"Stato dello studente", 
	   course:"Corso", 
	   course_level:"Livello del corso", 
	   section:"Sezione", 
	   teacher:"Insegnante", 
	   primary_teacher:"Insegnante primario", 
	   secondary_teacher:"Insegnante secondario", 
	   completion_Date_Range:"Intervallo di data di completamento", 
	   from_date:"Di data", 
	   to_date:"Ad oggi", 
	   status:"Stato", 
	   gender:"Genere", 
	   final_grade:"Voto finale", 
	   advisor:"Consulente", 
	   grade_level:"Livello", 
	   specific_mark:"Marchio specifico", 
	   track:"Traccia", 
	   ethnicity:"Etnia", 
	   additional_fields:"Campi aggiuntivi", 
	   school_sessions:"Sessioni scolastiche", 
	   gradebook:"Gradebook", 
	   submit:"Invia", 
	   reset:"Ripristina", 
	   show_hide_columns:"Mostra/nascondi colonne", 
	   select_all:"Seleziona tutto", 
	   student_id:"ID studente", 
	   last_name:"Cognome", 
	   first_name:"Nome di battesimo", 
	   grade_level:"Livello", 
	   start_date:"Data d'inizio", 
	   end_date:"Data di fine", 
	   grade_final:"Final di grado", 
	   percent:"Per cento", 
	   credit:"Credito", 
	   download_excel:"Scarica Excel", 
	   print:"Stampa", 
	   no_data:"Nessun dato.", 
	   view:"Visualizzazione", 
	   showing:"Mostrando", 
	   of:"Di", 
	   other_grade:"Altro grado", 
	   level:"Livello", 
	   date:"Data", 
	   grade:"Grado",
	   enrollment_Change_Status:"Lo stato di modifica delle iscrizioni", 
	   close:"Vicino", 
	   select_Enrollment_Status:"Selezionare lo stato di iscrizione", 
	   select:"Selezionare...", 
	   cancel:"Annulla", 
	   save:"Salva", 
	   students:"Studenti", 
	   Course_Status:"Stato del corso", 
	   Closed_courses:"Corsi chiusi", 
	   Section_Status:"Stato della sezione", 
	   Closed_sections:"Sezioni chiuse", 
	   Transferred_From:"Trasferito da",
	   Graduation_From_Date:"Laurea dalla data", 
	   Graduation_To_Date:"Laurea fino ad oggi", 
	   Enrollment_From_Date:"Iscrizione dalla data", 
	   Enrollment_To_Date:"Iscrizione fino ad oggi", 
	   Enrollment_Status:"Stato di iscrizione", 
	   Transfer_From_Date:"Trasferimento dalla data", 
	   Transfer_To_Date:"Trasferimento fino ad oggi", 
	   Custom_Query:"Query personalizzata", 
	   Last_Access_Date:"Ultima data di accesso", 
	   Total_Session_Time:"Tempo totale di sessione", 
	   Quality_of_Work:"Qualità del lavoro", 
	   Grade_to_Date:"Grado fino ad oggi", 
	   Overall_Percent:"Percentuale complessiva", 
	   On_Schedule_Percent:"Nell'assegna percentuale", 
	   Activity_Count_Complete:"Conteggio delle attività completo", 
	   Activity_Count_Total:"Conteggio delle attività totali", 
	   Overdue_Activitie:"Attizie in ritardo",
	   Section_Course_Additional_Fields:"Sezione/corso campi aggiuntivi", 
	   Create_On_Date:"Crea alla data", 
	   Last_Status_Update_Date:"Ultima data di aggiornamento dello stato", 
	   Transferred_In:"Trasferito in", 
	   Transferred_In_Date:"Trasferito in data", 
	   email:"E-mail", 
	   birth_date:"Data di nascita", 
	   course_name:"Nome del corso", 
	   section_name:"Nome della sezione", 
	   school_name:"Nome della scuola", 
	   Graduation_Date:"Data di laurea", 
	   Created_on:"Creato", 
	   mentor_Advisor:"Mentore/consulente",
	   sections:"Sezioni", 
	   roster:"Elenco", 
	   relationship:"Relazione", 
	   Email_or_Phone:"Email o telefono", 
	   Enter_any_text:"Immettere qualsiasi testo", 
	   Advisor_Success_Manager:"Advisor / Success Manager", 
	   User_Id:"ID utente", 
	   phone_number:"Numero di telefono", 
	   Student_Last_Name:"Cognome dello studente", 
	   Student_First_Name:"Nome studente", 
	   Student_Email:"Email degli studenti",
	   credentials:"Credenziali", 
	   availability:"Disponibilità",
	   enrollments:"Iscrizioni", 
	   Datea_Created_on:"Data creata su",
	   country:"Paese", 
	   state:"Stato", 
	   zipcode:"Cap", 
	   Enter_any_zipcode:"Immettere qualsiasi zipcode", 
	   address:"Indirizzo",
	   zip_Code:"Cap",
	   Login_Report:"Rapporto di accesso", 
	   user_Type:"Tipologia di utente", 
	   user_Name:"Nome utente", 
	   Show_last_log_in_only:"Mostra solo l'ultimo accesso", 
	   Username:"Nome utente", 
	   Date_Time:"Appuntamento", 
	   Ip_Address:"Indirizzo IP", 
	   city:"Città",
	   Enrollment_Start_Date:"Data di inizio dell'iscrizione", 
	   Enrollment_End_Date:"Data di fine dell'iscrizione", 
	   Completion_Date:"data di completamento", 
	   section_Type:"Tipo di sezione", 
	   student_Enrolled:"Studente iscritto", 
	   content_Provider:"Fornitore di contenuti", 
	   student_Additional_Fields:"Studente Field aggiuntivi",
	   type:"Tipo", 
	   in_Class_Information:"Nelle informazioni sulla classe",
	   Enrollment_Summary_Report:"Rapporto di riepilogo delle iscrizioni", 
	   Transferred_From_School:"Trasferito da scuola",
	   Total_Enrollments:"Iscrizioni totali", 
	   content_Type:"Tipo di contenuto", 
	   active_Course_Progress:"Progressi del corso attivo",
	   Grades:"gradi", 
	   attendance:"Presenza",
	   student_Absences:"Assenze per studenti", 
	   total_Absence:"Assenza totale", 
	   section_Absences:"Assenze di sezione",
	   Grade_Level_Absences:"Assenze di livello elementare",
	   Gender_Absences:"Assenze di genere",
	   Login_credentials:"Credenziali di accesso", 
	   names:"Nomi", 
	   user_status_admin_teacher_parent:"Stato dell'utente (amministratore, insegnante, genitore)", 
	   show_title:"Mostra titolo", 
	   midle_name:"Secondo nome", 
	   password:"Parola d'ordine", 
	   parent_name:"Nome del genitore", 
	   linked_to_parent:"Collegato al genitore", 
	   linked_to_student:"Collegato allo studente",
	   login_credentials_Report:"Rapporto sulle credenziali di accesso", 
	   app_id:"APP ID", 
	   created:"Creato", 
	   modified:"Modificata",
	   select_level:"Seleziona livello", 
	   select_additional_fields:"Sezione campi aggiuntivi", 
	   title:"Titolo", 
	   credits:"Crediti", 
	   section_ID:"ID sezione", 
	   content:"Contenuto", 
	   course_additional_fields:"Corso campi aggiuntivi",
	   course_id:"Id del corso", 
	   communication_summary_report:"Rapporto di riepilogo della comunicazione", 
	   method:"Metodo", 
	   create_date:"Crea data", 
	   subject:"Soggetto", 
	   make_from_id:"Fare da id", 
	   make_to:"Fare a", 
	   attachments:"Allegati", 
	   comment_and_document_summary_report:"Rapporto di riepilogo dei commenti e dei documenti", 
	   comment_type:"Tipo di commento", 
	   flagged:"Segnalato", 
	   sharing_target:"Condivisione di obiettivi", 
	   show_on_transcript:"Mostra sulla trascrizione", 
	   by:"Di", 
	   comment:"Commento", 
	   type_name:"Nome del tipo", 
	   effective_from_date:"In vigore dalla data", 
	   effective_to_date:"Fino ad oggi", 
	   count_docs:"Contare i documenti",
	   school_calendar_report:"Rapporto sul calendario scolastico", 
	   event_Id:"ID evento", 
	   date_start:"Data di inizio", 
	   date_end:"Fine della data", 
	   posted_last_name:"Postato cognome", 
	   posted_first_name:"Nome pubblicato",
	   bell_schedule_report:"Rapporto sulla pianificazione delle campane", 
	   period:"Periodo", 
	   start:"Inizio", 
	   end:"FINE",
	   student_contract_report:"Rapporto sul contratto degli studenti", 
	   begin_date:"Inizia la data", 
	   contracts:"Contratti", 
	   contract_name:"Nome del contratto", 
	   contract_begin_date:"Data di inizio del contratto", 
	   contract_end_date:"Data di fine del contratto",
	   active_enrollments_per_term_report:"Iscrizioni attive per termine Rapporto", 
	   entry_date:"Data di ingresso", 
	   teachers:"Insegnanti", 
	   term:"Termine", 
	   sections:"Sezioni",
	   showing_of:"Mostrando 10 su 20",
	   filter:"Filtro",
	   students:"Studenti",
	   school:"scuola",
	   all_school:"Tutte le scuole",
	   student:"Alunno",
	   email:"E-mail",
	   grade_level:"Livello",
	   status:"Stato",
	   seach_for_a_student_or_id:"Cerca uno studente o un documento d'identità...",
	   search:"Ricerca …",
	   message_student:"Messaggio studente",
	   request_enrollment:"Richiesta di iscrizione",
	   print_schedule:"Stampa programma",
	   view:"Visualizzazione",
	   no_data:"Nessun dato.",
	   views:"Visualizzazioni", 
	   enrollment:"Iscrizione", 
	   schedule:"Programma", 
	   transferred_grades:"Gradi trasferiti", 
	   comments_ocuments:"Commenti e documenti", 
	   academic_records:"Registri accademici", 
	   compliance_log:"Registro di conformità", 
	   unofficial_transcript:"Trascrizione non ufficiale", 
	   iD_card:"Carta d'identità", 
	   student_number_id_information:"Numero studente #29561 Informazioni", 
	   student_number:"Numero studente", 
	   gender:"Genere", 
	   goes_by:"Passa", 
	   date_of_birth:"Data di nascita", 
	   ethnicity:"Etnia", 
	   mobile:"Mobile", 
	   academic_track:"Pista accademica", 
	   learning_path_template:"Modello di percorso di apprendimento", 
	   graduation_date:"Data di laurea", 
	   comments:"Commenti", 
	   transfer_information:"Informazioni sul trasferimento", 
	   enrollment_date:"Data di iscrizione", 
	   transfer_date:"Data di trasferimento", 
	   transfer_student:"Studente di trasferimento", 
	   parent_mentor_contact:"Contatto genitore / mentore", 
	   mentor:"Mentore", 
	   parent_phone:"Telefono dei genitori", 
	   emergency_contact:"Contatto di emergenza", 
	   academic_advisor_ssm:"Consulente accademico / SSM", 
	   student_success_manager:"Responsabile del successo degli studenti", 
	   academic_avisor:"Consulente accademico", 
	   address:"Indirizzo", 
	   address_01_Default:"Indirizzo 01 (predefinito)", 
	   street:"Strada", 
	   city:"Città", 
	   state:"Stato", 
	   zip:"Cerniera lampo", 
	   hide_Detailed_information:"Nascondi informazioni dettagliate", 	    
	   current_course_progress:"Avanzamento del corso attuale", 	    
	   full_Path_Progress:"Avanzamento completo del percorso", 	    
	   print:"Stampa", 	    
	   avg_graduation_progress:"media Progresso di laurea", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Stato di laurea", 	    
	   on_track:"In pista",
	   show_detailed_information:"Mostra informazioni dettagliate",
	   communication:"Comunicazione",
		student_advisors:"Consulenti per gli studenti", 	    
	   country:"Paese", 	    
	   grade:"Grado", 	    
	   credits:"Crediti", 	    
	   sort:"Ordinare", 	    
	   course_progress:"Avanzamento del corso",
	   overall_GPA:"GPA globale",
	    current_graduation_progress:"Avanzamento di laurea in corso",
		individual_course_progress:"*Il progresso individuale del corso varia, questo è il tuo progresso generale", 
		subject:"Materia",
		 online_sections:"Sezioni online",
	   course:"Corso", 
	   section:"Sezione", 
	   actions:"Azioni", 
	   view_event:"Visualizza l'evento",
	   in_class_section:"Nella sezione di classe",
	   calendar:"Calendario",
	   access_link:"Link di accesso", 
	   online_link:"Link online",
		launch_course:"Corso di lancio", 
	   start_class:"Classe iniziale",
	   level:"Livello", 
	   date:"Data", 
	   transferred_in:"Trasferito in",
	   tranferred_grades:"Gradi trasferiti",
	   Searchs:"Ricerca", 
	   Search_department_course:"Cerca dipartimento corso, src...",
	   archived:"Archiviato", 
	   add_comment:"Aggiungi un commento", 
	   created_date:"Data di Creazione", 
	   by:"Di", 
	   type:"Tipo", 
	   comment:"Commento", 
	   from_date:"Dalla data", 
	   to_date:"Ad oggi", 
	   documents:"Documenti", 
	   edit:"Modificare", 
	   delete:"Elimina",
	   communications:"Comunicazioni", 
	   add_communications:"Aggiungi comunicazione", 
	   made_from:"Fatto di", 
	   made_to:"Fatto da", 
	   means:"Significa", 
	   attachments:"Allegati", 
	   content:"Contenuto",
	   compliance_logs:"Registri di conformità", 
	   messageID:"ID messaggio", 
	   agree:"Concordare", 
	   dateTime:"Appuntamento", 
	   iPAddress:"Indirizzo IP", 
	   add_idit_comment_document:"Aggiungi/Modifica commento e documento", 
	   document_type:"Tipo di documento", 
	   show_on_transcript:"Mostra su trascrizione", 
	   select_users_to:"Seleziona gli utenti per", 
	   teacher:"Insegnante", 
	   parent:"Genitore", 
	   flag:"Bandiera", 
	   none:"Nessuno", 
	   link:"Collegamento", 
	   label:"Etichetta", 
	   add_more_link:"Aggiungi altro collegamento", 
	   save:"Salva", 
	   add_edit_communication:"Aggiungi/Modifica comunicazione", 
	   made_by:"Fatto da", 
	   date_time:"Appuntamento", 
	   length:"Lunghezza", 
	   select:"Selezionare", 
	   select_users_to_view:"Seleziona gli utenti per visualizzare la comunicazione", 
	   add_more:"Aggiungere altro", 
	   communication_summary:"Riepilogo comunicazione",
	   close:"Chiudere",
	   new_type:"Nuovo tipo",
	   select_user_to_view_comment:"Seleziona gli utenti per visualizzare il commento",
	   flag_comment:"Segnala commento",
	   teacher_page:"Pagina dell'insegnante",
	   edit_information:"Modifica informazioni",
	   phone:"Telefono",
	   add_credential:"Aggiungi credenziali",
	   add_edit_credential:"Aggiungi/modifica credenziali",
	   first_name:"Nome di battesimo",
	   midle_name:"Secondo nome",
	   last_name:"Cognome",
	   cancel:"Annulla",
	   add_new:"Aggiungere nuova",
	   phone_type:"Tipo di telefono",
	   zipCode:"Cap",
	   phone_number:"Numero di telefono",
	   default:"Predefinita",
	   please_select_country:"Seleziona Paese",
	   student_information:"Informazioni sugli studenti",
	   username:"Nome utente",
	   user_directory:"Elenco utenti",
	   add_teacher:"Aggiungi Insegnante",
	   add_admin:"Aggiungi amministratore",
	   export_to_excel:"Esportare in Excel",
	   export_to_pdf:"Esporta in PDF",
	   send_login_credentials:"Invia credenziali di accesso",
	   search_for_a_user_or_id:"Cerca un utente o un ID...",
	   user:"Utente",
	   school_admin:"Amministratore Scolastico",
	   change_password:"Cambia la password",
	   set_password_expiration_date:"Imposta la data di scadenza della password",
	   impersonate_user:"Impersona utente",
	   edit_user_tags:"Modifica i tag utente",
	   add_or_edit_users_schoo_assign:"Aggiungi o modifica gli utenti assegnati alla scuola",
	   assign_content_access:"Assegna l'accesso ai contenuti",
	   add_student:"Aggiungi studente",
	   add_parent_mentor:"Aggiungi genitore / mentore",
	   showing:"Mostrando",
	   of:"di",
	   school_name:"Nome della scuola",
	   edit_user_school_tags:"Modifica i tag della scuola dell'utente",
	   personal_information:"Informazione personale",
	   contacted_load:"Carico contattato",
	   maximum_of_active_students:"Numero massimo di studenti attivi",
	   teacher_since:"Insegnante da",
	   login_infomation:"Informazioni di accesso",
	   username:"Nome utente",
	   password :"Parola d'ordine",
	   avatar :"Avatar",
	   teachers :"Insegnanti",
	   change_status :"Cambiare stato",
	   add_admin:"Aggiungi amministratore",
	   name:"Nome",
	   create_on:"Crea il",
	   registrar:"Cancelliere",
	   birthday:"Compleanno",
	   signature:"Firma",
	   photo:"Foto",
	   designated_registrar:"Cancelliere designato",
	   track:"Traccia",
	   select_existing_track:"Seleziona traccia esistente",
	   available:"Disponibile",
	   parent_mentor:"Genitore/mentore",
	   relationship:"Relazione",
	   email_address:"Indirizzo e-mail",
	   academic_mentor:"Mentore accademico",
	   no_data_available_in_table:"Nessun dato disponibile nella tabella",
	   primary_language:"Lingua madre",
	   add_into_parent_or_mentor:"Aggiungi in Genitore / Mentore",
	   add_into_phone:"Aggiungi al telefono",
	   add_into_address:"Aggiungi in indirizzo",
	   select_one:"Selezionane uno",
	   login:"Login",
	   plese_select_country:"Si prega di scegliere il paese",
	   edit_student:"Modifica studente",
	   academic_advisor_or_student_success_manager:"Consulente accademico / Responsabile del successo degli studenti",
	   role:"Ruolo",
	   link_parent:"Collegamento genitore",
	   link_advisor_sms:"Link Advisor/SSM",
	   save_into_parent_mentor:"Salva in Genitore/Mentore",
	   save_into_parent_phone:"Salva nel telefono",
	   save_into_parent_address:"Salva in indirizzo",
	   bulk_information_update:"Aggiornamento delle informazioni di massa",
	   enrollments:"Iscrizioni",
	   email_student:"E-mail Studente",
	   unofficial_transcripts:"Trascrizioni non ufficiali",
	   official_transcripts:"Trascrizioni ufficiali",
	   email_students_schedule:"E-mail programma dello studente",
	   export_students_to_excel:"Esporta gli studenti in Excel",
	   export_parent_list_to_excel:"Esporta l'elenco dei genitori in Excel",
	   assign_learning_path_template:"Assegna modello di percorso di apprendimento",
	   promote_student_to_the_next_grade_level:"Promuovere lo studente al livello successivo",
	   batch_upload_students:"Caricamento in batch degli studenti",
	   batch_upload_transfer_grades:"Gradi di trasferimento caricamento in batch",
	   transfer_apex_only:"Trasferimento (solo APEX)",
	   transfer_content_providers:"Trasferimento (tutti i fornitori di contenuti)",
	   batch_enrollments:"Iscrizioni batch",
	   send_message:"Invia messaggio",
	   impersonate:"Impersonare",
	   change_login_credentials:"Modifica credenziali di accesso",
	   request_enrollment:"Richiesta di iscrizione",
	   send_weekly_status_report:"Invia rapporto di stato settimanale",
	   please_select_student:"Seleziona gli studenti.",	   
	   student_status_will_be_changed_to_status_withdraw:"Lo stato dello studente verrà modificato in 111 e tutte le iscrizioni verranno ritirate. Sei sicuro di voler continuare?",
	   student_status_will_be_changed_to_status:"Lo stato dello studente verrà cambiato in 111. Sei sicuro di voler continuare?",
	   value:"Valore",
	   student_success_manager_or_acdemic:"Student Success Manager / Academic Advisor",
	   enroll_students_to_section:"Iscrivi agli studenti alla sezione",
	   department:"Dipartimento",
	   refresh:"ricaricare",
	   select_department:"Seleziona il dipartimento",
	   select_course:"Seleziona il corso",
	   select_section:"Selezionare la sezione",
	   start_date:"Data d'inizio",
	   end_date:"Data di fine",
	   ID:"ID",
	   action:"Azione",
	   enrollment_period:"Periodo di iscrizione",
	   select_a_course_to_register_ilp:"Seleziona un corso per registrare ILP",
	   period:"Periodo",
	   credit:"Credito",
	   year:"Anno",
	   enroll:"Iscriversi",
	   recipient_transcript:"Trascrizione del destinatario",
	   select_all_or_unselect_all:"Seleziona tutto / non selezionato tutto",
	   include_in_progress_sections:"Includi le sezioni di avanzamento",
	   show_satisfaction_of_program:"Mostra soddisfazione del programma",
	   show_total_credit:"Mostra crediti totali",
	   show_student_info:"Mostra le informazioni sullo studente",
	   show_academic_info:"Mostra informazioni accademiche",
	   show_school_names_from_orther_grades:"Mostra nomi delle scuole da altri voti",
	   show_school_contact:"Mostra il contatto scolastico",
	   include_transferred_grades_in_gpa:"Includere i voti trasferiti in GPA",
	   include_in_progress_grade:"Includi il grado in progresso",
	   include_grade_scales:"Includere scale di grado",
	   show_graduation_date:"Mostra la data di laurea",
	   show_weighted_gpa:"Mostra GPA ponderato",
	   show_grade_level_gpa:"Mostra GPA di livello elementare",
	   show_comletion_date:"Mostra la data di completamento",
	   show_withdraw_classes:"Mostra le classi ritirate",
	   show_withdraw_date:"Mostra la data ritirata",
	   show_transfered_in_classes:"Mostra trasferito in classi",
	   show_digital_seal:"Mostra sigillo digitale",
	   show_singnature:"Mostra la firma",
	   group_by:"Raggruppa per",
	   school_year:"Anno scolastico",
	   school_level:"Livello scolastico",
	   notes:"Appunti",
	   ok:"OK",
	   are_you_sure_to_send:"Sei sicuro di inviare?",
	   assign_learning_path_templete:"Assegna il modello di percorso di apprendimento",
	   assign_student_to_selected_learning:"Assegna lo studente al modello di percorso di apprendimento selezionato",
	   assign:"Assegnare",
	   are_you_sure_to_promote_to_level:"Sei sicuro di promuovere al livello successivo?",
	   data_process:"Processo di dati",
	   upload_and_import_data:"Carica e importazioni di importazione",
	   download_user_information:"Scarica le informazioni dell'utente",
	   here:"qui",
	   select_student_upload_file:"",
	   local_drive:"",
	   the_file_is_uploaded:"",
	   template_name:"",
	   Here:"",
	   sample_file_excel:"File di esempio Excel.",
	   file_type:"Tipo di file",
	   delimited:"Delimitato",
	   delimited_chars:"Carattere delimitati",
	   fixed_width:"Larghezza fissa",
	   first_line_header:"Testa di prima linea",
	   loader_field:"Campo di carico",
	   Header:"Intestazione",
	   sample_data:"Dati di esempio",
	   column_width:"Larghezza di Colunm",
	   save_tamplate:"Salva modello",
	   save_and_upload_data:"Salva e carica i dati",
	   result:"Risultato",
	   upload_and_import_data_orther_grade:"Carica e importazioni di importazione Altri voti",
	   select_upload_file:"Seleziona il file di upload",
	   student_id:"ID studente",
	   uploadAnd_import_data_enrollment:"Carica e importazione dell'iscrizione dati",
	   section_id:"ID sezione",
	   title:"Titolo",
	   recipient:"Destinatario",
	   same_current_address:"Come l'indirizzo attuale",
	   add_more_reciptient:"Aggiungi più destinatario",
	   issuse_date:"Data di emissione",
	   show_total_unapplied_credits:"Mostra crediti totali non applicati",
	   reconcile_another_student_record:"Riconciliare con un altro record di studenti",
	   please_choose_one_student_to_reconcile:"Scegli uno studente per riconciliare.",
	   yes:"SÌ",
	   no:"NO",
	   apex_classroom_sync:"Apex Classroom Sync",
	   next:"Prossimo",
	   apex_classrooms:"Classe Apex",
	   online_user_id:"ID utente online",
	   enter_online_user_id:"Inserisci l'ID utente online",
	   online_section_id:"ID sezione online",
	   online_section_name:"Nome della sezione online",
	   online_course_name:"Nome del corso online",
	   enrollment_date:"Data di iscrizione",
	   back:"Indietro",
	   import:"Importare",
	   offical_transcipt:"Trascrizione ufficiale",
	   email_schedule:"Programma e -mail",
	   reconcile_with_another_records:"Riconciliare con un altro record",
	   online_sync_and_update:"Sincronizzazione e aggiornamento dei progressi online",
	   download_all_completion_cretification:"Scarica tutta la certificazione di completamento",
	   orther_grade:"Altri voti",
	   medical:"Medico",
	   comments_and_documents:"Commenti e documenti",
	   contracts:"Contratti",
	   invoices:"Fatture",
	   audit_logs:"Registri di audit",
	   edit_logs:"Modifica registri",
	   grade_to_date:"Grado fino ad oggi",
	   quality_of_work:"Qualità del lavoro",
	   last_access:"Ultimo accesso",
	   gradebook:"Gradebook",
	   transfer:"Trasferimento",
	   completion_certification:"Certificazione di completamento",
	   tranfer_user_school:"Trasferisci la scuola degli utenti",
	   tranfer_to_school:"Trasferirsi a scuola",
	   tranfer_apex_classrooms:"Trasferisci le aule apice",
	   course_to_moved:"Corso per trasferirsi",
	   current_teacher:"Insegnante attuale",
	   future_section:"Sezione futura",
	   future_program:"Programma futuro",
	   future_teacher:"Insegnante futuro",
	   enrollment_start_date_end_date:"Data di inizio dell'iscrizione - Data di fine",
	   no_more_option:"Niente più opzioni",
	   create_new:"creare nuovo",
	   transfer_classrooms:"Trasferisci le aule",
	   tyler_synchronization_for_az_school:"Sincronizzazione Tyler per le scuole AZ",
	   synchronize:"Sincronizzare",
	   individual_course_progress_varies:"Il progresso individuale del corso varia. Questo è il tuo progresso complessivo verso la laurea.",
	   edit_ilp:"Modifica ILP",
	   add_academic_record:"Aggiungi record accademico",
	   edit_all_records:"Modifica tutti i record",
	   search_corse_department_src:"Cerca corso, dipartimento, SRC ...",
	   message_id:"Messaggio ID",
	   add_new_contract:"Aggiungi nuovo contratto",
	   contract_id:"ID a contratto",
	   contract_name:"Nome del contratto",
	   first_date:"Primo appuntamento",
	   last_date:"Ultimo appuntamento",
	   amount_per_period:"Importo per periodo",
	   terminating_status:"Stato terminale",
	    payment_history:"Storico dei pagamenti",
	   record_payment:"Record pagamento",
	   payment_method:"Metodo di pagamento",
	   invoice_id:"codice di identificazione della fattura",
	   show_all:"Mostra tutto",
	   invoice_date:"Data fattura",
	   from:"Da…",
	   to:"A…",
	   amount:"Quantità",
	   paid:"Pagato",
	   due:"Dovuto",
	   date_paid:"Data pagata",
	   apply_payments:"Applicare pagamenti",
	   mark_as_paid:"Segna come pagato",
	   void:"Vuoto",
	   audit_log:"Registro di audizione",
	   object:"Oggetto",
	   changes_made:"Modifiche apportate",
	   create_time:"Creare tempo",
	   time_stamp:"Timestamp",
	   user_creare:"L'utente crea",
	   edit_log:"Modifica registro",
	   field_name:"Nome campo",
	   old_value:"Vecchio valore",
	   new_value:"Nuovo valore",
	   date_time_update:"Aggiornamento data/ora",
	   updater:"Aggiornamento",
	   add_edit_academic_records:"Aggiungi/modifica il record accademico",
	   select_flag:"Seleziona Flag ...",
	   edit_all_tranferred_grades:"Modifica tutti i voti transerati",
	   save_records:"Salva i record",
	   possible_credits:"Possibili crediti",
	   select_level:"Seleziona livello",
	   select_grade_level:"Seleziona il livello di grado",
	   select_status:"Seleziona Stato",
	   add_more_row:"Aggiungi più riga",
	   full_screen:"A schermo intero",
	   course_code:"Aggiungi altri voti",
	   add_order_grades:"Codice del corso",
	   select_credit:"Seleziona credito",
	   select_default:"Seleziona predefinito",
	   credits_possible:"Crediti possibili",
	   select_possible_credit:"Seleziona possibile credito",
	   product:"Prodotto",
	   fromn:"Da",
	   ton:"A",
	   last_invoice_date:"Ultima data di fattura",
	   please_select_stu:"Seleziona Studente",
	   payer:"Pagatore",
	   amount_per_billing_period:"Importo per periodo di fatturazione",
	   price_unit:"Prezzo unitario",
	   billing_period:"Periodo di fatturazione",
	   automatic_renewal:"Rinnovo automatico",
	   automatic_payment:"Fatturazione automatica",
	   duration_of_period:"Durata (# di periodi)",
	   payment_id:"ID di pagamento",
	   payment_date:"Data di pagamento",
	   payment_amount:"Importo del pagamento",
	   applied:"Applicato",
	   available:"Disponibile",
	   unApply:"Non applicazione",
	   refund:"Rimborso",
	   add_new_teacher:"Aggiungi un nuovo insegnante",
	   change_teacher_status:"Cambia lo stato dell'insegnante",
	   search_for_a_teacher_or_id:"Cerca un insegnante o un ID ...",
	   flags:"Bandiere",
	   tags:"Tag",
	   allowed:"Consentito",
	   message_teacher:"Insegnante di messaggi",
	   impersonate_teacher:"Impersonare l'insegnante",
	   add_teacher_qualification:"Aggiungi la qualifica dell'insegnante",
	   profile:"Profilo",
	   teacher_schedule:"Programma degli insegnanti",
	   qualifications:"Titoli di studio",
	   student_actions:"Azioni degli studenti",
	   linking_parents_to:"Collegare i genitori a",
	   select_do:"Selezionare ...",
	   see_edit_logs:"Vedi i registri di modifica",
	   see_qualifications:"Vedi qualifiche",
	   link_academic_advisor:"Link Academic Advisor",
	   student_success:"Successo degli studenti",
	   linking_academic_advisor_or_student_success:"Collegamento del consulente accademico / successo degli studenti a",
	   staff:"Personale",
	   teacher_status:"Stato dell'insegnante",
	   school_admin_status:"Stato dell'amministratore scolastico",
	   global_user_directory:"Directory dell'utente globale",
	   edit_teacher:"Modifica insegnante",
	   contracted:"Contratto",
	   add_comments_and_documents:"Commenti e documenti",
	   edit_comments_and_documents:"Modifica commenti e documenti",
	   parents_or_mentor:"Genitori / mentore",
	   send_mail:"Inviare una mail",
	   are_you_sure_to_delete_this_teacher:"Sei sicuro di eliminare questo insegnante.",
	   edit_user_password:"Modifica nome utente e password",
	   add_qualifications:"Aggiungi qualifiche",
	   please_select_a_least_on_teacher:"Seleziona almeno un insegnante.",
	   edit_parent_mentor:"Modifica genitore / mentore",
	   parent_mentor_information:"Informazioni sui genitori / mentore",
	   send:"Inviare",
	   are_you_surse_to_delete_this_parent:"Sei sicuro di eliminare questo genitore.",
	   home:"Casa",
	   
	   //auto_promotion:"Promozione automatica",
	   auto_promotion:"Promozione di livello per studenti",
	   Promote:"Promuovere",
	   search_for_a_name:"Cerca un nome ...",
	   download_to_excel:"Scarica su Excel",
	   download_to_pdf:"Scarica su PDF",
	   User_ID:"ID utente",
	   User_type:"Tipologia di utente",
	   communication_log:"Registro di comunicazione",
	   Student_Status:"Stato dello studente",
	   Users:"Utenti",
	   Staff_Reassignment:"Riassegnazione del personale",
	   Select_Staff:"Seleziona il personale",
	   select_asset_type_to_reassign:"Seleziona il tipo di risorsa per riassegnare",
	   transfer_all_to:"Trasferisci tutto a",
	   transfer_selectively:"Trasferisci selettivamente",
	   remove_all:"Rimuovi tutto",
	   remove_selectively:"Rimuovere selettivamente",
	   Event:"Evento",
	   Time:"Tempo",
	   Participants:"Partecipanti",
	   new_staff:"Nuovo staff",
	   Remove:"Rimuovere",
	   Profile_Page:"Pagina profilo",
	   settings:"Impostazioni",
	   security:"Sicurezza",
	   timezone:"Fuso orario",
	   notifications:"Notifiche",
	   check_for_feature_availability_at_your_school:"Controlla la disponibilità delle funzionalità nella tua scuola.",
	   current_password:"password attuale",
	   new_password:"nuova password",
	   confirm_password:"Conferma password",
	   updte_password:"Aggiorna la password",
	   change_timezone:"Cambia il fuso orario",
	   time_zone:"Fuso orario",
	   please_select_time_zone:"Seleziona il fuso orario",
	   notification_settings:"Impostazioni di notifica",
	   level_of_urgency:"Livello di urgenza",
	   email_destination:"Destinazione e -mail",
	   SMS_Destination:"Destinazione SMS",
	   app:"App",
	   please_select_level_of_urgency:"Seleziona il livello di urgenza",	  
	   reset_filters:"Ripristina i filtri",
	   batch_data_update:"Aggiornamento dei dati degli studenti",
	   contract_template:"Modello di contratto",
	   accept:"Accettare",
	   reject:"Rifiutare",
	   view_roles:"Visualizza ruoli",
	   administrator_information:"Informazioni sull'amministratore", 
	   account_reation_date:"Data di creazione dell'account", 
	   expiration_date:"Data di scadenza", 
	   schools:"Scuole", 
	   advisees:"Consigli",
	   message:"Messaggio",
	   see_comments_and_documents:"Vedi commenti e documenti",
	   restore_APEX_Classrooms:"Ripristina le classi apice",
	   teacher_information:"Informazioni sull'insegnante", 
	   teacher_number:"Numero dell'insegnante", 
	   departmens:"Dipartmens", 
	   global_capacity:"Capacità globale", 
	   local_contracted_load:"Carico contratto locale", 
	   parents:"Genitori", 
	   parent_information:"Informazioni sui genitori",
	   linked_students:"Studenti collegati", 
	   link_student:"Link Student", 
	   unlink_student:"UNKINK STUDENT", 
	   search_dot:"Ricerca…", 
	   view_local:"Visualizza locale", 
	   view_global:"Visualizza globale",
	   resource:"Risorsa",
	   current_grade:"Grado attuale", 
	   affiliation:"Affiliazione", 
	   current_assignment:"Assegnazione corrente", 
	   total_assignments:"Incarichi totali", 
	   percent_completed:"Percentuale completata",
	   semester:"semestre",
	   graduation_year:"anno di laurea", 
	   student_name:"Crediti guadagnati", 
	   credits_earned:"Crediti guadagnati",
	   exit:"Uscita",
	   engagement_type:"Tipo di coinvolgimento",
	   college_admitted:"College ammesso", 
	   college_attending:"College frequentando", 
	   major:"Maggiore", 
	   report_card:"Pagella", 
	   academic_term:"Termine accademico", 
	   show_average:"Mostra la media",
	   school_information:"Informazioni scolastiche",
	   school_misc_configuration:"Configurazione misc -misc", 
	   school_tags:"Tag della scuola", 
	   role_tags:"Tag del ruolo", 
	   content_integration:"Integrazione dei contenuti", 
	   user_roles:"Ruoli utente", 
	   communication_user_rules:"Regole dell'utente di comunicazione", 
	   school_administrators:"Amministratori scolastici", 
	   school_year_configuration:"Configurazione dell'anno scolastico", 
	   A_R_payment_configuration:"Configurazione del pagamento A/R", 
	   facility:"Facilità", 
	   enrollment_rules:"Regole di iscrizione", 
	   student_contract_rules:"Regole del contratto degli studenti", 
	   products:"Prodotti", 
	   notification_templates:"Modelli di notifica", 
	   transcript_viewer_options:"Opzioni del visualizzatore di trascrizione", 
	   feature_configuration:"Configurazione delle caratteristiche", 
	   feature_settings:"Impostazioni delle funzionalità", 
	   communication_rules:"Regole di comunicazione", 
	   object_state:"Stato oggetto", 
	   departments:"Dipartimenti", 
	   grading_scales:"Scale di classificazione", 
	   grading_periods:"Periodi di classificazione", 
	   academic_tracks:"Tracce accademiche", 
	   learning_path_templates:"Modelli di percorso di apprendimento", 
	   grade_book_activity_descriptions:"Descrizioni delle attività del libro di grado", 
	   academic_terms:"Termini accademici",
	   academic_system:"Sistema accademico",
	   address_line_1:"Indirizzo Linea 1", 
	   country_code:"Prefisso internazionale", 
	   address_line_2:"indirizzo 2", 
	   school_title:"Titolo scolastico",
	   CEEB_code:"Codice CEEB", 
	   zip_postal_code:"Zip / Codice postale", 
	   state_province:"Stato/Provincia", 
	   website:"Sito web", 
	   subdomain:"Sottodominio", 
	   success_manager:"Responsabile del successo", 
	   school_logo:"Logo scolastico", 
	   digital_seal:"Sigillo digitale",
	   password_exception_rule:"Regola di eccezione della password",
	   change_password_first_login:"Cambia la password prima di accedere", 
	   password_expires_after_days:"La password scade dopo giorni", 
	   enforcement_of_teachers_load:"Applicazione del carico dell'insegnante", 
	   in_house_handling_of_transcript_requests:"Nella gestione delle richieste di trascrizione della casa", 
	   display_mobile_app_link:"Visualizza il collegamento dell'app mobile", 
	   display_weekly_progress_goal:"Visualizza l'obiettivo di progresso settimanale", 
	   turn_on_notification:"Accendi le notifiche", 
	   classic_letter:"Lettera classica", 
	   automatic_parent_account_creation:"Creazione automatica dell'account genitore", 
	   default_parent_account_status:"Stato dell'account principale predefinito", 
	   default_time_zone:"Fuso orario predefinito", 
	   link_to_transcript_vendor_help:"Collegamento alla Guida del fornitore di trascrizioni", 
	   link_to_transcript_vendor:"Collegamento al fornitore di trascrizioni", 
	   link_for_help_system:"Link per il sistema di aiuto", 
	   student_enrollment_limit:"Limite di iscrizione degli studenti", 
	   default_section_type:"Tipo di sezione predefinito", 
	   default_section_capacity:"Capacità della sezione predefinita",
	   transcript_template:"Modello di trascrizione",
	   edit_security_school_tags:"Modifica tag della scuola di sicurezza", 
	   security_school_tags:"Tag della scuola di sicurezza",
	   tags_name:"Nome dei tag", 
	   edit_role_tags:"Modifica tag di ruolo",
	   add_school_based_tags:"Aggiungi tag a scuola", 
	   description:"Descrizione", 
	   applied_to_roles:"Applicato ai ruoli", 
	   teacher:"Insegnante",
	   edit_security_role_tags_for:"Modifica tag di ruolo di sicurezza per",
	   school_admins:"Amministratori scolastici",
	   school_begin_date:"Data di inizio della scuola", 
	   school_end_date:"Data di fine scolastica", 
	   automatic_control_of_teacher_s_load:"Controllo automatico del carico dell'insegnante",
	   A_R_payment_gateway_configuration:"Configurazione del gateway di pagamento A/R", 
	   payment_processing_vendor:"Fornitore di elaborazione dei pagamenti", 
	   secret_key:"Chiave segreta", 
	   publishable_key:"Chiave pubblicabile", 
	   account_id:"Account ID",
	   updating_tudents:"Aggiornamento degli studenti", 
	   delete_selected_records:"Elimina i record selezionati",
	   attribute_name:"nome attributo", 
	   applied_for:"Aver fatto richiesta per",
	   add_school:"Aggiungi la scuola", 
	   overview:"Panoramica", 
	   search_for_school:"Cerca la scuola ...", 
	   search_for_student:"Cerca lo studente ...",
	   attribute_type:"Tipo di attributo", 
	   select_school_group:"Seleziona il gruppo scolastico", 
	   access_rights:"Diritti di accesso", 
	   create:"Creare", 
	   read:"Leggere",
	   facility_management:"Gestione delle strutture", 
	   facility_name:"Nome struttura", 
	   capacity:"Capacità",
	   enrollment_allowance_period_days:"Periodo di indennità di iscrizione (giorni)", 
	   maximum_enrollment_duration_days:"Durata massima di iscrizione (giorni)", 
	   start_date_of_the_week:"Data di inizio della settimana", 
	   end_date_of_the_week:"Data di fine della settimana",
	   lookup_name:"Nome alla ricerca", 
	   duration:"Durata", 
	   time_unit:"Unità temporale", 
	   round_up_to_end_of_time_unit:"Arrotondare fino all'unità di fine tempo",
	   product_name:"nome del prodotto",
	   product_ID:"Codice prodotto", 
	   price_offer:"Prezzo d'offerta", 
	   price:"Prezzo", 
	   frequency:"Frequenza", 
	   effective_from:"Efficace da", 
	   effective_to:"Efficace a", 
	   active:"Attivo",
	   drag_drop_to_text_cursor_in_content:"Trascina e lascia cadere nel cursore di testo nel contenuto", 
	   event_type:"Tipo di evento", 
	   notification_rule:"Regola di notifica", 
	   level_or_ugency:"Livello o ugency", 
	   user_role:"Ruolo dell'utente",
	   edit_security_user_tags:"Modifica i tag utente di sicurezza",
	   content_access:"Accesso ai contenuti", 
	   content_access_for:"Accesso ai contenuti per", 
	   add_new_access:"Aggiungi un nuovo accesso", 
	   date_assigned:"Data assegnata",
	   enrollment_request:"Data assegnata", 
	   enrollment_request_for:"Richiesta di iscrizione", 
	   mentors:"Mentori",
	   options:"Opzioni",
	   department_name:"Nome Dipartimento", 
	   universal_department:"Dipartimento universale", 
	   open:"Aprire",
	   min_point:"Min Point", 
	   max_point:"Punto massimo", 
	   grade_point:"Punto di voto", 
	   honors:"Onori", 
	   college:"Università",
	   order:"Ordine", 
	   start_time:"Ora di inizio", 
	   end_time:"Tempo scaduto",
	   period_name:"Nome periodo",
	   grading_periods_head:"Periodi di valutazione testa",
	   grading_period:"Periodo di classificazione", 
	   weight:"Peso",
	   track_name:"Nome traccia",
	   academic_track_requirement:"Requisito di traccia accademica", 
	   of_required_credits:"# dei crediti richiesti",
	   individual_learning_plan_template:"Modello di piano di apprendimento individuale",
	   ILP_name:"Nome ILP",
	   remove_requirement:"Rimuovere il requisito", 
	   reset_requirement:"Requisito requisito", 
	   add_requirement:"Aggiungi requisito",
	   must_end_date:"Deve terminare la data", 
	   courses_open_date:"Corsi Apri Data", 
	   signup_end_date:"Data di fine iscrizione", 
	   signup_start_date:"Data di inizio di iscrizione", 
	   section_period:"Periodo di sezione",
	   
	   weeks:"Settimane", 
	   search_for_a_section_or_id:"Cerca una sezione o un ID ...",
	   search_for_a_deft:"Cerca un reparto ...", 	   
	   launch_course:"Corso di lancio", 
	   start_class:"Classe iniziale", 	   
	   weekly_progress_goal:"Obiettivo di progresso settimanale", 
	   send_message_to_all_section_students:"Invia messaggio a tutti gli studenti della sezione", 	   
	   monitor_live_sessions:"Monitorare le sessioni vive", 
	   average_section_grade:"Grado di sezione medio", 
	   resources:"Risorse", 
	   activities:"attività", 	   
	   course_attendance_today:"Presenza del corso oggi", 
	   staffs:"Personale", 
	   units:"Unità", 
	   view_all_15_resources:"Visualizza tutte e 15 le risorse", 
	   Class_discussions:"Discussioni in classe", 
	   recent_discussions:"Discussioni recenti", 
	   go_to_class_discussions:"Vai alle discussioni in classe",	   
	   show_my_class_attendance:"Mostra la mia presenza in classe", 
	   add_section:"Aggiungi sezione",
	   add_new:"Aggiungere nuova",
	   add_global_section:"Aggiungi sezione globale",
	   close_section:"Chiudi sezioni",
	   open_section:"Sezioni aperte",
	   batch_upload:"Caricamento in blocco",
	   finalize:"Finalizzare",	   
	   add_tearcger:"Aggiungi insegnante/i",
	   remove_tearcger:"Rimuovi insegnante/i",
	   uploadSectionStatusUpdates:"Carica gli aggiornamenti sullo stato della sezione",
	   status_count:"Conteggio stato",	   
	   reactivate:"Riattiva",
	   clone:"Clone",
	   enroll_into_Section:"Iscriviti alla Sezione",
	   bulk_enrollment:"Iscrizione in blocco",
	   general_Information:"Informazioni generali",	   
	   online_content_source:"Fonte di contenuto online",
	   second_teacher:"Secondo Maestro",
	   today:"oggi",
	   calendar:"Calendario",
	   week:"settimana",
	   month:"Mese",	   
	   section_progress:"Progresso della sezione",
	   complete:"completare",	   
	   section_title:"Titolo della sezione",
	   enter_section_title:"Inserisci il titolo della sezione",
	   select_teacher:"Seleziona insegnante",	   
	   select_weeks:"Seleziona le settimane",
	   select_credits:"Seleziona crediti",
	   select_type:"Seleziona il tipo",
	   global_section:"Sezione Globale",	   
	   enrollment_capacity:"Capacità di iscrizione",
	   enter_enrollment_capacity:"Inserisci la capacità di registrazione",
	   in_class_information:"Informazioni in classe",
	   Start:"Inizio",
	   End:"Fine",	   
	   recurrencePattern:"Modello di ricorrenza",
	   recurrenceFrequency:"Frequenza di ricorrenza",
	   Weekly:"Settimanalmente",
	   Monthly:"Mensile",
	   Recur_every:"Accade ogni",
	   Weeks_on:"Settimane dopo",
	   day_of_week:"Giorno della settimana",
	   daily_period:"Periodo giornaliero",
	   select_daily_period:"Seleziona il periodo giornaliero",
	   Day:"Giorno",
	   The:"Il",
	   of_every:"di ogni",
	   month_s:"mesi)",
	   add:"Aggiungere",	   
	   course_prequisites:"Prerequisiti del corso",
	   select_status:"Seleziona stato",
	   select_school:"Seleziona Scuole",	   
	   select_period:"Seleziona Periodo",
	   room_number:"Numero di Camera",
	   select_room_number:"Seleziona il numero della camera",
	   Service:"Servizio",	   
	   enter_url:"Inserisci URL",
	   edit_section:"Modifica sezione",
	   activity_templates:"Modelli di attività",
	   select_activity_templates:"Seleziona il modello di attività",
	   link_section:"Sezione Collegamento",
	   select_link_section:"Seleziona la sezione del collegamento",
	   please_select_sections:"Si prega di selezionare le sezioni.",
	   if_you_change_your_status_of_inactivity:"Se modifichi il tuo stato di inattività, lo studente ne risentirà.",
	   closing_the_global_section_will_cause:"La chiusura della sezione globale comporterà la chiusura di tutte le scuole e il ritiro di tutti gli studenti. Fare clic su Conferma se si desidera procedere.",
	   upload_import_data:"Carica e importa dati",	   
	   here:"Qui",
	   no_data_avalable_in_table:"Nessun dato disponibile nella tabella",
	   add_teacher_to_multiple_section:"Aggiungi insegnante (i) a più sezioni",
	   select_teachers_to_add_to_multiple_section:"Seleziona gli insegnanti da aggiungere a selezioni multiple",
	   selected:"Selezionato",
	   selected_all:"Seleziona tutto",
	   deselected_all:"Deselezionare tutto",
	   remove_teacher_from_multiple_section:"Rimuovi insegnante/i da più sezioni",
	   select_teacher_to_remove_to:"Seleziona gli insegnanti da rimuovere in selezioni multiple",
	   process_removal:"Rimozione del processo",	   
	   clone_section:"Sezione clone",
	   enroll_student:"Iscrivi Studente",
	   enroll_student_to:"Iscrivi gli studenti a",
	   name:"Nome",
	   confirmation_of_enrollment:"CONFERMA DELL'ISCRIZIONE",
	   please_review_and_confirm_enrollments_for:"Controlla e conferma le iscrizioni per",
	   confirm:"Confermare",
	   enroll_students_to_section:"ISCRIVITI GLI STUDENTI ALLA SEZIONE",
	   enrollment_period:"Periodo di iscrizione",
	   days:"giorni",
	   no_data_avalible:"Nessun dato disponibile.",
	   number_of_primary_teacher:"Numero di insegnanti primari",
	   secondary_teachers:"Insegnanti secondari",
	   department_head:"Capo dipartimento",
	   section_enroll:"Sezione Iscrizione",
	  load_from_file:"Carica da file",
	  see_sections:"Vedi sezioni",
	  change_enrollment_status:"Modifica lo stato di iscrizione",
	  mentor_s:"Mentore (i)",
	  overdue_activities:"Attività in ritardo",
	  total_session_time_and_last_log:"Tempo totale di sessione e ultimo registro",
	  course_name_on_transcript:"Nome del corso sulla trascrizione",
	  edit_other_grades:"Modifica altri voti",
	  save_as:"Salva come",
	  account_receivable_dashboard:"Dashboard del destinatario dell'account",
	   key_performance_indicators:"indicatore chiave di prestazione",
	   a_r_dashboard:"Dashboard A/R",
	   payments_credits:"Pagamenti/crediti",
	   contract_templates:"Modelli di contratto",
	   master_contracts:"Contratti principali",
	   a_r_configuration:"Configurazione A/R",
	   a_r_processing:"Elaborazione A/R",
	   aging:"Invecchiamento",
	   receivable:"Ricevibile",
	   account_receivable_by_program:"Conto per il programma",
	   request_detail:"Dettaglio richiesto",
	    request_information:"Richiesta di informazioni",
	    requested_by:"Richiesto da",
	    approved_by:"Approvato da",
	    approve:"Approvare",
	    phone_name:"Nome del telefono",
	    phone_carrier:"Gestore di telefonia",
		area_code:"Codice area",
	   address_lable:"Indirizzo Lable",
	   address_default:"Indirizzo predefinito",
	   new_photo:"Nuova foto",
	   current_of_wweeks:"Attuale # di settimane",
	   select_enrollment_period:"Selezionare il periodo di iscrizione",
	   enter_rejection_reason:"Inserisci il motivo del rifiuto ...",
	   comments_and_documents:"Commenti e documenti",
	   enrollment_history:"Storia delle iscrizioni",
	   request_extension_for:"Richiedere estensione per",
	   extended_of_weeks:"# Esteso di settimane",
	   current_enrollment_status:"Stato di iscrizione corrente",
	   select_extension_option:"Seleziona l'opzione di estensione",
	   extend_current_enrollment_until:"Estendere l'iscrizione corrente fino a quando",
	   transfer_to_new_section:"Trasferire in una nuova sezione",
	   transcript_requests:"Richieste di trascrizione",
	   person_requesting_transcript:"Persona che richiede trascrizione",
	   telephone_number:"Numero di telefono",
	   number_of_copies:"Numero di copie",
	   special_instructions:"istruzioni speciali",
	   last_school_attendance:"Ultima frequenza scolastica",
	   year_last_attended:"Anno ha partecipato l'anno scorso",
	   current_address:"Indirizzo corrente",
	   relationship_to_student:"Il rapporto con un studente",
	   method_of_delivery:"Metodo di spedizione",
	   instructions:"*Istruzioni",
	   previous_requests:"Richieste precedenti",
	   additional_info:"Informazioni addizionali",
	   receive:"Ricevere",
	   process:"Processi",
	   add_to_school_group:"Aggiungi al gruppo scolastico",
	   submit_romote:"Invia Promuovi",
	   next_grade_level:"Livello di grado successivo",
	   please_select_a_school_for_promotion_and_transfer:"Seleziona una scuola per la promozione e il trasferimento",
	   write_off:"Cancellare",
	   amount_due:"Importo dovuto",
	   open_amount:"Importo aperto",
	   payment_application:"Domanda di pagamento",
	   use_credit_openBalance:"Usa il credito $ 111",
	   payment_amount_usd:"Importo del pagamento (USD)",
	   check_number:"Numero di controllo",
	   confirmation_number:"Numero di conferma",
	   apply_payment:"Applica il pagamento",
	   amount_paid:"Importo pagato",
	   applied_payment:"Pagamento applicato",
	   payer_id:"ID pagatore",
	   view_detail:"vedi dettagli",
	   master_contract:"Contratto principale",
	   copy:"copia",
	   contract_user_detail:"Dettagli dell'utente del contratto",
	   follow_product_cost:"Seguire il costo del prodotto",
	   default_cost:"Costo predefinito",
	   offered_cost:"Costo offerto",
	   contract_detail:"Dettaglio del contratto",
	   contract_template_name:"Nome modello a contratto",
	    master_contract_name:"Nome del contratto principale",
		 view_students:"Voir les étudiants",
		 make_payment:"Fare un pagamento",
		 parent_page:"Pagina genitore",
		 edit_parent:"Modifica genitore",
		 edit_profile:"Modifica Profilo",
		 account_receivable_configuration:"Configurazione dei crediti account",
		 invoice_generation_date:"Data di generazione della fattura", 
	   invoice_generation:"Generazione della fattura", 
	   number_of_days_until_due_date:"Numero di giorni fino alla data di scadenza",
	   account_receivable_processing:"Elaborazione del conto Account",
	   generate_invoices:"Generare fatture", 
	   process_automatic_payments:"Pagamenti automatici di processo", 
	   send_late_notices:"Invia avvisi in ritardo", 
	   course:"Corso",
	   copy_courses:"Copia corsi", 
	   copy_to_school:"Copia a scuola", 
	   originating_program_code:"Codice del programma di origine", 
	   destinating_program_code:"Codice del programma di destinazione", 
	   status_error:"Stato/errore",
	   add_prerequisite:"Aggiungi prerequisito", 
	   group_name:"Nome del gruppo", 
	   enter_group_name:"Immettere il nome del gruppo", 
	   select_a_department_to_display_courses:"Seleziona un dipartimento per visualizzare corsi", 
	   edit_tranferred_grades:"Modifica altri voti", 
	   showing_num_records:"Mostrando 000 record",
	   edit_all_other_grades:"Modifica tutti gli altri voti",
	   upload_student_documents:"Carica i documenti degli studenti",
	   select_an_official_transcript_option:"Seleziona un'opzione di trascrizione ufficiale", 
	   for_schools_or_personal_copy:"Per scuole o copia personale", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Per l'uso degli studenti, invia a un'altra scuola o per verificare l'iscrizione.", 
	   request_official_transcript:"Richiedere una trascrizione ufficiale", 
	   PARCHMENT_for_colleges_or_universities:"Pergamena per college o università", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Per applicazione a un college/università e per verificare il completamento del diploma.", 
	   request_transcript:"Richiedi trascrizione", 
	   Learn_more_about_how_to_use_PARCHMENT:"Ulteriori informazioni su come usare la pergamena",
	   print_PDF:"Stampa pdf",
	   user_school:"Scuola per utenti",
	   filter:"Filtro",
	   GENERAL:"GENERALE", 
	   STUDENT_INFO:"Informazioni sullo studente", 
	   list:"Elenco", 
	   last_school_name:"Ultimo nome di scuola", 
	   TEACHER_INFO:"Informazioni per l'insegnante", 
	   contracted_load:"Carico contratto", 
	   ARENT_INFO:"Informazioni per i genitori",
	   add_credential:"Aggiungi credenziali",
	   edit_credential:"Modificare le credenziali",
	   add_comment_document:"Aggiungi commento e documento",
	   add_comment_document_for:"Aggiungi commento e documento per",
	   state_province:"Stato/ Provincia", 
	   post_code:"Post Codice", 
	   linking_students_to:"Collegare gli studenti a", 
	   change_expiration_date:"Modificare la data di scadenza", 
	   expiry_date:"Data di scadenza", 
	   please_select_department:"Seleziona il dipartimento.", 
	   please_select_course:"Seleziona il corso.", 
	   please_select_title:"Inserisci il titolo.", 
	   please_select_primary_teacher:"Seleziona insegnante primario.", 
	   please_select_weeks:"Seleziona le settimane.", 
	   please_select_level:"Seleziona il livello.", 
	   please_select_credits:"Seleziona i crediti.", 
	   please_select_type:"Selezionare il tipo.", 
	   please_select_daily_period:"Seleziona il periodo giornaliero.",
	   please_enter_link_section:"Inserisci la sezione Link.",
	   please_enter_first_name:"Inserisci il nome.", 
	   please_enter_last_name:"Inserisci il cognome.", 
	   please_enter_contracted:"Si prega di inserire contratto.", 
	   please_enter_email:"Inserisci e -mail.", 
	   please_enter_phone:"Inserisci il telefono.", 
	   please_enter_username:"Si prega di inserire il nome utente.",
	   please_enter_password:"Per favore, inserisci la password.", 
	   please_enter_status:"Seleziona Stato.", 
	   save_successful:"Salvataggio eseguito con successo!.",
	   please_add_student_address:"Si prega di aggiungere l'indirizzo dello studente.", 
	   please_enter_email_address:"Inserisci l'indirizzo e -mail.", 
	   please_select_relationship:"Seleziona la relazione.", 
	   please_select_parent_status:"Seleziona lo stato del genitore.", 
	   please_enter_label:"Inserisci l'etichetta.", 
	   please_enter_address:"Inserisci l'indirizzo.", 
	   please_enter_city:"Inserisci la città.", 
	   please_enter_state:"Inserisci lo stato.", 
	   please_enter_zip_code:"Inserisci il codice postale.", 
	   please_select_date_of_birth:"Seleziona la data di nascita.", 
	   please_select_track:"Seleziona traccia.", 
	   please_enter_graduation_date:"Inserisci la data di laurea.", 
	   please_enter_country:"Si prega di entrare nel paese.", 
	   please_enter_phone_number:"Inserisci il numero di telefono.", 
	    please_enter_parent_first_name:"Inserisci il nome genitore.", 
	   please_enter_parent_last_name:"Inserisci il cognome principale.", 
	   please_enter_parent_email_address:"Inserisci l'indirizzo email principale.", 
	   please_enter_parent_username:"Inserisci il nome utente dei genitori.", 
	   please_select_parent_relationship:"Seleziona la relazione genitore.", 
	   please_enter_phone_label:"Inserisci l'etichetta del telefono.", 
	   student_address_canot_be_empty:"L'indirizzo dello studente non può essere vuoto.",
	   please_select_document_type:"Selezionare il tipo di documento.", 
	   please_enter_new_type:"Inserisci nuovo tipo.", 
	   please_enter_comment:"Inserisci il commento.", 
	   link_is_not_a_valid_url:"Il collegamento non è un URL valido.",	   
	   please_enter_link_and_label:"Inserisci link ed etichetta.",
		are_you_sure_to_delete_this_student:"Sei sicuro di eliminare questo studente.",	   
		please_select_gender:"Seleziona il genere.",
		school_contracted_load:"Carico a contratto scolastico", 
	   global_contracted_load:"Carico contratto globale",
	   please_enter_label_for_attachments:"Inserisci l'etichetta per gli allegati.",
	   please_select_section:"Seleziona la sezione.", 
	   enrollment_completed_successfully:"Iscrizione completata con successo.",
	   delete_this_comment:"Elimina questo commento?",
	   please_enter_course_name:"Inserisci il nome del corso.", 
	   please_select_credits_possible:"Selezionare i crediti possibili.",
	   can_save_record:"Non riesco a salvare il record:",
	   are_you_sure_to_delete_this_tranferred_grade:"Sei sicuro di eliminare questo voto trattato?",
	   are_you_sure_to_delete_num_tranferred_grade:"Sei sicuro di eliminare 11 voti transferati?", 
	   please_select_tranferred_grade:"Selezionare il grado transferato.",
	   please_ente_subject:"Inserisci l'argomento.", 
	   please_select_made_to:"Seleziona realizzato a.", 
	   delete_this_communication:"Elimina questa comunicazione?",
	   please_select_school:"Seleziona la scuola.",
	   please_enter_name:"Inserisci il nome.",
	   please_enter_group_name:"Immettere il nome del gruppo.",
	   you_have_some_form_errors_please_check_above:"Hai alcuni errori di forma. Si prega di controllare sopra.",
	   please_select_recipient:"Seleziona il destinatario.", 
	   please_enter_description:"Inserisci la descrizione.",
	   delete_this_resource:"Elimina questa risorsa?",
	   please_enter_activity_name:"Immettere il nome dell'attività.", 
	   please_select_activity_type:"Seleziona il tipo di attività.", 
	   please_enter_max_score:"Inserisci il punteggio MAX.", 
	   please_enter_due_date:"Inserisci la data di scadenza.",
	   please_enter_unit_name:"Immettere il nome dell'unità.",
	   are_you_sure_to_clear_this_unit:"Sei sicuro di cancellare questa unità?",
	   please_enter_score:"Inserisci il punteggio.",
	   delete_this_credential:"Elimina questa credenziale?",
	   plase_select_period:"Seleziona il periodo", 
	   plase_select_start_date:"Seleziona la data di inizio", 
	   plase_select_end_date:"Seleziona la data di fine",
	   select_to_register_course_to_students_individual_learning_path_view:"Seleziona per registrare il corso sugli studenti View percorso di apprendimento individuale",
       delete_this_request:"Elimina questa richiesta?",
	   please_enter_fname:"Inserisci il nome.", 
	   please_enter_lname:"Inserisci il cognome.", 
	   please_enter_birthday:"Inserisci il compleanno.", 
	   please_enter_address:"Inserisci l'indirizzo.", 
	   please_enter_zip:"Inserisci Zip.", 
	   please_enter_country:"Si prega di entrare nel paese.", 
	   please_enter_ethnicity:"Si prega di inserire etnia.", 
	   please_enter_grade:"Inserisci il grado.", 
	   please_enter_mobile:"Inserisci il cellulare.", 
	   please_enter_hear_about_us:"Inserisci a sapere di noi.", 
	   please_enter_program_of_interest:"Inserisci il programma di interesse.", 
	   please_enter_course_level:"Si prega di inserire il livello del corso.", 
	   please_enter_guardian_1_name:"Inserisci il nome di Guardian 1.", 
	   please_enter_guardian_1_email:"Inserisci l'e -mail di Guardian 1.", 
	   please_enter_guardian_1_home_phone:"Inserisci il telefono di Guardian 1 Home.", 
	   please_enter_guardian_1_relation:"Inserisci la relazione Guardian 1.",
	   please_select_parents:"Seleziona i genitori.",
	   transfer_classroom:"Trasferisci l'aula", 
	   please_choose_one_section_to_transfer:"Scegli una sezione da trasferimento.", 
	   transfer:"Trasferimento",
	   assigning_multiple_users_to_a_school_or_school_group:"Assegnare più utenti a un gruppo scolastico o scolastico", 
	   add_to_school_or_school_group:"Aggiungi a scuola o gruppo scolastico", 
	   please_select_school_or_school_group:"Seleziona la scuola o il gruppo scolastico.",
	   print_student_progress_report:"Stampa Rapporto sui progressi degli studenti",
 },
 kk: {
	   reporting_center:"Есеп беру орталығы", 
	   grade_reports:"Бағалар туралы есептер", 
	   user_reports:"Пайдаланушы есептері", 
	   learning_reports:"Оқу туралы есептер", 
	   administrative_reports:"Әкімшілік есептер", 
	   progress_report:"Прогресс туралы есеп", 
	   full_progress_report:"Толық прогресс туралы есеп", 
	   grade_report:"Бағасы туралы есеп", 
	   roster_report:"Тапсырыс беру есебі", 
	   parent_report:"Ата-ана туралы есеп", 
	   teacher_report:"Мұғалімнің есебі", 
	   student_report:"Студенттік есеп", 
	   log_in_report:"Кіру Есеп", 
	   enrollmentreport:"Тіркелу туралы есеп", 
	   enrollment_summary:"Тіркелу туралы қысқаша ақпарат", 
	   student_enrollment_summary:"Студенттерді қабылдаудың қысқаша мазмұны", 
	   attendance_report:"Қатысу туралы есеп", 
	   attendance_summary_report:"Қатысу жиынтығы туралы есеп", 
	   log_In_Credentials:"Тіркелгі деректеріне кіріңіз", 
	   application_report:"Өтінім есебі", 
	   section_report:"Бөлімнің есебі", 
	   course_report:"Курс туралы есеп", 
	   communication_summary:"Байланыс туралы қысқаша ақпарат", 
	   comments_and_Document_Report:"Пікірлер және құжаттар туралы есеп", 
	   School_Calendar:"Мектеп күнтізбесі", 
	   bell_Schedule:"Қоңырау кестесі", 
	   student_Contract:"Студенттік келісім-шарт", 
	   eOS_Report:"EOS есебі", 
	   active_Enrollments_Per_Term_Report:"Үстеме есеп беру үшін белсенді қабылдау", 
	   active_Student_Enrollments_with_As_Report:"Есеп ретінде студенттердің белсенді қабылдауы", 
	   active_Student_Enrollments_Report:"Студенттердің белсенді оқу есебі", 
	   all_Students_GPA_Report:"Барлық студенттер GPA есебі", 
	   old_All_Student_GPA_Report:"Ескі барлық студенттер GPA есебі", 
	   billingGroup_Engagement_Type_Report:"БиллингТрупоп + Келісім типіндегі есеп", 
	   enrollment_Confirmation_Report:"Тіркелу туралы есеп туралы есеп", 
	   eOS_College_Matriculations_Report:"EOS колледжінің оқу мерзімі туралы есеп", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Студенттерді қабылдау тарихы Бүгінгі күнге дейін",
	   student_Information_Report:"Студенттік ақпараттық есеп", 
	   ran_by:"жүгірді",
	   Show_Filter:"Сүзгіні көрсету", 
	   School_Group:"Мектеп тобы", 
	   school:"Мектеп", 
	   department:"Бөлім", 
	   student:"Студент", 
	   student_status:"Студенттік мәртебе", 
	   course:"Курс", 
	   course_level:"Курстың деңгейі", 
	   section:"Бөлім", 
	   teacher:"Мұғалім", 
	   primary_teacher:"Бастапқы оқытушы", 
	   secondary_teacher:"Орта оқытушы", 
	   completion_Date_Range:"Аяқталу күнінің диапазоны", 
	   from_date:"Бүгінгі күннен бастап", 
	   to_date:"Бүгінгі күнге дейін", 
	   status:"Мәртебе", 
	   gender:"Жыныс", 
	   final_grade:"Қорытынды баға", 
	   advisor:"Кеңесші", 
	   grade_level:"Бағасы", 
	   specific_mark:"Белгілі бір белгі", 
	   track:"Бақылау", 
	   ethnicity:"Ұлт", 
	   additional_fields:"Қосымша өрістер", 
	   school_sessions:"Мектептегі сессиялар", 
	   gradebook:"Сыныптама", 
	   submit:"Бағыну", 
	   reset:"Ысыру", 
	   show_hide_columns:"Бағандарды көрсету / жасыру", 
	   select_all:"Барлығын таңдаңыз", 
	   student_id:"Студенттік куәлік", 
	   last_name:"Тек", 
	   first_name:"Аты", 
	   grade_level:"Бағасы", 
	   start_date:"Басталатын күн", 
	   end_date:"Аяқталу күні", 
	   grade_final:"САТЫЛАДЫ", 
	   percent:"Пайыз", 
	   credit:"Несие", 
	   download_excel:"Excel бағдарламасын жүктеп алыңыз", 
	   print:"Із", 
	   no_data:"Деректер жоқ.", 
	   view:"Көзқарас", 
	   showing:"Көрсету", 
	   of:"-ден", 
	   other_grade:"Басқа бағалар", 
	   level:"Деңгей", 
	   date:"Дата", 
	   grade:"Дәреже",
	   enrollment_Change_Status:"Тіркелу күйінің күйі", 
	   close:"Жабық", 
	   select_Enrollment_Status:"Тіркелу күйін таңдаңыз", 
	   select:"Таңдау ...", 
	   cancel:"Күшін жою", 
	   save:"Жинау", 
	   students:"Студенттер", 
	   Course_Status:"Курстың мәртебесі", 
	   Closed_courses:"Жабық курстар", 
	   Section_Status:"Бөлімнің мәртебесі", 
	   Closed_sections:"Жабық бөлімдер", 
	   Transferred_From:"Аударылған",
	   Graduation_From_Date:"Дипломдық күннен бастап", 
	   Graduation_To_Date:"Дипломдық", 
	   Enrollment_From_Date:"Күннен қабылдау", 
	   Enrollment_To_Date:"Күнге қабылдау", 
	   Enrollment_Status:"Тіркелу мәртебесі", 
	   Transfer_From_Date:"Күннен ауысу", 
	   Transfer_To_Date:"Бүгінгі күнге ауыстыру", 
	   Custom_Query:"Жеке сұрау", 
	   Last_Access_Date:"Соңғы кіру күні", 
	   Total_Session_Time:"Жалпы сессия уақыты", 
	   Quality_of_Work:"Жұмыс сапасы", 
	   Grade_to_Date:"Бүгінгі таңда", 
	   Overall_Percent:"Жалпы пайыздар", 
	   On_Schedule_Percent:"Пайыздық кестені", 
	   Activity_Count_Complete:"Әрекет саны аяқталды", 
	   Activity_Count_Total:"Барлығы белсенділік саны", 
	   Overdue_Activitie:"Мерзімі өткен Activitie",
	   Section_Course_Additional_Fields:"Бөлім / Курстың қосымша өрістері", 
	   Create_On_Date:"Күні бойынша жасаңыз", 
	   Last_Status_Update_Date:"Соңғы күйді жаңарту күні", 
	   Transferred_In:"Ауыстырылды", 
	   Transferred_In_Date:"Күні бойынша ауыстырылды", 
	   email:"Электрондық пошта", 
	   birth_date:"Туылған күні", 
	   course_name:"Курс атауы", 
	   section_name:"Бөлімнің атауы", 
	   school_name:"Мектеп аты", 
	   Graduation_Date:"Бітіру күні", 
	   Created_on:"Құрылған", 
	   mentor_Advisor:"Тәлімгер / кеңесші",
	   sections:"Бөлімдер", 
	   roster:"Тапшы", 
	   relationship:"Туыстық", 
	   Email_or_Phone:"Электрондық пошта немесе телефон", 
	   Enter_any_text:"Кез келген мәтінді енгізіңіз", 
	   Advisor_Success_Manager:"Кеңесші / Табыс менеджері", 
	   User_Id:"Қолданушының ID", 
	   phone_number:"Телефон нөмірі", 
	   Student_Last_Name:"Студенттік тегі", 
	   Student_First_Name:"Студенттің аты-жөні", 
	   Student_Email:"Студенттік электрондық пошта",
	   credentials:"Куәлік", 
	   availability:"Жолы ашықтық",
	   enrollments:"Тіркеулер", 
	   Datea_Created_on:"Жасалған күн",
	   country:"Ел", 
	   state:"Штат", 
	   zipcode:"ZIPCODE", 
	   Enter_any_zipcode:"Кез келген Zipcode енгізіңіз", 
	   address:"Айналу",
	   zip_Code:"ZIP коды",
	   Login_Report:"Кіру туралы есеп", 
	   user_Type:"Пайдаланушы түрі", 
	   user_Name:"Пайдаланушының аты", 
	   Show_last_log_in_only:"Тек соңғы кіріңіз", 
	   Username:"Пайдаланушы аты", 
	   Date_Time:"Күні / уақыты", 
	   Ip_Address:"IP мекенжайы", 
	   city:"Қала",
	   Enrollment_Start_Date:"Тіркелу басталу күні", 
	   Enrollment_End_Date:"Тіркелу күні", 
	   Completion_Date:"Аяқталу күні", 
	   section_Type:"Бөлім түрі", 
	   student_Enrolled:"Студент тіркелді", 
	   content_Provider:"Мазмұн провайдері", 
	   student_Additional_Fields:"Студенттің қосымша өрістері",
	   type:"Басу", 
	   in_Class_Information:"Сабақ туралы ақпарат", 
	   Enrollment_Summary_Report:"Тіркелу туралы қысқаша есеп", 
	   Transferred_From_School:"Мектептен өткізілді",
	   Total_Enrollments:"Жалпы қабылдау", 
	   content_Type:"Мазмұн түрі", 
	   active_Course_Progress:"Белсенді курстың прогресі",
	   Grades:"Бағалар", 
	   attendance:"Бару",
	   student_Absences:"Студенттер қатысады", 
	   total_Absence:"Жалпы болмау", 
	   section_Absences:"Бөлім сабақтары",
	   Grade_Level_Absences:"Бағалар деңгейі",
	   Gender_Absences:"Гендерлік сабақ",
	   Login_credentials:"Кіру Тіркелгі деректері", 
	   names:"Ашулар", 
	   user_status_admin_teacher_parent:"Пайдаланушының күйі (әкімші, мұғалім, ата-ана)", 
	   show_title:"Тақырыпты көрсету", 
	   midle_name:"Екінші аты", 
	   password:"Пароль", 
	   parent_name:"Ата-аналық атауы", 
	   linked_to_parent:"Ата-аналарға байланыстырылған", 
	   linked_to_student:"Студентпен байланыстырылған",
	   login_credentials_Report:"Кіру Тіркелгі деректері туралы есеп", 
	   app_id:"Қолданба идентификаторы", 
	   created:"Құрылған", 
	   modified:"Түрлендірілген",
	   select_level:"Деңгей таңдаңыз", 
	   select_additional_fields:"Қосымша өрістер", 
	   title:"Тақырып", 
	   credits:"Несиелер", 
	   section_ID:"Бөлім идентификаторы", 
	   content:"Мазмұны", 
	   course_additional_fields:"Курстың қосымша өрістері",
	   course_id:"Курстың жеке куәлігі", 
	   communication_summary_report:"Байланыс жиынтығы туралы есеп", 
	   method:"Әдіс", 
	   create_date:"Күн құру", 
	   subject:"Душар қылу", 
	   make_from_id:"Жеке куәліктен", 
	   make_to:"Жасау", 
	   attachments:"Тіркемелер", 
	   comment_and_document_summary_report:"Түсініктеме және құжат жиынтығы туралы есеп", 
	   comment_type:"Түсініктеме түрі", 
	   flagged:"Жалауша қойылды", 
	   sharing_target:"Мақсатты бөлісу", 
	   show_on_transcript:"Транскрипт туралы көрсету", 
	   by:"-Дан", 
	   comment:"Ескерту", 
	   type_name:"Тип атауы", 
	   effective_from_date:"Күшінен тиімді", 
	   effective_to_date:"Бүгінгі күнге дейін", 
	   count_docs:"Докс санайтын",
	   school_calendar_report:"Мектеп күнтізбесі туралы есеп", 
	   event_Id:"Оқиға идентификаторы", 
	   date_start:"Күн басталуы", 
	   date_end:"Күні", 
	   posted_last_name:"Тегі жарияланған", 
	   posted_first_name:"Аты-жөні",
	   bell_schedule_report:"Қоңырау кестесі туралы есеп", 
	   period:"Етекпір", 
	   start:"Жүргізу", 
	   end:"Соңы",
	   student_contract_report:"Студенттік келісім-шарттың есебі", 
	   begin_date:"Бастау күні", 
	   contracts:"Келісімшарттар", 
	   contract_name:"Шарт атауы", 
	   contract_begin_date:"Келісімшарт басталу күні", 
	   contract_end_date:"Келісімшарттың аяқталу күні",
	   active_enrollments_per_term_report:"Үстеме есеп беру үшін белсенді қабылдау", 
	   entry_date:"Кіру күні", 
	   teachers:"Мұғалімдер", 
	   term:"Мерзім",
	   sections:"Бөлімдер",
	   showing_of:"10-дан 20-ны көрсету",
	   filter:"Сүзу",
	   students:"Оқушылар",
	   school:"мектеп",
	   all_school:"Барлық мектептер",
	   student:"Студент",
	   email:"Электрондық пошта",
	   grade_level:"Сынып деңгейі",
	   status:"Күй",
	   seach_for_a_student_or_id:"Студент немесе жеке куәлікті іздеу ...",
	   search:"Іздеу...",
	   message_student:"Хабарлама оқушы",
	   request_enrollment:"Тіркеуді сұрау",
	   print_schedule:"Басып шығару кестесі",
	   view:"Көру",
	   no_data:"Деректер жоқ.",
	   views:"Көрулер", 
	   enrollment:"Тіркелу", 
	   schedule:"Кесте", 
	   transferred_grades:"Ауыстырылған бағалар", 
	   comments_ocuments:"Түсініктемелер және құжаттар", 
	   academic_records:"Академиялық жазбалар", 
	   compliance_log:"Сәйкестік журналы", 
	   unofficial_transcript:"Бейресми транскрипт", 
	   iD_card:"Жеке куәлік", 
	   student_number_id_information:"Студент нөмірі №29561 Ақпарат", 
	   student_number:"Студент саны", 
	   gender:"Жыныс", 
	   goes_by:"Өтіп жатыр", 
	   date_of_birth:"Туған кезі", 
	   ethnicity:"Этникалық", 
	   mobile:"Ұялы", 
	   academic_track:"Академиялық трек", 
	   learning_path_template:"Оқу жолы үлгісі", 
	   graduation_date:"Бітіру күні", 
	   comments:"Пікірлер", 
	   transfer_information:"Ақпаратты тасымалдау", 
	   enrollment_date:"Тіркеу күні", 
	   transfer_date:"Тасымалдау күні", 
	   transfer_student:"Студентті ауыстыру", 
	   parent_mentor_contact:"Ата-ана/тәлімгер байланысы", 
	   mentor:"Тәлімгер", 
	   parent_phone:"Ата-анасының телефоны", 
	   emergency_contact:"Төтенше байланыс", 
	   academic_advisor_ssm:"Академиялық кеңесші / SSM", 
	   student_success_manager:"Студенттердің жетістік менеджері", 
	   academic_avisor:"Академиялық кеңесші", 
	   address:"Мекенжай", 
	   address_01_Default:"01 мекенжайы (әдепкі)", 
	   street:"Көше", 
	   city:"Қала", 
	   state:"Мемлекет", 
	   zip:"Zip", 
	   hide_Detailed_information:"Толық ақпаратты жасыру", 	    
	   current_course_progress:"Ағымдағы курстың барысы", 	    
	   full_Path_Progress:"Толық жол барысы", 	    
	   print:"Басып шығару", 	    
	   avg_graduation_progress:"Орт. Бітіру барысы", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Бітіру мәртебесі", 	    
	   on_track:"Жолда",
	   show_detailed_information:"Толық ақпаратты көрсету",
	   communication:"Байланыс",
		student_advisors:"Студенттік кеңесшілер", 	    
	   country:"Ел", 	    
	   grade:"Баға", 	    
	   credits:"Несиелер", 	    
	   sort:"Сұрыптау", 	    
	   course_progress:"Курстың барысы",
	   overall_GPA:"Жалпы GPA",
	    current_graduation_progress:"Ағымдағы бітіру барысы",
		individual_course_progress:"*Жеке курс үлгерімі өзгереді, бұл сіздің жалпы үлгеріміңіз",
		subject:"Тақырып",
		online_sections:"Онлайн бөлімдер",
	   course:"Курс",
	   section:"Бөлім", 
	   actions:"Әрекеттер", 
	   view_event:"Іс-шараны қарау",
	   in_class_section:"Сабақ бөлімінде",
	   calendar:"Күнтібзе",
	   access_link:"Кіру сілтемесі", 
	   online_link:"Онлайн сілтеме",
		launch_course:"Іске қосу курсы", 
	   start_class:"Сыныпты бастау",
	   level:"Деңгей", 
	   date:"Күн", 
	   transferred_in:"Аударылған",
	   tranferred_grades:"Ауыстырылған бағалар",
	   Searchs:"Іздеу", 
	   Search_department_course:"Іздеу бөлімі курсы, src…",
	   archived:"Мұрағатталған", 
	   add_comment:"Пікір қосу", 
	   created_date:"Құрылған күні", 
	   by:"Авторы", 
	   type:"Түр", 
	   comment:"Түсініктеме", 
	   from_date:"Күннен бастап", 
	   to_date:"Бүгінгі күнге дейін", 
	   documents:"Құжаттар", 
	   edit:"Өңдеу", 
	   delete:"Жою",
	   communications:"Коммуникациялар", 
	   add_communications:"Байланыс қосу", 
	   made_from:"Жасалған", 
	   made_to:"Жасалған", 
	   means:"білдіреді", 
	   attachments:"Қосымшалар", 
	   content:"Мазмұны",
	   compliance_logs:"Сәйкестік журналдары", 
	   messageID:"Хабар идентификаторы", 
	   agree:"Келісемін", 
	   dateTime:"Күн уақыты", 
	   iPAddress:"IP мекенжайы", 
	   add_idit_comment_document:"Түсініктеме мен құжатты қосу/өңдеу", 
	   document_type:"Құжат түрі", 
	   show_on_transcript:"Транскриптте көрсету", 
	   select_users_to:"Пайдаланушыларды таңдаңыз", 
	   teacher:"Мұғалім", 
	   parent:"Ата-ана", 
	   flag:"Жалау", 
	   none:"Жоқ", 
	   link:"Сілтеме", 
	   label:"Заттаңба", 
	   add_more_link:"Қосымша сілтеме қосу", 
	   save:"Сақтау", 
	   add_edit_communication:"Байланысты қосу/өңдеу", 
	   made_by:"Жасаған", 
	   date_time:"Күні/Уақыты", 
	   length:"Ұзындығы", 
	   select:"таңдаңыз", 
	   select_users_to_view:"Байланысты көру үшін пайдаланушыларды таңдаңыз", 
	   add_more:"Қосымша қосу", 
	   communication_summary:"Қарым-қатынас туралы қорытынды",
	   close:"Жабық",
	   new_type:"Жаңа түрі",
	   select_user_to_view_comment:"Пікірді көру үшін пайдаланушыларды таңдаңыз",
	   flag_comment:"Түсініктемені белгілеу",
	   teacher_page:"Мұғалім беті",
	   edit_information:"Ақпаратты өңдеу",
	   phone:"Телефон",
	   add_credential:"Тіркелгі деректерін қосыңыз",
	   add_edit_credential:"Тіркелгі деректерін қосу/өңдеу",
	   first_name:"Аты",
	   midle_name:"Әкесінің аты",
	   last_name:"Тек",
	   cancel:"Болдырмау",
	   add_new:"Жаңа қосу",
	   phone_type:"Телефон түрі",
	   zipCode:"Пошта индексі",
	   phone_number:"Телефон нөмірі",
	   default:"Әдепкі",
	   please_select_country:"Елді таңдаңыз",
	   student_information:"Студенттік ақпарат",
	   username:"Пайдаланушы аты",
	   user_directory:"Пайдаланушы каталогы",
	   add_teacher:"Мұғалім қосу",
	   add_admin:"Әкімші қосыңыз",
	   export_to_excel:"Excel бағдарламасына экспорттау",
	   export_to_pdf:"PDF файлына экспорттау",
	   send_login_credentials:"Кіру тіркелгі деректерін жіберу",
	   search_for_a_user_or_id:"Пайдаланушыны немесе идентификаторды іздеу…",
	   user:"Пайдаланушы",
	   school_admin:"Мектеп әкімшілігі",
	   change_password:"Құпия сөзді өзгерту",
	   set_password_expiration_date:"Құпия сөздің жарамдылық мерзімін орнатыңыз",
	   impersonate_user:"Еліктеу пайдаланушы",
	   edit_user_tags:"Пайдаланушы тегтерін өңдеу",
	   add_or_edit_users_schoo_assign:"Пайдаланушыларды мектеп тағайындауын қосыңыз немесе өңдеңіз",
	   assign_content_access:"Мазмұнға қол жеткізуді тағайындаңыз",
	   add_student:"Оқушы қосу",
	   add_parent_mentor:"Ата-ананы/тәлімгерді қосыңыз",
	   showing:"Көрсетілуде",
	   of:"бойынша",
	   school_name:"Мектеп аты",
	   edit_user_school_tags:"Пайдаланушы мектеп тегтерін өңдеу",
	   personal_information:"Жеке ақпарат",
	   contacted_load:"Байланыстағы жүктеме",
	   maximum_of_active_students:"Белсенді оқушылардың ең көп саны",
	   teacher_since:"Содан бері мұғалім",
	   login_infomation:"Жүйеге кіру ақпараты",
	   username:"Пайдаланушы аты",
	   password :"Құпия сөз",
	   avatar :"Аватар",
	   teachers :"Мұғалімдер",
	   change_status :"Күйді өзгерту",
	   add_admin:"Әкімші қосыңыз",
	   name:"Аты",
	   create_on:"Жасау қосулы",
	   registrar:"Тіркеуші",
	   birthday:"Туған күн",
	   signature:"Қол қою",
	   photo:"Фото",
	   designated_registrar:"Белгіленген тіркеуші",
	   track:"Трек",
	   select_existing_track:"Бар жолды таңдаңыз",
	   available:"Қол жетімді",
	   parent_mentor:"Ата-ана/тәлімгер",
	   relationship:"Қарым-қатынас",
	   email_address:"Электрондық пошта",
	   academic_mentor:"Академиялық тәлімгер",
	   no_data_available_in_table:"Кестеде деректер жоқ",
	   primary_language:"Негізгі тіл",
	   add_into_parent_or_mentor:"Ата-анаға / тәлімгерге қосу",
	   add_into_phone:"Телефонға қосыңыз",
	   add_into_address:"Мекенжайға қосыңыз",
	   select_one:"Біреуін таңдаңыз",
	   login:"Кіру",
	   plese_select_country:"Елді таңдаңыз",
	   edit_student:"Оқушыны өңдеу",
	   academic_advisor_or_student_success_manager:" Академиялық кеңесші / Студенттердің жетістік менеджері",
	   role:"Рөл",
	   link_parent:"Ата-анаға сілтеме",
	   link_advisor_sms:"Сілтеме кеңесшісі/SSM",
	   save_into_parent_mentor:"Ата-анаға/тәлімгерге сақтаңыз",
	   save_into_parent_phone:"Телефонға сақтаңыз",
	   save_into_parent_address:"Мекенжайға сақтаңыз",
	   bulk_information_update:"Ақпаратты жаппай жаңарту",
	   enrollments:"Тіркелулер",
	   email_student:"Студентке электрондық пошта",
	   unofficial_transcripts:"Бейресми транскрипттер",
	   official_transcripts:"Ресми транскрипттер",
	   email_students_schedule:"Студенттік кестені электрондық поштамен жіберу",
	   export_students_to_excel:"Оқушыларды Excel бағдарламасына экспорттау",
	   export_parent_list_to_excel:"Негізгі тізімді Excel бағдарламасына экспорттау",
	   assign_learning_path_template:"Оқу жолының үлгісін тағайындаңыз",
	   promote_student_to_the_next_grade_level:"Оқушыны келесі сынып деңгейіне көтеру",
	   batch_upload_students:"Топтық жүктеп салу студенттері",
	   batch_upload_transfer_grades:"Пакеттік жүктеп салуды тасымалдау бағалары",
	   transfer_apex_only:"Тасымалдау (тек APEX)",
	   transfer_content_providers:"Тасымалдау (барлық мазмұн жеткізушілері)",
	   batch_enrollments:"Пакеттік тіркеулер",
	   send_message:"Отправить сообщение",
	   impersonate:"Выдавать себя за",
	   change_login_credentials:"Изменить учетные данные для входа",
	   request_enrollment:"Запросить регистрацию",
	   send_weekly_status_report:"Отправить еженедельный отчет о состоянии",
	   please_select_student:"Оқушыларды таңдаңыз.",
	   student_status_will_be_changed_to_status_withdraw:"Студенттік мәртебесі 111-ге өзгертіліп, барлық жазылулар алынып тасталады. Жалғастырғыңыз келе ме?",
	   student_status_will_be_changed_to_status:"Студенттің мәртебесі 111-ге өзгертіледі. Сіз жалғастырғыңыз келе ме?",
	   value:"Бағалау",
	   student_success_manager_or_acdemic:"Студенттік жетістіктер жөніндегі менеджер / Академиялық кеңесші",
	   enroll_students_to_section:"Студенттерді бөлімге жазыңыз",
	   department:"Бөлім",
	   refresh:"Сергіту",
	   select_department:"Бөлімді таңдаңыз",
	   select_course:"Курсты таңдаңыз",
	   select_section:"Бөлімді таңдаңыз",
	   start_date:"Басталатын күн",
	   end_date:"Аяқталу күні",
	   ID:"Куәлік",
	   action:"Ірекет",
	   enrollment_period:"Тіркелу мерзімі",
	   select_a_course_to_register_ilp:"ILP тіркеу үшін курсын таңдаңыз",
	   period:"Етекпір",
	   credit:"Несие",
	   year:"Жыл",
	   enroll:"Жазылу",
	   recipient_transcript:"Алушы транскрипт",
	   select_all_or_unselect_all:"Барлығын таңдаңыз / Барлығын алып тастаңыз",
	   include_in_progress_sections:"Орындалу барысы бөліміне кіріңіз",
	   show_satisfaction_of_program:"Бағдарламаның қанағаттанушылығын көрсету",
	   show_total_credit:"Жалпы несие көрсету",
	   show_student_info:"Студенттік ақпараттарды көрсету",
	   show_academic_info:"Академиялық ақпаратты көрсету",
	   show_school_names_from_orther_grades:"Басқа сыныптардан мектеп атауларын көрсету",
	   show_school_contact:"Мектептегі контактілерді көрсету",
	   include_transferred_grades_in_gpa:"GPA-да берілген бағаларды қамтиды",
	   include_in_progress_grade:"Прогресс бағасына кіріңіз",
	   include_grade_scales:"Сынып шкалаларын қосыңыз",
	   show_graduation_date:"Бітіру күнін көрсету",
	   show_weighted_gpa:"Салмақты GPA көрсетіңіз",
	   show_grade_level_gpa:"GPA деңгейін көрсету",
	   show_comletion_date:"Табылған күнді көрсету",
	   show_withdraw_classes:"Алынған сабақтарды көрсету",
	   show_withdraw_date:"Алынған күнді көрсету",
	   show_transfered_in_classes:"Сабақтарға ауысу",
	   show_digital_seal:"Сандық тығыздағышты көрсету",
	   show_singnature:"Қолтаңбаны көрсету",
	   group_by:"Тобы",
	   school_year:"Оқу жылы",
	   school_level:"Мектеп деңгейі",
	   notes:"ЕСталдар",
	   ok:"Жарайды ма",
	   are_you_sure_to_send:"Сіз жібересіз бе?",
	   assign_learning_path_templete:"Оқу жолының шаблонын тағайындаңыз",
	   assign_student_to_selected_learning:"Оқушыны таңдау жолының шаблонына тағайындаңыз",
	   assign:"Белгілеу",
	   are_you_sure_to_promote_to_level:"Келесі сынып деңгейіне сенесіз бе?",
	   data_process:"Деректер процесі",
	   upload_and_import_data:"Деректерді жүктеу және импорттау",
	   download_user_information:"Пайдаланушы туралы ақпаратты жүктеңіз",
	   here:"Мұнда",
	   select_student_upload_file:"Студенттік жүктеу файлын таңдаңыз",
	   local_drive:"Жергілікті диск",
	   the_file_is_uploaded:"Файл жүктелген",
	   template_name:"Үлгі аты",
	   Here:"Мұнда",
	   sample_file_excel:"Excel файлының үлгісі.",
	   file_type:"Файл түрі",
	   delimited:"Бөлінген",
	   delimited_chars:"Бөлінген chars",
	   fixed_width:"Бекітілген ен",
	   first_line_header:"Бірінші жол тақырыбы",
	   loader_field:"Жүктеме өрісі",
	   Header:"Үстіңгі жо",
	   sample_data:"Деректер үлгісі",
	   column_width:"Колунм ені",
	   save_tamplate:"Шаблонды сақтау",
	   save_and_upload_data:"Деректерді сақтау және жүктеу",
	   result:"Нәтиже",
	   upload_and_import_data_orther_grade:"Деректерді жүктеу және импорттау Басқа сыныптар",
	   select_upload_file:"Жүктеу файлын таңдаңыз",
	   student_id:"Студенттік куәлік",
	   uploadAnd_import_data_enrollment:"Деректерді тіркеу және импорттау",
	    section_id:"Бөлім идентификаторы",
	   title:"Тақырып",
	   recipient:"Алушы",
	   same_current_address:"Ағымдағы мекен-жаймен бірдей",
	   add_more_reciptient:"Қосымша алушыны қосыңыз",
	   issuse_date:"Берілу күні",
	   show_total_unapplied_credits:"Жалпы қолданылмаған несиелер көрсетіңіз",
	   reconcile_another_student_record:"Басқа студенттік жазбамен келісу",
	   please_choose_one_student_to_reconcile:"Өтінемін, бір оқушыны таңдау үшін таңдаңыз.",
	   yes:"Иә",
	   no:"Жоқ",
	   apex_classroom_sync:"Apex сынып оқу бөлмесі синхрондау",
	   next:"Келесі",
	   apex_classrooms:"APEX сынып бөлмелері",
	   online_user_id:"Интернеттегі пайдаланушы идентификаторы",
	   enter_online_user_id:"Интернеттегі пайдаланушы идентификаторын енгізіңіз",
	   online_section_id:"Интернеттегі бөлім",
	   online_section_name:"Интернеттегі бөлім атауы",
	   online_course_name:"Онлайн курс атауы",
	   enrollment_date:"Тіркелу күні",
	   back:"Көмектесу",
	   import:"Импорт",
	   offical_transcipt:"Ресми транскрипт",
	   email_schedule:"Электрондық пошта кестесі",
	   reconcile_with_another_records:"Басқа жазбамен келісу",
	   online_sync_and_update:"Интернеттегі прогресті синхрондау және жаңарту",
	   download_all_completion_cretification:"Барлық аяқтау сертификатын жүктеу",
	   orther_grade:"Басқа бағалар",
	   medical:"Медициналық",
	   comments_and_documents:"Пікірлер мен құжаттар",
	   contracts:"Келісімшарттар",
	   invoices:"Шот-фактуралар",
	   audit_logs:"Аудит журналдары",
	   edit_logs:"Журналдарды өңдеу",
	   grade_to_date:"Бүгінгі таңда",
	   quality_of_work:"Жұмыс сапасы",
	   last_access:"Соңғы қатынас",
	   gradebook:"Сыныптама",
	   transfer:"Ауыстыру",
	   completion_certification:"Аяқтау сертификаты",
	   tranfer_user_school:"Пайдаланушы мектебін ауыстыру",
	   tranfer_to_school:"Мектепке ауысу",
	   tranfer_apex_classrooms:"Apex сынып бөлмелерін ауыстыру",
	   course_to_moved:"Көшу курсы",
	   current_teacher:"Қазіргі мұғалім",
	   future_section:"Болашақ бөлім",
	   future_program:"Болашақ бағдарлама",
	   future_teacher:"Болашақ мұғалім",
	   enrollment_start_date_end_date:"Тіркелу басталу күні - Аяқталу күні",
	   no_more_option:"Қосымша опциялар жоқ",
	   create_new:"Жаңа жасаңыз",
	   transfer_classrooms:"Аудармалар",
	   tyler_synchronization_for_az_school:"AZ мектептеріне арналған Tyler синхронизациясы",
	   synchronize:"Үндестіру",
	   individual_course_progress_varies:"Жеке курстың прогресі өзгереді. Бұл сіздің бітіруге қатысты жалпы барысы.",
	   edit_ilp:"ILP өңдеңіз",
	   add_academic_record:"Академиялық жазбаны қосыңыз",
	   edit_all_records:"Барлық жазбаларды өңдеңіз",
	   search_corse_department_src:"Іздеу курсы, кафедрасы, SRC ...",
	   message_id:"Хабарлама идентификаторы",
	   add_new_contract:"Жаңа келісімшартты қосыңыз",
	   contract_id:"Келісімшарт бойынша жеке куәлік",
	   contract_name:"Шарт атауы",
	   first_date:"Бірінші күн",
	   last_date:"Соңғы күн",
	   amount_per_period:"Бір кезеңге сома",
	   terminating_status:"Күйді тоқтату",
	    payment_history:"Төлем тарихы",
	   record_payment:"Жазба төлем",
	   payment_method:"Төлем тәсілі",
	   invoice_id:"Шот-фактура идентификаторы",
	   show_all:"Барлығын көрсету",
	   invoice_date:"Шот-фактура күні",
	   from:"From...",
	   to:"To...",
	   amount:"Сан",
	   paid:"Ақылы",
	   due:"Өюсіз",
	   date_paid:"Ақылы күн",
	   apply_payments:"Төлемдерді қолдану",
	   mark_as_paid:"Төленген ретінде белгілеңіз",
	   void:"Заңсыз",
	   audit_log:"Аудит журналы",
	   object:"Қарсы болу",
	   changes_made:"Өзгерістер енгізілді",
	   create_time:"Уақытты жасаңыз",
	   time_stamp:"Уақыт белгісі",
	   user_creare:"Пайдаланушы жасайды",
	   edit_log:"Журналды өңдеу",
	   field_name:"Өріс атауы",
	   old_value:"Ескі мән",
	   new_value:"Жаңа мән",
	   date_time_update:"Күні / уақытын жаңарту",
	   updater:"Жаңартушы",
	   add_edit_academic_records:"Академиялық жазбаны қосу / өңдеу",
	   select_flag:"Жалаушаны таңдаңыз ...",
	   edit_all_tranferred_grades:"Барлық трансферді бағаларды өңдеңіз",
	   save_records:"Жазбаларды сақтаңыз",
	   possible_credits:"Мүмкін несиелер",
	   select_level:"Деңгей таңдаңыз",
	   select_grade_level:"САҒЫҢЫЗДЫ таңдаңыз",
	   select_status:"Күй таңдаңыз",
	   add_more_row:"Басқа қатар қосыңыз",
	   full_screen:"Толық экран",
	   course_code:"Басқа бағаларды қосыңыз",
	   add_order_grades:"Курстың коды",
	   select_credit:"Несие таңдаңыз",
	   select_default:"Әдепкі таңдаңыз",
	   credits_possible:"Несиелер мүмкін",
	   select_possible_credit:"Мүмкін несие таңдаңыз",
	   product:"Өнім",
	   fromn:"-Ден",
	   ton:"Қарай",
	   last_invoice_date:"Соңғы шот-фактура күні",
	   please_select_stu:"Студентті таңдаңыз",
	   payer:"Төлеуші",
	   amount_per_billing_period:"Есеп айырысу кезеңі",
	   price_unit:"Бағалар бірлігі",
	   billing_period:"Есеп айырысу кезеңі",
	   automatic_renewal:"Автоматты жаңарту",
	   automatic_payment:"Автоматты есеп айырысу",
	   duration_of_period:"Ұзақтығы (кезеңдер саны)",
	   payment_id:"Төлем идентификаторы",
	   payment_date:"Төлем күні",
	   payment_amount:"Төлем сомасы",
	   applied:"Өтініш",
	   available:"Жолы ашық",
	   unApply:"Араластыру",
	   refund:"Төлеу",
	   add_new_teacher:"Жаңа мұғалім қосыңыз",
	   change_teacher_status:"Мұғалімнің мәртебесін өзгерту",
	   search_for_a_teacher_or_id:"Мұғалімді немесе жеке куәлікті іздеңіз ...",
	   flags:"Жалаулар",
	   tags:"Тегтер",
	   allowed:"Рұқсат",
	   message_teacher:"Хабарлама мұғалімі",
	   impersonate_teacher:"Халыққа мұғалім",
	   add_teacher_qualification:"Мұғалімдер біліктілігін қосу",
	   profile:"Қырынан бейнелеу",
	   teacher_schedule:"Мұғалім кестесі",
	   qualifications:"Біліктілік",
	   student_actions:"Студенттік іс-шаралар",
	   linking_parents_to:"Ата-аналарды байланыстыру",
	   select_do:"Таңдау ...",
	   see_edit_logs:"Журналдарды өңдеу бөлімін қараңыз",
	   see_qualifications:"Біліктіліктерді қараңыз",
	   link_academic_advisor:"Ғылыми жетекшінің байланысы",
	   student_success:"Студенттік жетістік",
	   linking_academic_advisor_or_student_success:"Ғылыми жетекшімен байланысу / студенттердің жетістігін байланыстыру",
	   staff:"Қызметкерлер штаты",
	   teacher_status:"Мұғалім мәртебесі",
	   school_admin_status:"Мектеп әкімшісінің жағдайы",
	   global_user_directory:"Ғаламдық пайдаланушы каталогы",
	   edit_teacher:"Мұғалімді өңдеңіз",
	   contracted:"Келісім-шарт",
	   add_comments_and_documents:"Пікірлер мен құжаттар",
	   edit_comments_and_documents:"Пікірлер мен құжаттарды өңдеу",
	   parents_or_mentor:"Ата-аналар / тәлімгер",
	   send_mail:"Пошта жіберу",
	   are_you_sure_to_delete_this_teacher:"Сіз бұл мұғалімді жоясыз ба?",
	   edit_user_password:"Пайдаланушы аты мен парольді өңдеңіз",
	   add_qualifications:"Біліктіліктер қосу",
	   please_select_a_least_on_teacher:"Кем дегенде бір мұғалімді таңдаңыз.",
	   edit_parent_mentor:"Ата-аналық / тәлімгерді өңдеңіз",
	   parent_mentor_information:"Ата-ана / тәлімгер туралы ақпарат",
	   send:"Жіберу",
	   are_you_surse_to_delete_this_parent:"Сіз осы ата-ананы жоясыз ба?",
	   home:"Үй",
	   
	   //auto_promotion:"Авто жылжыту",
	   auto_promotion:"Студенттік сынып деңгейін жоғарылату",
	   Promote:"Жарнамалау",
	   search_for_a_name:"Аты іздеу ...",
	   download_to_excel:"Excel-ге жүктеу",
	   download_to_pdf:"PDF-ке жүктеу",
	   User_ID:"Қолданушының ID",
	   User_type:"Пайдаланушы түрі",
	   communication_log:"Байланыс журналы",
	   Student_Status:"Студенттік мәртебе",
	   Users:"Пайдаланушылар",
	   Staff_Reassignment:"Қызметкерлерді қайта тағайындау",
	   Select_Staff:"Қызметкерлерді таңдаңыз",
	   select_asset_type_to_reassign:"Қайта тағайындау үшін актив түрін таңдаңыз",
	   transfer_all_to:"Барлығын беру",
	   transfer_selectively:"Таңдау үшін",
	   remove_all:"Барлығын алып тастаңыз",
	   remove_selectively:"Таңдау",
	   Event:"Оқиға",
	   Time:"Уақыт",
	   Participants:"Қатысушылар",
	   new_staff:"Жаңа қызметкерлер",
	   Remove:"Кетіру",
	   Profile_Page:"Профиль беті",
	   settings:"Параметрлер",
	   security:"Қауіпсіздік",
	   timezone:"TayZone",
	   notifications:"Хабарландырулар",
	   check_for_feature_availability_at_your_school:"Мектебіңізде мүмкіндіктің қол жетімділігін тексеріңіз.",
	   current_password:"ағымдағы құпия сөз",
	   new_password:"Жаңа Құпия Сөз",
	   confirm_password:"Құпия сөзді Растау",
	   updte_password:"Құпия сөзді жаңарту",
	   change_timezone:"TimeZone-ді өзгерту",
	   time_zone:"Уақыт белдеуі",
	   please_select_time_zone:"Уақыт белдеуін таңдаңыз",
	   notification_settings:"Хабарландыру параметрлері",
	   level_of_urgency:"Шұғыл деңгейі",
	   email_destination:"Электрондық пошта тағайындауы",
	   SMS_Destination:"SMS баратын жері",
	   app:"Бағдарша",
	   please_select_level_of_urgency:"Шұғыл деңгейін таңдаңыз",	  
	   reset_filters:"Сүзгілерді қалпына келтіріңіз",
	   batch_data_update:"Студенттік деректерді жаңарту",
	   contract_template:"Modello di contratto",
	   accept:"Accettare",
	   reject:"Rifiutare",
	   view_roles:"Рөлдерді қарау",
	   administrator_information:"Әкімші туралы ақпарат", 
	   account_reation_date:"Тіркелгіні жасау күні", 
	   expiration_date:"Мерзімнің өту күні", 
	   schools:"Мектептер", 
	   advisees:"Антестіктер",
	   message:"Хабар",
	   see_comments_and_documents:"Пікірлер мен құжаттарды қараңыз",
	   restore_APEX_Classrooms:"Apex сыныптарын қалпына келтіру",
	   teacher_information:"Мұғалім туралы ақпарат", 
	   teacher_number:"Мұғалім нөмірі", 
	   departmens:"Кітапандар", 
	   global_capacity:"Ғаламдық сыйымдылығы", 
	   local_contracted_load:"Жергілікті келісімшарт жүктемесі", 
	   parents:"Ата-ана", 
	   parent_information:"Ата-ана туралы ақпарат",
	   linked_students:"Байланыстырылған студенттер", 
	   link_student:"Студент", 
	   unlink_student:"Студентке қарсы", 
	   search_dot:"Іздеу ...", 
	   view_local:"Жергілікті қарау", 
	   view_global:"Ғаламдық көрініс",
	   resource:"Ресурс",
	   current_grade:"Ағымдағы баға", 
	   affiliation:"Елестету", 
	   current_assignment:"Ағымдағы тапсырма", 
	   total_assignments:"Жалпы тапсырмалар", 
	   percent_completed:"Пайыз аяқталған",
	   semester:"съеш",
	   graduation_year:"Бала бітіру жылы", 
	   student_name:"Алынған кредит", 
	   credits_earned:"Алынған кредит",
	   exit:"Шығу",
	   engagement_type:"Келісім түрі",
	   college_admitted:"Колледж қабылданды", 
	   college_attending:"Колледжге қатысу", 
	   major:"Майор", 
	   report_card:"Есеп карточкасы", 
	   academic_term:"Академиялық мерзім", 
	   show_average:"Орташа көрсету",
	   school_information:"Мектеп туралы ақпарат",
	   school_misc_configuration:"Мектеп Misc конфигурациясы", 
	   school_tags:"Мектеп тегтері", 
	   role_tags:"Рөлдік тегтер", 
	   content_integration:"Мазмұнды біріктіру", 
	   user_roles:"Пайдаланушы рөлдері", 
	   communication_user_rules:"Байланыс пайдаланушыларының ережелері", 
	   school_administrators:"Мектеп әкімшілері", 
	   school_year_configuration:"Оқу жылының конфигурациясы", 
	   A_R_payment_configuration:"A / R төлем конфигурациясы", 
	   facility:"Нысан", 
	   enrollment_rules:"Тіркелу ережелері", 
	   student_contract_rules:"Студенттік келісім-шарттар", 
	   products:"Құралдар", 
	   notification_templates:"Хабарландыру шаблондары", 
	   transcript_viewer_options:"Транскрипт қарау құралдары", 
	   feature_configuration:"Мүмкіндік конфигурациясы", 
	   feature_settings:"Мүмкіндік параметрлері", 
	   communication_rules:"Байланыс ережелері", 
	   object_state:"Нысан күйі", 
	   departments:"Бөлімдер", 
	   grading_scales:"Бағалау шкаласы", 
	   grading_periods:"Бағалау кезеңдері", 
	   academic_tracks:"Академиялық жолдар", 
	   learning_path_templates:"Оқыту жолының шаблондары", 
	   grade_book_activity_descriptions:"Бағалау кітапшасының сипаттамалары", 
	   academic_terms:"Академиялық шарттары",
	   academic_system:"Академиялық жүйе",
	   address_line_1:"Адрестік Жол 1", 
	   country_code:"Ел коды", 
	   address_line_2:"2-мекен-жайы", 
	   school_title:"Мектеп тақырыбы",
	   CEEB_code:"CEEB коды", 
	   zip_postal_code:"Zip / Пошта индексі", 
	   state_province:"Мемлекет / провинция", 
	   website:"Сайт", 
	   subdomain:"Қосалқы", 
	   success_manager:"Табыс менеджері", 
	   school_logo:"Мектеп логотипі", 
	   digital_seal:"Сандық тығыздағыш",
	   password_exception_rule:"Парольді ерекшелік ережесі",
	   change_password_first_login:"Құпия сөзді өзгерту Алғашқы кіру", 
	   password_expires_after_days:"Пароль күннен кейін аяқталады", 
	   enforcement_of_teachers_load:"Мұғалімнің жүктелуін орындау", 
	   in_house_handling_of_transcript_requests:"Транскрипт сұраныстарын үйде ұстау", 
	   display_mobile_app_link:"Мобильді қосымшаның сілтемесі", 
	   display_weekly_progress_goal:"Апта сайынғы прогресс мақсаты", 
	   turn_on_notification:"Хабарландыруды қосыңыз", 
	   classic_letter:"Классикалық хат", 
	   automatic_parent_account_creation:"Автоматты ата-аналық есептік жазбаны құру", 
	   default_parent_account_status:"Әдепкі ата-аналық есептік жазба", 
	   default_time_zone:"Әдепкі уақыт белдеуі", 
	   link_to_transcript_vendor_help:"Транскрипт сатушысының анықтамасына сілтеме", 
	   link_to_transcript_vendor:"Транскрипт сатушысына сілтеме", 
	   link_for_help_system:"Анықтама жүйесіне сілтеме", 
	   student_enrollment_limit:"Студенттерді қабылдау шегі", 
	   default_section_type:"Әдепкі бөлім түрі", 
	   default_section_capacity:"Әдепкі бөлім сыйымдылығы",
	   transcript_template:"Транскрипт шаблоны",
	   edit_security_school_tags:"Қауіпсіздік мектеп тегтерін өңдеу", 
	   security_school_tags:"Қауіпсіздік мектебінің тегтері",
	   tags_name:"Тегтер атауы", 
	   edit_role_tags:"Рөл белгілерін өңдеңіз",
	   add_school_based_tags:"Мектепке негізделген тегтерді қосыңыз", 
	   description:"Түсіндірме", 
	   applied_to_roles:"Рөлдерге қолданылады", 
	   teacher:"Мұғалім",
	   edit_security_role_tags_for:"Қауіпсіздік рөлдерінің тегтерін өңдеңіз",
	   school_admins:"Мектеп әкімшілері",
	   school_begin_date:"Мектеп басталуы", 
	   school_end_date:"Мектептің аяқталу күні", 
	   automatic_control_of_teacher_s_load:"Мұғалімнің жүктемесін автоматты басқару",
	   A_R_payment_gateway_configuration:"A / R төлем шлюзінің конфигурациясы", 
	   payment_processing_vendor:"Төлемдерді өңдеу сатушысы", 
	   secret_key:"Құпия кілт", 
	   publishable_key:"Жарияланған кілт", 
	   account_id:"Есептік жазба идентификаторы",
	   updating_tudents:"Студенттерді жаңарту", 
	   delete_selected_records:"Таңдалған жазбаларды жою",
	   attribute_name:"Атрибут атауы", 
	   applied_for:"Үшін қолданылады",
	   add_school:"Мектеп қосу", 
	   overview:"Қайта қарау", 
	   search_for_school:"Мектепті іздеу ...", 
	   search_for_student:"Студентті іздеу ...",
	   attribute_type:"Атрибут түрі", 
	   select_school_group:"Мектеп тобын таңдаңыз", 
	   access_rights:"Қол жеткізу құқықтары", 
	   create:"Жарату", 
	   read:"Оқу",
	   facility_management:"Нысанды басқару", 
	   facility_name:"Нысанының атауы", 
	   capacity:"Сыйымдылық",
	   enrollment_allowance_period_days:"Тіркелу мерзімі (күн)", 
	   maximum_enrollment_duration_days:"Тіркелудің максималды ұзақтығы (күндер)", 
	   start_date_of_the_week:"Аптаның басталу күні", 
	   end_date_of_the_week:"Аптаның аяқталу күні",
	   lookup_name:"Іздеу атауы", 
	   duration:"Ұзақтық", 
	   time_unit:"Уақыт бөлімі", 
	   round_up_to_end_of_time_unit:"Уақыт бірлігінің аяқталуына дейін",
	   product_name:"Өнім атауы",
	   product_ID:"Өнім идентификаторы", 
	   price_offer:"Баға ұсынысы", 
	   price:"Баға", 
	   frequency:"Жиілік", 
	   effective_from:"Тиімді", 
	   effective_to:"Тиімді", 
	   active:"Белсенді",
	   drag_drop_to_text_cursor_in_content:"Мазмұндағы курсорды мәтінге апарыңыз", 
	   event_type:"Оқиға түрі", 
	   notification_rule:"Хабарландыру ережесі", 
	   level_or_ugency:"Деңгей немесе біртұтастық", 
	   user_role:"Пайдаланушы рөлі",
	   edit_security_user_tags:"Қауіпсіздік пайдаланушысының тегтерін өңдеу",
	   content_access:"Мазмұнға кіру", 
	   content_access_for:"Мазмұнға қол жеткізу", 
	   add_new_access:"Жаңа қатынас қосыңыз", 
	   date_assigned:"Тағайындалған күні",
	   enrollment_request:"Тағайындалған күні", 
	   enrollment_request_for:"Тіркелу туралы өтініш", 
	   mentors:"Тәлімгерлер",
	   options:"Опциялар",
	   department_name:"Бөлімнің атауы", 
	   universal_department:"Әмбебап бөлім", 
	   open:"Ашу",
	   min_point:"Мин", 
	   max_point:"Макс", 
	   grade_point:"Бағасы", 
	   honors:"Сыйлықтар", 
	   college:"Колледж",
	   order:"Тапсырыс", 
	   start_time:"Басталу уақыты", 
	   end_time:"Аяқталу уақыты",
	   period_name:"Кезең атауы",
	   grading_periods_head:"Бағалау кезеңдері",
	   grading_period:"Бағалау кезеңі", 
	   weight:"Салмақ",
	   track_name:"Жол атауы",
	   academic_track_requirement:"Академиялық трек талаптары", 
	   of_required_credits:"# талап етілетін несиелер",
	   individual_learning_plan_template:"Жеке оқу жоспары",
	   ILP_name:"ILP атауы",
	   remove_requirement:"Талапты жою", 
	   reset_requirement:"Қалпына келтіру қажеттілігі", 
	   add_requirement:"Талап қосу",
	   must_end_date:"Күні аяқталуы керек", 
	   courses_open_date:"Курстар ашық күн", 
	   signup_end_date:"Тіркелу күні", 
	   signup_start_date:"Тіркелу басталу күні", 
	   section_period:"Бөлім кезеңі",
	   
	   weeks:"Апта", 
	   search_for_a_section_or_id:"Бөлімді немесе жеке куәлікті іздеңіз ...",
	   search_for_a_deft:"Деп садағын іздеу ...", 	   
	   launch_course:"Іске қосу курсы", 
	   start_class:"Сыныпты бастау", 	   
	   weekly_progress_goal:"Апта сайынғы прогресс мақсаты", 
	   send_message_to_all_section_students:"Барлық бөлім студенттеріне хабарлама жіберіңіз", 
	   monitor_live_sessions:"Тікелей сессияларды бақылау", 
	   average_section_grade:"Орташа секция", 
	   resources:"Ресурс", 
	   activities:"қызмет", 	   
	   course_attendance_today:"Бүгінгі курсқа қатысу", 
	   staffs:"Қызметкерлер", 
	   units:"Қондырғылары", 	   
	   view_all_15_resources:"Барлық 15 ресурстарды қарау", 
	   Class_discussions:"Сыныптастықтар", 
	   recent_discussions:"Соңғы пікірталастар", 
	   go_to_class_discussions:"Сыныптастықтарға барыңыз", 	   
	   show_my_class_attendance:"Менің сабаққа қатысуымды көрсетіңіз", 
	   add_section:"Бөлім қосу",
	   add_global_section:"Ғаламдық бөлімді қосыңыз",
	   close_section:"Бөлімдерді жабу",
	   open_section:"Бөлімдерді ашыңыз",
	   batch_upload:"Пакеттік жүктеп салу",
	   finalize:"Аяқтау",	   
	   add_tearcger:"Мұғалімдерді қосу",
	   remove_tearcger:"Мұғалімдерді алып тастау",
	   uploadSectionStatusUpdates:"Бөлім күйінің жаңартуларын жүктеп салу",
	   status_count:"Күй саны",	   
	   reactivate:"Қайта белсендіру",
	   clone:"Клондау",
	   enroll_into_Section:"Бөлімге тіркелу",
	   bulk_enrollment:"Жаппай тіркеу",
	   general_Information:"Негізгі ақпарат",	   
	   online_content_source:"Онлайн мазмұн көзі",
	   second_teacher:"Екінші мұғалім",
	   today:"бүгін",
	   calendar:"Күнтізбе",
	   week:"апта",
	   month:"Ай",	   
	   section_progress:"Бөлімнің барысы",
	   complete:"толық",	   
	   section_title:"Бөлім атауы",
	   enter_section_title:"Бөлім тақырыбын енгізіңіз",
	   select_teacher:"Мұғалімді таңдаңыз",	   
	   select_weeks:"Апталарды таңдаңыз",
	   select_credits:"Несиелерді таңдаңыз",
	   select_type:"Түрді таңдаңыз",
	   global_section:"Ғаламдық бөлім",	   
	   enrollment_capacity:"Тіркеу сыйымдылығы",
	   enter_enrollment_capacity:"Тіркеу сыйымдылығын енгізіңіз",
	   in_class_information:"Сыныптағы ақпарат",
	   show_all:"Барлығын көрсету",
	   Start:"Бастау",
	   End:"Соңы",
	   recurrencePattern:"Қайталану үлгісі",
	   recurrenceFrequency:"Қайталану жиілігі",
	   Weekly:"Апта сайын",
	   Monthly:"Ай сайын",
	   Recur_every:"Әр қайталаныңыз",
	   Weeks_on:"Апталар",
	   day_of_week:"Аптаның күні",
	   daily_period:"Күнделікті кезең",
	   select_daily_period:"Күнделікті кезеңді таңдаңыз",
	   Day:"Күн",
	   The:"The",
	   of_every:"әрқайсысынан",
	   month_s:"ай(лар)",
	   add:"қосу",	   
	   course_prequisites :"Курстың пререквизиттері",
	   select_status:"Күйді таңдаңыз",
	   select_school:"Мектептерді таңдаңыз",	   
	   select_period:"Кезеңді таңдаңыз",
	   room_number:"Бөлме нөмірі",
	   select_room_number:"Бөлме нөмірін таңдаңыз",
	   Service:"Қызмет",
	   enter_url:"Url енгізіңіз",
	   edit_section:"Бөлімді өңдеу",
	   activity_templates:"Әрекет үлгілері",
	   select_activity_templates:"Әрекет үлгісін таңдаңыз",
	   link_section:"Сілтеме бөлімі",
	   select_link_section:"Сілтеме бөлімін таңдаңыз",
	   please_select_sections:"Бөлімдерді таңдаңыз.",
	   if_you_change_your_status_of_inactivity:"Әрекетсіздік күйіңізді өзгертсеңіз, студентке әсер етеді.",
	   closing_the_global_section_will_cause:"Ғаламдық бөлімді жабу барлық мектептердің жабылуына және олардағы барлық студенттердің кетуіне әкеледі. Жалғастыруды қаласаңыз, «Растау» түймесін басыңыз.",
	   upload_import_data:"Деректерді жүктеп салу және импорттау",	   
	   here:"Мұнда",
	   no_data_avalable_in_table:"Кестеде деректер жоқ",
	   add_teacher_to_multiple_section:"Бірнеше бөлімдерге мұғалім(лер) қосу",
	   select_teachers_to_add_to_multiple_section:"Бірнеше таңдауға қосу үшін мұғалімдерді таңдаңыз",
	   selected:"Таңдалған",
	   selected_all:"Барлығын таңдаңыз",
	   deselected_all:"Барлығын таңдауды алып тастаңыз",
	   remove_teacher_from_multiple_section:"Бірнеше бөлімнен мұғалімдерді алып тастаңыз",
	   select_teacher_to_remove_to:"Бірнеше таңдауға алып тастау үшін мұғалімдерді таңдаңыз",
	   process_removal:"Процесті жою",	   
	   clone_section:"Клондау бөлімі",
	   enroll_student:"Оқушыны тіркеу",
	   enroll_student_to:"Оқушыларды тіркеу",
	   name:"Аты",
	   search_for_a_student_or_id:"Студент немесе жеке куәлікті іздеу…",
	   confirmation_of_enrollment:"ТІРКЕЛУДІ РАСТАУ",
	   please_review_and_confirm_enrollments_for:"үшін тіркелулерді қарап шығыңыз және растаңыз",
	   confirm:"Растау",
	   enroll_students_to_section:"БӨЛІМГЕ СТУДЕНТТЕРДІ ТІРКЕЛІҢІЗ",
	   enrollment_period:"Тіркеу кезеңі",
	   days:"күндер",
	   no_data_avalible:"Дерек жоқ.",
	   number_of_primary_teacher:"Бастауыш сынып мұғалімдерінің саны",
	   secondary_teachers:"Орта мектеп мұғалімдері",
	   department_head:"Бөлім меңгерушісі",
	   section_enroll:"Бөлімге тіркелу",
	   load_from_file:"Файлдан жүктеңіз",
	   see_sections:"Бөлімдерді қараңыз",
	   change_enrollment_status:"Тіркелу күйін өзгертіңіз",
	   mentor_s:"Тәлімгер (лар)",
	   overdue_activities:"Мерзімі өткен іс-шаралар",
	   total_session_time_and_last_log:"Жалпы сессия уақыты және соңғы журнал",
	   course_name_on_transcript:"Транскрипт бойынша курс атауы",
	   edit_other_grades:"Басқа бағаларды өңдеңіз",
	   save_as:"Басқаша сақтау",
	   account_receivable_dashboard:"Есептік жазбаның дебиторлық берешек тақтасы",
	   key_performance_indicators:"Қызметтің негізгі көрсеткіштері",
	   a_r_dashboard:"A / r бақылау тақтасы",
	   payments_credits:"Төлемдер / несиелер",
	   contract_templates:"Шарт шаблондары",
	   master_contracts:"Мастер-келісімшарттар",
	   a_r_configuration:"A / R конфигурациясы",
	   a_r_processing:"A / r өңдеу",
	   aging:"Қартаю",
	   receivable:"Алынбалы",
	   account_receivable_by_program:"Бағдарлама бойынша дебиторлық берешек",
	   request_detail:"Толығырақ сұрау",
	    request_information:"Ақпарат",
	    requested_by:"Сұрады",
	    approved_by:"Мақұлдады",
	    approve:"Мақұлдау",
	    phone_name:"Телефон атауы",
	    phone_carrier:"Телефон тасымалдаушы",
		area_code:"Аймақ коды",
	   address_lable:"Жеңілдік",
	   address_default:"Мекенжай әдепкі",
	   new_photo:"Жаңа фотосурет",
	   current_of_wweeks:"Ағымдағы апта",
	   select_enrollment_period:"Тіркелу кезеңін таңдаңыз",
	   enter_rejection_reason:"Қабылдамау себебін енгізіңіз ...",
	   comments_and_documents:"Пікірлер мен құжаттар",
	   enrollment_history:"Тіркелу тарихы",
	   request_extension_for:"Кеңейту туралы сұраныс",
	   extended_of_weeks:"Бірнеше апта",
	   current_enrollment_status:"Ағымдағы тіркеу мәртебесі",
	   select_extension_option:"Кеңейту опциясын таңдаңыз",
	   extend_current_enrollment_until:"Ағымдағы тіркеуді ұзартыңыз",
	   transfer_to_new_section:"Жаңа бөлімге ауысу",
	   transcript_requests:"Транскрипт сұраулары",
	   person_requesting_transcript:"Транскрипт сұрайтын адам",
	   telephone_number:"Телефон нөмірі",
	   number_of_copies:"Көшірмелер саны",
	   special_instructions:"Арнайы нұсқаулар",
	   last_school_attendance:"Соңғы сабаққа қатысу",
	   year_last_attended:"Соңғы рет қатысты",
	   current_address:"Қазіргі мекенжай",
	   relationship_to_student:"Студентпен қарым-қатынас",
	   method_of_delivery:"Жеткізу әдісі",
	   instructions:"* Нұсқаулық",
	   previous_requests:"Алдыңғы сұраулар",
	   additional_info:"Қосымша ақпарат",
	   receive:"Алу",
	   process:"Өңдеу",
	   add_to_school_group:"Мектеп тобына қосу",
	   submit_romote:"Алға жылжу",
	   next_grade_level:"Келесі сынып деңгейі",
	   please_select_a_school_for_promotion_and_transfer:"Науқандық және беру үшін мектепті таңдаңыз",
	   write_off:"Есеп шоттан шығарып тастау",
	   amount_due:"Төлем мөлшері",
	   open_amount:"Ашық сома",
	   payment_application:"Төлем қолдану",
	   use_credit_openBalance:"Несие бойынша $ 111 қолданыңыз",
	   payment_amount_usd:"Төлем сомасы (USD)",
	   check_number:"Тексеру нөмірі",
	   confirmation_number:"Растау нөмірі",
	   apply_payment:"Төлемді қолдану",
	   amount_paid:"Төленген сома",
	   applied_payment:"Қолданбалы төлем",
	   payer_id:"Төлеуші ​​идентификаторы",
	   view_detail:"Толығырақ қарау",
	   master_contract:"Мастер-келісімшарт",
	   copy:"Еліктеу",
	   contract_user_detail:"Келісімшарт туралы мәліметтер",
	   follow_product_cost:"Өнімнің құнын қадағалаңыз",
	   default_cost:"Әдепкі құны",
	   offered_cost:"Ұсынылған құны",
	   contract_detail:"Келісім-шарт туралы мәліметтер",
	   contract_template_name:"Шарт шаблонының аты",
	    master_contract_name:"Келісімшарттың басы",
		 view_students:"Оқушыларды қарау",
		 make_payment:"Төлем жасау",
		 parent_page:"Ата-аналар беті",
		 edit_parent:"Ата-ананы өңдеңіз",
		 edit_profile:"Профильді өңдеу",
		 account_receivable_configuration:"Дебиторлық берешек конфигурациясы",
		 invoice_generation_date:"Шот-фактураны құру күні", 
	   invoice_generation:"Шот-фактураның өсуі", 
	   number_of_days_until_due_date:"Мерзімі өткен күндер саны",
	   account_receivable_processing:"Дебиторлық берешекті өңдеу",
	   generate_invoices:"Шот-фактураларды жасаңыз", 
	   process_automatic_payments:"Технологиялық төлемдер", 
	   send_late_notices:"Кеш хабарламалар жіберіңіз", 
	   course:"Курс",
	   copy_courses:"Курстарды көшіру", 
	   copy_to_school:"Мектепке көшіру", 
	   originating_program_code:"Бағдарлама коды", 
	   destinating_program_code:"Бағдарламаның бағыты", 
	   status_error:"Күй / қате",
	   add_prerequisite:"Шартты қосу", 
	   group_name:"Топ атауы", 
	   enter_group_name:"Топ атауын енгізіңіз", 
	   select_a_department_to_display_courses:"Курстарды көрсету үшін бөлімді таңдаңыз", 
	   edit_tranferred_grades:"Басқа бағаларды өңдеңіз", 
	   showing_num_records:"000 жазбаны көрсету",
	   edit_all_other_grades:"Барлық басқа бағаларды өңдеңіз",
	   upload_student_documents:"Студенттік құжаттарды жүктеңіз",
	   select_an_official_transcript_option:"Ресми транскрипт опциясын таңдаңыз", 
	   for_schools_or_personal_copy:"Мектептер немесе жеке көшірме үшін", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Студенттерді пайдалану үшін басқа мектепке жіберіңіз немесе тіркелуді тексеру үшін.", 
	   request_official_transcript:"Ресми транскрипт сұраңыз", 
	   PARCHMENT_for_colleges_or_universities:"Колледждер мен университеттер үшін пергамент", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Колледжге / университетке өтінім беру және дипломның аяқталуын тексеру үшін.", 
	   request_transcript:"Транскрипт сұрау", 
	   Learn_more_about_how_to_use_PARCHMENT:"Пергамент қолдану туралы көбірек біліңіз",
	   print_PDF:"PDF басып шығарыңыз",
	   user_school:"Пайдаланушы мектебі",
	   filter:"Сүзгі",
	   GENERAL:"Генерал", 
	   STUDENT_INFO:"Студенттік ақпарат", 
	   list:"Тізім", 
	   last_school_name:"Соңғы мектеп аты", 
	   TEACHER_INFO:"Мұғалім туралы ақпарат", 
	   contracted_load:"Келісім-шарт жүк тиеу", 
	   ARENT_INFO:"Ата-аналық ақпарат",
	   add_credential:"Тіркелгі дерегім қосыңыз",
	   edit_credential:"Тіркелгі деректерін өңдеңіз",
	   add_comment_document:"Пікір қосу және құжат қосу",
	   add_comment_document_for:"Түсініктеме қосыңыз және құжат қосыңыз",
	   state_province:"Мемлекет / провинция", 
	   post_code:"Пошта коды", 
	   linking_students_to:"Оқушыларды байланыстыру", 
	   change_expiration_date:"Жарамдылық мерзімін өзгерту", 
	   expiry_date:"Қолданылу мерзімі", 
	   please_select_department:"Бөлімді таңдаңыз.", 
	   please_select_course:"Курсты таңдаңыз.", 
	   please_select_title:"Тақырыпты енгізіңіз.", 
	   please_select_primary_teacher:"Бастапқы мұғалімді таңдаңыз.", 
	   please_select_weeks:"Бірнеше апта таңдаңыз.", 
	   please_select_level:"Деңгейді таңдаңыз.", 
	   please_select_credits:"Несиелерді таңдаңыз.", 
	   please_select_type:"Түрді таңдаңыз.", 
	   please_select_daily_period:"Күнделікті кезеңді таңдаңыз.",
	   please_enter_link_section:"Сілтеме бөлімін енгізіңіз.",
	   please_enter_first_name:"Аты-жөнін енгізіңіз.", 
	   please_enter_last_name:"Тегіді енгізіңіз.", 
	   please_enter_contracted:"Келісімшартты енгізіңіз.", 
	   please_enter_email:"Электрондық поштаны енгізіңіз.", 
	   please_enter_phone:"Телефонды енгізіңіз.", 
	   please_enter_username:"Пайдаланушы атын енгізіңіз.",
	   please_enter_password:"Құпия сөзді енгізіңіз.", 
	   please_enter_status:"Күй таңдаңыз.", 
	   save_successful:"Табысты үнемдеңіз!",
	   please_add_student_address:"Оқушы мекен-жайын қосыңыз.", 
	   please_enter_email_address:"Электрондық пошта мекенжайын енгізіңіз.", 
	   please_select_relationship:"Қарым-қатынас таңдаңыз.", 
	   please_select_parent_status:"Ата-ана күйін таңдаңыз.", 
	   please_enter_label:"Жапсырманы енгізіңіз.", 
	   please_enter_address:"Мекенжайды енгізіңіз.", 
	   please_enter_city:"ҚАЛАДЫ.", 
	   please_enter_state:"Мемлекет енгізіңіз.", 
	   please_enter_zip_code:"Пошта кодын енгізіңіз.", 
	   please_select_date_of_birth:"Туған күнін таңдаңыз.", 
	   please_select_track:"Жолды таңдаңыз.", 
	   please_enter_graduation_date:"Дипломдық күнді енгізіңіз.", 
	   please_enter_country:"Елге кіріңіз.", 
	   please_enter_phone_number:"Телефон нөмірін енгізіңіз.", 
	    please_enter_parent_first_name:"Ата-ананың атын енгізіңіз.", 
	   please_enter_parent_last_name:"Ата-аналар тегін енгізіңіз.", 
	   please_enter_parent_email_address:"Ата-аналық электрондық пошта мекенжайын енгізіңіз.", 
	   please_enter_parent_username:"Ата-ананың атын енгізіңіз.", 
	   please_select_parent_relationship:"Ата-аналармен қарым-қатынасты таңдаңыз.", 
	   please_enter_phone_label:"Телефон белгісін енгізіңіз.", 
	   student_address_canot_be_empty:"Студенттік мекен-жай бос болмауы керек.", 
	   please_select_document_type:"Құжат түрін таңдаңыз.", 
	   please_enter_new_type:"Жаңа түрді енгізіңіз.", 
	   please_enter_comment:"Түсініктемені енгізіңіз.", 
	   link_is_not_a_valid_url:"Сілтеме жарамды URL емес.",
	   please_enter_link_and_label:"Сілтеме және жапсырманы енгізіңіз.",
	   are_you_sure_to_delete_this_student:"Сіз бұл оқушыны жойғаныңызға сенімдісіз бе?",
	   please_select_gender:"Гендер таңдаңыз.",
	   school_contracted_load:"Мектептің келісімшартты жүктемесі", 
	   global_contracted_load:"Жаһандық келісім-шарт жүк тиеу",
	   please_enter_label_for_attachments:"Тіркемелерге арналған жапсырманы енгізіңіз.",
	   please_select_section:"Бөлімді таңдаңыз.", 
	   enrollment_completed_successfully:"Тіркелу сәтті аяқталды.",
	   delete_this_comment:"Бұл түсініктемені жойыңыз ба?",
	   please_enter_course_name:"Курс атауын енгізіңіз.", 
	   please_select_credits_possible:"Мүмкін несиелерді таңдаңыз.",
	   can_save_record:"Жазбаны сақтау мүмкін емес:",
	   are_you_sure_to_delete_this_tranferred_grade:"Сіз бұл маркалы бағаны жойғаныңызға сенімдісіз бе?",
	   are_you_sure_to_delete_num_tranferred_grade:"Сіз 11 маркалы бағаны жоясыз ба?", 
	   please_select_tranferred_grade:"Трансферретті бағаны таңдаңыз.",
	   please_ente_subject:"Тақырыпты енгізіңіз.", 
	   please_select_made_to:"Жалғанды ​​таңдаңыз.", 
	   delete_this_communication:"Бұл байланысты жойыңыз ба?",
	   please_select_school:"Мектепті таңдаңыз.",
	   please_enter_name:"Атын енгізіңіз.",
	   please_enter_group_name:"Топ атауын енгізіңіз.",
	   you_have_some_form_errors_please_check_above:"Сізде қандай да бір қателіктер бар. Жоғарыда көрсетілгенін тексеріңіз.",
	   please_select_recipient:"Алушыны таңдаңыз.", 
	   please_enter_description:"Сипаттаманы енгізіңіз.",
	   delete_this_resource:"Бұл ресурсты жойыңыз ба?",
	   please_enter_activity_name:"Әрекет атауын енгізіңіз.", 
	   please_select_activity_type:"Әрекет түрін таңдаңыз.", 
	   please_enter_max_score:"Max ұпайын енгізіңіз.", 
	   please_enter_due_date:"Мерзімін енгізіңіз.", 
	   please_enter_unit_name:"Бірлік атауын енгізіңіз.",
	   are_you_sure_to_clear_this_unit:"Бұл құрылғыны тазалағаныңызға сенімдісіз бе?",
	   please_enter_score:"Ұпай енгізіңіз.",
	   delete_this_credential:"Осы тіркелгі деректерін жойыңыз ба?",
	   plase_select_period:"Кезеңді таңдаңыз", 
	   plase_select_start_date:"Старт күнін таңдаңыз", 
	   plase_select_end_date:"Аяқтау күнін таңдаңыз",
	   select_to_register_course_to_students_individual_learning_path_view:"Студенттерге курсқа жеке оқу жолының көрінісі тіркелуін таңдаңыз",
       delete_this_request:"Бұл сұранысты жойыңыз ба?",
	   please_enter_fname:"Аты-жөнін енгізіңіз.", 
	   please_enter_lname:"Тегіді енгізіңіз.", 
	   please_enter_birthday:"Туған күнді енгізіңіз.", 
	   please_enter_address:"Мекенжайды енгізіңіз.", 
	   please_enter_zip:"ZIP енгізіңіз.", 
	   please_enter_country:"Елге кіріңіз.", 
	   please_enter_ethnicity:"Этникалық тұрғыдан енгізіңіз.", 
	   please_enter_grade:"Сыныпқа кіріңіз.", 
	   please_enter_mobile:"Ұялы телефонды енгізіңіз.", 
	   please_enter_hear_about_us:"Біз туралы естуіңізді өтінемін.", 
	   please_enter_program_of_interest:"Қызығушылық бағдарламасын енгізіңіз.", 
	   please_enter_course_level:"Курстың деңгейіне кіріңіз.", 
	   please_enter_guardian_1_name:"Guardian 1 атауын енгізіңіз.", 
	   please_enter_guardian_1_email:"Guardian 1 электрондық поштасын енгізіңіз.", 
	   please_enter_guardian_1_home_phone:"Guardian 1 үй телефонын енгізіңіз.", 
	   please_enter_guardian_1_relation:"Guardian 1 байланысын енгізіңіз.",
	   please_select_parents:"Ата-аналарды таңдаңыз.",
	   transfer_classroom:"Аудармалы сынып", 
	   please_choose_one_section_to_transfer:"Ауыстыру үшін бір бөлімді таңдаңыз.", 
	   transfer:"Ауыстыру",
	   assigning_multiple_users_to_a_school_or_school_group:"Мектепке немесе мектеп тобына бірнеше пайдаланушыларды тағайындау", 
	   add_to_school_or_school_group:"Мектепке немесе мектеп тобына қосу", 
	   please_select_school_or_school_group:"Мектеп немесе мектеп тобын таңдаңыз.",
	   print_student_progress_report:"Студенттің үлгерімі туралы есепті басып шығару",
 },
 ko: {
	   reporting_center:"보고 센터", 
	   grade_reports:"등급 보고서", 
	   user_reports:"사용자 보고서", 
	   learning_reports:"학습 보고서", 
	   administrative_reports:"행정 보고서", 
	   progress_report:"진행 보고서", 
	   full_progress_report:"전체 진행 보고서", 
	   grade_report:"등급 보고서", 
	   roster_report:"명단 보고서", 
	   parent_report:"부모 보고서", 
	   teacher_report:"교사 보고서", 
	   student_report:"학생 보고서", 
	   log_in_report:"로그인 보고서", 
	   enrollmentreport:"등록 보고서", 
	   enrollment_summary:"등록 요약", 
	   student_enrollment_summary:"학생 등록 ​​요약", 
	   attendance_report:"출석 보고서", 
	   attendance_summary_report:"출석 요약 보고서", 
	   log_In_Credentials:"자격 증명을 로그인하십시오", 
	   application_report:"응용 프로그램 보고서", 
	   section_report:"섹션 보고서", 
	   course_report:"코스 보고서", 
	   communication_summary:"커뮤니케이션 요약", 
	   comments_and_Document_Report:"의견 및 문서 보고서", 
	   School_Calendar:"학교 캘린더", 
	   bell_Schedule:"벨 일정", 
	   student_Contract:"학생 계약", 
	   eOS_Report:"EOS 보고서", 
	   active_Enrollments_Per_Term_Report:"용어 보고서 당 활성 등록", 
	   active_Student_Enrollments_with_As_Report:"AS 보고서에 적극적인 학생 등록", 
	   active_Student_Enrollments_Report:"활동적인 학생 등록 ​​보고서", 
	   all_Students_GPA_Report:"모든 학생 GPA 보고서", 
	   old_All_Student_GPA_Report:"모든 학생 GPA 보고서", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + 참여 유형 보고서", 
	   enrollment_Confirmation_Report:"등록 확인 보고서", 
	   eOS_College_Matriculations_Report:"EOS College Matrications 보고서", 
	   student_Enrollment_History_To_Date_w_Term_Report:"학생 등록 ​​기록 날짜 W 기간 보고서",
	   student_Information_Report:"학생 정보 보고서", 
	   ran_by:"도망 쳤다",
	   Show_Filter:"필터를 표시하십시오", 
	   School_Group:"학교 그룹", 
	   school:"학교", 
	   department:"부서", 
	   student:"학생", 
	   student_status:"학생 상태", 
	   course:"강의", 
	   course_level:"코스 수준", 
	   section:"부분", 
	   teacher:"선생님", 
	   primary_teacher:"초등 교사", 
	   secondary_teacher:"중등 교사", 
	   completion_Date_Range:"완료 날짜 범위", 
	   from_date:"날짜부터", 
	   to_date:"지금까지", 
	   status:"상태", 
	   gender:"성별", 
	   final_grade:"최종 성 ​​적", 
	   advisor:"조언자", 
	   grade_level:"학년 수준", 
	   specific_mark:"특정 마크", 
	   track:"길", 
	   ethnicity:"민족성", 
	   additional_fields:"추가 필드", 
	   school_sessions:"학교 세션", 
	   gradebook:"등급", 
	   submit:"제출하다", 
	   reset:"초기화", 
	   show_hide_columns:"열을 표시/숨기십시오", 
	   select_all:"모두를 선택하십시오", 
	   student_id:"학생 아이디", 
	   last_name:"성", 
	   first_name:"이름", 
	   grade_level:"학년 수준", 
	   start_date:"시작 날짜", 
	   end_date:"종료 날짜", 
	   grade_final:"성적 최종", 
	   percent:"퍼센트", 
	   credit:"신용 거래", 
	   download_excel:"Excel을 다운로드하십시오", 
	   print:"인쇄", 
	   no_data:"데이터가 없습니다.", 
	   view:"보다", 
	   showing:"전시", 
	   of:"~의", 
	   other_grade:"다른 등급", 
	   level:"수준", 
	   date:"날짜", 
	   grade:"등급",
	   enrollment_Change_Status:"등록 변경 상태", 
	   close:"닫다", 
	   select_Enrollment_Status:"등록 상태를 선택하십시오", 
	   select:"선택하다...", 
	   cancel:"취소", 
	   save:"구하다", 
	   students:"재학생", 
	   Course_Status:"코스 상태", 
	   Closed_courses:"폐쇄 된 코스", 
	   Section_Status:"섹션 상태", 
	   Closed_sections:"닫힌 섹션", 
	   Transferred_From:"전송",
	   Graduation_From_Date:"날짜부터 졸업", 
	   Graduation_To_Date:"지금까지 졸업", 
	   Enrollment_From_Date:"날짜부터 등록", 
	   Enrollment_To_Date:"현재까지 등록", 
	   Enrollment_Status:"등록 상태", 
	   Transfer_From_Date:"날짜부터 전송", 
	   Transfer_To_Date:"현재까지 전송하십시오", 
	   Custom_Query:"사용자 정의 쿼리", 
	   Last_Access_Date:"마지막 액세스 날짜", 
	   Total_Session_Time:"총 세션 시간", 
	   Quality_of_Work:"작품의 질", 
	   Grade_to_Date:"지금까지 등급", 
	   Overall_Percent:"전체 퍼센트", 
	   On_Schedule_Percent:"일정에 따라", 
	   Activity_Count_Complete:"활동 수가 완료됩니다", 
	   Activity_Count_Total:"활동 카운트 총", 
	   Overdue_Activitie:"연체 된 활동",
	   Section_Course_Additional_Fields:"섹션/코스 추가 필드", 
	   Create_On_Date:"날짜에 만듭니다", 
	   Last_Status_Update_Date:"마지막 상태 업데이트 날짜", 
	   Transferred_In:"전송", 
	   Transferred_In_Date:"날짜로 양도", 
	   email:"이메일", 
	   birth_date:"생일", 
	   course_name:"코스 이름", 
	   section_name:"섹션 이름", 
	   school_name:"학교 이름", 
	   Graduation_Date:"졸업 날짜", 
	   Created_on:"에 만든", 
	   mentor_Advisor:"멘토/어드바이저",
	   sections:"섹션", 
	   roster:"명단에", 
	   relationship:"관계", 
	   Email_or_Phone:"이메일 또는 전화", 
	   Enter_any_text:"텍스트를 입력하십시오", 
	   Advisor_Success_Manager:"고문 / 성공 관리자", 
	   User_Id:"사용자 ID", 
	   phone_number:"전화 번호", 
	   Student_Last_Name:"학생 성", 
	   Student_First_Name:"학생 이름", 
	   Student_Email:"학생 이메일",
	   credentials:"신임장", 
	   availability:"유효성",
	   enrollments:"등록", 
	   Datea_Created_on:"생성 된 날짜",
	   country:"국가", 
	   state:"상태", 
	   zipcode:"우편 번호", 
	   Enter_any_zipcode:"우편 번호를 입력하십시오", 
	   address:"주소",
	   zip_Code:"우편 번호",
	   Login_Report:"로그인 보고서", 
	   user_Type:"사용자 유형", 
	   user_Name:"사용자 이름", 
	   Show_last_log_in_only:"마지막 로그인 만 표시하십시오", 
	   Username:"사용자 이름", 
	   Date_Time:"날짜 시간", 
	   Ip_Address:"IP 주소", 
	   city:"도시",
	   Enrollment_Start_Date:"등록 시작 날짜", 
	   Enrollment_End_Date:"등록 종료 날짜", 
	   Completion_Date:"완료 날짜", 
	   section_Type:"섹션 유형", 
	   student_Enrolled:"학생 등록", 
	   content_Provider:"콘텐츠 제공자", 
	   student_Additional_Fields:"학생 추가 분야",
	   type:"유형", 
	   in_Class_Information:"수업 정보에서", 
	   Enrollment_Summary_Report:"등록 요약 보고서", 
	   Transferred_From_School:"학교에서 양도",
	   Total_Enrollments:"총 등록", 
	   content_Type:"컨텐츠 타입", 
	   active_Course_Progress:"적극적인 코스 진행",
	   Grades:"성적", 
	   attendance:"출석",
	   student_Absences:"학생 부재", 
	   total_Absence:"총 부재", 
	   section_Absences:"섹션 결석",
	   Grade_Level_Absences:"학년 수준 결석",
	   Gender_Absences:"성 결석",
	   Login_credentials:"로그인 자격 증명", 
	   names:"이름", 
	   user_status_admin_teacher_parent:"사용자 상태 (관리자, 교사, 부모)", 
	   show_title:"제목 표시", 
	   midle_name:"중간 이름", 
	   password:"비밀번호", 
	   parent_name:"부모님 성함", 
	   linked_to_parent:"부모와 연결됩니다", 
	   linked_to_student:"학생과 연결됩니다",
	   login_credentials_Report:"로그인 자격 증명 보고서", 
	   app_id:"앱 ID", 
	   created:"만들어진", 
	   modified:"수정",
	   select_level:"레벨을 선택하십시오", 
	   select_additional_fields:"추가 필드 섹션", 
	   title:"제목", 
	   credits:"크레딧", 
	   section_ID:"섹션 ID", 
	   content:"콘텐츠", 
	   course_additional_fields:"추가 필드 코스",
	   course_id:"코스 ID", 
	   communication_summary_report:"커뮤니케이션 요약 보고서", 
	   method:"방법", 
	   create_date:"날짜를 만듭니다", 
	   subject:"주제", 
	   make_from_id:"ID에서 만듭니다", 
	   make_to:"만듭니다", 
	   attachments:"첨부 파일", 
	   comment_and_document_summary_report:"의견 및 문서 요약 보고서", 
	   comment_type:"주석 유형", 
	   flagged:"신고", 
	   sharing_target:"목표 공유", 
	   show_on_transcript:"성적표에 표시하십시오", 
	   by:"에 의해", 
	   comment:"논평", 
	   type_name:"유형 이름", 
	   effective_from_date:"날짜부터 유효합니다", 
	   effective_to_date:"지금까지 효과적입니다", 
	   count_docs:"문서를 세십시오",
	   school_calendar_report:"학교 일정 보고서", 
	   event_Id:"이벤트 ID", 
	   date_start:"날짜 시작", 
	   date_end:"날짜 종료", 
	   posted_last_name:"게시 된 성", 
	   posted_first_name:"게시 된 이름입니다",
	   bell_schedule_report:"벨 일정 보고서", 
	   period:"기간", 
	   start:"시작", 
	   end:"끝",
	   student_contract_report:"학생 계약 보고서", 
	   begin_date:"날짜 시작", 
	   contracts:"계약", 
	   contract_name:"계약 이름", 
	   contract_begin_date:"계약 시작 날짜", 
	   contract_end_date:"계약 종료 날짜",
	   active_enrollments_per_term_report:"용어 보고서 당 활성 등록", 
	   entry_date:"입력 날짜", 
	   teachers:"교사", 
	   term:"용어",
	   sections:"섹션",
	   showing_of:"20/20을 보여줍니다",
	   filter:"필터",
	   students:"학생",
	   school:"학교",
	   all_school:"모든 학교",
	   student:"학생",
	   email:"이메일",
	   grade_level:"학년 수준",
	   status:"상태",
	   seach_for_a_student_or_id:"학생 또는 아이디 검색 …",
	   search:"검색 …",
	   message_student:"메시지 학생",
	   request_enrollment:"등록 요청",
	   print_schedule:"인쇄 일정",
	   view:"보다",
	   no_data:"데이터가 없습니다.",
	   views:"견해", 
	   enrollment:"등록", 
	   schedule:"일정", 
	   transferred_grades:"이전된 성적", 
	   comments_ocuments:"의견 및 문서", 
	   academic_records:"학업 기록", 
	   compliance_log:"규정 준수 로그", 
	   unofficial_transcript:"비공식 성적표", 
	   iD_card:"신분증", 
	   student_number_id_information:"학생 번호 #29561 정보", 
	   student_number:"학생 수", 
	   gender:"성별", 
	   goes_by:"지나간다", 
	   date_of_birth:"생일", 
	   ethnicity:"민족성", 
	   mobile:"이동하는", 
	   academic_track:"학업 트랙", 
	   learning_path_template:"학습 경로 템플릿", 
	   graduation_date:"졸업 날짜", 
	   comments:"코멘트", 
	   transfer_information:"전송 정보", 
	   enrollment_date:"등록 날짜", 
	   transfer_date:"이전 날짜", 
	   transfer_student:"교환 학생", 
	   parent_mentor_contact:"학부모/멘토 연락처", 
	   mentor:"멘토르", 
	   parent_phone:"부모님 전화", 
	   emergency_contact:"긴급 연락처", 
	   academic_advisor_ssm:"학술 고문 / SSM", 
	   student_success_manager:"학생 성공 관리자", 
	   academic_avisor:"학술 고문", 
	   address:"주소", 
	   address_01_Default:"주소 01(기본값)", 
	   street:"거리", 
	   city:"도시", 
	   state:"상태", 
	   zip:"지퍼", 
	   hide_Detailed_information:"자세한 정보를 숨깁니다", 	    
	   current_course_progress:"현재 과정 진행 상황", 	    
	   full_Path_Progress:"전체 경로 진행", 	    
	   print:"인쇄", 	    
	   avg_graduation_progress:"평균 졸업 진행 상황", 	    
	   GPA:"평점", 	    
	   graduation_Status:"졸업 현황", 	    
	   on_track:"트랙에",
	   show_detailed_information:"자세한 정보 표시",
	   communication:"의사소통",
		student_advisors:"학생 고문", 	    
	   country:"국가", 	    
	   grade:"등급", 	    
	   credits:"크레딧", 	    
	   sort:"종류", 	    
	   course_progress:"코스 진행 상황",
	   overall_GPA:"전체 평점",
	    current_graduation_progress:"현재 졸업 진행 상황",
		individual_course_progress:"*개별 과정 진행 상황은 다르며 이는 전체 진행 상황입니다",
		subject:"주제",
		online_sections:"온라인 섹션",
	   course:"강의",  
	   section:"부분", 
	   actions:"행위", 
	   view_event:"이벤트보기",
	   in_class_section:"수업 섹션에서",
	   calendar:"달력",
	   access_link:"액세스 링크", 
	   online_link:"O온라인 링크",
		launch_course:"런칭 코스", 
	   start_class:"수업을 시작하십시오",
	   level:"수준", 
	   date:"날짜", 
	   transferred_in:"이전되었습니다",
	   tranferred_grades:"편입학점",
	   Searchs:"검색", 
	   Search_department_course:"검색학과 과정, src…",
	   archived:"보관됨", 
	   add_comment:"댓글을 추가합니다", 
	   created_date:"만든 날짜입니다", 
	   by:"에 의해", 
	   type:"유형", 
	   comment:"논평", 
	   from_date:"시작 날짜", 
	   to_date:"날짜까지", 
	   documents:"서류", 
	   edit:"편집하다", 
	   delete:"삭제",
	   communications:"연락", 
	   add_communications:"커뮤니케이션을 추가합니다", 
	   made_from:"에서 만들어진", 
	   made_to:"메이드 투", 
	   means:"수단", 
	   attachments:"첨부 파일", 
	   content:"콘텐츠",
	   compliance_logs:"규정 준수 로그", 
	   messageID:"메시지 ID", 
	   agree:"동의하다", 
	   dateTime:"날짜 시간", 
	   iPAddress:"IP 주소", 
	   add_idit_comment_document:"주석 및 문서를 추가/편집합니다", 
	   document_type:"문서 유형", 
	   show_on_transcript:"대본에 표시합니다", 
	   select_users_to:"사용자를 선택합니다", 
	   teacher:"선생님", 
	   parent:"부모의", 
	   flag:"깃발", 
	   none:"없음", 
	   link:"링크", 
	   label:"상표", 
	   add_more_link:"더 많은 링크를 추가합니다", 
	   save:"구하다", 
	   add_edit_communication:"통신 추가/편집", 
	   made_by:"메이드 바이", 
	   date_time:"날짜 시간", 
	   length:"길이", 
	   select:"고르다", 
	   select_users_to_view:"커뮤니케이션을 볼 사용자를 선택하세요", 
	   add_more:"더 추가합니다", 
	   communication_summary:"커뮤니케이션 요약",
	   close:"닫다",
	   new_type:"새로운 유형",
	   select_user_to_view_comment:"댓글을 볼 사용자 선택",
	   flag_comment:"플래그 댓글",
	   teacher_page:"교사 페이지",
	   edit_information:"정보 수정",
	   phone:"핸드폰",
	   add_credential:"자격 증명 추가",
	   add_edit_credential:"자격 증명 추가/편집",
	   first_name:"이름",
	   midle_name:"중간 이름",
	   last_name:"성",
	   cancel:"취소",
	   add_new:"새로운 걸 더하다",
	   phone_type:"전화 유형",
	   zipCode:"우편 번호",
	   phone_number:"전화 번호",
	   default:"기본",
	   please_select_country:"국가를 선택하세요",
	   student_information:"학생 정보",
	   username:"사용자 이름",
	   user_directory:"사용자 디렉토리",
	   add_teacher:"교사를 추가합니다",
	   add_admin:"관리자를 추가합니다",
	   export_to_excel:"엑셀로 내보냅니다",
	   export_to_pdf:"PDF로 내보내기",
	   send_login_credentials:"로그인 자격 증명을 보냅니다",
	   search_for_a_user_or_id:"사용자 또는 ID 검색…",
	   user:"사용자",
	   school_admin:"학교 관리자",
	   change_password:"비밀번호를 변경합니다",
	   set_password_expiration_date:"비밀번호 만료일을 설정합니다",
	   impersonate_user:"사용자를 사칭합니다",
	   edit_user_tags:"사용자 태그를 편집합니다",
	   add_or_edit_users_schoo_assign:"사용자 학교 할당을 추가하거나 편집합니다",
	   assign_content_access:"콘텐츠 액세스를 할당합니다",
	   add_student:"학생 추가",
	   add_parent_mentor:"학부모/멘토 추가",
	   showing:"전시",
	   of:"~의",
	   school_name:"학교 이름",
	   edit_user_school_tags:"사용자 학교 태그를 수정합니다",
	   personal_information:"개인 정보",
	   contacted_load:"연락 로드",
	   maximum_of_active_students:"활성 학생의 최대 수",
	   teacher_since:"선생님부터",
	   login_infomation:"로그인 정보",
	   username:"사용자 이름",
	   password :"비밀번호",
	   avatar :"화신",
	   teachers :"교사",
	   change_status :"상태를 변경합니다",
	   add_admin:"관리자를 추가합니다",
	   name:"이름",
	   create_on:"다음에 생성합니다",
	   registrar:"기록 사무관",
	   birthday:"생신",
	   signature:"서명",
	   photo:"사진",
	   designated_registrar:"지정 등록기관",
	   track:"길",
	   select_existing_track:"기존 트랙 선택",
	   available:"사용 가능",
	   parent_mentor:"학부모/멘토",
	   relationship:"관계",
	   email_address:"이메일 주소",
	   academic_mentor:"학업 멘토",
	   no_data_available_in_table:"표에 데이터가 없습니다.",
	   primary_language:"기본 언어",
	   add_into_parent_or_mentor:"학부모/멘토에 추가",
	   add_into_phone:"전화에 추가",
	   add_into_address:"주소에 추가",
	   select_one:"하나를 고르세요",
	   login:"로그인",
	   plese_select_country:"국가를 선택하세요.",
	   edit_student:"학생 편집",
	   academic_advisor_or_student_success_manager:"학업 고문 / 학생 성공 관리자",
	   role:"역할",
	   link_parent:"링크 부모",
	   link_advisor_sms:"링크 어드바이저/SSM",
	   save_into_parent_mentor:"학부모/멘토에 저장",
	   save_into_parent_phone:"전화에 저장",
	   save_into_parent_address:"주소에 저장",
	   bulk_information_update:"대량 정보 업데이트",
	   enrollments:"등록",
	   email_student:"이메일 학생",
	   unofficial_transcripts:"비공식 성적 증명서",
	   official_transcripts:"공식 성적 증명서",
	   email_students_schedule:"이메일 학생의 일정",
	   export_students_to_excel:"학생을 Excel로 내보내기",
	   export_parent_list_to_excel:"부모 목록을 Excel로 내보내기",
	   assign_learning_path_template:"학습 경로 템플릿 할당",
	   promote_student_to_the_next_grade_level:"학생을 다음 학년으로 진급",
	   batch_upload_students:"학생 일괄 업로드",
	   batch_upload_transfer_grades:"성적 일괄 업로드 전송",
	   transfer_apex_only:"환승(APEX만 해당)",
	   transfer_content_providers:"전송(모든 콘텐츠 제공자)",
	   batch_enrollments:"일괄 등록",
	   send_message:"문자 보내",
	   impersonate:"사칭",
	   change_login_credentials:"로그인 자격 증명 변경",
	   request_enrollment:"등록 요청",
	   send_weekly_status_report:"주간 상태 보고서 보내기",
	   please_select_student:"학생을 선택하십시오.",
	   student_status_will_be_changed_to_status_withdraw:"학생 상태는 111로 변경되며 모든 등록이 철회됩니다. 정말로 계속하기를 원하십니까?",
	   student_status_will_be_changed_to_status:"학생 상태가 111로 변경됩니다. 계속하고 싶습니까?",
	   value:"값",
	   student_success_manager_or_acdemic:"학생 성공 관리자 / 학업 고문",
	   enroll_students_to_section:"학생 등록 ​​섹션",
	   department:"부서",
	   refresh:"새로 고치다",
	   select_department:"부서를 선택하십시오",
	   select_course:"코스를 선택하십시오",
	   select_section:"섹션을 선택하십시오",
	   start_date:"시작 날짜",
	   end_date:"종료 날짜",
	   ID:"ID",
	   action:"행동",
	   enrollment_period:"등록 기간",
	   select_a_course_to_register_ilp:"ILP 등록 코스를 선택하십시오",
	   period:"기간",
	   credit:"신용 거래",
	   year:"년도",
	   enroll:"싸다",
	   recipient_transcript:"수신자 성적표",
	   select_all_or_unselect_all:"모두 / 선택을 선택하십시오",
	   include_in_progress_sections:"진행 상황을 포함합니다",
	   show_satisfaction_of_program:"프로그램의 만족을 보여줍니다",
	   show_total_credit:"총 크레딧을 보여줍니다",
	   show_student_info:"학생 정보를 보여줍니다",
	   show_academic_info:"학업 정보를 보여줍니다",
	   show_school_names_from_orther_grades:"다른 성적에서 학교 이름을 보여줍니다",
	   show_school_contact:"학교 연락을 보여줍니다",
	   include_transferred_grades_in_gpa:"GPA에 이전 된 등급을 포함하십시오",
	   include_in_progress_grade:"진행중인 등급을 포함하십시오",
	   include_grade_scales:"등급 척도를 포함합니다",
	   show_graduation_date:"졸업 날짜를 보여주십시오",
	   show_weighted_gpa:"가중 GPA를 보여줍니다",
	   show_grade_level_gpa:"학년 수준 GPA를 표시하십시오",
	   show_comletion_date:"완료 날짜를 표시하십시오",
	   show_withdraw_classes:"철수 수업을 보여줍니다",
	   show_withdraw_date:"철수 날짜를 보여줍니다",
	   show_transfered_in_classes:"수업에서 전송 된 쇼",
	   show_digital_seal:"디지털 씰을 보여줍니다",
	   show_singnature:"서명을 보여줍니다",
	   group_by:"그룹에 의해",
	   school_year:"학년",
	   school_level:"학교 수준",
	   notes:"메모",
	   ok:"좋아요",
	   are_you_sure_to_send:"당신은 확실히 보내 주시겠습니까?",
	   assign_learning_path_templete:"학습 경로 템플릿을 할당합니다",
	   assign_student_to_selected_learning:"선택한 학습 경로 템플릿에 학생을 지정하십시오",
	   assign:"양수인",
	   are_you_sure_to_promote_to_level:"다음 학년 수준으로 홍보할까요?",
	   data_process:"데이터 프로세스",
	   upload_and_import_data:"업로드 및 가져 오기 데이터",
	   download_user_information:"사용자 정보를 다운로드하십시오",
	   here:"여기",
	   select_student_upload_file:"학생 업로드 파일을 선택하십시오",
	   local_drive:"로컬 드라이브",
	   the_file_is_uploaded:"파일이 업로드되었습니다",
	   template_name:"템플릿 이름",
	   Here:"여기",
	   sample_file_excel:"샘플 파일 엑셀.",
	   file_type:"파일 유형",
	   delimited:"구분",
	   delimited_chars:"구분 된 숯",
	   fixed_width:"고정 너비",
	   first_line_header:"첫 번째 라인 헤더",
	   loader_field:"로드 필드",
	   Header:"머리글",
	   sample_data:"샘플 데이터",
	   column_width:"Colunm 너비",
	   save_tamplate:"템플릿을 저장하십시오",
	   save_and_upload_data:"데이터 저장 및 업로드",
	   result:"결과",
	   upload_and_import_data_orther_grade:"업로드 및 가져 오기 데이터 기타 등급",
	   select_upload_file:"파일 업로드를 선택하십시오",
	   student_id:"학생 아이디",
	   uploadAnd_import_data_enrollment:"데이터 등록 업로드 및 가져 오기",
	   section_id:"섹션 ID",
	   title:"제목",
	   recipient:"받는 사람",
	   same_current_address:"현재 주소와 동일합니다",
	   add_more_reciptient:"더 많은 수신자를 추가하십시오",
	   issuse_date:"발행 날짜",
	   show_total_unapplied_credits:"적용되지 않은 신용을 보여주십시오",
	   reconcile_another_student_record:"다른 학생 기록과 화해하십시오",
	   please_choose_one_student_to_reconcile:"화해 할 학생 한 명을 선택하십시오.",
	   yes:"예",
	   no:"아니요",
	   apex_classroom_sync:"에이펙스 교실 동기",
	   next:"다음",
	   apex_classrooms:"에이펙스 교실",
	   online_user_id:"온라인 사용자 ID",
	   enter_online_user_id:"온라인 사용자 ID를 입력하십시오",
	   online_section_id:"온라인 섹션 ID",
	   online_section_name:"온라인 섹션 이름",
	   online_course_name:"온라인 코스 이름",
	   enrollment_date:"등록 날짜",
	   back:"뒤쪽에",
	   import:"수입",
	   offical_transcipt:"공식 성적 증명서",
	   email_schedule:"이메일 일정",
	   reconcile_with_another_records:"다른 레코드와 조화를 이루십시오",
	   online_sync_and_update:"온라인 진행 상황 동기화 및 업데이트",
	   download_all_completion_cretification:"모든 완료 인증을 다운로드하십시오",
	   orther_grade:"다른 성적",
	   medical:"의료",
	   comments_and_documents:"의견과 문서",
	   contracts:"계약",
	   invoices:"송장",
	   audit_logs:"감사 로그",
	   edit_logs:"로그 편집",
	   grade_to_date:"지금까지 등급",
	   quality_of_work:"작품의 질",
	   last_access:"마지막 액세스",
	   gradebook:"등급",
	   transfer:"옮기다",
	   completion_certification:"완료 인증",
	   tranfer_user_school:"전송 사용자 학교",
	   tranfer_to_school:"학교로 전학",
	   tranfer_apex_classrooms:"에이펙스 교실을 이체하십시오",
	   course_to_moved:"이사 과정",
	   current_teacher:"현재 교사",
	   future_section:"미래 섹션",
	   future_program:"미래 프로그램",
	   future_teacher:"미래의 교사",
	   enrollment_start_date_end_date:"등록 시작 날짜 - 종료 날짜",
	   no_more_option:"더 이상 옵션이 없습니다",
	   create_new:"새로운 창조",
	   transfer_classrooms:"교실을 전송합니다",
	   tyler_synchronization_for_az_school:"AZ 학교의 타일러 동기화",
	   synchronize:"동기화",
	   individual_course_progress_varies:"개별 코스 진행 상황은 다양합니다. 이것이 졸업을 향한 전반적인 진전입니다.",
	   edit_ilp:"ILP 편집",
	   add_academic_record:"학업 기록을 추가하십시오",
	   edit_all_records:"모든 레코드를 편집하십시오",
	   search_corse_department_src:"검색 과정, 부서, SRC…",
	   message_id:"메시지 ID",
	   add_new_contract:"새로운 계약을 추가하십시오",
	   contract_id:"계약 ID",
	   contract_name:"계약 이름",
	   first_date:"첫 데이트",
	   last_date:"마지막 날짜",
	   amount_per_period:"기간 당 금액",
	   terminating_status:"종료 상태",
	    payment_history:"지불 내역",
	   record_payment:"기록 지불",
	   payment_method:"지불 방법",
	   invoice_id:"송장 ID",
	   show_all:"모두 보이기",
	   invoice_date:"송장 날짜",
	   from:"에서…",
	   to:"에게…",
	   amount:"양",
	   paid:"유급의",
	   due:"로 인한",
	   date_paid:"지불 된 날짜",
	   apply_payments:"지불을 적용하십시오",
	   mark_as_paid:"지불 한대로 표시하십시오",
	   void:"무효의",
	   audit_log:"감사 로그",
	   object:"물체",
	   changes_made:"변경",
	   create_time:"시간을 만듭니다",
	   time_stamp:"타임 스탬프",
	   user_creare:"사용자 생성",
	   edit_log:"로그 편집",
	   field_name:"분야 명",
	   old_value:"오래된 가치",
	   new_value:"새로운 가치",
	   date_time_update:"날짜/시간 업데이트",
	   updater:"업데이트",
	   add_edit_academic_records:"학업 기록 추가/편집",
	   select_flag:"깃발 선택 ...",
	   edit_all_tranferred_grades:"모든 트랜지레드 등급을 편집하십시오",
	   save_records:"레코드 저장",
	   possible_credits:"가능한 크레딧",
	   select_level:"레벨을 선택하십시오",
	   select_grade_level:"학년 수준을 선택하십시오",
	   select_status:"상태를 선택하십시오",
	   add_more_row:"더 많은 행을 추가하십시오",
	   full_screen:"전체 화면",
	   course_code:"다른 등급을 추가하십시오",
	   add_order_grades:"코스 코드",
	   select_credit:"신용을 선택하십시오",
	   select_default:"기본값을 선택하십시오",
	   credits_possible:"크레딧 가능",
	   select_possible_credit:"가능한 크레딧을 선택하십시오",
	   product:"제품",
	   fromn:"에서",
	   ton:"에게",
	   last_invoice_date:"마지막 송장 날짜",
	   please_select_stu:"학생을 선택하십시오",
	   payer:"지불 자",
	   amount_per_billing_period:"청구 기간 당 금액",
	   price_unit:"가격 단위",
	   billing_period:"청구 기간",
	   automatic_renewal:"자동 갱신",
	   automatic_payment:"자동 청구",
	   duration_of_period:"기간 (#의 기간)",
	   payment_id:"지불 ID",
	   payment_date:"지불 날짜",
	   payment_amount:"결제 금액",
	   applied:"적용된",
	   available:"사용 가능",
	   unApply:"적응하지 않습니다",
	   refund:"환불하다",
	   add_new_teacher:"새로운 교사를 추가하십시오",
	   change_teacher_status:"교사 상태를 변경하십시오",
	   search_for_a_teacher_or_id:"교사 또는 신분증 검색…",
	   flags:"깃발",
	   tags:"태그",
	   allowed:"허용된",
	   message_teacher:"메시지 교사",
	   impersonate_teacher:"교사를 가장합니다",
	   add_teacher_qualification:"교사 자격을 추가하십시오",
	   profile:"프로필",
	   teacher_schedule:"교사 일정",
	   qualifications:"자격",
	   student_actions:"학생 행동",
	   linking_parents_to:"부모를 연결합니다",
	   select_do:"선택하다 ...",
	   see_edit_logs:"로그 편집을 참조하십시오",
	   see_qualifications:"자격을 참조하십시오",
	   link_academic_advisor:"Academic Advisor를 연결하십시오",
	   student_success:"학생의 성공",
	   linking_academic_advisor_or_student_success:"학업 고문 / 학생 성공을 연결합니다",
	   staff:"직원",
	   teacher_status:"교사 상태",
	   school_admin_status:"학교 관리자 상태",
	   global_user_directory:"글로벌 사용자 디렉토리",
	   edit_teacher:"교사 편집",
	   contracted:"옹졸한",
	   add_comments_and_documents:"의견과 문서",
	   edit_comments_and_documents:"의견과 문서를 편집하십시오",
	   parents_or_mentor:"부모 / 멘토",
	   send_mail:"메일을 보내다",
	   are_you_sure_to_delete_this_teacher:"이 선생님을 삭제해야합니까?",
	   edit_user_password:"사용자 이름 및 비밀번호 편집",
	   add_qualifications:"자격을 추가하십시오",
	   please_select_a_least_on_teacher:"하나 이상의 교사를 선택하십시오.",
	   edit_parent_mentor:"부모 / 멘토 편집",
	   parent_mentor_information:"부모 / 멘토 정보",
	   send:"보내다",
	   are_you_surse_to_delete_this_parent:"이 부모를 삭제해야합니까?",
	   home:"집",	   
	   //auto_promotion:"자동 프로모션",
	   auto_promotion:"학생 학년 수준 프로모션",
	   Promote:"홍보하다",
	   search_for_a_name:"이름 검색…",
	   download_to_excel:"Excel로 다운로드하십시오",
	   download_to_pdf:"PDF로 다운로드하십시오",
	   User_ID:"사용자 ID",
	   User_type:"사용자 유형",
	   communication_log:"통신 로그",
	   Student_Status:"학생 상태",
	   Users:"사용자",
	   Staff_Reassignment:"직원 재 할당",
	   Select_Staff:"직원을 선택하십시오",
	   select_asset_type_to_reassign:"재 할당 자산 유형을 선택하십시오",
	   transfer_all_to:"전송하십시오",
	   transfer_selectively:"선택적으로 전송하십시오",
	   remove_all:"모두 제거",
	   remove_selectively:"선택적으로 제거하십시오",
	   Event:"이벤트",
	   Time:"시간",
	   Participants:"참가자들",
	   new_staff:"새 직원",
	   Remove:"제거하다",
	   Profile_Page:"프로필 페이지",
	   settings:"설정",
	   security:"보안",
	   timezone:"시간대",
	   notifications:"알림",
	   check_for_feature_availability_at_your_school:"학교에서 기능 가용성을 확인하십시오.",
	   current_password:"현재 비밀번호",
	   new_password:"새 비밀번호",
	   confirm_password:"비밀번호 확인",
	   updte_password:"비밀번호 업데이트",
	   change_timezone:"시간대를 변경하십시오",
	   time_zone:"시간대",
	   please_select_time_zone:"시간대를 선택하십시오",
	   notification_settings:"알림 설정",
	   level_of_urgency:"긴급 성 수준",
	   email_destination:"이메일 목적지",
	   SMS_Destination:"SMS 목적지",
	   app:"앱",
	   please_select_level_of_urgency:"긴급 성 수준을 선택하십시오",	   
	   reset_filters:"필터를 재설정합니다",
	   batch_data_update:"학생 데이터 업데이트",
	   contract_template:"계약 템플릿",
	   accept:"수용하다",
	   reject:"거부하다",
	   view_roles:"역할을 봅니다",
	   administrator_information:"관리자 정보", 
	   account_reation_date:"계정 생성 날짜", 
	   expiration_date:"만료일", 
	   schools:"학교", 
	   advisees:"조언",
	   message:"메시지",
	   see_comments_and_documents:"의견과 문서를 참조하십시오",
	   restore_APEX_Classrooms:"정점 교실을 복원하십시오",
	   teacher_information:"교사 정보", 
	   teacher_number:"교사 번호", 
	   departmens:"부서", 
	   global_capacity:"글로벌 용량", 
	   local_contracted_load:"현지 계약 부하", 
	   parents:"부모", 
	   parent_information:"부모 정보", 
	   linked_students:"연결된 학생", 
	   link_student:"링크 학생", 
	   unlink_student:"링크 된 학생", 
	   search_dot:"찾다…", 
	   view_local:"로컬을보십시오", 
	   view_global:"글로벌보기",
	   resource:"자원",
	   current_grade:"현재 등급", 
	   affiliation:"입회", 
	   current_assignment:"현재 과제", 
	   total_assignments:"총 할당", 
	   percent_completed:"완료된 퍼센트",
	   semester:"학기",
	   graduation_year:"졸업 년도", 
	   student_name:"적립 된 크레딧", 
	   credits_earned:"적립 된 크레딧",
	   exit:"출구",
	   engagement_type:"참여 유형",
	   college_admitted:"대학 입학", 
	   college_attending:"대학 참석", 
	   major:"주요한", 
	   report_card:"보고서 카드", 
	   academic_term:"학업 용어", 
	   show_average:"평균을 보여주십시오",
	   school_information:"학교 정보",
	   school_misc_configuration:"학교 기타 구성", 
	   school_tags:"학교 태그", 
	   role_tags:"역할 태그", 
	   content_integration:"컨텐츠 통합", 
	   user_roles:"사용자 역할", 
	   communication_user_rules:"커뮤니케이션 사용자 규칙", 
	   school_administrators:"학교 관리자", 
	   school_year_configuration:"학년도 구성", 
	   A_R_payment_configuration:"A/R 결제 구성", 
	   facility:"시설", 
	   enrollment_rules:"등록 규칙", 
	   student_contract_rules:"학생 계약 규칙", 
	   products:"제품", 
	   notification_templates:"알림 템플릿", 
	   transcript_viewer_options:"전사 뷰어 옵션", 
	   feature_configuration:"기능 구성", 
	   feature_settings:"기능 설정", 
	   communication_rules:"커뮤니케이션 규칙", 
	   object_state:"객체 상태", 
	   departments:"부서", 
	   grading_scales:"등급 스케일", 
	   grading_periods:"채점 기간", 
	   academic_tracks:"학문적 트랙", 
	   learning_path_templates:"학습 경로 템플릿", 
	   grade_book_activity_descriptions:"등급 도서 활동 설명", 
	   academic_terms:"학문적 용어",
	   academic_system:"학업 시스템",
	   address_line_1:"주소 라인 1", 
	   country_code:"국가 코드", 
	   address_line_2:"주소 2", 
	   school_title:"학교 제목",
	   CEEB_code:"CEEB 코드", 
	   zip_postal_code:"지퍼/우편 번호", 
	   state_province:"주/지방", 
	   website:"웹 사이트", 
	   subdomain:"하위 도메인", 
	   success_manager:"성공 관리자", 
	   school_logo:"학교 로고", 
	   digital_seal:"디지털 씰",
	   password_exception_rule:"비밀번호 예외 규칙",
	   change_password_first_login:"암호를 먼저 로그인합니다", 
	   password_expires_after_days:"암호는 며칠 후 만료됩니다", 
	   enforcement_of_teachers_load:"교사의 부하 시행", 
	   in_house_handling_of_transcript_requests:"성적표 요청의 집 처리에서", 
	   display_mobile_app_link:"모바일 앱 링크를 표시합니다", 
	   display_weekly_progress_goal:"주간 진행 목표를 표시합니다", 
	   turn_on_notification:"알림을 켜십시오", 
	   classic_letter:"클래식 편지", 
	   automatic_parent_account_creation:"자동 부모 계정 생성", 
	   default_parent_account_status:"기본 상위 계정 상태", 
	   default_time_zone:"기본 시간대", 
	   link_to_transcript_vendor_help:"전사 공급 업체 도움말 링크", 
	   link_to_transcript_vendor:"전 사체 공급 업체 링크", 
	   link_for_help_system:"도움말 시스템 링크", 
	   student_enrollment_limit:"학생 등록 ​​한도", 
	   default_section_type:"기본 섹션 유형", 
	   default_section_capacity:"기본 섹션 용량",
	   transcript_template:"전사 템플릿",
	   edit_security_school_tags:"보안 학교 태그 편집", 
	   security_school_tags:"보안 학교 태그",
	   tags_name:"태그 이름", 
	   edit_role_tags:"역할 태그 편집",
	   add_school_based_tags:"학교 기반 태그를 추가하십시오", 
	   description:"설명", 
	   applied_to_roles:"역할에 적용됩니다", 
	   teacher:"선생님",
	   edit_security_role_tags_for:"보안 역할 태그를 편집하십시오",
	   school_admins:"학교 관리자",
	   school_begin_date:"학교 시작 날짜", 
	   school_end_date:"학교 종료 날짜", 
	   automatic_control_of_teacher_s_load:"교사의 부하에 대한 자동 제어",
	   A_R_payment_gateway_configuration:"A/R 결제 게이트웨이 구성", 
	   payment_processing_vendor:"지불 처리 공급 업체", 
	   secret_key:"비밀 키", 
	   publishable_key:"게시 가능한 키", 
	   account_id:"계정 ID",
	   updating_tudents:"학생 업데이트", 
	   delete_selected_records:"선택한 레코드를 삭제합니다",
	   attribute_name:"속성 이름", 
	   applied_for:"신청",
	   add_school:"학교 추가", 
	   overview:"개요", 
	   search_for_school:"학교 검색…", 
	   search_for_student:"학생 검색…",
	   attribute_type:"속성 유형", 
	   select_school_group:"학교 그룹을 선택하십시오", 
	   access_rights:"액세스 권한", 
	   create:"만들다", 
	   read:"읽다",
	   facility_management:"시설 관리", 
	   facility_name:"시설 이름", 
	   capacity:"용량",
	   enrollment_allowance_period_days:"등록 수당 기간 (일)", 
	   maximum_enrollment_duration_days:"최대 등록 기간 (일)", 
	   start_date_of_the_week:"일주일의 시작일", 
	   end_date_of_the_week:"금주의 종료 날짜",
	   lookup_name:"조회 이름", 
	   duration:"지속", 
	   time_unit:"시간 단위", 
	   round_up_to_end_of_time_unit:"시간 단위로 반올림합니다",
	   product_name:"상품명",
	   product_ID:"제품 ID", 
	   price_offer:"가격 제안", 
	   price:"가격", 
	   frequency:"빈도", 
	   effective_from:"효과적입니다", 
	   effective_to:"효과적입니다", 
	   active:"활동적인",
	   drag_drop_to_text_cursor_in_content:"컨텐츠에서 커서를 텍스트로 끌고 드롭합니다", 
	   event_type:"이벤트 유형", 
	   notification_rule:"알림 규칙", 
	   level_or_ugency:"레벨 또는 못성", 
	   user_role:"사용자 역할",
	   edit_security_user_tags:"보안 사용자 태그를 편집합니다",
	   content_access:"컨텐츠 액세스", 
	   content_access_for:"컨텐츠 액세스", 
	   add_new_access:"새로운 액세스를 추가하십시오", 
	   date_assigned:"할당 된 날짜",
	   enrollment_request:"할당 된 날짜", 
	   enrollment_request_for:"등록 요청", 
	   mentors:"멘토",
	   options:"옵션",
	   department_name:"부서 이름", 
	   universal_department:"보편적 부서", 
	   open:"열려 있는",
	   min_point:"최소 포인트", 
	   max_point:"맥스 포인트", 
	   grade_point:"점수", 
	   honors:"명예", 
	   college:"대학",
	   order:"주문하다", 
	   start_time:"시작 시간", 
	   end_time:"종료 시간",
	   period_name:"기간 이름",
	   grading_periods_head:"채점 기간 머리",
	   grading_period:"채점 기간", 
	   weight:"무게",
	   track_name:"트랙 이름",
	   academic_track_requirement:"학업 트랙 요구 사항", 
	   of_required_credits:"필요한 크레딧의 #",
	   individual_learning_plan_template:"개별 학습 계획 템플릿",
	   ILP_name:"ILP 이름",
	   remove_requirement:"요구 사항을 제거하십시오", 
	   reset_requirement:"요구 사항을 재설정하십시오", 
	   add_requirement:"요구 사항 추가",
	   must_end_date:"종료 날짜", 
	   courses_open_date:"코스 개방일", 
	   signup_end_date:"가입 종료 날짜", 
	   signup_start_date:"가입 시작 날짜", 
	   section_period:"섹션 기간",
	   
	    weeks:"주", 
	   search_for_a_section_or_id:"섹션 또는 ID를 검색하십시오…",
	   search_for_a_deft:"부서 검색…", 	   
	   launch_course:"런칭 코스", 
	   start_class:"수업을 시작하십시오", 	   
	   weekly_progress_goal:"주간 진행 목표", 
	   send_message_to_all_section_students:"모든 섹션 학생들에게 메시지를 보냅니다", 
	   monitor_live_sessions:"라이브 세션을 모니터링하십시오", 
	   average_section_grade:"평균 섹션 등급", 
	   resources:"자원", 
	   activities:"활동", 	   
	   course_attendance_today:"오늘 코스 참석", 
	   staffs:"직원", 
	   units:"단위", 	   
	   view_all_15_resources:"15 개의 리소스를 모두보십시오", 
	   Class_discussions:"수업 토론", 
	   recent_discussions:"최근 토론", 
	   go_to_class_discussions:"수업 토론으로 이동하십시오", 	   
	   show_my_class_attendance:"내 수업 출석을 보여주세요", 
	   add_section:"섹션 추가",
	   add_global_section:"전역 섹션을 추가합니다",
	   close_section:"섹션을 닫습니다",
	   open_section:"섹션을 엽니다",
	   batch_upload:"일괄 업로드",
	   finalize:"마무리합니다",	   
	   add_tearcger:"교사를 추가합니다",
	   remove_tearcger:"교사를 제거합니다",
	   uploadSectionStatusUpdates:"섹션 상태 업데이트를 업로드합니다",	   
	   status_count:"상태 카운트",	   
	   reactivate:"재활성화합니다",
	   clone:"클론",
	   enroll_into_Section:"섹션에 등록하십시오",
	   bulk_enrollment:"대량 등록",
	   general_Information:"일반 정보",	   
	   online_content_source:"온라인 콘텐츠 소스",
	   second_teacher:"두 번째 선생님",
	   today:"오늘",
	   calendar:"달력",
	   week:"주",
	   month:"월",
	   section_progress:"섹션 진행",
	   complete:"완벽한",	   
	   section_title:"섹션 제목",
	   enter_section_title:"섹션 제목을 입력합니다",
	   select_teacher:"선생님을 선택하세요",	   
	   select_weeks:"주를 선택합니다",
	   select_credits:"크레딧을 선택합니다",
	   select_type:"유형을 선택합니다",
	   global_section:"글로벌 섹션",	   
	   enrollment_capacity:"등록 정원",
	   enter_enrollment_capacity:"등록 정원을 입력하십시오",
	   in_class_information:"클래스 정보에서",
	   Start:"시작",
	   End:"끝",
	   recurrencePattern:"반복 패턴",
	   recurrenceFrequency:"재발 빈도",
	   Weekly:"주간",
	   Monthly:"월간 간행물",
	   Recur_every:"반복마다",
	   Weeks_on:"몇 주",
	   day_of_week:"요일",
	   daily_period:"일일 기간",
	   select_daily_period:"일별 기간을 선택합니다",
	   Day:"낮",
	   The:"그만큼",
	   of_every:"모든",
	   month_s:"월",
	   add:"추가하다",	   
	   course_prequisites:"과정 전제 조건",
	   select_status:"상태 선택",
	   select_school:"학교 선택",	   
	   select_period:"기간 선택",
	    room_number:"방 번호",
	   select_room_number:"방 번호를 선택합니다",
	   Service:"서비스",
	   enter_url:"URL을 입력합니다",
	   edit_section:"섹션 편집",
	   activity_templates:"활동 템플릿",
	   select_activity_templates:"활동 템플릿 선택",
	   link_section:"링크 섹션",
	   select_link_section:"링크 섹션 선택",
	   please_select_sections:"섹션을 선택하세요.",
	   if_you_change_your_status_of_inactivity:"비활동 상태를 변경하면 학생에게 영향을 미칩니다.",
	   closing_the_global_section_will_cause:"글로벌 섹션을 폐쇄하면 모든 학교가 폐쇄되고 모든 학생이 탈퇴하게 됩니다. 계속하려면 확인을 클릭하십시오.",
	   upload_import_data:"데이터 업로드 및 가져오기",	   
	   here:"여기",
	   no_data_avalable_in_table:"테이블에 사용 가능한 데이터가 없습니다",
	   add_teacher_to_multiple_section:"여러 섹션에 교사를 추가합니다",
	   select_teachers_to_add_to_multiple_section:"여러 선택 항목에 추가할 교사를 선택합니다",
	   selected:"선택된",
	   selected_all:"모두를 선택합니다",
	   deselected_all:"모두 선택을 취소합니다",
	   remove_teacher_from_multiple_section:"여러 섹션에서 교사를 제거합니다",
	   select_teacher_to_remove_to:"다중 선택에서 제거할 교사를 선택하십시",
	   process_removal:"프로세스 제거",	   
	   clone_section:"클론 섹션",
	   enroll_student:"학생 등록",
	   enroll_student_to:"학생 등록",
	   name:"이름",
	   search_for_a_student_or_id:"학생 또는 ID 검색…",
	   confirmation_of_enrollment:"등록 확인",
	   please_review_and_confirm_enrollments_for:"에 대한 등록을 검토하고 확인하십시오",
	   confirm:"확인하다",
	   enroll_students_to_section:"학생을 섹션에 등록하십시오",
	   enrollment_period:"등록 기간",
	   days:"날",
	   no_data_avalible:"자료 없음.",
	   number_of_primary_teacher:"초등교사 수",
	   secondary_teachers:"중등 교사",
	   department_head:"부서장",
	   section_enroll:"섹션 등록",
	   load_from_file:"파일에서 로드",
	   see_sections:"섹션을 참조하십시오",
	   change_enrollment_status:"등록 상태를 변경하십시오",
	   mentor_s:"멘토 (들)",
	   overdue_activities:"기한이 지난 활동",
	   total_session_time_and_last_log:"총 세션 시간 및 마지막 로그",
	   course_name_on_transcript:"성적표에서 코스 이름",
	   edit_other_grades:"다른 등급을 편집합니다",
	   save_as:"다른 이름으로 저장",
	   account_receivable_dashboard:"계정 채권 대시 보드",
	   key_performance_indicators:"핵심 성과 지표",
	   a_r_dashboard:"A/R 대시 보드",
	   payments_credits:"지불/크레딧",
	   contract_templates:"계약 템플릿",
	   master_contracts:"마스터 계약",
	   a_r_configuration:"A/R 구성",
	   a_r_processing:"A/R 처리",
	   aging:"노화",
	   receivable:"받을 수 있는",
	   account_receivable_by_program:"프로그램별로 채권",
	   request_detail:"세부 사항을 요청합니다",
	    request_information:"정보를 요청하다",
	    requested_by:"에 의해 요청",
	    approved_by:"승인",
	    approve:"승인하다",
	    phone_name:"전화 이름",
	    phone_carrier:"전화 통신사",
		area_code:"지역 코드",
	   address_lable:"Lable 주소",
	   address_default:"주소 기본값",
	   new_photo:"새로운 사진",
	   current_of_wweeks:"현재 # 몇 주",
	   select_enrollment_period:"등록 기간을 선택하십시오",
	   enter_rejection_reason:"거부 이유를 입력 ...",
	   comments_and_documents:"의견 및 문서",
	   enrollment_history:"등록 기록",
	   request_extension_for:"요청 내선을 요청하십시오",
	   extended_of_weeks:"몇 주 연장",
	   current_enrollment_status:"현재 등록 상태",
	   select_extension_option:"확장 옵션을 선택하십시오",
	   extend_current_enrollment_until:"현재까지 현재 등록을 연장하십시오",
	   transfer_to_new_section:"새 섹션으로 전송합니다",
	   transcript_requests:"사본 요청",
	   person_requesting_transcript:"성적표를 요청하는 사람",
	   telephone_number:"전화 번호",
	   number_of_copies:"사본 수",
	   special_instructions:"특별 지시",
	   last_school_attendance:"마지막 학교 출석",
	   year_last_attended:"마지막으로 참석했습니다",
	   current_address:"현재 주소",
	   relationship_to_student:"학생과의 관계",
	   method_of_delivery:"전달 방법",
	   instructions:"*지침",
	   previous_requests:"이전 요청",
	   additional_info:"추가 정보",
	   receive:"받다",
	   process:"프로세스",
	   add_to_school_group:"학교 그룹에 추가하십시오",
	   submit_romote:"프로모션 제출",
	   next_grade_level:"다음 학년 수준",
	   please_select_a_school_for_promotion_and_transfer:"승진 및 전학을위한 학교를 선택하십시오",
	   write_off:"글을 쓰십시오",
	   amount_due:"지불액",
	   open_amount:"개방 금액",
	   payment_application:"지불 신청서",
	   use_credit_openBalance:"신용 $ 111을 사용하십시오",
	   payment_amount_usd:"지불 금액 (USD)",
	   check_number:"번호를 확인하십시오",
	   confirmation_number:"확인 번호",
	   apply_payment:"지불을 적용하십시오",
	   amount_paid:"금액 지급",
	   applied_payment:"응용 지불",
	   payer_id:"지불 자 ID",
	   view_detail:"자세히보기",
	   master_contract:"마스터 계약",
	   copy:"복사",
	   contract_user_detail:"계약 사용자 세부 사항",
	   follow_product_cost:"제품 비용을 따르십시오",
	   default_cost:"기본 비용",
	   offered_cost:"제공된 비용",
	   contract_detail:"계약 세부 사항",
	   contract_template_name:"계약 템플릿 이름",
	    master_contract_name:"마스터 계약 이름",
		 view_students:"학생들을 봅니다",
		 make_payment:"지불하십시오",
		 parent_page:"부모 페이지",
		 edit_parent:"부모 편집",
		 edit_profile:"프로필 수정",
		 account_receivable_configuration:"계정 채권 구성",
		 invoice_generation_date:"송장 생성 날짜", 
	   invoice_generation:"송장 생성", 
	   number_of_days_until_due_date:"마감일까지의 일 수",
	   account_receivable_processing:"계정 채권 처리",
	   generate_invoices:"송장을 생성합니다", 
	   process_automatic_payments:"프로세스 자동 결제", 
	   send_late_notices:"늦게 통지를 보내십시오",
	   course:"강의",
	   copy_courses:"코스를 복사하십시오",
	   copy_to_school:"학교에 복사하십시오",
	   originating_program_code:"시작 프로그램 코드", 
	   destinating_program_code:"프로그램 코드의 대상", 
	   status_error:"상태/오류",
	   add_prerequisite:"전제 조건을 추가하십시오", 
	   group_name:"그룹 이름", 
	   enter_group_name:"그룹 이름을 입력하십시오", 
	   select_a_department_to_display_courses:"코스를 표시하려면 부서를 선택하십시오", 
	   edit_tranferred_grades:"다른 등급을 편집합니다", 
	   showing_num_records:"000 레코드 표시",
	   edit_all_other_grades:"다른 모든 등급을 편집합니다",
	   upload_student_documents:"학생 문서를 업로드하십시오",
	   select_an_official_transcript_option:"공식 사본 옵션을 선택하십시오", 
	   for_schools_or_personal_copy:"학교 나 개인 사본", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"학생 사용을 위해 다른 학교로 보내거나 등록을 확인하십시오.", 
	   request_official_transcript:"공식 성적 증명서를 요청하십시오", 
	   PARCHMENT_for_colleges_or_universities:"대학이나 대학교의 양피지", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"대학/대학교에 신청하고 졸업장 완료를 확인합니다.", 
	   request_transcript:"성적 증명서를 요청하십시오", 
	   Learn_more_about_how_to_use_PARCHMENT:"양피지 사용 방법에 대해 자세히 알아보십시오",
	   print_PDF:"PDF 인쇄",
	   user_school:"사용자 학교",
	   filter:"필터",
	   GENERAL:"일반적인", 
	   STUDENT_INFO:"학생 정보", 
	   list:"목록", 
	   last_school_name:"마지막 학교 이름", 
	   TEACHER_INFO:"교사 정보", 
	   contracted_load:"계약 부하", 
	   ARENT_INFO:"부모 정보",
	   add_credential:"자격 증명을 추가하십시오",
	   edit_credential:"자격 증명 편집",
	   add_comment_document:"주석 및 문서를 추가하십시오",
	   add_comment_document_for:"주석 및 문서를 추가하십시오",
	   state_province:"주/ 지방", 
	   post_code:"우편 번호", 
	   linking_students_to:"학생들을 연결합니다", 
	   change_expiration_date:"만료 날짜를 변경하십시오", 
	   expiry_date:"만료일", 
	   please_select_department:"부서를 선택하십시오.", 
	   please_select_course:"코스를 선택하십시오.", 
	   please_select_title:"제목을 입력하십시오.", 
	   please_select_primary_teacher:"기본 교사를 선택하십시오.", 
	   please_select_weeks:"몇 주를 선택하십시오.", 
	   please_select_level:"레벨을 선택하십시오.", 
	   please_select_credits:"크레딧을 선택하십시오.", 
	   please_select_type:"유형을 선택하십시오.", 
	   please_select_daily_period:"매일 선택하십시오.",
	   please_enter_link_section:"링크 섹션을 입력하십시오.",
	   please_enter_first_name:"이름을 입력하십시오.", 
	   please_enter_last_name:"성을 입력하십시오.", 
	   please_enter_contracted:"계약을 입력하십시오.", 
	   please_enter_email:"이메일을 입력하십시오.", 
	   please_enter_phone:"전화를 입력하십시오.", 
	   please_enter_username:"사용자 이름을 입력하십시오.",
	   please_enter_password:"비밀번호를 입력 해주세요.", 
	   please_enter_status:"상태를 선택하십시오.", 
	   save_successful:"성공을 저장하십시오!.",
	   please_add_student_address:"학생 주소를 추가하십시오.", 
	   please_enter_email_address:"이메일 주소를 입력하십시오.", 
	   please_select_relationship:"관계를 선택하십시오.", 
	   please_select_parent_status:"부모 상태를 선택하십시오.", 
	   please_enter_label:"레이블을 입력하십시오.", 
	   please_enter_address:"주소를 입력하십시오.", 
	   please_enter_city:"도시에 들어가십시오.", 
	   please_enter_state:"주를 입력하십시오.", 
	   please_enter_zip_code:"우편 번호를 입력하십시오.", 
	   please_select_date_of_birth:"생년월일을 선택하십시오.", 
	   please_select_track:"트랙을 선택하십시오.", 
	   please_enter_graduation_date:"졸업일을 입력하십시오.", 
	   please_enter_country:"국가에 들어가십시오.", 
	   please_enter_phone_number:"전화 번호를 입력하십시오.", 
	    please_enter_parent_first_name:"부모 이름을 입력하십시오.", 
	   please_enter_parent_last_name:"학부모 성을 입력하십시오.", 
	   please_enter_parent_email_address:"부모 이메일 주소를 입력하십시오.", 
	   please_enter_parent_username:"부모 사용자 이름을 입력하십시오.", 
	   please_select_parent_relationship:"부모 관계를 선택하십시오.", 
	   please_enter_phone_label:"전화 레이블을 입력하십시오.", 
	   student_address_canot_be_empty:"학생 주소는 비어있을 수 없습니다.", 
	   please_select_document_type:"문서 유형을 선택하십시오.", 
	   please_enter_new_type:"새 유형을 입력하십시오.", 
	   please_enter_comment:"의견을 입력하십시오.", 
	   link_is_not_a_valid_url:"링크는 유효한 URL이 아닙니다.",
	   please_enter_link_and_label:"링크 및 레이블을 입력하십시오.",
	   are_you_sure_to_delete_this_student:"이 학생을 삭제해야합니까?",
	   please_select_gender:"성별을 선택하십시오.",
	   school_contracted_load:"학교 계약 부하", 
	   global_contracted_load:"글로벌 계약 부하",
	   please_enter_label_for_attachments:"첨부 파일에 대한 레이블을 입력하십시오.",
	   please_select_section:"섹션을 선택하십시오.", 
	   enrollment_completed_successfully:"등록이 성공적으로 완료되었습니다.",
	   delete_this_comment:"이 의견을 삭제 하시겠습니까?",
	   please_enter_course_name:"코스 이름을 입력하십시오.", 
	   please_select_credits_possible:"가능한 크레딧을 선택하십시오.",
	   can_save_record:"레코드를 저장할 수 없습니다 :",
	   are_you_sure_to_delete_this_tranferred_grade:"이 트랜지레드 등급을 삭제 하시겠습니까?",
	   are_you_sure_to_delete_num_tranferred_grade:"11 트랜 퍼드 등급을 삭제 하시겠습니까?", 
	   please_select_tranferred_grade:"Tranferred Grade를 선택하십시오.",
	   please_ente_subject:"주제를 입력하십시오.", 
	   please_select_made_to:"Made to를 선택하십시오.", 
	   delete_this_communication:"이 커뮤니케이션을 삭제 하시겠습니까?",
	   please_select_school:"학교를 선택하십시오.",
	   please_enter_name:"이름을 입력하십시오.",
	   please_enter_group_name:"그룹 이름을 입력하십시오.",
	   you_have_some_form_errors_please_check_above:"양식 오류가 있습니다. 위에서 확인하십시오.",
	   please_select_recipient:"수신자를 선택하십시오.", 
	   please_enter_description:"설명을 입력하십시오.",
	   delete_this_resource:"이 리소스를 삭제 하시겠습니까?",
	   please_enter_activity_name:"활동 이름을 입력하십시오.", 
	   please_select_activity_type:"활동 유형을 선택하십시오.", 
	   please_enter_max_score:"Max Score를 입력하십시오.", 
	   please_enter_due_date:"마감일을 입력하십시오.", 
	   please_enter_unit_name:"단위 이름을 입력하십시오.",
	   are_you_sure_to_clear_this_unit:"이 장치를 정리 하시겠습니까?",
	   please_enter_score:"점수를 입력하십시오.",
	   delete_this_credential:"이 자격 증명을 삭제 하시겠습니까?",
	   plase_select_period:"기간을 선택하십시오", 
	   plase_select_start_date:"시작 날짜를 선택하십시오", 
	   plase_select_end_date:"종료 날짜를 선택하십시오",
	   select_to_register_course_to_students_individual_learning_path_view:"학생들에게 등록 코스를 선택하여 개별 학습 경로보기",
	   delete_this_request:"이 요청을 삭제 하시겠습니까?",
	   please_enter_fname:"이름을 입력하십시오.", 
	   please_enter_lname:"성을 입력하십시오.", 
	   please_enter_birthday:"생일을 입력하십시오.", 
	   please_enter_address:"주소를 입력하십시오.", 
	   please_enter_zip:"지퍼를 입력하십시오.", 
	   please_enter_country:"국가에 들어가십시오.", 
	   please_enter_ethnicity:"민족성을 입력하십시오.", 
	   please_enter_grade:"등급을 입력하십시오.", 
	   please_enter_mobile:"모바일을 입력하십시오.", 
	   please_enter_hear_about_us:"우리에 대해 들어보세요.", 
	   please_enter_program_of_interest:"관심 프로그램을 입력하십시오.", 
	   please_enter_course_level:"코스 수준을 입력하십시오.", 
	   please_enter_guardian_1_name:"Guardian 1 이름을 입력하십시오.", 
	   please_enter_guardian_1_email:"Guardian 1 이메일을 입력하십시오.", 
	   please_enter_guardian_1_home_phone:"Guardian 1 홈 전화를 입력하십시오.", 
	   please_enter_guardian_1_relation:"Guardian 1 관계를 입력하십시오.",
	   please_select_parents:"부모를 선택하십시오.",
	   transfer_classroom:"교실 전송", 
	   please_choose_one_section_to_transfer:"전송하려면 하나의 섹션을 선택하십시오.", 
	   transfer:"옮기다",
	   assigning_multiple_users_to_a_school_or_school_group:"여러 사용자를 학교 또는 학교 그룹에 할당합니다", 
	   add_to_school_or_school_group:"학교 또는 학교 그룹에 추가하십시오", 
	   please_select_school_or_school_group:"학교 또는 학교 그룹을 선택하십시오.",
	   print_student_progress_report:"학생 진행 보고서를 인쇄하십시오",
 },
 pt: {
	   reporting_center:"Centro de relatórios", 
	   grade_reports:"Relatórios de notas", 
	   user_reports:"Relatórios de usuário", 
	   learning_reports:"Relatórios de aprendizagem", 
	   administrative_reports:"Relatórios Administrativos", 
	   progress_report:"Relatório de progresso", 
	   full_progress_report:"Relatório de progresso pleno", 
	   grade_report:"Relatório de nota", 
	   roster_report:"Relatório da lista", 
	   parent_report:"Relatório dos pais", 
	   teacher_report:"Relatório do professor", 
	   student_report:"Relatório do aluno", 
	   log_in_report:"Log em relatório", 
	   enrollmentreport:"Relatório de inscrição", 
	   enrollment_summary:"Resumo da inscrição", 
	   student_enrollment_summary:"Resumo da matrícula do aluno", 
	   attendance_report:"Relatório de presenças", 
	   attendance_summary_report:"Relatório de resumo de participação", 
	   log_In_Credentials:"Credenciais de login", 
	   application_report:"Relatório do aplicativo", 
	   section_report:"Relatório da seção", 
	   course_report:"Relatório do curso", 
	   communication_summary:"Resumo da comunicação", 
	   comments_and_Document_Report:"Comentários e relatório de documentos", 
	   School_Calendar:"Calendário escolar", 
	   bell_Schedule:"Programação de sino", 
	   student_Contract:"Contrato de estudante",
		eOS_Report:"Relatório EOS", 
	   active_Enrollments_Per_Term_Report:"Inscrições ativas por relatório de termo", 
	   active_Student_Enrollments_with_As_Report:"Matrículas de estudantes ativos com relatório AS", 
	   active_Student_Enrollments_Report:"Relatório ativo de matrículas de estudantes", 
	   all_Students_GPA_Report:"Todos os alunos relatam GPA", 
	   old_All_Student_GPA_Report:"Relatório GPA de All All Student", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + Tipo de engajamento Relatório", 
	   enrollment_Confirmation_Report:"Relatório de confirmação de inscrição", 
	   eOS_College_Matriculations_Report:"Relatório de matrículas da faculdade EOS", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Histórico de matrículas para estudantes até o momento do relatório do termo",
	   student_Information_Report:"Relatório de informações do aluno", 	   
	   ran_by:"passou por",
 	   Show_Filter:"Mostre filtro", 
	   School_Group:"Grupo escolar", 
	   school:"Escola", 
	   department:"Departamento", 
	   student:"Estudante", 
	   student_status:"Status de estudante", 
	   course:"Curso", 
	   course_level:"Nível de curso", 
	   section:"Seção", 
	   teacher:"Professor", 
	   primary_teacher:"Professor primário", 
	   secondary_teacher:"Professor secundário", 
	   completion_Date_Range:"Intervalo de conclusão", 
	   from_date:"Da data", 
	   to_date:"A data", 
	   status:"Status", 
	   gender:"Gênero", 
	   final_grade:"Nota final", 
	   advisor:"Orientador", 
	   grade_level:"Nível de ensino", 
	   specific_mark:"Marca específica", 
	   track:"Acompanhar", 
	   ethnicity:"Etnia", 
	   additional_fields:"Campos adicionais", 
	   school_sessions:"Sessões escolares", 
	   gradebook:"Livro de notas", 
	   submit:"Enviar", 
	   reset:"Reiniciar", 
	   show_hide_columns:"Mostrar/ocultar colunas", 
	   select_all:"Selecionar tudo", 
	   student_id:"Identidade estudantil", 
	   last_name:"Sobrenome", 
	   first_name:"Primeiro nome", 
	   grade_level:"Nível de ensino", 
	   start_date:"Data de início", 
	   end_date:"Data final", 
	   grade_final:"Grade Final", 
	   percent:"Por cento", 
	   credit:"Crédito", 
	   download_excel:"Baixar Excel", 
	   print:"Imprimir", 
	   no_data:"Sem dados.", 
	   view:"Visualizar", 
	   showing:"Mostrando", 
	   of:"de", 
	   other_grade:"Outra série", 
	   level:"Nível", 
	   date:"Data", 
	   grade:"Nota",
	   enrollment_Change_Status:"Status de mudança de inscrição", 
	   close:"Fechar", 
	   select_Enrollment_Status:"Selecione o status de inscrição", 
	   select:"Selecione ...", 
	   cancel:"Cancelar", 
	   save:"Salvar", 
	   students:"Alunos", 
	   Course_Status:"Status do curso", 
	   Closed_courses:"Cursos fechados", 
	   Section_Status:"Status da seção", 
	   Closed_sections:"Seções fechadas", 
	   Transferred_From:"Transferido de", 
	   Graduation_From_Date:"Graduação a partir da data", 
	   Graduation_To_Date:"Graduação até o momento", 
	   Enrollment_From_Date:"Inscrição a partir da data", 
	   Enrollment_To_Date:"Inscrição até o momento", 
	   Enrollment_Status:"status da inscrição", 
	   Transfer_From_Date:"Transferência da data", 
	   Transfer_To_Date:"Transferência até a data", 
	   Custom_Query:"Consulta personalizada", 
	   Last_Access_Date:"Última data de acesso", 
	   Total_Session_Time:"Tempo total da sessão", 
	   Quality_of_Work:"Qualidade do trabalho", 
	   Grade_to_Date:"Nota até o momento", 
	   Overall_Percent:"Percentual geral", 
	   On_Schedule_Percent:"No cronograma porcentagem", 
	   Activity_Count_Complete:"Contagem de atividades completa", 
	   Activity_Count_Total:"Contagem de atividades Total", 
	   Overdue_Activitie:"Activitie vencida",
	   Section_Course_Additional_Fields:"Seção/curso campos adicionais", 
	   Create_On_Date:"Criar na data", 
	   Last_Status_Update_Date:"Data de atualização do último status", 
	   Transferred_In:"Transferido em", 
	   Transferred_In_Date:"Transferido na data", 
	   email:"E-mail", 
	   birth_date:"Data de nascimento", 
	   course_name:"Nome do curso", 
	   section_name:"Nome da Seção", 
	   school_name:"Nome da escola", 
	   Graduation_Date:"Data de Graduação", 
	   Created_on:"Criado em", 
	   mentor_Advisor:"Mentor/consultor",
	   sections:"Seções", 
	   roster:"Lista", 
	   relationship:"Relação", 
	   Email_or_Phone:"Email ou telefone", 
	   Enter_any_text:"Insira qualquer texto", 
	   Advisor_Success_Manager:"Advisor / Gerente de Sucesso", 
	   User_Id:"ID do usuário", 
	   phone_number:"Número de telefone", 
	   Student_Last_Name:"Sobrenome do aluno", 
	   Student_First_Name:"Primeiro nome do aluno", 
	   Student_Email:"Email de estudante",
	   credentials:"Credenciais", 
	   availability:"Disponibilidade",
	   enrollments:"Matrículas", 
	   Datea_Created_on:"Data criada em",
	   country:"País", 
	   state:"Estado", 
	   zipcode:"CEP", 
	   Enter_any_zipcode:"Digite qualquer código ZIP", 
	   address:"Endereço",
	   zip_Code:"CEP",
	   Login_Report:"Relatório de login", 
	   user_Type:"Tipo de usuário", 
	   user_Name:"Nome de usuário", 
	   Show_last_log_in_only:"Mostre o último login apenas", 
	   Username:"Nome de usuário", 
	   Date_Time:"Data hora", 
	   Ip_Address:"Endereço de IP", 
	   city:"Cidade",
	   Enrollment_Start_Date:"Data de início da inscrição", 
	   Enrollment_End_Date:"Data de término da inscrição", 
	   Completion_Date:"Data de conclusão", 
	   section_Type:"Tipo de seção", 
	   student_Enrolled:"Aluno matriculado", 
	   content_Provider:"Provedor de conteúdo", 
	   student_Additional_Fields:"Campos adicionais do aluno",
	   type:"Tipo", 
	   in_Class_Information:"Nas informações da classe",
	   Enrollment_Summary_Report:"Relatório de resumo da inscrição", 
	   Transferred_From_School:"Transferido da escola",
	   Total_Enrollments:"Total de inscrições", 
	   content_Type:"Tipo de conteúdo", 
	   active_Course_Progress:"Progresso ativo do curso",
	   Grades:"Notas", 
	   attendance:"Comparecimento",
	   student_Absences:"Ausências de estudantes", 
	   total_Absence:"Ausência total", 
	   section_Absences:"Ausências de seção",
	   Grade_Level_Absences:"Ausências de nível de série",
	   Gender_Absences:"Ausências de gênero",
	   Login_credentials:"", 
	   names:"Nomes", 
	   user_status_admin_teacher_parent:"Status do usuário (administrador, professor, pai)", 
	   show_title:"Mostrar título", 
	   midle_name:"Nome do meio", 
	   password:"Senha", 
	   parent_name:"Nome dos pais", 
	   linked_to_parent:"Ligado ao pai", 
	   linked_to_student:"Ligado ao aluno",
	   login_credentials_Report:"Relatório de credenciais de login", 
	   app_id:"ID do aplicativo", 
	   created:"Criada", 
	   modified:"Modificado",
	   select_level:"Selecione o nível", 
	   select_additional_fields:"Seção Campos adicionais", 
	   title:"Título", 
	   credits:"Créditos", 
	   section_ID:"ID da seção", 
	   content:"Contente", 
	   course_additional_fields:"Curso Campos adicionais",
	   course_id:"Identidade do curso", 
	   communication_summary_report:"Relatório de resumo da comunicação", 
	   method:"Método", 
	   create_date:"Criar Data", 
	   subject:"Assunto", 
	   make_from_id:"Fazer de id", 
	   make_to:"Fazer", 
	   attachments:"Anexos", 
	   comment_and_document_summary_report:"Comentar e documentar o relatório de resumo", 
	   comment_type:"Tipo de comentário", 
	   flagged:"Sinalizado", 
	   sharing_target:"Compartilhando alvo", 
	   show_on_transcript:"Mostrar na transcrição", 
	   by:"Por", 
	   comment:"Comente", 
	   type_name:"Digite o nome", 
	   effective_from_date:"Efetiva a partir da data", 
	   effective_to_date:"Efetivo até o momento", 
	   count_docs:"Conde Docs",
	   school_calendar_report:"Relatório do calendário escolar", 
	   event_Id:"ID do evento", 
	   date_start:"Data inicial", 
	   date_end:"Data final", 
	   posted_last_name:"Publicado sobrenome", 
	   posted_first_name:"Postado primeiro nome",
	   bell_schedule_report:"Relatório da programação do sino", 
	   period:"Período", 
	   start:"Começar", 
	   end:"Fim",
	   student_contract_report:"Relatório de contrato do aluno", 
	   begin_date:"Data de início", 
	   contracts:"Contratos", 
	   contract_name:"Nome do contrato", 
	   contract_begin_date:"Data de início do contrato", 
	   contract_end_date:"Data final do contrato",
	   active_enrollments_per_term_report:"Inscrições ativas por relatório de termo", 
	   entry_date:"Data de entrada", 
	   teachers:"Professores", 
	   term:"Prazo", 
	   sections:"Seções",
	   showing_of:"Mostrando 10 de 20",
	   filter:"Filtro",
	   students:"Estudiantes",
	   school:"escuela",
	   all_school:"Todas las Escuelas",
	   student:"Estudante",
	   email:"Correo electrónico",
	   grade_level:"Nivel de grado",
	   status:"Status",
	   seach_for_a_student_or_id:"Buscar un estudiante o DNI...",
	   search:"Búsqueda …",
	   message_student:"Mensaje estudiante",
	   request_enrollment:"Solicitar matrícula",
	   print_schedule:"Imprimir horario",
	   view:"Visualizar",
	   no_data:"Sem dados.",
	   views:"Visualizações", 
	   enrollment:"Inscrição", 
	   schedule:"Agenda", 
	   transferred_grades:"Notas Transferidas", 
	   comments_ocuments:"Comentários e Documentos", 
	   academic_records:"Recordes academicos", 
	   compliance_log:"Registro de Conformidade", 
	   unofficial_transcript:"Transcrição não oficial", 
	   iD_card:"Carteira de identidade", 
	   student_number_id_information:"Número do Aluno #29561 Informações", 
	   student_number:"Número de estudante", 
	   gender:"Gênero", 
	   goes_by:"Nome preferido", 
	   date_of_birth:"Data de nascimento", 
	   ethnicity:"Etnia", 
	   mobile:"Móvel", 
	   academic_track:"Trilha Acadêmica", 
	   learning_path_template:"Modelo de Caminho de Aprendizagem", 
	   graduation_date:"Data de Graduação", 
	   comments:"Comentários", 
	   transfer_information:"Transferir Informações", 
	   enrollment_date:"Data de inscrição", 
	   transfer_date:"Data de transferência", 
	   transfer_student:"Transferir Aluno", 
	   parent_mentor_contact:"Contato de pais / mentores", 
	   mentor:"Mentor", 
	   parent_phone:"Telefone do Pai", 
	   emergency_contact:"Contato de emergência", 
	   academic_advisor_ssm:"Orientador Acadêmico / SSM", 
	   student_success_manager:"Gerente de sucesso estudantil", 
	   academic_avisor:"Orientador acadêmico", 
	   address:"Endereço", 
	   address_01_Default:"Endereço 01 (Padrão)", 
	   street:"Rua", 
	   city:"Cidade", 
	   state:"Estado", 
	   zip:"Fecho eclair", 
	   hide_Detailed_information:"Ocultar informações detalhadas", 	    
	   current_course_progress:"Progresso Atual do Curso", 	    
	   full_Path_Progress:"Progresso do Caminho Completo", 	    
	   print:"Imprimir", 	    
	   avg_graduation_progress:"Média do progresso da graduação", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Situação de Graduação", 	    
	   on_track:"No ritmo certo",
	   show_detailed_information:"Mostrar informações detalhadas",
	   communication:"Comunicação",
		student_advisors:"Conselheiros Estudantis", 	    
	   country:"País", 	    
	   grade:"Avaliar", 	    
	   credits:"Créditos", 	    
	   sort:"Ordenar", 	    
	   course_progress:"Progresso do curso",
	   overall_GPA:"GPA geral",
	    current_graduation_progress:"Progresso da Graduação Atual",
		individual_course_progress:"O progresso individual do curso varia, este é seu progresso geral",
		subject:"Assunto",
		 online_sections:"Seções online",
	   course:"Curso", 
	   section:"Seção", 
	   actions:"Ações", 
	   view_event:"Exibir evento",
	   in_class_section:"Seção de aula",
	   calendar:"Calendário",
	   access_link:"Link de acesso", 
	   online_link:"Link online",
		launch_course:"Abrir o curso", 
	   start_class:"Começar a aula",
	   level:"Nível", 
	   date:"Encontro", 
	   transferred_in:"Transferido em",
	   tranferred_grades:"Notas transferidas",
	   Searchs:"Procurar", 
	   Search_department_course:"Curso do departamento de pesquisa, src…",
	   archived:"Arquivado", 
	   add_comment:"Adicionar comentário", 
	   created_date:"Data de criação", 
	   by:"Por", 
	   type:"Modelo", 
	   comment:"Comente", 
	   from_date:"Da data", 
	   to_date:"Até a presente data", 
	   documents:"Documentos", 
	   edit:"Editar", 
	   delete:"Excluir",
	   communications:"Comunicações", 
	   add_communications:"Adicionar Comunicação", 
	   made_from:"Feito de", 
	   made_to:"Feito para", 
	   means:"Significa", 
	   attachments:"Anexos", 
	   content:"Conteúdo",
	   compliance_logs:"Registros de conformidade", 
	   messageID:"ID da mensagem", 
	   agree:"Aceita", 
	   dateTime:"Data hora", 
	   iPAddress:"Endereço de IP", 
	   add_idit_comment_document:"Adicionar/editar comentário e documento", 
	   document_type:"Tipo de documento", 
	   show_on_transcript:"Mostrar na transcrição", 
	   select_users_to:"Selecione os usuários para", 
	   teacher:"Professor", 
	   parent:"Pai", 
	   flag:"Bandeira", 
	   none:"Nenhum", 
	   link:"Link", 
	   label:"Etiqueta", 
	   add_more_link:"Adicionar mais links", 
	   save:"Salvar", 
	   add_edit_communication:"Adicionar/editar comunicação", 
	   made_by:"Feito por", 
	   date_time:"Data hora", 
	   length:"Comprimento", 
	   select:"Selecione", 
	   select_users_to_view:"Selecione os usuários para visualizar a comunicação", 
	   add_more:"Adicione mais", 
	   communication_summary:"Resumo da Comunicação",
	   close:"Perto",
	   new_type:"Novo tipo",
	   select_user_to_view_comment:"Selecione os usuários para ver o comentário",
	   flag_comment:"Sinalizar comentário",
	   teacher_page:"página do professor",
	   edit_information:"Editar informações",
	   phone:"Telefone",
	   add_credential:"Adicionar credencial",
	   add_edit_credential:"Adicionar/editar credencial",
	   first_name:"Primeiro nome",
	   midle_name:"Nome do meio",
	   last_name:"Sobrenome",
	   cancel:"Cancelar",
	   add_new:"Adicionar novo",
	   phone_type:"Tipo de telefone",
	   zipCode:"CEP",
	   phone_number:"Número de telefone",
	   default:"Predefinição",
	   please_select_country:"Selecione o país",
	   student_information:"Informações do aluno",
	   username:"Nome de usuário",
	   user_directory:"Diretório de usuários",
	   add_teacher:"Adicionar Professor",
	   add_admin:"Adicionar administrador",
	   export_to_excel:"Exportar para Excel",
	   export_to_pdf:"Exportar para PDF",
	   send_login_credentials:"Enviar credenciais de login",
	   search_for_a_user_or_id:"Pesquise um usuário ou ID…",
	   user:"Do utilizador",
	   school_admin:"Administrador Escolar",
	   change_password:"Alterar a senha",
	   set_password_expiration_date:"Defina a data de expiração da senha",
	   impersonate_user:"Personificar usuário",
	   edit_user_tags:"Editar tags de usuário",
	   add_or_edit_users_schoo_assign:"Adicione ou edite a atribuição escolar dos usuários",
	   assign_content_access:"Atribuir acesso ao conteúdo",
	   add_student:"Adicionar Aluno",
	   add_parent_mentor:"Adicionar pai/mentor",
	   showing:"Mostrando",
	   of:"de",
	   school_name:"Nome da escola",
	   edit_user_school_tags:"Editar tags de escola do usuário",
	   personal_information:"Informações pessoais",
	   contacted_load:"Carga contatada",
	   maximum_of_active_students:"Nº Máximo de Alunos Ativos",
	   teacher_since:"Professor Desde",
	   login_infomation:"Informações de login",
	   username:"Nome do usuário",
	   password :"Senha",
	   avatar :"Avatar",
	   teachers :"Professores",
	   change_status :"Alterar Estado",
	   add_admin:"Adicionar administrador",
	   name:"Nome",
	   create_on:"Criar em",
	   registrar:"Registrador",
	   birthday:"Registrador",
	   signature:"Assinatura",
	   photo:"Foto",
	   designated_registrar:"Registrador designado",
	   track:"Acompanhar",
	   select_existing_track:"Selecione a faixa existente",
	   available:"Disponível",
	   parent_mentor:"Pai / Mentor",
	   relationship:"Relação",
	   email_address:"Endereço de e-mail",
	   academic_mentor:"Mentor Acadêmico",
	   no_data_available_in_table:"Sem dados disponíveis na tabela",
	   primary_language:"Idioma Principal",
	   add_into_parent_or_mentor:"Adicionar ao Pai/Mentor",
	   add_into_phone:"Adicionar ao telefone",
	   add_into_address:"Adicionar no endereço",
	   select_one:"Selecione um",
	   login:"Conecte-se",
	   plese_select_country:"Escolha o país",
	   edit_student:"Editar estudante",
	   academic_advisor_or_student_success_manager:"Orientador Acadêmico / Gerente de Sucesso do Aluno",
	   role:"Função",
	   link_parent:"Link pai",
	   link_advisor_sms:"Link Advisor/SSM",
	   save_into_parent_mentor:"Salvar em Pai/Mentor",
	   save_into_parent_phone:"Salvar no telefone",
	   save_into_parent_address:"Salvar no endereço",
	   bulk_information_update:"Atualização de informações em massa",
	   enrollments:" Matrículas",
	   email_student:"E-mail Aluno",
	   unofficial_transcripts:"Transcrições não oficiais",
	   official_transcripts:"Transcrições oficiais",
	   email_students_schedule:"E-mail Agenda do Aluno",
	   export_students_to_excel:"Exportar Alunos para Excel",
	   export_parent_list_to_excel:"Exportar lista pai para Excel",
	   assign_learning_path_template:"Atribuir Modelo de Caminho de Aprendizagem",
	   promote_student_to_the_next_grade_level:"Promover o aluno para o próximo nível de série",
	   batch_upload_students:"Alunos de upload em lote",
	   batch_upload_transfer_grades:"Notas de transferência de upload em lote",
	   transfer_apex_only:"Transferência (Apenas APEX)",
	   transfer_content_providers:"Transferência (todos os provedores de conteúdo)",
	   batch_enrollments:"Inscrições em Lote",
	   send_message:"Enviar mensaje",
	   impersonate:"Suplantar",
	   change_login_credentials:"Cambiar credenciales de inicio de sesión",
	   request_enrollment:"Solicitar matrícula",
	   send_weekly_status_report:"Enviar informe de estado semanal",
	   please_select_student:"Selecione os alunos.",
	   student_status_will_be_changed_to_status_withdraw:"O status do aluno será alterado para 111 e todas as matrículas serão retiradas. Você tem certeza que quer continuar?",
	   student_status_will_be_changed_to_status:"O status do aluno será alterado para 111. Você tem certeza de que deseja continuar?",
	   value:"Valor",
	   student_success_manager_or_acdemic:"Gerente de sucesso do aluno / consultor acadêmico",
	   enroll_students_to_section:"Inscreva os alunos na seção",
	   department:"Departamento",
	   refresh:"Atualizar",
	   select_department:"Selecione o departamento",
	   select_course:"Selecione o curso",
	   select_section:"Selecione a seção",
	   start_date:"Data de início",
	   end_date:"Data final",
	   ID:"ID",
	   action:"Ação",
	   enrollment_period:"Período de inscrição",
	   select_a_course_to_register_ilp:"Selecione um curso para registrar o ILP",
	   period:"Período",
	   credit:"Crédito",
	   year:"Ano",
	   enroll:"Matricular",
	   recipient_transcript:"Transcrição do destinatário",
	   select_all_or_unselect_all:"Selecione tudo / não seleção a todos",
	   include_in_progress_sections:"Inclua seções de progresso",
	   show_satisfaction_of_program:"Mostrar satisfação do programa",
	   show_total_credit:"Mostre créditos totais",
	   show_student_info:"Mostre informações do aluno",
	   show_academic_info:"Mostre informações acadêmicas",
	   show_school_names_from_orther_grades:"Mostrar nomes das escolas de outras notas",
	   show_school_contact:"Mostrar contato da escola",
	   include_transferred_grades_in_gpa:"Inclua notas transferidas no GPA",
	   include_in_progress_grade:"Inclua no Progress Grade",
	   include_grade_scales:"Inclua escalas de grau",
	   show_graduation_date:"Mostrar data de graduação",
	   show_weighted_gpa:"Mostre GPA ponderado",
	   show_grade_level_gpa:"Mostrar GPA de nível de série",
	   show_comletion_date:"Mostrar data de conclusão",
	   show_withdraw_classes:"Mostrar classes retiradas",
	   show_withdraw_date:"Mostrar data retirada",
	   show_transfered_in_classes:"Show transferido nas aulas",
	   show_digital_seal:"Mostre selo digital",
	   show_singnature:"Mostrar assinatura",
	   group_by:"Grupo por",
	   school_year:"Ano escolar",
	   school_level:"Nível escolar",
	   notes:"Notas",
	   ok:"OK",
	   are_you_sure_to_send:"Você tem certeza de enviar?",
	   assign_learning_path_templete:"Atribuir modelo de caminho de aprendizagem",
	   assign_student_to_selected_learning:"Atribuir o aluno ao modelo de caminho de aprendizado selecionado",
	   assign:"Atribuir",
	   are_you_sure_to_promote_to_level:"Você tem certeza de promover para o próximo nível?",
	   data_process:"Processo de dados",
	   upload_and_import_data:"Carregar e importar dados",
	   download_user_information:"Baixar informações do usuário",
	   here:"aqui",
	   select_student_upload_file:"Selecione o arquivo de upload do aluno",
	   local_drive:"Unidade local",
	   the_file_is_uploaded:"O arquivo é carregado",
	   template_name:"Nome do modelo",
	   Here:"Aqui",
	   sample_file_excel:"Amostra Arquivo Excel.",
	   file_type:"Tipo de arquivo",
	   delimited:"Delimitado",
	   delimited_chars:"Chars delimitados",
	   fixed_width:"Largura fixa",
	   first_line_header:"Cabeçalho da primeira linha",
	   loader_field:"Campo de carga",
	   Header:"Cabeçalho",
	   sample_data:"Dados de amostra",
	   column_width:"Largura de Colunm",
	   save_tamplate:"Salvar modelo",
	   save_and_upload_data:"Salvar e fazer upload de dados",
	   result:"Resultado",
	   upload_and_import_data_orther_grade:"Carregar e importar dados de outras séries",
	   select_upload_file:"Selecione o arquivo de upload",
	   student_id:"Identidade estudantil",
	   uploadAnd_import_data_enrollment:"Carregar e importar a inscrição de dados",
	   section_id:"ID da seção",
	   title:"Título",
	   recipient:"Destinatário",
	   same_current_address:"O mesmo que endereço atual",
	   add_more_reciptient:"Adicione mais destinatário",
	   issuse_date:"Data de emissão",
	   show_total_unapplied_credits:"Mostrar total de créditos não aplicados",
	   reconcile_another_student_record:"Reconciliar com outro registro de estudante",
	   please_choose_one_student_to_reconcile:"Escolha um aluno para se reconciliar.",
	   yes:"Sim",
	   no:"Não",
	   apex_classroom_sync:"Sincronização da sala de aula do Apex",
	   next:"Próximo",
	   apex_classrooms:"Salas de aula de ápice",
	   online_user_id:"ID de usuário online",
	   enter_online_user_id:"Digite ID de usuário online",
	   online_section_id:"ID da seção online",
	   online_section_name:"Nome da seção online",
	   online_course_name:"Nome do curso online",
	   enrollment_date:"Data de inscrição",
	   back:"Voltar",
	   import:"Importar",
	   offical_transcipt:"Transcrição oficial",
	   email_schedule:"Programação de e -mail",
	   reconcile_with_another_records:"Reconciliar com outro recorde",
	   online_sync_and_update:"Sincronização e atualização de progresso online",
	   download_all_completion_cretification:"Baixe toda a certificação de conclusão",
	   orther_grade:"Outras notas",
	   medical:"Médico",
	   comments_and_documents:"Comentários e documentos",
	   contracts:"Contratos",
	   invoices:"Faturas",
	   audit_logs:"Logs de auditoria",
	   edit_logs:"Editar logs",
	   grade_to_date:"Nota até o momento",
	   quality_of_work:"Qualidade do trabalho",
	   last_access:"Último acesso",
	   gradebook:"Livro de notas",
	   transfer:"Transferir",
	   completion_certification:"Certificação de conclusão",
	   tranfer_user_school:"Transferir escola de usuário",
	   tranfer_to_school:"Transferir para a escola",
	   tranfer_apex_classrooms:"Transfira as salas de aula do Apex",
	   course_to_moved:"Claro para se mudar",
	   current_teacher:"Professor atual",
	   future_section:"Seção futura",
	   future_program:"Programa futuro",
	   future_teacher:"Futuro professor",
	   enrollment_start_date_end_date:"Data de início da inscrição - data de término",
	   no_more_option:"Sem mais opções",
	   create_new:"Crie um novo",
	   transfer_classrooms:"Transferir salas de aula",
	   tyler_synchronization_for_az_school:"Sincronização de Tyler para escolas AZ",
	   synchronize:"Sincronizar",
	   individual_course_progress_varies:"O progresso do curso individual varia. Este é o seu progresso geral em direção à graduação.",
	   edit_ilp:"Editar ilp",
	   add_academic_record:"Adicione registro acadêmico",
	   edit_all_records:"Edite todos os registros",
	   search_corse_department_src:"Curso de pesquisa, departamento, SRC…",
	   message_id:"ID da mensagem",
	   add_new_contract:"Adicione novo contrato",
	   contract_id:"ID do contrato",
	   contract_name:"Nome do contrato",
	   first_date:"Primeiro encontro",
	   last_date:"Última data",
	   amount_per_period:"Quantidade por período",
	   terminating_status:"Status de encerramento",
	    payment_history:"Histórico de pagamento",
	   record_payment:"Pagamento recorde",
	   payment_method:"Forma de pagamento",
	   invoice_id:"ID da fatura",
	   show_all:"Mostre tudo",
	   invoice_date:"Data da fatura",
	   from:"De…",
	   to:"Para…",
	   amount:"Quantia",
	   paid:"Pago",
	   due:"Devido",
	   date_paid:"Data paga",
	   apply_payments:"Aplicar pagamentos",
	   mark_as_paid:"Marca conforme pago",
	   void:"Vazio",
	   audit_log:"Log de auditoria",
	   object:"Objeto",
	   changes_made:"Alterações feitas",
	   create_time:"Criar tempo",
	   time_stamp:"Carimbo de hora",
	   user_creare:"Usuário Crie",
	   edit_log:"Editar log",
	   field_name:"Nome do campo",
	   old_value:"Valor antigo",
	   new_value:"Novo valor",
	   date_time_update:"Atualização de data/hora",
	   updater:"Atualizador",
	   add_edit_academic_records:"Adicionar/editar registro acadêmico",
	   select_flag:"Selecione Flag ...",
	   edit_all_tranferred_grades:"Editar todas as notas transferidas",
	   save_records:"Salvar registros",
	   possible_credits:"Possíveis créditos",
	   select_level:"Selecione o nível",
	   select_grade_level:"Selecione o nível da nota",
	   select_status:"Selecione Status",
	   add_more_row:"Adicione mais linha",
	   full_screen:"Tela cheia",
	   course_code:"Adicione outras notas",
	   add_order_grades:"Código do curso",
	   select_credit:"Selecione Crédito",
	   select_default:"Selecione o padrão",
	   credits_possible:"Créditos possíveis",
	   select_possible_credit:"Selecione Possível crédito",
	   product:"",
	   fromn:"De",
	   ton:"Para",
	   last_invoice_date:"Última data da fatura",
	   please_select_stu:"Selecione o aluno",
	   payer:"Pagador",
	   amount_per_billing_period:"Valor por período de cobrança",
	   price_unit:"Preço unitário",
	   billing_period:"Período de pagamento",
	   automatic_renewal:"Renovação automática",
	   automatic_payment:"Cobrança automática",
	   duration_of_period:"Duração (nº de períodos)",
	   payment_id:"ID de pagamento",
	   payment_date:"Data de pagamento",
	   payment_amount:"Valor do pagamento",
	   applied:"Aplicado",
	   available:"Disponível",
	   unApply:"União",
	   refund:"Reembolso",
	   add_new_teacher:"Adicione um novo professor",
	   change_teacher_status:"Alterar o status do professor",
	   search_for_a_teacher_or_id:"Procure um professor ou id…",
	   flags:"Bandeiras",
	   tags:"Tags",
	   allowed:"Permitido",
	   message_teacher:"Professor de mensagens",
	   impersonate_teacher:"PESSOAL PROFESSOR",
	   add_teacher_qualification:"Adicione a qualificação do professor",
	   profile:"Perfil",
	   teacher_schedule:"Programação do professor",
	   qualifications:"Qualificações",
	   student_actions:"Ações do aluno",
	   linking_parents_to:"Vincular pais a",
	   select_do:"Selecione ...",
	   see_edit_logs:"Consulte Editar logs",
	   see_qualifications:"Veja qualificações",
	   link_academic_advisor:"Link Advisor Academic",
	   student_success:"Sucesso do aluno",
	   linking_academic_advisor_or_student_success:"Vincular o consultor acadêmico / sucesso do aluno a",
	   staff:"Funcionários",
	   teacher_status:"Status do professor",
	   school_admin_status:"Status do administrador da escola",
	   global_user_directory:"Diretório de Usuário Global",
	   edit_teacher:"Editar Professor",
	   contracted:"Contratado",
	   add_comments_and_documents:"Comentários e documentos",
	   edit_comments_and_documents:"Editar comentários e documentos",
	   parents_or_mentor:"Pais / Mentor",
	   send_mail:"Enviar correio",
	   are_you_sure_to_delete_this_teacher:"Você tem certeza de excluir este professor.",
	   edit_user_password:"Editar nome de usuário e senha",
	   add_qualifications:"Adicione qualificações",
	   please_select_a_least_on_teacher:"Selecione pelo menos um professor.",
	   edit_parent_mentor:"Editar pai / mentor",
	   parent_mentor_information:"Informações sobre pais / mentores",
	   send:"Enviar",
	   are_you_surse_to_delete_this_parent:"Você tem certeza de excluir este pai.",
	   home:"Lar",
	   
	   //auto_promotion:"Promoção automática",
	   auto_promotion:"Promoção de nível de alunos do aluno",
	   Promote:"Promover",
	   search_for_a_name:"Procure um nome…",
	   download_to_excel:"Baixe para Excel",
	   download_to_pdf:"Baixe para PDF",
	   User_ID:"ID do usuário",
	   User_type:"Tipo de usuário",
	   communication_log:"Log de comunicação",
	   Student_Status:"Status de estudante",
	   Users:"Usuários",
	   Staff_Reassignment:"Reatribuição de pessoal",
	   Select_Staff:"Selecione funcionários",
	   select_asset_type_to_reassign:"Selecione o tipo de ativo para reatribuir",
	   transfer_all_to:"Transferir tudo para",
	   transfer_selectively:"Transferir seletivamente",
	   remove_all:"Deletar tudo",
	   remove_selectively:"Remova seletivamente",
	   Event:"Evento",
	   Time:"Tempo",
	   Participants:"Participantes",
	   new_staff:"Nova equipe",
	   Remove:"Remover",
	   Profile_Page:"Página de perfil",
	   settings:"Configurações",
	   security:"Segurança",
	   timezone:"Fuso horário",
	   notifications:"Notificações",
	   check_for_feature_availability_at_your_school:"Verifique a disponibilidade de recursos na sua escola.",
	   current_password:"Senha atual",
	   new_password:"Nova Senha",
	   confirm_password:"Confirme sua senha",
	   updte_password:"Atualizar senha",
	   change_timezone:"Mudar o fuso horário",
	   time_zone:"Fuso horário",
	   please_select_time_zone:"Selecione o fuso horário",
	   notification_settings:"Configurações de notificação",
	   level_of_urgency:"Nível de urgência",
	   email_destination:"Destino de e -mail",
	   SMS_Destination:"Destino SMS",
	   app:"Aplicativo",
	   please_select_level_of_urgency:"Selecione o nível de urgência",	  
	   reset_filters:"Redefinir filtros",
	   batch_data_update:"Atualização de dados do aluno",
	   contract_template:"Modelo de contrato",
	   accept:"Aceitar",
	   reject:"Rejeitar",
	   view_roles:"Ver funções",
	   administrator_information:"Informações do administrador", 
	   account_reation_date:"Data de criação da conta", 
	   expiration_date:"Data de validade", 
	   schools:"Escolas", 
	   advisees:"Conselhos",
	   message:"Mensagem",
	   see_comments_and_documents:"Veja comentários e documentos",
	   restore_APEX_Classrooms:"Restaure as salas de aula do Apex",
	   teacher_information:"Informação do professor", 
	   teacher_number:"Número do professor", 
	   departmens:"Departamento", 
	   global_capacity:"Capacidade global", 
	   local_contracted_load:"Carga contratada local", 
	   parents:"Pais", 
	   parent_information:"Informações dos pais",
	   linked_students:"Alunos vinculados", 
	   link_student:"Link Student", 
	   unlink_student:"Estudante desvincular", 
	   search_dot:"Procurar…", 
	   view_local:"Ver Local", 
	   view_global:"Ver Global",
	   resource:"Recurso",
	   current_grade:"Nota atual", 
	   affiliation:"Afiliação", 
	   current_assignment:"Atribuição atual", 
	   total_assignments:"Total de atribuições", 
	   percent_completed:"Por cento concluído",
	   semester:"semestre",
	   graduation_year:"Ano de graduação", 
	   student_name:"Créditos ganhos", 
	   credits_earned:"Créditos ganhos",
	   exit:"saída",
	   engagement_type:"Tipo de engajamento",
	   college_admitted:"Faculdade admitida", 
	   college_attending:"Faculdade atendendo", 
	   major:"Principal", 
	   report_card:"Boletim", 
	   academic_term:"Termo acadêmico", 
	   show_average:"Mostrar média",
	   school_information:"Informações da escola",
	   school_misc_configuration:"Configuração da escola", 
	   school_tags:"Tags da escola", 
	   role_tags:"Tags de função", 
	   content_integration:"Integração de conteúdo", 
	   user_roles:"Funções do usuário", 
	   communication_user_rules:"Regras do usuário da comunicação", 
	   school_administrators:"Administradores da escola", 
	   school_year_configuration:"Configuração do ano letivo", 
	   A_R_payment_configuration:"Configuração de pagamento A/R", 
	   facility:"Instalação", 
	   enrollment_rules:"Regras de inscrição", 
	   student_contract_rules:"Regras de contrato dos alunos", 
	   products:"Produtos", 
	   notification_templates:"Modelos de notificação", 
	   transcript_viewer_options:"Opções do visualizador de transcrição", 
	   feature_configuration:"Configuração do recurso", 
	   feature_settings:"Configurações de recurso", 
	   communication_rules:"Regras de comunicação", 
	   object_state:"Estado de objeto", 
	   departments:"Departamentos", 
	   grading_scales:"Escalas de classificação", 
	   grading_periods:"Períodos de classificação", 
	   academic_tracks:"Faixas acadêmicas", 
	   learning_path_templates:"Modelos de caminho de aprendizado", 
	   grade_book_activity_descriptions:"Descrições de atividades do livro de notas", 
	   academic_terms:"Termos acadêmicos",
	   academic_system:"Sistema acadêmico",
	   address_line_1:"Endereço Linha 1", 
	   country_code:"Código do país", 
	   address_line_2:"endereço linha 2", 
	   school_title:"Título da escola",
	   CEEB_code:"Código CEEB", 
	   zip_postal_code:"CEP / Código Postal", 
	   state_province:"Estado/província", 
	   website:"Local na rede Internet", 
	   subdomain:"Subdomínio", 
	   success_manager:"Gerente de sucesso", 
	   school_logo:"Logotipo da escola", 
	   digital_seal:"SEAL DIGITAL",
	   password_exception_rule:"Regra de exceção de senha",
	   change_password_first_login:"Alterar a senha primeiro login", 
	   password_expires_after_days:"A senha expira após dias", 
	   enforcement_of_teachers_load:"Aplicação da carga do professor", 
	   in_house_handling_of_transcript_requests:"No manuseio da casa de solicitações de transcrição", 
	   display_mobile_app_link:"Exibir link de aplicativo móvel", 
	   display_weekly_progress_goal:"Exibir meta de progresso semanal", 
	   turn_on_notification:"Ligue a notificação", 
	   classic_letter:"Carta clássica", 
	   automatic_parent_account_creation:"Criação automática de conta pai", 
	   default_parent_account_status:"Status da conta pai padrão", 
	   default_time_zone:"Fuso horário padrão", 
	   link_to_transcript_vendor_help:"Link para ajuda do fornecedor da transcrição", 
	   link_to_transcript_vendor:"Link para o fornecedor da transcrição", 
	   link_for_help_system:"Link para sistema de ajuda", 
	   student_enrollment_limit:"Limite de matrícula do aluno", 
	   default_section_type:"Tipo de seção padrão", 
	   default_section_capacity:"Capacidade de seção padrão",
	   transcript_template:"Modelo de transcrição",
	   edit_security_school_tags:"Editar tags da escola de segurança", 
	   security_school_tags:"Tags da escola de segurança",
	   tags_name:"Nome das tags", 
	   edit_role_tags:"Editar tags de função",
	   add_school_based_tags:"Adicionar tags baseadas na escola", 
	   description:"Descrição", 
	   applied_to_roles:"Aplicado a funções", 
	   teacher:"Professor",
	   edit_security_role_tags_for:"Editar tags de função de segurança para",
	   school_admins:"Administradores da escola",
	   school_begin_date:"Data de início da escola", 
	   school_end_date:"Data de término da escola", 
	   automatic_control_of_teacher_s_load:"Controle automático da carga do professor",
	   A_R_payment_gateway_configuration:"Configuração do gateway de pagamento A/R", 
	   payment_processing_vendor:"Fornecedor de processamento de pagamento", 
	   secret_key:"Chave secreta", 
	   publishable_key:"Chave publicável", 
	   account_id:"ID da conta",
	   updating_tudents:"Atualizando os alunos", 
	   delete_selected_records:"Excluir registros selecionados",
	   attribute_name:"Nome do Atributo", 
	   applied_for:"Solicitou",
	   add_school:"Adicione a escola", 
	   overview:"Visão geral", 
	   search_for_school:"Procure por escola ...", 
	   search_for_student:"Procure por aluno ...",
	   attribute_type:"Tipo de atributo", 
	   select_school_group:"Selecione Grupo Escolar", 
	   access_rights:"Direitos de acesso", 
	   create:"Criar", 
	   read:"Ler",
	   facility_management:"Gerenciamento de instalações", 
	   facility_name:"Nome da instalação", 
	   capacity:"Capacidade",
	   enrollment_allowance_period_days:"Período de subsídio de inscrição (dias)", 
	   maximum_enrollment_duration_days:"Duração máxima da inscrição (dias)", 
	   start_date_of_the_week:"Data de início da semana", 
	   end_date_of_the_week:"Data da semana final",
	   lookup_name:"Nome da pesquisa", 
	   duration:"Duração", 
	   time_unit:"Unidade de tempo", 
	   round_up_to_end_of_time_unit:"Recupeia até o final da unidade",
	   product_name:"Nome do Produto",
	   product_ID:"ID do produto", 
	   price_offer:"Oferta de preço", 
	   price:"Preço", 
	   frequency:"Frequência", 
	   effective_from:"Eficaz de", 
	   effective_to:"Eficaz para", 
	   active:"Ativo",
	   drag_drop_to_text_cursor_in_content:"Arraste e solte para o cursor de texto em conteúdo", 
	   event_type:"Tipo de evento", 
	   notification_rule:"Regra de notificação", 
	   level_or_ugency:"Nível ou ugência", 
	   user_role:"Papel do usuário",
	   edit_security_user_tags:"Editar tags de usuário de segurança",
	   content_access:"Acesso ao conteúdo", 
	   content_access_for:"Acesso ao conteúdo para", 
	   add_new_access:"Adicione novo acesso", 
	   date_assigned:"Data atribuída",
	   enrollment_request:"Data atribuída", 
	   enrollment_request_for:"Solicitação de inscrição", 
	   mentors:"Mentores",
	   options:"Opções",
	   department_name:"Nome do departamento", 
	   universal_department:"Departamento Universal", 
	   open:"Abrir",
	   min_point:"Min Point", 
	   max_point:"Max Point", 
	   grade_point:"Ponto de classificação", 
	   honors:"Honras", 
	   college:"Faculdade",
	   order:"Ordem", 
	   start_time:"Hora de início", 
	   end_time:"Fim do tempo",
	   period_name:"Nome do período",
	   grading_periods_head:"Cabeça dos períodos de classificação",
	   grading_period:"Período de classificação", 
	   weight:"Peso",
	   track_name:"Nome da faixa",
	   academic_track_requirement:"Requisito de faixa acadêmica", 
	   of_required_credits:"# de créditos necessários",
	   individual_learning_plan_template:"Modelo de plano de aprendizado individual",
	   ILP_name:"Nome do ILP",
	   remove_requirement:"Remova o requisito", 
	   reset_requirement:"Redefinir requisito", 
	   add_requirement:"Adicione requisito",
	   must_end_date:"Deve terminar a data", 
	   courses_open_date:"Cursos Data de abertura", 
	   signup_end_date:"Data final de inscrição", 
	   signup_start_date:"Data de início da inscrição", 
	   section_period:"Período de seção",
	   
	    weeks:"Semanas", 	  
	   search_for_a_section_or_id:"Procure uma seção ou ID…",
	   search_for_a_deft:"Procure um departamento ...", 	   
	   launch_course:"Abrir o curso", 
	   start_class:"Começar a aula", 	   
	   weekly_progress_goal:"Objetiva de progresso semanal", 
	   send_message_to_all_section_students:"Envie mensagem para todos os alunos da seção", 
	   monitor_live_sessions:"Monitore sessões ao vivo", 
	   average_section_grade:"Grau de seção média", 
	   resources:"Recursos", 
	   activities:"Atividades", 	   
	   course_attendance_today:"Participação no curso hoje", 
	   staffs:"Funcionários", 
	   units:"Unidades", 	   
	   view_all_15_resources:"Ver todos os 15 recursos", 
	   Class_discussions:"Discussões em classe", 
	   recent_discussions:"Discussões recentes", 
	   go_to_class_discussions:"Vá para discussões de aula", 	   
	   show_my_class_attendance:"Mostre minha aula de presença", 
	   add_section:"Adicionar seção",
	   add_global_section:"Adicionar seção global",
	   close_section:"Fechar Seções",
	   open_section:"Seções abertas",
	   batch_upload:"Carregamento em Lote",
	   finalize:"Finalizar",	   
	   add_tearcger:"Adicionar professor(es)",
	   remove_tearcger:"Remova o(s) professor(es)",
	   uploadSectionStatusUpdates:"Carregar atualizações de status da seção",
	   status_count:"Contagem de status",	   
	   reactivate:"Reativar",
	   clone:"Clone",
	   enroll_into_Section:"Inscreva-se na Seção",
	   bulk_enrollment:"Inscrição em Massa",
	   general_Information:"Informações gerais",	   
	   online_content_source:"Fonte de conteúdo on-line",
	   second_teacher:"Segundo Professor",
	   today:"hoje",
	   calendar:"Calendário",
	   week:"semana",
	   month:"Mês",	   
	   section_progress:"Progresso da Seção",
	   complete:"completa",	   
	   section_title:"Título da seção",
	   enter_section_title:"Digite o título da seção",
	   select_teacher:"Selecione o professor",	   
	   select_weeks:"Selecione semanas",
	   select_credits:"Selecione os créditos",
	   select_type:"Selecione o tipo",
	   global_section:"Seção Global",	   
	   enrollment_capacity:"Capacidade de inscrição",
	   enter_enrollment_capacity:"Insira a capacidade de inscrição",
	   in_class_information:"Em Informações de Classe",
	   show_all:"Mostre tudo",
	   Start:"Começar",
	   End:"Fim",
	   recurrencePattern:"Padrão de recorrência",
	   recurrenceFrequency:"Frequência de Recorrência",
	   Weekly:"Semanalmente",
	   Monthly:"Por mês",
	   Recur_every:"Se repetem a cada",
	   Weeks_on:"Semanas depois",
	   day_of_week:"Dia da semana",
	   daily_period:"Período diário",
	   select_daily_period:"Selecione o período diário",
	   Day:"Dia",
	   The:"O",
	   of_every:"de todos",
	   month_s:"meses)",
	   add:"Adicionar",	   
	   course_prequisites :"Pré-requisitos do curso",
	   select_status:"Selecione o estado",
	   select_school:"Selecione Escolas",	   
	   select_period:"Selecione o período",
	    room_number:"Número do quarto",
	   select_room_number:"Selecione o número do quarto",
	   Service:"Serviço",
	   enter_url:"Insira URL",
	   edit_section:"Editar seção",
	   activity_templates:"Modelos de atividades",
	   select_activity_templates:"Selecione o modelo de atividade",
	   link_section:"Seção de links",
	   select_link_section:"Selecione a seção do link",
	   please_select_sections:"Selecione as seções.",
	   if_you_change_your_status_of_inactivity:"Se você alterar seu status de inatividade, o aluno será afetado.",
	   closing_the_global_section_will_cause:"O fechamento da seção global causará o fechamento de todas as escolas e a retirada de todos os alunos nelas. Clique em Confirmar se quiser continuar.",
	   upload_import_data:"Carregar e importar dados",	   
	   here:"Aqui",
	   no_data_avalable_in_table:"Sem dados disponíveis na tabela",
	   add_teacher_to_multiple_section:"Adicionar professor(es) a várias seções",
	   select_teachers_to_add_to_multiple_section:"Selecione professores para adicionar a várias seleções",
	   selected:"Selecionado",
	   selected_all:"Selecionar tudo",
	   deselected_all:"Desmarcar todos",
	   remove_teacher_from_multiple_section:"Remova o(s) professor(es) de várias seções",
	   select_teacher_to_remove_to:"Selecione os professores para remover para várias seleções",
	   process_removal:"Remoção de processos",
	   clone_section:"Seção Clonar",
	   enroll_student:"matricular aluno",
	   enroll_student_to:"Matricular alunos para",
	   name:"Nome",
	   search_for_a_student_or_id:"Pesquise por um estudante ou ID…",
	   confirmation_of_enrollment:"CONFIRMAÇÃO DA INSCRIÇÃO",
	   please_review_and_confirm_enrollments_for:"Revise e confirme as inscrições para",
	   confirm:"Confirme",
	   enroll_students_to_section:"INSCREVA ALUNOS NA SEÇÃO",
	   enrollment_period:"Período de inscrição",
	   days:"dias",
	   no_data_avalible:"Não há dados disponíveis.",
	   number_of_primary_teacher:"Número de professores primários",
	   secondary_teachers:"Professores Secundários",
	   department_head:"Chefe de departamento",
	   section_enroll:"Seção Inscrever",
	   load_from_file:"Carregar do arquivo",
	   see_sections:"Veja seções",
	   change_enrollment_status:"Alterar o status da inscrição",
	   mentor_s:"Mentor (s)",
	   overdue_activities:"Atividades atrasadas",
	   total_session_time_and_last_log:"Tempo total da sessão e último log",
	   course_name_on_transcript:"Nome do curso na transcrição",
	   edit_other_grades:"Edite outras notas",
	   save_as:"Salvar como",
	   account_receivable_dashboard:"Painel de contas a receber",
	   key_performance_indicators:"Indicadores Chave de Performance",
	   a_r_dashboard:"Painel A/R",
	   payments_credits:"Pagamentos/créditos",
	   contract_templates:"Modelos de contrato",
	   master_contracts:"Contratos mestre",
	   a_r_configuration:"Configuração A/R",
	   a_r_processing:"Processamento A/R",
	   aging:"Envelhecimento",
	   receivable:"A receber",
	   account_receivable_by_program:"Conta a receber por programa",
	   request_detail:"Solicitar detalhes",
	    request_information:"Pedir informação",
	    requested_by:"Requerido por",
	    approved_by:"Aprovado por",
	    approve:"Aprovar",
	    phone_name:"Nome do telefone",
	    phone_carrier:"Operadora de telefone",
		area_code:"Código de área",
	   address_lable:"Endereço da vontade",
	   address_default:"Endereço padrão",
	   new_photo:"Nova foto",
	   current_of_wweeks:"Número atual de semanas",
	   select_enrollment_period:"Selecione Período de inscrição",
	   enter_rejection_reason:"Digite a razão de rejeição ...",
	   comments_and_documents:"Comentários e documentos",
	   enrollment_history:"Histórico de inscrições",
	   request_extension_for:"Solicitar extensão para",
	   extended_of_weeks:"Número prolongado de semanas",
	   current_enrollment_status:"Status de inscrição atual",
	   select_extension_option:"Selecione a opção de extensão",
	   extend_current_enrollment_until:"Estender a inscrição atual até",
	   transfer_to_new_section:"Transferência para a nova seção",
	   transcript_requests:"Solicitações de transcrição",
	   person_requesting_transcript:"Pessoa solicitando transcrição",
	   telephone_number:"Número de telefone",
	   number_of_copies:"Número de cópias",
	   special_instructions:"Instruções Especiais",
	   last_school_attendance:"Última participação na escola",
	   year_last_attended:"Ano passado participou",
	   current_address:"Morada atual",
	   relationship_to_student:"Relacionamento com o aluno",
	   method_of_delivery:"Método de entrega",
	   instructions:"*Instruções",
	   previous_requests:"Solicitações anteriores",
	   additional_info:"Informação adicional",
	   receive:"Receber",
	   process:"Processo",
	   add_to_school_group:"Adicionar ao grupo escolar",
	   submit_romote:"Enviar promoção",
	   next_grade_level:"Próximo nível da série",
	   please_select_a_school_for_promotion_and_transfer:"Selecione uma escola para promoção e transferência",
	   write_off:"Eliminar",
	   amount_due:"Valor devido",
	   open_amount:"Valor Aberto",
	   payment_application:"Solicitação de pagamento",
	   use_credit_openBalance:"Use crédito $ 111",
	   payment_amount_usd:"Valor do pagamento (USD)",
	   check_number:"Verifique o número",
	   confirmation_number:"Número de confirmação",
	   apply_payment:"Aplicar pagamento",
	   amount_paid:"Quantia paga",
	   applied_payment:"Pagamento aplicado",
	   payer_id:"ID do pagador",
	   view_detail:"Ver detalhes",
	   master_contract:"Contrato mestre",
	   copy:"cópia de",
	   contract_user_detail:"Detalhes do usuário do contrato",
	   follow_product_cost:"Siga o custo do produto",
	   default_cost:"Custo padrão",
	   offered_cost:"Custo oferecido",
	   contract_detail:"Detalhes do contrato",
	   contract_template_name:"Nome do modelo de contrato",
	    master_contract_name:"Nome do contrato mestre",
		 view_students:"Ver alunos",
		 make_payment:"Faça o pagamento",
		 parent_page:"Página pai",
		 edit_parent:"Edite pai",
		 edit_profile:"Editar Perfil",
		 account_receivable_configuration:"Configuração de conta a receber",
		 invoice_generation_date:"Data de geração da fatura", 
	   invoice_generation:"Geração de fatura", 
	   number_of_days_until_due_date:"Número de dias até a data de vencimento",
	   account_receivable_processing:"Processamento a receber de conta",
	   generate_invoices:"Gerar faturas", 
	   process_automatic_payments:"Processe pagamentos automáticos", 
	   send_late_notices:"Envie avisos atrasados",
	   course:"Curso",  
	   copy_courses:"Cursos de cópia", 
	   copy_to_school:"Cópia para a escola", 
	   originating_program_code:"Originando o código do programa", 
	   destinating_program_code:"Destinar o código do programa", 
	   status_error:"Status/erro",
	   add_prerequisite:"Adicione o pré -requisito", 
	   group_name:"Nome do grupo", 
	   enter_group_name:"Digite o nome do grupo", 
	   select_a_department_to_display_courses:"Selecione um departamento para exibir cursos", 
	   edit_tranferred_grades:"Edite outras notas", 
	   showing_num_records:"Mostrando 000 registros",
	   edit_all_other_grades:"Edite todas as outras notas",
	   upload_student_documents:"Carregar documentos do aluno",
	   select_an_official_transcript_option:"Selecione uma opção de transcrição oficial", 
	   for_schools_or_personal_copy:"Para escolas ou cópia pessoal", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Para uso do aluno, envie para outra escola ou para verificar as matrículas.", 
	   request_official_transcript:"Solicitar transcrição oficial", 
	   PARCHMENT_for_colleges_or_universities:"Pergaminho para faculdades ou universidades", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Para aplicação em uma faculdade/universidade e para verificar a conclusão do seu diploma.", 
	   request_transcript:"Solicite transcrição", 
	   Learn_more_about_how_to_use_PARCHMENT:"Saiba mais sobre como usar pergaminho",
	   print_PDF:"Imprima PDF",
	   user_school:"Escola de usuário",
	   filter:"Filtro",
	   GENERAL:"EM GERAL", 
	   STUDENT_INFO:"Informações do aluno", 
	   list:"Lista", 
	   last_school_name:"Último nome da escola", 
	   TEACHER_INFO:"Informações do professor", 
	   contracted_load:"Carga contratada", 
	   ARENT_INFO:"Informações dos pais",
	   add_credential:"Adicione credencial",
	   edit_credential:"Editar credencial",
	   add_comment_document:"Adicionar comentário e documento",
	   add_comment_document_for:"Adicionar comentário e documento para",
	   state_province:"Estado/ província", 
	   post_code:"Código de postagem", 
	   linking_students_to:"Vincular os alunos a", 
	   change_expiration_date:"Data de expiração da alteração", 
	   expiry_date:"Data de validade", 
	   please_select_department:"Selecione o departamento.", 
	   please_select_course:"Selecione o curso.", 
	   please_select_title:"Por favor, insira o título.", 
	   please_select_primary_teacher:"Selecione o professor primário.", 
	   please_select_weeks:"Selecione semanas.", 
	   please_select_level:"Selecione o nível.", 
	   please_select_credits:"Selecione os créditos.", 
	   please_select_type:"Selecione o tipo.", 
	   please_select_daily_period:"Selecione o período diário.",
	   please_enter_link_section:"Por favor, insira a seção Link.",
	   please_enter_first_name:"Por favor, insira o primeiro nome.", 
	   please_enter_last_name:"Por favor, insira o sobrenome.", 
	   please_enter_contracted:"Por favor, insira contratados.", 
	   please_enter_email:"Por favor, insira o email.", 
	   please_enter_phone:"Por favor, insira o telefone.", 
	   please_enter_username:"Por favor, insira o nome de usuário.",
	   please_enter_password:"Por favor, digite a senha.", 
	   please_enter_status:"Selecione o status.", 
	   save_successful:"Salvo com sucesso!.",
	   please_add_student_address:"Adicione o endereço do aluno.", 
	   please_enter_email_address:"Por favor, insira endereço de e -mail.", 
	   please_select_relationship:"Selecione o relacionamento.", 
	   please_select_parent_status:"Selecione o status dos pais.", 
	   please_enter_label:"Por favor, insira a etiqueta.", 
	   please_enter_address:"Por favor, insira o endereço.", 
	   please_enter_city:"Por favor, entre na cidade.", 
	   please_enter_state:"Por favor, insira o estado.", 
	   please_enter_zip_code:"Por favor, insira o código postal.", 
	   please_select_date_of_birth:"Selecione a data de nascimento.", 
	   please_select_track:"Selecione a faixa.", 
	   please_enter_graduation_date:"Por favor, insira a data de graduação.", 
	   please_enter_country:"Por favor, entre no país.", 
	   please_enter_phone_number:"Por favor, insira o número de telefone.", 
	    please_enter_parent_first_name:"Por favor, insira o primeiro nome do pai.", 
	   please_enter_parent_last_name:"Por favor, insira o sobrenome dos pais.", 
	   please_enter_parent_email_address:"Por favor, insira endereço de e -mail pai.", 
	   please_enter_parent_username:"Por favor, insira o nome de usuário dos pais.", 
	   please_select_parent_relationship:"Selecione o relacionamento pai.", 
	   please_enter_phone_label:"Por favor, insira a etiqueta telefônica.", 
	   student_address_canot_be_empty:"O endereço do aluno não pode estar vazio.", 
	   please_select_document_type:"Selecione o tipo de documento.", 
	   please_enter_new_type:"Por favor, insira um novo tipo.", 
	   please_enter_comment:"Por favor, insira o comentário.", 
	   link_is_not_a_valid_url:"O link não é um URL válido.",
	   please_enter_link_and_label:"Por favor, insira link e etiqueta.",
	   are_you_sure_to_delete_this_student:"Você tem certeza de excluir este aluno.",
	   please_select_gender:"Por favor selecione um gênero.",
	   school_contracted_load:"Escola contratou carga", 
	   global_contracted_load:"Carga contratada global",
	   please_enter_label_for_attachments:"Por favor, insira o rótulo para anexos.",
	   please_select_section:"Selecione a seção.", 
	   enrollment_completed_successfully:"A inscrição foi concluída com sucesso.",
	   delete_this_comment:"Excluir este comentário?",
	   please_enter_course_name:"Por favor, insira o nome do curso.", 
	   please_select_credits_possible:"Selecione os créditos possíveis.",
	   can_save_record:"Não é possível salvar registro:",
	   are_you_sure_to_delete_this_tranferred_grade:"Você tem certeza de excluir esta nota transferida?",
	   are_you_sure_to_delete_num_tranferred_grade:"Você tem certeza de excluir 11 grau transferido?", 
	   please_select_tranferred_grade:"Selecione Grau transferido.",
	   please_ente_subject:"Por favor, insira o assunto.", 
	   please_select_made_to:"Selecione feito para.", 
	   delete_this_communication:"Excluir esta comunicação?",
	   please_select_school:"Selecione a escola.",
	   please_enter_name:"Por favor, insira o nome.",
	   please_enter_group_name:"Por favor, insira o nome do grupo.",
	   you_have_some_form_errors_please_check_above:"Você tem alguns erros de formulário. Por favor, verifique acima.",
	   please_select_recipient:"Selecione o destinatário.", 
	   please_enter_description:"Por favor, insira a descrição.",
	   delete_this_resource:"Excluir este recurso?",
	   please_enter_activity_name:"Por favor, insira o nome da atividade.", 
	   please_select_activity_type:"Selecione o tipo de atividade.", 
	   please_enter_max_score:"Por favor, insira a pontuação máxima.", 
	   please_enter_due_date:"Por favor, insira a data de vencimento.",
	   please_enter_unit_name:"Por favor, insira o nome da unidade.",
	   are_you_sure_to_clear_this_unit:"Você tem certeza de limpar esta unidade?",
	   please_enter_score:"Por favor, insira a pontuação.",
	   delete_this_credential:"Excluir esta credencial?",
	   plase_select_period:"Selecione o período", 
	   plase_select_start_date:"Selecione a data de início", 
	   plase_select_end_date:"Selecione a data final",
	   select_to_register_course_to_students_individual_learning_path_view:"Selecione para registrar o curso para os alunos Visualização de Caminho de Aprendizagem Individual",
	   delete_this_request:"Excluir este pedido?",
	   please_enter_fname:"Por favor, insira o primeiro nome.", 
	   please_enter_lname:"Por favor, insira o sobrenome.", 
	   please_enter_birthday:"Por favor, insira o aniversário.", 
	   please_enter_address:"Por favor, insira o endereço.", 
	   please_enter_zip:"Por favor, digite ZIP.", 
	   please_enter_country:"Por favor, entre no país.", 
	   please_enter_ethnicity:"Por favor, digite a etnia.", 
	   please_enter_grade:"Por favor, insira a nota.", 
	   please_enter_mobile:"Por favor, insira o celular.", 
	   please_enter_hear_about_us:"Por favor, digite ouvir sobre nós.", 
	   please_enter_program_of_interest:"Por favor, insira o programa de interesse.", 
	   please_enter_course_level:"Por favor, insira o nível do curso.", 
	   please_enter_guardian_1_name:"Por favor, digite o Guardian 1 Nome.", 
	   please_enter_guardian_1_email:"Por favor, digite o Guardian 1 E -mail.", 
	   please_enter_guardian_1_home_phone:"Por favor, digite o Guardian 1 Home Telefone.", 
	   please_enter_guardian_1_relation:"Por favor, digite o Guardian 1 Relação.",
	   please_select_parents:"Selecione os pais.",
	   transfer_classroom:"Transferir sala de aula", 
	   please_choose_one_section_to_transfer:"Escolha uma seção para transferir.", 
	   transfer:"Transferir",
	   assigning_multiple_users_to_a_school_or_school_group:"Atribuir vários usuários a um grupo escolar ou escolar", 
	   add_to_school_or_school_group:"Adicionar ao grupo escolar ou da escola", 
	   please_select_school_or_school_group:"Selecione a escola ou o grupo escolar.",
	   print_student_progress_report:"Relatório de progresso do aluno de impressão",
 },
 ru: {
	   reporting_center:"Отчетный центр", 
	   grade_reports:"Отчеты классов", 
	   user_reports:"Пользовательские отчеты", 
	   learning_reports:"Учебные отчеты", 
	   administrative_reports:"Административные отчеты", 
	   progress_report:"Отчет о прогрессе", 
	   full_progress_report:"Полный отчет о прогрессе", 
	   grade_report:"Оценка отчета", 
	   roster_report:"СПОСКОЛЬНЫЙ ОТЧЕТ", 
	   parent_report:"Родительский отчет", 
	   teacher_report:"Отчет учителя", 
	   student_report:"Студенческий отчет", 
	   log_in_report:"Войдите в отчет", 
	   enrollmentreport:"Отчет о зачислении", 
	   enrollment_summary:"Резюме зачисления", 
	   student_enrollment_summary:"Сводка студентов", 
	   attendance_report:"Отчет посещаемости", 
	   attendance_summary_report:"Отчет об участии посещаемости", 
	   log_In_Credentials:"Войдите в учетные данные", 
	   application_report:"Отчет о подаче заявления", 
	   section_report:"Отчет раздела", 
	   course_report:"Курс отчет", 
	   communication_summary:"Сводка связи", 
	   comments_and_Document_Report:"Комментарии и отчет о документах", 
	   School_Calendar:"Школьный календарь", 
	   bell_Schedule:"График колокола", 
	   student_Contract:"Студенческий контракт", 
	   eOS_Report:"Отчет EOS", 
	   active_Enrollments_Per_Term_Report:"Активные зачисления в течение срока отчета", 
	   active_Student_Enrollments_with_As_Report:"Активные участия студентов с отчетом", 
	   active_Student_Enrollments_Report:"Активные отчеты о регистрации студентов", 
	   all_Students_GPA_Report:"Все студенты GPA отчет", 
	   old_All_Student_GPA_Report:"Старый все студенческие GPA отчет", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + отчет типа взаимодействия", 
	   enrollment_Confirmation_Report:"Отчет о подтверждении регистрации", 
	   eOS_College_Matriculations_Report:"Отчет о запланированных категориях EOS College", 
	   student_Enrollment_History_To_Date_w_Term_Report:"История зачисления студентов на сегодняшний день",
	   student_Information_Report:"Информационный отчет студентов", 
	   ran_by:"пробежал мимо",
	   Show_Filter:"Показать фильтр", 
	   School_Group:"Школьная группа", 
	   school:"Школа", 
	   department:"Отделение", 
	   student:"Студент", 
	   student_status:"Студенческий статус", 
	   course:"Курс", 
	   course_level:"Уровень курса", 
	   section:"Раздел", 
	   teacher:"Учитель", 
	   primary_teacher:"Основной учитель", 
	   secondary_teacher:"Средний учитель", 
	   completion_Date_Range:"Диапазон даты завершения", 
	   from_date:"С даты", 
	   to_date:"На сегодняшний день", 
	   status:"Положение дел", 
	   gender:"Пол", 
	   final_grade:"Окончательный класс", 
	   advisor:"Советник", 
	   grade_level:"Уровень образования", 
	   specific_mark:"Конкретный знак", 
	   track:"Отслеживать", 
	   ethnicity:"Этническая принадлежность", 
	   additional_fields:"Дополнительные поля", 
	   school_sessions:"Школьные сессии", 
	   gradebook:"Класс", 
	   submit:"Представлять на рассмотрение", 
	   reset:"Перезагрузить", 
	   show_hide_columns:"Показать/скрыть столбцы", 
	   select_all:"Выбрать все", 
	   student_id:"Студенческий билет", 
	   last_name:"Фамилия", 
	   first_name:"Имя", 
	   grade_level:"Уровень образования", 
	   start_date:"Дата начала", 
	   end_date:"Дата окончания", 
	   grade_final:"Оценка финала", 
	   percent:"Процент", 
	   credit:"Кредит", 
	   download_excel:"Скачать Excel", 
	   print:"Распечатать", 
	   no_data:"Нет данных.", 
	   view:"Вид", 
	   showing:"Показ", 
	   of:"из", 
	   other_grade:"Другой класс", 
	   level:"Уровень", 
	   date:"Дата", 
	   grade:"Оценка",
	   enrollment_Change_Status:"Статус изменения зачисления", 
	   close:"Закрывать", 
	   select_Enrollment_Status:"Выберите статус регистрации", 
	   select:"Выбирать...", 
	   cancel:"Отмена", 
	   save:"Сохранять", 
	   students:"Студенты", 
	   Course_Status:"Статус курса", 
	   Closed_courses:"Закрытые курсы", 
	   Section_Status:"Статус раздела", 
	   Closed_sections:"Закрытые секции", 
	   Transferred_From:"Переведен из",
	   Graduation_From_Date:"Выпуск с даты", 
	   Graduation_To_Date:"Выпускной на сегодняшний день", 
	   Enrollment_From_Date:"Зачисление с даты", 
	   Enrollment_To_Date:"Зачисление на сегодняшний день", 
	   Enrollment_Status:"Статус регистрации", 
	   Transfer_From_Date:"Передача с даты", 
	   Transfer_To_Date:"Передавать на сегодняшний день", 
	   Custom_Query:"Пользовательский запрос", 
	   Last_Access_Date:"Последняя дата доступа", 
	   Total_Session_Time:"Общее время сеанса", 
	   Quality_of_Work:"Качество работы", 
	   Grade_to_Date:"Оценка до настоящего времени", 
	   Overall_Percent:"Общий процент", 
	   On_Schedule_Percent:"По расписанию процент", 
	   Activity_Count_Complete:"Задолженность деятельности завершена", 
	   Activity_Count_Total:"Общее количество деятельности", 
	   Overdue_Activitie:"Просроченная активность",
	   Section_Course_Additional_Fields:"Раздел/Курс Дополнительные поля", 
	   Create_On_Date:"Создать на дату", 
	   Last_Status_Update_Date:"Последняя дата обновления статуса", 
	   Transferred_In:"Переведен в", 
	   Transferred_In_Date:"Передано в дату", 
	   email:"Электронная почта", 
	   birth_date:"Дата рождения", 
	   course_name:"Название курса", 
	   section_name:"Название раздела", 
	   school_name:"Название школы", 
	   Graduation_Date:"Дата выпуска", 
	   Created_on:"Создано на", 
	   mentor_Advisor:"Наставник/консультант",
	   sections:"Разделы", 
	   roster:"Состав", 
	   relationship:"Отношение", 
	   Email_or_Phone:"По электронной почте или телефону", 
	   Enter_any_text:"Введите любой текст", 
	   Advisor_Success_Manager:"Консультант / менеджер успеха", 
	   User_Id:"ID пользователя", 
	   phone_number:"Номер телефона", 
	   Student_Last_Name:"Студенческая фамилия", 
	   Student_First_Name:"Студенческое имя", 
	   Student_Email:"Электронная почта студентов",
	   credentials:"Реквизиты для входа", 
	   availability:"Доступность",
	   enrollments:"Зачисление", 
	   Datea_Created_on:"Дата создана на",
	   country:"Страна", 
	   state:"Состояние", 
	   zipcode:"Почтовый индекс", 
	   Enter_any_zipcode:"Введите любой ZipCode", 
	   address:"Адрес",
	   zip_Code:"Почтовый индекс",
	   Login_Report:"Отчет о входе в систему", 
	   user_Type:"Тип пользователя", 
	   user_Name:"Имя пользователя", 
	   Show_last_log_in_only:"Покажите только последний вход", 
	   Username:"Имя пользователя", 
	   Date_Time:"Дата/время", 
	   Ip_Address:"Айпи адрес", 
	   city:"Город",
	   Enrollment_Start_Date:"Дата начала регистрации", 
	   Enrollment_End_Date:"Дата окончания регистрации", 
	   Completion_Date:"Дата завершения", 
	   section_Type:"Тип раздела", 
	   student_Enrolled:"Студент зарегистрирован", 
	   content_Provider:"Поставщик услуг", 
	   student_Additional_Fields:"Студенческие дополнительные поля",
	   type:"Тип", 
	   in_Class_Information:"В классе информация",
	   Enrollment_Summary_Report:"Отчет об резюме зачисления", 
	   Transferred_From_School:"Переведен из школы",
	   Total_Enrollments:"Общее количество зачислений", 
	   content_Type:"Тип содержимого", 
	   active_Course_Progress:"Активный прогресс курса",
	   Grades:"Оценки", 
	   attendance:"Посещаемость",
	   student_Absences:"Студенческие отсутствия", 
	   total_Absence:"Полное отсутствие", 
	   section_Absences:"Пропуски раздела",
	   Grade_Level_Absences:"Отсутствие уровня",
	   Gender_Absences:"Гендерные отсутствия",
	   Login_credentials:"Вход в учетные данные", 
	   names:"Имена", 
	   user_status_admin_teacher_parent:"Статус пользователя (администратор, учитель, родитель)", 
	   show_title:"Показать заголовок", 
	   midle_name:"Второе имя", 
	   password:"Пароль", 
	   parent_name:"Родительское имя", 
	   linked_to_parent:"Связано с родителем", 
	   linked_to_student:"Связано со студентом",
	   login_credentials_Report:"Вход в учетные данные отчет", 
	   app_id:"Приложение идентификатор", 
	   created:"Созданный", 
	   modified:"Модифицированный",
	   select_level:"Выберите уровень", 
	   select_additional_fields:"Раздел Дополнительные поля", 
	   title:"Заголовок", 
	   credits:"Кредиты", 
	   section_ID:"Идентификатор раздела", 
	   content:"Содержание", 
	   course_additional_fields:"Курс Дополнительные поля",
	   course_id:"Идентификатор курса", 
	   communication_summary_report:"Сводка связи", 
	   method:"Метод", 
	   create_date:"Создать дату", 
	   subject:"Предмет", 
	   make_from_id:"Сделать из идентификатора", 
	   make_to:"Делать", 
	   attachments:"Вложения", 
	   comment_and_document_summary_report:"Комментарий и сводный отчет о документах", 
	   comment_type:"Тип комментария", 
	   flagged:"Помеченный", 
	   sharing_target:"Разделение цели", 
	   show_on_transcript:"Показать на стенограмме", 
	   by:"К", 
	   comment:"Комментарий", 
	   type_name:"Тип имени", 
	   effective_from_date:"Вступает в силу с даты", 
	   effective_to_date:"Вступает в силу на сегодняшний день", 
	   count_docs:"Считайте документы",
	   school_calendar_report:"Отчет о школьном календаре", 
	   event_Id:"Идентификатор события", 
	   date_start:"Дата старта", 
	   date_end:"Конец даты", 
	   posted_last_name:"Опубликовано фамилия", 
	   posted_first_name:"Опубликовано имя",
	   bell_schedule_report:"Отчет о расписании колокола", 
	   period:"Период", 
	   start:"Начинать", 
	   end:"Конец",
	   student_contract_report:"Отчет студенческого контракта", 
	   begin_date:"Начните дату", 
	   contracts:"Контракты", 
	   contract_name:"Название контракта", 
	   contract_begin_date:"Контракт дата начала", 
	   contract_end_date:"Дата окончания контракта",
	   active_enrollments_per_term_report:"Активные зачисления в течение срока отчета", 
	   entry_date:"Дата ввода", 
	   teachers:"Учителя", 
	   term:"Срок",
	   sections:"Разделы",
	   showing_of:"Показывая 10 из 20",
	   filter:"Фильтр",
	   students:"Ученики",
	   school:"школа",
	   all_school:"Все школы",
	   student:"Ученик",
	   email:"Эл. адрес",
	   grade_level:"Уровень оценки",
	   status:"Статус",
	   seach_for_a_student_or_id:"Поиск учащегося или удостоверения личности…",
	   search:"Поиск …",
	   message_student:"Сообщение студента",
	   request_enrollment:"Запрос на регистрацию",
	   print_schedule:"Распечатать расписание",
	   view:"Вид",
	   no_data:"Нет данных.",
	   views:"Просмотры", 
	   enrollment:"Зачисление", 
	   schedule:"Расписание", 
	   transferred_grades:"Перенесенные оценки", 
	   comments_ocuments:"Комментарии и документы", 
	   academic_records:"Академические отчеты", 
	   compliance_log:"Журнал соответствия", 
	   unofficial_transcript:"Неофициальная стенограмма", 
	   iD_card:"Идентификационая карта", 
	   student_number_id_information:"Студенческий номер #29561 Информация", 
	   student_number:"Количество студентов", 
	   gender:"Пол", 
	   goes_by:"Проходит мимо", 
	   date_of_birth:"Дата рождения", 
	   ethnicity:"Этническая принадлежность", 
	   mobile:"Мобильный", 
	   academic_track:"Академический трек", 
	   learning_path_template:"Шаблон пути обучения", 
	   graduation_date:"Дата окончания", 
	   comments:"Комментарии", 
	   transfer_information:"Информация о передаче", 
	   enrollment_date:"Дата поступления на работу", 
	   transfer_date:"Дата передачи", 
	   transfer_student:"Студент по обмену", 
	   parent_mentor_contact:"Контакты родителей/наставников", 
	   mentor:"Наставник", 
	   parent_phone:"Телефон родителей", 
	   emergency_contact:"Экстренный контакт", 
	   academic_advisor_ssm:"Научный советник / SSM", 
	   student_success_manager:"Менеджер по успеху студентов", 
	   academic_avisor:"Научный руководитель", 
	   address:"Адрес", 
	   address_01_Default:"Адрес 01 (по умолчанию)", 
	   street:"Улица", 
	   city:"Город", 
	   state:"Состояние", 
	   zip:"Почтовый индекс", 
	   hide_Detailed_information:"Скрыть подробную информацию", 	    
	   current_course_progress:"Текущий прогресс курса", 	    
	   full_Path_Progress:"Прохождение полного пути", 	    
	   print:"Распечатать", 	    
	   avg_graduation_progress:"Сред. Выпускной прогресс", 	    
	   GPA:"средний балл", 	    
	   graduation_Status:"Выпускной статус", 	    
	   on_track:"На ходу",
	   show_detailed_information:"Показать подробную информацию",
	   communication:"Коммуникация",
		student_advisors:"Студенческие советники", 	    
	   country:"Страна", 	    
	   grade:"Оценка", 	    
	   credits:"Кредиты", 	    
	   sort:"Сортировать", 	    
	   course_progress:"Ход курса",
	   overall_GPA:"Общий средний балл",
	    current_graduation_progress:"Текущий выпускной",
		individual_course_progress:"*Индивидуальный прогресс курса варьируется, это ваш общий прогресс",
		subject:"Предмет",
		online_sections:"Онлайн разделы",
	   course:"Курс", 
	   section:"Раздел", 
	   actions:"Действия", 
	   view_event:"Просмотр события",
	   in_class_section:"В разделе класса",
	   calendar:"Календарь",
	   access_link:"Доступ к ссылке", 
	   online_link:"Онлайн ссылка",
		launch_course:"Запустить курс", 
	   start_class:"Начальный класс",
	   level:"Уровень", 
	   date:"Свидание", 
	   transferred_in:"Переведено в",
	   tranferred_grades:"Переведенные оценки",
	   Searchs:"Поиск", 
	   Search_department_course:"Курс отдела поиска, src…",
	   archived:"В архиве", 
	   add_comment:"Добавить комментарий", 
	   created_date:"Дата создания", 
	   by:"По", 
	   type:"Тип", 
	   comment:"Комментарий", 
	   from_date:"С даты", 
	   to_date:"На сегодняшний день", 
	   documents:"Документы", 
	   edit:"Редактировать", 
	   delete:"Удалить",
	   communications:"Коммуникации", 
	   add_communications:"Добавить общение", 
	   made_from:"Сделан из", 
	   made_to:"Внесены", 
	   means:"Означает", 
	   attachments:"Вложения", 
	   content:"Содержание",
	   compliance_logs:"Журналы соответствия", 
	   messageID:"Идентификатор сообщения", 
	   agree:"Соглашаться", 
	   dateTime:"Дата Время", 
	   iPAddress:"Айпи адрес", 
	   add_idit_comment_document:"Добавить/редактировать комментарий и документ", 
	   document_type:"Тип документа", 
	   show_on_transcript:"Показать в расшифровке", 
	   select_users_to:"Выберите пользователей для", 
	   teacher:"Учитель", 
	   parent:"Родитель", 
	   flag:"Флаг", 
	   none:"Никто", 
	   link:"Ссылка на сайт", 
	   label:"Этикетка", 
	   add_more_link:"Добавить еще ссылку", 
	   save:"Сохранять", 
	   add_edit_communication:"Добавить/редактировать сообщение", 
	   made_by:"Сделан", 
	   date_time:"Дата/Время", 
	   length:"Длина", 
	   select:"Выбирать", 
	   select_users_to_view:"Выберите пользователей для просмотра сообщений", 
	   add_more:"Добавить больше", 
	   communication_summary:"Резюме связи",
	   close:"Закрыть",
	   new_type:"Новый тип",
	   select_user_to_view_comment:"Выберите пользователей для просмотра комментариев",
	   flag_comment:"Пометить комментарий",
	   teacher_page:"Страница учителя",
	   edit_information:"Изменить информацию",
	   phone:"Телефон",
	   add_credential:"Добавить учетные данные",
	   add_edit_credential:"Добавить/изменить учетные данные",
	   first_name:"Имя",
	   midle_name:"Второе имя",
	   last_name:"Фамилия",
	   cancel:"Отмена",
	   add_new:"Добавить новое",
	   phone_type:"Тип телефона",
	   zipCode:"Почтовый индекс",
	   phone_number:"Номер телефона",
	   default:"По умолчанию",
	   please_select_country:"Пожалуйста, выберите страну",
	   student_information:"Студенческая информация",
	   username:"Имя пользователя",
	   user_directory:"Каталог пользователей",
	   add_teacher:"Добавить Учителя",
	   add_admin:"Добавить админ",
	   export_to_excel:"Экспорт в Excel",
	   export_to_pdf:"Экспорт в PDF",
	   send_login_credentials:"Отправить учетные данные для входа",
	   search_for_a_user_or_id:"Поиск пользователя или идентификатора…",
	   user:"Пользователь",
	   school_admin:"Админ школы",
	   change_password:"Изменить пароль",
	   set_password_expiration_date:"Установите срок действия пароля",
	   impersonate_user:"Выдавать себя за пользователя",
	   edit_user_tags:"Редактировать пользовательские теги",
	   add_or_edit_users_schoo_assign:"Добавьте или измените пользователей, назначенных школой",
	   assign_content_access:"Назначить доступ к содержимому",
	   add_student:"Добавить студента",
	   add_parent_mentor:"Добавить родителя/наставника",
	   showing:"Показаны",
	   of:"из",
	   school_name:"Название школы",
	   edit_user_school_tags:"Изменить школьные теги пользователей",
	   personal_information:"Личные данные",
	   contacted_load:"Связался с грузом",
	   maximum_of_active_students:"Максимальное количество активных студентов",
	   teacher_since:"Учитель С",
	   login_infomation:"Информация для входа",
	   username:"Имя пользователя ",
	   password :"Пароль",
	   avatar :"Аватар",
	   teachers :"Учителя",
	   change_status :"Изменить статус",
	   add_admin:"Добавить админ",
	   name:"Имя",
	   create_on:"Создать Вкл",
	   registrar:"Регистратор",
	   birthday:"День рождения",
	   signature:"Подпись",
	   photo:"Фото",
	   designated_registrar:"Назначенный регистратор",
	   track:"Отслеживать",
	   select_existing_track:"Выбрать существующий трек",
	   available:"Доступный",
	   parent_mentor:"Родитель / Наставник",
	   relationship:"Отношение",
	   email_address:"Адрес электронной почты",
	   academic_mentor:"Академический наставник",
	   no_data_available_in_table:"Данные отсутствуют в таблице",
	   primary_language:"Основной язык",
	   add_into_parent_or_mentor:"Добавить в Родитель / Наставник",
	   add_into_phone:"Добавить в телефон",
	   add_into_address:"Добавить в адрес",
	   select_one:"Выбери один",
	   login:"Авторизоваться",
	   plese_select_country:"Пожалуйста, выберите страну",
	   edit_student:"Редактировать студент",
	   academic_advisor_or_student_success_manager:"Академический консультант / Менеджер по успеваемости студентов",
	   role:"Роль",
	   link_parent:"Родительская ссылка",
	   link_advisor_sms:"Консультант по ссылкам/SSM",
	   save_into_parent_mentor:"Сохранить в Родитель / Наставник",
	   save_into_parent_phone:"Сохранить в телефон",
	   save_into_parent_address:"Сохранить в адрес",
	   bulk_information_update:"Массовое обновление информации",
	   enrollments:"Зачисления",
	   email_student:"Электронная почта студента",
	   unofficial_transcripts:"Неофициальные стенограммы",
	   official_transcripts:"Официальные стенограммы",
	   email_students_schedule:"Расписание студентов по электронной почте",
	   export_students_to_excel:"Экспорт студентов в Excel",
	   export_parent_list_to_excel:"Экспорт родительского списка в Excel",
	   assign_learning_path_template:"Назначить шаблон пути обучения",
	   promote_student_to_the_next_grade_level:"перевести ученика на следующий уровень",
	   batch_upload_students:"Пакетная загрузка студентов",
	   batch_upload_transfer_grades:"Пакетная загрузка оценок передачи",
	   transfer_apex_only:"Трансфер (только APEX)",
	   transfer_content_providers:"Передача (все контент-провайдеры)",
	   batch_enrollments:"Пакетная регистрация",
	   send_message:"Отправить сообщение",
	   impersonate:"Выдавать себя за",
	   change_login_credentials:"Изменить учетные данные для входа",
	   request_enrollment:"Запросить регистрацию",
	   send_weekly_status_report:"Отправить еженедельный отчет о состоянии",
	   please_select_student:"Пожалуйста, выберите студентов.",
	   student_status_will_be_changed_to_status_withdraw:"Статус студента будет изменен на 111, и все зачисления будут отозваны. Вы уверены что хотите продолжить?",
	   student_status_will_be_changed_to_status:"Статус студента будет изменен на 111. Вы уверены, что хотите продолжить?",
	   value:"Ценить",
	   student_success_manager_or_acdemic:"Менеджер по успеху студентов / академический консультант",
	   enroll_students_to_section:"Записать студентов в раздел",
	   department:"Отделение",
	   refresh:"Обновлять",
	   select_department:"Пожалуйста, выберите отдел",
	   select_course:"Выберите курс",
	   select_section:"Выберите раздел",
	   start_date:"Дата начала",
	   end_date:"Дата окончания",
	   ID:"Я БЫ",
	   action:"Действие",
	   enrollment_period:"Период регистрации",
	   select_a_course_to_register_ilp:"Выберите курс, чтобы зарегистрировать ILP",
	   period:"Период",
	   credit:"Кредит",
	   year:"Год",
	   enroll:"Зарегистрироваться",
	   recipient_transcript:"Стенограмма получателя",
	   select_all_or_unselect_all:"выберите все / не приведены все",
	   include_in_progress_sections:"Включите в разделы",
	   show_satisfaction_of_program:"Показать удовлетворение программы",
	   show_total_credit:"Показать общие кредиты",
	   show_student_info:"Показать информацию о студенте",
	   show_academic_info:"Показать академическую информацию",
	   show_school_names_from_orther_grades:"Показать имена школ из других классов",
	   show_school_contact:"Показать школу контакт",
	   include_transferred_grades_in_gpa:"Включите перенесенные оценки в GPA",
	   include_in_progress_grade:"Включить в оценку",
	   include_grade_scales:"Включите шкалы",
	   show_graduation_date:"Показать дату выпуска",
	   show_weighted_gpa:"Показать взвешенный средний балл",
	   show_grade_level_gpa:"Show Grade GPA",
	   show_comletion_date:"Показать дату завершения",
	   show_withdraw_classes:"Показать отозванные занятия",
	   show_withdraw_date:"Показать дату отозванного",
	   show_transfered_in_classes:"Показать перевод в классах",
	   show_digital_seal:"Показать цифровую печать",
	   show_singnature:"Показать подпись",
	   group_by:"Группа по",
	   school_year:"Школьный год",
	   school_level:"Школьный уровень",
	   notes:"Ноты",
	   ok:"Хорошо",
	   are_you_sure_to_send:"Вы обязательно отправите?",
	   assign_learning_path_templete:"Назначить шаблон пути обучения",
	   assign_student_to_selected_learning:"Назначьте учащегося на выбор шаблона пути обучения",
	   assign:"Назначать",
	   are_you_sure_to_promote_to_level:"Вы обязательно продвинетесь на следующий уровень?",
	   data_process:"Процесс данных",
	   upload_and_import_data:"Данные загрузки и импорта",
	   download_user_information:"Загрузите информацию пользователя",
	   here:"здесь",
	   select_student_upload_file:"Выберите файл загрузки студентов",
	   local_drive:"Местный диск",
	   the_file_is_uploaded:"Файл загружен",
	   template_name:"Имя Шаблона",
	   Here:"Здесь",
	   sample_file_excel:"Пример файла Excel.",
	   file_type:"Тип файла",
	   delimited:"Разграничен",
	   delimited_chars:"Разграниченные чары",
	   fixed_width:"Фиксированная ширина",
	   first_line_header:"Заголовок первой линии",
	   loader_field:"Поле для загрузки",
	   Header:"Заголовок",
	   sample_data:"Образец данных",
	   column_width:"Ширина Colunm",
	   save_tamplate:"Сохранить шаблон",
	   save_and_upload_data:"Сохранить и загружать данные",
	   result:"Результат",
	   upload_and_import_data_orther_grade:"Загрузка и импорт данных в другом классе",
	   select_upload_file:"Выберите файл загрузки",
	   student_id:"Студенческий билет",
	   uploadAnd_import_data_enrollment:"Загрузка и импорт загрузки и импорт",
	   section_id:"Идентификатор раздела",
	   title:"Заголовок",
	   recipient:"Получатель",
	   same_current_address:"То же, что и текущий адрес",
	   add_more_reciptient:"Добавьте больше получателя",
	   issuse_date:"Дата выпуска",
	   show_total_unapplied_credits:"Покажите полные неисправные кредиты",
	   reconcile_another_student_record:"Согласовать с другой студенческой записи",
	   please_choose_one_student_to_reconcile:"Пожалуйста, выберите одного студента, чтобы примириться.",
	   yes:"Да",
	   no:"Нет",
	   apex_classroom_sync:"Apex Classroom Sync",
	   next:"Следующий",
	   apex_classrooms:"Apex Classrooms",
	   online_user_id:"Онлайн -идентификатор пользователя",
	   enter_online_user_id:"Введите онлайн -идентификатор пользователя",
	   online_section_id:"Идентификатор онлайн -раздела",
	   online_section_name:"Онлайн название раздела",
	   online_course_name:"Имя онлайн -курса",
	   enrollment_date:"Дата поступления на работу",
	   back:"Назад",
	   import:"Импортировать",
	   offical_transcipt:"Официальный транскрипт",
	   email_schedule:"Расписание электронной почты",
	   reconcile_with_another_records:"Согласовать с другой записью",
	   online_sync_and_update:"Синхронизация и обновление онлайн -прогресса",
	   download_all_completion_cretification:"Загрузите все сертификацию завершения",
	   orther_grade:"Другие оценки",
	   medical:"Медицинский",
	   comments_and_documents:"Комментарии и документы",
	   contracts:"Контракты",
	   invoices:"Счета",
	   audit_logs:"Журналы аудита",
	   edit_logs:"Редактировать журналы",
	   grade_to_date:"Оценка до настоящего времени",
	   quality_of_work:"Качество работы",
	   last_access:"Последний доступ",
	   gradebook:"Класс",
	   transfer:"Передача",
	   completion_certification:"Сертификация завершения",
	   tranfer_user_school:"Передача пользовательской школы",
	   tranfer_to_school:"Перевод в школу",
	   tranfer_apex_classrooms:"Передача вершины классные комнаты",
	   course_to_moved:"Курс, чтобы переехать",
	   current_teacher:"Нынешний учитель",
	   future_section:"Будущий раздел",
	   future_program:"Будущая программа",
	   future_teacher:"Будущий учитель",
	   enrollment_start_date_end_date:"Дата начала регистрации - дата окончания",
	   no_more_option:"Нет больше вариантов",
	   create_new:"создавать новое",
	   transfer_classrooms:"Передача классных комнат",
	   tyler_synchronization_for_az_school:"Синхронизация Тайлера для школ АЗ",
	   synchronize:"Синхронизировать",
	   individual_course_progress_varies:"Индивидуальный прогресс курса варьируется. Это ваш общий прогресс на пути к окончанию.",
	   edit_ilp:"Редактировать ILP",
	   add_academic_record:"Добавить академическую запись",
	   edit_all_records:"Редактировать все записи",
	   search_corse_department_src:"Поисковый курс, отдел, SRC…",
	   message_id:"Идентификатор сообщения",
	   add_new_contract:"Добавить новый контракт",
	   contract_id:"Идентификатор контракта",
	   contract_name:"Название контракта",
	   first_date:"Первое свидание",
	   last_date:"Последнее свидание",
	   amount_per_period:"Сумма за период",
	   terminating_status:"Прекращение статуса",
	    payment_history:"История платежей",
	   record_payment:"Запись оплаты",
	   payment_method:"Способ оплаты",
	   invoice_id:"Идентификатор счета",
	   show_all:"Показать все",
	   invoice_date:"Дата счета",
	   from:"От…",
	   to:"К…",
	   amount:"Количество",
	   paid:"Оплаченный",
	   due:"Должный",
	   date_paid:"Дата оплата",
	   apply_payments:"Применить платежи",
	   mark_as_paid:"Марк как оплаченный",
	   void:"Пустота",
	   audit_log:"Журнал аудита",
	   object:"Объект",
	   changes_made:"Изменения внесены",
	   create_time:"Создать время",
	   time_stamp:"Печать времени",
	   user_creare:"Пользователь CREATE",
	   edit_log:"Редактировать журнал",
	   field_name:"Имя поля",
	   old_value:"Старая стоимость",
	   new_value:"Новое значение",
	   date_time_update:"Обновление даты/времени",
	   updater:"Обновляющий",
	   add_edit_academic_records:"Добавить/редактировать академическую запись",
	   select_flag:"Выберите флаг ...",
	   edit_all_tranferred_grades:"Отредактируйте все оцениваемые оценки",
	   save_records:"Сохранить записи",
	   possible_credits:"Возможные кредиты",
	   select_level:"Выберите уровень",
	   select_grade_level:"Выберите уровень обучения",
	   select_status:"Выберите статус",
	   add_more_row:"Добавить больше ряда",
	   full_screen:"Полноэкранный",
	   course_code:"Добавить другие оценки",
	   add_order_grades:"Код курса",
	   select_credit:"Выберите кредит",
	   select_default:"Выберите по умолчанию",
	   credits_possible:"Кредиты возможны",
	   select_possible_credit:"Выберите возможный кредит",
	   product:"Продукт",
	   fromn:"От",
	   ton:"К",
	   last_invoice_date:"Последняя дата счета",
	   please_select_stu:"Пожалуйста, выберите студента",
	   payer:"Плательщик",
	   amount_per_billing_period:"Сумма за счет выставления счетов",
	   price_unit:"Ценовая единица",
	   billing_period:"Расчетный период",
	   automatic_renewal:"Автоматическое обновление",
	   automatic_payment:"Автоматический выставление счетов",
	   duration_of_period:"Продолжительность (# периодов)",
	   payment_id:"Идентификатор оплаты",
	   payment_date:"Дата оплаты",
	   payment_amount:"К оплате",
	   applied:"Применяемый",
	   available:"Доступный",
	   unApply:"Неисполнение",
	   refund:"Возвращать деньги",
	   add_new_teacher:"Добавить нового учителя",
	   change_teacher_status:"Изменить статус учителя",
	   search_for_a_teacher_or_id:"Поиск учителя или удостоверения личности…",
	   flags:"Флаги",
	   tags:"Теги",
	   allowed:"Допустимый",
	   message_teacher:"Сообщение Учитель",
	   impersonate_teacher:"Выдающегося учителя",
	   add_teacher_qualification:"Добавить квалификацию учителя",
	   profile:"Профиль",
	   teacher_schedule:"График учителей",
	   qualifications:"Квалификация",
	   student_actions:"Действия студентов",
	   linking_parents_to:"Связывая родителей",
	   select_do:"Выбирать ...",
	   see_edit_logs:"Смотрите журналы редактирования",
	   see_qualifications:"Смотрите квалификацию",
	   link_academic_advisor:"Ссылка академического советника",
	   student_success:"Студенческий успех",
	   linking_academic_advisor_or_student_success:"Связывая академического консультанта / успеха студентов с",
	   staff:"Персонал",
	   teacher_status:"Статус учителя",
	   school_admin_status:"Школьный администратор статус",
	   global_user_directory:"Глобальный пользовательский каталог",
	   edit_teacher:"Редактировать учитель",
	   contracted:"Контрактный",
	   add_comments_and_documents:"Комментарии и документы",
	   edit_comments_and_documents:"Редактировать комментарии и документы",
	   parents_or_mentor:"Родители / наставник",
	   send_mail:"Отправить письмо",
	   are_you_sure_to_delete_this_teacher:"Вы обязательно удалите этого учителя.",
	   edit_user_password:"Редактировать имя пользователя и пароль",
	   add_qualifications:"Добавить квалификацию",
	   please_select_a_least_on_teacher:"Пожалуйста, выберите хотя бы одного учителя.",
	   edit_parent_mentor:"Редактировать родитель / наставник",
	   parent_mentor_information:"Информация о родителе / ​​наставнике",
	   send:"Отправлять",
	   are_you_surse_to_delete_this_parent:"Вы обязательно удалите этого родителя.",
	   home:"Дом",	   
	  // auto_promotion:"Автопродаж",
	   auto_promotion:"Продвижение уровня ученика",
	   Promote:"Продвигать",
	   search_for_a_name:"Ищите имя…",
	   download_to_excel:"Скачать в Excel",
	   download_to_pdf:"Скачать в PDF",
	   User_ID:"ID пользователя",
	   User_type:"Тип пользователя",
	   communication_log:"Журнал связи",
	   Student_Status:"Студенческий статус",
	   Users:"Пользователи",
	   Staff_Reassignment:"Персонал Персонал",
	   Select_Staff:"Выберите персонал",
	   select_asset_type_to_reassign:"Выберите тип актива, чтобы переназначить",
	   transfer_all_to:"Перенесите все на",
	   transfer_selectively:"Переносить выборочно",
	   remove_all:"Убрать все",
	   remove_selectively:"Удалить выборочно",
	   Event:"Событие",
	   Time:"Время",
	   Participants:"Участники",
	   new_staff:"Новые сотрудники",
	   Remove:"Удалять",
	   Profile_Page:"Страница профиля",
	   settings:"Настройки",
	   security:"Безопасность",
	   timezone:"Часовой пояс",
	   notifications:"Уведомления",
	   check_for_feature_availability_at_your_school:"Проверьте наличие функций в вашей школе.",
	   current_password:"Текущий пароль",
	   new_password:"Новый пароль",
	   confirm_password:"Подтвердите пароль",
	   updte_password:"Обновить пароль",
	   change_timezone:"Изменение часового пояса",
	   time_zone:"Часовой пояс",
	   please_select_time_zone:"Пожалуйста, выберите часовой пояс",
	   notification_settings:"Настройки уведомлений",
	   level_of_urgency:"Уровень срочности",
	   email_destination:"Электронная почта",
	   SMS_Destination:"Смс назначение",
	   app:"Приложение",
	   please_select_level_of_urgency:"Пожалуйста, выберите уровень срочности",	   
	   reset_filters:"Сбросить фильтры",
	   batch_data_update:"Обновление данных студента",
	   contract_template:"Шаблон контракта",
	   accept:"Принимать",
	   reject:"Отклонять",
	   view_roles:"Посмотреть роли",
	   administrator_information:"Информация администратора", 
	   account_reation_date:"Дата создания учетной записи", 
	   expiration_date:"Дата окончания срока", 
	   schools:"Школы", 
	   advisees:"Советы",
	   message:"Сообщение",
	   see_comments_and_documents:"См. Комментарии и документы",
	   restore_APEX_Classrooms:"Восстановите Apex Classrooms",
	   teacher_information:"Информация учителя", 
	   teacher_number:"Номер учителя", 
	   departmens:"Отделы", 
	   global_capacity:"Глобальный потенциал", 
	   local_contracted_load:"Местная контрактная нагрузка", 
	   parents:"Родители", 
	   parent_information:"Родительская информация",
	   linked_students:"Связанные студенты", 
	   link_student:"Ссылка студента", 
	   unlink_student:"Unlink Student", 
	   search_dot:"Поиск…", 
	   view_local:"Посмотреть локальный", 
	   view_global:"Посмотреть Global",
	   resource:"Ресурс",
	   current_grade:"Текущая оценка", 
	   affiliation:"Принадлежность", 
	   current_assignment:"Текущее задание", 
	   total_assignments:"Общие задания", 
	   percent_completed:"Процент завершен",
	   semester:"семестр",
	   graduation_year:"год выпуска", 
	   student_name:"Кредиты заработали", 
	   credits_earned:"Кредиты заработали",
	   exit:"Выход",
	   engagement_type:"Тип взаимодействия",
	   college_admitted:"Колледж признался", 
	   college_attending:"В колледже посещает", 
	   major:"Главный", 
	   report_card:"Табель успеваемости", 
	   academic_term:"Академический термин", 
	   show_average:"Показать среднее",
	   school_information:"Информация о школе",
	   school_misc_configuration:"Конфигурация школьной разности", 
	   school_tags:"Школьные теги", 
	   role_tags:"Ролевые теги", 
	   content_integration:"Интеграция контента", 
	   user_roles:"Пользовательские роли", 
	   communication_user_rules:"Правила пользователя связи", 
	   school_administrators:"Школьные администраторы", 
	   school_year_configuration:"Конфигурация учебного года", 
	   A_R_payment_configuration:"Конфигурация платежей A/R", 
	   facility:"Средство", 
	   enrollment_rules:"Правила зачисления", 
	   student_contract_rules:"Правила студенческого контракта", 
	   products:"Продукты", 
	   notification_templates:"Шаблоны уведомлений", 
	   transcript_viewer_options:"Транскрипционные параметры просмотра", 
	   feature_configuration:"Конфигурация функции", 
	   feature_settings:"Настройки функции", 
	   communication_rules:"Правила связи", 
	   object_state:"Объектное состояние", 
	   departments:"Отделы", 
	   grading_scales:"Масштабы оценки", 
	   grading_periods:"Периоды оценки", 
	   academic_tracks:"Академические треки", 
	   learning_path_templates:"Шаблоны пути обучения", 
	   grade_book_activity_descriptions:"Описания занятий книги классов", 
	   academic_terms:"Академические термины",
	   academic_system:"Академическая система",
	   address_line_1:"Адресная строка 1", 
	   country_code:"Код страны", 
	   address_line_2:"Адресная строка 2", 
	   school_title:"Школьный титул",
	   CEEB_code:"CEEB CODE", 
	   zip_postal_code:"Zip/почтовый код", 
	   state_province:"Государство/провинция", 
	   website:"Веб-сайт", 
	   subdomain:"Субдомен", 
	   success_manager:"Менеджер успеха", 
	   school_logo:"Школьный логотип", 
	   digital_seal:"Цифровая печать",
	   password_exception_rule:"Правило исключения пароля",
	   change_password_first_login:"Изменить пароль первым входом в систему", 
	   password_expires_after_days:"Пароль истекает через несколько дней", 
	   enforcement_of_teachers_load:"Применение нагрузки учителя", 
	   in_house_handling_of_transcript_requests:"В обработке запросов на стенограмму", 
	   display_mobile_app_link:"Отображать ссылку на мобильное приложение", 
	   display_weekly_progress_goal:"Показать еженедельную цель прогресса", 
	   turn_on_notification:"Включите уведомление", 
	   classic_letter:"Классическое письмо", 
	   automatic_parent_account_creation:"Автоматическое создание учетной записи родительской учетной записи", 
	   default_parent_account_status:"Статус родительской учетной записи по умолчанию", 
	   default_time_zone:"Временный пояс по умолчанию", 
	   link_to_transcript_vendor_help:"Ссылка на помощь поставщика стенограммы", 
	   link_to_transcript_vendor:"Ссылка на поставщика стенограммы", 
	   link_for_help_system:"Ссылка на систему помощи", 
	   student_enrollment_limit:"Предел регистрации студентов", 
	   default_section_type:"Тип раздела по умолчанию", 
	   default_section_capacity:"Емкость раздела по умолчанию",
	   transcript_template:"Шаблон транскрипта",
	   edit_security_school_tags:"Редактировать теги школы безопасности", 
	   security_school_tags:"Школа безопасности теги",
	   tags_name:"Теги имени", 
	   edit_role_tags:"Редактировать теги роли",
	   add_school_based_tags:"Добавить школьные теги", 
	   description:"Описание", 
	   applied_to_roles:"Применяется к ролям", 
	   teacher:"Учитель",
	   edit_security_role_tags_for:"Редактировать теги роли безопасности для",
	   school_admins:"Школьные администраторы",
	   school_begin_date:"Школа начала дата", 
	   school_end_date:"Дата окончания школы", 
	   automatic_control_of_teacher_s_load:"Автоматический контроль нагрузки учителя",
	   A_R_payment_gateway_configuration:"Конфигурация платежного шлюза A/R", 
	   payment_processing_vendor:"Обработка оплаты", 
	   secret_key:"Секретный ключ", 
	   publishable_key:"Публичный ключ", 
	   account_id:"Идентификатор учетной записи",
	   updating_tudents:"Обновление студентов", 
	   delete_selected_records:"Удалить выбранные записи",
	   attribute_name:"имя атрибута", 
	   applied_for:"Подал заявку на",
	   add_school:"Добавить школу", 
	   overview:"Обзор", 
	   search_for_school:"Поиск школы ...", 
	   search_for_student:"Поиск студента ...",
	   attribute_type:"Тип атрибута", 
	   select_school_group:"Выберите школьную группу", 
	   access_rights:"Права доступа", 
	   create:"Создавать", 
	   read:"Читать",
	   facility_management:"Управление объектом", 
	   facility_name:"Название объекта", 
	   capacity:"Емкость",
	   enrollment_allowance_period_days:"Период пособия по зачислению (дни)", 
	   maximum_enrollment_duration_days:"Максимальная продолжительность регистрации (дни)", 
	   start_date_of_the_week:"Начать дату недели", 
	   end_date_of_the_week:"Дата окончания недели",
	   lookup_name:"Имя поищивания", 
	   duration:"Продолжительность", 
	   time_unit:"Время", 
	   round_up_to_end_of_time_unit:"Закругление до конца времени",
	   product_name:"наименование товара",
	   product_ID:"Код товара", 
	   price_offer:"Предложение цены", 
	   price:"Цена", 
	   frequency:"Частота", 
	   effective_from:"Действительно с", 
	   effective_to:"Эффективно для", 
	   active:"Активный",
	   drag_drop_to_text_cursor_in_content:"Перетащите, чтобы текст курсор в контенте", 
	   event_type:"Тип события", 
	   notification_rule:"Правило уведомления", 
	   level_or_ugency:"Уровень или Украшение", 
	   user_role:"Роль пользователя",
	   edit_security_user_tags:"Редактировать теги пользователей безопасности",
	   content_access:"Контент доступ", 
	   content_access_for:"Контент доступ для", 
	   add_new_access:"Добавить новый доступ", 
	   date_assigned:"Дата назначена",
	   enrollment_request:"Дата назначена", 
	   enrollment_request_for:"Запрос на зачисление", 
	   mentors:"Наставники",
	   options:"Параметры",
	   department_name:"название отдела", 
	   universal_department:"Универсальный отдел", 
	   open:"Открыть",
	   min_point:"Мин точка", 
	   max_point:"Макс", 
	   grade_point:"Оценка", 
	   honors:"Награды", 
	   college:"Колледж",
	   order:"Заказ", 
	   start_time:"Время начала", 
	   end_time:"Время окончания",
	   period_name:"Имя периода",
	   grading_periods_head:"Оценки срока голове",
	   grading_period:"Период оценки", 
	   weight:"Масса",
	   track_name:"Название трека",
	   academic_track_requirement:"Академические требования треков", 
	   of_required_credits:"# необходимых кредитов",
	   individual_learning_plan_template:"Индивидуальный шаблон плана обучения",
	   ILP_name:"ILP имя",
	   remove_requirement:"Удалить требование", 
	   reset_requirement:"Сброс требования", 
	   add_requirement:"Добавить требование",
	   must_end_date:"Должен закончить дату", 
	   courses_open_date:"Курсы открыты", 
	   signup_end_date:"Регистрация дата окончания", 
	   signup_start_date:"Подписать дату начала", 
	   section_period:"Период раздела",
	   
	    weeks:"Недели", 	   
	   search_for_a_section_or_id:"Ищите раздел или удостоверение личности…",
	   search_for_a_deft:"Ищите отдел ...", 	   
	   launch_course:"Запустить курс", 
	   start_class:"Начальный класс", 	   
	   weekly_progress_goal:"Еженедельная цель прогресса", 
	   send_message_to_all_section_students:"Отправить сообщение всем учащимся раздела", 
	   monitor_live_sessions:"Мониторинг живых сессий", 
	   average_section_grade:"Средний класс секции", 
	   resources:"Ресурсы", 
	   activities:"виды деятельности", 	   
	   course_attendance_today:"Посещаемость курса сегодня", 
	   staffs:"Персонал", 
	   units:"Единицы", 	   
	   view_all_15_resources:"Просмотреть все 15 ресурсов", 
	   Class_discussions:"Классовые дискуссии", 
	   recent_discussions:"Недавние дискуссии", 
	   go_to_class_discussions:"Ходить на классные дискуссии", 	   
	   show_my_class_attendance:"Покажите мою посещаемость класса", 
	   add_section:"Добавить раздел",
	   add_global_section:"Добавить глобальную секцию",
	   close_section:"Закрыть разделы",
	   open_section:"Открытые разделы",
	   batch_upload:"Пакетная загрузка",
	   finalize:"Завершить",	   
	   add_tearcger:"Добавить учителя(ей)",
	   remove_tearcger:"Удалить Учителя(ов)",
	   uploadSectionStatusUpdates:"Загрузить обновления статуса раздела",
	   status_count:"Счетчик статусов",	   
	   reactivate:"Повторно активировать",
	   clone:"Клон",
	   enroll_into_Section:"Запишитесь в раздел",
	   bulk_enrollment:"Массовая регистрация",
	   general_Information:"Главная Информация",	   
	   online_content_source:"Источник онлайн-контента",
	   second_teacher:"Второй Учитель",
	   today:"Cегодня",
	   calendar:"Календарь",
	   week:"неделя",
	   month:"Месяц",
	   section_progress:"Раздел Прогресс",
	   complete:"полный",	   
	   section_title:"Название раздела",
	   enter_section_title:"Введите название раздела",
	   select_teacher:"Выберите учителя",	   
	   select_weeks:"Выберите недели",
	   select_credits:"Выберите кредиты",
	   select_type:"Выберите тип",
	   global_section:"Глобальный раздел",	   
	   enrollment_capacity:"Регистрационная емкость",
	   enter_enrollment_capacity:"Введите количество регистраций",
	   in_class_information:"В информации о классе",	   
	   Start:"Начинать",
	   End:"Конец",
	   recurrencePattern:"Повторяющийся шаблон",
	   recurrenceFrequency:"Частота повторения",
	   Weekly:"Еженедельно",
	   Monthly:"Ежемесячно",
	   Recur_every:"Повторяются каждый",
	   Weeks_on:"Недели",
	   day_of_week:"День недели",
	   daily_period:"Ежедневный период",
	   select_daily_period:"Выберите дневной период",
	   Day:"День",
	   The:"The",
	   of_every:"каждого",
	   month_s:"месяцы)",
	   add:"Добавлять",	   
	   course_prequisites :"Требования к курсу",
	   select_status:"Выберите статус",
	   select_school:"Выберите школы",	   
	   select_period:"Выберите период",
	   room_number:"Номер комнаты",
	   select_room_number:"Выберите номер комнаты",
	   Service:"Обслуживание",
	   enter_url:"Введите адрес",
	   edit_section:"Редактировать раздел",
	   activity_templates:"Шаблоны действий",
	   select_activity_templates:"Выберите шаблон активности",
	   link_section:"Раздел ссылок",
	   select_link_section:"Выберите раздел ссылки",
	   please_select_sections:"Выберите разделы.",
	   if_you_change_your_status_of_inactivity:"Если вы измените свой статус неактивности, это повлияет на учащегося.",
	   closing_the_global_section_will_cause:"Закрытие глобальной секции приведет к закрытию всех школ и выводу из них всех учащихся. Нажмите Подтвердить, если хотите продолжить.",
	   upload_import_data:"Загрузить и импортировать данные",	   
	   here:"Здесь",
	   no_data_avalable_in_table:"Данные отсутствуют в таблице",
	   add_teacher_to_multiple_section:"Добавить учителя (ов) в несколько разделов",
	   select_teachers_to_add_to_multiple_section:"Выберите учителей, чтобы добавить к нескольким выборам",
	   selected:"Выбрано",
	   selected_all:"Выбрать все",
	   deselected_all:"Убрать выделение со всего",
	   remove_teacher_from_multiple_section:"Удалить учителя (ов) из нескольких разделов",
	   select_teacher_to_remove_to:"Выберите учителей для удаления из нескольких вариантов",
	   process_removal:"Удаление процесса",	   
	   clone_section:"Клонировать раздел",
	   enroll_student:"Зарегистрировать студента",
	   enroll_student_to:"Зачислить студентов в",
	   name:"Имя",
	   search_for_a_student_or_id:"Поиск учащегося или удостоверения личности…",	   
	   confirmation_of_enrollment:"ПОДТВЕРЖДЕНИЕ ЗАЧИСЛЕНИЯ",
	   please_review_and_confirm_enrollments_for:"Пожалуйста, просмотрите и подтвердите регистрацию для",
	   confirm:"Подтверждать",
	   enroll_students_to_section:"ЗАПИСАТЬ СТУДЕНТОВ В СЕКЦИЮ",
	   enrollment_period:"Период зачисления",
	   days:"дней",
	   no_data_avalible:"Данные недоступны.",
	   number_of_primary_teacher:"Количество учителей начальных классов",
	   secondary_teachers:"Учителя средней школы",
	   department_head:"Глава отделения",
	   section_enroll:"Раздел Регистрация",
		load_from_file:"Загрузить из файла",
	   see_sections:"См. Разделы",
	   change_enrollment_status:"Изменить статус регистрации",
	   mentor_s:"Наставник (ы)",
	   overdue_activities:"Просроченная деятельность",
	   total_session_time_and_last_log:"Общее время сеанса и последний журнал",
	   course_name_on_transcript:"Название курса по стенограмме",
	   edit_other_grades:"Редактировать другие оценки",
	   save_as:"Сохранить как",
	   account_receivable_dashboard:"Учетная дебиторская панель",
	   key_performance_indicators:"Ключевые показатели производительности",
	   a_r_dashboard:"A/R Dashboard",
	   payments_credits:"Платежи/кредиты",
	   contract_templates:"Контрактные шаблоны",
	   master_contracts:"Главные контракты",
	   a_r_configuration:"Конфигурация A/R",
	   a_r_processing:"Обработка A/R",
	   aging:"Старение",
	   receivable:"Дебиторская задолженность",
	   account_receivable_by_program:"Дебиторская задолженность по программе",
	   request_detail:"Запросить детали",
	    request_information:"Запрашивать информацию",
	    requested_by:"Запрошенный",
	    approved_by:"Одобрено",
	    approve:"Утвердить",
	    phone_name:"Имя телефона",
	    phone_carrier:"Телефон",
		area_code:"Код района",
	   address_lable:"Адрес Lable",
	   address_default:"Адрес по умолчанию",
	   new_photo:"Новая фотография",
	   current_of_wweeks:"Текущий № недели",
	   select_enrollment_period:"Выберите период регистрации",
	   enter_rejection_reason:"Введите причина отклонения ...",
	   comments_and_documents:"Комментарии и документы",
	   enrollment_history:"История зачисления",
	   request_extension_for:"Запрос расширения для",
	   extended_of_weeks:"Продолжительный # недель",
	   current_enrollment_status:"Текущий статус регистрации",
	   select_extension_option:"Выберите опцию расширения",
	   extend_current_enrollment_until:"Продлить зачисление тока до тех пор, пока",
	   transfer_to_new_section:"Перевод в новый раздел",
	   transcript_requests:"Запросы на стенограмму",
	   person_requesting_transcript:"Лицо, запрашивающее стенограмму",
	   telephone_number:"Номер телефона",
	   number_of_copies:"Количество копий",
	   special_instructions:"Специальные инструкции",
	   last_school_attendance:"Последняя школа посещаемость",
	   year_last_attended:"Год последний посещался",
	   current_address:"Текущий адрес",
	   relationship_to_student:"Отношение к студенту",
	   method_of_delivery:"Способ доставки",
	   instructions:"*Инструкции",
	   previous_requests:"Предыдущие запросы",
	   additional_info:"Дополнительная информация",
	   receive:"Получать",
	   process:"Процесс",
	   add_to_school_group:"Добавить в школьную группу",
	   submit_romote:"Отправить рекламу",
	   next_grade_level:"Следующий класс",
	   please_select_a_school_for_promotion_and_transfer:"Пожалуйста, выберите школу для продвижения по службе и перевода",
	   write_off:"Списывать",
	   amount_due:"Сумма долга",
	   open_amount:"Открытая сумма",
	   payment_application:"Заявка на оплату",
	   use_credit_openBalance:"Используйте кредит $ 111",
	   payment_amount_usd:"Сумма оплаты (доллар США)",
	   check_number:"Номер чека",
	   confirmation_number:"Подтверждение номер",
	   apply_payment:"Применить оплату",
	   amount_paid:"Сумма уплачена",
	   applied_payment:"Применяемый платеж",
	   payer_id:"Идентификатор плательщика",
	   view_detail:"Просмотреть детали",
	   master_contract:"Генеральный контракт",
	   copy:"Копия",
	   contract_user_detail:"Подробная информация о контракте",
	   follow_product_cost:"Следуйте стоимости продукта",
	   default_cost:"Стоимость по умолчанию",
	   offered_cost:"Предлагаемая стоимость",
	   contract_detail:"Подробная информация",
	   contract_template_name:"Название шаблона контракта",
	    master_contract_name:"Название главного контракта",
		 view_students:"Посмотреть студентов",
		 make_payment:"Производить оплату",
		 parent_page:"Родительская страница",
		 edit_parent:"Редактировать родитель",
		 edit_profile:"Редактировать профиль",
		 account_receivable_configuration:"Конфигурация дебиторской задолженности",
		 invoice_generation_date:"Дата генерации счетов", 
	   invoice_generation:"Генерация счета -фактуры", 
	   number_of_days_until_due_date:"Количество дней до даты срока",
	   account_receivable_processing:"Обработка дебиторской задолженности",
	   generate_invoices:"Генерировать счета", 
	   process_automatic_payments:"Обрабатывать автоматические платежи", 
	   send_late_notices:"Отправить поздние уведомления",
	   course:"Курс",
	   copy_courses:"Копировать курсы",
	   copy_to_school:"Копировать в школу",
	   originating_program_code:"Исходный код программы", 
	   destinating_program_code:"Назначение кода программы", 
	   status_error:"Статус/ошибка",
	   add_prerequisite:"Добавить необходимое условие", 
	   group_name:"Имя группы", 
	   enter_group_name:"Введите имя группы", 
	   select_a_department_to_display_courses:"Выберите отдел для отображения курсов", 
	   edit_tranferred_grades:"Редактировать другие оценки", 
	   showing_num_records:"Показывая 000 записей",
	   edit_all_other_grades:"Изменить все остальные оценки",
	   upload_student_documents:"Загрузите студенческие документы",
	   select_an_official_transcript_option:"Выберите официальный вариант стенограммы", 
	   for_schools_or_personal_copy:"Для школ или личной копии", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Для использования учащихся отправьте в другую школу или чтобы проверить зачисление.", 
	   request_official_transcript:"Запросить официальную стенограмму", 
	   PARCHMENT_for_colleges_or_universities:"Пергамент для колледжей или университетов", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Для подачи заявления в колледж/университет и проверку завершения вашего диплома.", 
	   request_transcript:"Запросить стенограмму", 
	   Learn_more_about_how_to_use_PARCHMENT:"Узнайте больше о том, как использовать пергамент",
	   print_PDF:"Печать PDF",
	   user_school:"Пользовательская школа",
	   filter:"Фильтр",
	   GENERAL:"ОБЩИЙ", 
	   STUDENT_INFO:"Информация о студенте", 
	   list:"Список", 
	   last_school_name:"Имя последней школы", 
	   TEACHER_INFO:"Информация учителя", 
	   contracted_load:"Контрактная нагрузка", 
	   ARENT_INFO:"Родительская информация",
	   add_credential:"Добавить учетные данные",
	   edit_credential:"Редактировать учетные данные",
	   add_comment_document:"Добавить комментарий и документ",
	   add_comment_document_for:"Добавить комментарий и документ для",
	   state_province:"Государство/ провинция", 
	   post_code:"Post Code", 
	   linking_students_to:"Связывая студентов", 
	   change_expiration_date:"Изменить дату истечения срока действия", 
	   expiry_date:"Дата истечения срока действия", 
	   please_select_department:"Пожалуйста, выберите отдел.", 
	   please_select_course:"Пожалуйста, выберите курс.", 
	   please_select_title:"Пожалуйста, введите заголовок.", 
	   please_select_primary_teacher:"Пожалуйста, выберите учителя начальной школы.", 
	   please_select_weeks:"Пожалуйста, выберите недели.", 
	   please_select_level:"Пожалуйста, выберите уровень.", 
	   please_select_credits:"Пожалуйста, выберите кредиты.", 
	   please_select_type:"Пожалуйста, выберите тип.", 
	   please_select_daily_period:"Пожалуйста, выберите ежедневный период.",
	   please_enter_link_section:"Пожалуйста, введите раздел ссылки.",
	   please_enter_first_name:"Пожалуйста, введите имя.", 
	   please_enter_last_name:"Пожалуйста, введите фамилию.", 
	   please_enter_contracted:"Пожалуйста, введите контракт.", 
	   please_enter_email:"Пожалуйста, введите электронное письмо.", 
	   please_enter_phone:"Пожалуйста, введите телефон.", 
	   please_enter_username:"Пожалуйста, введите имя пользователя.",
	   please_enter_password:"Пожалуйста введите пароль.", 
	   please_enter_status:"Пожалуйста, выберите статус.", 
	   save_successful:"Сохраните успешный!.",
	   please_add_student_address:"Пожалуйста, добавьте адрес студента.", 
	   please_enter_email_address:"Пожалуйста, введите адрес электронной почты.", 
	   please_select_relationship:"Пожалуйста, выберите отношения.", 
	   please_select_parent_status:"Пожалуйста, выберите статус родителей.", 
	   please_enter_label:"Пожалуйста, введите этикетку.", 
	   please_enter_address:"Пожалуйста, введите адрес.", 
	   please_enter_city:"Пожалуйста, войдите в город.", 
	   please_enter_state:"Пожалуйста, введите состояние.", 
	   please_enter_zip_code:"Пожалуйста, введите почтовый индекс.",
		please_select_date_of_birth:"Пожалуйста, выберите дату рождения.", 
	   please_select_track:"Пожалуйста, выберите трек.", 
	   please_enter_graduation_date:"Пожалуйста, введите дату выпуска.", 
	   please_enter_country:"Пожалуйста, войдите в страну.", 
	   please_enter_phone_number:"Пожалуйста, введите номер телефона.", 
	    please_enter_parent_first_name:"Пожалуйста, введите имя родителя.", 
	   please_enter_parent_last_name:"Пожалуйста, введите фамилию родителей.", 
	   please_enter_parent_email_address:"Пожалуйста, введите родительский адрес электронной почты.", 
	   please_enter_parent_username:"Пожалуйста, введите имя пользователя родителей.", 
	   please_select_parent_relationship:"Пожалуйста, выберите родительские отношения.", 
	   please_enter_phone_label:"Пожалуйста, введите лейбл телефона.", 
	   student_address_canot_be_empty:"Адрес студента не может быть пустым.", 
	   please_select_document_type:"Пожалуйста, выберите тип документа.", 
	   please_enter_new_type:"Пожалуйста, введите новый тип.", 
	   please_enter_comment:"Пожалуйста, введите комментарий.", 
	   link_is_not_a_valid_url:"Ссылка не является действительным URL.",
	   please_enter_link_and_label:"Пожалуйста, введите ссылку и этикетку.",
	   are_you_sure_to_delete_this_student:"Вы обязательно удалите этого студента.",
	   please_select_gender:"Пожалуйста, выберите пол.",
	   school_contracted_load:"Школьная контрактная нагрузка", 
	   global_contracted_load:"Глобальная контрактная нагрузка",
	   please_enter_label_for_attachments:"Пожалуйста, введите этикетку для вложений.",
	   please_select_section:"Пожалуйста, выберите раздел.", 
	   enrollment_completed_successfully:"Зачисление завершено успешно.",
	   delete_this_comment:"Удалить этот комментарий?",
	   please_enter_course_name:"Пожалуйста, введите имя курса.", 
	   please_select_credits_possible:"Пожалуйста, выберите возможные кредиты.",
	   can_save_record:"Не могу сохранить запись:",
	   are_you_sure_to_delete_this_tranferred_grade:"Вы обязательно удалите эту траспирную оценку?",
	   are_you_sure_to_delete_num_tranferred_grade:"Вы обязательно удалите 11 трансферентных классов?", 
	   please_select_tranferred_grade:"Пожалуйста, выберите Tranferred Grade.",
	   please_ente_subject:"Пожалуйста, введите тему.", 
	   please_select_made_to:"Пожалуйста, выберите «Сделано».", 
	   delete_this_communication:"Удалить это общение?",
	   please_select_school:"Пожалуйста, выберите школу.",
	   please_enter_name:"Пожалуйста, введите имя.",
	   please_enter_group_name:"Пожалуйста, введите имя группы.",
	   you_have_some_form_errors_please_check_above:"У вас есть какие -то ошибки формы. Пожалуйста, проверьте выше.",
	   please_select_recipient:"Пожалуйста, выберите получателя.", 
	   please_enter_description:"Пожалуйста, введите описание.",
	   delete_this_resource:"Удалить этот ресурс?",
	   please_enter_activity_name:"Пожалуйста, введите имя деятельности.", 
	   please_select_activity_type:"Пожалуйста, выберите тип деятельности.", 
	   please_enter_max_score:"Пожалуйста, введите Max Score.", 
	   please_enter_due_date:"Пожалуйста, введите дату.",
	   please_enter_unit_name:"Пожалуйста, введите имя устройства.",
	   are_you_sure_to_clear_this_unit:"Вы обязательно очистите этот блок?",
	   please_enter_score:"Пожалуйста, введите счет.",
	   delete_this_credential:"Удалить этот учетный данных?",
	   plase_select_period:"Пожалуйста, выберите период", 
	   plase_select_start_date:"Пожалуйста, выберите дату начала", 
	   plase_select_end_date:"Пожалуйста, выберите дату окончания",
	   select_to_register_course_to_students_individual_learning_path_view:"Выберите для регистрации курса для студентов Индивидуальный просмотр пути обучения",
	   delete_this_request:"Удалить этот запрос?",
	   please_enter_fname:"Пожалуйста, введите имя.", 
	   please_enter_lname:"Пожалуйста, введите фамилию.", 
	   please_enter_birthday:"Пожалуйста, введите день рождения.", 
	   please_enter_address:"Пожалуйста, введите адрес.", 
	   please_enter_zip:"Пожалуйста, введите Zip.", 
	   please_enter_country:"Пожалуйста, войдите в страну.", 
	   please_enter_ethnicity:"Пожалуйста, войдите в этническую принадлежность.", 
	   please_enter_grade:"Пожалуйста, введите оценку.", 
	   please_enter_mobile:"Пожалуйста, введите мобильный.", 
	   please_enter_hear_about_us:"Пожалуйста, введите услышать о нас.", 
	   please_enter_program_of_interest:"Пожалуйста, введите программу интересов.", 
	   please_enter_course_level:"Пожалуйста, введите уровень курса.", 
	   please_enter_guardian_1_name:"Пожалуйста, введите имя Guardian 1.", 
	   please_enter_guardian_1_email:"Пожалуйста, введите guardian 1 электронное письмо.", 
	   please_enter_guardian_1_home_phone:"Пожалуйста, введите Guardian 1 домашний телефон.", 
	   please_enter_guardian_1_relation:"Пожалуйста, введите отношение Guardian 1.",
	   please_select_parents:"Пожалуйста, выберите родителей.",
	   transfer_classroom:"Перенос класс", 
	   please_choose_one_section_to_transfer:"Пожалуйста, выберите один раздел для перевода.", 
	   transfer:"Передача",
	   assigning_multiple_users_to_a_school_or_school_group:"Назначение нескольких пользователей в школу или школьную группу", 
	   add_to_school_or_school_group:"Добавить в школу или школьную группу", 
	   please_select_school_or_school_group:"Пожалуйста, выберите школу или школьную группу.",
	   print_student_progress_report:"Печать отчета о прогрессе студентов",
 },
 es: {
	   reporting_center:"Centro de informes", 
	   grade_reports:"Informes de calificación", 
	   user_reports:"Informes de usuario", 
	   learning_reports:"Informes de aprendizaje", 
	   administrative_reports:"Informes administrativos", 
	   progress_report:"Informe de progreso", 
	   full_progress_report:"Informe de progreso completo", 
	   grade_report:"Informe", 
	   roster_report:"Informe de la lista", 
	   parent_report:"Informe de los padres", 
	   teacher_report:"Informe de maestro", 
	   student_report:"Informe de estudiante", 
	   log_in_report:"Informe de inicio de sesión", 
	   enrollmentreport:"Informe de inscripción", 
	   enrollment_summary:"Resumen de inscripción", 
	   student_enrollment_summary:"Resumen de inscripción de estudiantes", 
	   attendance_report:"Reporte de asistencia", 
	   attendance_summary_report:"Informe de resumen de asistencia", 
	   log_In_Credentials:"Credenciales de acceso", 
	   application_report:"Informe de la solicitud", 
	   section_report:"Informe de la sección", 
	   course_report:"Informe del curso", 
	   communication_summary:"Resumen de comunicación", 
	   comments_and_Document_Report:"Comentarios e informe de documentos", 
	   School_Calendar:"Calendario escolar", 
	   bell_Schedule:"Horario de campana", 
	   student_Contract:"Contrato estudiantil",
	   eOS_Report:"Informe EOS", 
	   active_Enrollments_Per_Term_Report:"Informe de inscripciones activas por término", 
	   active_Student_Enrollments_with_As_Report:"Inscripciones de estudiantes activos con AS Informe", 
	   active_Student_Enrollments_Report:"Informe activo de inscripciones para estudiantes", 
	   all_Students_GPA_Report:"Todos los estudiantes informan GPA", 
	   old_All_Student_GPA_Report:"Antiguo Informe de GPA de todos los estudiantes", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + Informe de tipo de compromiso", 
	   enrollment_Confirmation_Report:"Informe de confirmación de inscripción", 
	   eOS_College_Matriculations_Report:"Informe de matriculaciones de EOS College", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Historial de inscripción de estudiantes hasta la fecha W Término Informe",
	   student_Information_Report:"Informe de información del estudiante", 
	   ran_by:"atravesado",
	   Show_Filter:"Filtro de espectáculos", 
	   School_Group:"Grupo escolar", 
	   school:"Escuela", 
	   department:"Departamento", 
	   student:"Alumno", 
	   student_status:"Estatus de estudiante", 
	   course:"Curso", 
	   course_level:"Nivel de curso", 
	   section:"Sección", 
	   teacher:"Maestro", 
	   primary_teacher:"Profesor de primaria", 
	   secondary_teacher:"Profesor secundario", 
	   completion_Date_Range:"Rango de fechas de finalización", 
	   from_date:"Partir de la fecha", 
	   to_date:"Hasta la fecha", 
	   status:"Estado", 
	   gender:"Género", 
	   final_grade:"Nota final", 
	   advisor:"Tutor", 
	   grade_level:"Nivel de grado", 
	   specific_mark:"Marca específica", 
	   track:"Pista", 
	   ethnicity:"Etnia", 
	   additional_fields:"Campos Adicionales", 
	   school_sessions:"Sesiones escolares", 
	   gradebook:"Libro de calificaciones", 
	   submit:"Entregar", 
	   reset:"Reiniciar", 
	   show_hide_columns:"Mostrar/ocultar columnas", 
	   select_all:"Seleccionar todo", 
	   student_id:"Identificación del Estudiante", 
	   last_name:"Apellido", 
	   first_name:"Nombre de pila", 
	   grade_level:"Nivel de grado", 
	   start_date:"Fecha de inicio", 
	   end_date:"Fecha final", 
	   grade_final:"Final de la calificación", 
	   percent:"Por ciento", 
	   credit:"Crédito", 
	   download_excel:"Descargar Excel", 
	   print:"Imprimir", 
	   no_data:"Sin datos.", 
	   view:"Vista", 
	   showing:"Demostración", 
	   of:"de", 
	   other_grade:"Otro grado", 
	   level:"Nivel", 
	   date:"Fecha", 
	   grade:"Calificación",
	   enrollment_Change_Status:"Estado de cambio de inscripción", 
	   close:"Cerca", 
	   select_Enrollment_Status:"Seleccione el estado de inscripción", 
	   select:"Seleccionar...", 
	   cancel:"Cancelar", 
	   save:"Ahorrar", 
	   students:"Estudiantes", 
	   Course_Status:"Estado del curso", 
	   Closed_courses:"Cursos cerrados", 
	   Section_Status:"Estado de la sección", 
	   Closed_sections:"Secciones cerradas", 
	   Transferred_From:"Transferido desde",
	   Graduation_From_Date:"Graduación de la fecha", 
	   Graduation_To_Date:"Graduación hasta la fecha", 
	   Enrollment_From_Date:"Inscripción desde la fecha", 
	   Enrollment_To_Date:"Inscripción hasta la fecha", 
	   Enrollment_Status:"Estado de inscripción", 
	   Transfer_From_Date:"Transferir desde la fecha", 
	   Transfer_To_Date:"Transferencia hasta la fecha", 
	   Custom_Query:"Consulta personalizada", 
	   Last_Access_Date:"Última fecha de acceso", 
	   Total_Session_Time:"Tiempo de sesión total", 
	   Quality_of_Work:"Calidad de trabajo", 
	   Grade_to_Date:"Calificar hasta la fecha", 
	   Overall_Percent:"Porcentaje general", 
	   On_Schedule_Percent:"Porcentaje de programación", 
	   Activity_Count_Complete:"Recuento de actividades completas", 
	   Activity_Count_Total:"Total de recuento de actividades", 
	   Overdue_Activitie:"Activitie superada",
	   Section_Course_Additional_Fields:"Sección/curso campos adicionales", 
	   Create_On_Date:"Crear fecha", 
	   Last_Status_Update_Date:"Última fecha de actualización de estado", 
	   Transferred_In:"Transferido", 
	   Transferred_In_Date:"Transferido en la fecha", 
	   email:"Correo electrónico", 
	   birth_date:"Fecha de nacimiento", 
	   course_name:"Nombre del curso", 
	   section_name:"Nombre de la sección", 
	   school_name:"Nombre de escuela", 
	   Graduation_Date:"Fecha de Graduación", 
	   Created_on:"Creado en", 
	   mentor_Advisor:"Mentor/asesor",
	   sections:"Secciones", 
	   roster:"Lista", 
	   relationship:"Relación", 
	   Email_or_Phone:"Email o teléfono", 
	   Enter_any_text:"Ingrese cualquier texto", 
	   Advisor_Success_Manager:"Asesor / gerente de éxito", 
	   User_Id:"ID de usuario", 
	   phone_number:"Número de teléfono", 
	   Student_Last_Name:"Apellido del estudiante", 
	   Student_First_Name:"Nombre del estudiante", 
	   Student_Email:"Correo electrónico de estudiante",
	   credentials:"Cartas credenciales", 
	   availability:"Disponibilidad",
	   enrollments:"Inscripciones", 
	   Datea_Created_on:"Fecha creada en",
	   country:"País", 
	   state:"Estado", 
	   zipcode:"Código postal", 
	   Enter_any_zipcode:"Ingrese cualquier código postal", 
	   address:"DIRECCIÓN",
	   zip_Code:"Código postal",
	   Login_Report:"Informe de inicio de sesión", 
	   user_Type:"Tipo de usuario", 
	   user_Name:"Nombre de usuario", 
	   Show_last_log_in_only:"Mostrar el último inicio de sesión solo", 
	   Username:"Nombre de usuario", 
	   Date_Time:"Fecha y hora", 
	   Ip_Address:"Dirección IP", 
	   city:"Ciudad",
	   Enrollment_Start_Date:"Fecha de inicio de inscripción", 
	   Enrollment_End_Date:"Fecha de finalización de inscripción", 
	   Completion_Date:"Fecha de Terminación", 
	   section_Type:"Tipo de sección", 
	   student_Enrolled:"Estudiante inscrito", 
	   content_Provider:"Proveedor de contenido", 
	   student_Additional_Fields:"Estudiante campos adicionales",
	   type:"Tipo", 
	   in_Class_Information:"Información de clase",
	   Enrollment_Summary_Report:"Informe de resumen de inscripción", 
	   Transferred_From_School:"Transferido de la escuela",
	   Total_Enrollments:"Inscripciones totales", 
	   content_Type:"Tipo de contenido", 
	   active_Course_Progress:"Progreso del curso activo",
		Grades:"Los grados", 
	   attendance:"Asistencia",
	   student_Absences:"Ausencia de estudiante", 
	   total_Absence:"Ausencia total", 
	   section_Absences:"Ausencia de sección",
	   Grade_Level_Absences:"Ausencias de nivel de grado",
	   Gender_Absences:"Ausencia de género",
	   Login_credentials:"Credenciales de acceso", 
	   names:"Nombres", 
	   user_status_admin_teacher_parent:"Estado del usuario (administrador, maestro, padre)", 
	   show_title:"Mostrar título", 
	   midle_name:"Segundo nombre", 
	   password:"Contraseña", 
	   parent_name:"Nombre del padre", 
	   linked_to_parent:"Vinculado al padre", 
	   linked_to_student:"Vinculado al estudiante",
	   login_credentials_Report:"Informe de credenciales de inicio de sesión", 
	   app_id:"ID de aplicación", 
	   created:"Creado", 
	   modified:"Modificado",
	   select_level:"Selecciona el nivel", 
	   select_additional_fields:"Sección de campos adicionales", 
	   title:"Título", 
	   credits:"Créditos", 
	   section_ID:"Sección ID", 
	   content:"Contenido", 
	   course_additional_fields:"Cambio de campos adicionales",
	   course_id:"ID de curso", 
	   communication_summary_report:"Informe de resumen de comunicación", 
	   method:"Método", 
	   create_date:"Fecha de Creación", 
	   subject:"Sujeto", 
	   make_from_id:"Hacer de identificación", 
	   make_to:"Hacer a", 
	   attachments:"Archivos adjuntos", 
	   comment_and_document_summary_report:"Informe de resumen de comentarios y documentos", 
	   comment_type:"Tipo de comentario", 
	   flagged:"Marcado", 
	   sharing_target:"Target de intercambio", 
	   show_on_transcript:"Mostrar en la transcripción", 
	   by:"Por", 
	   comment:"Comentario", 
	   type_name:"Escribe un nombre", 
	   effective_from_date:"Efectivo desde la fecha", 
	   effective_to_date:"Efectivo hasta la fecha", 
	   count_docs:"Conteo Docs",
	   school_calendar_report:"Informe del calendario escolar", 
	   event_Id:"ID de evento", 
	   date_start:"Inicio de fecha", 
	   date_end:"Fecha de finalización", 
	   posted_last_name:"Apellido publicado", 
	   posted_first_name:"Nombre publicado",
	   bell_schedule_report:"Informe de horario de campana", 
	   period:"Período", 
	   start:"Comenzar", 
	   end:"Fin",
	   student_contract_report:"Informe de contrato de estudiante", 
	   begin_date:"Fecha de inicio", 
	   contracts:"Contratos", 
	   contract_name:"Nombre de contrato", 
	   contract_begin_date:"Fecha de inicio del contrato", 
	   contract_end_date:"Fecha de finalización del contrato",
	   active_enrollments_per_term_report:"Informe de inscripciones activas por término", 
	   entry_date:"Fecha de entrada", 
	   teachers:"Maestros", 
	   term:"Término", 
	   sections:"Secciones",
	   showing_of:"Mostrando 10 de 20",
	   filter:"Filtrar",
	   students:"Estudiantes",
	   school:"escuela",
	   all_school:"Todas las Escuelas",
	   student:"Alumno",
	   email:"Correo electrónico",
	   grade_level:"Nivel de grado",
	   status:"Estado",
	   seach_for_a_student_or_id:"Buscar un estudiante o DNI...",
	   search:"Búsqueda …",
	   message_student:"Mensaje estudiante",
	   request_enrollment:"Solicitud de Matrícula",
	   print_schedule:"Imprimir horario",
	   view:"Vista",
	   no_data:"Sem dados.",
	   views:"Puntos de vista", 
	   enrollment:"Inscripción", 
	   schedule:"Calendario", 
	   transferred_grades:"Calificaciones transferidas", 
	   comments_ocuments:"Comentarios y Documentos", 
	   academic_records:"Expedientes Académicos", 
	   compliance_log:"Registro de cumplimiento", 
	   unofficial_transcript:"Transcripción no oficial", 
	   iD_card:"Tarjeta de identificación", 
	   student_number_id_information:"Número de estudiante #29561 Información", 
	   student_number:"Número de estudiante", 
	   gender:"Género", 
	   goes_by:"Va por", 
	   date_of_birth:"Fecha de nacimiento", 
	   ethnicity:"Etnicidad", 
	   mobile:"Móvil", 
	   academic_track:"Pista Académica", 
	   learning_path_template:"Plantilla de ruta de aprendizaje", 
	   graduation_date:"Fecha de Graduación", 
	   comments:"Comentarios", 
	   transfer_information:"Información de la transferencia", 
	   enrollment_date:"Fecha de inscripción", 
	   transfer_date:"Fecha de transferencia", 
	   transfer_student:"Estudiante de intercambio", 
	   parent_mentor_contact:"Contacto de padres/mentores", 
	   mentor:"Mentor", 
	   parent_phone:"Teléfono de los padres", 
	   emergency_contact:"Contacto de emergencia", 
	   academic_advisor_ssm:"Consejero Académico / SSM", 
	   student_success_manager:"Gerente de Éxito Estudiantil", 
	   academic_avisor:"Tutor académico", 
	   address:"Dirección", 
	   address_01_Default:"Dirección 01 (predeterminada)", 
	   street:"Calle", 
	   city:"Ciudad", 
	   state:"Estado", 
	   zip:"Cremallera", 
	   hide_Detailed_information:"Ocultar información detallada", 	    
	   current_course_progress:"Progreso actual del curso", 	    
	   full_Path_Progress:"Progreso completo de la ruta", 	    
	   print:"Impresión", 	    
	   avg_graduation_progress:"Promedio Progreso de graduación", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Estado de graduación", 	    
	   on_track:"A tiempo",
		show_detailed_information:"Mostrar información detallada",
		communication:"Comunicación",
		student_advisors:"Asesores estudiantiles", 	    
	   country:"País", 	    
	   grade:"Calificación", 	    
	   credits:"Créditos", 	    
	   sort:"Clasificar", 	    
	   course_progress:"Progreso del curso",
	   overall_GPA:"GPA general",
	    current_graduation_progress:"Progreso de graduación actual",
		individual_course_progress:"*El progreso del curso individual varía, este es su progreso general",
		subject:"Tema",
		online_sections:"Secciones en línea",
	   course:"Curso", 
	   section:"Sección", 
	   actions:"Comportamiento", 
	   view_event:"Ver evento",
	   in_class_section:"En la sección de clase",
	   calendar:"Calendario",
	   access_link:"Enlace de acceso", 
	   online_link:"Enlace en línea",
		launch_course:"Curso de lanzamiento", 
	   start_class:"Comenzar la clase",
	   level:"Nivel", 
	   date:"Fecha", 
	   transferred_in:"Transferido en",
	   tranferred_grades:"Calificaciones transferidas",
	   Searchs:"Búsqueda", 
	   Search_department_course:"Curso de departamento de búsqueda, src…",
	   archived:"Archivado", 
	   add_comment:"Agregar comentario", 
	   created_date:"Fecha de creación", 
	   by:"Por", 
	   type:"Escribe", 
	   comment:"Comentario", 
	   from_date:"Partir de la fecha", 
	   to_date:"Hasta la fecha", 
	   documents:"Documentos", 
	   edit:"Editar", 
	   delete:"Borrar",
	   communications:"Comunicaciones", 
	   add_communications:"Agregar comunicación", 
	   made_from:"Hecho de", 
	   made_to:"Hecho para", 
	   means:"Medio", 
	   attachments:"Archivos adjuntos", 
	   content:"Contenido",
	   compliance_logs:"Registros de cumplimiento", 
	   messageID:"ID de mensaje", 
	   agree:"Aceptar", 
	   dateTime:"Fecha y hora", 
	   iPAddress:"Dirección IP", 
	   add_idit_comment_document:"Agregar/Editar comentario y documento", 
	   document_type:"Tipo de Documento", 
	   show_on_transcript:"Mostrar en transcripción", 
	   select_users_to:"Seleccionar usuarios para", 
	   teacher:"Maestro", 
	   parent:"Padre", 
	   flag:"Bandera", 
	   none:"Ninguna", 
	   link:"Enlace", 
	   label:"Etiqueta", 
	   add_more_link:"Agregar más enlace", 
	   save:"Ahorrar", 
	   add_edit_communication:"Agregar/Editar comunicación", 
	   made_by:"Hecho por", 
	   date_time:"Fecha y hora", 
	   length:"Longitud", 
	   select:"Seleccione", 
	   select_users_to_view:"Seleccione usuarios para ver la comunicación", 
	   add_more:"Añadir más", 
	   communication_summary:"Resumen de comunicación",
	   close:"cerca",
	   new_type:"Nuevo tipo",
	   select_user_to_view_comment:"Seleccionar usuarios para ver el comentario",
	   flag_comment:"Marcar comentario",
	   teacher_page:"Página del maestro",
	   edit_information:"Editar informacion",
	   phone:"Teléfono",
	   add_credential:"Agregar credencial",
	   add_edit_credential:"Agregar/Editar credencial",
	   first_name:"Primer nombre",
	   midle_name:"Segundo nombre",
	   last_name:"Apellido",
	   cancel:"Cancelar",
	   add_new:"Agregar nuevo",
	   phone_type:"Tipo de telefono",
	   zipCode:"Código postal",
	   phone_number:"Número de teléfono",
	   default:"Defecto",
	   please_select_country:"Por favor seleccione país",
	   student_information:"Información del estudiante",
	   username:"Nombre de usuario",
	   user_directory:"Directorio de usuarios",
	   add_teacher:"Agregar maestro",
	   add_admin:"Agregar administrador",
	   export_to_excel:"Exportar a Excel",
	   export_to_pdf:"Exportar a PDF",
	   send_login_credentials:"Enviar credenciales de inicio de sesión",
	   search_for_a_user_or_id:"Buscar un usuario o ID…",
	   user:"Usuario",
	   school_admin:"administrador de la escuela",
	   change_password:"Cambia la contraseña",
	   set_password_expiration_date:"Establecer la fecha de caducidad de la contraseña",
	   impersonate_user:"Hacerse pasar por usuario",
	   edit_user_tags:"Editar etiquetas de usuario",
	   add_or_edit_users_schoo_assign:"Agregue o edite la asignación de la escuela de los usuarios",
	   assign_content_access:"Asignar acceso al contenido",
	   add_student:"Agregar estudiante",
	   add_parent_mentor:"Agregar madre / mentora",
	   showing:"Demostración",
	   of:"de",
	   school_name:"Nombre de escuela",
	   edit_user_school_tags:"Editar etiquetas de escuela de usuario",
	   personal_information:"Informacion personal",
	   contacted_load:"Carga contactada",
	   maximum_of_active_students:"# Máximo de Estudiantes Activos",
	   teacher_since:"Profesor Desde",
	   login_infomation:"Información Entrar",
	   username:"Nombre de usuario",
	   password :"Contraseña",
	   avatar :"Avatar",
	   teachers :"maestros",
	   change_status :"Cambiar Estado",
	   add_admin:"Agregar administrador",
	   name:"Nombre",
	   create_on:"Crear en",
	   registrar:"Registrador",
	   birthday:"Cumpleaños",
	   signature:"Firma",
	   photo:"Foto",
	   designated_registrar:"registrador designado",
	   track:"Pista",
	   select_existing_track:"Seleccionar pista existente",
	   available:"Disponible",
	   parent_mentor:"Madre / Mentora",
	   relationship:"Relación",
	   email_address:"Dirección de correo electrónico",
	   academic_mentor:"Mentor Académico",
	   no_data_available_in_table:"No hay datos disponibles en la tabla",
	   primary_language:"Lenguaje primario",
	   add_into_parent_or_mentor:"Agregar a Padre / Mentor",
	   add_into_phone:"Agregar al teléfono",
	   add_into_address:"Agregar a la dirección",
	   select_one:"Seleccione uno",
	   login:"Acceso",
	   plese_select_country:"Por favor elige país",
	   edit_student:"Editar estudiante",
	   academic_advisor_or_student_success_manager:"Asesor Académico / Gerente de Éxito Estudiantil",
	   role:"Role",
	   link_parent:"Vincular padre",
	   link_advisor_sms:"Asesor de enlaces/SSM",
	   save_into_parent_mentor:"Guardar en padre/mentor",
	   save_into_parent_phone:"Guardar en el teléfono",
	   save_into_parent_address:"Guardar en Dirección",
	   bulk_information_update:"Actualización de información masiva",
	   enrollments:"Inscripciones",
	   email_student:"Estudiante de correo electrónico",
	   unofficial_transcripts:"Transcripciones no oficiales",
	   official_transcripts:"Transcripciones oficiales",
	   email_students_schedule:"Horario del estudiante por correo electrónico",
	   export_students_to_excel:"Exportar Estudiantes a Excel",
	   export_parent_list_to_excel:"Exportar lista de padres a Excel",
	   assign_learning_path_template:"Asignar plantilla de ruta de aprendizaje",
	   promote_student_to_the_next_grade_level:"Promover al estudiante al siguiente nivel de grado",
	   batch_upload_students:"Estudiantes de carga por lotes",
	   batch_upload_transfer_grades:"Calificaciones de transferencia de carga por lotes",
	   transfer_apex_only:"Transferencia (Solo APEX)",
	   transfer_content_providers:"Transferencia (Todos los proveedores de contenido)",
	   batch_enrollments:"Inscripciones por lotes",
	   send_message:"Enviar mensaje",
	   impersonate:"Suplantar",
	   change_login_credentials:"Cambiar credenciales de inicio de sesión",
	   request_enrollment:"Solicitud de Inscripción",
	   send_weekly_status_report:"Enviar informe de estado semanal",
	   please_select_student:"Seleccione los estudiantes.",
	   student_status_will_be_changed_to_status_withdraw:"El estado del estudiante se cambiará a 111, y todas las inscripciones serán retiradas. Estás seguro de que quieres continuar?",
	   student_status_will_be_changed_to_status:"El estado del estudiante se cambiará a 111. ¿Estás seguro de que quieres continuar?",
	   value:"Valor",
	   student_success_manager_or_acdemic:"Gerente de éxito estudiantil / asesor académico",
	   enroll_students_to_section:"Inscribir a los estudiantes a la sección",
	   department:"Departamento",
	   refresh:"Actualizar",
	   select_department:"Seleccione el departamento",
	   select_course:"Curso de selección",
	   select_section:"SELECCIÓN SECCIÓN",
	   start_date:"Fecha de inicio",
	   end_date:"Fecha final",
	   ID:"IDENTIFICACIÓN",
	   action:"Acción",
	   enrollment_period:"Período de inscripción",
	   select_a_course_to_register_ilp:"Seleccione un curso para registrar ILP",
	   period:"Período",
	   credit:"Crédito",
	   year:"Año",
	   enroll:"Inscribirse",
	   recipient_transcript:"Transcripción del receptor",
	   select_all_or_unselect_all:"Seleccione todo / deseleccionar todos",
	   include_in_progress_sections:"Incluir secciones en progreso",
	   show_satisfaction_of_program:"Mostrar satisfacción del programa",
	   show_total_credit:"Mostrar créditos totales",
	   show_student_info:"Mostrar información de los estudiantes",
	   show_academic_info:"Mostrar información académica",
	   show_school_names_from_orther_grades:"Mostrar nombres de la escuela de otras calificaciones",
	   show_school_contact:"Mostrar contacto escolar",
	   include_transferred_grades_in_gpa:"Incluir calificaciones transferidas en GPA",
	   include_in_progress_grade:"Incluir en el grado de progreso",
	   include_grade_scales:"Incluir escamas de grado",
	   show_graduation_date:"Mostrar fecha de graduación",
	   show_weighted_gpa:"Mostrar GPA ponderado",
	   show_grade_level_gpa:"Mostrar GPA de nivel de grado",
	   show_comletion_date:"Mostrar fecha de finalización",
	   show_withdraw_classes:"Mostrar clases retiradas",
	   show_withdraw_date:"Mostrar fecha retirada",
	   show_transfered_in_classes:"Mostrar transferido en clases",
	   show_digital_seal:"Mostrar sello digital",
	   show_singnature:"Mostrar firma",
	   group_by:"Agrupar por",
	   school_year:"Año escolar",
	   school_level:"Nivel escolar",
	   notes:"Notas",
	   ok:"De acuerdo",
	   are_you_sure_to_send:"¿Estás seguro de enviar?",
	   assign_learning_path_templete:"Asignar plantilla de ruta de aprendizaje",
	   assign_student_to_selected_learning:"Asignar alumno a la plantilla de ruta de aprendizaje seleccionada",
	   assign:"Asignar",
	   are_you_sure_to_promote_to_level:"¿Estás seguro de promover al siguiente nivel de grado?",
	   data_process:"Proceso de datos",
	   upload_and_import_data:"Cargar e importar datos",
	   download_user_information:"Descargar información del usuario",
	   here:"aquí",
	   select_student_upload_file:"Seleccione el archivo de carga del estudiante",
	   local_drive:"Conducción local",
	   the_file_is_uploaded:"El archivo está cargado",
	   template_name:"Nombre de la plantilla",
	   Here:"Aquí",
	   sample_file_excel:"muestra de archivo Excel.",
	   file_type:"Tipo de archivo",
	   delimited:"Delimitado",
	   delimited_chars:"Chars delimitados",
	   fixed_width:"Ancho fijo",
	   first_line_header:"Encabezado de primera línea",
	   loader_field:"Campo de carga",
	   Header:"Encabezamiento",
	   sample_data:"Data de muestra",
	   column_width:"Ancho de colunm",
	   save_tamplate:"Guardar plantilla",
	   save_and_upload_data:"Guardar y subir datos",
	   result:"Resultado",
	   upload_and_import_data_orther_grade:"Cargar e importar datos de otro grado",
	   select_upload_file:"Seleccionar el archivo de carga",
	   student_id:"Identificación del Estudiante",
	   uploadAnd_import_data_enrollment:"La inscripción de datos de carga e importación",
	   section_id:"ID de sección",
	   title:"Título",
	   recipient:"Recipiente",
	   same_current_address:"Igual que la dirección actual",
	   add_more_reciptient:"Agregar más destinatario",
	   issuse_date:"Fecha de asunto",
	   show_total_unapplied_credits:"Mostrar créditos totales no aplicados",
	   reconcile_another_student_record:"Conciliar con otro registro de estudiante",
	   please_choose_one_student_to_reconcile:"Elija un estudiante para reconciliarse.",
	   yes:"Sí",
	   no:"No",
	   apex_classroom_sync:"Sincronización del aula de Apex",
	   next:"Próximo",
	   apex_classrooms:"Aulas de Apex",
	   online_user_id:"ID de usuario en línea",
	   enter_online_user_id:"Ingrese la identificación de usuario en línea",
	   online_section_id:"ID de sección en línea",
	   online_section_name:"Nombre de la sección en línea",
	   online_course_name:"Nombre del curso en línea",
	   enrollment_date:"Fecha de inscripción",
	   back:"Atrás",
	   import:"Importar",
	   offical_transcipt:"Transcripción oficial",
	   email_schedule:"Horario de correo electrónico",
	   reconcile_with_another_records:"Reconciliar con otro registro",
	   online_sync_and_update:"Sincronización y actualización del progreso en línea",
	   download_all_completion_cretification:"Descargar toda la certificación de finalización",
	   orther_grade:"Otras calificaciones",
	   medical:"Médico",
	   comments_and_documents:"Comentarios y documentos",
	   contracts:"Contratos",
	   invoices:"Facturas",
	   audit_logs:"Registros de auditoría",
	   edit_logs:"Editar registros",
	   grade_to_date:"Calificar hasta la fecha",
	   quality_of_work:"Calidad de trabajo",
	   last_access:"Ultimo acceso",
	   gradebook:"Libro de calificaciones",
	   transfer:"Transferir",
	   completion_certification:"Certificación de finalización",
	   tranfer_user_school:"Transferir la escuela de usuario",
	   tranfer_to_school:"Transferencia a la escuela",
	   tranfer_apex_classrooms:"Transferir aulas de Apex",
	   course_to_moved:"Curso para moverse",
	   current_teacher:"Maestro actual",
	   future_section:"Sección futura",
	   future_program:"Programa futuro",
	   future_teacher:"Maestro futuro",
	   enrollment_start_date_end_date:"Fecha de inicio de inscripción - Fecha de finalización",
	   no_more_option:"No mas opciones",
	   create_new:"crear nuevo",
	   transfer_classrooms:"Transferir aulas",
	   tyler_synchronization_for_az_school:"Sincronización de Tyler para las escuelas AZ",
	   synchronize:"Sincronizar",
	   individual_course_progress_varies:"El progreso individual del curso varía. Este es su progreso general hacia la graduación.",
	   edit_ilp:"Editar ILP",
	   add_academic_record:"Agregar registro académico",
	   edit_all_records:"Editar todos los registros",
	   search_corse_department_src:"Curso de búsqueda, Departamento, SRC ...",
	   message_id:"ID de mensaje",
	   add_new_contract:"Agregar nuevo contrato",
	   contract_id:"ID de contrato",
	   contract_name:"Nombre de contrato",
	   first_date:"Primera fecha",
	   last_date:"Ultima cita",
	   amount_per_period:"Cantidad por período",
	   terminating_status:"Estado de terminación",
	    payment_history:"historial de pagos",
	   record_payment:"Pago récord",
	   payment_method:"Método de pago",
	   invoice_id:"ID de factura",
	   show_all:"Mostrar todo",
	   invoice_date:"Fecha de la factura",
	   from:"Desde…",
	   to:"A…",
	   amount:"Cantidad",
	   paid:"Pagado",
	   due:"Adeudado",
	   date_paid:"Fecha pagada",
	   apply_payments:"Aplicar pagos",
	   mark_as_paid:"Mark como pagado",
	   void:"Vacío",
	   audit_log:"Registro de auditoría",
	   object:"Objeto",
	   changes_made:"Cambios realizados",
	   create_time:"Crear tiempo",
	   time_stamp:"Estampilla de tiempo",
	   user_creare:"Usuario Crear",
	   edit_log:"Registro de edición",
	   field_name:"Nombre del campo",
	   old_value:"Valor antiguo",
	   new_value:"Nuevo valor",
	   date_time_update:"Actualización de fecha/hora",
	   updater:"Actualizador",
	   add_edit_academic_records:"Agregar/editar registro académico",
	   select_flag:"Seleccionar bandera ...",
	   edit_all_tranferred_grades:"Editar todos los grados transferidos",
	   save_records:"Guardar registros",
	   possible_credits:"Posibles créditos",
	   select_level:"Selecciona el nivel",
	   select_grade_level:"Seleccionar nivel de grado",
	   select_status:"Seleccionar estado",
	   add_more_row:"Agregar más fila",
	   full_screen:"Pantalla completa",
	   course_code:"Agregar otras calificaciones",
	   add_order_grades:"Código del curso",
	   select_credit:"Seleccionar crédito",
	   select_default:"Seleccionar predeterminado",
	   credits_possible:"Créditos posibles",
	   select_possible_credit:"Seleccione Posible Crédito",
	   product:"Producto",
	   fromn:"De",
	   ton:"A",
	   last_invoice_date:"Última fecha de factura",
	   please_select_stu:"Seleccione Estudiante",
	   payer:"Pagador",
	   amount_per_billing_period:"Cantidad por período de facturación",
	   price_unit:"Precio unitario",
	   billing_period:"Período de facturación",
	   automatic_renewal:"Renovación Automática",
	   automatic_payment:"Facturación automática",
	   duration_of_period:"Duración (# de períodos)",
	   payment_id:"ID de pago",
	   payment_date:"Fecha de pago",
	   payment_amount:"Monto del pago",
	   applied:"Aplicado",
	   available:"Disponible",
	   unApply:"Falta de aplicación",
	   refund:"Reembolso",
	   add_new_teacher:"Agregar nuevo maestro",
	   change_teacher_status:"Cambiar el estado del maestro",
	   search_for_a_teacher_or_id:"Busque un maestro o identificación ...",
	   flags:"Banderas",
	   tags:"Etiquetas",
	   allowed:"Permitido",
	   message_teacher:"Profesor de mensajes",
	   impersonate_teacher:"Maestro de suplantado",
	   add_teacher_qualification:"Agregar calificación del maestro",
	   profile:"Perfil",
	   teacher_schedule:"Horario de maestros",
	   qualifications:"Calificaciones",
	   student_actions:"Acciones de los estudiantes",
	   linking_parents_to:"Vincular a los padres con",
	   select_do:"Seleccionar ...",
	   see_edit_logs:"Ver registros de edición",
	   see_qualifications:"Ver calificaciones",
	   link_academic_advisor:"Enlace asesor académico",
	   student_success:"Éxito estudiantil",
	   linking_academic_advisor_or_student_success:"Vincular asesor académico / éxito estudiantil con",
	   staff:"Personal",
	   teacher_status:"Estatus de maestro",
	   school_admin_status:"Estado de administración escolar",
	   global_user_directory:"Directorio de usuario global",
	   edit_teacher:"Editar profesor",
	   contracted:"Contratado",
	   add_comments_and_documents:"Comentarios y documentos",
	   edit_comments_and_documents:"Editar comentarios y documentos",
	   parents_or_mentor:"Padres / mentor",
	   send_mail:"Enviar correo",
	   are_you_sure_to_delete_this_teacher:"¿Estás seguro de eliminar a este maestro?",
	   edit_user_password:"Editar nombre de usuario y contraseña",
	   add_qualifications:"Agregar calificaciones",
	   please_select_a_least_on_teacher:"Seleccione al menos un maestro.",
	   edit_parent_mentor:"Editar padre / mentor",
	   parent_mentor_information:"Información para padres / mentores",
	   send:"Enviar",
	   are_you_surse_to_delete_this_parent:"¿Estás seguro de eliminar a este padre?",
	   home:"Hogar",
	   
	   //auto_promotion:"Promoción automática",
	   auto_promotion:"Promoción de nivel de grado estudiantil",
	   Promote:"Promover",
	   search_for_a_name:"Buscar un nombre ...",
	   download_to_excel:"Descargar a Excel",
	   download_to_pdf:"Descargar a PDF",
	   User_ID:"ID de usuario",
	   User_type:"Tipo de usuario",
	   communication_log:"Registro de comunicación",
	   Student_Status:"Estatus de estudiante",
	   Users:"Usuarios",
	   Staff_Reassignment:"Reasignación del personal",
	   Select_Staff:"Seleccionar personal",
	   select_asset_type_to_reassign:"Seleccione el tipo de activo para reasignar",
	   transfer_all_to:"Transferir todo a",
	   transfer_selectively:"Transferir selectivamente",
	   remove_all:"Eliminar todo",
	   remove_selectively:"Eliminar selectivamente",
	   Event:"Evento",
	   Time:"Tiempo",
	   Participants:"Participantes",
	   new_staff:"Personal nuevo",
	   Remove:"Eliminar",
	   Profile_Page:"Página de perfil",
	   settings:"Ajustes",
	   security:"Seguridad",
	   timezone:"Zona horaria",
	   notifications:"Notificaciones",
	   check_for_feature_availability_at_your_school:"Verifique la disponibilidad de funciones en su escuela.",
	   current_password:"Contraseña actual",
	   new_password:"Nueva contraseña",
	   confirm_password:"confirmar Contraseña",
	   updte_password:"Actualiza contraseña",
	   change_timezone:"Cambiar la zona horaria",
	   time_zone:"Zona horaria",
	   please_select_time_zone:"Seleccione la zona horaria",
	   notification_settings:"Configuración de las notificaciones",
	   level_of_urgency:"Nivel de urgencia",
	   email_destination:"Destino de correo electrónico",
	   SMS_Destination:"Destino SMS",
	   app:"Aplicación",
	   please_select_level_of_urgency:"Seleccione el nivel de urgencia",	   
	   reset_filters:"Restablecer filtros",
	   batch_data_update:"Actualización de datos del estudiante",
	   contract_template:"Plantilla de contrato",
	   accept:"Aceptar",
	   reject:"Rechazar",
	   view_roles:"Ver roles",
	   administrator_information:"Información administradora", 
	   account_reation_date:"Fecha de creación de cuentas", 
	   expiration_date:"Fecha de caducidad", 
	   schools:"Escuelas", 
	   advisees:"Consejos",
	   message:"Mensaje",
	   see_comments_and_documents:"Ver comentarios y documentos",
	   restore_APEX_Classrooms:"Restaurar a las aulas de Apex",
	   teacher_information:"Información del maestro", 
	   teacher_number:"Número de maestro", 
	   departmens:"Departamento", 
	   global_capacity:"Capacidad global", 
	   local_contracted_load:"Carga contratada local", 
	   parents:"Padres", 
	   parent_information:"Información de los padres", 
	   linked_students:"Estudiantes vinculados", 
	   link_student:"Enlace de estudiante", 
	   unlink_student:"Estudiante de Unlink", 
	   search_dot:"Buscar…", 
	   view_local:"Ver local", 
	   view_global:"Ver global",
	   resource:"Recurso",
	   current_grade:"Grado actual", 
	   affiliation:"Afiliación", 
	   current_assignment:"Tarea actual", 
	   total_assignments:"Asignaciones totales", 
	   percent_completed:"Porcentaje completo",
	   semester:"semestre",
	   graduation_year:"Año de graduación", 
	   student_name:"Creditos ganados", 
	   credits_earned:"Creditos ganados",
	   exit:"salida",
	   engagement_type:"Tipo de compromiso",
	   college_admitted:"Universidad admitida", 
	   college_attending:"Universidad asistente", 
	   major:"Importante", 
	   report_card:"Boleta de calificaciones", 
	   academic_term:"Término académico", 
	   show_average:"Promedio de espectáculos",
	   school_information:"Informacion de la Escuela",
	   school_misc_configuration:"Configuración de misceláneos escolares", 
	   school_tags:"Etiquetas escolares", 
	   role_tags:"Etiquetas de roles", 
	   content_integration:"Integración de contenido", 
	   user_roles:"Roles del usuario", 
	   communication_user_rules:"Reglas del usuario de comunicación", 
	   school_administrators:"Administradores escolares", 
	   school_year_configuration:"Configuración del año escolar", 
	   A_R_payment_configuration:"Configuración de pago de A/R", 
	   facility:"Instalación", 
	   enrollment_rules:"Reglas de inscripción", 
	   student_contract_rules:"Reglas de contrato de estudiante", 
	   products:"Productos", 
	   notification_templates:"Plantillas de notificación", 
	   transcript_viewer_options:"Opciones para el visor de transcripción", 
	   feature_configuration:"Configuración de características", 
	   feature_settings:"Configuración de características", 
	   communication_rules:"Reglas de comunicación", 
	   object_state:"Estado de objeto", 
	   departments:"Departamentos", 
	   grading_scales:"Escalas de calificación", 
	   grading_periods:"Períodos de clasificación", 
	   academic_tracks:"Pistas académicas", 
	   learning_path_templates:"Plantillas de ruta de aprendizaje", 
	   grade_book_activity_descriptions:"Descripciones de actividades de libros de grado", 
	   academic_terms:"Términos académicos",
	   academic_system:"Sistema académico",
	   address_line_1:"Dirección Línea 1", 
	   country_code:"Código de país", 
	   address_line_2:"Línea de dirección 2", 
	   school_title:"Título escolar",
	   CEEB_code:"Código CEEB", 
	   zip_postal_code:"Código postal/postal", 
	   state_province:"Provincia del estado", 
	   website:"Sitio web", 
	   subdomain:"Subdominio", 
	   success_manager:"Gerente de éxito", 
	   school_logo:"Logo de la escuela", 
	   digital_seal:"Sello digital",
	   password_exception_rule:"Regla de excepción de contraseña",
	   change_password_first_login:"Cambiar la contraseña primero inicio de sesión", 
	   password_expires_after_days:"La contraseña expira después de los días", 
	   enforcement_of_teachers_load:"Cumplimiento de la carga del maestro", 
	   in_house_handling_of_transcript_requests:"Manejo interno de solicitudes de transcripción", 
	   display_mobile_app_link:"Mostrar enlace de aplicaciones móviles", 
	   display_weekly_progress_goal:"Mostrar objetivo de progreso semanal", 
	   turn_on_notification:"Activar la notificación", 
	   classic_letter:"Carta clásica", 
	   automatic_parent_account_creation:"Creación automática de cuentas para padres", 
	   default_parent_account_status:"Estado de cuenta principal predeterminada", 
	   default_time_zone:"Zona horaria predeterminada", 
	   link_to_transcript_vendor_help:"Enlace a la ayuda del proveedor de transcripción", 
	   link_to_transcript_vendor:"Enlace al proveedor de transcripción", 
	   link_for_help_system:"Enlace para el sistema de ayuda", 
	   student_enrollment_limit:"Límite de inscripción de estudiantes", 
	   default_section_type:"Tipo de sección predeterminado", 
	   default_section_capacity:"Capacidad de sección predeterminada",
	   transcript_template:"Plantilla de transcripción",
	   edit_security_school_tags:"Editar etiquetas de la escuela de seguridad", 
	   security_school_tags:"Etiquetas de escuela de seguridad",
	   tags_name:"Etiquetas Nombre", 
	   edit_role_tags:"Editar etiquetas de rol",
	   add_school_based_tags:"Agregar etiquetas basadas en la escuela", 
	   description:"Descripción", 
	   applied_to_roles:"Aplicado a roles", 
	   teacher:"Maestro",
	   edit_security_role_tags_for:"Editar etiquetas de rol de seguridad para",
	   school_admins:"Administradores escolares",
	   school_begin_date:"Fecha de inicio de la escuela", 
	   school_end_date:"Fecha de finalización de la escuela", 
	   automatic_control_of_teacher_s_load:"Control automático de la carga del maestro",
	   A_R_payment_gateway_configuration:"Configuración de la pasarela de pago A/R", 
	   payment_processing_vendor:"Proveedor de procesamiento de pagos", 
	   secret_key:"Llave secreta", 
	   publishable_key:"Clave publicable", 
	   account_id:"ID de la cuenta",
	   updating_tudents:"Actualización de estudiantes", 
	   delete_selected_records:"Eliminar registros seleccionados",
	   attribute_name:"Nombre del Atributo", 
	   applied_for:"Solicitado",
	   add_school:"Agregar escuela", 
	   overview:"Descripción general", 
	   search_for_school:"Buscar la escuela ...", 
	   search_for_student:"Buscar al estudiante ...",
	   attribute_type:"Tipo de atributo", 
	   select_school_group:"Seleccionar grupo escolar", 
	   access_rights:"Derechos de acceso", 
	   create:"Crear", 
	   read:"Leer",
	   facility_management:"Gestión de instalaciones", 
	   facility_name:"Nombre de la instalación", 
	   capacity:"Capacidad",
	   enrollment_allowance_period_days:"Período de asignación de inscripción (días)", 
	   maximum_enrollment_duration_days:"Duración máxima de inscripción (días)", 
	   start_date_of_the_week:"Fecha de inicio de la semana", 
	   end_date_of_the_week:"Fecha final de la semana",
	   lookup_name:"Nombre de búsqueda", 
	   duration:"Duración", 
	   time_unit:"Unidad de tiempo", 
	   round_up_to_end_of_time_unit:"Redondear hasta el final de la unidad de tiempo",
	   product_name:"nombre del producto",
	   product_ID:"ID del Producto", 
	   price_offer:"Precio de oferta", 
	   price:"Precio", 
	   frequency:"Frecuencia", 
	   effective_from:"Válido desde", 
	   effective_to:"Efectivo para", 
	   active:"Activo",
	   drag_drop_to_text_cursor_in_content:"Arrastrar y soltar al cursor de texto en contenido", 
	   event_type:"Tipo de evento", 
	   notification_rule:"Regla de notificación", 
	   level_or_ugency:"Nivel o ugencia", 
	   user_role:"Rol del usuario",
	   edit_security_user_tags:"Editar etiquetas de usuario de seguridad",
	   content_access:"Acceso al contenido", 
	   content_access_for:"Acceso de contenido para", 
	   add_new_access:"Agregar nuevo acceso", 
	   date_assigned:"Fecha asignada",
	   enrollment_request:"Fecha asignada", 
	   enrollment_request_for:"Solicitud de inscripción", 
	   mentors:"Mentores",
	   options:"Opción",
	   department_name:"Nombre de Departamento", 
	   universal_department:"Departamento universal", 
	   open:"Abierto",
	   min_point:"Punto mínimo", 
	   max_point:"Punto máximo", 
	   grade_point:"Calificación", 
	   honors:"Honores", 
	   college:"Colega",
	   order:"Orden", 
	   start_time:"Hora de inicio", 
	   end_time:"Hora de finalización",
	   period_name:"Nombre de período",
	   grading_periods_head:"Cabeza de períodos de calificación",
	   grading_period:"Período de clasificación", 
	   weight:"Peso",
	   track_name:"Nombre de la pista",
	   academic_track_requirement:"Requisito de vía académica", 
	   of_required_credits:"# de créditos requeridos",
	   individual_learning_plan_template:"Plantilla de plan de aprendizaje individual",
	   ILP_name:"Nombre de ILP",
	   remove_requirement:"Eliminar requisito", 
	   reset_requirement:"Requisito de reinicio", 
	   add_requirement:"Agregar requisito",
	   must_end_date:"Debe finalizar la fecha", 
	   courses_open_date:"Cursos Fecha de apertura", 
	   signup_end_date:"Fecha de finalización de registro", 
	   signup_start_date:"Fecha de inicio de registro", 
	   section_period:"Período de sección",
	   
	   weeks:"Semanas", 	   
	   search_for_a_section_or_id:"Busque una sección o identificación ...",
	   search_for_a_deft:"Buscar un departamento ...", 	   
	   launch_course:"Curso de lanzamiento", 
	   start_class:"Comenzar la clase", 	   
	   weekly_progress_goal:"Objetivo de progreso semanal", 
	   send_message_to_all_section_students:"Enviar mensaje a todos los estudiantes de la sección", 
	   monitor_live_sessions:"Monitorear sesiones en vivo", 
	   average_section_grade:"Grado de sección promedio", 
	   resources:"Recursos", 
	   activities:"actividades", 	   
	    course_attendance_today:"Asistencia del curso hoy", 
	   staffs:"Personal", 
	   units:"Unidades", 	   
	   view_all_15_resources:"Ver los 15 recursos", 
	   Class_discussions:"Discusiones de clase", 
	   recent_discussions:"Discusiones recientes", 
	   go_to_class_discussions:"Ir a discusiones de clase", 	   
	   show_my_class_attendance:"Muestra mi asistencia de clase", 
	   add_section:"Agregar sección",
	   add_global_section:"Agregar sección global",
	   close_section:"Cerrar secciones",
	   open_section:"Secciones abiertas",
	   batch_upload:"Carga por lotes",
	   finalize:"Finalizar",	   
	   add_tearcger:"Agregar maestro(s)",
	   remove_tearcger:"Quitar profesor(es)",
	   uploadSectionStatusUpdates:"Cargar actualizaciones de estado de la sección",
	   status_count:"Cuenta de estado",	   
	   reactivate:"Reactivar",
	   clone:"Clon",
	   enroll_into_Section:"Inscríbete en la Sección",
	   bulk_enrollment:"Inscripción masiva",
	   general_Information:"Información general",	   
	   online_content_source:"Fuente de contenido en línea",
	   second_teacher:"Segundo Maestro",
	   today:"Este Dia",
	   calendar:"Calendario",
	   week:"semana",
	   month:"Mes",
	   section_progress:"Progreso de la sección",
	   complete:"completa",	   
	   section_title:"Sección de título",
	   enter_section_title:"Introduzca el título de la sección",
	   select_teacher:"Seleccionar profesor",	   
	   select_weeks:"Seleccionar semanas",
	   select_credits:"Seleccionar créditos",
	   select_type:"Seleccione tipo",
	   global_section:"Sección Global",	   
	   enrollment_capacity:"Capacidad de inscripción",
	   enter_enrollment_capacity:"Ingrese la capacidad de inscripción",
	   in_class_information:"Información en clase",	   
	   Start:"Comienzo",
	   End:"Final",
	   recurrencePattern:"Patrón de recurrencia",
	   recurrenceFrequency:"Frecuencia de recurrencia",
	   Weekly:"Semanalmente",
	   Monthly:"Mensual",
	   Recur_every:"Repita todos los",
	   Weeks_on:"Semanas en",
	   day_of_week:"Día de la semana",
	   daily_period:"Período diario",
	   select_daily_period:"Seleccione el período diario",
	   Day:"Día",
	   The:"Los",
	   of_every:"de cada",
	   month_s:"meses)",
	   add:"Agregar",	   
	   course_prequisites:"Requisitos previos del curso",
	   select_status:"Seleccionar estado",
	   select_school:"Seleccionar escuelas",	   
	   select_period:"Seleccione Periodo",
	    room_number:"Número de habitación",
	   select_room_number:"Seleccione Número de habitación",
	   Service:"Servicio",
	   enter_url:"Introducir URL",
	   edit_section:"Editar sección",
	   activity_templates:"Plantillas de actividad",
	   select_activity_templates:"Seleccionar plantilla de actividad",
	   link_section:"Sección de enlace",
	   select_link_section:"Seleccionar sección de enlace",
	   please_select_sections:"Por favor seleccione secciones.",
	   if_you_change_your_status_of_inactivity:"Si cambia su estado de inactividad, el alumno se verá afectado.",
	   closing_the_global_section_will_cause:"El cierre de la sección global provocará el cierre en todas las escuelas y el retiro de todos los estudiantes en ellas. Haga clic en Confirmar si desea continuar.",
	  upload_import_data:"Cargar e importar datos",	  
	   here:"Aquí",
	   no_data_avalable_in_table:"No hay datos disponibles en la tabla",
	   add_teacher_to_multiple_section:"Agregar maestro(s) a varias secciones",
	   select_teachers_to_add_to_multiple_section:"Seleccione maestros para agregar a múltiples selecciones",
	   selected:"Seleccionado",
	   selected_all:"Seleccionar todo",
	   deselected_all:"Deseleccione Todo",
	   remove_teacher_from_multiple_section:"Quitar profesor(es) de múltiples secciones",
	   select_teacher_to_remove_to:"Seleccione maestros para eliminar a múltiples selecciones",
	   process_removal:"Eliminación de procesos",	   
	   clone_section:"Sección Clon",
	   enroll_student:"Inscribir estudiante",
		enroll_student_to:"Inscribir estudiantes para",
		name:"Nombre",
	   search_for_a_student_or_id:"Buscar un estudiante o ID…",
	   confirmation_of_enrollment:"CONFIRMACIÓN DE INSCRIPCIÓN",
	   please_review_and_confirm_enrollments_for:"Revise y confirme las inscripciones para",
	   confirm:"Confirmar",
	   enroll_students_to_section:"INSCRIBIR ALUMNOS A LA SECCIÓN",
	   enrollment_period:"Período de inscripción",
	   days:"dias",
	   no_data_avalible:"Datos no disponibles.",
	   number_of_primary_teacher:"Numero de maestras de primaria",
	   secondary_teachers:"Maestras de secundaria",
	   department_head:"Jefa de departamento",
	   section_enroll:"Sección Inscribirse",
	   load_from_file:"Carga del archivo",
	   see_sections:"Ver secciones",
	   change_enrollment_status:"Cambiar el estado de la inscripción",
	   mentor_s:"Mentor (s)",
	   overdue_activities:"Actividades atrasadas",
	   total_session_time_and_last_log:"Tiempo total de sesión y último registro",
	   course_name_on_transcript:"Nombre del curso en la transcripción",
	   edit_other_grades:"Editar otras calificaciones",
	   save_as:"Guardar como",
	   account_receivable_dashboard:"Tablero de cuentas por cobrar",
	   key_performance_indicators:"Indicadores clave de rendimiento",
	   a_r_dashboard:"Panel de A/R",
	   payments_credits:"Pagos/créditos",
	   contract_templates:"Plantillas de contrato",
	   master_contracts:"Contratos maestros",
	   a_r_configuration:"Configuración de A/R",
	   a_r_processing:"Procesamiento A/R",
	   aging:"Envejecimiento",
	   receivable:"Cuenta por cobrar",
	   account_receivable_by_program:"Cuenta por cobrar por programa",
	   request_detail:"Detalle de solicitud",
	    request_information:"Información requerida",
	    requested_by:"Solicitado por",
	    approved_by:"Aprobado por",
	    approve:"Aprobar",
	    phone_name:"Nombre por teléfono",
	    phone_carrier:"Transportista telefónico",
		area_code:"Codigo de AREA",
	   address_lable:"Dirección lable",
	   address_default:"Dirección predeterminada",
	   new_photo:"Nueva foto",
	   current_of_wweeks:"# Actual de semanas",
	   select_enrollment_period:"Seleccionar el período de inscripción",
	   enter_rejection_reason:"Ingrese la razón de rechazo ...",
	   comments_and_documents:"Comentarios y documentos",
	   enrollment_history:"Historial de inscripción",
	   request_extension_for:"Solicitud de extensión para",
	   extended_of_weeks:"# Extendido de semanas",
	   current_enrollment_status:"Estado de inscripción actual",
	   select_extension_option:"Seleccione la opción de extensión",
	   extend_current_enrollment_until:"Extender la inscripción actual hasta",
	   transfer_to_new_section:"Transferir a una nueva sección",
	   transcript_requests:"Solicitudes de transcripción",
	   person_requesting_transcript:"Persona que solicita la transcripción",
	   telephone_number:"Número de teléfono",
	   number_of_copies:"Número de copias",
	   special_instructions:"instrucciones especiales",
	   last_school_attendance:"Última asistencia escolar",
	   year_last_attended:"Año por última vez asistido",
	   current_address:"Direccion actual",
	   relationship_to_student:"Relación con el estudiante",
	   method_of_delivery:"Método de entrega",
	   instructions:"*Instrucciones",
	   previous_requests:"Solicitudes anteriores",
	   additional_info:"Información adicional",
	   receive:"Recibir",
	   process:"Proceso",
	   add_to_school_group:"Agregar al grupo escolar",
	   submit_romote:"Presentar promover",
	   next_grade_level:"Siguiente nivel de grado",
	   please_select_a_school_for_promotion_and_transfer:"Seleccione una escuela para promoción y transferencia",
	   write_off:"Pedir por escrito",
	   amount_due:"Monto adeudado",
	   open_amount:"Cantidad abierta",
	   payment_application:"Solicitud de pago",
	   use_credit_openBalance:"Use crédito $ 111",
	   payment_amount_usd:"Monto de pago (USD)",
	   check_number:"Verifique el número",
	   confirmation_number:"Número de confirmación",
	   apply_payment:"Aplicar pago",
	   amount_paid:"Cantidad pagada",
	   applied_payment:"Pago aplicado",
	   payer_id:"Identificación del pagador",
	   view_detail:"Ver Detalle",
	   master_contract:"Contrato principal",
	   copy:"Copiar",
	   contract_user_detail:"Detalle del usuario de contrato",
	   follow_product_cost:"Siga el costo del producto",
	   default_cost:"Costo predeterminado",
	   offered_cost:"Costo ofrecido",
	   contract_detail:"Detalle del contrato",
	   contract_template_name:"Nombre de la plantilla de contrato",
	    master_contract_name:"Nombre de contrato maestro",
		 view_students:"Ver a los estudiantes",
		 make_payment:"Hacer el pago",
		 parent_page:"Página principal",
		 edit_parent:"Editar padre",
		 edit_profile:"Editar perfil",
		 account_receivable_configuration:"Configuración de cuentas por cobrar",
		 invoice_generation_date:"Fecha de generación de facturas", 
	   invoice_generation:"Generación de facturas", 
	   number_of_days_until_due_date:"Número de días hasta la fecha de vencimiento",
	   account_receivable_processing:"Procesamiento de cuentas por cobrar",
	   generate_invoices:"Generar facturas", 
	   process_automatic_payments:"Procesar pagos automáticos", 
	   send_late_notices:"Enviar avisos tardíos",
		course:"Curso",
		copy_courses:"Copiar cursos",
		copy_to_school:"Copia a la escuela",
		originating_program_code:"Código de programa de origen", 
	   destinating_program_code:"Destinar el código del programa", 
	   status_error:"Estado/error",
	   add_prerequisite:"Agregar requisito previo", 
	   group_name:"Nombre del grupo", 
	   enter_group_name:"Ingrese el nombre del grupo", 
	   select_a_department_to_display_courses:"Seleccione un departamento para mostrar cursos", 
	   edit_tranferred_grades:"Editar otras calificaciones", 
	   showing_num_records:"Mostrando 000 registros",
	   edit_all_other_grades:"Editar todas las demás calificaciones",
	   upload_student_documents:"Subir documentos de los estudiantes",
	   select_an_official_transcript_option:"Seleccione una opción de transcripción oficial", 
	   for_schools_or_personal_copy:"Para escuelas o copia personal", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Para uso de los estudiantes, envíe a otra escuela o para verificar la inscripción.", 
	   request_official_transcript:"Solicitar la transcripción oficial", 
	   PARCHMENT_for_colleges_or_universities:"Pergamino para colegios o universidades", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Para solicitar una universidad/universidad y para verificar la finalización de su diploma.", 
	   request_transcript:"Transcripción de solicitud", 
	   Learn_more_about_how_to_use_PARCHMENT:"Obtenga más información sobre cómo usar pergamino",
	   print_PDF:"Imprimir PDF",
	   user_school:"Escuela de usuarios",
	   filter:"Filtrar",
	   GENERAL:"GENERAL", 
	   STUDENT_INFO:"Información de los estudiantes", 
	   list:"Lista", 
	   last_school_name:"Último nombre de la escuela", 
	   TEACHER_INFO:"Información del maestro", 
	   contracted_load:"Carga contratada", 
	   ARENT_INFO:"Información de los padres",
	   add_credential:"Agregar credencial",
	   edit_credential:"Editar credencial",
	   add_comment_document:"Agregar comentarios y documento",
	   add_comment_document_for:"Agregar comentarios y documento para",
	   state_province:"Provincia del estado", 
	   post_code:"Código postal", 
	   linking_students_to:"Vincular a los estudiantes para", 
	   change_expiration_date:"Cambiar la fecha de vencimiento", 
	   expiry_date:"Fecha de caducidad", 
	   please_select_department:"Seleccione el departamento.", 
	   please_select_course:"Seleccione el curso.", 
	   please_select_title:"Ingrese el título.", 
	   please_select_primary_teacher:"Seleccione el maestro de primaria.", 
	   please_select_weeks:"Seleccione semanas.", 
	   please_select_level:"Seleccione el nivel.", 
	   please_select_credits:"Seleccione créditos.", 
	   please_select_type:"Seleccione Tipo.", 
	   please_select_daily_period:"Seleccione el período diario.",
	   please_enter_link_section:"Ingrese la sección de enlaces.",
	   please_enter_first_name:"Por favor ingrese el primer nombre.", 
	   please_enter_last_name:"Ingrese el apellido.", 
	   please_enter_contracted:"Ingrese contratado.", 
	   please_enter_email:"Ingrese el correo electrónico.", 
	   please_enter_phone:"Ingrese el teléfono.", 
	   please_enter_username:"Ingrese el nombre de usuario.",
	   please_enter_password:"Por favor, ingrese contraseña.", 
	   please_enter_status:"Seleccione el estado.", 
	   save_successful:"¡Se guardo correctamente!.",
	   please_add_student_address:"Agregue la dirección del estudiante.", 
	   please_enter_email_address:"Ingrese la dirección de correo electrónico.", 
	   please_select_relationship:"Seleccione la relación.", 
	   please_select_parent_status:"Seleccione el estado del padre.", 
	   please_enter_label:"Ingrese la etiqueta.", 
	   please_enter_address:"Ingrese la dirección.", 
	   please_enter_city:"Por favor ingrese a la ciudad.", 
	   please_enter_state:"Por favor ingrese el estado.", 
	   please_enter_zip_code:"Ingrese el código postal.", 
	   please_select_date_of_birth:"Seleccione la fecha de nacimiento.", 
	   please_select_track:"Seleccione Track.", 
	   please_enter_graduation_date:"Ingrese la fecha de graduación.", 
	   please_enter_country:"Por favor ingrese el país.", 
	   please_enter_phone_number:"Ingrese el número de teléfono.", 
	    please_enter_parent_first_name:"Ingrese el primer nombre de los padres.", 
	   please_enter_parent_last_name:"Ingrese el apellido del padre.", 
	   please_enter_parent_email_address:"Ingrese la dirección de correo electrónico principal.", 
	   please_enter_parent_username:"Ingrese el nombre de usuario de los padres.", 
	   please_select_parent_relationship:"Seleccione la relación de los padres.", 
	   please_enter_phone_label:"Ingrese la etiqueta del teléfono.", 
	   student_address_canot_be_empty:"La dirección del estudiante no puede estar vacía.",
	   please_select_document_type:"Seleccione el tipo de documento.", 
	   please_enter_new_type:"Por favor ingrese un nuevo tipo.", 
	   please_enter_comment:"Por favor ingrese el comentario.", 
	   link_is_not_a_valid_url:"El enlace no es una URL válida.",
	   please_enter_link_and_label:"Ingrese el enlace y la etiqueta.",
	   are_you_sure_to_delete_this_student:"¿Estás seguro de eliminar a este estudiante?",
	   please_select_gender:"Por favor seleccione el género.",
	   school_contracted_load:"Carga contratada en la escuela", 
	   global_contracted_load:"Carga global contratada",
	   please_enter_label_for_attachments:"Ingrese la etiqueta para los archivos adjuntos.",
	   please_select_section:"Seleccione la sección.", 
	   enrollment_completed_successfully:"Inscripción completada con éxito.",
	   delete_this_comment:"Eliminar este comentario?",
	   please_enter_course_name:"Ingrese el nombre del curso.", 
	   please_select_credits_possible:"Seleccione los créditos posibles.",
	   can_save_record:"No puedo guardar el registro:",
	   are_you_sure_to_delete_this_tranferred_grade:"¿Seguro que eliminará esta calificación transferida?",
	   are_you_sure_to_delete_num_tranferred_grade:"¿Seguro que eliminará 11 calificaciones transferidas?", 
	   please_select_tranferred_grade:"Seleccione la calificación Tranfered.",
	   please_ente_subject:"Por favor ingrese sujeto.", 
	   please_select_made_to:"Seleccione Hecho a.", 
	   delete_this_communication:"Eliminar esta comunicación?",
	   please_select_school:"Seleccione la escuela.",
	   please_enter_name:"Por favor ingrese el nombre.",
	   please_enter_group_name:"Ingrese el nombre del grupo.",
	   you_have_some_form_errors_please_check_above:"Tienes algunos errores de forma. Por favor, consulte arriba.",
	   please_select_recipient:"Seleccione el destinatario.", 
	   please_enter_description:"Ingrese la descripción.",
	   delete_this_resource:"Eliminar este recurso?",
	   please_enter_activity_name:"Ingrese el nombre de la actividad.", 
	   please_select_activity_type:"Seleccione el tipo de actividad.", 
	   please_enter_max_score:"Ingrese el puntaje máximo.", 
	   please_enter_due_date:"Ingrese la fecha de vencimiento.",
	   please_enter_unit_name:"Ingrese el nombre de la unidad.",
	   are_you_sure_to_clear_this_unit:"¿Estás seguro de borrar esta unidad?",
	   please_enter_score:"Por favor ingrese el puntaje.",
	   delete_this_credential:"Eliminar esta credencial?",
	   plase_select_period:"Seleccione el período", 
	   plase_select_start_date:"Seleccione la fecha de inicio", 
	   plase_select_end_date:"Seleccione la fecha de finalización",
	   select_to_register_course_to_students_individual_learning_path_view:"Seleccione registrar el curso a los estudiantes Vista de ruta de aprendizaje individual",
	   delete_this_request:"Eliminar esta solicitud?",
	   please_enter_fname:"Por favor ingrese el primer nombre.", 
	   please_enter_lname:"Ingrese el apellido.", 
	   please_enter_birthday:"Por favor ingrese el cumpleaños.", 
	   please_enter_address:"Ingrese la dirección.", 
	   please_enter_zip:"Por favor ingrese zip.", 
	   please_enter_country:"Por favor ingrese el país.", 
	   please_enter_ethnicity:"Por favor ingrese la etnia.", 
	   please_enter_grade:"Por favor ingrese la calificación.", 
	   please_enter_mobile:"Por favor ingrese a Mobile.", 
	   please_enter_hear_about_us:"Por favor, ingrese a escuchar sobre nosotros.", 
	   please_enter_program_of_interest:"Ingrese el programa de interés.", 
	   please_enter_course_level:"Ingrese el nivel del curso.", 
	   please_enter_guardian_1_name:"Por favor ingrese a Guardian 1 nombre.", 
	   please_enter_guardian_1_email:"Ingrese a Guardian 1 correo electrónico.", 
	   please_enter_guardian_1_home_phone:"Ingrese a Guardian 1 Teléfono de la casa.", 
	   please_enter_guardian_1_relation:"Por favor ingrese la relación Guardian 1.",
	   please_select_parents:"Seleccione a los padres.",
	   transfer_classroom:"Aula de transferencia", 
	   please_choose_one_section_to_transfer:"Elija una sección para transferir.", 
	   transfer:"Transferir",
	   assigning_multiple_users_to_a_school_or_school_group:"Asignar múltiples usuarios a un grupo escolar o escolar", 
	   add_to_school_or_school_group:"Agregar al grupo escolar o escolar", 
	   please_select_school_or_school_group:"Seleccione la escuela o el grupo escolar.",
	   print_student_progress_report:"Informe de progreso de los estudiantes impresos",
 },
 vi: {
	  reporting_center:"Trung tâm báo cáo", 
	   grade_reports:"Báo cáo lớp", 
	   user_reports:"Báo cáo người dùng", 
	   learning_reports:"Báo cáo học tập", 
	   administrative_reports:"Báo cáo hành chính", 
	   progress_report:"Báo cáo tiến trình", 
	   full_progress_report:"Báo cáo tiến độ đầy đủ", 
	   grade_report:"Báo cáo lớp", 
	   roster_report:"Báo cáo danh sách", 
	   parent_report:"Báo cáo phụ huynh", 
	   teacher_report:"Báo cáo giáo viên", 
	   student_report:"Báo cáo của sinh viên", 
	   log_in_report:"Đăng nhập báo cáo", 
	   enrollmentreport:"Báo cáo tuyển sinh", 
	   enrollment_summary:"Tóm tắt ghi danh", 
	   student_enrollment_summary:"Tóm tắt ghi danh của sinh viên", 
	   attendance_report:"Báo cáo tham dự", 
	   attendance_summary_report:"Báo cáo tóm tắt tham dự", 
	   log_In_Credentials:"Thông tin đăng nhập", 
	   application_report:"Báo cáo ứng dụng", 
	   section_report:"Phần Báo cáo", 
	   course_report:"Báo cáo khóa học", 
	   communication_summary:"Tóm tắt giao tiếp", 
	   comments_and_Document_Report:"Nhận xét và báo cáo tài liệu", 
	   School_Calendar:"Lịch học", 
	   bell_Schedule:"Lịch trình chuông", 
	   student_Contract:"Hợp đồng sinh viên",
	   eOS_Report:"Báo cáo EOS", 
	   active_Enrollments_Per_Term_Report:"Ghi danh hoạt động cho mỗi báo cáo kỳ hạn thời hạn", 
	   active_Student_Enrollments_with_As_Report:"Các học sinh tích cực đăng ký với báo cáo như báo cáo", 
	   active_Student_Enrollments_Report:"Báo cáo đăng ký học sinh tích cực", 
	   all_Students_GPA_Report:"Tất cả các báo cáo GPA của sinh viên", 
	   old_All_Student_GPA_Report:"Old All Student GPA Báo cáo", 
	   billingGroup_Engagement_Type_Report:"Báo cáo loại Billinggroup +", 
	   enrollment_Confirmation_Report:"Báo cáo xác nhận tuyển sinh", 
	   eOS_College_Matriculations_Report:"Báo cáo trúng tuyển đại học EOS", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Lịch sử tuyển sinh của sinh viên cho đến ngày W Báo cáo thời hạn",
	   student_Information_Report:"Báo cáo thông tin sinh viên", 
	   ran_by:"chạy qua",
	   Show_Filter:"Hiển thị bộ lọc", 
	   School_Group:"Nhóm trường", 
	   school:"Trường học", 
	   department:"Phòng", 
	   student:"Học sinh", 
	   student_status:"Tình trạng Học sinh", 
	   course:"Khóa học", 
	   course_level:"Cấp độ khóa học", 
	   section:"Phần", 
	   teacher:"Giáo viên", 
	   primary_teacher:"Giáo viên chính", 
	   secondary_teacher:"Giáo viên thứ hai", 
	   completion_Date_Range:"Phạm vi ngày hoàn thành", 
	   from_date:"Từ ngày", 
	   to_date:"Cho đến nay", 
	   status:"Trạng thái", 
	   gender:"Giới tính", 
	   final_grade:"Lớp cuối cùng", 
	   advisor:"Cố vấn", 
	   grade_level:"Khối", 
	   specific_mark:"Dấu hiệu cụ thể", 
	   track:"Theo dõi", 
	   ethnicity:"Dân tộc", 
	   additional_fields:"các trường bổ sung", 
	   school_sessions:"Buổi học", 
	   gradebook:"Lớp", 
	   submit:"Nộp", 
	   reset:"Cài lại", 
	   show_hide_columns:"Hiển thị/ẩn cột", 
	   select_all:"Chọn tất cả", 
	   student_id:"thẻ học sinh", 
	   last_name:"Họ", 
	   first_name:"Tên đầu tiên", 
	   grade_level:"Khối", 
	   start_date:"Ngày bắt đầu", 
	   end_date:"Ngày cuối", 
	   grade_final:"Lớp cuối cùng", 
	   percent:"Phần trăm", 
	   credit:"Tín dụng", 
	   download_excel:"Tải xuống Excel", 
	   print:"In", 
	   no_data:"Không có dữ liệu.", 
	   view:"Xem", 
	   showing:"Hiển thị", 
	   of:"của", 
	   other_grade:"Lớp khác", 
	   level:"Mức độ", 
	   date:"Ngày", 
	   grade:"Cấp",
	   enrollment_Change_Status:"Trạng thái thay đổi ghi danh", 
	   close:"Đóng", 
	   select_Enrollment_Status:"Chọn trạng thái đăng ký", 
	   select:"Lựa chọn...", 
	   cancel:"Hủy bỏ", 
	   save:"lưu", 
	   students:"Học sinh", 
	   Course_Status:"Tình trạng khóa học", 
	   Closed_courses:"Các khóa học đóng", 
	   Section_Status:"Trạng thái phần", 
	   Closed_sections:"Các phần đóng", 
	   Transferred_From:"Chuyển từ",
	   Graduation_From_Date:"Tốt nghiệp từ ngày", 
	   Graduation_To_Date:"Tốt nghiệp cho đến nay", 
	   Enrollment_From_Date:"Ghi danh từ ngày", 
	   Enrollment_To_Date:"Ghi danh cho đến nay", 
	   Enrollment_Status:"Tình trạng tuyển sinh", 
	   Transfer_From_Date:"Chuyển từ ngày", 
	   Transfer_To_Date:"Chuyển đến ngày", 
	   Custom_Query:"Truy vấn tùy chỉnh", 
	   Last_Access_Date:"Ngày truy cập cuối cùng", 
	   Total_Session_Time:"Tổng thời gian phiên", 
	   Quality_of_Work:"Chất lượng công việc", 
	   Grade_to_Date:"Lớp cho đến nay", 
	   Overall_Percent:"Tổng thể phần trăm", 
	   On_Schedule_Percent:"Theo lịch trình phần trăm", 
	   Activity_Count_Complete:"Số lượng hoạt động hoàn thành", 
	   Activity_Count_Total:"Tổng số hoạt động", 
	   Overdue_Activitie:"Quá hạn activitie",
	   Section_Course_Additional_Fields:"Phần/Khóa học các lĩnh vực bổ sung", 
	   Create_On_Date:"Tạo vào ngày", 
	   Last_Status_Update_Date:"Ngày cập nhật trạng thái cuối cùng", 
	   Transferred_In:"Chuyển vào", 
	   Transferred_In_Date:"Chuyển giao trong ngày", 
	   email:"E-mail", 
	   birth_date:"Ngày sinh", 
	   course_name:"Tên khóa học", 
	   section_name:"Tên phần", 
	   school_name:"Tên trường", 
	   Graduation_Date:"Ngày tốt nghiệp", 
	   Created_on:"Được tạo ra", 
	   mentor_Advisor:"Cố vấn/cố vấn",
	   sections:"Phần", 
	   roster:"Đội hình", 
	   relationship:"Mối quan hệ", 
	   Email_or_Phone:"Email hoặc điện thoại", 
	   Enter_any_text:"Nhập bất kỳ văn bản", 
	   Advisor_Success_Manager:"Cố vấn / quản lý thành công", 
	   User_Id:"Tên người dùng", 
	   phone_number:"Số điện thoại", 
	   Student_Last_Name:"Họ học sinh", 
	   Student_First_Name:"Tên học sinh", 
	   Student_Email:"Email học sinh",
	   credentials:"Thông tin xác thực", 
	   availability:"khả dụng",
	   enrollments:"Ghi danh", 
	   Datea_Created_on:"Ngày được tạo trên",
	   country:"Quốc gia", 
	   state:"Tình trạng", 
	   zipcode:"Mã Bưu Chính", 
	   Enter_any_zipcode:"Nhập bất kỳ mã zipcode nào", 
	   address:"Địa chỉ",
	   zip_Code:"Mã Bưu Chính",
	   Login_Report:"Báo cáo đăng nhập", 
	   user_Type:"Loại người dùng", 
	   user_Name:"Tên tài khoản", 
	   Show_last_log_in_only:"Chỉ hiển thị đăng nhập cuối cùng trong", 
	   Username:"tên tài khoản", 
	   Date_Time:"Ngày giờ", 
	   Ip_Address:"Địa chỉ IP", 
	   city:"Thành phố",
	   Enrollment_Start_Date:"Ngày bắt đầu đăng ký", 
	   Enrollment_End_Date:"Ngày kết thúc ghi danh", 
	   Completion_Date:"Ngày hoàn thành", 
	   section_Type:"Loại phần", 
	   student_Enrolled:"Học sinh ghi danh", 
	   content_Provider:"Nhà cung cấp nội dung", 
	   student_Additional_Fields:"Sinh viên các lĩnh vực bổ sung",
	   type:"Kiểu", 
	   in_Class_Information:"Trong thông tin lớp học",
	   Enrollment_Summary_Report:"Báo cáo tóm tắt ghi danh", 
	   Transferred_From_School:"Chuyển từ trường học",
	   Total_Enrollments:"Tổng số tuyển sinh", 
	   content_Type:"Loại nội dung", 
	   active_Course_Progress:"Tiến bộ khóa học tích cực",
		Grades:"Điểm", 
	   attendance:"Sự tham dự",
	   student_Absences:"Học sinh vắng mặt", 
	   total_Absence:"Hoàn toàn vắng mặt", 
	   section_Absences:"Phần vắng mặt",
	   Grade_Level_Absences:"Lớp vắng mặt",
	   Gender_Absences:"Vắng mặt giới tính",
	   Login_credentials:"Thông tin đăng nhập", 
	   names:"Tên", 
	   user_status_admin_teacher_parent:"Trạng thái người dùng (quản trị viên, giáo viên, phụ huynh)", 
	   show_title:"Hiển thị tiêu đề", 
	   midle_name:"Tên đệm", 
	   password:"Mật khẩu", 
	   parent_name:"Tên cha mẹ", 
	   linked_to_parent:"Được liên kết với cha mẹ", 
	   linked_to_student:"Liên kết với hoc sinh",
	   login_credentials_Report:"Báo cáo thông tin đăng nhập", 
	   app_id:"Id Ứng dụng", 
	   created:"Tạo", 
	   modified:"Sửa đổi",
	   select_level:"Chọn cấp độ", 
	   select_additional_fields:"Phần các trường bổ sung", 
	   title:"Tiêu đề", 
	   credits:"Tín dụng", 
	   section_ID:"Mục ID", 
	   content:"Nội dung", 
	   course_additional_fields:"Khóa học các lĩnh vực bổ sung",
	   course_id:"Mã khóa học", 
	   communication_summary_report:"Báo cáo tóm tắt truyền thông", 
	   method:"Phương pháp", 
	   create_date:"Tạo ngày", 
	   subject:"Chủ thể", 
	   make_from_id:"Làm từ id", 
	   make_to:"Làm cho", 
	   attachments:"Đính kèm", 
	   comment_and_document_summary_report:"Nhận xét và báo cáo tóm tắt tài liệu", 
	   comment_type:"Loại bình luận", 
	   flagged:"Được gắn cờ", 
	   sharing_target:"Chia sẻ mục tiêu", 
	   show_on_transcript:"Hiển thị trên bảng điểm", 
	   by:"Qua", 
	   comment:"Bình luận", 
	   type_name:"Tên loại", 
	   effective_from_date:"Hiệu quả từ ngày", 
	   effective_to_date:"Hiệu quả cho đến nay", 
	   count_docs:"Đếm tài liệu",
	   school_calendar_report:"Báo cáo lịch của trường", 
	   event_Id:"ID sự kiện", 
	   date_start:"Ngày bắt đầu", 
	   date_end:"Ngày kết thúc", 
	   posted_last_name:"Đăng tên cuối cùng", 
	   posted_first_name:"Đăng tên đầu tiên",
	   bell_schedule_report:"Báo cáo lịch trình Bell", 
	   period:"Giai đoạn", 
	   start:"Bắt đầu", 
	   end:"Kết thúc",
	   student_contract_report:"Báo cáo hợp đồng sinh viên", 
	   begin_date:"Ngày bắt đầu", 
	   contracts:"Hợp đồng", 
	   contract_name:"Tên hợp đồng", 
	   contract_begin_date:"Hợp đồng bắt đầu ngày", 
	   contract_end_date:"Ngày kết thúc hợp đồng",
	   active_enrollments_per_term_report:"Ghi danh hoạt động cho mỗi báo cáo kỳ hạn thời hạn", 
	   entry_date:"Ngày nhập", 
	   teachers:"Giáo viên", 
	   term:"Thuật ngữ", 
	   sections:"Phần",	   
	   showing_of:"Hiển thị 10 trên 20",	   
	   filter:"Lọc",	
	   students:"Học Sinh",
	   school:"trường học",
	   all_school:"Tất cả các trường học",
	   student:"Học Sinh",
	   school:"trường học",
	   email:"Thư điện tử",
	   grade_level:"Khối",
	   status:"Trạng thái",
	   seach_for_a_student_or_id:"Tìm kiếm sinh viên hoặc ID…",
	   search:"Tìm kiếm …",
	   message_student:"Nhắn học sinh",
	   request_enrollment:"Yêu cầu ghi danh",
	   print_schedule:"Lịch in",
	   view:"Lượt xem",
	   no_data:"Không có dữ liệu.",
	   views:"Lượt xem", 
	   enrollment:"Ghi danh", 
	   schedule:"Lịch trình", 
	   transferred_grades:"Điểm được chuyển", 
	   comments_ocuments:"Nhận xét & Tài liệu", 
	   academic_records:"Hồ sơ học tập", 
	   compliance_log:"Nhật ký Tuân thủ", 
	   unofficial_transcript:"Bảng điểm không chính thức", 
	   iD_card:"Chứng minh nhân dân", 
	   student_number_id_information:"Số sinh viên # 29561 Thông tin", 
	   student_number:"Số Học Sinh", 
	   gender:"Giới tính", 
	   goes_by:"Đi bằng", 
	   date_of_birth:"Ngày sinh", 
	   ethnicity:"Dân tộc", 
	   mobile:"Điện thoại di động", 
	   academic_track:"Kết quả học tập", 
	   learning_path_template:"Mẫu Đường dẫn Học tập", 
	   graduation_date:"Ngày tốt nghiệp", 
	   comments:"Bình luận", 
	   transfer_information:"Chuyển thông tin", 
	   enrollment_date:"Ngày đăng ký", 
	   transfer_date:"Ngày chuyển giao", 
	   transfer_student:"Học sinh chuyển trường", 
	   parent_mentor_contact:"Liên hệ với Phụ huynh / Cố vấn", 
	   mentor:"Người hướng dẫn", 
	   parent_phone:"Điện thoại của Cha mẹ", 
	   emergency_contact:"Liên lạc khẩn cấp", 
	   academic_advisor_ssm:"Cố vấn học tập / SSM", 
	   student_success_manager:"Quản lý thành công của sinh viên", 
	   academic_avisor:"Cố vấn học tập", 
	   address:"Địa chỉ nhà", 
	   address_01_Default:"Địa chỉ 01 (Mặc định)", 
	   street:"Đường phố", 
	   city:"Thành phố", 
	   state:"Tiểu bang", 
	   zip:"Zip", 
	   hide_Detailed_information:"Ẩn thông tin chi tiết", 	    
	   current_course_progress:"Tiến độ khóa học hiện tại", 	    
	   full_Path_Progress:"Tiến độ đường dẫn đầy đủ", 	    
	   print:"In", 	    
	   avg_graduation_progress:"Trung bình Tiến độ tốt nghiệp", 	    
	   GPA:"Điểm trung bình", 	    
	   graduation_Status:"Tình trạng Tốt nghiệp", 	    
	   on_track:"Theo dõi",
		show_detailed_information:"Hiển thị thông tin chi tiết",
		communication:"Liên lạc",
		student_advisors:"Cố vấn Học Sinh", 	    
	   country:"Quốc gia", 	    
	   grade:"Lớp", 	    
	   credits:"Tín dụng", 	    
	   sort:"Loại", 	    
	   course_progress:"Tiến trình khóa học",
	   overall_GPA:"Điểm trung bình chung",
	    current_graduation_progress:"Tiến độ tốt nghiệp hiện tại",
		individual_course_progress:"* Tiến trình của từng khóa học khác nhau, đây là tiến trình tổng thể của bạn",
		subject:"Môn học",
		online_sections:"Phần trực tuyến",
	   course:"Khóa học", 
	   section:"Tiết diện", 
	   actions:"Hành động", 
	   view_event:"xem sự kiện",
	   in_class_section:"Trong phần lớp",
	   calendar:"Lịch",
	   access_link:"Liên kết truy cập", 
	   online_link:"Liên kết trực tuyến",
	   launch_course:"Khóa học khởi động", 
	   start_class:"Bắt đầu lớp học",
	   level:"Mức độ", 
	   date:"Ngày", 
	   transferred_in:"Đã chuyển vào",
	   tranferred_grades:"Điểm đã chuyển",
	   Searchs:"Tìm kiếm", 
	   Search_department_course:"Khóa học bộ phận tìm kiếm, src…",
	   archived:"Đã lưu trữ", 
	   add_comment:"Thêm bình luận", 
	   created_date:"Ngày tạo ra", 
	   by:"Qua", 
	   type:"Loại hình", 
	   comment:"Bình luận", 
	   from_date:"Từ ngày", 
	   to_date:"Đến ngày", 
	   documents:"Các tài liệu", 
	   edit:"Chỉnh sửa", 
	   delete:"Xóa bỏ",
	   communications:"Thông tin liên lạc", 
	   add_communications:"Thêm thông tin liên lạc", 
	   made_from:"Làm từ", 
	   made_to:"Được thực hiện đến.", 
	   means:"Có nghĩa", 
	   attachments:"Tệp đính kèm", 
	   content:"Nội dung",
	   compliance_logs:"Nhật ký Tuân thủ", 
	   messageID:"ID tin nhắn", 
	   agree:"Đồng ý", 
	   dateTime:"Ngày giờ", 
	   iPAddress:"Địa chỉ IP", 
	   add_idit_comment_document:"Thêm / Chỉnh sửa Bình luận & Tài liệu", 
	   document_type:"Loại tài liệu", 
	   show_on_transcript:"Hiển thị Trên Bản ghi", 
	   select_users_to:"Chọn người dùng", 
	   teacher:"Giáo viên", 
	   parent:"Cha mẹ", 
	   flag:"Lá cờ", 
	   none:"Không có", 
	   link:"Liên kết", 
	   label:"Nhãn mác", 
	   add_more_link:"Thêm liên kết khác", 
	   save:"Tiết kiệm", 
	   add_edit_communication:"Thêm / Chỉnh sửa thông tin liên lạc", 
	   made_by:"Được làm bởi", 
	   date_time:"Ngày giờ", 
	   length:"Chiều dài", 
	   select:"Lựa chọn", 
	   select_users_to_view:"Chọn người dùng để xem thông tin liên lạc", 
	   add_more:"Bổ sung thêm", 
	   communication_summary:"Tóm tắt thông tin liên lạc",
	   close:"Đóng",
	   new_type:"Kiểu mới",
	   select_user_to_view_comment:"Chọn người dùng để xem bình luận",
	   flag_comment:"Gắn cờ bình luận",
	   teacher_page:"Trang giáo viên",
	   edit_information:"Chỉnh sửa thông tin",
	   phone:"Điện thoại",
	   add_credential:"Thêm thông tin xác thực",
	   add_edit_credential:"Thêm/Chỉnh sửa thông tin đăng nhập",
	   first_name:"Họ",
	   midle_name:"Tên đệm",
	   last_name:"Tên",
	   cancel:"Hủy bỏ",
	   add_new:"Thêm mới",
	   phone_type:"Loại điện thoại",
	   zipCode:"Mã Bưu Chính",
	   phone_number:"Số điện thoại",
	   default:"Mặc định",
	   please_select_country:"Vui lòng chọn quốc gia",
	   student_information:"Thông tin học sinh",
	   username:"Tên tài khoản",
	   user_directory:"Danh mục người dùng",
	   add_teacher:"Thêm giáo viên",
	   add_admin:"Thêm quản trị viên",
	   export_to_excel:"Xuất sang Excel",
	   export_to_pdf:"Xuất sang PDF",
	   send_login_credentials:"Gửi thông tin đăng nhập",
	   search_for_a_user_or_id:"Tìm kiếm người dùng hoặc ID…",
	   user:"Người dùng",
	   school_admin:"Quản lý trường học",
	   change_password:"Đổi mật khẩu",
	   set_password_expiration_date:"Đặt ngày hết hạn mật khẩu",
	   impersonate_user:"Mạo danh người dùng",
	   edit_user_tags:"Chỉnh sửa thẻ người dùng",
	   add_or_edit_users_schoo_assign:"Thêm hoặc chỉnh sửa người dùng trường chỉ định",
	   assign_content_access:"Chỉ định quyền truy cập nội dung",
	   add_student:"Thêm học sinh",
	   add_parent_mentor:"Thêm phụ huynh / người cố vấn",
	   showing:"Đang hiển thị",
	   of:"của",
	   school_name:"Tên trường",
	   edit_user_school_tags:"Chỉnh sửa thẻ trường người dùng",
	   personal_information:"Thông tin cá nhân",
	   contacted_load:"Liên hệ tải",
	   maximum_of_active_students:"Số lượng học sinh tích cực tối đa",
	   teacher_since:"Giaó viên từ",
	   login_infomation:"Đăng nhập thông tin",
	   username:"Tên tài khoản ",
	   password :"Mật khẩu",
	   avatar :"Hình đại diện",
	   teachers :"Giáo viên",
	   change_status :"Thay đổi trạng thái",
	   add_admin:"Thêm quản trị viên",
	   name:"Tên",
	   create_on:"Tạo Bật",
	   registrar:"công ty đăng ký",
	   birthday:"Sinh nhật",
	   signature:"Chữ ký",
	   photo:"Tấm ảnh",
	   designated_registrar:"Nhà đăng ký được chỉ định",
	   track:"Theo dõi",
	   select_existing_track:"Chọn bản nhạc hiện có",
	   available:"Có sẵn",
	   parent_mentor:"Phụ huynh / Người cố vấn",
	   relationship:"Mối quan hệ",
	   email_address:"Địa chỉ email",
	   academic_mentor:"Cố vấn học thuật",
	   no_data_available_in_table:"Không có dữ liệu trong bảng",
	   primary_language:"Ngôn ngữ chính",
	   add_into_parent_or_mentor:"Thêm vào Parent / Mentor",
	   add_into_phone:"Thêm vào điện thoại",
	   add_into_address:"Thêm vào Địa chỉ",
	   select_one:"Chọn một",
	   login:"Đăng nhập",
	   plese_select_country:"Vui lòng chọn quốc gia",
	   edit_student:"Sửa học sinh",
	   academic_advisor_or_student_success_manager:"Cố vấn học tập / Quản lý thành công của học sinh",
	   role:"Vai diễn",
	   link_parent:"Liên kết cha mẹ",
	   link_advisor_sms:"Cố vấn liên kết/SSM",
	   save_into_parent_mentor:"Lưu vào Parent / Mentor",
	   save_into_parent_phone:"Lưu vào điện thoại",
	   save_into_parent_address:"Lưu vào Địa chỉ",
	   bulk_information_update:"Cập nhật thông tin hàng loạt",
	   enrollments:"Tuyển sinh",
	   email_student:"Email học sinh",
	   unofficial_transcripts:"Bảng điểm không chính thức",
	   official_transcripts:"Bảng điểm chính thức",
	   email_students_schedule:"Gửi email thời khóa biểu của học sinh",
	   export_students_to_excel:"Xuất học sinh sang Excel",
	   export_parent_list_to_excel:"Xuất danh sách phụ huynh sang Excel",
	   assign_learning_path_template:"Chỉ định Mẫu Lộ trình Học tập",
	   promote_student_to_the_next_grade_level:"Thúc đẩy học sinh lên cấp lớp tiếp theo",
	   batch_upload_students:"Học sinh tải lên hàng loạt",
	   batch_upload_transfer_grades:"Điểm chuyển tải lên hàng loạt",
	   transfer_apex_only:"Chuyển (Chỉ APEX)",
	   transfer_content_providers:"Chuyển (Tất cả các nhà cung cấp nội dung)",
	   batch_enrollments:"Ghi danh hàng loạt",
	   send_message:"Gửi tin nhắn",
	   impersonate:"Mạo danh",
	   change_login_credentials:"Thay đổi thông tin đăng nhập",
	   request_enrollment:"Yêu cầu ghi danh",
	   send_weekly_status_report:"Gửi báo cáo tình trạng hàng tuần",
	   please_select_student:"Vui lòng chọn học sinh.",
	   student_status_will_be_changed_to_status_withdraw:"Tình trạng sinh viên sẽ được thay đổi thành 111 và tất cả các số đăng ký sẽ được rút. Bạn có chắc bạn muốn tiếp tục?",
	   student_status_will_be_changed_to_status:"Tình trạng học sinh sẽ được thay đổi thành 111. Bạn có chắc mình muốn tiếp tục không?",
	   value:"Giá trị",
	   student_success_manager_or_acdemic:"Người quản lý thành công sinh viên / Cố vấn học tập",
	   enroll_students_to_section:"Đăng ký học sinh vào phần",
	   department:"Phòng",
	   refresh:"Làm mới lại",
	   select_department:"Vui lòng chọn bộ phận",
	   select_course:"Chọn khóa học",
	   select_section:"Chọn phần",
	   start_date:"Ngày bắt đầu",
	   end_date:"Ngày cuối",
	   ID:"ID",
	   action:"Hoạt động",
	   enrollment_period:"Thời gian đăng ký",
	   select_a_course_to_register_ilp:"Chọn một khóa học để đăng ký ILP",
	   period:"Giai đoạn",
	   credit:"Tín dụng",
	   year:"Năm",
	   enroll:"Ghi danh",
	   recipient_transcript:"Bảng điểm người nhận",
	   select_all_or_unselect_all:"Chọn tất cả / không cần lựa chọn tất cả",
	   include_in_progress_sections:"Bao gồm trong các phần tiến độ",
	   show_satisfaction_of_program:"Hiển thị sự hài lòng của chương trình",
	   show_total_credit:"Hiển thị tổng số tín dụng",
	   show_student_info:"Hiển thị thông tin hoc sinh",
	   show_academic_info:"Hiển thị thông tin học tập",
	   show_school_names_from_orther_grades:"Hiển thị tên trường từ các lớp khác",
	   show_school_contact:"Hiển thị liên hệ trường học",
	   include_transferred_grades_in_gpa:"Bao gồm các lớp được chuyển trong GPA",
	   include_in_progress_grade:"Bao gồm trong lớp tiến bộ",
	   include_grade_scales:"Bao gồm thang điểm",
	   show_graduation_date:"Hiển thị ngày tốt nghiệp",
	   show_weighted_gpa:"Hiển thị GPA có trọng số",
	   show_grade_level_gpa:"Hiển thị GPA cấp lớp",
	   show_comletion_date:"Hiển thị ngày hoàn thành",
	   show_withdraw_classes:"Hiển thị các lớp học rút tiền",
	   show_withdraw_date:"Hiển thị ngày rút",
	   show_transfered_in_classes:"Hiển thị được chuyển trong các lớp học",
	   show_digital_seal:"Hiển thị con dấu kỹ thuật số",
	   show_singnature:"Hiển thị chữ ký",
	   group_by:"Nhóm theo",
	   school_year:"Năm học",
	   school_level:"Cấp trường",
	   notes:"Ghi chú",
	   ok:"Ok",
	   are_you_sure_to_send:"Bạn có chắc chắn sẽ gửi không?",
	   assign_learning_path_templete:"Gán mẫu đường dẫn học tập",
	   assign_student_to_selected_learning:"Chỉ định học sinh cho mẫu đường dẫn học tập được chọn",
	   assign:"Giao phó",
	   are_you_sure_to_promote_to_level:"Bạn có chắc chắn sẽ quảng bá lên cấp lớp tiếp theo?",
	   data_process:"Quá trình dữ liệu",
	   upload_and_import_data:"Tải và nhập dữ liệu",
	   download_user_information:"Tải xuống thông tin người dùng",
	   here:"nơi đây",
	   select_student_upload_file:"Chọn tệp tải lên học sinh",
	   local_drive:"Ổ đĩa địa phương",
	   the_file_is_uploaded:"Tệp được tải lên",
	   template_name:"Tên mẫu",
	   Here:"Nơi đây",
	   sample_file_excel:"Tệp mẫu Excel.",
	   file_type:"Loại tệp",
	   delimited:"Được phân định",
	   delimited_chars:"Phân đoạn ký tự",
	   fixed_width:"Chiều rộng cố định",
	   first_line_header:"Tiêu đề dòng đầu tiên",
	   loader_field:"Trường tải",
	   Header:"Tiêu đề",
	   sample_data:"Dữ liệu mẫu",
	   column_width:"Chiều rộng colunm",
	   save_tamplate:"Lưu mẫu",
	   save_and_upload_data:"Lưu và tải lên dữ liệu",
	   result:"Kết quả",
	   upload_and_import_data_orther_grade:"Tải lên và nhập dữ liệu",
	   select_upload_file:"Chọn Tải lên tệp",
	   student_id:"thẻ học sinh",
	   uploadAnd_import_data_enrollment:"Tải lên và nhập dữ liệu đăng ký",
	   section_id:"Mục ID",
	   title:"Tiêu đề",
	   recipient:"Người nhận",
	   same_current_address:"Giống như địa chỉ hiện tại",
	   add_more_reciptient:"Thêm nhiều người nhận",
	   issuse_date:"Ngày phát hành",
	   show_total_unapplied_credits:"Hiển thị tổng số tín dụng không được áp dụng",
	   reconcile_another_student_record:"Hòa giải với một hồ sơ sinh viên khác",
	   please_choose_one_student_to_reconcile:"Vui lòng chọn một sinh viên để hòa giải.",
	   yes:"Đúng",
	   no:"KHÔNG",
	   apex_classroom_sync:"Đồng bộ lớp học Apex",
	   next:"Kế tiếp",
	   apex_classrooms:"Lớp học Apex",
	   online_user_id:"ID người dùng trực tuyến",
	   enter_online_user_id:"Nhập ID người dùng trực tuyến",
	   online_section_id:"ID phần trực tuyến",
	   online_section_name:"Tên phần trực tuyến",
	   online_course_name:"Tên khóa học trực tuyến",
	   enrollment_date:"Ngày đăng ký",
	   back:"Mặt sau",
	   import:"Nhập khẩu",
	   offical_transcipt:"Bảng điểm chính thức",
	   email_schedule:"Lịch trình email",
	   reconcile_with_another_records:"Hòa giải với một kỷ lục khác",
	   online_sync_and_update:"Cập nhật & Cập nhật tiến độ trực tuyến",
	   download_all_completion_cretification:"Tải xuống tất cả các chứng nhận hoàn thành",
	   orther_grade:"Các lớp khác",
	   medical:"Thuộc về y học",
	   comments_and_documents:"Nhận xét và tài liệu",
	   contracts:"Hợp đồng",
	   invoices:"Hóa đơn",
	   audit_logs:"Nhật ký kiểm toán",
	   edit_logs:"Chỉnh sửa nhật ký",
	   grade_to_date:"Lớp cho đến nay",
	   quality_of_work:"Chất lượng công việc",
	   last_access:"Truy cập lần cuối",
	   gradebook:"Lớp",
	   transfer:"Chuyển khoản",
	   completion_certification:"Hoàn thành chứng nhận",
	   tranfer_user_school:"Chuyển trường người dùng",
	   tranfer_to_school:"Chuyển đến trường",
	   tranfer_apex_classrooms:"Chuyển các lớp học Apex",
	   course_to_moved:"Khóa học để di chuyển",
	   current_teacher:"Giáo viên hiện tại",
	   future_section:"Phần tương lai",
	   future_program:"Chương trình tương lai",
	   future_teacher:"Giáo viên tương lai",
	   enrollment_start_date_end_date:"Ngày bắt đầu đăng ký - Ngày kết thúc",
	   no_more_option:"Không có nhiều lựa chọn",
	   create_new:"tạo mới",
	   transfer_classrooms:"Chuyển phòng học",
	   tyler_synchronization_for_az_school:"Đồng bộ hóa Tyler cho các trường AZ",
	   synchronize:"Làm cho đồng bộ",
	   individual_course_progress_varies:"Tiến trình khóa học cá nhân khác nhau. Đây là tiến bộ tổng thể của bạn để tốt nghiệp.",
	   edit_ilp:"Chỉnh sửa ILP",
	   add_academic_record:"Thêm hồ sơ học tập",
	   edit_all_records:"Chỉnh sửa tất cả các hồ sơ",
	   search_corse_department_src:"Khóa học tìm kiếm, bộ phận, SRC",
	   message_id:"ID tin nhắn",
	   add_new_contract:"Thêm hợp đồng mới",
	   contract_id:"ID hợp đồng",
	   contract_name:"Tên hợp đồng",
	   first_date:"Ngày đầu tiên",
	   last_date:"Ngày cuối cùng",
	   amount_per_period:"Số tiền mỗi kỳ",
	   terminating_status:"Chấm dứt trạng thái",
	    payment_history:"Lịch sử thanh toán",
	   record_payment:"Ghi lại thanh toán",
	   payment_method:"Phương thức thanh toán",
	   invoice_id:"ID hóa đơn",
	   show_all:"Hiển thị tất cả",
	   invoice_date:"Ngày hóa đơn",
	   from:"Từ…",
	   to:"ĐẾN…",
	   amount:"Số lượng",
	   paid:"Trả",
	   due:"Quá hạn",
	   date_paid:"Ngay trả",
	   apply_payments:"Áp dụng thanh toán",
	   mark_as_paid:"Đánh dấu như đã trả tiền",
	   void:"Vô hiệu",
	   audit_log:"Sổ ghi chép đánh giá",
	   object:"Sự vật",
	   changes_made:"Những thay đổi đã làm",
	   create_time:"Tạo thời gian",
	   time_stamp:"Dấu thời gian",
	   user_creare:"Người dùng tạo",
	   edit_log:"Chỉnh sửa nhật ký",
	   field_name:"Tên hiện trường",
	   old_value:"Giá trị cũ",
	   new_value:"Giá trị mới",
	   date_time_update:"Cập nhật ngày/giờ",
	   updater:"Cập nhật",
	   add_edit_academic_records:"Thêm/chỉnh sửa hồ sơ học tập",
	   select_flag:"Chọn cờ ...",
	   edit_all_tranferred_grades:"Chỉnh sửa tất cả các lớp được cấp phép",
	   save_records:"Lưu hồ sơ",
	   possible_credits:"Tín dụng có thể",
	   select_level:"Chọn cấp độ",
	   select_grade_level:"Chọn cấp lớp",
	   select_status:"Chọn trạng thái",
	   add_more_row:"Thêm nhiều hàng",
	   full_screen:"Toàn màn hình",
	   add_order_grades:"Add Other Grades",
	   course_code:"Thêm các lớp khác",
	   add_order_grades:"Mã khóa học",
	   select_credit:"Chọn tín dụng",
	   select_default:"Chọn mặc định",
	   credits_possible:"Tín dụng có thể",
	   select_possible_credit:"Chọn tín dụng có thể",
	   product:"Sản phẩm",
	   fromn:"Từ",
	   ton:"ĐẾN",
	   last_invoice_date:"Ngày hóa đơn cuối cùng",
	   please_select_stu:"Vui lòng chọn học sinh",
	   payer:"Người trả tiền",
	   amount_per_billing_period:"Số tiền trên mỗi thời gian thanh toán",
	   price_unit:"Đơn vị giá",
	   billing_period:"Thời gian thanh toán",
	   automatic_renewal:"tự động gia hạn",
	   automatic_payment:"Thanh toán tự động",
	   duration_of_period:"Thời lượng (# của các giai đoạn)",
	   payment_id:"ID thanh toán",
	   payment_date:"Ngày thanh toán",
	   payment_amount:"Số tiền thanh toán",
	   applied:"Áp dụng",
	   available:"Có sẵn",
	   unApply:"Không được áp dụng",
	   refund:"Đền bù",
	   add_new_teacher:"Thêm giáo viên mới",
	   change_teacher_status:"Thay đổi trạng thái giáo viên",
	   search_for_a_teacher_or_id:"Tìm kiếm một giáo viên hoặc ID",
	   flags:"Cờ",
	   tags:"Tags",
	   allowed:"Cho phép",
	   message_teacher:"Giáo viên tin nhắn",
	   impersonate_teacher:"Giáo viên mạo danh",
	   add_teacher_qualification:"Thêm trình độ giáo viên",
	   profile:"Hồ sơ",
	   teacher_schedule:"Lịch trình giáo viên",
	   qualifications:"Trình độ chuyên môn",
	   student_actions:"Hành động của sinh viên",
	   linking_parents_to:"Liên kết cha mẹ với",
	   select_do:"Lựa chọn ...",
	   see_edit_logs:"Xem Nhật ký chỉnh sửa",
	   see_qualifications:"Xem trình độ",
	   link_academic_advisor:"Liên kết cố vấn học tập",
	   student_success:"Thành công của sinh viên",
	   linking_academic_advisor_or_student_success:"Liên kết cố vấn học tập / thành công của sinh viên với",
	   staff:"Nhân viên",
	   teacher_status:"Tình trạng giáo viên",
	   school_admin_status:"Tình trạng quản trị trường học",
	   global_user_directory:"Thư mục người dùng toàn cầu",
	   edit_teacher:"Chỉnh sửa giáo viên",
	   contracted:"Ký hợp đồng",
	   add_comments_and_documents:"Nhận xét và tài liệu",
	   edit_comments_and_documents:"Chỉnh sửa nhận xét và tài liệu",
	   parents_or_mentor:"Cha mẹ / người cố vấn",
	   send_mail:"Gửi thư",
	   are_you_sure_to_delete_this_teacher:"Bạn chắc chắn sẽ xóa giáo viên này.",
	   edit_user_password:"Chỉnh sửa tên người dùng & mật khẩu",
	   add_qualifications:"Thêm trình độ",
	   please_select_a_least_on_teacher:"Vui lòng chọn ít nhất một giáo viên.",
	   edit_parent_mentor:"Chỉnh sửa phụ huynh / người cố vấn",
	   parent_mentor_information:"Thông tin phụ huynh / người cố vấn",
	   send:"Gửi",
	   are_you_surse_to_delete_this_parent:"Bạn có chắc chắn xóa cha mẹ này.",
	   home:"Trang chủ",
	   
	   //auto_promotion:"Khuyến mãi tự động",
	   auto_promotion:"Chương trình khuyến mãi cấp lớp học sinh",
	   Promote:"Khuyến khích",
	   search_for_a_name:"Tìm kiếm một tên…",
	   download_to_excel:"Tải xuống Excel",
	   download_to_pdf:"Tải xuống PDF",
	   User_ID:"Tên người dùng",
	   User_type:"Loại người dùng",
	   communication_log:"Nhật ký giao tiếp",
	   Student_Status:"Tình trạng sinh viên",
	   Users:"Người dùng",
	   Staff_Reassignment:"Nhân viên chỉ định lại",
	   Select_Staff:"Chọn nhân viên",
	   select_asset_type_to_reassign:"Chọn loại tài sản để gán lại",
	   transfer_all_to:"Chuyển tất cả sang",
	   transfer_selectively:"Chuyển giao một cách chọn lọc",
	   remove_all:"Bỏ hết",
	   remove_selectively:"Loại bỏ chọn lọc",
	   Event:"Sự kiện",
	   Time:"Thời gian",
	   Participants:"Những người tham gia",
	   new_staff:"Nhân viên mới",
	   Remove:"Xoá",
	   Profile_Page:"Trang hồ sơ",
	   settings:"Cài đặt",
	   security:"Bảo vệ",
	   timezone:"Múi giờ",
	   notifications:"Thông báo",
	   check_for_feature_availability_at_your_school:"Kiểm tra tính năng có sẵn tại trường của bạn.",
	   current_password:"Mật khẩu hiện tại",
	   new_password:"mật khẩu mới",
	   confirm_password:"Xác nhận mật khẩu",
	   updte_password:"Cập nhật mật khẩu",
	   change_timezone:"Thay đổi múi giờ",
	   time_zone:"Múi giờ",
	   please_select_time_zone:"Vui lòng chọn múi giờ",
	   notification_settings:"Thiết lập thông báo",
	   level_of_urgency:"Mức độ cấp bách",
	   email_destination:"Điểm đến email",
	   SMS_Destination:"Điểm đến SMS",
	   app:"Ứng dụng",
	   please_select_level_of_urgency:"Vui lòng chọn mức độ khẩn cấp",	  
	   reset_filters:"Đặt lại bộ lọc",
	   batch_data_update:"Cập nhật dữ liệu của sinh viên",
	   contract_template:"Mẫu hợp đồng",
	   accept:"Chấp nhận",
	   reject:"Từ chối",
	   view_roles:"Xem vai trò",
	   administrator_information:"Thông tin quản trị viên", 
	   account_reation_date:"Ngày tạo tài khoản", 
	   expiration_date:"Ngày hết hạn", 
	   schools:"Trường học", 
	   advisees:"Tư vấn",
	   message:"Tin nhắn",
	   see_comments_and_documents:"Xem nhận xét và tài liệu",
	   restore_APEX_Classrooms:"Khôi phục các lớp học Apex",
	   teacher_information:"Thông tin giáo viên", 
	   teacher_number:"Số giáo viên", 
	   departmens:"Khởi hành", 
	   global_capacity:"Năng lực toàn cầu", 
	   local_contracted_load:"Tải hợp đồng địa phương", 
	   parents:"Cha mẹ", 
	   parent_information:"Thông tin phụ huynh", 
	   linked_students:"Sinh viên liên kết", 
	   link_student:"Liên kết sinh viên", 
	   unlink_student:"Không liên kết sinh viên", 
	   search_dot:"Tìm kiếm…", 
	   view_local:"Xem địa phương", 
	   view_global:"Xem toàn cầu",
	   resource:"Nguồn",
	   current_grade:"Lớp hiện tại", 
	   affiliation:"Liên kết", 
	   current_assignment:"Chuyển nhượng hiện thời", 
	   total_assignments:"Tổng số bài tập", 
	   percent_completed:"Phần trăm hoàn thành",
	   semester:"học kỳ",
	   graduation_year:"năm tốt nghiệp", 
	   student_name:"Tín dụng kiếm được", 
	   credits_earned:"Tín dụng kiếm được",
	   exit:"lối ra",
	   engagement_type:"Loại tham gia",
	   college_admitted:"Đại học thừa nhận", 
	   college_attending:"Đại học theo học", 
	   major:"Lớn lao", 
	   report_card:"Thẻ báo cáo", 
	   academic_term:"Học thuật", 
	   show_average:"Hiển thị trung bình",
	   school_information:"Thông tin trường học",
	   school_misc_configuration:"Cấu hình trường học trường học", 
	   school_tags:"Thẻ trường", 
	   role_tags:"Thẻ vai trò", 
	   content_integration:"Tích hợp nội dung", 
	   user_roles:"Vai trò người dùng", 
	   communication_user_rules:"Quy tắc người dùng giao tiếp", 
	   school_administrators:"Quản trị viên trường học", 
	   school_year_configuration:"Cấu hình năm học", 
	   A_R_payment_configuration:"Cấu hình thanh toán A/R", 
	   facility:"Cơ sở", 
	   enrollment_rules:"Quy tắc tuyển sinh", 
	   student_contract_rules:"Quy tắc hợp đồng của sinh viên", 
	   products:"Các sản phẩm", 
	   notification_templates:"Mẫu thông báo", 
	   transcript_viewer_options:"Tùy chọn Trình xem bảng điểm", 
	   feature_configuration:"Cấu hình tính năng", 
	   feature_settings:"Cài đặt tính năng", 
	   communication_rules:"Quy tắc giao tiếp", 
	   object_state:"Trạng thái đối tượng", 
	   departments:"Phòng ban", 
	   grading_scales:"Thang điểm", 
	   grading_periods:"Thời gian chấm điểm", 
	   academic_tracks:"Bài hát học thuật", 
	   learning_path_templates:"Các mẫu đường dẫn học tập", 
	   grade_book_activity_descriptions:"Mô tả hoạt động sổ sách lớp", 
	   academic_terms:"Thuật ngữ học thuật",
	   academic_system:"Hệ thống học thuật",
	   address_line_1:"Dòng địa chỉ 1", 
	   country_code:"Mã quốc gia", 
	   address_line_2:"Địa chỉ 2", 
	   school_title:"Tiêu đề trường học",
	   CEEB_code:"Mã CEEB", 
	   zip_postal_code:"Mã zip/bưu chính", 
	   state_province:"Tiểu bang/Tỉnh", 
	   website:"Trang mạng", 
	   subdomain:"Tên miền phụ", 
	   success_manager:"Quản lý thành công", 
	   school_logo:"Biểu tượng của trường học", 
	   digital_seal:"Con dấu kỹ thuật số",
	   password_exception_rule:"Quy tắc ngoại lệ mật khẩu",
	   change_password_first_login:"Thay đổi mật khẩu đăng nhập đầu tiên", 
	   password_expires_after_days:"Mật khẩu hết hạn sau nhiều ngày", 
	   enforcement_of_teachers_load:"Thực thi tải của giáo viên", 
	   in_house_handling_of_transcript_requests:"Trong việc xử lý nhà của các yêu cầu bảng điểm", 
	   display_mobile_app_link:"Hiển thị liên kết ứng dụng di động", 
	   display_weekly_progress_goal:"Hiển thị mục tiêu tiến độ hàng tuần", 
	   turn_on_notification:"Bật thông báo", 
	   classic_letter:"Thư cổ điển", 
	   automatic_parent_account_creation:"Tạo tài khoản phụ huynh tự động", 
	   default_parent_account_status:"Trạng thái tài khoản cha mẹ mặc định", 
	   default_time_zone:"Múi giờ mặc định", 
	   link_to_transcript_vendor_help:"Liên kết đến Trợ giúp nhà cung cấp bảng điểm", 
	   link_to_transcript_vendor:"Liên kết đến nhà cung cấp bảng điểm", 
	   link_for_help_system:"Liên kết cho hệ thống trợ giúp", 
	   student_enrollment_limit:"Giới hạn tuyển sinh của sinh viên", 
	   default_section_type:"Loại phần mặc định", 
	   default_section_capacity:"Công suất phần mặc định",
	   transcript_template:"Mẫu bảng điểm",
	   edit_security_school_tags:"Chỉnh sửa thẻ trường bảo mật", 
	   security_school_tags:"Thẻ trường bảo mật",
	   tags_name:"Tên thẻ", 
	   edit_role_tags:"Chỉnh sửa thẻ vai trò",
	   add_school_based_tags:"Thêm thẻ dựa trên trường học", 
	   description:"Sự miêu tả", 
	   applied_to_roles:"Áp dụng cho các vai trò", 
	   teacher:"Giáo viên",
	   edit_security_role_tags_for:"Chỉnh sửa thẻ vai trò bảo mật cho",
	   school_admins:"Quản trị viên trường học",
	   school_begin_date:"Ngày bắt đầu trường học", 
	   school_end_date:"Ngày kết thúc trường học", 
	   automatic_control_of_teacher_s_load:"Kiểm soát tự động tải của giáo viên",
	   A_R_payment_gateway_configuration:"Cấu hình cổng thanh toán A/R", 
	   payment_processing_vendor:"Nhà cung cấp xử lý thanh toán", 
	   secret_key:"Chìa khoá bí mật", 
	   publishable_key:"Khóa có thể xuất bản", 
	   account_id:"ID tài khoản",
	   updating_tudents:"Cập nhật học sinh", 
	   delete_selected_records:"Xóa các bản ghi đã chọn",
	   attribute_name:"Tên thuộc tính", 
	   applied_for:"Áp dụng cho",
	   add_school:"Thêm trường học", 
	   overview:"Tổng quan", 
	   search_for_school:"Tìm kiếm trường học…", 
	   search_for_student:"Tìm kiếm sinh viên…",
	   attribute_type:"Loại thuộc tính", 
	   select_school_group:"Chọn nhóm trường", 
	   access_rights:"Quyền truy cập", 
	   create:"Tạo nên", 
	   read:"Đọc",
	   facility_management:"Quản lý cơ sở", 
	   facility_name:"Tên cơ sở", 
	   capacity:"Dung tích",
	   enrollment_allowance_period_days:"Thời gian phụ cấp đăng ký (ngày)", 
	   maximum_enrollment_duration_days:"Thời lượng đăng ký tối đa (ngày)", 
	   start_date_of_the_week:"Ngày bắt đầu trong tuần", 
	   end_date_of_the_week:"Ngày kết thúc trong tuần",
	   lookup_name:"Tên tra cứu", 
	   duration:"Khoảng thời gian", 
	   time_unit:"Đơn vị thời gian", 
	   round_up_to_end_of_time_unit:"Làm tròn đến cuối đơn vị thời gian",
	   product_name:"tên sản phẩm",
	   product_ID:"ID sản phẩm", 
	   price_offer:"Mời giá", 
	   price:"Giá", 
	   frequency:"Tính thường xuyên", 
	   effective_from:"Có hiệu lực từ", 
	   effective_to:"Hiệu quả để", 
	   active:"Tích cực",
	   drag_drop_to_text_cursor_in_content:"Kéo và thả vào văn bản con trỏ trong nội dung", 
	   event_type:"Loại sự kiện", 
	   notification_rule:"Quy tắc thông báo", 
	   level_or_ugency:"Cấp độ hoặc sự Ugency", 
	   user_role:"Vai trò người dùng",
	   edit_security_user_tags:"Chỉnh sửa thẻ người dùng bảo mật",
	   content_access:"Truy cập nội dung", 
	   content_access_for:"Truy cập nội dung cho", 
	   add_new_access:"Thêm quyền truy cập mới", 
	   date_assigned:"Ngày được chỉ định",
	   enrollment_request:"Ngày được chỉ định", 
	   enrollment_request_for:"Yêu cầu đăng ký", 
	   mentors:"Cố vấn",
	   options:"Tùy chọn",
	   department_name:"Tên bộ phận", 
	   universal_department:"Cục phổ quát", 
	   open:"Mở",
	   min_point:"Điểm tối thiểu", 
	   max_point:"Điểm tối đa", 
	   grade_point:"Lớp điểm", 
	   honors:"Danh dự", 
	   college:"Trường cao đẳng",
	   order:"Đặt hàng", 
	   start_time:"Thời gian bắt đầu", 
	   end_time:"Thời gian kết thúc",
	   period_name:"Tên thời kỳ",
	   grading_periods_head:"Trưởng thời kỳ chấm điểm",
	   grading_period:"Thời gian chấm điểm", 
	   weight:"Cân nặng",
	   track_name:"Tên bài hát",
	   academic_track_requirement:"Yêu cầu theo dõi học tập", 
	   of_required_credits:"# của các khoản tín dụng cần thiết",
	   individual_learning_plan_template:"Mẫu kế hoạch học tập cá nhân",
	   ILP_name:"Tên ILP",
	   remove_requirement:"Loại bỏ yêu cầu", 
	   reset_requirement:"Đặt lại yêu cầu", 
	   add_requirement:"Thêm yêu cầu",
	   must_end_date:"Phải kết thúc ngày", 
	   courses_open_date:"Các khóa học mở ngày", 
	   signup_end_date:"Đăng ký ngày kết thúc", 
	   signup_start_date:"Ngày bắt đầu đăng ký", 
	   section_period:"Phần thời gian",
	   
	    weeks:"Tuần", 
	   search_for_a_section_or_id:"Tìm kiếm một phần hoặc ID",
	   search_for_a_deft:"Tìm kiếm một phòng", 
	   launch_course:"Khóa học khởi động", 
	   start_class:"Bắt đầu lớp học", 	   
	   weekly_progress_goal:"Mục tiêu tiến bộ hàng tuần", 
	   send_message_to_all_section_students:"Gửi tin nhắn cho tất cả các sinh viên", 
	   monitor_live_sessions:"Giám sát các phiên trực tiếp", 
	   average_section_grade:"Lớp trung bình", 
	   resources:"Tài nguyên", 
	   activities:"các hoạt động", 	   
	   course_attendance_today:"Tham dự khóa học hôm nay", 
	   staffs:"Nhân viên", 
	   units:"Các đơn vị", 	   
	   view_all_15_resources:"Xem tất cả 15 tài nguyên", 
	   Class_discussions:"Thảo luận lớp học", 
	   recent_discussions:"Các cuộc thảo luận gần đây", 
	   go_to_class_discussions:"Đi đến lớp thảo luận", 	   
	   show_my_class_attendance:"Hiển thị sự tham dự lớp học của tôi", 
	   add_section:"Thêm phần",
	   add_global_section:"Thêm phần toàn cầu",
	   close_section:"Đóng các phần",
	   open_section:"Mở các phần",
	   batch_upload:"Tải lên hàng loạt",
	   finalize:"Hoàn thiện",	   
	   add_tearcger:"Thêm (các) giáo viên",
	   remove_tearcger:"Xóa (các) Giáo viên",
	   uploadSectionStatusUpdates:"Cập nhật trạng thái phần tải lên",
	   status_count:"Số lượng trạng thái",	   
	   reactivate:"Kích hoạt lại",
	   clone:"Dòng vô tính",
	   enroll_into_Section:"Đăng ký vào Mục",
	   bulk_enrollment:"Đăng ký số lượng lớn",
	   general_Information:"Thông tin chung",	   
	   online_content_source:"Nguồn nội dung trực tuyến",
	   second_teacher:"Giáo viên thứ hai",
	   today:"hôm nay",
	   calendar:"Lịch",
	   week:"tuần",
	   month:"Tháng",
	   section_progress:"Phần tiến độ",
	   complete:"hoàn thành",	   
	   section_title:"Mục tiêu đề",
	   enter_section_title:"Nhập tiêu đề phần",
	   select_teacher:"Chọn giáo viên",	   
	   select_weeks:"Chọn tuần",
		select_credits:"Chọn các khoản tín dụng",
	   select_type:"Lựa chọn đối tượng",
	   global_section:"Phần toàn cầu",	   
	   enrollment_capacity:"Năng lực tuyển sinh",
	   enter_enrollment_capacity:"Nhập khả năng ghi danh",
	   in_class_information:"Trong Thông Tin Lớp Học",
	   Start:"Bắt đầu",
	   End:"Kết thúc",
	   recurrencePattern:"Mô hình phát sinh",
	   recurrenceFrequency:"Tần suất lặp lại",
	   Weekly:"Hàng tuần",
	   Monthly:"Hàng tháng",
	   Recur_every:"Tái diễn mỗi",
	   Weeks_on:"Tuần trên",
	   day_of_week:"Ngày trong tuần",
	   daily_period:"Thời gian hàng ngày",
	   select_daily_period:"Chọn khoảng thời gian hàng ngày",
	   Day:"Ngày",
	   The:"Các",
	   of_every:"của mọi",
	   month_s:"tháng",
	   add:"Thêm",	   
	   course_prequisites :"Điều kiện tiên quyết của khóa học",
	   select_status:"Chọn trạng thái",
	   select_school:"Chọn trường",	   
	   select_period:"Chọn khoảng thời gian",
	    room_number:"Số phòng",
	   select_room_number:"Chọn Số phòng",
	   Service:"Dịch vụ",
	   enter_url:"Nhập Url",
	   edit_section:"Chỉnh sửa phần",
	   activity_templates:"Mẫu hoạt động",
	   select_activity_templates:"Chọn mẫu hoạt động",
	   link_section:"Phần liên kết",
	   select_link_section:"Chọn phần liên kết",
	   please_select_sections:"Vui lòng chọn các phần.",
	   if_you_change_your_status_of_inactivity:"Nếu bạn thay đổi trạng thái không hoạt động, học sinh sẽ bị ảnh hưởng.",
	   closing_the_global_section_will_cause:"Việc đóng phần toàn cầu sẽ khiến tất cả các trường học phải đóng cửa và tất cả học sinh trong đó phải rút lui. Vui lòng nhấp vào Xác nhận nếu bạn muốn tiếp tục.",
	   upload_import_data:"Tải lên & Nhập dữ liệu",	   
	   here:"Nơi đây",
	   no_data_avalable_in_table:"không có dữ liệu trong bảng",
	   add_teacher_to_multiple_section:"Thêm Giáo viên (S) vào Nhiều Phần",
	   select_teachers_to_add_to_multiple_section:"Chọn giáo viên để thêm vào nhiều lựa chọn",
	   selected:"Đã chọn",
	   selected_all:"Chọn tất cả",
	   deselected_all:"Bỏ chọn tất cả",
	   remove_teacher_from_multiple_section:"Xóa (Các) Giáo viên khỏi Nhiều Phần",
	   select_teacher_to_remove_to:"Chọn giáo viên để loại bỏ nhiều lựa chọn",
	   process_removal:"Quá trình loại bỏ",	   
	   clone_section:"Phần nhân bản",
	   enroll_student:"ghi danh sinh viên",
	   enroll_student_to:"Đăng ký học sinh",
	   name:"Tên",
	   search_for_a_student_or_id:"Tìm kiếm một sinh viên hoặc ID ...",
	   confirmation_of_enrollment:"XÁC NHẬN GHI DANH",
	   please_review_and_confirm_enrollments_for:"Vui lòng xem xét và xác nhận đăng ký cho",
	   confirm:"Xác nhận",
	   enroll_students_to_section:"GHI DANH HỌC SINH VÀO PHẦN",
	   enrollment_period:"Thời gian tuyển sinh",
	   days:"ngày",
	   no_data_avalible:"Không có dữ liệu.",
	   number_of_primary_teacher:"Số giáo viên tiểu học",
	   secondary_teachers:"Giáo viên thứ hai",
	   department_head:"Trưởng khoa",
	   section_enroll:"Mục Ghi danh",
	   load_from_file:"Tải từ tệp",
	   see_sections:"Xem các phần",
	   change_enrollment_status:"Thay đổi trạng thái đăng ký",
	   mentor_s:"Người cố vấn",
	   overdue_activities:"Hoạt động quá hạn",
	   total_session_time_and_last_log:"Tổng thời gian phiên và nhật ký cuối cùng",
	   course_name_on_transcript:"Tên khóa học trên bảng điểm",
	   edit_other_grades:"Chỉnh sửa các lớp khác",
	   save_as:"Lưu thành",
	   account_receivable_dashboard:"Bảng điều khiển phải thu tài khoản",
	   key_performance_indicators:"Chỉ số hiệu suất chính",
	   a_r_dashboard:"Bảng điều khiển A/R",
	   payments_credits:"Thanh toán/Tín dụng",
	   contract_templates:"Mẫu hợp đồng",
	   master_contracts:"Hợp đồng chính",
	   a_r_configuration:"Cấu hình A/R",
	   a_r_processing:"Xử lý A/R",
	   aging:"Sự lão hóa",
	   receivable:"Phải thu",
	   account_receivable_by_program:"Tài khoản phải thu theo chương trình",
	   request_detail:"Yêu cầu chi tiết",
	    request_information:"Yêu cầu thông tin",
	    requested_by:"Được yêu cầu bởi",
	    approved_by:"Được chấp nhận bởi",
	    approve:"Chấp thuận",
	    phone_name:"Tên điện thoại",
	    phone_carrier:"Hãng điện thoại",
		area_code:"Mã vùng",
	   address_lable:"Địa chỉ Lable",
	   address_default:"Địa chỉ mặc định",
	   new_photo:"Ảnh mơi",
	   current_of_wweeks:"# Tuần hiện tại",
	   select_enrollment_period:"Chọn thời gian đăng ký",
	   enter_rejection_reason:"Nhập lý do từ chối ...",
	   comments_and_documents:"Nhận xét & tài liệu",
	   enrollment_history:"Lịch sử tuyển sinh",
	   request_extension_for:"Yêu cầu mở rộng cho",
	   extended_of_weeks:"Kéo dài # tuần",
	   current_enrollment_status:"Tình trạng đăng ký hiện tại",
	   select_extension_option:"Chọn tùy chọn tiện ích mở rộng",
	   extend_current_enrollment_until:"Mở rộng đăng ký hiện tại cho đến khi",
	   transfer_to_new_section:"Chuyển sang phần mới",
	   transcript_requests:"Yêu cầu bảng điểm",
	   person_requesting_transcript:"Người yêu cầu bảng điểm",
	   telephone_number:"Số điện thoại",
	   number_of_copies:"Số bản sao",
	   special_instructions:"Hướng dẫn đặc biệt",
	   last_school_attendance:"Đi học cuối cùng",
	   year_last_attended:"Năm cuối cùng tham dự",
	   current_address:"Địa chỉ hiện tại",
	   relationship_to_student:"Mối quan hệ với học sinh",
	   method_of_delivery:"Phương thức vận chuyển",
	   instructions:"*Hướng dẫn",
	   previous_requests:"Yêu cầu trước",
	   additional_info:"Thông tin bổ sung",
	   receive:"Nhận được",
	   process:"Quá trình",
	   add_to_school_group:"Thêm vào nhóm trường",
	   submit_romote:"Gửi quảng cáo",
	   next_grade_level:"Lớp tiếp theo",
	   please_select_a_school_for_promotion_and_transfer:"Vui lòng chọn một trường để thăng chức và chuyển nhượng",
	   write_off:"Viết ra",
	   amount_due:"Số tiền đến hạn",
	   open_amount:"Lượng mở",
	   payment_application:"Ứng dụng thanh toán",
	   use_credit_openBalance:"Sử dụng tín dụng $ 111",
	   payment_amount_usd:"Số tiền thanh toán (USD)",
	   check_number:"Kiểm tra số",
	   confirmation_number:"Số xác nhận",
	   apply_payment:"Áp dụng thanh toán",
	   amount_paid:"Số tiền đã trả",
	   applied_payment:"Thanh toán được áp dụng",
	   payer_id:"ID người trả tiền",
	   view_detail:"xem chi tiết",
	   master_contract:"Hợp đồng chính",
	   copy:"Sao chép",
	   contract_user_detail:"Hợp đồng chi tiết người dùng",
	   follow_product_cost:"Theo dõi chi phí sản phẩm",
	   default_cost:"Chi phí mặc định",
	   offered_cost:"Cung cấp chi phí",
	   contract_detail:"Hợp đồng chi tiết",
	   contract_template_name:"Tên mẫu hợp đồng",
	    master_contract_name:"Tên hợp đồng chính",
		 view_students:"Xem học sinh",
		 make_payment:"Thanh toán",
		 parent_page:"Trang cha mẹ",
		 edit_parent:"Chỉnh sửa cha mẹ",
		 edit_profile:"Chỉnh sửa hồ sơ",
		 account_receivable_configuration:"Cấu hình phải thu tài khoản",
		 invoice_generation_date:"Ngày tạo hóa đơn", 
	   invoice_generation:"Tạo hóa đơn", 
	   number_of_days_until_due_date:"Số ngày cho đến ngày đáo hạn",
	   account_receivable_processing:"Tài khoản xử lý phải thu",
	   generate_invoices:"Tạo hóa đơn", 
	   process_automatic_payments:"Quá trình thanh toán tự động", 
	   send_late_notices:"Gửi thông báo muộn",
	   course:"Khóa học", 
	   copy_courses:"Sao chép các khóa học", 
	   copy_to_school:"Sao chép vào trường", 
	   originating_program_code:"Mã chương trình khởi tạo", 
	   destinating_program_code:"Định mệnh mã chương trình", 
	   status_error:"Trạng thái/lỗi",
	   add_prerequisite:"Thêm điều kiện tiên quyết", 
	   group_name:"Tên nhóm", 
	   enter_group_name:"Nhập tên nhóm", 
	   select_a_department_to_display_courses:"Chọn một bộ phận để hiển thị các khóa học", 
	   edit_tranferred_grades:"Chỉnh sửa các lớp khác", 
	   showing_num_records:"Hiển thị 000 hồ sơ",
	   edit_all_other_grades:"Chỉnh sửa tất cả các lớp khác",
	   upload_student_documents:"Tải lên tài liệu sinh viên",
	   select_an_official_transcript_option:"Chọn một tùy chọn bảng điểm chính thức", 
	   for_schools_or_personal_copy:"Đối với các trường học hoặc bản sao cá nhân", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Để sử dụng học sinh, gửi đến một trường khác hoặc để xác minh tuyển sinh.", 
	   request_official_transcript:"Yêu cầu bảng điểm chính thức", 
	   PARCHMENT_for_colleges_or_universities:"Giấy da cho các trường cao đẳng hoặc đại học", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Để nộp đơn vào một trường cao đẳng/đại học và để xác minh hoàn thành bằng tốt nghiệp của bạn.", 
	   request_transcript:"Yêu cầu bảng điểm", 
	   Learn_more_about_how_to_use_PARCHMENT:"Tìm hiểu thêm về cách sử dụng giấy da",
	   print_PDF:"In pdf",
	   user_school:"Trường người dùng",
	   filter:"Lọc",
	   GENERAL:"TỔNG QUAN", 
	   STUDENT_INFO:"Thông tin sinh viên", 
	   list:"Danh sách", 
	   last_school_name:"Tên trường cuối cùng", 
	   TEACHER_INFO:"Thông tin giáo viên", 
	   contracted_load:"Tải hợp đồng", 
	   ARENT_INFO:"Thông tin cha mẹ",
	   add_credential:"Thêm thông tin xác thực",
	   edit_credential:"Chỉnh sửa thông tin xác thực",
	   add_comment_document:"Thêm bình luận & tài liệu",
	   add_comment_document_for:"Thêm bình luận & tài liệu cho",
	   state_province:"Tiểu bang/ Tỉnh", 
	   post_code:"Mã bài viết", 
	   linking_students_to:"Liên kết sinh viên với", 
	   change_expiration_date:"Thay đổi ngày hết hạn", 
	   expiry_date:"Ngày hết hạn", 
	   please_select_department:"Vui lòng chọn bộ phận.", 
	   please_select_course:"Vui lòng chọn khóa học.", 
	   please_select_title:"Vui lòng nhập tiêu đề.", 
	   please_select_primary_teacher:"Vui lòng chọn giáo viên tiểu học.", 
	   please_select_weeks:"Vui lòng chọn tuần.", 
	   please_select_level:"Vui lòng chọn cấp độ.", 
	   please_select_credits:"Vui lòng chọn Tín dụng.", 
	   please_select_type:"Vui lòng chọn Loại.", 
	   please_select_daily_period:"Vui lòng chọn thời gian hàng ngày.",
	   please_enter_link_section:"Vui lòng nhập phần liên kết.",
	   please_enter_first_name:"Vui lòng nhập tên đầu tiên.", 
	   please_enter_last_name:"Vui lòng nhập họ.", 
	   please_enter_contracted:"Vui lòng nhập hợp đồng.", 
	   please_enter_email:"Vui lòng nhập email.", 
	   please_enter_phone:"Vui lòng nhập điện thoại.", 
	   please_enter_username:"Vui lòng nhập tên người dùng.",
	   please_enter_password:"Xin vui lòng nhập mật khẩu.", 
	   please_enter_status:"Vui lòng chọn trạng thái.", 
	   save_successful:"Lưu giữ thành công!.",
	   please_add_student_address:"Vui lòng thêm địa chỉ sinh viên.", 
	   please_enter_email_address:"Vui lòng nhập địa chỉ email.", 
	   please_select_relationship:"Vui lòng chọn mối quan hệ.", 
	   please_select_parent_status:"Vui lòng chọn trạng thái cha mẹ.", 
	   please_enter_label:"Vui lòng nhập nhãn.", 
	   please_enter_address:"Vui lòng nhập địa chỉ.", 
	   please_enter_city:"Vui lòng vào thành phố.", 
	   please_enter_state:"Vui lòng vào trạng thái.", 
	   please_enter_zip_code:"Vui lòng nhập mã zip.", 
	   please_select_date_of_birth:"Vui lòng chọn ngày sinh.", 
	   please_select_track:"Vui lòng chọn Track.", 
	   please_enter_graduation_date:"Vui lòng nhập ngày tốt nghiệp.", 
	   please_enter_country:"Vui lòng vào quốc gia.", 
	   please_enter_phone_number:"Vui lòng nhập số điện thoại.", 
	    please_enter_parent_first_name:"Vui lòng nhập tên cha mẹ.", 
	   please_enter_parent_last_name:"Vui lòng nhập họ của cha mẹ.", 
	   please_enter_parent_email_address:"Vui lòng nhập địa chỉ email của phụ huynh.", 
	   please_enter_parent_username:"Vui lòng nhập tên người dùng cha mẹ.", 
	   please_select_parent_relationship:"Vui lòng chọn mối quan hệ cha mẹ.", 
	   please_enter_phone_label:"Vui lòng nhập nhãn điện thoại.", 
	   student_address_canot_be_empty:"Địa chỉ sinh viên không thể trống.", 
	   please_select_document_type:"Vui lòng chọn loại tài liệu.", 
	   please_enter_new_type:"Vui lòng nhập loại mới.", 
	   please_enter_comment:"Vui lòng nhập bình luận.", 
	   link_is_not_a_valid_url:"Liên kết không phải là một URL hợp lệ.",
	   please_enter_link_and_label:"Vui lòng nhập liên kết và nhãn.",
	   are_you_sure_to_delete_this_student:"Bạn chắc chắn sẽ xóa học sinh này.",
	   please_select_gender:"Vui lòng chọn giới tính.",
	   school_contracted_load:"Trường học ký hợp đồng", 
	   global_contracted_load:"Tải hợp đồng toàn cầu",
	   please_enter_label_for_attachments:"Vui lòng nhập nhãn để biết tệp đính kèm.",
	   please_select_section:"Vui lòng chọn phần.", 
	   enrollment_completed_successfully:"Ghi danh hoàn thành thành công.",
	   delete_this_comment:"Xóa bình luận này?",
	   please_enter_course_name:"Vui lòng nhập tên khóa học.", 
	   please_select_credits_possible:"Vui lòng chọn các khoản tín dụng có thể.",
	   can_save_record:"Không thể lưu bản ghi:",
	   are_you_sure_to_delete_this_tranferred_grade:"Bạn có chắc chắn xóa lớp học này không?",
	   are_you_sure_to_delete_num_tranferred_grade:"Bạn có chắc chắn xóa 11 lớp được tranferred?", 
	   please_select_tranferred_grade:"Vui lòng chọn lớp Tranferred.",
	   please_ente_subject:"Vui lòng nhập chủ đề.", 
	   please_select_made_to:"Vui lòng chọn làm cho.", 
	   delete_this_communication:"Xóa giao tiếp này?",
	   please_select_school:"Vui lòng chọn trường.",
	   please_enter_name:"Vui lòng nhập tên.",
	   please_enter_group_name:"Vui lòng nhập tên nhóm.",
	   you_have_some_form_errors_please_check_above:"Bạn có một số lỗi hình thức. Vui lòng kiểm tra ở trên.",
	   please_select_recipient:"Vui lòng chọn người nhận.", 
	   please_enter_description:"Vui lòng nhập mô tả.",
	   delete_this_resource:"Xóa tài nguyên này?",
	   please_enter_activity_name:"Vui lòng nhập tên hoạt động.", 
	   please_select_activity_type:"Vui lòng chọn loại hoạt động.", 
	   please_enter_max_score:"Vui lòng nhập điểm tối đa.", 
	   please_enter_due_date:"Vui lòng nhập ngày đáo hạn.",
	   please_enter_unit_name:"Vui lòng nhập tên đơn vị.",
	   are_you_sure_to_clear_this_unit:"Bạn có chắc chắn để xóa đơn vị này?",
	   please_enter_score:"Vui lòng nhập điểm.",
	   delete_this_credential:"Xóa thông tin này?",
	   plase_select_period:"Vui lòng chọn thời gian", 
	   plase_select_start_date:"Vui lòng chọn Ngày bắt đầu", 
	   plase_select_end_date:"Vui lòng chọn ngày kết thúc",
	   select_to_register_course_to_students_individual_learning_path_view:"Chọn để đăng ký khóa học cho sinh viên Chế độ xem đường dẫn học tập cá nhân",
	   delete_this_request:"Xóa yêu cầu này?",
	   please_enter_fname:"Vui lòng nhập tên.", 
	   please_enter_lname:"Vui lòng nhập họ.", 
	   please_enter_birthday:"Vui lòng nhập sinh nhật.", 
	   please_enter_address:"Vui lòng nhập địa chỉ.", 
	   please_enter_zip:"Vui lòng nhập zip.", 
	   please_enter_country:"Vui lòng vào quốc gia.", 
	   please_enter_ethnicity:"Vui lòng nhập dân tộc.", 
	   please_enter_grade:"Vui lòng vào lớp.", 
	   please_enter_mobile:"Vui lòng nhập điện thoại di động.", 
	   please_enter_hear_about_us:"Vui lòng nhập nghe về chúng tôi.", 
	   please_enter_program_of_interest:"Vui lòng tham gia chương trình quan tâm.", 
	   please_enter_course_level:"Vui lòng vào cấp độ khóa học.", 
	   please_enter_guardian_1_name:"Vui lòng nhập tên Guardian 1.", 
	   please_enter_guardian_1_email:"Vui lòng nhập email Guardian 1.", 
	   please_enter_guardian_1_home_phone:"Vui lòng nhập Điện thoại Home Guardian 1.", 
	   please_enter_guardian_1_relation:"Vui lòng nhập mối quan hệ Guardian 1.",
	   please_select_parents:"Vui lòng chọn cha mẹ.",
	   transfer_classroom:"Chuyển lớp học", 
	   please_choose_one_section_to_transfer:"Vui lòng chọn một phần để chuyển.", 
	   transfer:"Chuyển khoản",
	   assigning_multiple_users_to_a_school_or_school_group:"Chỉ định nhiều người dùng cho một trường học hoặc nhóm trường học", 
	   add_to_school_or_school_group:"Thêm vào trường học hoặc nhóm trường học", 
	   please_select_school_or_school_group:"Vui lòng chọn trường học hoặc nhóm trường.",
	   print_student_progress_report:"In Báo cáo tiến độ của sinh viên",
 },
 hi:{
	   reporting_center:"रिपोर्टिंग केंद्र", 
	   grade_reports:"ग्रेड रिपोर्ट", 
	   user_reports:"उपयोगकर्ता रिपोर्ट", 
	   learning_reports:"सीखने की रिपोर्ट", 
	   administrative_reports:"प्रशासनिक रिपोर्टें", 
	   progress_report:"प्रगति रिपोर्ट", 
	   full_progress_report:"पूर्ण प्रगति रिपोर्ट", 
	   grade_report:"ग्रेड रिपोर्ट", 
	   roster_report:"रोस्टर रिपोर्ट", 
	   parent_report:"अभिभावक रिपोर्ट", 
	   teacher_report:"शिक्षक रिपोर्ट", 
	   student_report:"छात्र रिपोर्ट", 
	   log_in_report:"रिपोर्ट में लॉग इन करें", 
	   enrollmentreport:"नामांकन रिपोर्ट", 
	   enrollment_summary:"नामांकन सारांश", 
	   student_enrollment_summary:"छात्र नामांकन सारांश", 
	   attendance_report:"उपस्थिति विवरण", 
	   attendance_summary_report:"उपस्थिति सारांश रिपोर्ट", 
	   log_In_Credentials:"लॉग इन प्रमाण - पत्र", 
	   application_report:"अनुप्रयोग रिपोर्ट", 
	   section_report:"अनुभाग रिपोर्ट", 
	   course_report:"पाठ्यक्रम रिपोर्ट", 
	   communication_summary:"संचार सारांश", 
	   comments_and_Document_Report:"टिप्पणियाँ और दस्तावेज़ रिपोर्ट", 
	   School_Calendar:"विद्यालय का कैलेंडर", 
	   bell_Schedule:"घंटा", 
	   student_Contract:"छात्र संविदा",
	   eOS_Report:"ईओएस रिपोर्ट", 
	   active_Enrollments_Per_Term_Report:"प्रति टर्म रिपोर्ट सक्रिय नामांकन", 
	   active_Student_Enrollments_with_As_Report:"रिपोर्ट के साथ सक्रिय छात्र नामांकन", 
	   active_Student_Enrollments_Report:"सक्रिय छात्र नामांकन रिपोर्ट", 
	   all_Students_GPA_Report:"सभी छात्र GPA रिपोर्ट", 
	   old_All_Student_GPA_Report:"पुरानी सभी छात्र GPA रिपोर्ट", 
	   billingGroup_Engagement_Type_Report:"बिलिंगग्रुप + सगाई प्रकार की रिपोर्ट", 
	   enrollment_Confirmation_Report:"नामांकन पुष्टिकरण रिपोर्ट", 
	   eOS_College_Matriculations_Report:"ईओएस कॉलेज मैट्रिकुलेशन रिपोर्ट", 
	   student_Enrollment_History_To_Date_w_Term_Report:"छात्र नामांकन इतिहास डब्ल्यू टर्म रिपोर्ट के लिए",
	   student_Information_Report:"छात्र सूचना रिपोर्ट", 
	   ran_by:"के द्वारा भागना",
	   Show_Filter:"फ़िल्टर दिखाएं", 
	   School_Group:"स्कूल -समूह", 
	   school:"विद्यालय", 
	   department:"विभाग", 
	   student:"विद्यार्थी", 
	   student_status:"स्टूडेंट दर्जा", 
	   course:"अवधि", 
	   course_level:"पाठ्यक्रम स्तर", 
	   section:"अनुभाग", 
	   teacher:"अध्यापक", 
	   primary_teacher:"प्राथमिक अध्यापक", 
	   secondary_teacher:"द्वितीयक शिक्षक", 
	   completion_Date_Range:"समापन दिनांक सीमा", 
	   from_date:"की तिथि से", 
	   to_date:"तारीख तक", 
	   status:"दर्जा", 
	   gender:"लिंग", 
	   final_grade:"अंतिम अंक", 
	   advisor:"सलाहकार", 
	   grade_level:"क्रम स्तर", 
	   specific_mark:"विशिष्ट चिह्न", 
	   track:"रास्ता", 
	   ethnicity:"जातीयता", 
	   additional_fields:"अतिरिक्त क्षेत्र", 
	   school_sessions:"स्कूल सत्र", 
	   gradebook:"ग्रेडबुक", 
	   submit:"जमा करना", 
	   reset:"रीसेट", 
	   show_hide_columns:"स्तंभ दिखाएं/छिपाएं", 
	   select_all:"सबका चयन करें", 
	   student_id:"स्टूडेंट आईडी", 
	   last_name:"उपनाम", 
	   first_name:"पहला नाम", 
	   grade_level:"क्रम स्तर", 
	   start_date:"आरंभ करने की तिथि", 
	   end_date:"अंतिम तिथि", 
	   grade_final:"ग्रेड फाइनल", 
	   percent:"प्रतिशत", 
	   credit:"श्रेय", 
	   download_excel:"डाउनलोड एक्सेल", 
	   print:"छाप", 
	   no_data:"कोई डेटा नहीं।", 
	   view:"देखना", 
	   showing:"दिखा", 
	   of:"का", 
	   other_grade:"अन्य ग्रेड", 
	   level:"स्तर", 
	   date:"तारीख", 
	   grade:"श्रेणी",
	   enrollment_Change_Status:"नामांकन परिवर्तन की स्थिति", 
	   close:"बंद करना", 
	   select_Enrollment_Status:"नामांकन स्थिति का चयन करें", 
	   select:"चुनना...", 
	   cancel:"रद्द करना", 
	   save:"बचाना", 
	   students:"रद्द छात्र", 
	   Course_Status:"पाठ्यक्रम की स्थिति", 
	   Closed_courses:"बंद पाठ्यक्रम", 
	   Section_Status:"अनुभाग स्थिति", 
	   Closed_sections:"बंद खंड", 
	   Transferred_From:"से स्थानांतरित किया गया",
	   Graduation_From_Date:"दिनांक से स्नातक", 
	   Graduation_To_Date:"आज तक स्नातक", 
	   Enrollment_From_Date:"तिथि से नामांकन", 
	   Enrollment_To_Date:"अद्यतित नामांकन", 
	   Enrollment_Status:"नामांकन की स्थिति", 
	   Transfer_From_Date:"तिथि से स्थानांतरण", 
	   Transfer_To_Date:"अद्यतित स्थानांतरण", 
	   Custom_Query:"कस्टम क्वेरी", 
	   Last_Access_Date:"अंतिम अभिगम तिथि", 
	   Total_Session_Time:"कुल सत्र काल", 
	   Quality_of_Work:"काम की गुणवत्ता", 
	   Grade_to_Date:"अद्यतित ग्रेड", 
	   Overall_Percent:"समग्र प्रतिशत", 
	   On_Schedule_Percent:"समय -समय पर", 
	   Activity_Count_Complete:"गतिविधि की गिनती पूर्ण", 
	   Activity_Count_Total:"समग्र गतिविधि गणना", 
	   Overdue_Activitie:"अतिदेय सक्रियता",
	   Section_Course_Additional_Fields:"अनुभाग/पाठ्यक्रम अतिरिक्त क्षेत्र", 
	   Create_On_Date:"दिनांक बनाएँ", 
	   Last_Status_Update_Date:"अंतिम स्थिति अद्यतन तिथि", 
	   Transferred_In:"में स्थानांतरित किया गया", 
	   Transferred_In_Date:"तिथि में स्थानांतरित", 
	   email:"ईमेल", 
	   birth_date:"जन्म तिथि", 
	   course_name:"कोर्स का नाम", 
	   section_name:"अनुभाग का नाम", 
	   school_name:"स्कूल के नाम", 
	   Graduation_Date:"स्नातक की तारीख", 
	   Created_on:"पर बनाया", 
	   mentor_Advisor:"संरक्षक/सलाहकार",
	   sections:"धारा", 
	   roster:"रोस्टर", 
	   relationship:"रिश्ता", 
	   Email_or_Phone:"ईमेल या फोन", 
	   Enter_any_text:"कोई भी पाठ दर्ज करें", 
	   Advisor_Success_Manager:"सलाहकार / सफलता प्रबंधक", 
	   User_Id:"उपयोगकर्ता पहचान", 
	   phone_number:"फ़ोन नंबर", 
	   Student_Last_Name:"छात्र अंतिम नाम", 
	   Student_First_Name:"छात्र का पहला नाम", 
	   Student_Email:"छात्र ईमेल",
	   credentials:"साख", 
	   availability:"उपलब्धता",
	   enrollments:"नामांकन", 
	   Datea_Created_on:"पर बनाई गई तारीख",
	   country:"देश", 
	   state:"राज्य", 
	   zipcode:"ज़िप कोड", 
	   Enter_any_zipcode:"कोई भी ज़िपकोड दर्ज करें", 
	   address:"पता",
	   zip_Code:"ज़िप कोड",
	   Login_Report:"लॉगिन रिपोर्ट", 
	   user_Type:"उपयोगकर्ता का प्रकार", 
	   user_Name:"उपयोगकर्ता नाम", 
	   Show_last_log_in_only:"केवल अंतिम लॉग दिखाएं", 
	   Username:"उपयोगकर्ता नाम", 
	   Date_Time:"दिनांक समय", 
	   Ip_Address:"आईपी ​​पता", 
	   city:"शहर",
	   Enrollment_Start_Date:"नामांकन प्रारंभ तिथि", 
	   Enrollment_End_Date:"नामांकन अंत तिथि", 
	   Completion_Date:"पूरा करने की तिथि", 
	   section_Type:"अनुभाग प्रकार", 
	   student_Enrolled:"छात्र नामांकित छात्र", 
	   content_Provider:"सामग्री प्रदाता", 
	   student_Additional_Fields:"छात्र अतिरिक्त क्षेत्र",
	   type:"प्रकार", 
	   in_Class_Information:"वर्ग की जानकारी में",
	   Enrollment_Summary_Report:"नामांकन सारांश रिपोर्ट", 
	   Transferred_From_School:"स्कूल से स्थानांतरित किया गया",
	   Total_Enrollments:"कुल नामांकन", 
	   content_Type:"सामग्री प्रकार", 
	   active_Course_Progress:"सक्रिय पाठ्यक्रम प्रगति",
		Grades:"ग्रेड", 
	   attendance:"उपस्थिति",
	   student_Absences:"छात्र अनुपस्थिति", 
	   total_Absence:"कुल अनुपस्थिति", 
	   section_Absences:"धारा अनुपस्थिति",
	   Grade_Level_Absences:"ग्रेड स्तर की अनुपस्थिति",
	   Gender_Absences:"लिंग अनुपस्थिति",
	   Login_credentials:"लॉग इन प्रमाण - पत्र", 
	   names:"नाम", 
	   user_status_admin_teacher_parent:"उपयोगकर्ता की स्थिति (व्यवस्थापक, शिक्षक, माता -पिता)", 
	   show_title:"शीर्षक दिखाओ", 
	   midle_name:"मध्य नाम", 
	   password:"पासवर्ड", 
	   parent_name:"अभिभावक का नाम", 
	   linked_to_parent:"माता -पिता से जुड़ा हुआ है", 
	   linked_to_student:"छात्र से जुड़ा हुआ है",
	   login_credentials_Report:"लॉगिन साख रिपोर्ट", 
	   app_id:"ऐप आईडी", 
	   created:"बनाया था", 
	   modified:"संशोधित",
	   select_level:"स्तर चुनें", 
	   select_additional_fields:"धारा अतिरिक्त फ़ील्ड", 
	   title:"शीर्षक", 
	   credits:"क्रेडिट", 
	   section_ID:"धारा आईडी", 
	   content:"संतुष्ट", 
	   course_additional_fields:"पाठ्यक्रम अतिरिक्त क्षेत्र",
	   course_id:"पाठ्यक्रम आईडी", 
	   communication_summary_report:"संचार सारांश रिपोर्ट", 
	   method:"तरीका", 
	   create_date:"तिथि बनाएं", 
	   subject:"विषय", 
	   make_from_id:"आईडी से बनाओ", 
	   make_to:"बनाने के लिए", 
	   attachments:"संलग्नक", 
	   comment_and_document_summary_report:"टिप्पणी और दस्तावेज़ सारांश रिपोर्ट", 
	   comment_type:"टिप्पणी प्रकार", 
	   flagged:"चिह्नित किए गए", 
	   sharing_target:"साझाकरण लक्ष्य", 
	   show_on_transcript:"प्रतिलेख पर दिखाओ", 
	   by:"द्वारा", 
	   comment:"टिप्पणी", 
	   type_name:"नाम टाइप करें", 
	   effective_from_date:"तिथि से प्रभावी", 
	   effective_to_date:"आज तक प्रभावी", 
	   count_docs:"गिनती डॉक्स",
	   school_calendar_report:"विद्यालय कैलेंडर रिपोर्ट", 
	   event_Id:"इवेंट आईडी", 
	   date_start:"दिनांक शुरू", 
	   date_end:"दिनांक अंत", 
	   posted_last_name:"अंतिम नाम पोस्ट किया", 
	   posted_first_name:"पहला नाम पोस्ट किया",
	   bell_schedule_report:"घंटी अनुसूची रिपोर्ट", 
	   period:"अवधि", 
	   start:"शुरू", 
	   end:"अंत",
	   student_contract_report:"छात्र संविदा रिपोर्ट", 
	   begin_date:"तिथि शुरू", 
	   contracts:"ठेके", 
	   contract_name:"संविदा नाम", 
	   contract_begin_date:"अनुबंध शुरू तिथि", 
	   contract_end_date:"संविदा अंत तिथि",
	   active_enrollments_per_term_report:"प्रति टर्म रिपोर्ट सक्रिय नामांकन", 
	   entry_date:"प्रवेश तिथि", 
	   teachers:"शिक्षकों की", 
	   term:"अवधि", 
	   sections:"धारा", 
	   showing_of:"20 में से 10 दिखा रहा है", 
	   filter:"फ़िल्टर", 
	   students:"छात्र", 
	   school:"स्कूल", 
	   all_school:"सभी स्कूल", 
	   student:"विद्यार्थी", 
	   email:"ईमेल", 
	   grade_level:"क्रम स्तर", 
	   status:"दर्जा", 
	   seach_for_a_student_or_id:"एक छात्र या आईडी खोजें ...", 
	   search:"खोज …", 
	   message_student:"संदेश छात्र", 
	   request_enrollment:"नामांकन का अनुरोध करें", 
	   print_schedule:"प्रिंट अनुसूची", 
	   view:"देखना", 
	   no_data:"कोई आकड़ा उपलब्ध नहीं है।", 
	   views:"विचारों", 
	   enrollment:"उपस्थिति पंजी", 
	   schedule:"अनुसूची", 
	   transferred_grades:"स्थानांतरित ग्रेड", 
	   comments_ocuments:"टिप्पणियाँ और दस्तावेज़", 
	   academic_records:"अकादमिक रिकॉर्ड", 
	   compliance_log:"अनुपालन लॉग", 
	   unofficial_transcript:"अनधिकारिक ट्रांसस्क्रिप्ट", 
	   iD_card:"पहचान पत्र", 
	   student_number_id_information:"विद्यार्थी संख्या #29561 सूचना", 
	   student_number:"छात्र संख्या", 
	   gender:"लिंग", 
	   goes_by:"गुज़रना", 
	   date_of_birth:"जन्म की तारीख", 
	   ethnicity:"जातीयता", 
	   mobile:"मोबाइल", 
	   academic_track:"अकादमिक ट्रैक", 
	   learning_path_template:"प्रशिक्षण पथ टेम्पलेट", 
	   graduation_date:"स्नातक स्तर की तारीख", 
	   comments:"टिप्पणियाँ", 
	   transfer_information:"स्थानांतरण सूचना", 
	   enrollment_date:"नामांकन तिथि", 
	   transfer_date:"हस्तांतरण की तारीख", 
	   transfer_student:"स्थानांतरित विद्यार्थी", 
	   parent_mentor_contact:"माता-पिता / सलाहकार संपर्क", 
	   mentor:"उपदेशक", 
	   parent_phone:"माता-पिता का फोन", 
	   emergency_contact:"आपातकालीन संपर्क", 
	   academic_advisor_ssm:"शैक्षणिक सलाहकार / एसएसएम", 
	   student_success_manager:"छात्र सफलता प्रबंधक", 
	   academic_avisor:"अकादमिक सलाहकार", 
	   address:"पता", 
	   address_01_Default:"पता 01 (डिफ़ॉल्ट)", 
	   street:"गली", 
	   city:"शहर", 
	   state:"राज्य", 
	   zip:"ज़िप", 
	   hide_Detailed_information:"विस्तृत जानकारी छुपाएं", 	    
	   current_course_progress:"वर्तमान पाठ्यक्रम प्रगति", 	    
	   full_Path_Progress:"पूर्ण पथ प्रगति", 	    
	   print:"छाप", 	    
	   avg_graduation_progress:"औसत स्नातक प्रगति", 	    
	   GPA:"जीपीए", 	    
	   graduation_Status:"स्नातक की स्थिति", 	    
	   on_track:"ट्रैक पर", 	    
	   show_detailed_information:"विस्तृत जानकारी दिखाएं", 	    
	   communication:"संचार", 	    
	   student_advisors:"छात्र सलाहकार", 	    
	   country:"देश", 	    
	   grade:"श्रेणी", 	    
	   credits:"क्रेडिट", 	    
	   sort:"क्रम से लगाना", 	    
	   course_progress:"पाठ्यक्रम प्रगति", 	    
	   overall_GPA:"सकल जीपीए", 	    
	   current_graduation_progress:"वर्तमान स्नातक प्रगति", 	    
	   individual_course_progress:"*व्यक्तिगत पाठ्यक्रम की प्रगति भिन्न होती है, यह आपकी समग्र प्रगति है", 	    
	   subject:"विषय",
	   online_sections:"ऑनलाइन अनुभाग",
	   course:"पाठ्यक्रम",
	   section:"खंड", 
	   actions:"कार्रवाई", 
	   view_event:"घटना देखें", 
	   in_class_section:"वर्ग खंड में",
	   calendar:"पंचांग", 
	   access_link:"एक्सेस लिंक", 
	   online_link:"ऑनलाइन लिंक",
	   launch_course:"लॉन्च कोर्स", 
	   start_class:"कक्षा शुरू", 
	   level:"स्तर", 
	   date:"तारीख", 
	   transferred_in:"में स्थानान्तरित", 
	   tranferred_grades:"स्थानांतरित ग्रेड", 
	   Searchs:"खोज", 
	   Search_department_course:"खोज विभाग पाठ्यक्रम, src…", 
	   archived:"संग्रहीत", 
	   add_comment:"टिप्पणी जोड़ें", 
	   created_date:"सृजित दिनांक", 
	   by:"द्वारा", 
	   type:"प्रकार", 
	   comment:"टिप्पणी", 
	   from_date:"की तिथि से", 
	   to_date:"तारीख तक", 
	   documents:"दस्तावेज़", 
	   edit:"संपादन करना", 
	   delete:"मिटाना", 
	   communications:"संचार", 
	   add_communications:"संचार जोड़ें", 
	   made_from:"से बना", 
	   made_to:"से बना", 
	   means:"माध्यम", 
	   attachments:"संलग्नक", 
	   content:"विषय", 
	   compliance_logs:"अनुपालन लॉग", 
	   messageID:"संदेश आईडी", 
	   agree:"सहमत होना", 
	   dateTime:"दिनांक और समय", 
	   iPAddress:"आईपी ​​पता", 
	   add_idit_comment_document:"टिप्पणी और दस्तावेज़ जोड़ें/संपादित करें", 
	   document_type:"दस्तावेज़ का प्रकार", 
	   show_on_transcript:"ट्रांसक्रिप्ट पर दिखाएं", 
	   select_users_to:"के लिए उपयोगकर्ता चुनें", 
	   teacher:"शिक्षक", 
	   parent:"माता-पिता", 
	   flag:"झंडा", 
	   none:"कोई भी नहीं", 
	   link:"संपर्क", 
	   label:"लेबल", 
	   add_more_link:"अधिक लिंक जोड़ें", 
	   save:"बचाना", 
	   add_edit_communication:"संचार जोड़ें/संपादित करें", 
	   made_by:"द्वारा निर्मित", 
	   date_time:"दिनांक समय", 
	   length:"लंबाई", 
	   select:"चुनना", 
	   select_users_to_view:"संचार देखने के लिए उपयोगकर्ताओं का चयन करें", 
	   add_more:"अधिक जोड़ें", 
	   communication_summary:"संचार सारांश", 
	   close:"बंद करना", 
	   new_type:"नया प्रकार", 
	   select_user_to_view_comment:"टिप्पणी देखने के लिए उपयोगकर्ताओं का चयन करें", 
	   flag_comment:"ध्वज टिप्पणी", 
	   teacher_page:"शिक्षक पृष्ठ", 
	   edit_information:"जानकारी संपादित करें", 
	   phone:"फ़ोन",
	   add_credential:"क्रेडेंशियल जोड़ें",
	   add_edit_credential:"क्रेडेंशियल जोड़ें/संपादित करें",
	   first_name:"पहला नाम",
	   midle_name:"मध्य नाम",
	   last_name:"उपनाम",
	   cancel:"रद्द करना",
	   add_new:"नया जोड़ो",
	   phone_type:"फोन प्रकार",
	   zipCode:"पिन कोड",
	   phone_number:"फ़ोन नंबर",
	   default:"चूक जाना",
	   please_select_country:"कृपया देश का चयन करें",
	   student_information:"छात्र जानकारी",
	   username:"उपयोगकर्ता नाम",
	   user_directory:"उपयोगकर्ता निर्देशिका",
	   add_teacher:"शिक्षक जोड़ें",
	   add_admin:"व्यवस्थापक जोड़ें",
	   export_to_excel:"एक्सेल में भेजे",
	   export_to_pdf:"पीडीएफ में निर्यात करें",
	   send_login_credentials:"लॉगिन क्रेडेंशियल भेजें",
	   search_for_a_user_or_id:"उपयोगकर्ता या आईडी खोजें …",
	   user:"उपयोगकर्ता",
	   school_admin:"स्कूल प्रशासन",
	   change_password:"पासवर्ड बदलें",
	   set_password_expiration_date:"पासवर्ड समाप्ति तिथि निर्धारित करें",
	   impersonate_user:"उपयोगकर्ता का रूप धारण करें",
	   edit_user_tags:"उपयोगकर्ता टैग संपादित करें",
	   add_or_edit_users_schoo_assign:"स्कूल असाइन किए गए उपयोगकर्ताओं को जोड़ें या संपादित करें",
	   assign_content_access:"सामग्री पहुँच असाइन करें",
	   add_student:"विद्यार्थी जोड़ें",
	   add_parent_mentor:"माता-पिता/सलाहकार जोड़ें",
	   showing:"दिखा",
	   of:"का",
	   school_name:"विद्यालय का नाम",
	   edit_user_school_tags:"उपयोगकर्ता-स्कूल टैग संपादित करें",
	   personal_information:"व्यक्तिगत जानकारी",
	   contacted_load:"संपर्क लोड",
	   maximum_of_active_students:"अधिकतम # सक्रिय छात्र",
	   teacher_since:"शिक्षक के बाद से",
	   login_infomation:"लॉगिन जानकारी",
	   username:"उपयोगकर्ता नाम",
	   password :"पासवर्ड",
	   avatar :"अवतार",
	   teachers :"शिक्षकों की",
	   change_status:"अवस्था बदलो",
	   add_admin:"व्यवस्थापक जोड़ें",
	   name:"नाम",
	   create_on:"क्रिएट ऑन",
	   registrar:"रजिस्ट्रार",
	   birthday:"जन्मदिन",
	   signature:"हस्ताक्षर",
	   photo:"फ़ोटो",
	   designated_registrar:"मनोनीत रजिस्ट्रार",
	   track:"संकरा रास्ता",
	   select_existing_track:"मौजूदा ट्रैक का चयन करें",
	   available:"उपलब्ध",
	   parent_mentor:"अभिभावक/सलाहकार",
	   relationship:"संबंध",
	   email_address:"मेल पता",
	   academic_mentor:"अकादमिक गुरु",
	   no_data_available_in_table:"तालिका में आंकड़े उपलब्ध नहीं है",
	   primary_language:"प्राथमिक भाषा",
	   add_into_parent_or_mentor:"माता-पिता / सलाहकार में जोड़ें",
	   add_into_phone:"फोन में जोड़ें",
	   add_into_address:"पते में जोड़ें",
	   select_one:"एक चुनो",
	   login:"लॉग इन करें",
	   plese_select_country:"कृपया देश चुनें",
	   edit_student:"छात्र संपादित करें",
	   academic_advisor_or_student_success_manager:"अकादमिक सलाहकार / छात्र सफलता प्रबंधक",
	   role:"भूमिका",
	   link_parent:"लिंक जनक",
	   link_advisor_sms:"लिंक सलाहकार/एसएसएम",
	   save_into_parent_mentor:"माता-पिता/सलाहकार में सहेजें",
	   save_into_parent_phone:"फोन में सेव करें",
	   save_into_parent_address:"पते में सहेजें",
	   bulk_information_update:"थोक सूचना अद्यतन",
	   enrollments:"नामांकन",
	   email_student:"ईमेल छात्र",
	   unofficial_transcripts:"अनौपचारिक टेप",
	   official_transcripts:"सरकारी टेप",
	   email_students_schedule:"छात्र की अनुसूची ईमेल करें",
	   export_students_to_excel:"छात्रों को एक्सेल में निर्यात करें",
	   export_parent_list_to_excel:"एक्सेल में एक्सपोर्ट पेरेंट लिस्ट",
	   assign_learning_path_template:"प्रशिक्षण पथ टेम्पलेट असाइन करें",
	   promote_student_to_the_next_grade_level:"छात्र को अगली कक्षा स्तर पर पदोन्नत करें",
	   batch_upload_students:"बैच अपलोड छात्र",
	   batch_upload_transfer_grades:"बैच अपलोड ट्रांसफर ग्रेड",
	   transfer_apex_only:"स्थानांतरण (केवल एपेक्स)",
	   transfer_content_providers:"स्थानांतरण (सभी सामग्री प्रदाता)",
	   batch_enrollments:"बैच नामांकन",
	   send_message:"मेसेज भेजें",
	   impersonate:"प्रतिरूपण",
	   change_login_credentials:"लॉगिन क्रेडेंशियल बदलें",
	   request_enrollment:"नामांकन का अनुरोध करें",
	   send_weekly_status_report:"साप्ताहिक स्थिति रिपोर्ट भेजें",
	   please_select_student:"कृपया छात्रों का चयन करें।",
	   student_status_will_be_changed_to_status_withdraw:"छात्र की स्थिति को 111 में बदल दिया जाएगा, और सभी नामांकन वापस ले लिए जाएंगे। क्या तुम वाकई जारी रखना चाहते हो?",
	   student_status_will_be_changed_to_status:"छात्र की स्थिति को 111 में बदल दिया जाएगा। क्या आप सुनिश्चित हैं कि आप जारी रखना चाहते हैं?",
	   value:"मूल्य",
	   student_success_manager_or_acdemic:"छात्र सफलता प्रबंधक / शैक्षणिक सलाहकार",
	   enroll_students_to_section:"छात्रों को अनुभाग में दाखिला लें",
	   department:"समाप्ति तिथि",
	   refresh:"ताज़ा करना",
	   select_department:"कृपया विभाग का चयन करें।",
	   select_course:"पाठ्यक्रम का चयन करें",
	   select_section:"अनुभाग का चयन करें",
	   start_date:"आरंभ करने की तिथि",
	   end_date:"अंतिम तिथि",
	   ID:"पहचान",
	   action:"कार्य",
	   enrollment_period:"नामांकन अवधि",
	   select_a_course_to_register_ilp:"ILP को पंजीकृत करने के लिए एक कोर्स का चयन करें",
	   period:"अवधि",
	   credit:"श्रेय",
	   year:"वर्ष",
	   enroll:"नामांकन",
	   recipient_transcript:"प्राप्तकर्ता प्रतिलेख",
	   select_all_or_unselect_all:"सभी का चयन करें / सभी को अचयनित करें",
	   include_in_progress_sections:"प्रगति अनुभागों में शामिल करें",
	   show_satisfaction_of_program:"कार्यक्रम की संतुष्टि दिखाएं",
	   show_total_credit:"कुल क्रेडिट दिखाएं",
	   show_student_info:"छात्र जानकारी दिखाएं",
	   show_academic_info:"शैक्षणिक जानकारी दिखाएं",
	   show_school_names_from_orther_grades:"अन्य ग्रेड से स्कूल के नाम दिखाएं",
	   show_school_contact:"स्कूल संपर्क दिखाएं",
	   include_transferred_grades_in_gpa:"GPA में स्थानांतरित ग्रेड शामिल करें",
	   include_in_progress_grade:"प्रगति ग्रेड में शामिल करें",
	   include_grade_scales:"ग्रेड तराजू शामिल करें",
	   show_graduation_date:"स्नातक की तारीख दिखाएं",
	   show_weighted_gpa:"भारित GPA दिखाएं",
	   show_grade_level_gpa:"ग्रेड स्तर जीपीए दिखाएं",
	   show_comletion_date:"पूर्ण होने की तारीख दिखाएं",
	   show_withdraw_classes:"वापस ले ली गई कक्षाएं",
	   show_withdraw_date:"वापसी की तारीख दिखाएं",
	   show_transfered_in_classes:"कक्षाओं में स्थानांतरित दिखाएं",
	   show_digital_seal:"डिजिटल सील दिखाएं",
	   show_singnature:"हस्ताक्षर दिखाएं",
	   group_by:"द्वारा समूह बनाएं",
	   school_year:"स्कूल वर्ष",
	   school_level:"स्कुल स्तर",
	   notes:"टिप्पणियाँ",
	   ok:"ठीक",
	   are_you_sure_to_send:"क्या आप भेजना सुनिश्चित कर रहे हैं?",
	   assign_learning_path_templete:"लर्निंग पाथ टेम्पलेट असाइन करें",
	   assign_student_to_selected_learning:"चयनित शिक्षण पथ टेम्पलेट के लिए छात्र को असाइन करें",
	   assign:"सौंपना",
	   are_you_sure_to_promote_to_level:"क्या आप अगले ग्रेड स्तर को बढ़ावा देना सुनिश्चित करते हैं?",
	   data_process:"आँकड़ा प्रक्रिया",
	   upload_and_import_data:"अपलोड और आयात डेटा",
	   download_user_information:"उपयोगकर्ता जानकारी डाउनलोड करें",
	   here:"यहां",
	   select_student_upload_file:"छात्र अपलोड फ़ाइल का चयन करें",
	   local_drive:"स्थानीय ड्राइव",
	   the_file_is_uploaded:"फ़ाइल अपलोड की गई है",
	   template_name:"टेम्पलेट नाम",
	   Here:"यहां",
	   sample_file_excel:"नमूना फ़ाइल एक्सेल।",
	   file_type:"फाइल का प्रकार",
	   delimited:"सीमांकित",
	   delimited_chars:"सीमांकित चार्ट",
	   fixed_width:"निश्चित चौड़ाई",
	   first_line_header:"पहली पंक्ति हैडर",
	   loader_field:"लोड क्षेत्र",
	   Header:"हैडर",
	   sample_data:"नमूना डेटा",
	   column_width:"कोलुनम चौड़ाई",
	   save_tamplate:"टेम्पलेट सहेजें",
	   save_and_upload_data:"डेटा सहेजें और अपलोड करें",
	   result:"परिणाम",
	   upload_and_import_data_orther_grade:"अपलोड और आयात डेटा अन्य ग्रेड",
	   select_upload_file:"अपलोड फ़ाइल का चयन करें",
	   student_id:"स्टूडेंट आईडी",
	   uploadAnd_import_data_enrollment:"अपलोड और आयात डेटा नामांकन",
	   section_id:"धारा आईडी",
	   title:"शीर्षक",
	   recipient:"प्राप्तकर्ता",
	   same_current_address:"वर्तमान पते के समान",
	   add_more_reciptient:"अधिक प्राप्तकर्ता जोड़ें",
	   issuse_date:"जारी करने की तिथि",
	   show_total_unapplied_credits:"कुल अनियोजित क्रेडिट दिखाएं",
	   reconcile_another_student_record:"एक और छात्र रिकॉर्ड के साथ सामंजस्य स्थापित करें",
	   please_choose_one_student_to_reconcile:"कृपया सामंजस्य स्थापित करने के लिए एक छात्र चुनें।",
	   yes:"हाँ",
	   no:"नहीं",
	   apex_classroom_sync:"शीर्ष कक्षा सिंक",
	   next:"अगला",
	   apex_classrooms:"एपेक्स क्लासरूम",
	   online_user_id:"ऑनलाइन उपयोगकर्ता आईडी",
	   enter_online_user_id:"ऑनलाइन उपयोगकर्ता आईडी दर्ज करें",
	   online_section_id:"ऑनलाइन अनुभाग आईडी",
	   online_section_name:"ऑनलाइन अनुभाग नाम",
	   online_course_name:"ऑनलाइन पाठ्यक्रम का नाम",
	   enrollment_date:"नामांकन की तिथि",
	   back:"पीछे",
	   import:"आयात",
	   offical_transcipt:"आधिकारिक ट्रांस्क्रिप्ट",
	   email_schedule:"ईमेल अनुसूची",
	   reconcile_with_another_records:"एक और रिकॉर्ड के साथ सामंजस्य स्थापित करें",
	   online_sync_and_update:"ऑनलाइन प्रगति सिंक और अपडेट",
	   download_all_completion_cretification:"सभी पूर्ण प्रमाणन डाउनलोड करें",
	   orther_grade:"अन्य ग्रेड",
	   medical:"चिकित्सा",
	   comments_and_documents:"टिप्पणियाँ और दस्तावेज",
	   contracts:"ठेके",
	   invoices:"चालान",
	   audit_logs:"लेखापरीक्षा लॉग्स",
	   edit_logs:"लॉग संपादित करें",
	   grade_to_date:"अद्यतित ग्रेड",
	   quality_of_work:"काम की गुणवत्ता",
	   last_access:"अंतिम पहुंच",
	   gradebook:"ग्रेडबुक",
	   transfer:"स्थानांतरण",
	   completion_certification:"पूर्णता प्रमाणीकरण",
	   tranfer_user_school:"ट्रांसफर यूजर स्कूल",
	   tranfer_to_school:"स्कूल में स्थानांतरण",
	   tranfer_apex_classrooms:"शीर्ष कक्षाओं को स्थानांतरित करें",
	   course_to_moved:"स्थानांतरित करने के लिए पाठ्यक्रम",
	   current_teacher:"वर्तमान शिक्षक",
	   future_section:"भावी अनुभाग",
	   future_program:"भविष्य का कार्यक्रम",
	   future_teacher:"भावी शिक्षक",
	   enrollment_start_date_end_date:"नामांकन प्रारंभ तिथि - अंत तिथि",
	   no_more_option:"और अधिक विकल्प नहीं",
	   create_new:"नया निर्माण",
	   transfer_classrooms:"हस्तांतरण कक्षाओं",
	   tyler_synchronization_for_az_school:"AZ स्कूलों के लिए टायलर सिंक्रनाइज़ेशन",
	   synchronize:"सिंक्रनाइज़",
	   individual_course_progress_varies:"व्यक्तिगत पाठ्यक्रम प्रगति भिन्न होती है। यह स्नातक की ओर आपकी समग्र प्रगति है।",
	   edit_ilp:"ILP संपादित करें",
	   add_academic_record:"शैक्षणिक रिकॉर्ड जोड़ें",
	   edit_all_records:"सभी रिकॉर्ड संपादित करें",
	   search_corse_department_src:"खोज पाठ्यक्रम, विभाग, एसआरसी…",
	   message_id:"संदेश आईडी",
	   add_new_contract:"नया अनुबंध जोड़ें",
	   contract_id:"संविदा आईडी",
	   contract_name:"संविदा नाम",
	   first_date:"पहली मुलाकात",
	   last_date:"अंतिम तिथी",
	   amount_per_period:"प्रति अवधि की राशि",
	   terminating_status:"समाप्ति की स्थिति",
	    payment_history:"भुगतान इतिहास",
	   record_payment:"अभिलेख भुगतान",
	   payment_method:"भुगतान विधि",
	   invoice_id:"चालान आईडी",
	   show_all:"सब दिखाएं",
	   invoice_date:"चालान की तारीख",
	   from:"से…",
	   to:"को…",
	   amount:"मात्रा",
	   paid:"चुकाया गया",
	   due:"देय",
	   date_paid:"अदायगी की तिथि",
	   apply_payments:"भुगतान लागू करें",
	   mark_as_paid:"भुगतान के रूप में चिह्नित करें",
	   void:"खालीपन",
	   audit_log:"हिसाब सूचि",
	   object:"वस्तु",
	   changes_made:"परिवर्तन किए",
	   create_time:"निर्माण का समय",
	   time_stamp:"समय -समय पर टिकट",
	   user_creare:"उपयोगकर्ता बनाएँ",
	   edit_log:"संपादित करें लॉग",
	   field_name:"कार्यक्षेत्र नाम",
	   old_value:"पुराना मूल्य",
	   new_value:"नया मूल्य",
	   date_time_update:"दिनांक/समय अद्यतन",
	   updater:"अपडेटर",
	   add_edit_academic_records:"शैक्षणिक रिकॉर्ड जोड़ें/संपादित करें",
	   select_flag:"ध्वज का चयन करें ...",
	   edit_all_tranferred_grades:"सभी ट्रेनफर्ड ग्रेड संपादित करें",
	   save_records:"रिकॉर्ड सहेजें",
	   possible_credits:"संभव क्रेडिट",
	   select_level:"स्तर चुनें",
	   select_grade_level:"ग्रेड स्तर का चयन करें",
	   select_status:"स्थिति का चयन करें",
	   add_more_row:"अधिक पंक्ति जोड़ें",
	   full_screen:"पूर्ण स्क्रीन",
	   course_code:"अन्य ग्रेड जोड़ें",
	   add_order_grades:"पाठ्यक्रम कोड",
	   select_credit:"क्रेडिट का चयन करें",
	   select_default:"डिफ़ॉल्ट का चयन करें",
	   credits_possible:"संभव है",
	   select_possible_credit:"संभावित क्रेडिट का चयन करें",
	   product:"उत्पाद",
	   fromn:"से",
	   ton:"को",
	   last_invoice_date:"अंतिम चालान तिथि",
	   please_select_stu:"कृपया छात्र का चयन करें",
	   payer:"भुगतानकर्ता",
	   amount_per_billing_period:"प्रति बिलिंग अवधि",
	   price_unit:"कीमत दर",
	   billing_period:"बिलिंग अवधि",
	   automatic_renewal:"स्वचालित नवीकरण",
	   automatic_payment:"स्वत: बिलिंग",
	   duration_of_period:"अवधि (# अवधि)",
	   payment_id:"भुगतान आईडी",
	   payment_date:"भुगतान तिथि",
	   payment_amount:"भुगतान राशि",
	   applied:"लागू",
	   available:"उपलब्ध",
	   unApply:"अनियंत्रित",
	   refund:"धनवापसी",
	   add_new_teacher:"नए शिक्षक जोड़ें",
	   change_teacher_status:"शिक्षक की स्थिति बदलें",
	   search_for_a_teacher_or_id:"एक शिक्षक या आईडी के लिए खोज…",
	   flags:"झंडे",
	   tags:"टैग",
	   allowed:"अनुमत",
	   message_teacher:"संदेश शिक्षक",
	   impersonate_teacher:"जाली शिक्षक",
	   add_teacher_qualification:"शिक्षक योग्यता जोड़ें",
	   profile:"प्रोफ़ाइल",
	   teacher_schedule:"शिक्षक अनुसूची",
	   qualifications:"योग्यता",
	   student_actions:"छात्र कार्य",
	   linking_parents_to:"माता -पिता को जोड़ना",
	   select_do:"चुनना ...",
	   see_edit_logs:"एडिट लॉग देखें",
	   see_qualifications:"योग्यता देखें",
	   link_academic_advisor:"लिंक अकादमिक सलाहकार",
	   student_success:"छात्र सफलता",
	   linking_academic_advisor_or_student_success:"अकादमिक सलाहकार / छात्र की सफलता को जोड़ना",
	   staff:"कर्मचारी",
	   teacher_status:"शिक्षक की स्थिति",
	   school_admin_status:"विद्यालय की स्थिति",
	   global_user_directory:"वैश्विक उपयोगकर्ता निर्देशिका",
	   edit_teacher:"शिक्षक संपादित करें",
	   contracted:"संकुचित",
	   add_comments_and_documents:"टिप्पणियाँ और दस्तावेज",
	   edit_comments_and_documents:"टिप्पणियाँ और दस्तावेज संपादित करें",
	   parents_or_mentor:"माता -पिता / संरक्षक",
	   send_mail:"मेल भेजने",
	   are_you_sure_to_delete_this_teacher:"क्या आप इस शिक्षक को हटाना सुनिश्चित करते हैं।",
	   edit_user_password:"उपयोगकर्ता नाम और पासवर्ड संपादित करें",
	   add_qualifications:"योग्यता जोड़ें",
	   please_select_a_least_on_teacher:"कृपया कम से कम एक शिक्षक का चयन करें।",
	   edit_parent_mentor:"माता -पिता / संरक्षक संपादित करें",
	   parent_mentor_information:"अभिभावक / संरक्षक जानकारी",
	   send:"भेजना",
	   are_you_surse_to_delete_this_parent:"क्या आप इस माता -पिता को हटाना सुनिश्चित करते हैं।",
	   home:"घर",
	   
	  // auto_promotion:"ऑटो पदोन्नति",
	   auto_promotion:"छात्र ग्रेड स्तर पदोन्नति",
	   Promote:"पदोन्नति करना",
	   search_for_a_name:"एक नाम खोजें ...",
	   download_to_excel:"Excel पर डाउनलोड करें",
	   download_to_pdf:"पीडीएफ पर डाउनलोड करें",
	   User_ID:"उपयोगकर्ता पहचान",
	   User_type:"उपयोगकर्ता का प्रकार",
	   communication_log:"संचार लॉग",
	   Student_Status:"स्टूडेंट दर्जा",
	   Users:"उपयोगकर्ताओं",
	   Staff_Reassignment:"कर्मचारियों का पुनर्मूल्यांकन",
	   Select_Staff:"स्टाफ का चयन करें",
	   select_asset_type_to_reassign:"पुनर्मूल्यांकन करने के लिए परिसंपत्ति प्रकार का चयन करें",
	   transfer_all_to:"सभी को स्थानांतरित करें",
	   transfer_selectively:"चुनिंदा रूप से स्थानांतरित करें",
	   remove_all:"सभी हटाएं",
	   remove_selectively:"चुनिंदा रूप से हटा दें",
	   Event:"आयोजन",
	   Time:"समय",
	   Participants:"प्रतिभागियों",
	   new_staff:"नए कर्मचारी",
	   Remove:"निकालना",
	   Profile_Page:"प्रोफ़ाइल पृष्ठ",
	   settings:"समायोजन",
	   security:"सुरक्षा",
	   timezone:"समय क्षेत्र",
	   notifications:"अधिसूचना",
	   check_for_feature_availability_at_your_school:"अपने स्कूल में सुविधा उपलब्धता के लिए जाँच करें।",
	   current_password:"वर्तमान पासवर्ड",
	   new_password:"नया पासवर्ड",
	   confirm_password:"पासवर्ड की पुष्टि कीजिये",
	   updte_password:"पासवर्ड अपडेट करें",
	   change_timezone:"टाइमज़ोन बदलें",
	   time_zone:"समय क्षेत्र",
	   please_select_time_zone:"कृपया समय क्षेत्र का चयन करें",
	   notification_settings:"अधिसूचना सेटिंग्स",
	   level_of_urgency:"तात्कालिकता स्तर",
	   email_destination:"ईमेल गंतव्य",
	   SMS_Destination:"एसएमएस गंतव्य",
	   app:"अनुप्रयोग",
	   please_select_level_of_urgency:"कृपया तात्कालिकता के स्तर का चयन करें",
	   reset_filters:"फ़िल्टर रीसेट करें",
	   batch_data_update:"छात्र डेटा अद्यतन",
	   contract_template:"संविदा टेम्पलेट",
	   accept:"स्वीकार करना",
	   reject:"अस्वीकार करना",
	   view_roles:"भूमिकाएँ देखें",
	   administrator_information:"प्रशासक सूचना", 
	   account_reation_date:"खाता निर्माण तिथि", 
	   expiration_date:"समाप्ति तिथि", 
	   schools:"स्कूलों", 
	   advisees:"सलाह देना",
	   message:"संदेश",
	   see_comments_and_documents:"टिप्पणियाँ और दस्तावेज देखें",
	   restore_APEX_Classrooms:"शीर्ष कक्षाओं को पुनर्स्थापित करें",
	   teacher_information:"शिक्षक सूचना", 
	   teacher_number:"शिक्षक संख्या", 
	   departmens:"प्रस्थानमेन्स", 
	   global_capacity:"वैश्विक क्षमता", 
	   local_contracted_load:"स्थानीय अनुबंधित भार", 
	   parents:"अभिभावक", 
	   parent_information:"माता -पिता की जानकारी", 
	   linked_students:"जुड़े हुए छात्र", 
	   link_student:"लिंक छात्र", 
	   unlink_student:"छात्र को खोलना", 
	   search_dot:"खोजना…", 
	   view_local:"स्थानीय देखें", 
	   view_global:"वैश्विक देखें",
	   resource:"संसाधन",
	   current_grade:"वर्तमान श्रेणी", 
	   affiliation:"संबंधन", 
	   current_assignment:"वर्तमान असाइनमेंट", 
	   total_assignments:"कुल असाइनमेंट", 
	   percent_completed:"प्रतिशत पूरा हुआ",
	   semester:"छमाही",
	   graduation_year:"स्नातक वर्ष", 
	   student_name:"अर्जित क्रेडिट", 
	   credits_earned:"अर्जित क्रेडिट",
	   exit:"बाहर निकलना",
	   engagement_type:"सगाई प्रकार",
	   college_admitted:"भर्ती", 
	   college_attending:"कॉलेज में भाग लेना", 
	   major:"प्रमुख", 
	   report_card:"रिपोर्ट कार्ड", 
	   academic_term:"शैक्षिक कार्यकाल", 
	   show_average:"औसत शो",
	   school_information:"विद्यालय की सूचना",
	   school_misc_configuration:"स्कूल विविध विन्यास", 
	   school_tags:"स्कूल के टैग", 
	   role_tags:"रोल टैग", 
	   content_integration:"सामग्री एकीकरण", 
	   user_roles:"उपयोगकर्ता भूमिका", 
	   communication_user_rules:"संचार उपयोगकर्ता नियम", 
	   school_administrators:"स्कूल प्रशासक", 
	   school_year_configuration:"स्कूल वर्ष विन्यास", 
	   A_R_payment_configuration:"ए/आर भुगतान कॉन्फ़िगरेशन", 
	   facility:"सुविधा", 
	   enrollment_rules:"नामांकन नियम", 
	   student_contract_rules:"छात्र संविदा नियम", 
	   products:"उत्पादों", 
	   notification_templates:"अधिसूचना टेम्प्लेट", 
	   transcript_viewer_options:"प्रतिलेख व्यूअर विकल्प", 
	   feature_configuration:"फ़ीचर कॉन्फ़िगरेशन", 
	   feature_settings:"फ़ीचर सेटिंग्स", 
	   communication_rules:"संचार नियम", 
	   object_state:"वस्तु अवस्था", 
	   departments:"विभागों", 
	   grading_scales:"ग्रेडिंग तराजू", 
	   grading_periods:"ग्रेडिंग अवधि", 
	   academic_tracks:"शैक्षणिक पटरियाँ", 
	   learning_path_templates:"लर्निंग पाथ टेम्प्लेट", 
	   grade_book_activity_descriptions:"ग्रेड बुक गतिविधि विवरण", 
	   academic_terms:"शैक्षणिक शर्तें",
	   academic_system:"शैक्षणिक पद्धति",
	   address_line_1:"पता पंक्ति 1", 
	   country_code:"कंट्री कोड", 
	   address_line_2:"पता पंक्ति नं। 2", 
	   school_title:"विद्यालय का शीर्षक",
	   CEEB_code:"CEEB कोड", 
	   zip_postal_code:"ज़िप / पोस्टल कोड", 
	   state_province:"राज्य/प्रांत", 
	   website:"वेबसाइट", 
	   subdomain:"उप डोमेन", 
	   success_manager:"सफलता प्रबंधक", 
	   school_logo:"स्कूल का लोगो", 
	   digital_seal:"अंकीय मुहर",
	   password_exception_rule:"पासवर्ड अपवाद नियम",
	   change_password_first_login:"पासवर्ड बदलें पहले लॉगिन", 
	   password_expires_after_days:"पासवर्ड समाप्त हो जाता है दिनों के बाद", 
	   enforcement_of_teachers_load:"शिक्षक के भार का प्रवर्तन", 
	   in_house_handling_of_transcript_requests:"ट्रांसक्रिप्ट अनुरोधों के घर में हैंडलिंग", 
	   display_mobile_app_link:"मोबाइल ऐप लिंक प्रदर्शित करें", 
	   display_weekly_progress_goal:"साप्ताहिक प्रगति लक्ष्य प्रदर्शित करें", 
	   turn_on_notification:"सूचनाएं उपलब्ध कराऐं", 
	   classic_letter:"क्लासिक पत्र", 
	   automatic_parent_account_creation:"स्वचालित अभिभावक खाता निर्माण", 
	   default_parent_account_status:"डिफ़ॉल्ट माता -पिता खाता स्थिति", 
	   default_time_zone:"डिफ़ॉल्ट समय क्षेत्र", 
	   link_to_transcript_vendor_help:"प्रतिलेख विक्रेता सहायता के लिए लिंक", 
	   link_to_transcript_vendor:"प्रतिलेख विक्रेता के लिए लिंक", 
	   link_for_help_system:"सहायता प्रणाली के लिए लिंक", 
	   student_enrollment_limit:"छात्र नामांकन सीमा", 
	   default_section_type:"डिफ़ॉल्ट अनुभाग प्रकार", 
	   default_section_capacity:"डिफ़ॉल्ट अनुभाग क्षमता",
	   transcript_template:"प्रतिलेख टेम्पलेट",
	   edit_security_school_tags:"सुरक्षा स्कूल टैग संपादित करें", 
	   security_school_tags:"सुरक्षा स्कूल टैग",
	   tags_name:"टैग नाम", 
	   edit_role_tags:"भूमिका टैग संपादित करें",
	   add_school_based_tags:"स्कूल आधारित टैग जोड़ें", 
	   description:"विवरण", 
	   applied_to_roles:"भूमिकाओं के लिए लागू किया गया", 
	   teacher:"अध्यापक",
	   edit_security_role_tags_for:"के लिए सुरक्षा भूमिका टैग संपादित करें",
	   school_admins:"विद्यालय की प्रशंसा",
	   school_begin_date:"स्कूल शुरू होने की तारीख", 
	   school_end_date:"विद्यालय की समाप्ति तिथि", 
	   automatic_control_of_teacher_s_load:"शिक्षक के भार का स्वचालित नियंत्रण",
	   A_R_payment_gateway_configuration:"ए/आर भुगतान गेटवे कॉन्फ़िगरेशन", 
	   payment_processing_vendor:"अदायगी संसाधन विक्रेता", 
	   secret_key:"गुप्त कुंजी", 
	   publishable_key:"प्रकाशित की कुंजी", 
	   account_id:"खाता आईडी",
	   updating_tudents:"छात्रों को अद्यतन करना", 
	   delete_selected_records:"चयनित रिकॉर्ड हटाएं",
	   attribute_name:"उत्तरदायी ठहराने के लिए नाम", 
	   applied_for:"के लिए आवेदन",
	   add_school:"स्कूल जोड़ें", 
	   overview:"अवलोकन", 
	   search_for_school:"स्कूल के लिए खोज…", 
	   search_for_student:"छात्र के लिए खोज…",
	   attribute_type:"विशेषता प्रकार", 
	   select_school_group:"स्कूल समूह का चयन करें", 
	   access_rights:"पहुंच अधिकार", 
	   create:"बनाएं", 
	   read:"पढ़ना",
	   facility_management:"सुविधा प्रबंधन", 
	   facility_name:"सुविधा का नाम", 
	   capacity:"क्षमता",
	   enrollment_allowance_period_days:"नामांकन भत्ता अवधि (दिन)", 
	   maximum_enrollment_duration_days:"अधिकतम नामांकन अवधि (दिन)", 
	   start_date_of_the_week:"सप्ताह की तारीख शुरू करें", 
	   end_date_of_the_week:"सप्ताह की अंतिम तिथि",
	   lookup_name:"लुकअप नाम", 
	   duration:"अवधि", 
	   time_unit:"समय एकक", 
	   round_up_to_end_of_time_unit:"समय इकाई के अंत तक",
	   product_name:"प्रोडक्ट का नाम",
	   product_ID:"उत्पाद आयडी", 
	   price_offer:"कीमत की पेशकश", 
	   price:"कीमत", 
	   frequency:"आवृत्ति", 
	   effective_from:"से प्रभावी", 
	   effective_to:"के लिए प्रभावी होना", 
	   active:"सक्रिय",
	   drag_drop_to_text_cursor_in_content:"सामग्री में पाठ कर्सर को ड्रैग और ड्रॉप करें", 
	   event_type:"घटना प्रकार", 
	   notification_rule:"अधिसूचना नियम", 
	   level_or_ugency:"स्तरीय या बदाबी", 
	   user_role:"उपयोगकर्ता भूमिकाs",
	   edit_security_user_tags:"सुरक्षा उपयोगकर्ता टैग संपादित करें",
	   content_access:"सामग्री पहुंच", 
	   content_access_for:"के लिए सामग्री का उपयोग", 
	   add_new_access:"नई पहुंच जोड़ें", 
	   date_assigned:"तिथि सौंपी गई",
	   enrollment_request:"तिथि सौंपी गई", 
	   enrollment_request_for:"नामांकन अनुरोध", 
	   mentors:"मेंटर्स",
	   options:"विकल्प",
	   department_name:"विभाग का नाम", 
	   universal_department:"सार्वभौमिक विभाग", 
	   open:"खुला",
	   min_point:"न्यूनतम बिंदु", 
	   max_point:"अधिकतम बिंदु", 
	   grade_point:"ग्रेड बिंदु", 
	   honors:"सम्मान", 
	   college:"कॉलेज",
	   order:"आदेश", 
	   start_time:"समय शुरू", 
	   end_time:"अंत समय",
	   period_name:"अवधि का नाम",
	   grading_periods_head:"ग्रेडिंग अवधि प्रमुख",
	   grading_period:"ग्रेडिंग अवधि", 
	   weight:"वज़न",
	   track_name:"ट्रैक नाम",
	   academic_track_requirement:"अकादमिक ट्रैक आवश्यकता", 
	   of_required_credits:"# आवश्यक क्रेडिट का",
	   individual_learning_plan_template:"#व्यक्तिगत शिक्षण योजना टेम्पलेट",
	   ILP_name:"ILP नाम",
	   remove_requirement:"आवश्यकता निकालें", 
	   reset_requirement:"आवश्यकता को रीसेट करें", 
	   add_requirement:"आवश्यकता जोड़ें",
	   must_end_date:"समाप्ति तिथि चाहिए", 
	   courses_open_date:"पाठ्यक्रम खुली तारीख", 
	   signup_end_date:"साइनअप एंड तिथि", 
	   signup_start_date:"साइनअप स्टार्ट डेट", 
	   section_period:"धारा अवधि",
	   
	    weeks:"हफ्तों", 	 
	   search_for_a_section_or_id:"कोई अनुभाग या आईडी खोजें…", 
	   search_for_a_deft:"एक विभाग के लिए खोजें ...", 
	   launch_course:"लॉन्च कोर्स", 
	   start_class:"कक्षा शुरू", 	   
	   weekly_progress_goal:"साप्ताहिक प्रगति लक्ष्य", 
	   send_message_to_all_section_students:"सभी अनुभाग छात्रों को संदेश भेजें", 
	   monitor_live_sessions:"लाइव सत्रों की निगरानी करें", 
	   average_section_grade:"औसत खंड ग्रेड", 
	   resources:"संसाधन", 
	   activities:"गतिविधियाँ", 	   
	   course_attendance_today:"पाठ्यक्रम उपस्थिति आज", 
	   staffs:"कर्मचारी", 
	   units:"इकाइयों", 	   
	   view_all_15_resources:"सभी 15 संसाधन देखें", 
	   Class_discussions:"वर्ग चर्चाएँ", 
	   recent_discussions:"हाल की चर्चाएँ", 
	   go_to_class_discussions:"कक्षा चर्चाओं पर जाएँ", 	   
	   show_my_class_attendance:"मेरी कक्षा उपस्थिति दिखाओ", 
	   add_section:"अनुभाग जोड़ें",
	   add_global_section:"वैश्विक खंड जोड़ें",
	   close_section:"खंड बंद करें",
	   open_section:"खुला खंड",
	   batch_upload:"बैच अपलोड",
	   finalize:"अंतिम रूप",	   
	   add_tearcger:"शिक्षक जोड़ें",
	   remove_tearcger:"शिक्षक हटाएं",
	   uploadSectionStatusUpdates:"अनुभाग स्थिति अद्यतन अपलोड करें",	   
	   status_count:"स्थिति गणना",	   
	   reactivate:"पुन: सक्रिय",
	   clone:"क्लोन",
	   enroll_into_Section:"अनुभाग में नामांकन करें",
	   bulk_enrollment:"थोक नामांकन",
	   general_Information:"सामान्य जानकारी",	   
	   online_content_source:"ऑनलाइन सामग्री स्रोत",
	   second_teacher:"दूसरा शिक्षक",
	   today:"आज",
	   calendar:"पंचांग",
	   week:"सप्ताह",
	   month:"महीना",
	   section_progress:"खंड प्रगति",
	   complete:"पूर्ण",	   
	   section_title:"अनुभाग शीर्षक",
	   enter_section_title:"अनुभाग शीर्षक दर्ज करें",
	   select_teacher:"शिक्षक का चयन करें",	   
	   select_weeks:"सप्ताह चुनें",
	   select_credits:"क्रेडिट चुनें",
	   select_type:"प्रकार चुनें",
	   global_section:"वैश्विक खंड",	   
	   enrollment_capacity:"नामांकन क्षमता",
	   enter_enrollment_capacity:"नामांकन क्षमता दर्ज करें",
	   in_class_information:"कक्षा सूचना में",
	   Start:"शुरू",
	   End:"अंत",
	   recurrencePattern:"पुनरावृत्ति पैटर्न",
	   recurrenceFrequency:"पुनरावृत्ति आवृत्ति",
	   Weekly:"साप्ताहिक",
	   Monthly:"महीने के",
	   Recur_every:"हर पुनरावृत्ति होना",
	   Weeks_on:"सप्ताह चालू है",
	   day_of_week:"सप्ताह के दिन",
	   daily_period:"दैनिक अवधि",
	   select_daily_period:"दैनिक अवधि का चयन करें",
	   Day:"दिन",
	   The:"The",
	   of_every:"हरेक का",
	   month_s:"महीना",
	   add:"जोड़ें",	   
	   course_prequisites :"पाठ्यक्रम पूर्वापेक्षाएँ",
	   select_status:"स्थिति का चयन करें",
	   select_school:"स्कूलों का चयन करें",	   
	   select_period:"अवधि का चयन करें",
	   room_number:"रूम नंबर",
	   select_room_number:"कक्ष संख्या का चयन करें",
	   Service:"सेवा",
	   enter_url:"यू आर एल दर्ज करो",
	   edit_section:"अनुभाग का संपादन",
	   activity_templates:"गतिविधि टेम्पलेट्स",
	   select_activity_templates:"गतिविधि टेम्पलेट चुनें",
	   link_section:"लिंक अनुभाग",
	   select_link_section:"लिंक अनुभाग का चयन करें",
	   please_select_sections:"कृपया वर्गों का चयन करें।",
	   if_you_change_your_status_of_inactivity:"यदि आप अपनी निष्क्रियता की स्थिति बदलते हैं, तो विद्यार्थी प्रभावित होगा।",
	   closing_the_global_section_will_cause:"वैश्विक खंड को बंद करने से सभी स्कूल बंद हो जाएंगे और उनमें सभी छात्रों की वापसी हो जाएगी। यदि आप आगे बढ़ना चाहते हैं तो कृपया पुष्टि करें पर क्लिक करें।",
	   upload_import_data:"अपलोड और आयात डेटा",
	   here:"यहां",	   
	   no_data_avalable_in_table:"तालिका में आंकड़े उपलब्ध नहीं है",
	   add_teacher_to_multiple_section:"शिक्षक (एस) को कई वर्गों में जोड़ें",
	   select_teachers_to_add_to_multiple_section:"एकाधिक चयनों में जोड़ने के लिए शिक्षकों का चयन करें",
	   selected:"गिने चुने",
	   selected_all:"सभी का चयन करे",
	   deselected_all:"सभी को अचिन्हिंत करें",
	   remove_teacher_from_multiple_section:"शिक्षक (एस) को कई वर्गों से निकालें",
	   select_teacher_to_remove_to:"एकाधिक चयनों को निकालने के लिए शिक्षकों का चयन करें",
	   process_removal:"प्रक्रिया निष्कासन",	   
	   clone_section:"क्लोन अनुभाग",
	   enroll_student:"छात्र दर्ज करें",
	   enroll_student_to:"छात्रों को नामांकित करें",
	   name:"नाम",
	   search_for_a_student_or_id:"एक छात्र या आईडी खोजें ...",
	   confirmation_of_enrollment:"नामांकन की पुष्टि",
	   please_review_and_confirm_enrollments_for:"कृपया के लिए नामांकन की समीक्षा करें और पुष्टि करें",
	   confirm:"पुष्टि करें",
	   enroll_students_to_section:"छात्रों को अनुभाग में नामांकित करें",
	   enrollment_period:"नामांकन अवधि",
	   days:"दिन",
	   no_data_avalible:"कोई डेटा उपलब्ध नहीं है।",
	   number_of_primary_teacher:"प्राथमिक शिक्षकों की संख्या",
	   secondary_teachers:"माध्यमिक शिक्षक",
	   department_head:"विभाग प्रमुख",
	   section_enroll:"अनुभाग नामांकन",
	   load_from_file:"फ़ाइल से लोड करें",
	   see_sections:"अनुभाग देखें", 
	   change_enrollment_status:"नामांकन की स्थिति बदलें", 
	   mentor_s:"संरक्षक", 
	   overdue_activities:"अतिदेय गतिविधियाँ", 
	   total_session_time_and_last_log:"कुल सत्र समय और अंतिम लॉग", 
	   course_name_on_transcript:"प्रतिलेख पर पाठ्यक्रम का नाम", 
	   edit_other_grades:"अन्य ग्रेड संपादित करें", 
	   save_as:"के रूप रक्षित करें", 
	   account_receivable_dashboard:"अकाउंट प्राप्य डैशबोर्ड",
	   key_performance_indicators:"मुख्य निष्पादन संकेतक",
	   a_r_dashboard:"ए/आर डैशबोर्ड",
	   payments_credits:"भुगतान/क्रेडिट",
	   contract_templates:"संविदा टेम्प्लेट",
	   master_contracts:"मास्टर संविदा",
	   a_r_configuration:"ए/आर कॉन्फ़िगरेशन",
	   a_r_processing:"ए/आर प्रसंस्करण",
	   aging:"उम्र बढ़ने",
	   receivable:"प्राप्य",
	   account_receivable_by_program:"कार्यक्रम द्वारा प्राप्य खाता",
	   request_detail:"अनुरोध विवरण",
	    request_information:"जानकारी के लिए अनुरोध करे",
	    requested_by:"द्वारा अनुरोध किया गया",
	    approved_by:"के द्वारा अनुमोदित",
	    approve:"मंज़ूरी देना",
	    phone_name:"फ़ोन नाम",
	    phone_carrier:"फ़ोन वाहक",
		area_code:"एरिया कोड",
	   address_lable:"पता लेबल",
	   address_default:"पता डिफ़ॉल्ट",
	   new_photo:"नई तस्वीर",
	   current_of_wweeks:"हफ्तों का वर्तमान #",
	   select_enrollment_period:"नामांकन अवधि का चयन करें",
	   enter_rejection_reason:"अस्वीकृति का कारण दर्ज करें ...",
	   comments_and_documents:" टिप्पणियाँ और दस्तावेज",
	   enrollment_history:"नामांकन इतिहास",
	   request_extension_for:"के लिए विस्तार से अनुरोध करें",
	   extended_of_weeks:"हफ्तों का # विस्तारित",
	   current_enrollment_status:"वर्तमान नामांकन स्थिति",
	   select_extension_option:"एक्सटेंशन विकल्प का चयन करें",
	   extend_current_enrollment_until:"जब तक वर्तमान नामांकन का विस्तार करें",
	   transfer_to_new_section:"नए अनुभाग में स्थानांतरण",
	   transcript_requests:"प्रतिलेख अनुरोध",
	   person_requesting_transcript:"प्रतिलेख का अनुरोध करने वाला व्यक्ति",
	   telephone_number:"टेलीफोन नंबर",
	   number_of_copies:"प्रतियों की संख्या",
	   special_instructions:"विशेष निर्देश",
	   last_school_attendance:"अंतिम स्कूल उपस्थिति",
	   year_last_attended:"वर्ष में भाग लिया",
	   current_address:"वर्त्तमान पता",
	   relationship_to_student:"छात्र से संबंध",
	   method_of_delivery:"प्रसव की विधि",
	   instructions:"*निर्देश",
	   previous_requests:"पिछला अनुरोध",
	   additional_info:"अतिरिक्त जानकारी",
	   receive:"पाना",
	   process:"प्रक्रिया",
	   add_to_school_group:"स्कूल समूह में जोड़ें",
	   submit_romote:"बढ़ावा देना",
	   next_grade_level:"अगली ग्रेड स्तर",
	   please_select_a_school_for_promotion_and_transfer:"कृपया पदोन्नति और स्थानांतरण के लिए एक स्कूल का चयन करें",
	   write_off:"ख़ारिज करना",
	   amount_due:"देय राशि",
	   open_amount:"खुली राशि",
	   payment_application:"भुगतान आवेदन",
	   use_credit_openBalance:"क्रेडिट $ 111 का उपयोग करें",
	   payment_amount_usd:"भुगतान राशि (USD)",
	   check_number:"चेक संख्या",
	   confirmation_number:"पुष्टिकरण नंबर",
	   apply_payment:"भुगतान लागू करें",
	   amount_paid:"राशि का भुगतान",
	   applied_payment:"अनुप्रयुक्त भुगतान",
	   payer_id:"अदायगी आईडी",
	   view_detail:"विस्तार से देखें",
	   master_contract:"मास्टर संविदा",
	   copy:"प्रतिलिपि",
	   contract_user_detail:"अनुबंध उपयोगकर्ता विवरण",
	   follow_product_cost:"उत्पाद लागत का पालन करें",
	   default_cost:"डिफ़ॉल्ट लागत",
	   offered_cost:"प्रस्तावित लागत",
	   contract_detail:"संविदा विवरण",
	   contract_template_name:"संविदा टेम्पलेट नाम",
	    master_contract_name:"मास्टर संविदा नाम",
		 view_students:"छात्रों को देखें",
		 make_payment:"भुगतान करें",
		 parent_page:"मूल पृष्ठ",
		 edit_parent:"अभिभावक संपादित करें",
		 edit_profile:"प्रोफ़ाइल संपादित करें",
		 account_receivable_configuration:"खाता प्राप्य विन्यास",
		 invoice_generation_date:"चालान उत्पादन तिथि", 
	   invoice_generation:"चालान उत्पादन", 
	   number_of_days_until_due_date:"नियत तारीख तक दिनों की संख्या",
	   account_receivable_processing:"अकाउंट प्राप्य संसाधन",
	   generate_invoices:"चालान उत्पन्न करें", 
	   process_automatic_payments:"प्रक्रिया स्वचालित भुगतान", 
	   send_late_notices:"देर से नोटिस भेजें",
	    course:"पाठ्यक्रम",
	   copy_courses:"कॉपी पाठ्यक्रम",
	   copy_to_school:"स्कूल में कॉपी",
	   originating_program_code:"मूल कार्यक्रम कोड", 
	   destinating_program_code:"नियति संहिता संहिता", 
	   status_error:"स्थिति/त्रुटि",
	   add_prerequisite:"शर्त जोड़ें", 
	   group_name:"समूह नाम", 
	   enter_group_name:"समूह नाम दर्ज करें", 
	   select_a_department_to_display_courses:"पाठ्यक्रम प्रदर्शित करने के लिए एक विभाग का चयन करें", 
	   edit_tranferred_grades:"अन्य ग्रेड संपादित करें", 
	   showing_num_records:"000 रिकॉर्ड दिखा रहा है",
	   edit_all_other_grades:"अन्य सभी ग्रेड संपादित करें",
	   upload_student_documents:"छात्र दस्तावेज अपलोड करें",
	   select_an_official_transcript_option:"एक आधिकारिक प्रतिलेख विकल्प का चयन करें", 
	   for_schools_or_personal_copy:"स्कूलों या व्यक्तिगत प्रति के लिए", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"छात्र के उपयोग के लिए, दूसरे स्कूल में भेजें, या नामांकन को सत्यापित करें।", 
	   request_official_transcript:"आधिकारिक प्रतिलेख का अनुरोध करें", 
	   PARCHMENT_for_colleges_or_universities:"कॉलेजों या विश्वविद्यालयों के लिए चर्मपत्र", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"एक कॉलेज/विश्वविद्यालय के लिए आवेदन के लिए और अपने डिप्लोमा को पूरा करने के लिए।", 
	   request_transcript:"अनुरोध प्रतिलेख", 
	   Learn_more_about_how_to_use_PARCHMENT:"चर्मपत्र का उपयोग करने के तरीके के बारे में और जानें",
	   print_PDF:"प्रिंट पीडीएफ",
	   user_school:"उपयोगकर्ता स्कूल",
	   filter:"फ़िल्टर ",
	   GENERAL:"आम", 
	   STUDENT_INFO:"छात्र की जानकारी", 
	   list:"सूची", 
	   last_school_name:"अंतिम स्कूल का नाम", 
	   TEACHER_INFO:"शिक्षक की जानकारी", 
	   contracted_load:"अनुबंधित भार", 
	   ARENT_INFO:"माता -पिता की जानकारी",
	   add_credential:"क्रेडेंशियल जोड़ें",
	   edit_credential:"संपादन संपादित करें",
	   add_comment_document:"टिप्पणी और दस्तावेज़ जोड़ें",
	   add_comment_document_for:"के लिए टिप्पणी और दस्तावेज़ जोड़ें",
	   state_province:"राज्य/ प्रांत", 
	   post_code:"पोस्ट कोड", 
	   linking_students_to:"छात्रों को जोड़ना", 
	   change_expiration_date:"समाप्ति तिथि बदलें", 
	   expiry_date:"समाप्ति तिथि", 
	   please_select_department:"कृपया विभाग का चयन करें।", 
	   please_select_course:"कृपया पाठ्यक्रम का चयन करें।", 
	   please_select_title:"कृपया शीर्षक दर्ज करें।", 
	   please_select_primary_teacher:"कृपया प्राथमिक शिक्षक का चयन करें।", 
	   please_select_weeks:"कृपया सप्ताह का चयन करें।", 
	   please_select_level:"कृपया स्तर का चयन करें।", 
	   please_select_credits:"कृपया क्रेडिट चुनें।", 
	   please_select_type:"कृपया प्रकार चुनें।", 
	   please_select_daily_period:"कृपया दैनिक अवधि का चयन करें।",
	   please_enter_link_section:"कृपया लिंक अनुभाग दर्ज करें।",
	   please_enter_first_name:"कृपया पहले नाम दर्ज करें।", 
	   please_enter_last_name:"कृपया अंतिम नाम दर्ज करें।", 
	   please_enter_contracted:"कृपया अनुबंधित दर्ज करें।", 
	   please_enter_email:"कृपया ईमेल दर्ज करें।", 
	   please_enter_phone:"कृपया फोन दर्ज करें।", 
	   please_enter_username:"कृपया उपयोगकर्ता नाम दर्ज करें।",
	   please_enter_password:"कृपया पासवर्ड दर्ज करें।", 
	   please_enter_status:"कृपया स्थिति चुनें।", 
	   save_successful:"संग्रहण सफल!।",
	   please_add_student_address:"कृपया छात्र का पता जोड़ें।", 
	   please_enter_email_address:"कृपया ईमेल पता दर्ज करें।", 
	   please_select_relationship:"कृपया संबंध चुनें।", 
	   please_select_parent_status:"कृपया माता -पिता की स्थिति चुनें।", 
	   please_enter_label:"कृपया लेबल दर्ज करें।", 
	   please_enter_address:"कृपया पता दर्ज करें।", 
	   please_enter_city:"कृपया शहर में प्रवेश करें।", 
	   please_enter_state:"कृपया राज्य दर्ज करें।", 
	   please_enter_zip_code:"कृपया ज़िप कोड दर्ज करें।", 
	   please_select_date_of_birth:"कृपया जन्म तिथि का चयन करें।", 
	   please_select_track:"कृपया ट्रैक चुनें।", 
	   please_enter_graduation_date:"कृपया स्नातक तिथि दर्ज करें।", 
	   please_enter_country:"कृपया देश में प्रवेश करें।", 
	   please_enter_phone_number:"कृपया फ़ोन नंबर दर्ज करें।", 
	    please_enter_parent_first_name:"कृपया माता -पिता का पहला नाम दर्ज करें।", 
	   please_enter_parent_last_name:"कृपया अभिभावक अंतिम नाम दर्ज करें।", 
	   please_enter_parent_email_address:"कृपया मूल ईमेल पता दर्ज करें।", 
	   please_enter_parent_username:"कृपया मूल उपयोगकर्ता नाम दर्ज करें।", 
	   please_select_parent_relationship:"कृपया माता -पिता के रिश्ते का चयन करें।", 
	   please_enter_phone_label:"कृपया फोन लेबल दर्ज करें।", 
	   student_address_canot_be_empty:"छात्र का पता खाली नहीं हो सकता।",
	   please_select_document_type:"कृपया दस्तावेज़ प्रकार चुनें।", 
	   please_enter_new_type:"कृपया नए प्रकार दर्ज करें।", 
	   please_enter_comment:"कृपया टिप्पणी दर्ज करें।", 
	   link_is_not_a_valid_url:"लिंक एक मान्य URL नहीं है।",
	   please_enter_link_and_label:"कृपया लिंक और लेबल दर्ज करें।",
	   are_you_sure_to_delete_this_student:"क्या आप इस छात्र को हटाना सुनिश्चित करते हैं।",
	   please_select_gender:"कृपया लिंग चुनें।",
	   school_contracted_load:"अनुबंधित भार", 
	   global_contracted_load:"वैश्विक अनुबंधित भार",
	   please_enter_label_for_attachments:"कृपया अटैचमेंट के लिए लेबल दर्ज करें।",
	   please_select_section:"कृपया अनुभाग चुनें।", 
	   enrollment_completed_successfully:"नामांकन सफलतापूर्वक पूरा हुआ।",
	   delete_this_comment:"इस टिप्पणी को हटा दें?",
	   please_enter_course_name:"कृपया पाठ्यक्रम का नाम दर्ज करें।", 
	   please_select_credits_possible:"कृपया क्रेडिट का चयन करें।",
	   can_save_record:"रिकॉर्ड नहीं बचा सकते:",
	   are_you_sure_to_delete_this_tranferred_grade:"क्या आप इस ट्रेंफर्ड ग्रेड को हटाना सुनिश्चित कर रहे हैं?",
	   are_you_sure_to_delete_num_tranferred_grade:"क्या आप 11 ट्रेंफर्ड ग्रेड को हटाना सुनिश्चित करते हैं?", 
	   please_select_tranferred_grade:"कृपया Tranferred ग्रेड चुनें।",
	   please_ente_subject:"कृपया विषय दर्ज करें।", 
	   please_select_made_to:"कृपया का चयन करें।", 
	   delete_this_communication:"इस संचार को हटा दें?",
	   please_select_school:"कृपया स्कूल का चयन करें।",
	   please_enter_name:"कृपया नाम दर्ज करें।",
	   please_enter_group_name:"कृपया समूह का नाम दर्ज करें।",
	   you_have_some_form_errors_please_check_above:"आपके पास कुछ फॉर्म त्रुटियां हैं। कृपया ऊपर देखें।",
	   please_select_recipient:"कृपया प्राप्तकर्ता का चयन करें।", 
	   please_enter_description:"कृपया विवरण दर्ज करें।",
	   delete_this_resource:"इस संसाधन को हटा दें?",
	   please_enter_activity_name:"कृपया गतिविधि का नाम दर्ज करें।", 
	   please_select_activity_type:"कृपया गतिविधि प्रकार चुनें।", 
	   please_enter_max_score:"कृपया अधिकतम स्कोर दर्ज करें।", 
	   please_enter_due_date:"कृपया नियत तारीख दर्ज करें।",
	   please_enter_unit_name:"कृपया यूनिट का नाम दर्ज करें।",
	   are_you_sure_to_clear_this_unit:"क्या आप इस इकाई को साफ करना सुनिश्चित कर रहे हैं?",
	   please_enter_score:"कृपया स्कोर दर्ज करें।",
	   delete_this_credential:"इस क्रेडेंशियल को हटा दें?",
	   plase_select_period:"कृपया अवधि का चयन करें", 
	   plase_select_start_date:"कृपया प्रारंभ तिथि का चयन करें", 
	   plase_select_end_date:"कृपया अंतिम तिथि का चयन करें",
	   select_to_register_course_to_students_individual_learning_path_view:"छात्रों को व्यक्तिगत शिक्षण पथ दृश्य के लिए रजिस्टर करने के लिए चयन करें",
	   delete_this_request:"इस अनुरोध को हटा दें?",
	   please_enter_fname:"कृपया पहले नाम दर्ज करें।", 
	   please_enter_lname:"कृपया अंतिम नाम दर्ज करें।", 
	   please_enter_birthday:"कृपया जन्मदिन दर्ज करें।", 
	   please_enter_address:"कृपया पता दर्ज करें।", 
	   please_enter_zip:"कृपया ज़िप दर्ज करें।", 
	   please_enter_country:"कृपया देश में प्रवेश करें।", 
	   please_enter_ethnicity:"कृपया जातीयता दर्ज करें।", 
	   please_enter_grade:"कृपया ग्रेड दर्ज करें।", 
	   please_enter_mobile:"कृपया मोबाइल दर्ज करें।", 
	   please_enter_hear_about_us:"कृपया हमारे बारे में सुनें।", 
	   please_enter_program_of_interest:"कृपया ब्याज का कार्यक्रम दर्ज करें।", 
	   please_enter_course_level:"कृपया पाठ्यक्रम स्तर दर्ज करें।", 
	   please_enter_guardian_1_name:"कृपया गार्डियन 1 नाम दर्ज करें।", 
	   please_enter_guardian_1_email:"कृपया गार्जियन 1 ईमेल दर्ज करें।", 
	   please_enter_guardian_1_home_phone:"कृपया गार्जियन 1 होम फोन दर्ज करें।", 
	   please_enter_guardian_1_relation:"कृपया गार्जियन 1 रिलेशन दर्ज करें।",
	   please_select_parents:"कृपया माता -पिता का चयन करें।",
	   transfer_classroom:"अंतरण कक्षा", 
	   please_choose_one_section_to_transfer:"कृपया स्थानांतरण के लिए एक अनुभाग चुनें।", 
	   transfer:"स्थानांतरण",
	   assigning_multiple_users_to_a_school_or_school_group:"एक स्कूल या स्कूल समूह को कई उपयोगकर्ताओं को असाइन करना", 
	   add_to_school_or_school_group:"स्कूल या स्कूल समूह में जोड़ें", 
	   please_select_school_or_school_group:"कृपया स्कूल या स्कूल समूह का चयन करें।",
	   print_student_progress_report:"प्रिंट छात्र प्रगति रिपोर्ट",
 },
 tr:{
	  reporting_center:"Raporlama merkezi", 
	   grade_reports:"Not raporları", 
	   user_reports:"Kullanıcı Raporları", 
	   learning_reports:"Öğrenme Raporları", 
	   administrative_reports:"İdari raporlar", 
	   progress_report:"İlerleme raporu", 
	   full_progress_report:"Tam İlerleme Raporu", 
	   grade_report:"Not raporu", 
	   roster_report:"Kadro Raporu", 
	   parent_report:"Ana rapor", 
	   teacher_report:"Öğretmen raporu", 
	   student_report:"Öğrenci raporu", 
	   log_in_report:"Giriş Raporu", 
	   enrollmentreport:"Kayıt raporu", 
	   enrollment_summary:"Kayıt Özeti", 
	   student_enrollment_summary:"Öğrenci Kayıt Özeti", 
	   attendance_report:"Katılım raporu", 
	   attendance_summary_report:"Katılım Özeti Raporu", 
	   log_In_Credentials:"Giriş kimlik", 
	   application_report:"Başvuru raporu", 
	   section_report:"Bölüm raporu", 
	   course_report:"Kurs raporu", 
	   communication_summary:"İletişim Özeti", 
	   comments_and_Document_Report:"Yorumlar ve Belge Raporu", 
	   School_Calendar:"Okul takvimi", 
	   bell_Schedule:"Çan programı", 
	   student_Contract:"Öğrenci sözleşmesi",
	   eOS_Report:"EOS raporu", 
	   active_Enrollments_Per_Term_Report:"Dönem raporu başına aktif kayıtlar", 
	   active_Student_Enrollments_with_As_Report:"AS Raporu ile Aktif Öğrenci Kayıtları", 
	   active_Student_Enrollments_Report:"Aktif Öğrenci Kayıt Raporu", 
	   all_Students_GPA_Report:"Tüm Öğrenciler GPA raporu", 
	   old_All_Student_GPA_Report:"Eski Tüm Öğrenci GPA Raporu", 
	   billingGroup_Engagement_Type_Report:"BillingGroup + Katılım Türü Raporu", 
	   enrollment_Confirmation_Report:"Kayıt Onay Raporu", 
	   eOS_College_Matriculations_Report:"EOS Kolej Matrisülasyon Raporu", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Öğrenci Kayıt Geçmişi Tarih W Terim Raporu",
	   student_Information_Report:"Öğrenci Bilgi Raporu", 
	   ran_by:"koşmak",
	   Show_Filter:"Filtreyi Göster", 
	   School_Group:"Okul grubu", 
	   school:"Okul", 
	   department:"Departman", 
	   student:"Öğrenci", 
	   student_status:"Öğrenci durumu", 
	   course:"Kurs", 
	   course_level:"Kurs seviyesi", 
	   section:"Bölüm", 
	   teacher:"Öğretmen", 
	   primary_teacher:"İlkokul öğretmeni", 
	   secondary_teacher:"İkincil öğretmen", 
	   completion_Date_Range:"Tamamlama Tarih Aralığı", 
	   from_date:"İtibaren", 
	   to_date:"Bugüne kadar", 
	   status:"Durum", 
	   gender:"Cinsiyet", 
	   final_grade:"Final notu", 
	   advisor:"Danışman", 
	   grade_level:"Sınıf düzeyi", 
	   specific_mark:"Özel not", 
	   track:"İzlemek", 
	   ethnicity:"Etnik köken", 
	   additional_fields:"İlave Alanlar", 
	   school_sessions:"Okul oturumları", 
	   gradebook:"Not kitabı", 
	   submit:"Göndermek", 
	   reset:"Sıfırla", 
	   show_hide_columns:"Sütunları göster/gizle", 
	   select_all:"Hepsini seç", 
	   student_id:"Öğrenci Kimliği", 
	   last_name:"Soy isim", 
	   first_name:"İlk adı", 
	   grade_level:"Sınıf düzeyi", 
	   start_date:"Başlangıç ​​tarihi", 
	   end_date:"Bitiş tarihi", 
	   grade_final:"Sınıf finali", 
	   percent:"Yüzde", 
	   credit:"Kredi", 
	   download_excel:"Excel'i indir", 
	   print:"Yazdır", 
	   no_data:"Veri yok.", 
	   view:"Görüş", 
	   showing:"Gösteriş", 
	   of:"ile ilgili", 
	   other_grade:"Diğer sınıf", 
	   level:"Seviyesi", 
	   date:"Tarih", 
	   grade:"Seviye",
	   enrollment_Change_Status:"Kayıt Değişikliği Durumu", 
	   close:"Kapalı", 
	   select_Enrollment_Status:"Kayıt Durumunu Seçin", 
	   select:"Seçme...", 
	   cancel:"İptal etmek", 
	   save:"Kaydetmek", 
	   students:"Öğrenciler", 
	   Course_Status:"Kurs durumu", 
	   Closed_courses:"Kapalı kurslar", 
	   Section_Status:"Bölüm Durumu", 
	   Closed_sections:"Kapalı bölümler", 
	   Transferred_From:"Aktarıldı",
	   Graduation_From_Date:"Tarihten mezuniyet", 
	   Graduation_To_Date:"Bugüne kadar mezuniyet", 
	   Enrollment_From_Date:"Tarihten Kayıt", 
	   Enrollment_To_Date:"Bugüne kadar kayıt", 
	   Enrollment_Status:"kayıt durumu", 
	   Transfer_From_Date:"Tarihten itibaren transfer", 
	   Transfer_To_Date:"Bugüne kadar transfer", 
	   Custom_Query:"Özel sorgu", 
	   Last_Access_Date:"Son Erişim Tarihi", 
	   Total_Session_Time:"Toplam Oturum Süresi", 
	   Quality_of_Work:"İşin kalitesi", 
	   Grade_to_Date:"Bugüne kadar not", 
	   Overall_Percent:"Genel yüzde", 
	   On_Schedule_Percent:"Çizelge Yüzde", 
	   Activity_Count_Complete:"Etkinlik Sayısı Tamamlandı", 
	   Activity_Count_Total:"Etkinlik Sayısı Toplam", 
	   Overdue_Activitie:"Gecikmiş aktivite",
	   Section_Course_Additional_Fields:"Bölüm/Kurs Ek Alanlar", 
	   Create_On_Date:"Tarihte Oluştur", 
	   Last_Status_Update_Date:"Son Durum Güncelleme Tarihi", 
	   Transferred_In:"Aktarıldı", 
	   Transferred_In_Date:"Tarihte transfer edildi", 
	   email:"E -posta", 
	   birth_date:"Doğum günü", 
	   course_name:"Kurs adı", 
	   section_name:"Bölüm adı", 
	   school_name:"Okul Adı", 
	   Graduation_Date:"Mezuniyet Tarihi", 
	   Created_on:"ON ON", 
	   mentor_Advisor:"Mentor/Danışman",
	   sections:"Bölümler", 
	   roster:"Kadro", 
	   relationship:"İlişki", 
	   Email_or_Phone:"Eposta ya da telefon", 
	   Enter_any_text:"Herhangi bir metni girin", 
	   Advisor_Success_Manager:"Danışman / Başarı Yöneticisi", 
	   User_Id:"Kullanıcı kimliği", 
	   phone_number:"Telefon numarası", 
	   Student_Last_Name:"Öğrenci Soyadı", 
	   Student_First_Name:"Öğrenci Adı", 
	   Student_Email:"Öğrenci e -postası",
	   credentials:"Kimlik bilgileri", 
	   availability:"Kullanılabilirlik",
	   enrollments:"Kayıt", 
	   Datea_Created_on:"Oluşturulan tarih",
	   country:"Ülke", 
	   state:"Durum", 
	   zipcode:"Posta kodu", 
	   Enter_any_zipcode:"Herhangi bir zipcode girin", 
	   address:"Adres",
	   zip_Code:"Posta kodu",
	   Login_Report:"Giriş raporu", 
	   user_Type:"Kullanıcı tipi", 
	   user_Name:"Kullanıcı adı", 
	   Show_last_log_in_only:"Yalnızca son girişi göster", 
	   Username:"Kullanıcı adı", 
	   Date_Time:"Tarih/saat", 
	   Ip_Address:"IP adresi", 
	   city:"Şehir",
	   Enrollment_Start_Date:"Kayıt Başlangıç ​​Tarihi", 
	   Enrollment_End_Date:"Kayıt bitiş tarihi", 
	   Completion_Date:"Tamamlama tarihi", 
	   section_Type:"Bölüm türü", 
	   student_Enrolled:"Öğrenci kayıtlı", 
	   content_Provider:"İçerik sağlayıcı", 
	   student_Additional_Fields:"Öğrenci Ek Alanlar",
	   type:"Tip", 
	   in_Class_Information:"Sınıf bilgileri",
	   Enrollment_Summary_Report:"Kayıt Özeti raporu", 
	   Transferred_From_School:"Okuldan transfer edildi",
	   Total_Enrollments:"Toplam Kayıtlar", 
	   content_Type:"İçerik türü", 
	   active_Course_Progress:"Aktif Kurs İlerleme", 
	   Grades:"Notlar", 
	   attendance:"Katılma",
	   student_Absences:"Öğrenci Devamsızlıkları", 
	   total_Absence:"Toplam devamsızlık", 
	   section_Absences:"Bölüm devamsızlıkları",
	   Grade_Level_Absences:"Sınıf seviyesi devamsızlık",
	   Gender_Absences:"Cinsiyet Devamsızlıkları",
	   Login_credentials:"Giriş kimlik", 
	   names:"İsimler", 
	   user_status_admin_teacher_parent:"Kullanıcı Durumu (Yönetici, Öğretmen, Ebeveyn)", 
	   show_title:"Başlığı göster", 
	   midle_name:"İkinci ad", 
	   password:"Şifre", 
	   parent_name:"Ebeveyn adı", 
	   linked_to_parent:"Ebeveynle bağlantılı", 
	   linked_to_student:"Öğrenciye bağlı",
	   login_credentials_Report:"Giriş Kimlik Bilgileri Raporu", 
	   app_id:"Uygulama Kimliği", 
	   created:"Yaratılmış", 
	   modified:"Değiştirilmiş",
	   select_level:"Seviye seç", 
	   select_additional_fields:"Bölüm Ek Alanlar", 
	   title:"Başlık", 
	   credits:"Kredi", 
	   section_ID:"Bölüm kimliği", 
	   content:"İçerik", 
	   course_additional_fields:"Kurs Ek Alanlar",
	   course_id:"Kurs kimliği", 
	   communication_summary_report:"İletişim Özeti Raporu", 
	   method:"Yöntem", 
	   create_date:"Oluşturma Tarihi", 
	   subject:"Ders", 
	   make_from_id:"Kimlikten yap", 
	   make_to:"Yapmak", 
	   attachments:"Ekler", 
	   comment_and_document_summary_report:"Yorum ve Belge Özeti Raporu", 
	   comment_type:"Yorum türü", 
	   flagged:"İşaretli", 
	   sharing_target:"Paylaşım Hedefi", 
	   show_on_transcript:"Transkript'te Gösteri", 
	   by:"İle", 
	   comment:"Yorum", 
	   type_name:"Tip Adı", 
	   effective_from_date:"Tarihten itibaren geçerli", 
	   effective_to_date:"Bugüne kadar etkili", 
	   count_docs:"Dokümanlar saymak",
	   school_calendar_report:"Okul Takvim Raporu", 
	   event_Id:"Olay kimliği", 
	   date_start:"baslangıç ​​tarihi", 
	   date_end:"Tarih sonu", 
	   posted_last_name:"Yayınlanan Soyadı", 
	   posted_first_name:"Gönderilen Adı",
	   bell_schedule_report:"Bell Programı Raporu", 
	   period:"Dönem", 
	   start:"Başlangıç", 
	   end:"Son",
	   student_contract_report:"Öğrenci Sözleşme Raporu", 
	   begin_date:"Başlangıç ​​tarihi", 
	   contracts:"Sözleşmeler", 
	   contract_name:"Sözleşme adı", 
	   contract_begin_date:"Sözleşme Başlangıç ​​Tarihi", 
	   contract_end_date:"Sözleşme bitiş tarihi",
	   active_enrollments_per_term_report:"Dönem raporu başına aktif kayıtlar", 
	   entry_date:"Giriş tarihi", 
	   teachers:"Öğretmen", 
	   term:"Terim",	   
	   sections:"Bölümler", 
	   showing_of:"20'nin 10'unu gösteriyor", 
	   filter:"Filtre", 
	   students:"Öğrenciler", 
	   school:"Okul", 
	   all_school:"Tüm Okullar", 
	   student:"Öğrenci", 
	   email:"E -posta", 
	   grade_level:"Sınıf düzeyi", 
	   status:"Durum", 
	   seach_for_a_student_or_id:"Bir öğrenci veya kimlik arayın…", 
	   search:"Aramak …", 
	   message_student:"Mesaj öğrencisi", 
	   request_enrollment:"Kayıt İsteği", 
	   print_schedule:"Baskı Çizelgesi", 
	   view:"Görüş", 
	   no_data:"Veri yok.", 
	   views:"Görüntüleme", 
	   enrollment:"Kayıt", 
	   schedule:"Takvim", 
	   transferred_grades:"Aktarılan notlar", 
	   comments_ocuments:"Yorumlar ve Belgeler", 
	   academic_records:"Akademik kayıtlar", 
	   compliance_log:"Uyumluluk Günlüğü", 
	   unofficial_transcript:"Gayri resmi transkript", 
	   iD_card:"Kimlik kartı", 
	   student_number_id_information:"Öğrenci numarası #29561 Bilgi", 
	   student_number:"Öğrenci Numarası", 
	   gender:"Cinsiyet", 
	   goes_by:"Gider", 
	   date_of_birth:"Doğum tarihi", 
	   ethnicity:"Etnik köken", 
	   mobile:"Hareketli", 
	   academic_track:"Akademik parça", 
	   learning_path_template:"Toplu Veri Güncellemesi", 
	   graduation_date:"Mezuniyet Tarihi", 
	   comments:"Yorumlar", 
	   transfer_information:"Bilgi aktarma", 
	   enrollment_date:"Kayıt tarihi", 
	   transfer_date:"Transfer tarihi", 
	   transfer_student:"Nakil öğrenci", 
	   parent_mentor_contact:"Ebeveyn / Mentor İletişim", 
	   mentor:"Akıl hocası", 
	   parent_phone:"Ebeveyn Telefonu", 
	   emergency_contact:"Acil iletişim", 
	   academic_advisor_ssm:"Akademik Danışman / SSM", 
	   student_success_manager:"Öğrenci Başarı Yöneticisi", 
	   academic_avisor:"Akademik Danışman", 
	   address:"Adres", 
	   address_01_Default:"Adres 01 (Varsayılan)", 
	   street:"Sokak", 
	   city:"Şehir", 
	   state:"Durum", 
	   zip:"Zip", 
	   hide_Detailed_information:"Ayrıntılı bilgileri gizle", 	    
	   current_course_progress:"Tam Yol İlerleme", 	    
	   full_Path_Progress:"Tam Yol İlerleme", 	    
	   print:"Yazdır", 	    
	   avg_graduation_progress:"AVG. Mezuniyet ilerlemesi", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Mezuniyet Durumu", 	    
	   on_track:"Takipte", 	    
	   show_detailed_information:"Ayrıntılı bilgileri göster", 	    
	   communication:"İletişim", 	    
	   student_advisors:"Öğrenci danışmanları", 	    
	   country:"Ülke", 	    
	   grade:"Seviye", 	    
	   credits:"Kredi", 	    
	   sort:"Düzenlemek", 	    
	   course_progress:"Kurs İlerleme", 	    
	   overall_GPA:"Genel not ortalaması", 	    
	   current_graduation_progress:"Mevcut mezuniyet ilerlemesi", 	    
	   individual_course_progress:"*Bireysel kurs ilerlemesi değişir, bu sizin genel ilerlemenizdir", 	    
	   subject:"Ders",
	   online_sections:"Çevrimiçi bölümler",
	   course:"Kurs",
	   section:"Bölüm", 
	   actions:"Hareketler", 
	   view_event:"Etkinliği Görüntüle", 
	   in_class_section:"Sınıf bölümünde",
	   calendar:"Takvim", 
	   access_link:"Erişim bağlantısı", 
	   online_link:"Çevrimiçi bağlantı",
	   launch_course:"Başlatma Kursu", 
	   start_class:"Sınıfı başlat", 
	   level:"Seviyesi", 
	   date:"Tarih", 
	   transferred_in:"Aktarıldı", 
	   tranferred_grades:"Aktarılan notlar", 
	   Searchs:"Aramak", 
	   Search_department_course:"Arama Departmanı Kursu, SRC…", 
	   archived:"Arşivlenmiş", 
	   add_comment:"Yorum ekle", 
	   created_date:"Oluşturulan Tarih", 
	   by:"İle", 
	   type:"Tip", 
	   comment:"Yorum", 
	   from_date:"İtibaren", 
	   to_date:"Bugüne kadar", 
	   documents:"Belgeler", 
	   edit:"Düzenlemek", 
	   delete:"Silmek", 
	   communications:"İletişim", 
	   add_communications:"İletişim ekle", 
	   made_from:"Den imal edilmiş", 
	   made_to:"Yapıldı", 
	   means:"Araç", 
	   attachments:"Ekler", 
	   content:"İçerik", 
	   compliance_logs:"Uyum Günlükleri", 
	   messageID:"Mesaj Kimliği", 
	   agree:"Kabul etmek", 
	   dateTime:"Tarih saati", 
	   iPAddress:"IP adresi", 
	   add_idit_comment_document:"Yorum ve Belgeyi Ekle/Düzenle", 
	   document_type:"Belge Türü", 
	   show_on_transcript:"Transkript'te Gösteri", 
	   select_users_to:"Kullanıcıları seçin", 
	   teacher:"Öğretmen", 
	   parent:"Ebeveyn", 
	   flag:"Bayrak", 
	   none:"Hiçbiri", 
	   link:"Bağlantı", 
	   label:"Etiket", 
	   add_more_link:"Daha Fazla Bağlantı Ekle", 
	   save:"Kaydetmek", 
	   add_edit_communication:"İletişimi Ekle/Düzenle", 
	   made_by:"Tarafından yapılan", 
	   date_time:"Tarih/saat", 
	   length:"Uzunluk", 
	   select:"Seçme", 
	   select_users_to_view:"İletişimi görüntülemek için kullanıcıları seçin", 
	   add_more:"Daha ekle", 
	   communication_summary:"İletişim Özeti", 
	   close:"Kapalı", 
	   new_type:"Yeni tip", 	   
	   select_user_to_view_comment:"Yorumu görüntülemek için kullanıcıları seçin", 
	   flag_comment:"Bayrak yorumu", 
	   teacher_page:"Öğretmen sayfası", 
	   edit_information:"Bilgileri Düzenle", 
	   phone:"Telefon",
	   add_credential:"Kimlik bilgisi ekle",
	   add_edit_credential:"Kimlik Bilgisi Ekle/Düzenle",
	   first_name:"İlk adı",
	   midle_name:"İkinci ad",
	   last_name:"Soy isim",
	   cancel:"İptal etmek",
	   add_new:"Yeni ekle",
	   phone_type:"Telefon türü",
	   zipCode:"Posta kodu",
	   phone_number:"Telefon numarası",
	   default:"Varsayılan",
	   please_select_country:"Lütfen Ülke Seçin",
	   student_information:"Öğrenci bilgileri",
	   username:"Kullanıcı adı",
	   user_directory:"Kullanıcı dizin",
	   add_teacher:"Öğretmen ekle",
	   add_admin:"Yönetici Ekle",
	   export_to_excel:"Excel'e İhracat",
	   export_to_pdf:"PDF'ye İhracat",
	   send_login_credentials:"Toplu Veri Güncellemesi",
	   search_for_a_user_or_id:"Bir kullanıcı veya kimlik arayın ...",
	   user:"Kullanıcı",
	   school_admin:"Okul yöneticisi",
	   change_password:"Şifre değiştir",
	   set_password_expiration_date:"Parola Sona Erme Tarihini ayarlayın",
	   impersonate_user:"Kullanıcıyı taklit et",
	   edit_user_tags:"Toplu Veri Güncellemesi",
	   add_or_edit_users_schoo_assign:"Kullanıcılar Okulu atama ekleyin veya düzenleyin",
	   assign_content_access:"İçerik erişimi atayın",
	   add_student:"Öğrenci ekle",
	   add_parent_mentor:"Ebeveyn / mentor ekleyin",
	   showing:"Gösteriş",
	   of:"ile ilgili",
	   school_name:"Okul Adı",
	   edit_user_school_tags:"Kullanıcı Okulu Etiketlerini Düzenle",
	   personal_information:"Kişisel bilgi",
	   contacted_load:"İletişim kuru yük",
	   maximum_of_active_students:"Aktif öğrencilerin maksimum # #",
	   teacher_since:"O zamandan beri öğretmen",
	   login_infomation:"giriş bilgileri",
	   username:"Kullanıcı adı",
	   password :"Şifre",
	   avatar :"Avatar",
	   teachers :"Öğretmen",
	   change_status:"Durum değiştirmek",
	   add_admin:"Yönetici Ekle",
	   name:"İsim",
	   create_on:"Yaratmak",
	   registrar:"Kayıt memuru",
	   birthday:"Doğum günü",
	   signature:"İmza",	   
	   photo:"Fotoğraf",
	   designated_registrar:"Belirlenmiş kayıt memuru",
	   track:"İzlemek",
	   select_existing_track:"Toplu Veri Güncellemesi",
	   available:"Mevcut",
	   parent_mentor:"Ebeveyn / akıl hocası",
	   relationship:"İlişki",
	   email_address:"E -posta adresi",
	   academic_mentor:"Akademik danışman",
	   no_data_available_in_table:"Tabloda veri yok",
	   primary_language:"Birincil dil",
	   add_into_parent_or_mentor:"Ebeveyn / Mentor'a ekle",
	   add_into_phone:"Telefona Ekle",
	   add_into_address:"Adresine Ekle",
	   select_one:"Birini seç",
	   login:"Giriş yapmak",
	   plese_select_country:"Toplu Veri Güncellemesi",
	   edit_student:"Öğrenciyi Düzenle",
	   academic_advisor_or_student_success_manager:"Akademik Danışman / Öğrenci Başarı Yöneticisi",
	   role:"Rol",
	   link_parent:"Bağlantı Ebeveyn",
	   link_advisor_sms:"Bağlantı Danışmanı/SSM",
	   save_into_parent_mentor:"Ebeveyn / Mentor'a kaydedin",
	   save_into_parent_phone:"SToplu Veri Güncellemesi",
	   save_into_parent_address:"Adresine kaydedin",
	   bulk_information_update:"Toplu Bilgi Güncellemesi",
	   enrollments:"Kayıt",
	   email_student:"E -posta Öğrencisi",
	   unofficial_transcripts:"Gayri resmi transkriptler",
	   official_transcripts:"Resmi Transkriptler",
	   email_students_schedule:"E -posta Öğrencinin Programı",
	   export_students_to_excel:"Öğrencileri mükemmelleştirmek için ihraç et",
	   export_parent_list_to_excel:"Excel'e Export Excel Listesi",
	   assign_learning_path_template:"Öğrenme yolu şablonunu atayın",
	   promote_student_to_the_next_grade_level:"Öğrenciyi bir sonraki sınıf seviyesine tanıtın",
	   batch_upload_students:"Öğrencileri toplu yükle",
	   batch_upload_transfer_grades:"Toplu yükleme transfer notları",
	   transfer_apex_only:"Transfer (yalnızca apeks)",
	   transfer_content_providers:"Transfer (tüm içerik sağlayıcıları)",
	   batch_enrollments:"Toplu Kayıtlar",
	   send_message:"Mesaj gönder",
	   impersonate:"Taklit etmek",
	   change_login_credentials:"Giriş Kimlik Bilgilerini Değiştir",
	   request_enrollment:"Kayıt İsteği",
	   send_weekly_status_report:"Haftalık Durum Raporu Gönder",
	   please_select_student:"Lütfen öğrencileri seçin.",
	   student_status_will_be_changed_to_status_withdraw:"Öğrenci statüsü 111 olarak değiştirilecek ve tüm kayıtlar geri çekilecektir. Devam etmek istediğine emin misin?",
	   student_status_will_be_changed_to_status:"Öğrenci statüsü 111 olarak değiştirilecektir. Devam etmek istediğinizden emin misiniz?",
	   value:"Değer",
	   student_success_manager_or_acdemic:"Öğrenci Başarı Yöneticisi / Akademik Danışman",
	   enroll_students_to_section:"Öğrencileri bölüme kaydedin",
	   department:"Departman",
	   refresh:"Yenilemek",
	   select_department:"Toplu Veri Güncellemesi",
	   select_course:"Select course",
	   select_section:"Bölüm seçin",
	   start_date:"Başlangıç ​​tarihi",
	   end_date:"Bitiş tarihi",
	   ID:"ID",
	   action:"Aksiyon",
	   enrollment_period:"Kayıt dönemi",
	   select_a_course_to_register_ilp:"ILP'yi kaydetmek için bir kurs seçin",
	   period:"Dönem",
	   credit:"Kredi",
	   year:"Yıl",
	   enroll:"Kaydetmek",
	   recipient_transcript:"Alıcı transkript",
	   select_all_or_unselect_all:"Tümünü seçin / Tümünü Seçin",
	   include_in_progress_sections:"İlerleme bölümlerini ekleyin",
	   show_satisfaction_of_program:"Programın Memnuniyetini Göster",
	   show_total_credit:"Toplam kredileri göster",
	   show_student_info:"Öğrenci Bilgilerini Göster",
	   show_academic_info:"Akademik bilgileri göster",
	   show_school_names_from_orther_grades:"Diğer sınıflardan okul isimlerini göster",
	   show_school_contact:"Okul İletişimini Göster",
	   include_transferred_grades_in_gpa:"GPA'da transfer edilen notları ekleyin",
	   include_in_progress_grade:"İlerleme notunu dahil et",
	   include_grade_scales:"Sınıf ölçeklerini ekleyin",
	   show_graduation_date:"Mezuniyet Tarihini Göster",
	   show_weighted_gpa:"Ağırlıklı GPA göster",
	   show_grade_level_gpa:"Sınıf Seviyesi GPA'yı Göster",
	   show_comletion_date:"Tamamlama Tarihini Göster",
	   show_withdraw_classes:"Geri Çekilen Sınıfları Göster",
	   show_withdraw_date:"Geri Çekilen Tarihi Göster",
	   show_transfered_in_classes:"Sınıflarda aktarılan gösteri",
	   show_digital_seal:"Dijital contayı göster",
	   show_singnature:"İmzayı Göster",
	   group_by:"Grup",
	   school_year:"Okul yılı",
	   school_level:"Okul seviyesi",
	   notes:"Notlar",
	   ok:"Tamam",
	   are_you_sure_to_send:"Göndereceğinizden emin misin?",
	   assign_learning_path_templete:"Öğrenme yolu şablonunu atayın",
	   assign_student_to_selected_learning:"Öğrenci seçilen öğrenme yolu şablonuna atayın",
	   assign:"Atamak",
	   are_you_sure_to_promote_to_level:"Bir sonraki sınıf seviyesine ulaştığınızdan emin misiniz?",
	   data_process:"Veri süreci",
	   upload_and_import_data:"Verileri Yükle ve İçe Aktar",
	   download_user_information:"Kullanıcı bilgilerini indirin",
	   here:"Burada",
	   select_student_upload_file:"Öğrenci Yükle dosyasını seçin",
	   local_drive:"Yerel sürücü",
	   the_file_is_uploaded:"Dosya yüklendi",
	   template_name:"şablon adı",
	   Here:"Burada",
	   sample_file_excel:"Örnek Dosya Excel.",
	   file_type:"Dosya tipi",
	   delimited:"Sınırlı",
	   delimited_chars:"Sınırlandırılmış karakterler",
	   fixed_width:"Sabit genişlik",
	   first_line_header:"İlk satır başlığı",
	   loader_field:"Yük alanı",
	   Header:"Başlık",
	   sample_data:"Örnek veri",
	   column_width:"Colunm genişliği",
	   save_tamplate:"Şablonu Kaydet",
	   save_and_upload_data:"Verileri Kaydet ve Yükle",
	   result:"Sonuç",
	   upload_and_import_data_orther_grade:"Diğer sınıf verileri yükleyin ve içe aktarın",
	   select_upload_file:"Dosyayı Yükle seçin",
	   student_id:"Öğrenci Kimliği",
	   uploadAnd_import_data_enrollment:"Veri Kaydı Yükle ve İçe Aktar",
	   section_id:"Bölüm kimliği",
	   title:"Başlık",
	   recipient:"Alıcı",
	   same_current_address:"Mevcut adresle aynı",
	   add_more_reciptient:"Daha fazla alıcı ekleyin",
	   issuse_date:"Düzenleme tarihi",
	   show_total_unapplied_credits:"Toplam uygulanmamış kredileri göster",
	   reconcile_another_student_record:"Başka bir öğrenci kaydıyla uzlaşın",
	   please_choose_one_student_to_reconcile:"Lütfen uzlaşmak için bir öğrenci seçin.",
	   yes:"Evet",
	   no:"HAYIR",
	   apex_classroom_sync:"Apex Sınıf Senkronizasyonu",
	   next:"Sonraki",
	   apex_classrooms:"Apeks sınıfları",
	   online_user_id:"Çevrimiçi Kullanıcı Kimliği",
	   enter_online_user_id:"Çevrimiçi Kullanıcı Kimliği girin",
	   online_section_id:"Çevrimiçi Bölüm Kimliği",
	   online_section_name:"Çevrimiçi Bölüm Adı",
	   online_course_name:"Çevrimiçi kurs adı",
	   enrollment_date:"Kayıt tarihi",
	   back:"Geri",
	   import:"İçe aktarmak",
	   offical_transcipt:"Resmi transkript",
	   email_schedule:"E -posta programı",
	   reconcile_with_another_records:"Başka bir kayıtla uzlaşın",
	   online_sync_and_update:"Çevrimiçi İlerleme Senkronizasyonu ve Güncellemesi",
	   download_all_completion_cretification:"Tüm Tamamlama Sertifikasını İndirin",
	   orther_grade:"Diğer notlar",
	   medical:"Tıbbi",
	   comments_and_documents:"Yorumlar ve belgeler",
	   contracts:"Sözleşmeler",
	   invoices:"Faturalar",	   
	   audit_logs:"Denetim Günlükleri",
	   edit_logs:"Günlükleri Düzenle",
	   grade_to_date:"Bugüne kadar not",
	   quality_of_work:"İşin kalitesi",
	   last_access:"Son erişim",
	   gradebook:"Not kitabı",
	   transfer:"Aktar",
	   completion_certification:"Tamamlama sertifikası",
	   tranfer_user_school:"Transfer Kullanıcı Okulu",
	   tranfer_to_school:"Okula transfer",
	   tranfer_apex_classrooms:"Apeks sınıflarını aktarın",
	   course_to_moved:"Harekete geçmek için kurs",
	   current_teacher:"Mevcut Öğretmen",
	   future_section:"Gelecek Bölümü",
	   future_program:"Gelecek Program",
	   future_teacher:"Gelecek Öğretmen",
	   enrollment_start_date_end_date:"Kayıt Başlangıç ​​Tarihi - Bitiş Tarihi",
	   no_more_option:"Daha fazla seçenek yok",
	   create_new:"Yeni oluşturmak",
	   transfer_classrooms:"Aktarma Sınıfları",
	   tyler_synchronization_for_az_school:"AZ okulları için Tyler senkronizasyonu",
	   synchronize:"Senkronize etmek",
	   individual_course_progress_varies:"Bireysel kurs ilerlemesi değişir. Bu, mezuniyete yönelik genel ilerlemenizdir.",
	   edit_ilp:"ILP'yi düzenle",
	   add_academic_record:"Akademik kayıt ekleyin",
	   edit_all_records:"Tüm Kayıtları Düzenle",
	   search_corse_department_src:"Arama Kursu, Bölüm, SRC…",
	   message_id:"Mesaj Kimliği",
	   add_new_contract:"Yeni Sözleşme Ekle",
	   contract_id:"Sözleşme kimliği",
	   contract_name:"Sözleşme adı",
	   first_date:"İlk buluşma",
	   last_date:"Son tarih",
	   amount_per_period:"Dönem başına miktar",
	   terminating_status:"Sonlandırma durumu",
	   payment_history:"ödeme geçmişi",
	   record_payment:"Kayıt Ödeme",
	   payment_method:"Ödeme yöntemi",
	   invoice_id:"Fatura Kimliği",
	   show_all:"Hepsini Göster ↓",
	   invoice_date:"Fatura tarihi",
	   from:"İtibaren…",
	   to:"İle…",
	   amount:"Miktar",
	   paid:"Paralı",
	   due:"Vadesi dolmuş",
	   date_paid:"Ödenen tarih",
	   apply_payments:"Ödeme Uygulama",
	   mark_as_paid:"Ücretli olarak işaretleyin",
	   void:"Geçersiz",
	   audit_log:"Denetim günlüğü",
	   object:"Nesne",
	   changes_made:"Değişiklikler yapıldı",
	   create_time:"Zaman yarat",
	   time_stamp:"Zaman damgası",
	   user_creare:"Kullanıcı Oluştur",
	   edit_log:"Günlüğü Düzenle",
	   field_name:"Alan adı",
	   old_value:"Eski değer",
	   new_value:"Yeni değer",
	   date_time_update:"Tarih/Saat Güncellemesi",
	   updater:"Güncelleyici",
	   add_edit_academic_records:"Akademik Kayıt Ekle/Düzenle",
	   select_flag:"Bayrak seçin ...",
	   edit_all_tranferred_grades:"Tranfered tüm notları düzenle",
	   save_records:"Kayıt Kaydet",
	   possible_credits:"Olası krediler",
	   select_level:"Seviye seç",
	   select_grade_level:"Sınıf seviyesini seçin",
	   select_status:"Durumu seçin",
	   add_more_row:"Daha Fazla Satır Ekle",
	   full_screen:"Tam ekran",
	   course_code:"Kurs kodu",
	   add_order_grades:"Diğer notları ekleyin",
	   select_credit:"Kredi seçin",
	   select_default:"Varsayılan'ı seçin",
	   credits_possible:"Mümkün olan krediler",
	   select_possible_credit:"Olası krediyi seçin",
	   product:"Ürün",
	   fromn:"İtibaren",
	   ton:"İle",
	   last_invoice_date:"Son Fatura Tarihi",
	   please_select_stu:"Lütfen Öğrenci Seçin",
	   payer:"Ödeme yapan kimse",
	   amount_per_billing_period:"Faturalandırma dönemi başına tutar",
	   price_unit:"Birim fiyat",
	   billing_period:"Fatura donemi",
	   automatic_renewal:"otomatik Yenileme",
	   automatic_payment:"Otomatik faturalandırma",
	   contract_template:"Toplu Veri Güncellemesi",
	   accept:"Kabul etmek",
	   reject:"Reddetmek",
	   duration_of_period:"Süre (dönem#)",
	   payment_id:"Ödeme kimliği",
	   payment_date:"Ödeme tarihi",
	   payment_amount:"Ödeme miktarı",
	   applied:"Uygulamalı",
	   available:"Mevcut",
	   unApply:"Uyuşmaz",
	   refund:"Geri ödemek",
	   add_new_teacher:"Yeni Öğretmen Ekle",
	   change_teacher_status:"Öğretmen Durumunu Değiştir",
	   search_for_a_teacher_or_id:"Bir öğretmen veya kimlik arayın…",
	   flags:"Bayraklar",
	   tags:"Etiketler",
	   allowed:"İzin verilmiş",
	   message_teacher:"Mesaj öğretmeni",
	   impersonate_teacher:"Öğretmen taklit et",
	   add_teacher_qualification:"Öğretmen Yeterliliği Ekle",
	   profile:"Profil",
	   teacher_schedule:"Öğretmen programı",
	   qualifications:"Nitelikler",
	   student_actions:"Öğrenci Eylemleri",
	   linking_parents_to:"Ebeveynleri birbirine bağlamak",
	   select_do:"Seçme ...",
	   see_edit_logs:"Günlükleri Düzenle'ye bakın",
	   see_qualifications:"Niteliklere bakın",
	   link_academic_advisor:"Bağlantı akademik danışmanı",
	   student_success:"Öğrenci başarısı",
	   linking_academic_advisor_or_student_success:"Akademik Danışman / Öğrenci Başarısını Bağlamak",
	   staff:"Kadro",
	   teacher_status:"Öğretmen statüsü",
	   school_admin_status:"Okul Yöneticisi Durumu",
	   global_user_directory:"Global Kullanıcı Dizini",
	   edit_teacher:"Öğretmen'i Düzenle",
	   contracted:"Sözleşmeli",
	   add_comments_and_documents:"Yorum ve belge ekleyin",
	   edit_comments_and_documents:"Yorumları ve belgeleri düzenleyin",
	   parents_or_mentor:"Ebeveynler / Mentor",
	   send_mail:"Posta göndermek",
	   are_you_sure_to_delete_this_teacher:"Bu öğretmeni sileceğinizden emin misiniz?",
	   edit_user_password:"Kullanıcı Adı ve Şifreyi Düzenle",
	   add_qualifications:"Nitelikler ekleyin",
	   please_select_a_least_on_teacher:"Lütfen en az bir öğretmen seçin.",
	   edit_parent_mentor:"Ebeveyn / Mentoru Düzenle",
	   parent_mentor_information:"Ebeveyn / Mentor Bilgileri",
	   send:"Göndermek",
	   are_you_surse_to_delete_this_parent:"Toplu Veri Güncellemesi",
	   home:"Ev",
	  // auto_promotion:"Otomatik Promosyon",
	   auto_promotion:"Öğrenci Sınıfı Seviye Tanıtımı",
	   Promote:"Terfi",
	   search_for_a_name:"Bir isim arayın…",
	   download_to_excel:"Excel'e İndir",
	   download_to_pdf:"PDF'ye indir",
	   User_ID:"Kullanıcı kimliği",
	   User_type:"Kullanıcı tipi",
	   communication_log:"İletişim günlüğü",
	   Student_Status:"Öğrenci durumu",
	   Users:"Kullanıcılar",
	   Staff_Reassignment:"Personel yeniden atama",
	   Select_Staff:"Personel Seçin",
	   select_asset_type_to_reassign:"Yeniden atamak için varlık türünü seçin",
	   transfer_all_to:"Hepsini aktarın",
	   transfer_selectively:"Seçici olarak transfer",
	   remove_all:"Hepsini kaldır",
	   remove_selectively:"Seçici olarak kaldır",
	   Event:"Etkinlik",
	   Time:"Zaman",
	   Participants:"Katılımcılar",
	   new_staff:"Yeni personel",
	   Remove:"Kaldırmak",
	   Profile_Page:"Profil sayfası",
	   settings:"Ayarlar",
	   security:"Güvenlik",
	   timezone:"Saat dilimi",
	   notifications:"Bildirimler",
	   check_for_feature_availability_at_your_school:"Okulunuzda özellik kullanılabilirliğini kontrol edin.",
	   current_password:"Mevcut Şifre",
	   new_password:"Yeni Şifre",
	   confirm_password:"Şifreyi Onayla",
	   updte_password:"Şifre güncelle",
	   change_timezone:"Saat dilimini değiştir",
	   time_zone:"Saat dilimi",
	   please_select_time_zone:"Lütfen saat dilimi seçin",
	   notification_settings:"Bildirim ayarları",
	   level_of_urgency:"Aciliyet seviyesi",
	   email_destination:"E -posta hedefi",
	   SMS_Destination:"SMS Hedefi",
	   app:"Uygulama",
	   please_select_level_of_urgency:"Lütfen aciliyet seviyesini seçin",
	   
	   only_jpg_jpeg_png_pdf_files_of_size_2mb_or_smaller_will_be_accepted:"(Yalnızca *.jpg, *.jpeg, *.png, *.pdf dosyaları, 2MB veya daha küçük boyuttaki dosyalar kabul edilecektir)",
      individual_course_progress_varies_this_is_your_overall_progress:"*Tek tek ders ilerlemeleri farklılık gösterebilir, bu genel ilerlemenizdir",
      n_days_in_progress :"11 gün (devam ediyor)",
      n_activities_complete :"11/138 etkinlik tamamlandı",
      showing_17_records:"17 kayıt gösteriliyor",
      showing_n_of_n:"26'nın 10'unu gösteriliyor",
      showing_of:"79'un 10'u gösteriliyor",
      description:"Açıklama",
      description:"Açıklama",
      description:"Açıklama",
      emergency_contact:"Acil Durum İletişimi",
      level_of_urgency:"Aciliyet Seviyesi",
      level_of_urgency:"Aciliyet Seviyesi:",
      first_name:"Ad",
      address:"Adres",
      address:"Adres",
      address_default:"Adres (Varsayılan)",
      academic_information:"Akademik Bilgi",
      active_courses_progress:"Aktif Dersler İlerlemesi",
      home:"Anasayfa",
      searc:"Ara",
      searc:"Ara",
      month:"Ay",
      settings:"Ayarlar",
      start:"Başlangıç",
      start_date:"Başlangıç tarihi",
      title:"Başlık",
      drag_n_drop_some_files_here_or_click_to_select_files:"Bazı dosyaları buraya sürükleyin veya seçmek için tıklayın",
      documents:"Belgeler",
      remember_me:"Beni hatırla",
      format:"Biçim",
      notification_settings:"Bildirim Ayarları",
      notifications:"Bildirimler",
      edit_infomation:"Bilgileri Düzenle",
      for_application_to_a_:"Bir kolej / üniversiteye başvuru ve diploma tamamlama doğrulaması için.",
      need_help_finding_a_course:"Bir kurs bulmaya yardıma ihtiyacınız mı var?",
      end:"Bitiş",
      section:"Bölüm",
      are_you_sure_you_want_to_delete_this_level_urgency:"Bu aciliyet seviyesini silmek istediğinizden emin misiniz?",
      this_is_a_replacement_course:"Bu bir değiştirme kursudur",
      this_is_a_new_course:"Bu yeni bir kurs",
      grade_to_date :"Bugüne kadar Not",
      cc:"Cc",
      offline:"Çevrimdışı",
      online:"Çevrimiçi",
      online_link:"Çevrimiçi bağlantı",
      online_sections:"Çevrimiçi Bölümler",
      gender:"Cinsiyet",
      gender:"Cinsiyet",
      trash:"Çöp Kutusu",
      trash:"Çöp Kutusuna Taşı",
      course:"Ders",
      course_progress:"Ders İlerlemesi",
      course_progress:"Ders İlerlemesi",
      schedule:"Ders proğramı",
      my_schedule:"Ders proğramım",
      launch_course:"Dersi Başlat",
      contact_support:"Destek ile iletişime geçin",
      in_progress :"Devam eden",
      date_of_birth:"Doğum Tarihi",
      date_of_birth:"Doğum Tarihi",
      click_to_attach:"Dosya ekle veya sürükleyin",
      status:"Durum",
      satus:"Durum",
      status:"Durum",
      announcement:"Duyuru",
      email:"E-posta",
      email:"E-posta",
      email_destination:"E-posta Hedefi",
      attachment :"Ek Dosya",
      date_added:"Eklenme Tarihi",
      attachments:"Ekler",
      access:"Erişim",
      access_link:"Erişim bağlantısı",
      label:"Etiket",
      tags:"Etiketler",
      effective_from_date:"Etkili Olma Tarihi",
      effective_to_date:"Etkili Olma Tarihi",
      view_event:"Etkinliği Görüntüle",
      activity_name :"Etkinlik Adı",
      no_event:"Etkinlik Yok",
      activities:"etkinlikler",
      ethnicity:"Etnik Köken",
      ethnicity:"Etnik Köken",
      state:"Eyalet",
      state:"Eyalet",
      actions:"Eylemler",
      filter:"Filtre",
      reset_filters:"Filtreleri Sıfırla",
      inbox:"Gelen Kutusu",
      inbox:"Gelen Kutusu",
      inbox_messages:"Gelen Kutusu Mesajları",
      back_to_inbox:"Gelen kutusuna geri dön",
      overall_gpa:"Genel not ortalaması",
      log_in:"Giriş yap",
      send:"Gönder",
      sent:"Gönderilenler",
      view:"Göster",
      days :"günler",
      week:"Hafta",
      weekly_progress_goal:"Haftalık ilerleme hedefi",
      time_spent :"Harcanan Zaman",
      reply_all:"Hepimize yanıtla",
      reply_all:"Hepimize Yanıtla",
      content:"İçerik",
      midle_name:"İkinci Ad",
      progress_tracking :"İlerleme Takibi",
      forwarded_message:"İleti Yönlendirildi",
      forward:"İletiyi Yönlendir",
      cancel:"İptal",
      cancel:"İptal",
      quality_of_work :"İş Kalitesi",
      quality_of_work :"İş Kalitesi",
      quality_of_work :"İş Kalitesi",
      actions:"İşlemler",
      close:"Kapat",
      date_recorded :"Kaydedilen Tarih",
      save:"Kaydet",
      request_enrollment:"Kayıt İste",
      enrollment_Request:"Kayıt isteği",
      resources :"Kaynaklar",
      from:"Kimden",
      to:"Kime",
      to:"Kime",
      id:"Kimlik",
      create_folder:"Klasör Oluştur",
      subject:"Konu",
      subject:"Konu",
      credits:"Krediler",
      credits:"Krediler",
      username:"Kullanıcı adı",
      goes_by:"Kullanılan İsim",
      goes_by:"Kullanılan İsim",
      terms_of_use:"Kullanım Şartları",
      course_attendance :"Kurs Devamı",
      course_activity_report :"Kurs Etkinlik Puanları Raporu",
      course_progress:"Kurs İlerlemesi",
      course_progress:"Kurs İlerlemesi",
      course_progress_n :"Kurs İlerlemesi %11",
      my_course_enrollment:"Kurs Kaydım",
      launch_course:"Kursu Başlat",
      please_select_level_:"Lütfen aciliyet seviyesi seçin",
      please_choice_time_zone:"Lütfen zaman dilimini seçin",
      message :"Mesaj",
      messages:"Mesajlar",
      current_graduation_:"Mevcut mezuniyet İlerlemesi",
      current_grade :"Mevcut Not",
      current_password:"Mevcut Şifre",
      graduation_status:"Mezuniyet Durumu",
      grade:"Not",
      grade:"Not",
      assignments :"Ödevler",
      student:"Öğrenci",
      upload_student_documents:"Öğrenci Belgeleri Yükle",
      upload_student_documents:"Öğrenci Belgeleri Yükle",
      student_actions:"Öğrenci İşlemleri",
      for_student_use_send_to_another_school_or_to_verify_enrollment:"Öğrenci kullanımı, başka bir okula gönderme veya kayıt doğrulama için.",
      student_page:"Öğrenci Sayfası",
      edit_student:"Öğrenciyi Düzenle",
      learning:"Öğrenme",
      learning_path_progress:"Öğrenme Yolu İlerlemesi",
      learning_path_progress:"Öğrenme Yolu İlerlemesi",
      teacher:"Öğretmen",
      for_schools_or_:"Okullar veya Kişisel Kopya için",
      marsk_as_read:"Okundu Olarak İşaretle",
      as:"olarak",
      log_in_as:"Olarak giriş yap",
      created_date:"Oluşturulma tarihi",
      confirm:"Onayla",
      avg_graduation_:"Ort. Mezuniyet İlerlemesi",
      learning_more_about_:"PARCHMENT'ın nasıl kullanılacağı hakkında daha fazla bilgi edinin",
      print_pdf :"PDF'yi Yazdır",
      print_pdf :"PDF'yi Yazdır",
      zipCode:"Posta Kodu",
      zip:"Posta Kodu",
      score :"Puan",
      view_unofficial_:"Resmi Olmayan Transkripti Görüntüle",
      request_official_:"Resmi Transkript İste",
      request_official_:"Resmi Transkript İste",
      select_an_official_transcript_option:"Resmi transkript seçeneği seçin",
      role:"Rol",
      city:"Şehir",
      city:"Şehir",
      password :"Şifre",
      change_password:"Şifre Değiştir",
      forgot_your_password:"Şifrenizi mi unuttunuz?",
      update_password:"Şifreyi Güncelle",
      confirm_password:"Şifreyi Onayla",
      in_class_section:"Sınıf Bölümünde",
      go_to_class_discussions :"Sınıf Tartışmalarına Git",
      join_class:"Sınıfa Katıl",
      my_classrooms:"Sınıflarım",
      sms:"SMS",
      sms_destination:"SMS Hedefi",
      street:"Sokak",
      last_access :"Son Erişim",
      last_access :"Son Erişim",
      last_access :"Son Erişim",
      recent_discussions :"Son Tartışmalar",
      have_question_ :"Sorularınız var mı veya tartışmaları görüntülemek istiyor musunuz?",
      last_name:"Soyadı",
      ssn:"SSN",
      sent_a_message:"şunun üzerine bir mesaj gönderildi",
      on_track:"Takipte",
      end_impersonation_mode:"Taklit Modundan Çık",
      impersonator:"Taklitçi",
      calendar:"Takvim",
      calendar:"Takvim",
      complete:"tamamla",
      activities :"Tamamlanan Etkinlikler",
      by:"Tarafından",
      grade_to_date :"Tarihe Göre Not",
      grade_to_date :"Tarihe Göre Not",
      on:"tarihinde",
      move:"Taşı",
      request_recommendation:"Tavsiye İste",
      phone:"Telefon",
      phone:"Telefon",
      phone:"Telefon",
      phone_number:"Telefon Numarası",
      phone_type:"Telefon Türü",
      due_date :"Teslim Tarihi",
      assignments_due :"Teslim Tarihi Yaklaşan Ödevler",
      total_time_spent :"Toplam Harcanan Zaman",
      request_transcript_:"Transkript İste (Resmi ve Resmi Olmayan)",
      view_all_resource :"Tüm 60 kaynağı görüntüle",
      view_all_n_messages:"Tüm 95 mesajı görüntüle",
      all_right_reserved:"Tüm hakları saklıdır",
      see_all_classes:"Tüm sınıfları görüntüle",
      type:"Tür",
      type:"Tür",
      country:"Ülke",
      country:"Ülke",
      college_preparatory_track:"Universite Hazırlık Takvimi",
      parchment_for_colleges_:"Üniversiteler için PARCHMENT",
      app:"Uygulama",
      default:"Varsayılan",
      parent_rentor_contact:"Veli / Mentor İletişimi",
      parent_name:"Veli Adı",
      no_data:"Veri yok",
      upcoming_events:"Yaklaşan Etkinlikler",
      upcoming_events:"Yaklaşan Etkinlikler",
      reply:"Yanıtla",
      configuration_notifications:"Yapılandırma Bildirimi Kuralları",
      configuration_notifications:"Yapılandırma Bildirimi Kuralları",
      need_help:"Yardıma mı ihtiyacınız var?",
      print:"Yazdır",
      new:"yeni",
      add_new:"Yeni Ekle",
      select_your_new_course_option:"Yeni kurs seçeneğinizi seçin",
      select_your_new_course:"Yeni kursunuzu seçin",
      new_message:"Yeni Mesaj",
      new_password:"Yeni Şifre",
      year:"Yıl",
      starred:"Yıldızlı İletiler",
      comment:"Yorum",
      timezone:"Zaman Dilimi",
      time_zone:"zaman dilimi",
      change_timezone:"Zaman Dilimini Değiştir",
      batch_data_update:"Öğrenci Veri Güncellemesi",
	  accept:"Kabul etmek",
	  reject:"Reddetmek",
	  view_roles:"Rolleri Görüntüle",
	  administrator_information:"Yönetici Bilgileri", 
	   account_reation_date:"Hesap Oluşturma Tarihi", 
	   expiration_date:"Son kullanma tarihi", 
	   schools:"Okul", 
	   advisees:"Tavsiye",
	   message:"İleti",
	   see_comments_and_documents:"Yorumlara ve belgelere bakın",
	   restore_APEX_Classrooms:"Apex sınıflarını geri yükle",
	   teacher_information:"Öğretmen bilgileri", 
	   teacher_number:"Öğretmen numarası", 
	   departmens:"Departmanlar", 
	   global_capacity:"Küresel kapasite", 
	   local_contracted_load:"Yerel sözleşmeli yük", 
	   parents:"Ebeveynler", 
	   parent_information:"Ana bilgi", 
	   linked_students:"Bağlı Öğrenciler", 
	   link_student:"Bağlantı öğrencisi", 
	   unlink_student:"Öğrenci Unliat", 
	   search_dot:"Aramak…", 
	   view_local:"Yerel görüntüleyin", 
	   view_global:"Global'i görüntüle",
	   resource:"Kaynak",
	   current_grade:"Mevcut sınıf", 
	   affiliation:"Bağlılık", 
	   current_assignment:"Mevcut Görev", 
	   total_assignments:"Toplam Görevler", 
	   percent_completed:"Yüzde tamamlandı",
	   semester:"dönem",
	   graduation_year:"mezuniyet yılı", 
	   student_name:"Kredi kazanıldı", 
	   credits_earned:"Kredi kazanıldı",
	   exit:"çıkış",
	   engagement_type:"Nişan türü",
	   college_admitted:"Üniversite kabul etti", 
	   college_attending:"KOLEJİ Katılıyor", 
	   major:"Ana", 
	   report_card:"Karne", 
	   academic_term:"Akademik dönem", 
	   show_average:"Ortalama Göster",
	   school_information:"Okul bilgileri",
	   school_misc_configuration:"Okul Misc Yapılandırması", 
	   school_tags:"Okul etiketleri", 
	   role_tags:"Rol etiketleri", 
	   content_integration:"İçerik Entegrasyonu", 
	   user_roles:"Kullanıcı rolleri", 
	   communication_user_rules:"İletişim Kullanıcı Kuralları", 
	   school_administrators:"Okul yöneticileri", 
	   school_year_configuration:"Okul yılı yapılandırması", 
	   A_R_payment_configuration:"A/R Ödeme Yapılandırması", 
	   facility:"Tesis", 
	   enrollment_rules:"Kayıt Kuralları", 
	   student_contract_rules:"Öğrenci Sözleşme Kuralları", 
	   products:"Ürünler", 
	   notification_templates:"Bildirim Şablonları", 
	   transcript_viewer_options:"Transkript Görüntüleyici Seçenekleri", 
	   feature_configuration:"Özellik Yapılandırması", 
	   feature_settings:"Özellik Ayarları", 
	   communication_rules:"İletişim Kuralları", 
	   object_state:"Nesne durumu", 
	   departments:"Departmanlar", 
	   grading_scales:"Derecelendirme ölçekleri", 
	   grading_periods:"Derecelendirme dönemleri", 
	   academic_tracks:"Akademik parçalar", 
	   learning_path_templates:"Öğrenme Yolu Şablonları", 
	   grade_book_activity_descriptions:"Sınıf Kitap Etkinlik Açıklamaları", 
	   academic_terms:"Akademik terimler",
	   academic_system:"Akademik sistem",
	   address_line_1:"Adres satırı 1", 
	   country_code:"Ülke kodu", 
	   address_line_2:"Adres Satırı 2", 
	   school_title:"Okul başlığı",
	   CEEB_code:"CEEB kodu", 
	   zip_postal_code:"Zip/Posta Kodu", 
	   state_province:"Eyalet/il", 
	   website:"İnternet sitesi", 
	   subdomain:"Alt alan", 
	   success_manager:"Başarı Yöneticisi", 
	   school_logo:"Okul logosu", 
	   digital_seal:"Dijital mühür",
	   password_exception_rule:"password_exception_rule",
	   change_password_first_login:"Şifreyi Değiştirin Önce Giriş", 
	   password_expires_after_days:"Parola günler sonra sona erer", 
	   enforcement_of_teachers_load:"Öğretmen yükünün uygulanması", 
	   in_house_handling_of_transcript_requests:"Transkript isteklerinin ev işlenmesinde", 
	   display_mobile_app_link:"Mobil uygulama bağlantısını göster", 
	   display_weekly_progress_goal:"Haftalık ilerleme hedefini göster", 
	   turn_on_notification:"Bildirimi aç", 
	   classic_letter:"Klasik mektup", 
	   automatic_parent_account_creation:"Otomatik ebeveyn hesabı oluşturma", 
	   default_parent_account_status:"Varsayılan ana hesap durumu", 
	   default_time_zone:"Varsayılan saat dilimi", 
	   link_to_transcript_vendor_help:"Transkript satıcı yardımına bağlantı", 
	   link_to_transcript_vendor:"Transkript satıcısına bağlantı", 
	   link_for_help_system:"Yardım sistemi için bağlantı", 
	   student_enrollment_limit:"Öğrenci kayıt sınırı", 
	   default_section_type:"Varsayılan bölüm türü", 
	   default_section_capacity:"Varsayılan bölüm kapasitesi",
	   transcript_template:"Transkript şablonu",
	   edit_security_school_tags:"Güvenlik Okulu Etiketlerini Düzenle", 
	   security_school_tags:"Güvenlik Okulu Etiketleri",
	   tags_name:"Etiketler Adı", 
	   edit_role_tags:"Rol etiketlerini düzenle",
	   add_school_based_tags:"Okul tabanlı etiketler ekleyin", 
	   description:"Tanım", 
	   applied_to_roles:"Rollere uygulandı", 
	   teacher:"Öğretmen",
	   edit_security_role_tags_for:"Güvenlik rolü etiketlerini düzenle", 
	   school_admins:"Okul yöneticileri",
	   school_begin_date:"Okul Başlangıç ​​Tarihi", 
	   school_end_date:"Okul bitiş tarihi", 
	   automatic_control_of_teacher_s_load:"Öğretmen yükünün otomatik kontrolü",
	   A_R_payment_gateway_configuration:"A/R ödeme ağ geçidi yapılandırması", 
	   payment_processing_vendor:"Ödeme İşleme Satıcısı", 
	   secret_key:"Gizli anahtar", 
	   publishable_key:"Yayınlanabilir anahtar", 
	   account_id:"Hesap kimliği",
	   updating_tudents:"Öğrencileri güncellemek", 
	   delete_selected_records:"Seçilen Kayıtları Sil",
	   attribute_name:"Nitelik Adı", 
	   applied_for:"Başvurdu",
	   add_school:"Okul ekle", 
	   overview:"Genel bakış", 
	   search_for_school:"Okul arayın…", 
	   search_for_student:"Öğrenci arayın…",
	   attribute_type:"Nitelik Türü", 
	   select_school_group:"Okul Grubu Seçin", 
	   access_rights:"Erişim Hakları", 
	   create:"Yaratmak", 
	   read:"Okumak",
	   facility_management:"Tesis Yönetimi", 
	   facility_name:"Tesis adı", 
	   capacity:"Kapasite",
	   enrollment_allowance_period_days:"Kayıt Ödeneği Dönemi (Gün)", 
	   maximum_enrollment_duration_days:"Maksimum kayıt süresi (günler)", 
	   start_date_of_the_week:"Haftanın Başlangıç ​​Tarihi", 
	   end_date_of_the_week:"Haftanın bitiş tarihi",
	   lookup_name:"Arama Adı", 
	   duration:"Süre", 
	   time_unit:"Zaman birimi", 
	   round_up_to_end_of_time_unit:"Zamanın sonuna kadar birim",
	   product_name:"Ürün adı",
	   product_ID:"ürün kimliği", 
	   price_offer:"Fiyat teklifi", 
	   price:"Fiyat", 
	   frequency:"Sıklık", 
	   effective_from:"İtibaren geçerli", 
	   effective_to:"Etkili", 
	   active:"Aktif",
	   drag_drop_to_text_cursor_in_content:"İçerikte metin imlecine sürükleyin ve bırakın", 
	   event_type:"Etkinlik tipi", 
	   notification_rule:"Bildirim Kuralı", 
	   level_or_ugency:"Seviye veya ugency", 
	   user_role:"Kullanıcı rolü",
	   edit_security_user_tags:"Güvenlik Kullanıcı Etiketlerini Düzenle",
	   content_access:"İçerik erişimi", 
	   content_access_for:"İçin içerik erişimi", 
	   add_new_access:"Yeni Erişim Ekle", 
	   date_assigned:"Atanan tarih",
	   enrollment_request:"Atanan tarih", 
	   enrollment_request_for:"Kayıt talebi", 
	   mentors:"Akıl hocası",
	   options:"Seçenekler",
	   department_name:"Bölüm Adı", 
	   universal_department:"Evrensel departman", 
	   open:"Açık",
	   min_point:"Min Point", 
	   max_point:"Maksimum nokta", 
	   grade_point:"Sayı puanı", 
	   honors:"Onur", 
	   college:"Kolej",
	   grade_name:"Grade Name",
	   order:"Emir", 
	   start_time:"Başlangıç ​​saati", 
	   end_time:"Bitiş zamanı",
	   period_name:"Dönem adı",
	   grading_periods_head:"Derecelendirme dönemleri",
	   grading_period:"Derecelendirme dönemi", 
	   weight:"Ağırlık",
	   track_name:"Parça adı",
	   academic_track_requirement:"Akademik parça gereksinimi", 
	   of_required_credits:"gerekli kredilerin #",
	   individual_learning_plan_template:"Bireysel Öğrenme Planı Şablonu",
	   ILP_name:"ILP adı",
	   remove_requirement:"Gereksinimi Kaldır", 
	   reset_requirement:"Gereksinimi Sıfırla", 
	   add_requirement:"Gereksinim ekle",
	   must_end_date:"Tarih bitmeli", 
	   courses_open_date:"Kurslar Açık Tarih", 
	   signup_end_date:"Kayıt bitiş tarihi", 
	   signup_start_date:"Başlangıç ​​Tarihini Kaydet", 
	   section_period:"Bölüm dönemi",
	   
	   weeks:"haftalar", 
	   search_for_a_section_or_id:"Bir bölüm veya kimlik arayın…", 
	   search_for_a_deft:"Bir bölüm arayın…", 	
	   send_message_to_all_section_students:"Tüm bölüm öğrencilerine mesaj gönderin", 
	   monitor_live_sessions:"Canlı oturumları izleyin", 
	   average_section_grade:"Ortalama bölüm notu", 	   
	   course_attendance_today:"Bugün kursa katılımı", 	   
	   staffs:"Personel", 
	   units:"Birimler", 
	   view_all_15_resources:"15 kaynağın tamamını görüntüleyin", 
	   Class_discussions:"Sınıf tartışmaları", 
	   show_my_class_attendance:"Sınıf katılımımı göster", 
	   add_section:"Bölüm Ekle",
	   add_global_section:"Küresel Bölüm Ekle",
	   close_section:"Kapat bölümleri",
	   open_section:"Açık bölümler",
	   batch_upload:"Toplu yükleme",
	   finalize:"Sonuçlandırmak",
	   add_tearcger:"Öğretmen (ler) ekleyin",
	   remove_tearcger:"Öğretmenleri kaldır",
	   uploadSectionStatusUpdates:"Bölüm Durum Güncellemelerini Yükle",
	   status_count:"Durum sayımı",
	   reactivate:"Yeniden etkinleştirmek",
	   clone:"Klon",
	   enroll_into_Section:"Bölüme kaydolun",
	   bulk_enrollment:"Toplu kaydı",
	   general_Information:"Genel bilgi",
	   online_content_source:"Çevrimiçi İçerik Kaynağı",
	   second_teacher:"İkinci öğretmen",
	   today:"Bugün",		
	   section_progress:"Bölüm İlerleme",
	   section_title:"Bölüm başlığı",
	   enter_section_title:"Bölüm başlığını girin",
	   select_teacher:"Öğretmen seçin",
	   select_weeks:"Haftalar seçin",
	   select_credits:"Kredi Seçin",
	   select_type:"Türü seçin",	   
	   global_section:"Küresel bölüm",
	   enrollment_capacity:"Kayıt kapasitesi",
	   enter_enrollment_capacity:"Kayıt kapasitesini girin",
	   Start:"Başlangıç",
	   End:"Son",
	   recurrencePattern:"Tekrarlama paterni",
	   recurrenceFrequency:"Nüks frekansı",
	   Weekly:"Haftalık",
	   Monthly:"Aylık",
	   Recur_every:"Her şeyi tekrarla",
	   Weeks_on:"Haftalar",
	   day_of_week:"Haftanın günü",
	   daily_period:"Günlük dönem",
	   select_daily_period:"Günlük Dönemi Seçin",
	   Day:"Gün",
	   The:"The",
	   of_every:"herşeyin",
	   month_s:"Ay (S)",
	   add:"Eklemek",
	   course_prequisites :"Kurs Önkoşulları",
	   select_school:"Okulları Seçin",
	   select_period:"Dönemi seçin",
	   room_number:"Oda numarası",
	   select_room_number:"Oda Numarası Seçin",
	   Service:"Hizmet",
	   enter_url:"URL girin",
	   edit_section:"Bölümü düzenle",
	   activity_templates:"Etkinlik Şablonları",
	   select_activity_templates:"Etkinlik Şablonu'nu seçin",
	   link_section:"Bağlantı bölümü",
	   select_link_section:"Bağlantı Bölümü'nü seçin",
	   please_select_sections:"Lütfen bölümleri seçin.",
	   if_you_change_your_status_of_inactivity:"Hareketsizlik durumunuzu değiştirirseniz, öğrenci etkilenecektir.",
	   closing_the_global_section_will_cause:"Küresel bölümün kapanması tüm okullarda kapatılmaya ve içindeki tüm öğrencilerin geri çekilmesine neden olacaktır. Devam etmek isterseniz lütfen onaylayın.",
	   upload_import_data:"Verileri Yükle ve İçe Aktar",
	   no_data_avalable_in_table:"Tabloda veri yok",
	   add_teacher_to_multiple_section:"Birden çok bölüme öğretmen (ler) ekleyin",
	   select_teachers_to_add_to_multiple_section:"Birden çok seçime eklemek için öğretmenleri seçin",
	   selected:"Seçilmiş",
	   selected_all:"Hepsini seç",
	   deselected_all:"Hiçbirini seçme",
	   remove_teacher_from_multiple_section:"Öğretmenleri birden çok bölümden kaldırın",
	   select_teacher_to_remove_to:"Birden çok seçime kaldırmak için öğretmenleri seçin",
	   process_removal:"Okul başlığı",	   
	   clone_section:"Klon bölümü",
	   enroll_student:"Öğrenciyi kaydet",
	   enroll_student_to:"Öğrencileri kaydedin",
	   search_for_a_student_or_id:"Bir öğrenci veya kimlik arayın…",
	   confirmation_of_enrollment:"Kayıt teyidi",
	   please_review_and_confirm_enrollments_for:"Lütfen kayıtları inceleyin ve onaylayın",
	   no_data_avalible:"Veri yok.",
	   number_of_primary_teacher:"İlköğretim Öğretmen Sayısı",
	   secondary_teachers:"Orta öğretim öğretmenleri",
	   department_head:"Bölüm Başkanı",
	   section_enroll:"Bölüm Kayıt",
	   load_from_file:"Dosyadan yükle",
	   see_sections:"Bölümlere bakın",
	   in_class_information:"Sınıf bilgileri",
	   change_enrollment_status:"Kayıt Durumunu Değiştir",
	   mentor_s:"Mentor (lar)",
	   overdue_activities:"Gecikmiş faaliyetler",
	   total_session_time_and_last_log:"Toplam oturum süresi ve son kütük",
	   course_name_on_transcript:"Transcript'te kurs adı",
	   edit_other_grades:"Diğer notları düzenle",
	   save_as:"Farklı kaydet",
	   account_receivable_dashboard:"Hesap Alacak Gösterge Tablosu",
	   key_performance_indicators:"Anahtar Performans Göstergeleri",
	   a_r_dashboard:"A/R Gösterge Tablosu",
	   payments_credits:"Ödemeler/Krediler",
	   contract_templates:"Sözleşme şablonları",
	   master_contracts:"Master sözleşmeleri",
	   a_r_configuration:"A/R yapılandırması",
	   a_r_processing:"A/R İşleme",
	   aging:"Yaşlanma",
	   receivable:"Alacak",
	   account_receivable_by_program:"Programa göre Alacak Hesap",
	   request_detail:"Detay isteyin",
	    request_information:"Bilgi isteme",
	    requested_by:"Tarafından talep edildi",
	    approved_by:"Tarafından onaylandı",
	    approve:"Onaylamak",
	    phone_name:"Telefon adı",
	    phone_carrier:"Telefon taşıyıcısı",
		area_code:"Alan kodu",
	   address_lable:"Adres Lable",
	   address_default:"Adres Varsayılan",
	   new_photo:"Yeni fotoğraf",
	   current_of_wweeks:"Mevcut Haftalar #",
	   select_enrollment_period:"Kayıt dönemini seçin",
	   enter_rejection_reason:"Reddetme nedenini girin ...",
	   comments_and_documents:"Yorumlar ve Belgeler",
	   enrollment_history:"Kayıt geçmişi",
	   request_extension_for:"İçin bir uzantı isteyin",
	   extended_of_weeks:"Genişletilmiş # Haftalar",
	   current_enrollment_status:"Mevcut kayıt durumu",
	   select_extension_option:"Uzatma seçeneğini seçin",
	   extend_current_enrollment_until:"Mevcut kaydı kadar uzatın",
	   transfer_to_new_section:"Yeni bölüme transfer",
	   transcript_requests:"Transkript istekleri",
	   person_requesting_transcript:"Transkript isteyen kişi",
	   telephone_number:"Telefon numarası",
	   number_of_copies:"Kopya sayısı",
	   special_instructions:"Özel Talimatlar",
	   last_school_attendance:"Son Okul Katılımı",
	   year_last_attended:"Son yıl katıldı",
	   current_address:"Mevcut adres",
	   relationship_to_student:"Öğrenci ile ilişki",
	   method_of_delivery:"Teslimat yöntemi",
	   instructions:"*Talimatlar",
	   previous_requests:"Önceki istekler",
	   additional_info:"İlave bilgi",
	   receive:"Almak",
	   process:"İşlem",
	   add_to_school_group:"Okul Grubuna Ekle",
	   submit_romote:"Tanıtım gönder",
	   next_grade_level:"Sonraki Sınıf Seviyesi",
	   please_select_a_school_for_promotion_and_transfer:"Lütfen promosyon ve transfer için bir okul seçin",
	   write_off:"Hurdaya çıkarmak",
	   amount_due:"Alacak miktarı",
	   open_amount:"Açık meblağ",
	   payment_application:"Ödeme başvurusu",
	   use_credit_openBalance:"Kredi kullanın 111 $",
	   payment_amount_usd:"Ödeme Tutarı (USD)",
	   check_number:"Numaraya bak",
	   confirmation_number:"Onay numarası",
	   apply_payment:"Ödeme Uygulama",
	   amount_paid:"Ödenen miktar",
	   applied_payment:"Uygulamalı Ödeme",
	   payer_id:"Ödeyen kimlik",
	   view_detail:"ayrıntılara bakın",
	   master_contract:"Ana sözleşme",
	   copy:"Kopya",
	   contract_user_detail:"Sözleşme Kullanıcı Detayı",
	   follow_product_cost:"Ürün maliyetini takip edin",
	   default_cost:"Varsayılan Maliyet",
	   offered_cost:"Teklif edilen maliyet",
	   contract_detail:"Sözleşme detayı",
	   contract_template_name:"Sözleşme Şablonu Adı",
	    master_contract_name:"Master Sözleşme Adı",
		 view_students:"View Students",
		 make_payment:"Ödeme yapmak",
		 parent_page:"Ana sayfa",
		 edit_parent:"Ebeveyn Düzenle",
		 edit_profile:"Profili Düzenle",
		 account_receivable_configuration:"Hesap Alacak Yapılandırması",
		 invoice_generation_date:"Fatura Üretim Tarihi", 
	   invoice_generation:"Fatura üretimi", 
	   number_of_days_until_due_date:"Son tarihe kadar gün sayısı",
	   account_receivable_processing:"Hesap Alacak İşleme",
	   generate_invoices:"Fatura Oluşturun", 
	   process_automatic_payments:"Otomatik Ödemeleri İşlemle", 
	   send_late_notices:"Geç Bildirimler Gönder",
	   course:"Kurs",
	   copy_courses:"Kopyala Kursları",
	   copy_to_school:"Okula Kopyala",
	   originating_program_code:"Kökenli program kodu", 
	   destinating_program_code:"Program Kodunu Destinasyon", 
	   status_error:"Durum/Hata",
	   add_prerequisite:"Önkoşul ekleyin", 
	   group_name:"Grup ismi", 
	   enter_group_name:"Grup Adını Girin", 
	   select_a_department_to_display_courses:"Kursları görüntülemek için bir departman seçin", 
	   edit_tranferred_grades:"Diğer notları düzenle", 
	   showing_num_records:"000 Kayıt Gösterme",
	   edit_all_other_grades:"Diğer tüm notları düzenleyin",
	   upload_student_documents:"Öğrenci belgelerini yükleyin",
	   select_an_official_transcript_option:"Resmi bir transkript seçeneği seçin", 
	   for_schools_or_personal_copy:"Okullar veya kişisel kopya için", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"Öğrenci kullanımı için başka bir okula gönderin veya kaydı doğrulamak için.", 
	   request_official_transcript:"Resmi Transkript İsteyin", 
	   PARCHMENT_for_colleges_or_universities:"Kolejler veya üniversiteler için parşömen", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"Bir üniversiteye/üniversiteye başvurmak ve diplomanızı tamamlamak için.", 
	   request_transcript:"Transkript İstek", 
	   Learn_more_about_how_to_use_PARCHMENT:"Parşömenleri nasıl kullanacağınız hakkında daha fazla bilgi edinin",
	   print_PDF:"PDF yazdırın",
	   user_school:"Kullanıcı okulu",
	   filter:"Filtre",
	   GENERAL:"GENEL", 
	   STUDENT_INFO:"Öğrenci Bilgileri", 
	   list:"Liste", 
	   last_school_name:"Son Okul Adı", 
	   TEACHER_INFO:"Öğretmen Bilgisi", 
	   contracted_load:"Sözleşmeli yük", 
	   ARENT_INFO:"Ana bilgi",
	   add_credential:"Kimlik bilgisi ekle",
	   edit_credential:"Kimlik Bilgisi Düzenle",
	   add_comment_document:"Yorum ve Belge Ekle",
	   add_comment_document_for:"İçin yorum ve belge ekleyin",
	   state_province:"Eyalet/ il", 
	   post_code:"Posta Kod", 
	   linking_students_to:"Öğrencileri birbirine bağlamak", 
	   change_expiration_date:"Son kullanma tarihini değiştir", 
	   expiry_date:"Son kullanma tarihi", 
	   please_select_department:"Lütfen departmanı seçin.", 
	   please_select_course:"Lütfen kursu seçin.", 
	   please_select_title:"Lütfen başlığı girin.", 
	   please_select_primary_teacher:"Lütfen İlköğretim Öğretmenini seçin.", 
	   please_select_weeks:"Lütfen haftaları seçin.", 
	   please_select_level:"Lütfen Seviye'yi seçin.", 
	   please_select_credits:"Lütfen kredileri seçin.", 
	   please_select_type:"Lütfen Türü seçin.", 
	   please_select_daily_period:"Lütfen günlük dönem seçin.",
	   please_enter_link_section:"Lütfen bağlantı bölümünü girin.",
	   please_enter_first_name:"Lütfen ad girin.", 
	   please_enter_last_name:"Lütfen soyadı girin.", 
	   please_enter_contracted:"Lütfen sözleşmeli girin.", 
	   please_enter_email:"Lütfen e-posta giriniz.", 
	   please_enter_phone:"Lütfen telefonu girin.", 
	   please_enter_username:"Lütfen kullanıcı adı girin.",
	   please_enter_password:"Lütfen şifre giriniz.", 
	   please_enter_status:"Lütfen durum seçin.", 
	   save_successful:"Başarılı Kaydet!.",
	   please_add_student_address:"Lütfen öğrenci adresi ekleyin.", 
	   please_enter_email_address:"Lütfen e -posta adresini girin.", 
	   please_select_relationship:"Lütfen ilişkiyi seçin.", 
	   please_select_parent_status:"Lütfen ebeveyn durumu seçin.", 
	   please_enter_label:"Lütfen Etiketi girin.", 
	   please_enter_address:"Lütfen adresi girin.", 
	   please_enter_city:"Lütfen şehri girin.", 
	   please_enter_state:"Lütfen duruma girin.", 
	   please_enter_zip_code:"Lütfen Posta Kodunu girin.", 
	   please_select_date_of_birth:"Lütfen doğum tarihini seçin.", 
	   please_select_track:"Lütfen Track'i seçin.", 
	   please_enter_graduation_date:"Lütfen mezuniyet tarihine girin.",
	   please_enter_country:"Lütfen ülkeye girin.", 
	   please_enter_phone_number:"Lütfen telefon numarasını girin.", 
	    please_enter_parent_first_name:"Lütfen ebeveyn adını girin.", 
	   please_enter_parent_last_name:"Lütfen ebeveyn soyadı girin.", 
	   please_enter_parent_email_address:"Lütfen ebeveyn e -posta adresini girin.", 
	   please_enter_parent_username:"Lütfen Ebeveyn Kullanıcı Adı girin.", 
	   please_select_parent_relationship:"Lütfen Ebeveyn İlişkisi'ni seçin.", 
	   please_enter_phone_label:"Lütfen telefon etiketini girin.", 
	   student_address_canot_be_empty:"Öğrenci adresi boş olamaz.", 
	   please_select_document_type:"Lütfen Belge Türü'nü seçin.", 
	   please_enter_new_type:"Lütfen yeni türü girin.", 
	   please_enter_comment:"Lütfen yorum girin.", 
	   link_is_not_a_valid_url:"Bağlantı geçerli bir URL değildir.",
	   please_enter_link_and_label:"Lütfen bağlantı ve etiketi girin.",
	   are_you_sure_to_delete_this_student:"Bu öğrenciyi sileceğinizden emin misiniz?",
	   please_select_gender:"Lütfen cinsiyet seç.",
	   school_contracted_load:"Okul sözleşmeli yük", 
	   global_contracted_load:"Küresel sözleşmeli yük",
	   please_enter_label_for_attachments:"Lütfen ekler için etiket girin.",
	   please_select_section:"Lütfen bölüm seçin.", 
	   enrollment_completed_successfully:"Kayıt başarıyla tamamlandı.",
	   delete_this_comment:"Bu yorumu silin mi?",
	   please_enter_course_name:"Lütfen ders adını girin.", 
	   please_select_credits_possible:"Lütfen mümkün olan kredileri seçin.",
	   can_save_record:"Kayıt kaydedilemez:",
	   are_you_sure_to_delete_this_tranferred_grade:"Bu tranferik notu sileceğinizden emin misiniz?",
	   are_you_sure_to_delete_num_tranferred_grade:"11 Tranfered Sınıfı sileceğinizden emin misiniz?", 
	   please_select_tranferred_grade:"Lütfen Tranfered Sınıfı seçin.",
	   please_ente_subject:"Lütfen konuyu girin.", 
	   please_select_made_to:"Lütfen MADE SEÇİN.", 
	   delete_this_communication:"Bu iletişimi silmek?",
	   please_select_school:"Lütfen okulu seçin.",
	   please_enter_name:"Lütfen adı girin.",
	   please_enter_group_name:"Lütfen grup adını girin.",
	   you_have_some_form_errors_please_check_above:"Bazı form hatalarınız var. Lütfen yukarıda kontrol edin.",
	   please_select_recipient:"Lütfen alıcı seçin.", 
	   please_enter_description:"Lütfen Açıklama girin.",
	   delete_this_resource:"Bu kaynağı silin mi?",
	   please_enter_activity_name:"Lütfen etkinlik adını girin.", 
	   please_select_activity_type:"Lütfen etkinlik türünü seçin.", 
	   please_enter_max_score:"Lütfen Max Skorunu girin.", 
	   please_enter_due_date:"Lütfen son tarihi girin.",
	   please_enter_unit_name:"Lütfen birim adını girin.",
	   are_you_sure_to_clear_this_unit:"Bu üniteyi temizlediğinizden emin misiniz?",
	   please_enter_score:"Lütfen puanı girin.",
	   delete_this_credential:"Bu kimlik bilgilerini silin mi?",
	   plase_select_period:"Lütfen Dönemi Seçin", 
	   plase_select_start_date:"Lütfen Başlangıç ​​Tarihini seçin", 
	   plase_select_end_date:"Lütfen bitiş tarihini seçin",
	   select_to_register_course_to_students_individual_learning_path_view:"Öğrencilere Kurs Kaydolmayı Seçin Bireysel Öğrenme Yolu Görünümü",
	   delete_this_request:"Bu isteği silmek?",
	   please_enter_fname:"Lütfen ad girin.", 
	   please_enter_lname:"Lütfen soyadı girin.", 
	   please_enter_birthday:"Lütfen doğum gününe girin.", 
	   please_enter_address:"Lütfen adresi girin.", 
	   please_enter_zip:"Lütfen Zip'i girin.", 
	   please_enter_country:"Lütfen ülkeye girin.", 
	   please_enter_ethnicity:"Lütfen etnik köken girin.", 
	   please_enter_grade:"Lütfen not girin.", 
	   please_enter_mobile:"Lütfen Mobile girin.", 
	   please_enter_hear_about_us:"Lütfen bizi duyun.", 
	   please_enter_program_of_interest:"Lütfen ilgi programını girin.", 
	   please_enter_course_level:"Lütfen kurs seviyesini girin.", 
	   please_enter_guardian_1_name:"Lütfen Guardian 1 adını girin.", 
	   please_enter_guardian_1_email:"Lütfen Guardian 1 e -postasını girin.", 
	   please_enter_guardian_1_home_phone:"Lütfen Guardian 1 ev telefonuna girin.", 
	   please_enter_guardian_1_relation:"Lütfen Guardian 1 ilişkisini girin.",
	   please_select_parents:"Lütfen ebeveynleri seçin.",
	   transfer_classroom:"Transfer Sınıfı", 
	   please_choose_one_section_to_transfer:"Lütfen aktarmak için bir bölümü seçin.", 
	   transfer:"Aktar",
	   assigning_multiple_users_to_a_school_or_school_group:"Bir okula veya okul grubuna birden fazla kullanıcı atamak", 
	   add_to_school_or_school_group:"Okula veya okul grubuna ekleyin", 
	   please_select_school_or_school_group:"Lütfen okul veya okul grubunu seçin.",
	   print_student_progress_report:"Öğrenci İlerleme Raporunu Yazdır",
 },
  mr:{
	   reporting_center:"Rererme टिंग em", 
	   grade_reports:"Hemrेड rearmट", 
	   user_reports:"Raurmasa rearrmटs", 
	   learning_reports:"शिक्षण -रिपोर्ट", 
	   administrative_reports:"Cher re rearmeटें", 
	   progress_report:"Cher गति -rearrmट", 
	   full_progress_report:"Raurm ण er rerer ट", 
	   grade_report:"Hemrेड rearmट", 
	   roster_report:"Rhammarry rearmट", 
	   parent_report:"Lasa raurmeट", 
	   teacher_report:"शिक्षक रिपोर्ट", 
	   student_report:"Lasamr rearmeट", 
	   log_in_report:"Rerermeट में लॉग इन इन इन इन इन इन इन इन इन लॉग लॉग लॉग लॉग", 
	   enrollmentreport:"Thaishasa raurmट", 
	   enrollment_summary:"Thaishasंकनalंकन", 
	   student_enrollment_summary:"Thaisa nama nasalasंकन yसali.", 
	   attendance_report:"Chem थिति erण", 
	   attendance_summary_report:"उपस्थिति सारांश रिपोर्ट", 
	   log_In_Credentials:"लॉग इन.", 
	   application_report:"Hemrयोग rearmट", 
	   section_report:"Lasa raurmeट", 
	   course_report:"Lasa raurm ट", 
	   communication_summary:"Thiral hamalaisंश", 
	   comments_and_Document_Report:"Ne natia ream rama raurmट ट", 
	   School_Calendar:"Ne natisa na char", 
	   bell_Schedule:"Cha", 
	   student_Contract:"Thaisam ne", 
	   eOS_Report:"Re r rearmट", 
	   active_Enrollments_Per_Term_Report:"Ther ति er re re raurmट gry rairिय yasasa ंकन िय", 
	   active_Student_Enrollments_with_As_Report:"Rerermatट के lasa थ e chrिय yasa nasam nasa nasal", 
	   active_Student_Enrollments_Report:"Hemrिय nasal hasa raurmaंकन raurm ट", 
	   all_Students_GPA_Report:"सभी ya gpa gpa rereurmट", 
	   old_All_Student_GPA_Report:"Reria सभी सभी सभी gpa gpa raurmट ट", 
	   billingGroup_Engagement_Type_Report:"Therrुप + cha ई er re rear ट", 
	   enrollment_Confirmation_Report:"Lasasa ंकन em rauryrण", 
	   eOS_College_Matriculations_Report:"ईओएस कॉलेज कॉलेज ramerिकुलेशन", 
	   student_Enrollment_History_To_Date_w_Term_Report:"Thaisa natisal hamasंकन nasa स e dam natmयू re re re raurmट के लिए लिए लिए", 
	   student_Information_Report:"Lasamr hama raurmeट", 
	   ran_by:"के yasद nasal", 
	   Show_Filter:"Datmar chal", 
	   School_Group:"Ne nat कूल -समूह", 
	   school:"Daysti.", 
	   department:"S.a", 
	   student:"Datishamal", 
	   student_status:"स्टूडेंट दर्जा", 
	   course:"अवधि", 
	   course_level:"Saga name म मm", 
	   section:"विभाग", 
	   teacher:"शिक्षक.", 
	   primary_teacher:"प्राथमिक शिक्षक", 
	   secondary_teacher:"माध्यमिक शिक्षक", 
	   completion_Date_Range:"Saसमalपन yasa ंक ंकal", 
	   from_date:"की तिथि से", 
	   to_date:"Sagiarीख तक", 
	   status:"स्थिति", 
	   gender:"लिंग", 
	   final_grade:"अंतिम अंक", 
	   advisor:"Thaisal", 
	   grade_level:"Chrimम nem", 
	   specific_mark:"Nam ट emन", 
	   track:"RAINAS THAY", 
	   ethnicity:"Sausas", 
	   additional_fields:"Raurिकstत nam nam", 
	   school_sessions:"Dam कूल em", 
	   gradebook:"Cher ेडबुक", 
	   submit:"Tha raurya", 
	   reset:"Rीसेट", 
	   show_hide_columns:"स्तंभ दिखाएं/छिपाएं", 
	   select_all:"Sama चयन चयनrें", 
	   student_id:"Chem टूडेंट आईडी", 
	   last_name:"आडनाव", 
	   first_name:"पहिले नाव", 
	   start_date:"आरंभ करने की तिथि", 
	   end_date:"अंतिम तिथि", 
	   grade_final:"Hemrेड yasa इनल", 
	   percent:"Cher तिशत", 
	   credit:"Cher ेय", 
	   download_excel:"Thaisउनलोड", 
	   print:"S.a", 
	   no_data:"कोई कोई नहीं।।", 
	   view:"दृश्य", 
	   showing:"दर्शवित आहे", 
	   of:"च्या", 
	   other_grade:"इतर ग्रेड", 
	   level:"स्तर", 
	   date:"तारीख", 
	   grade:"ग्रेड", 
	   enrollment_Change_Status:"नावनोंदणी बदल स्थिती", 
	   close:"बंद", 
	   select_Enrollment_Status:"नावनोंदणीची स्थिती निवडा", 
	   select:"निवडा ...", 
	   cancel:"रद्द करा", 
	   save:"जतन करा", 
	   students:"विद्यार्थीच्या", 
	   Course_Status:"कोर्स स्थिती", 
	   Closed_courses:"बंद अभ्यासक्रम", 
	   Section_Status:"विभाग स्थिती", 
	   Closed_sections:"बंद विभाग", 
	   Transferred_From:"पासून हस्तांतरित", 
	   Graduation_From_Date:"तारखेपासून पदवी", 
	   Graduation_To_Date:"आजपर्यंतचे पदवी", 
	   Enrollment_From_Date:"तारखेपासून नावनोंदणी", 
	   Enrollment_To_Date:"आजची नोंद", 
	   Enrollment_Status:"नावनोंदणी स्थिती", 
	   Transfer_From_Date:"तारखेपासून हस्तांतरण", 
	   Transfer_To_Date:"आजपर्यंत हस्तांतरण", 
	   Custom_Query:"सानुकूल क्वेरी", 
	   Last_Access_Date:"शेवटची प्रवेश तारीख", 
	   Total_Session_Time:"एकूण सत्र वेळ", 
	   Quality_of_Work:"कामाचा दर्जा", 
	   Grade_to_Date:"आजपर्यंत ग्रेड", 
	   Overall_Percent:"एकूणच टक्के", 
	   On_Schedule_Percent:"वेळापत्रक टक्के वर", 
	   Activity_Count_Complete:"क्रियाकलाप पूर्ण", 
	   Activity_Count_Total:"क्रियाकलाप एकूण मोजणी", 
	   Overdue_Activitie:"थकीत सक्रियता", 
	   Section_Course_Additional_Fields:"विभाग/कोर्स अतिरिक्त फील्ड", 
	   Create_On_Date:"तारखेला तयार करा", 
	   Last_Status_Update_Date:"शेवटची स्थिती अद्यतन तारीख", 
	   Transferred_In:"मध्ये हस्तांतरित", 
	   Transferred_In_Date:"तारखेमध्ये हस्तांतरित", 
	   email:"ईमेल", 
	   birth_date:"जन्मदिनांक", 
	   course_name:"कोर्स नाव", 
	   section_name:"विभाग नाव", 
	   school_name:"शाळेचे नाव", 
	   Graduation_Date:"पदवी दिनांक", 
	   Created_on:"चालू", 
	   mentor_Advisor:"मार्गदर्शक/सल्लागार", 
	   sections:"विभाग", 
	   roster:"रोस्टर", 
	   relationship:"नाते", 
	   Email_or_Phone:"ईमेल किंवा फोन", 
	   Enter_any_text:"कोणताही मजकूर प्रविष्ट करा", 
	   Advisor_Success_Manager:"सल्लागार / यश व्यवस्थापक", 
	   User_Id:"फोन नंबर", 
	   phone_number:"फोन नंबर", 
	   Student_Last_Name:"विद्यार्थी आडनाव", 
	   Student_First_Name:"विद्यार्थी प्रथम नाव", 
	   Student_Email:"विद्यार्थी ईमेल", 
	   credentials:"क्रेडेन्शियल्स", 
	   availability:"उपलब्धता", 
	   enrollments:"नावनोंदणी", 
	   Datea_Created_on:"चालू तारीख", 
	   country:"देश", 
	   state:"राज्य", 
	   zipcode:"पिनकोड", 
	   Enter_any_zipcode:"कोणताही झिपकोड प्रविष्ट करा", 
	   address:"पत्ता", 
	   zip_Code:"पिनकोड", 
	   Login_Report:"लॉगिन अहवाल", 
	   user_Type:"वापरकर्ता प्रकार", 
	   user_Name:"वापरकर्त्याचे नाव", 
	   Show_last_log_in_only:"केवळ शेवटचा लॉग इन दर्शवा", 
	   Username:"वापरकर्तानाव", 
	   Date_Time:"तारीख वेळ", 
	   Ip_Address:"आयपी पत्ता", 
	   city:"शहर", 
	   Enrollment_Start_Date:"नावनोंदणी प्रारंभ तारीख", 
	   Enrollment_End_Date:"नावनोंदणी समाप्ती तारीख", 
	   Completion_Date:"पूर्ण झाल्याची तारीख", 
	   section_Type:"विभाग प्रकार", 
	   student_Enrolled:"विद्यार्थ्याने नोंदणी केली", 
	   content_Provider:"सामग्री प्रदाता", 
	   student_Additional_Fields:"विद्यार्थी अतिरिक्त फील्ड",
	   type:"प्रकार", 
	   in_Class_Information:"वर्ग माहितीमध्ये", 
	   Enrollment_Summary_Report:"नावनोंदणी सारांश अहवाल", 
	   Transferred_From_School:"शाळेतून बदली", 
	   Total_Enrollments:"एकूण नावनोंदणी", 
	   content_Type:"सामग्री प्रकार", 
	   active_Course_Progress:"सक्रिय कोर्स प्रगती", 
	   Grades:"ग्रेड", 
	   attendance:"उपस्थिती", 
	   student_Absences:"विद्यार्थ्यांची अनुपस्थितता", 
	   total_Absence:"एकूण अनुपस्थिती", 
	   section_Absences:"विभाग अनुपस्थित", 
	   Grade_Level_Absences:"ग्रेड लेव्हल अनुपस्थिति", 
	   Gender_Absences:"लिंग अनुपस्थिति", 
	   Login_credentials:"लॉगिन क्रेडेन्शियल्स", 
	   names:"नावे", 
	   user_status_admin_teacher_parent:"वापरकर्ता स्थिती (प्रशासन, शिक्षक, पालक)", 
	   show_title:"शीर्षक दर्शवा", 
	   midle_name:"मधले नाव", 
	   password:"संकेतशब्द", 
	   parent_name:"पालक नाव", 
	   linked_to_parent:"पालकांशी दुवा साधला", 
	   linked_to_student:"विद्यार्थ्याशी दुवा साधला", 
	   login_credentials_Report:"लॉगिन क्रेडेन्शियल्स अहवाल", 
	   app_id:"अ‍ॅप आयडी", 
	   created:"तयार केले", 
	   modified:"सुधारित", 
	   select_level:"स्तर निवडा", 
	   select_additional_fields:"विभाग अतिरिक्त फील्ड", 
	   title:"शीर्षक", 
	   credits:"क्रेडिट्स", 
	   section_ID:"विभाग आयडी", 
	   content:"सामग्री", 
	   course_additional_fields:"कोर्स अतिरिक्त फील्ड", 
	   course_id:"कोर्स आयडी", 
	   communication_summary_report:"संप्रेषण सारांश अहवाल", 
	   method:"पद्धत", 
	   create_date:"तारीख तयार करा", 
	   subject:"विषय", 
	   make_from_id:"आयडी पासून बनवा", 
	   make_to:"बनवा", 
	   attachments:"संलग्नक", 
	   comment_and_document_summary_report:"टिप्पणी आणि दस्तऐवज सारांश अहवाल", 
	   comment_type:"टिप्पणी प्रकार", 
	   flagged:"ध्वजांकित", 
	   sharing_target:"लक्ष्य सामायिकरण", 
	   show_on_transcript:"उतार्‍यावर दर्शवा", 
	   by:"द्वारा", 
	   comment:"टिप्पणी", 
	   type_name:"प्रकार नाव", 
	   effective_from_date:"तारखेपासून प्रभावी", 
	   effective_to_date:"आजपर्यंत प्रभावी", 
	   count_docs:"डॉक्स मोजा", 
	   school_calendar_report:"शालेय कॅलेंडर अहवाल", 
	   event_Id:"इव्हेंट आयडी", 
	   date_start:"तारीख प्रारंभ", 
	   date_end:"तारीख समाप्ती", 
	   posted_last_name:"आडनाव पोस्ट केले", 
	   posted_first_name:"प्रथम नाव पोस्ट केले", 
	   bell_schedule_report:"बेल वेळापत्रक अहवाल", 
	   period:"कालावधी", 
	   start:"प्रारंभ करा", 
	   end:"शेवट", 
	   student_contract_report:"विद्यार्थी कराराचा अहवाल", 
	   begin_date:"प्रारंभ तारीख", 
	   contracts:"करार", 
	   contract_name:"कराराचे नाव", 
	   contract_begin_date:"कराराची सुरूवात तारीख", 
	   contract_end_date:"कराराची समाप्ती तारीख", 
	   active_enrollments_per_term_report:"प्रति टर्म अहवाल सक्रिय नोंदणी", 
	   entry_date:"प्रविष्टी डेटe", 
	   teachers:"शिक्षक", 
	   term:"मुदत", 
	  
	   sections:"विभाग", 
	   showing_of:"20 पैकी 10 दर्शवित आहे", 
	   filter:"फिल्टर", 
	   students:"विद्यार्थीच्या", 
	   school:"शाळा", 
	   all_school:"सर्व शाळा", 
	   student:"विद्यार्थी", 
	   email:"ईमेल", 
	   grade_level:"ग्रेड स्तर", 
	   status:"स्थिती", 
	   seach_for_a_student_or_id:"विद्यार्थी किंवा आयडी शोधा…", 
	   search:"शोध…", 
	   message_student:"संदेश विद्यार्थी", 
	   request_enrollment:"नावनोंदणीची विनंती करा", 
	   print_schedule:"मुद्रण वेळापत्रक", 
	   view:"दृश्य", 
	   no_data:"माहिती उपलब्ध नाही.", 
	   views:"दृश्ये", 
	   enrollment:"नावनोंदणी", 
	   schedule:"वेळापत्रक", 
	   transferred_grades:"हस्तांतरित ग्रेड", 
	   comments_ocuments:"टिप्पण्या आणि कागदपत्रे", 
	   academic_records:"शैक्षणिक नोंदी", 
	   compliance_log:"अनुपालन लॉग", 
	   unofficial_transcript:"अनधिकृत उतारे", 
	   iD_card:"ओळखपत्र", 
	   student_number_id_information:"विद्यार्थ्यांची संख्या #29561 माहिती", 
	   student_number:"विद्यार्थी क्रमांक", 
	   gender:"लिंग", 
	   goes_by:"जाते", 
	   date_of_birth:"जन्म तारीख", 
	   ethnicity:"वांशिकता", 
	   mobile:"मोबाईल", 
	   academic_track:"शैक्षणिक ट्रॅक", 
	   learning_path_template:"पथ टेम्पलेट शिकणे", 
	   graduation_date:"पदवी दिनांक", 
	   comments:"टिप्पण्या", 
	   transfer_information:"हस्तांतरण माहिती", 
	   enrollment_date:"नावनोंदणीची तारीख", 
	   transfer_date:"हस्तांतरण तारीख", 
	   transfer_student:"विद्यार्थी हस्तांतरण", 
	   parent_mentor_contact:"पालक / मार्गदर्शक संपर्क", 
	   mentor:"मेंटोर", 
	   parent_phone:"पालकांचा फोन", 
	   emergency_contact:"आपत्कालीन संपर्क", 
	   academic_advisor_ssm:"शैक्षणिक सल्लागार / एसएसएम", 
	   student_success_manager:"विद्यार्थी यश व्यवस्थापक", 
	   academic_avisor:"शैक्षणिक सल्लागार", 
	   address:"पत्ता", 
	   address_01_Default:"पत्ता 01 (डीफॉल्ट)", 
	   street:"रस्ता", 
	   city:"शहर", 
	   state:"राज्य", 
	   zip:"झिप", 
	   hide_Detailed_information:"तपशीलवार माहिती लपवा", 	    
	   current_course_progress:"सध्याचा कोर्स प्रगती", 	    
	   full_Path_Progress:"पूर्ण पथ प्रगती", 	    
	   print:"मुद्रण", 	    
	   avg_graduation_progress:"एव्हीजी. पदवी प्रगती", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"पदवी स्थिती", 	    
	   on_track:"रुळावर", 	    
	   show_detailed_information:"तपशीलवार माहिती दर्शवा", 	    
	   communication:"संप्रेषण", 	    
	   student_advisors:"विद्यार्थी सल्लागार", 	    
	   country:"देश", 	    
	   grade:"ग्रेड", 	    
	   credits:"क्रेडिट्स", 	    
	   sort:"क्रमवारी लावा", 	    
	   course_progress:"कोर्स प्रगती", 	    
	   overall_GPA:"एकूणच जीपीए", 	    
	   current_graduation_progress:"सध्याची पदवी प्रगती", 	    
	   individual_course_progress:"*वैयक्तिक कोर्सची प्रगती बदलते, ही आपली एकूण प्रगती आहे", 	    
	   subject:"विषय",
	   online_sections:"ऑनलाइन विभाग",
	   course:"कोर्स",
	   section:"विभाग", 
	   actions:"क्रिया", 
	   view_event:"कार्यक्रम पहा", 
	   in_class_section:"वर्ग विभागात",
	   calendar:"कॅलेंडर", 
	   access_link:"प्रवेश दुवा", 
	   online_link:"ऑनलाइन दुवा",
	   launch_course:"लाँच कोर्स", 
	   start_class:"वर्ग सुरू करा", 
	   level:"स्तर", 
	   date:"तारीख", 
	   transferred_in:"मध्ये हस्तांतरित", 
	   tranferred_grades:"हस्तांतरित ग्रेड", 
	   Searchs:"शोध", 
	   Search_department_course:"शोध विभाग कोर्स, एसआरसी…", 
	   archived:"संग्रहित", 
	   add_comment:"टिप्पणी करा", 
	   created_date:"तयार तारीख", 
	   by:"द्वारा", 
	   type:"प्रकार", 
	   comment:"टिप्पणी", 
	   from_date:"या तारखेपासून", 
	   to_date:"आजपर्यंत", 
	   documents:"कागदपत्रे", 
	   edit:"सुधारणे", 
	   delete:"हटवा", 
	   communications:"संप्रेषण", 
	   add_communications:"संप्रेषण जोडा", 
	   made_from:"पासून बनविलेले", 
	   made_to:"बनविले", 
	   means:"म्हणजे", 
	   attachments:"संलग्नक", 
	   content:"सामग्री", 
	   compliance_logs:"अनुपालन लॉग", 
	   messageID:"संदेश आयडी", 
	   agree:"सहमत", 
	   dateTime:"तारीख वेळ", 
	   iPAddress:"आयपी पत्ता", 
	   add_idit_comment_document:"टिप्पणी आणि दस्तऐवज जोडा/संपादित करा", 
	   document_type:"दस्तऐवज प्रकार", 
	   show_on_transcript:"उतार्‍यावर दर्शवा", 
	   select_users_to:"वर वापरकर्ते निवडा", 
	   teacher:"शिक्षक", 
	   parent:"पालक", 
	   flag:"झेंडा", 
	   none:"काहीही नाही", 
	   link:"दुवा", 
	   label:"लेबल", 
	   add_more_link:"अधिक दुवा जोडा", 
	   save:"जतन करा", 
	   add_edit_communication:"संप्रेषण जोडा/संपादित करा", 
	   made_by:"द्वारा केले", 
	   date_time:"तारीख वेळ", 
	   length:"लांबी", 
	   select:"निवडा", 
	   select_users_to_view:"संप्रेषण पाहण्यासाठी वापरकर्त्यांना निवडा", 
	   add_more:"आणखी जोडा", 
	   communication_summary:"संप्रेषण सारांश", 
	   close:"बंद", 
	   new_type:"नवीन प्रकार", 
	   select_user_to_view_comment:"टिप्पणी पाहण्यासाठी वापरकर्त्यांना निवडा", 
	   flag_comment:"ध्वज टिप्पणी", 
	   teacher_page:"शिक्षक पृष्ठ", 
	   edit_information:"माहिती संपादित करा", 
	   phone:"फोन",
	   add_credential:"क्रेडेन्शियल जोडा",
	   add_edit_credential:"क्रेडेन्शियल जोडा/संपादित करा",
	   first_name:"पहिले नाव",
	   midle_name:"मधले नाव",
	   last_name:"आडनाव",
	   cancel:"रद्द करा",
	   add_new:"नवीन जोडा",
	   phone_type:"फोन प्रकार",
	   zipCode:"पिनकोड",
	   phone_number:"फोन नंबर",
	   default:"डीफॉल्ट",
	   please_select_country:"कृपया देश निवडा",
	   student_information:"विद्यार्थ्यांची माहिती",
	   username:"वापरकर्तानाव",
	   user_directory:"वापरकर्ता निर्देशिका",
	   add_teacher:"शिक्षक जोडा",
	   add_admin:"प्रशासन जोडा",
	   export_to_excel:"एक्सेलमध्ये निर्यात करा",
	   export_to_pdf:"पीडीएफला निर्यात करा",
	   send_login_credentials:"लॉगिन क्रेडेन्शियल्स पाठवा",
	   search_for_a_user_or_id:"वापरकर्ता किंवा आयडी शोधा…",
	   user:"वापरकर्ता",
	   school_admin:"शाळा प्रशासन",
	   change_password:"संकेतशब्द बदला",
	   set_password_expiration_date:"संकेतशब्द कालबाह्यता तारीख सेट करा",
	   impersonate_user:"वापरकर्त्याची तोतयागिरी करा",
	   edit_user_tags:"वापरकर्ता टॅग संपादित करा",
	   add_or_edit_users_schoo_assign:"वापरकर्ते शाळा जोडा किंवा संपादित करा",
	   assign_content_access:"सामग्री प्रवेश नियुक्त करा",
	   add_student:"विद्यार्थी जोडा",
	   add_parent_mentor:"पालक / मार्गदर्शक जोडा",
	   showing:"दर्शवित आहे",
	   of:"च्या",
	   school_name:"शाळेचे नाव",
	   edit_user_school_tags:"वापरकर्ता-शालेय टॅग संपादित करा",
	   personal_information:"वैयक्तिक माहिती",
	   contacted_load:"संपर्क लोड",
	   maximum_of_active_students:"सक्रिय विद्यार्थ्यांचे जास्तीत जास्त #",
	   teacher_since:"तेव्हापासून शिक्षक",
	   login_infomation:"लॉग इन माहिती",
	   username:"वापरकर्तानाव",
	   password :"संकेतशब्द",
	   avatar :"अवतार",
	   teachers :"शिक्षक",
	   change_status:"स्थिती बदला",
	   add_admin:"प्रशासन जोडा",
	   name:"नाव",
	   create_on:"चालू करा",
	   registrar:"निबंधक",
	   birthday:"वाढदिवस",
	   signature:"स्वाक्षरी",
	   photo:"छायाचित्र",
	   designated_registrar:"नियुक्त निबंधक",
	   track:"ट्रॅक",
	   select_existing_track:"विद्यमान ट्रॅक निवडा",
	   available:"उपलब्ध",
	   parent_mentor:"पालक / मार्गदर्शक",
	   relationship:"नाते",
	   email_address:"ईमेल पत्ता",
	   academic_mentor:"शैक्षणिक मार्गदर्शक",
	   no_data_available_in_table:"सारणीमध्ये कोणताही डेटा उपलब्ध नाही",
	   primary_language:"प्राथमिक भाषा",
	   add_into_parent_or_mentor:"पालक / मार्गदर्शक मध्ये जोडा",
	   add_into_phone:"फोनमध्ये जोडा",
	   add_into_address:"पत्त्यात जोडा",
	   select_one:"एक निवडा",
	   login:"लॉगिन",
	   plese_select_country:"कृपया देश निवडा",
	   edit_student:"विद्यार्थी संपादित करा",
	   academic_advisor_or_student_success_manager:"शैक्षणिक सल्लागार / विद्यार्थी यश व्यवस्थापक",
	   role:"भूमिका",
	   link_parent:"पालक दुवा",
	   link_advisor_sms:"दुवा सल्लागार/एसएसएम",
	   save_into_parent_mentor:"पालक / मार्गदर्शक मध्ये जतन करा",
	   save_into_parent_phone:"फोनमध्ये जतन करा",
	   save_into_parent_address:"पत्त्यात जतन करा",
	   bulk_information_update:"मोठ्या प्रमाणात माहिती अद्यतन",
	   enrollments:"नावनोंदणी",
	   email_student:"ईमेल विद्यार्थी",
	   unofficial_transcripts:"अनधिकृत लिपी",
	   official_transcripts:"अधिकृत उतारे",
	   email_students_schedule:"ईमेल विद्यार्थ्याचे वेळापत्रक",
	   export_students_to_excel:"एक्सेल करण्यासाठी विद्यार्थ्यांची निर्यात करा",
	   export_parent_list_to_excel:"एक्सेलला पालकांची यादी निर्यात करा",
	   assign_learning_path_template:"शिक्षण पथ टेम्पलेट नियुक्त करा",
	   promote_student_to_the_next_grade_level:"विद्यार्थ्याला पुढील श्रेणी स्तरावर प्रोत्साहन द्या",
	   batch_upload_students:"बॅच अपलोड विद्यार्थी",
	   batch_upload_transfer_grades:"बॅच अपलोड ट्रान्सफर ग्रेड",
	   transfer_apex_only:"हस्तांतरण (केवळ शिखर)",
	   transfer_content_providers:"हस्तांतरण (सर्व सामग्री प्रदाता)",
	   batch_enrollments:"बॅच नावनोंदणी",
	   send_message:"संदेश पाठवा",
	   impersonate:"तोतयागिरी",
	   change_login_credentials:"लॉगिन क्रेडेन्शियल्स बदला",
	   request_enrollment:"नावनोंदणीची विनंती करा",
	   send_weekly_status_report:"साप्ताहिक प्रगती अहवाल पाठवा",
	   please_select_student:"कृपया विद्यार्थी निवडा.",
	   student_status_will_be_changed_to_status_withdraw:"विद्यार्थ्यांची स्थिती 111 मध्ये बदलली जाईल आणि सर्व नोंदणी मागे घेण्यात येतील. आपणास खात्री आहे की आपण सुरू ठेवू इच्छिता?",
	   student_status_will_be_changed_to_status:"विद्यार्थ्यांची स्थिती 111 मध्ये बदलली जाईल. आपल्याला खात्री आहे की आपण सुरू ठेवू इच्छिता?",
	   value:"मूल्य",
	   student_success_manager_or_acdemic:"विद्यार्थी यश व्यवस्थापक / शैक्षणिक सल्लागार",
	   enroll_students_to_section:"विद्यार्थ्यांना विभागात नोंदणी करा",
	   department:"विभाग",
	   refresh:"रीफ्रेश",
	   select_department:"विभाग निवडा",
	   select_course:"कोर्स निवडा",
	   select_section:"विभाग निवडा",
	   start_date:"प्रारंभ तारीख",
	   end_date:"शेवटची तारीख",
	   ID:"ID",
	   action:"क्रिया",
	   enrollment_period:"नावनोंदणी कालावधी",
	   select_a_course_to_register_ilp:"आयएलपी नोंदणी करण्यासाठी कोर्स निवडा",
	   period:"कालावधी",
	   credit:"पत",
	   year:"वर्ष",
	   enroll:"नावनोंदणी",
	   recipient_transcript:"प्राप्तकर्त्याचे उतारे",
	   select_all_or_unselect_all:"सर्व निवडा / सर्व निवडणे",
	   include_in_progress_sections:"प्रगती विभागात समाविष्ट करा",
	   show_satisfaction_of_program:"कार्यक्रमाचे समाधान दर्शवा",
	   show_total_credit:"एकूण क्रेडिट्स दर्शवा",
	   show_student_info:"विद्यार्थ्यांची माहिती दर्शवा",
	   show_academic_info:"शैक्षणिक माहिती दर्शवा",
	   show_school_names_from_orther_grades:"इतर ग्रेडमधून शाळेची नावे दर्शवा",
	   show_school_contact:"शाळेचा संपर्क दर्शवा",
	   include_transferred_grades_in_gpa:"जीपीए मध्ये हस्तांतरित ग्रेड समाविष्ट करा",
	   include_in_progress_grade:"प्रगती ग्रेडमध्ये समाविष्ट करा",
	   include_grade_scales:"ग्रेड स्केल समाविष्ट करा",
	   show_graduation_date:"पदवी तारीख दर्शवा",
	   show_weighted_gpa:"भारित जीपीए दर्शवा",
	   show_grade_level_gpa:"ग्रेड लेव्हल जीपीए दर्शवा",
	   show_comletion_date:"पूर्ण तारीख दर्शवा",
	   show_withdraw_classes:"माघार घेतलेले वर्ग दर्शवा",
	   show_withdraw_date:"मागे घेतलेली तारीख दर्शवा",
	   show_transfered_in_classes:"वर्गात हस्तांतरित करा",
	   show_digital_seal:"डिजिटल सील दर्शवा",
	   show_singnature:"स्वाक्षरी दर्शवा",
	   group_by:"गट द्वारा",
	   school_year:"शालेय वर्ष",
	   school_level:"शाळा पातळी",
	   notes:"नोट्स",
	   ok:"ठीक आहे",
	   are_you_sure_to_send:"आपण निश्चितपणे पाठवणार आहात?",
	   assign_learning_path_templete:"शिक्षण पथ टेम्पलेट नियुक्त करा",
	   assign_student_to_selected_learning:"निवडलेल्या शिक्षण पथ टेम्पलेटला विद्यार्थ्याला नियुक्त करा",
	   assign:"नियुक्त",
	   are_you_sure_to_promote_to_level:"आपण पुढील ग्रेड स्तरावर बढती देण्याची खात्री आहे? ",
	   data_process:"डेटा प्रक्रिया",
	   upload_and_import_data:"डेटा अपलोड करा आणि आयात करा",
	   download_user_information:"वापरकर्त्याची माहिती डाउनलोड करा",
	   here:"येथे",
	   select_student_upload_file:"विद्यार्थी अपलोड फाइल निवडा",
	   local_drive:"स्थानिक ड्राइव्ह",
	   the_file_is_uploaded:"फाईल अपलोड केली आहे",
	   template_name:"टेम्पलेट नाव",
	   Here:"येथे",
	   sample_file_excel:"नमुना फाइल एक्सेल.",
	   file_type:"दस्तावेजाचा प्रकार",
	   delimited:"मर्यादित",
	   delimited_chars:"डीलीमिटेड चार",
	   fixed_width:"निश्चित रुंदी",
	   first_line_header:"प्रथम ओळ शीर्षलेख",
	   loader_field:"लोड फील्ड",
	   Header:"शीर्षलेख",
	   sample_data:"नमुना डेटा",
	   column_width:"कोलूनम रुंदी",
	   save_tamplate:"टेम्पलेट जतन करा",
	   save_and_upload_data:"डेटा जतन करा आणि अपलोड करा",
	   result:"परिणाम",
	   upload_and_import_data_orther_grade:"इतर ग्रेड अपलोड करा आणि आयात करा",
	   select_upload_file:"अपलोड फाइल निवडा",
	   student_id:"विद्यार्थी ओळखपत्र",
	   uploadAnd_import_data_enrollment:"डेटा नावनोंदणी अपलोड करा आणि आयात करा",
	   section_id:"विभाग आयडी",
	   title:"शीर्षक",
	   recipient:"प्राप्तकर्ता",
	   same_current_address:"वर्तमान पत्त्यासारखेच",
	   add_more_reciptient:"अधिक प्राप्तकर्ता जोडा",
	   issuse_date:"जारी तारीख",
	   show_total_unapplied_credits:"एकूण अप्रिय क्रेडिट्स दर्शवा",
	   reconcile_another_student_record:"दुसर्‍या विद्यार्थ्याच्या रेकॉर्डसह समेट करा",
	   please_choose_one_student_to_reconcile:"कृपया समेट करण्यासाठी एक विद्यार्थी निवडा.",
	   yes:"होय",
	   no:"नाही",
	   apex_classroom_sync:"शिखर वर्ग समक्रमण",
	   next:"पुढे",
	   apex_classrooms:"शिखर वर्ग",
	   online_user_id:"ऑनलाइन वापरकर्ता आयडी",
	   enter_online_user_id:"ऑनलाइन वापरकर्ता आयडी प्रविष्ट करा",
	   online_section_id:"ऑनलाइन विभाग आयडी",
	   online_section_name:"ऑनलाइन विभाग नाव",
	   online_course_name:"ऑनलाइन कोर्स नाव",
	   enrollment_date:"नावनोंदणीची तारीख",
	   back:"मागे",
	   import:"आयात",
	   offical_transcipt:"अधिकृत उतारा",
	   email_schedule:"ईमेल वेळापत्रक",
	   reconcile_with_another_records:"दुसर्‍या रेकॉर्डसह समेट करा",
	   online_sync_and_update:"ऑनलाइन प्रगती समक्रमण आणि अद्यतन",
	   download_all_completion_cretification:"सर्व पूर्ण प्रमाणपत्र डाउनलोड करा",
	   orther_grade:"इतर ग्रेड",
	   medical:"वैद्यकीय",
	   comments_and_documents:"टिप्पण्या आणि कागदपत्रे",
	   contracts:"करार",
	   invoices:"पावत्या",
	   audit_logs:"ऑडिट लॉग",
	   edit_logs:"नोंदी संपादित करा",
	   grade_to_date:"आजपर्यंत ग्रेड",
	   quality_of_work:"कामाचा दर्जा",
	   last_access:"शेवटचा प्रवेश",
	   gradebook:"ग्रेडबुक",
	   transfer:"हस्तांतरण",
	   completion_certification:"पूर्ण प्रमाणपत्र",
	   tranfer_user_school:"वापरकर्ता शाळा हस्तांतरित करा",
	   tranfer_to_school:"शाळेत हस्तांतरण",
	   tranfer_apex_classrooms:"शिखर वर्ग हस्तांतरित करा",
	   course_to_moved:"कोर्स हलविला",
	   current_teacher:"सध्याचे शिक्षक",
	   future_section:"भविष्यातील विभाग",
	   future_program:"भविष्यातील कार्यक्रम",
	   future_teacher:"भविष्यातील शिक्षक",
	   enrollment_start_date_end_date:"नावनोंदणी प्रारंभ तारीख - शेवटची तारीख",
	   no_more_option:"आणखी पर्याय नाहीत",
	   create_new:"नवीन तयार करा",
	   transfer_classrooms:"वर्गात हस्तांतरित करा",
	   tyler_synchronization_for_az_school:"एझेड स्कूलसाठी टायलर सिंक्रोनाइझेशन",
	   synchronize:"समक्रमित",
	   individual_course_progress_varies:"वैयक्तिक कोर्सची प्रगती बदलते. पदवीच्या दिशेने ही आपली एकूण प्रगती आहे.",
	   edit_ilp:"आयएलपी संपादित करा",
	   add_academic_record:"शैक्षणिक रेकॉर्ड जोडा",
	   edit_all_records:"सर्व रेकॉर्ड संपादित करा",
	   search_corse_department_src:"शोध कोर्स, विभाग, एसआरसी…",
	   message_id:"संदेश आयडी",
	   add_new_contract:"नवीन करार जोडा",
	   contract_id:"कॉन्ट्रॅक्ट आयडी",
	   contract_name:"कराराचे नाव",
	   first_date:"पहिली तारीख",
	   last_date:"शेवटची तारीख",
	   amount_per_period:"प्रति कालावधी रक्कम",
	   terminating_status:"संपुष्टात आणणारी स्थिती",
	   payment_history:"देय इतिहास",
	   record_payment:"रेकॉर्ड देयक",
	   payment_method:"देय पद्धत",
	   invoice_id:"बीजक आयडी",
	   show_all:"सगळं दाखवा",
	   invoice_date:"बीजक तारीख",
	   from:"पासून…",
	   to:"टू…",
	   amount:"रक्कम",
	   paid:"देय",
	   due:"देय",
	   date_paid:"तारीख भरली",
	   apply_payments:"देयके लागू करा",
	   mark_as_paid:"देय म्हणून चिन्हांकित करा",
	   void:"शून्य",
	   audit_log:"ऑडिट लॉग",
	   object:"ऑब्जेक्ट",
	   changes_made:"बदल केले",
	   create_time:"वेळ तयार करा",
	   time_stamp:"वेळ मुद्रांक",
	   user_creare:"वापरकर्ता तयार",
	   edit_log:"लॉग संपादित करा",
	   field_name:"फील्ड नाव",
	   old_value:"जुने मूल्य",
	   new_value:"नवीन मूल्य",
	   date_time_update:"तारीख/वेळ अद्यतन",
	   updater:"अद्ययावत",
	   add_edit_academic_records:"शैक्षणिक रेकॉर्ड जोडा/संपादित करा",
	   select_flag:"ध्वज निवडा ...",
	   edit_all_tranferred_grades:"सर्व ट्रॅन्फर्ड ग्रेड संपादित करा",
	   save_records:"रेकॉर्ड जतन करा",
	   possible_credits:"संभाव्य क्रेडिट्स",
	   select_level:"स्तर निवडा",
	   select_grade_level:"ग्रेड स्तर निवडा",
	   select_status:"स्थिती निवडा",
	   add_more_row:"अधिक पंक्ती जोडा",
	   full_screen:"पूर्ण स्क्रीन",
	   course_code:"कोर्स कोड",
	   add_order_grades:"इतर ग्रेड जोडा",
	   select_credit:"क्रेडिट निवडा",
	   select_default:"डीफॉल्ट निवडा",
	   credits_possible:"क्रेडिट्स शक्य",
	   select_possible_credit:"संभाव्य क्रेडिट निवडा",
	   product:"उत्पादन",
	   fromn:"पासून",
	   ton:"टू",
	   last_invoice_date:"शेवटची बीजक तारीख",
	   please_select_stu:"कृपया विद्यार्थी निवडा",
	   payer:"देयक",
	   amount_per_billing_period:"प्रति बिलिंग कालावधी रक्कम",
	   price_unit:"किंमत एकक",
	   billing_period:"बिलिंग कालावधी",
	   automatic_renewal:"स्वयंचलित नूतनीकरण",
	   automatic_payment:"स्वयंचलित बिलिंग",
	   contract_template:"करार टेम्पलेट",
	   accept:"स्वीकारा",
	   reject:"नाकारणे",
	   duration_of_period:"कालावधी (कालावधीचा#)",
	   payment_id:"देयक आयडी",
	   payment_date:"पगाराची तारीख",
	   payment_amount:"देय रक्कम",
	   applied:"लागू",
	   available:"उपलब्ध",
	   unApply:"अनपेक्षित",
	   refund:"परतावा",
	   add_new_teacher:"नवीन शिक्षक जोडा",
	   change_teacher_status:"शिक्षकांची स्थिती बदला",
	   search_for_a_teacher_or_id:"शिक्षक किंवा आयडी शोधा…",
	   flags:"झेंडे",
	   tags:"टॅग्ज",
	   allowed:"परवानगी",
	   message_teacher:"संदेश शिक्षक",
	   impersonate_teacher:"शिक्षकांची तोतयागिरी करा",
	   add_teacher_qualification:"शिक्षक पात्रता जोडा",
	   profile:"प्रोफाइल",
	   teacher_schedule:"शिक्षकांचे वेळापत्रक",
	   qualifications:"पात्रता",
	   student_actions:"विद्यार्थी क्रिया",
	   linking_parents_to:"पालकांशी दुवा साधत आहे",
	   select_do:"निवडा ...",
	   see_edit_logs:"नोंदी संपादित करा",
	   see_qualifications:"पात्रता पहा",
	   link_academic_advisor:"शैक्षणिक सल्लागार दुवा",
	   student_success:"विद्यार्थी यश",
	   linking_academic_advisor_or_student_success:"शैक्षणिक सल्लागार / विद्यार्थ्यांच्या यशाचा दुवा साधत आहे",
	   staff:"कर्मचारी",
	   teacher_status:"शिक्षकांची स्थिती",
	   school_admin_status:"शाळेची प्रशासन स्थिती",
	   global_user_directory:"ग्लोबल यूजर डिरेक्टरी",
	   edit_teacher:"शिक्षक संपादित करा",
	   contracted:"करार",
	   add_comments_and_documents:"टिप्पण्या आणि कागदपत्रे जोडा",
	   edit_comments_and_documents:"टिप्पण्या आणि कागदपत्रे संपादित करा",
	   parents_or_mentor:"पालक / मार्गदर्शक",
	   send_mail:"मेल पाठवा",
	   are_you_sure_to_delete_this_teacher:"आपण हे शिक्षक हटवण्याची खात्री आहे.",
	   edit_user_password:"वापरकर्तानाव आणि संकेतशब्द संपादित करा",
	   add_qualifications:"पात्रता जोडा",
	   please_select_a_least_on_teacher:"कृपया किमान एक शिक्षक निवडा.",
	   edit_parent_mentor:"पालक / मार्गदर्शक संपादित करा",
	   parent_mentor_information:"पालक / मार्गदर्शक माहिती",
	   send:"पाठवा",
	   are_you_surse_to_delete_this_parent:"आपण हे पालक हटवण्याची खात्री आहे.",
	   home:"मुख्यपृष्ठ",	   
	   //auto_promotion:"Auto Promotion",
	   auto_promotion:"विद्यार्थी ग्रेड स्तराची जाहिरात",
	   Promote:"प्रचार",
	   search_for_a_name:"नाव शोधा…",
	   download_to_excel:"एक्सेल वर डाउनलोड करा",
	   download_to_pdf:"पीडीएफ वर डाउनलोड करा",
	   User_ID:"वापरकर्ता आयडी",
	   User_type:"वापरकर्ता प्रकार",
	   communication_log:"संप्रेषण लॉग",
	   Student_Status:"विद्यार्थ्यांची स्थिती",
	   Users:"वापरकर्ते",
	   Staff_Reassignment:"कर्मचारी पुन्हा नियुक्त करा",
	   Select_Staff:"कर्मचारी निवडा",
	   select_asset_type_to_reassign:"पुन्हा नियुक्त करण्यासाठी मालमत्ता प्रकार निवडा",
	   transfer_all_to:"सर्व मध्ये हस्तांतरित करा",
	   transfer_selectively:"निवडकपणे हस्तांतरित करा",
	   remove_all:"सर्व काढून टाका",
	   remove_selectively:"निवडकपणे काढा",
	   Event:"कार्यक्रम",
	   Time:"वेळ",
	   Participants:"सहभागी",
	   new_staff:"नवीन कर्मचारी",
	   Remove:"काढा",
	   Profile_Page:"प्रोफाइल पृष्ठ",
	   settings:"सेटिंग्ज",
	   security:"सुरक्षा",
	   timezone:"वेळ क्षेत्र",
	   notifications:"अधिसूचना",
	   check_for_feature_availability_at_your_school:"आपल्या शाळेत वैशिष्ट्याची उपलब्धता तपासा.",
	   current_password:"सध्याचा गुप्त शब्द",
	   new_password:"नवीन संकेतशब्द",
	   confirm_password:"पासवर्डची पुष्टी करा",
	   updte_password:"संकेतशब्द अद्यतनित करा",
	   change_timezone:"टाइमझोन बदला",
	   time_zone:"वेळ क्षेत्र",
	   please_select_time_zone:"कृपया टाइम झोन निवडा",
	   notification_settings:"सूचना सेटिंग्ज",
	   level_of_urgency:"निकडची पातळी",
	   email_destination:"ईमेल गंतव्य",
	   SMS_Destination:"एसएमएस गंतव्यस्थान",
	   app:"अॅप",
	   please_select_level_of_urgency:"कृपया तातडीची पातळी निवडा",  
	   reset_filters:"रीसेट फिल्टर",
	   batch_data_update:"विद्यार्थी डेटा अद्यतन", 
	   view_roles:"भूमिका पहा", 
	   administrator_information:"प्रशासक माहिती", 
	   account_reation_date:"खाते निर्मितीची तारीख", 
	   expiration_date:"कालबाह्यता तारीख", 
	   schools:"शाळा", 
	   advisees:"सल्ला", 
	   message:"संदेश", 
	   see_comments_and_documents:"टिप्पण्या आणि कागदपत्रे पहा", 
	   restore_APEX_Classrooms:"शिखर वर्ग पुनर्संचयित करा", 
	   teacher_information:"शिक्षकांची माहिती", 
	   teacher_number:"शिक्षक क्रमांक", 
	   departmens:"विभाग", 
	   global_capacity:"जागतिक क्षमता", 
	   local_contracted_load:"स्थानिक कराराचा भार", 
	   parents:"पालक", 
	   parent_information:"पालक माहिती", 
	   linked_students:"लिंक केलेले विद्यार्थी", 
	   link_student:"लिंक विद्यार्थी", 
	   unlink_student:"अनलिंक विद्यार्थी", 
	   search_dot:"शोध…", 
	   view_local:"स्थानिक पहा", 
	   view_global:"जागतिक पहा", 
	   resource:"संसाधन", 
	   current_grade:"चालू ग्रेड", 
	   affiliation:"संलग्नता", 
	   current_assignment:"वर्तमान असाइनमेंट", 
	   total_assignments:"एकूण असाइनमेंटस्ट", 
	   percent_completed:"टक्के पूर्ण झाले", 
	   semester:"सत्र", 
	   graduation_year:"पदवी वर्ष", 
	   student_name:"विद्यार्थ्यांचे नाव", 
	   credits_earned:"क्रेडिट्स कमावले", 
	   exit:"बाहेर पडा", 
	   engagement_type:"प्रतिबद्धता प्रकार", 
	   college_admitted:"महाविद्यालयाने प्रवेश घेतला", 
	   college_attending:"महाविद्यालय उपस्थित", 
	   major:"प्रमुख", 
	   report_card:"प्रगतिपुस्तक, प्रगतिपत्रक", 
	   academic_term:"शैक्षणिक संज्ञा", 
	   show_average:"सरासरी दर्शवा", 
	   school_information:"शालेय माहिती", 
	   school_misc_configuration:"स्कूल मिस कॉन्फिगरेशन", 
	   school_tags:"शाळेचे टॅग", 
	   role_tags:"भूमिका टॅग", 
	   content_integration:"सामग्री एकत्रीकरण", 
	   user_roles:"वापरकर्ता भूमिका", 
	   communication_user_rules:"संप्रेषण वापरकर्ता नियम", 
	   school_administrators:"शाळा प्रशासक", 
	   school_year_configuration:"शालेय वर्ष कॉन्फिगरेशन", 
	   A_R_payment_configuration:"ए/आर पेमेंट कॉन्फिगरेशन", 
	   facility:"सुविधा", 
	   enrollment_rules:"नावनोंदणी नियम", 
	   student_contract_rules:"विद्यार्थी कराराचे नियम", 
	   products:"उत्पादने", 
	   notification_templates:"सूचना टेम्पलेट्स", 
	   transcript_viewer_options:"उतारा दर्शक पर्याय", 
	   feature_configuration:"वैशिष्ट्य कॉन्फिगरेशन", 
	   feature_settings:"वैशिष्ट्य सेटिंग्ज", 
	   communication_rules:"संप्रेषण नियम", 
	   object_state:"ऑब्जेक्ट स्टेट", 
	   departments:"विभाग", 
	   grading_scales:"ग्रेडिंग स्केल", 
	   grading_periods:"ग्रेडिंग पीरियड्स", 
	   academic_tracks:"शैक्षणिक ट्रॅक", 
	   learning_path_templates:"पथ टेम्पलेट शिकणे", 
	   grade_book_activity_descriptions:"ग्रेड बुक क्रियाकलाप वर्णन", 
	   academic_terms:"शैक्षणिक अटी", 
	   academic_system:"शैक्षणिक प्रणाली", 
	   address_line_1:"अ‍ॅड्रेस लाइन 1", 
	   country_code:"राष्ट्र संकेतांक", 
	   address_line_2:"पत्ता ओळ 2", 
	   school_title:"शाळेचे शीर्षक", 
	   CEEB_code:"सीईईबी कोड", 
	   zip_postal_code:"पिन/पोस्टल कोड", 
	   state_province:"राज्य/प्रांत", 
	   website:"संकेतस्थळ", 
	   subdomain:"सबडोमेन", 
	   success_manager:"यश व्यवस्थापक", 
	   school_logo:"शाळेचा लोगो", 
	   digital_seal:"डिजिटल सील", 
	   password_exception_rule:"संकेतशब्द अपवाद नियम", 
	   change_password_first_login:"प्रथम लॉगिन संकेतशब्द बदला", 
	   password_expires_after_days:"दिवसानंतर संकेतशब्द कालबाह्य होतो", 
	   enforcement_of_teachers_load:"शिक्षकांच्या लोडची अंमलबजावणी", 
	   in_house_handling_of_transcript_requests:"ट्रान्सक्रिप्ट विनंत्यांच्या घराच्या हाताळणीत", 
	   display_mobile_app_link:"मोबाइल अॅप दुवा प्रदर्शित करा", 
	   display_weekly_progress_goal:"साप्ताहिक प्रगती ध्येय प्रदर्शित करा", 
	   turn_on_notification:"सूचना चालू करा", 
	   classic_letter:"क्लासिक पत्र", 
	   automatic_parent_account_creation:"स्वयंचलित पालक खाते निर्मिती", 
	   default_parent_account_status:"डीफॉल्ट पालक खाते स्थिती", 
	   default_time_zone:"डीफॉल्ट टाइम झोन", 
	   link_to_transcript_vendor_help:"ट्रान्सक्रिप्ट विक्रेता मदतीचा दुवा", 
	   link_to_transcript_vendor:"उतारे विक्रेत्याचा दुवा", 
	   link_for_help_system:"मदत प्रणालीसाठी दुवा", 
	   student_enrollment_limit:"विद्यार्थ्यांची नावनोंदणी मर्यादा", 
	   default_section_type:"डीफॉल्ट विभाग प्रकार", 
	   default_section_capacity:"डीफॉल्ट विभाग क्षमता", 
	   transcript_template:"उतारा टेम्पलेट", 
	   edit_security_school_tags:"सुरक्षा शाळेचे टॅग संपादित करा", 
	   security_school_tags:"सुरक्षा शाळेचे टॅग संपादित करा", 
	   tags_name:"टॅगचे नाव", 
	   edit_role_tags:"भूमिका टॅग संपादित करा", 
	   add_school_based_tags:"शाळा आधारित टॅग जोडा", 
	   description:"वर्णन", 
	   applied_to_roles:"भूमिकांवर लागू", 
	   teacher:"शिक्षक", 
	   edit_security_role_tags_for:"साठी सुरक्षा भूमिका टॅग संपादित करा", 
	   school_admins:"शाळा प्रशासक", 
	   school_begin_date:"शाळा प्रारंभ तारीख", 
	   school_end_date:"शाळेची समाप्ती तारीख", 
	   automatic_control_of_teacher_s_load:"शिक्षकांच्या लोडचे स्वयंचलित नियंत्रण", 
	   A_R_payment_gateway_configuration:"ए/आर पेमेंट गेटवे कॉन्फिगरेशन", 
	   payment_processing_vendor:"देय प्रक्रिया विक्रेता", 
	   secret_key:"गुप्त की", 
	   publishable_key:"प्रकाशित करण्यायोग्य की", 
	   account_id:"खाते आयडी", 
	   updating_tudents:"विद्यार्थी अद्यतनित करीत आहे", 
	   delete_selected_records:"निवडलेल्या रेकॉर्ड हटवा", 
	   attribute_name:"विशेषता नाव", 
	   applied_for:"साठी अर्ज", 
	   add_school:"शाळा जोडा", 
	   overview:"आढावा", 
	   search_for_school:"शाळेचा शोध घ्या…", 
	   search_for_student:"विद्यार्थ्यासाठी शोधा…", 
	   attribute_type:"विशेषता प्रकार", 
	   select_school_group:"शालेय गट निवडा", 
	   access_rights:"प्रवेश अधिकार", 
	   create:"तयार करा", 
	   read:"वाचा", 
	   facility_management:"सुविधा व्यवस्थापन", 
	   facility_name:"सुविधेचे नाव", 
	   capacity:"क्षमता", 
	   enrollment_allowance_period_days:"नावनोंदणी भत्ता कालावधी (दिवस)", 
	   maximum_enrollment_duration_days:"जास्तीत जास्त नावनोंदणी कालावधी (दिवस)", 
	   start_date_of_the_week:"आठवड्याची प्रारंभ तारीख", 
	   end_date_of_the_week:"आठवड्याची शेवटची तारीख", 
	   lookup_name:"लुकअप नाव", 
	   duration:"कालावधी", 
	   time_unit:"वेळ युनिट", 
	   round_up_to_end_of_time_unit:"वेळ युनिटच्या शेवटी गोल", 
	   product_name:"उत्पादनाचे नांव", 
	   product_ID:"उत्पादन आयडी", 
	   price_offer:"किंमत ऑफर", 
	   price:"किंमत", 
	   frequency:"वारंवारता", 
	   effective_from:"पासून प्रभावी", 
	   effective_to:"प्रभावी", 
	   active:"सक्रिय", 
	   drag_drop_to_text_cursor_in_content:"सामग्रीमध्ये मजकूर कर्सरवर ड्रॅग करा आणि ड्रॉप करा", 
	   event_type:"कार्यक्रम प्रकार", 
	   notification_rule:"सूचना नियम", 
	   level_or_ugency:"पातळी किंवा ugency", 
	   user_role:"वापरकर्ता भूमिका", 
	   edit_security_user_tags:"सुरक्षा वापरकर्ता टॅग संपादित करा", 
	   content_access:"सामग्री प्रवेश", 
	   content_access_for:"यासाठी सामग्री प्रवेश", 
	   add_new_access:"नवीन प्रवेश जोडा", 
	   date_assigned:"नियुक्त तारीख", 
	   enrollment_request:"नावनोंदणी विनंती", 
	   enrollment_request_for:"नावनोंदणीची विनंती", 
	   mentors:"मार्गदर्शक", 
	   options:"पर्याय", 
	   department_name:"विभागाचे नाव", 
	   universal_department:"युनिव्हर्सल डिपार्टमेंट", 
	   open:"उघडा", 
	   min_point:"मि पॉईंट", 
	   max_point:"कमाल बिंदू", 
	   grade_point:"ग्रेड पॉईंट", 
	   honors:"सन्मान", 
	   college:"कॉलेज", 
	   order:"ऑर्डर", 
	   start_time:"सुरवातीची वेळ", 
	   end_time:"समाप्तीचा कालावधी", 
	   period_name:"कालावधी नाव", 
	   grading_periods_head:"ग्रेडिंग पीरियड्स हेड", 
	   grading_period:"ग्रेडिंग कालावधी", 
	   weight:"वजन", 
	   track_name:"ट्रॅक नाव", 
	   academic_track_requirement:"शैक्षणिक ट्रॅक आवश्यकता", 
	   of_required_credits:"आवश्यक क्रेडिटचे #", 
	   individual_learning_plan_template:"वैयक्तिक शिक्षण योजना टेम्पलेट", 
	   ILP_name:"आयएलपी नाव", 
	   remove_requirement:"आवश्यकता काढा", 
	   reset_requirement:"रीसेट आवश्यकता", 
	   add_requirement:"आवश्यकता जोडा", 
	   must_end_date:"तारीख समाप्त करणे आवश्यक आहे", 
	   courses_open_date:"अभ्यासक्रम खुले तारीख", 
	   signup_end_date:"साइनअप समाप्ती तारीख", 
	   signup_start_date:"साइनअप प्रारंभ तारीख", 
	   section_period:"विभाग कालावधी", 
	   
	   weeks:"आठवडे", 
	   search_for_a_section_or_id:"एक विभाग किंवा आयडी शोधा…", 
	   search_for_a_deft:"विभाग शोधा…", 	   
	    launch_course:"लाँच कोर्स", 
	   start_class:"वर्ग सुरू करा", 	   
	   weekly_progress_goal:"साप्ताहिक प्रगती ध्येय", 	 
	   send_message_to_all_section_students:"सर्व विभागातील विद्यार्थ्यांना संदेश पाठवा", 
	   monitor_live_sessions:"थेट सत्रांचे परीक्षण करा", 
	   average_section_grade:"सरासरी विभाग ग्रेड", 	   
	   resources:"संसाधने", 
	   activities:"क्रियाकलाप", 	   
	   course_attendance_today:"आज कोर्सची उपस्थिती", 	   
	   staffs:"कर्मचारी", 
	   units:"युनिट्स", 
	   view_all_15_resources:"सर्व 15 संसाधने पहा", 
	   Class_discussions:"वर्ग चर्चा", 
	   recent_discussions:"अलीकडील चर्चा", 	   
	   go_to_class_discussions:"वर्ग चर्चेवर जा", 
	   show_my_class_attendance:"माझी वर्ग उपस्थिती दर्शवा", 
	   add_section:"विभाग जोडा",
	   add_global_section:"जागतिक विभाग जोडा",
	   close_section:"विभाग बंद करा",
	   open_section:"खुले विभाग",
	   batch_upload:"बॅच अपलोड",
	   finalize:"अंतिम",
	   add_tearcger:"शिक्षक जोडा",
	   remove_tearcger:"शिक्षक काढा",
	   uploadSectionStatusUpdates:"विभाग स्थिती अद्यतने अपलोड करा",
	   status_count:"स्थिती गणना",
	   reactivate:"पुन्हा सक्रिय करा",
	   clone:"क्लोन",
	   enroll_into_Section:"विभागात प्रवेश घ्या",
	   bulk_enrollment:"मोठ्या प्रमाणात नोंदणी",
	   general_Information:"सामान्य माहिती",
	   online_content_source:"ऑनलाइन सामग्री स्रोत",
	   second_teacher:"दुसरा शिक्षक",
	   today:"आज",
	   calendar:"कॅलेंडर",
	   week:"आठवडा",
	   month:"महिना",
	   section_progress:"विभाग प्रगती",
	   complete:"पूर्ण",
	   section_title:"विभाग शीर्षक",
	   enter_section_title:"विभाग शीर्षक प्रविष्ट करा",
	   select_teacher:"शिक्षक निवडा",
	   select_weeks:"आठवडे निवडा",
	   select_credits:"क्रेडिट्स निवडा",
	   select_type:"प्रकार निवडा",
	   global_section:"जागतिक विभाग",
	   enrollment_capacity:"नावनोंदणी क्षमता",
	   enter_enrollment_capacity:"नावनोंदणी क्षमता प्रविष्ट करा",
	   in_class_information:"वर्ग माहितीमध्ये",
	   Start:"प्रारंभ करा",
	   End:"शेवट",
	   recurrencePattern:"पुनरावृत्ती नमुना",
	   recurrenceFrequency:"पुनरावृत्ती वारंवारता",
	   Weekly:"साप्ताहिक",
	   Monthly:"मासिक",
	   Recur_every:"प्रत्येकाची पुनरावृत्ती करा",
	   Weeks_on:"आठवडे चालू",
	   day_of_week:"आठवड्याचा दिवस",
	   daily_period:"दैनिक कालावधी",
	   select_daily_period:"दररोजचा कालावधी निवडा",
	   Day:"दिवस",
	   The:"द",
	   of_every:"प्रत्येकाची",
	   month_s:"महिना (र्स)",
	   add:"जोडा",
	   course_prequisites :"कोर्स पूर्वस्थिती",
	   select_status:"स्थिती निवडा",
	   select_school:"शाळा निवडा",
	   select_period:"कालावधी निवडा",
	   room_number:"खोली क्रमांक",
	   select_room_number:"खोली क्रमांक निवडा",
	   Service:"सेवा",
	   enter_url:"URL प्रविष्ट करा",
	   edit_section:"विभाग संपादित करा",
	   activity_templates:"क्रियाकलाप टेम्पलेट्स",
	   select_activity_templates:"क्रियाकलाप टेम्पलेट निवडा",
	   link_section:"दुवा विभाग",
	   select_link_section:"दुवा विभाग निवडा",
	   please_select_sections:"कृपया विभाग निवडा.",
	   if_you_change_your_status_of_inactivity:"आपण आपली निष्क्रियतेची स्थिती बदलल्यास, विद्यार्थ्यावर परिणाम होईल.",
	   closing_the_global_section_will_cause:"जागतिक विभाग बंद केल्याने सर्व शाळांमध्ये बंद होईल आणि त्यातील सर्व विद्यार्थ्यांचे माघार होईल. कृपया आपण पुढे जाऊ इच्छित असल्यास पुष्टी करा क्लिक करा.",
	   upload_import_data:"डेटा अपलोड करा आणि आयात करा",
	   here:"येथे",
	   no_data_avalable_in_table:"सारणीमध्ये कोणताही डेटा उपलब्ध नाही",
	   add_teacher_to_multiple_section:"एकाधिक विभागांमध्ये शिक्षक जोडा",
	   select_teachers_to_add_to_multiple_section:"एकाधिक निवडींमध्ये जोडण्यासाठी शिक्षक निवडा",
	   selected:"निवडलेले",
	   selected_all:"सर्व निवडा",
	   deselected_all:"सर्व निवड रद्द करा",
	   remove_teacher_from_multiple_section:"एकाधिक विभागांमधून शिक्षक काढा",
	   select_teacher_to_remove_to:"एकाधिक निवडी काढण्यासाठी शिक्षक निवडा",
	   process_removal:"प्रक्रिया काढणे",	   
	   clone_section:"क्लोन विभाग",
	   enroll_student:"विद्यार्थ्यांची नोंदणी करा",
	   enroll_student_to:"विद्यार्थ्यांची नोंद घ्या",
	   name:"नाव",
	   search_for_a_student_or_id:"विद्यार्थी किंवा आयडी शोधा…",
	   confirmation_of_enrollment:"नावनोंदणीची पुष्टीकरण",
	   please_review_and_confirm_enrollments_for:"कृपया यासाठी नावनोंदणीचे पुनरावलोकन करा आणि पुष्टी करा",
	   confirm:"पुष्टी",
	   //enroll_students_to_section:"ENROLL STUDENTS TO SECTION",
	   enrollment_period:"नावनोंदणी कालावधी",
	   days:"दिवस",
	    no_data_avalible:"माहिती उपलब्ध नाही.",
	   number_of_primary_teacher:"प्राथमिक शिक्षकांची संख्या",
	   secondary_teachers:"माध्यमिक शिक्षक",
	   department_head:"विभाग प्रमुख",
	   section_enroll:"विभाग नोंदणी",
	   load_from_file:"फाईलमधून लोड करा",
	   see_sections:"विभाग पहा",
	   change_enrollment_status:"नावनोंदणीची स्थिती बदला",
	   mentor_s:"मार्गदर्शक (ओं)",
	   overdue_activities:"थकीत क्रियाकलाप",
	   total_session_time_and_last_log:"एकूण सत्र वेळ आणि शेवटचा लॉग",
	   course_name_on_transcript:"उतार्‍यावरील कोर्स नाव",
	   edit_other_grades:"इतर ग्रेड संपादित करा",
	   save_as:"म्हणून जतन करा",
	   account_receivable_dashboard:"खाते प्राप्त करण्यायोग्य डॅशबोर्ड",
	   key_performance_indicators:"की कामगिरी निर्देशक",
	   a_r_dashboard:"ए/आर डॅशबोर्ड",
	   payments_credits:"देयके / क्रेडिट्स",
	   contract_templates:"कॉन्ट्रॅक्ट टेम्पलेट्स",
	   master_contracts:"मास्टर कॉन्ट्रॅक्ट्स",
	   a_r_configuration:"ए/आर कॉन्फिगरेशन",
	   a_r_processing:"ए/आर प्रक्रिया",
	   aging:"वृद्धत्व",
	   receivable:"प्राप्य",
	   account_receivable_by_program:"प्रोग्रामद्वारे प्राप्त करण्यायोग्य खाते",
	   request_detail:"विनंती तपशील",
	   request_information:"माहितीची विनंती करा",
	   requested_by:"विनंती करणारा",
	   approved_by:"च्याकडून मंजूर",
	   approve:"मंजूर",
	   phone_name:"फोन नाव",
	   phone_carrier:"फोन कॅरियर",
	   area_code:"क्षेत्र कोड",
	   address_lable:"पत्ता लेबल",
	   address_default:"पत्ता डीफॉल्ट",
	   new_photo:"नवीन फोटो",
	   current_of_wweeks:"आठवडे चालू #",
	   select_enrollment_period:"नावनोंदणी कालावधी निवडा",
	   enter_rejection_reason:"नकार कारण प्रविष्ट करा ...",
	   comments_and_documents:"टिप्पण्या आणि कागदपत्रे",
	   enrollment_history:"नावनोंदणी इतिहास",
	   request_extension_for:"विनंती विस्तार विनंती",
	   extended_of_weeks:"आठवडे विस्तारित",
	   current_enrollment_status:"सध्याची नावनोंदणी स्थिती",
	   select_extension_option:"विस्तार पर्याय निवडा",
	   extend_current_enrollment_until:"पर्यंत चालू नोंदणी वाढवा",
	   transfer_to_new_section:"नवीन विभागात स्थानांतरित करा",
	   transcript_requests:"उतारे विनंत्या",
	   person_requesting_transcript:"ट्रान्सक्रिप्टची विनंती करणारी व्यक्ती",
	   telephone_number:"दूरध्वनी क्रमांक",
	   number_of_copies:"प्रतींची संख्या",
	   special_instructions:"विशेष सूचना",
	   last_school_attendance:"शेवटची शाळा उपस्थिती",
	   year_last_attended:"वर्ष शेवटच्या वर्षात",
	   current_address:"सध्या राहत असलेला पत्ता, सध्याचा पत्ता, सध्या राहत्या घराचा पत्ता",
	   relationship_to_student:"विद्यार्थ्याशी संबंध",
	   method_of_delivery:"वितरणाची पद्धत",
	   instructions:"*सूचना",
	   previous_requests:"मागील विनंत्या",
	   additional_info:"अतिरिक्त माहिती",
	   receive:"प्राप्त करा",
	   process:"प्रक्रिया",
	   add_to_school_group:"शालेय गटात जोडा",
	   submit_romote:"जाहिरात सबमिट करा",
	   next_grade_level:"पुढील ग्रेड स्तर",
	   please_select_a_school_for_promotion_and_transfer:"कृपया पदोन्नती आणि हस्तांतरणासाठी एक शाळा निवडा",
	   write_off:"लिहा",
	   amount_due:"देय रक्कम",
	   open_amount:"खुली रक्कम",
	   payment_application:"देय अर्ज",
	   use_credit_openBalance:"क्रेडिट $ 111 वापरा",
	   payment_amount_usd:"देय रक्कम (यूएसडी)",
	   check_number:"चेक नंबर तपासा",
	   confirmation_number:"खात्री क्रमांक",
	   apply_payment:"देय द्या",
	   amount_paid:"भरलेली रक्कम",
	   applied_payment:"अर्ज भरलेला",
	   payer_id:"पेअर आयडी",
	   view_detail:"तपशील पहा",
	   master_contract:"मास्टर कॉन्ट्रॅक्ट",
	   copy:"कॉपी",
	   contract_user_detail:"कराराचा वापरकर्ता तपशील",
	   follow_product_cost:"उत्पादन खर्चाचे अनुसरण करा",
	   default_cost:"डीफॉल्ट किंमत",
	   offered_cost:"ऑफर केलेली किंमत",
	   contract_detail:"कराराचा तपशील",
	   contract_template_name:"कॉन्ट्रॅक्ट टेम्पलेट नाव",
	   master_contract_name:"मास्टर कॉन्ट्रॅक्ट नाव",
	   view_students:"विद्यार्थी पहा", 
	   make_payment:"देय द्या", 
	   parent_page:"मूळ पृष्ठ", 
	   edit_parent:"पालक संपादित करा", 
	   edit_profile:"प्रोफाईल संपादित करा", 
	   account_receivable_configuration:"खाते प्राप्त करण्यायोग्य कॉन्फिगरेशन", 
	   invoice_generation_date:"बीजक निर्मितीची तारीख", 
	   invoice_generation:"बीजक पिढी", 
	   number_of_days_until_due_date:"देय तारखेपर्यंत दिवसांची संख्या", 
	   account_receivable_processing:"खाते प्राप्त करण्यायोग्य प्रक्रिया", 
	   generate_invoices:"पावत्या व्युत्पन्न करा", 
	   process_automatic_payments:"स्वयंचलित देयके प्रक्रिया", 
	   send_late_notices:"उशीरा सूचना पाठवा", 
	   course:"कोर्स", 
	   copy_courses:"कॉपी कोर्स", 
	   copy_to_school:"शाळेत कॉपी करा", 
	   originating_program_code:"मूळ प्रोग्राम कोड", 
	   destinating_program_code:"प्रोग्राम कोड डेस्टिनेटिंग", 
	   status_error:"स्थिती/त्रुटी", 
	   add_prerequisite:"पूर्व शर्त जोडा", 
	   group_name:"गटाचे नाव", 
	   enter_group_name:"गट नाव प्रविष्ट करा", 
	   select_a_department_to_display_courses:"अभ्यासक्रम प्रदर्शित करण्यासाठी विभाग निवडा", 
	   edit_tranferred_grades:"इतर ग्रेड संपादित करा", 
	   showing_num_records:"000 रेकॉर्ड दर्शवित आहे", 
	   edit_all_other_grades:"इतर सर्व ग्रेड संपादित करा", 
	   upload_student_documents:"विद्यार्थ्यांची कागदपत्रे अपलोड करा", 
	   select_an_official_transcript_option:"अधिकृत उतारा पर्याय निवडा", 
	   for_schools_or_personal_copy:"शाळा किंवा वैयक्तिक कॉपीसाठी", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"विद्यार्थ्यांच्या वापरासाठी, दुसर्‍या शाळेत पाठवा किंवा नावनोंदणी सत्यापित करण्यासाठी.", 
	   request_official_transcript:"अधिकृत उतार्‍याची विनंती करा", 
	   PARCHMENT_for_colleges_or_universities:"महाविद्यालये किंवा विद्यापीठांसाठी चर्मपत्र", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"महाविद्यालय/विद्यापीठाच्या अर्जासाठी आणि आपल्या डिप्लोमा पूर्ण होण्याचे सत्यापित करण्यासाठी.", 
	   request_transcript:"ट्रान्सक्रिप्टची विनंती करा", 
	   Learn_more_about_how_to_use_PARCHMENT:"चर्मपत्र कसे वापरावे याबद्दल अधिक जाणून घ्या", 
	   print_PDF:"पीडीएफ मुद्रित करा", 
	   user_school:"वापरकर्ता शाळा", 
	   filter:"फिल्टर", 
	   GENERAL:"सामान्य", 
	   STUDENT_INFO:"विद्यार्थ्यांची माहिती", 
	   list:"यादी", 
	   last_school_name:"शेवटचे शाळेचे नाव", 
	   TEACHER_INFO:"शिक्षकांची माहिती", 
	   contracted_load:"कॉन्ट्रॅक्ट लोड", 
	   ARENT_INFO:"पालक माहिती", 
	   add_credential:"क्रेडेन्शियल जोडा", 
	   edit_credential:"क्रेडेन्शियल संपादित करा", 
	   add_comment_document:"टिप्पणी आणि दस्तऐवज जोडा", 
	   add_comment_document_for:"यासाठी टिप्पणी आणि दस्तऐवज जोडा", 
	   state_province:"राज्य/ प्रांत", 
	   post_code:"पिनकोड", 
	   linking_students_to:"विद्यार्थ्यांना जोडत आहे", 
	   change_expiration_date:"कालबाह्यता तारीख बदला", 
	   expiry_date:"कालबाह्यता तारीख", 
	   please_select_department:"कृपया विभाग निवडा.", 
	   please_select_course:"कृपया कोर्स निवडा.", 
	   please_select_title:"कृपया शीर्षक प्रविष्ट करा.", 
	   please_select_primary_teacher:"कृपया प्राथमिक शिक्षक निवडा.", 
	   please_select_weeks:"कृपया आठवडे निवडा.", 
	   please_select_level:"कृपया स्तर निवडा.", 
	   please_select_credits:"कृपया क्रेडिट्स निवडा.", 
	   please_select_type:"कृपया प्रकार निवडा.", 
	   please_select_daily_period:"कृपया दररोजचा कालावधी निवडा.", 
	   please_enter_link_section:"कृपया दुवा विभाग प्रविष्ट करा.", 
	   please_enter_first_name:"कृपया प्रथम नाव प्रविष्ट करा.", 
	   please_enter_last_name:"कृपया आडनाव प्रविष्ट करा.", 
	   please_enter_contracted:"कृपया करार प्रविष्ट करा.", 
	   please_enter_email:"कृपया ईमेल प्रविष्ट करा.", 
	   please_enter_phone:"कृपया फोन प्रविष्ट करा.", 
	   please_enter_username:"कृपया वापरकर्तानाव प्रविष्ट करा.", 
	   please_enter_password:"कृपया संकेतशब्द प्रविष्ट करा.", 
	   please_enter_status:"कृपया स्थिती निवडा.", 
	   save_successful:"यशस्वी जतन करा!.", 
	   please_add_student_address:"कृपया विद्यार्थ्यांचा पत्ता जोडा.", 
	   please_enter_email_address:"कृपया ईमेल पत्ता प्रविष्ट करा.", 
	   please_select_relationship:"कृपया संबंध निवडा.", 
	   please_select_parent_status:"कृपया पालकांची स्थिती निवडा.", 
	   please_enter_label:"कृपया लेबल प्रविष्ट करा.", 
	   please_enter_address:"कृपया पत्ता प्रविष्ट करा.", 
	   please_enter_city:"कृपया शहर प्रविष्ट करा.", 
	   please_enter_state:"कृपया राज्य प्रविष्ट करा.", 
	   please_enter_zip_code:"कृपया पिन कोड प्रविष्ट करा.", 
	   please_select_date_of_birth:"कृपया जन्मतारीख निवडा.", 
	   please_select_track:"कृपया ट्रॅक निवडा.", 
	   please_enter_graduation_date:"कृपया पदवीची तारीख प्रविष्ट करा.", 
	   please_enter_country:"कृपया देशात प्रवेश करा.", 
	   please_enter_phone_number:"कृपया फोन नंबर प्रविष्ट करा.", 
	   please_enter_parent_first_name:"कृपया पालकांचे पहिले नाव प्रविष्ट करा.", 
	   please_enter_parent_last_name:"कृपया पालकांचे आडनाव प्रविष्ट करा.", 
	   please_enter_parent_email_address:"कृपया पालक ईमेल पत्ता प्रविष्ट करा.", 
	   please_enter_parent_username:"कृपया पालक वापरकर्तानाव प्रविष्ट करा.", 
	   please_select_parent_relationship:"कृपया पालक संबंध निवडा.", 
	   please_enter_phone_label:"कृपया फोन लेबल प्रविष्ट करा.", 
	   student_address_canot_be_empty:"विद्यार्थ्यांचा पत्ता रिक्त असू शकत नाही.", 
	   please_select_document_type:"कृपया दस्तऐवज प्रकार निवडा.", 
	   please_enter_new_type:"कृपया नवीन प्रकार प्रविष्ट करा.", 
	   please_enter_comment:"कृपया टिप्पणी प्रविष्ट करा.", 
	   link_is_not_a_valid_url:"दुवा वैध URL नाही.", 
	   please_enter_link_and_label:"कृपया दुवा आणि लेबल प्रविष्ट करा.", 
	   are_you_sure_to_delete_this_student:"आपण या विद्यार्थ्याला हटवण्याची खात्री आहे.", 
	   please_select_gender:"कृपया लिंग निवडा.", 
	   school_contracted_load:"शाळेचा करार", 
	   global_contracted_load:"ग्लोबल कॉन्ट्रॅक्ट लोड", 
	   please_enter_label_for_attachments:"कृपया संलग्नकांसाठी लेबल प्रविष्ट करा.", 
	   please_select_section:"कृपया विभाग निवडा.", 
	   enrollment_completed_successfully:"नावनोंदणी यशस्वीरित्या पूर्ण झाली.", 
	   delete_this_comment:"ही टिप्पणी हटवा?", 
	   please_enter_course_name:"कृपया कोर्सचे नाव प्रविष्ट करा.", 
	   please_select_credits_possible:"कृपया शक्य क्रेडिट्स निवडा.", 
	   can_save_record:"रेकॉर्ड जतन करू शकत नाही:", 
	   are_you_sure_to_delete_this_tranferred_grade:"आपणास खात्री आहे की हा ट्रॅन्फरर्ड ग्रेड हटविला आहे?", 
	   are_you_sure_to_delete_num_tranferred_grade:"आपणास खात्री आहे की 11 ट्रॅन्फरर्ड ग्रेड हटवेल?", 
	   please_select_tranferred_grade:"कृपया ट्रॅनफर्ड ग्रेड निवडा.", 
	   please_ente_subject:"कृपया विषय प्रविष्ट करा.", 
	   please_select_made_to:"कृपया तयार केले निवडा.", 
	   delete_this_communication:"हे संप्रेषण हटवा?", 
	   please_select_school:"कृपया शाळा निवडा.", 
	   please_enter_name:"कृपया नाव प्रविष्ट करा.", 
	   please_enter_group_name:"कृपया गट नाव प्रविष्ट करा.", 
	   you_have_some_form_errors_please_check_above:"आपल्याकडे काही फॉर्म त्रुटी आहेत. कृपया वर तपासा.", 
	   please_select_recipient:"कृपया प्राप्तकर्ता निवडा.", 
	   please_enter_description:"कृपया वर्णन प्रविष्ट करा.", 
	   delete_this_resource:"हे स्त्रोत हटवा?", 
	   please_enter_activity_name:"कृपया क्रियाकलाप नाव प्रविष्ट करा.", 
	   please_select_activity_type:"कृपया क्रियाकलाप प्रकार निवडा.", 
	   please_enter_max_score:"कृपया मॅक्स स्कोअर प्रविष्ट करा.", 
	   please_enter_due_date:"कृपया देय तारीख प्रविष्ट करा.", 
	   please_enter_unit_name:"कृपया युनिटचे नाव प्रविष्ट करा.", 
	   are_you_sure_to_clear_this_unit:"आपण हे युनिट साफ करणार आहात याची खात्री आहे का?", 
	   please_enter_score:"कृपया स्कोअर प्रविष्ट करा.", 
	   delete_this_credential:"हे प्रमाणपत्र हटवा?", 
	   plase_select_period:"कृपया कालावधी निवडा", 
	   plase_select_start_date:"कृपया प्रारंभ तारीख निवडा", 
	   plase_select_end_date:"कृपया शेवटची तारीख निवडा", 
	   select_to_register_course_to_students_individual_learning_path_view:"विद्यार्थ्यांना वैयक्तिक शिक्षण पथ दृश्य नोंदणी करण्यासाठी निवडा", 
	   delete_this_request:"ही विनंती हटवा?", 
	   please_enter_fname:"कृपया fname प्रविष्ट करा.", 
	   please_enter_lname:"कृपया lname प्रविष्ट करा.", 
	   please_enter_birthday:"कृपया वाढदिवस प्रविष्ट करा.", 
	   please_enter_address:"कृपया पत्ता प्रविष्ट करा.", 
	   please_enter_zip:"कृपया झिप प्रविष्ट करा.", 
	   please_enter_country:"कृपया देश निवडा.", 
	   please_enter_ethnicity:"कृपया वांशिक प्रविष्ट करा.", 
	   please_enter_grade:"कृपया ग्रेड निवडा.", 
	   please_enter_mobile:"कृपया मोबाइल प्रविष्ट करा.", 
	   please_enter_hear_about_us:"कृपया आमच्याबद्दल ऐका निवडा.", 
	   please_enter_program_of_interest:"कृपया स्वारस्याचा कार्यक्रम निवडा.", 
	   please_enter_course_level:"कृपया कोर्स स्तर प्रविष्ट करा.", 
	   please_enter_guardian_1_name:"कृपया गार्डियन 1 नाव प्रविष्ट करा.", 
	   please_enter_guardian_1_email:"कृपया गार्डियन 1 ईमेल प्रविष्ट करा.", 
	   please_enter_guardian_1_home_phone:"कृपया गार्डियन 1 होम फोन प्रविष्ट करा.", 
	   please_enter_guardian_1_relation:"कृपया गार्डियन 1 संबंध प्रविष्ट करा.", 
	   please_select_parents:"कृपया पालक निवडा.", 
	   transfer_classroom:"वर्ग हस्तांतरण", 
	   please_choose_one_section_to_transfer:"कृपया हस्तांतरित करण्यासाठी एक विभाग निवडा.", 
	   transfer:"हस्तांतरण", 
	   assigning_multiple_users_to_a_school_or_school_group:"शाळा किंवा शाळा गटाला एकाधिक वापरकर्त्यांना नियुक्त करणे", 
	   add_to_school_or_school_group:"शाळा किंवा शाळा गटात जोडा", 
	   please_select_school_or_school_group:"कृपया शाळा किंवा शाळा गट निवडा.", 
	   print_student_progress_report:"विद्यार्थी प्रगती अहवाल मुद्रित करा", 
	  
 },
  kn:{
	   reporting_center:"ವರದಿ ಕೇಂದ್ರ", 
	   grade_reports:"ಗ್ರೇಡ್ ವರದಿಗಳು", 
	   user_reports:"ಬಾವೊ ಕಾವೊ ಂಗ್ಯು ಡಂಗ್", 
	   learning_reports:"ಕಲಿಕೆಯ ವರದಿಗಳು", 
	   administrative_reports:"ಆಡಳಿತಾತ್ಮಕ ವರದಿಗಳು", 
	   progress_report:"ಪ್ರಗತಿ ಪತ್ರ", 
	   full_progress_report:"ಪೂರ್ಣ ಪ್ರಗತಿ ವರದಿ", 
	   grade_report:"ಗ್ರೇಡ್ ವರದಿ", 
	   roster_report:"ರೋಸ್ಟರ್ ವರದಿ", 
	   parent_report:"ಪೋಷಕ ವರದಿ", 
	   teacher_report:"ಶಿಕ್ಷಕರ ವರದಿ", 
	   student_report:"ವಿದ್ಯಾರ್ಥಿ ವರದಿ", 
	   log_in_report:"ಲಾಗ್ ಇನ್ ವರದಿ", 
	   enrollmentreport:"ದಾಖಲಾತಿ ವರದಿ", 
	   enrollment_summary:"ದಾಖಲಾತಿ ಸಾರಾಂಶ", 
	   student_enrollment_summary:"ವಿದ್ಯಾರ್ಥಿಗಳ ದಾಖಲಾತಿ ಸಾರಾಂಶ", 
	   attendance_report:"ಹಾಜರಾತಿ ವರದಿ", 
	   attendance_summary_report:"ಹಾಜರಾತಿ ಸಾರಾಂಶ ವರದಿ", 
	   log_In_Credentials:"ಲಾಗ್ ಇನ್ ರುಜುವಾತುಗಳು", 
	   application_report:"ಅಪ್ಲಿಕೇಶನ್ ವರದಿ", 
	   section_report:"ವಿಭಾಗ ವರದಿ", 
	   course_report:"ಕೋರ್ಸ್ ವರದಿ", 
	   communication_summary:"ಸಂವಹನ ಸಾರಾಂಶ", 
	   comments_and_Document_Report:"ಕಾಮೆಂಟ್‌ಗಳು ಮತ್ತು ಡಾಕ್ಯುಮೆಂಟ್ ವರದಿ", 
	   School_Calendar:"ಶಾಲಾ ಕ್ಯಾಲೆಂಡರ್", 
	   bell_Schedule:"ಬೆಲ್ ವೇಳಾಪಟ್ಟಿ", 
	   student_Contract:"ವಿದ್ಯಾರ್ಥಿ ಒಪ್ಪಂದ", 
	   eOS_Report:"EOS ವರದಿ", 
	   active_Enrollments_Per_Term_Report:"ಪ್ರತಿ ಅವಧಿಯ ವರದಿಗೆ ಸಕ್ರಿಯ ದಾಖಲಾತಿಗಳು", 
	   active_Student_Enrollments_with_As_Report:"ವರದಿಯೊಂದಿಗೆ ಸಕ್ರಿಯ ವಿದ್ಯಾರ್ಥಿಗಳ ದಾಖಲಾತಿಗಳು", 
	   active_Student_Enrollments_Report:"ಸಕ್ರಿಯ ವಿದ್ಯಾರ್ಥಿಗಳ ದಾಖಲಾತಿಗಳ ವರದಿ", 
	   all_Students_GPA_Report:"ಎಲ್ಲಾ ವಿದ್ಯಾರ್ಥಿಗಳ ಜಿಪಿಎ ವರದಿ", 
	   old_All_Student_GPA_Report:"ಹಳೆಯ ಎಲ್ಲಾ ವಿದ್ಯಾರ್ಥಿಗಳ ಜಿಪಿಎ ವರದಿ", 
	   billingGroup_Engagement_Type_Report:"ಬಿಲ್ಲಿಂಗ್‌ಗ್ರೂಪ್ + ಎಂಗೇಜ್‌ಮೆಂಟ್ ಪ್ರಕಾರದ ವರದಿ", 
	   enrollment_Confirmation_Report:"ದಾಖಲಾತಿ ದೃಢೀಕರಣ ವರದಿ", 
	   eOS_College_Matriculations_Report:"EOS ಕಾಲೇಜ್ ಮೆಟ್ರಿಕ್ಯುಲೇಷನ್ಸ್ ವರದಿ", 
	   student_Enrollment_History_To_Date_w_Term_Report:"ವಿದ್ಯಾರ್ಥಿ ದಾಖಲಾತಿ ಇತಿಹಾಸ ಇಂದಿನವರೆಗಿನ ಅವಧಿಯ ವರದಿ", 
	   student_Information_Report:"ವಿದ್ಯಾರ್ಥಿ ಮಾಹಿತಿ ವರದಿ", 
	   ran_by:"ಓಡಿದರು", 
	   Show_Filter:"ಫಿಲ್ಟರ್ ತೋರಿಸು", 
	   School_Group:"ಶಾಲಾ ಗುಂಪು", 
	   school:"ಶಾಲೆ", 
	   department:"ಇಲಾಖೆ", 
	   student:"ವಿದ್ಯಾರ್ಥಿ", 
	   student_status:"ವಿದ್ಯಾರ್ಥಿ ಸ್ಥಿತಿ", 
	   course:"ಕೋರ್ಸ್", 
	   course_level:"ಕೋರ್ಸ್ ಮಟ್ಟ", 
	   section:"ವಿಭಾಗ", 
	   teacher:"ಶಿಕ್ಷಕ", 
	   primary_teacher:"ಪ್ರಾಥಮಿಕ ಶಿಕ್ಷಕ", 
	   secondary_teacher:"ಮಾಧ್ಯಮಿಕ ಶಿಕ್ಷಕ", 
	   completion_Date_Range:"ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಯ ದಿನಾಂಕ ಶ್ರೇಣಿ", 
	   from_date:"ದಿನಾಂಕದಿಂದ", 
	   to_date:"ಇಲ್ಲಿಯವರೆಗೆ", 
	   status:"ಸ್ಥಿತಿ", 
	   gender:"ಲಿಂಗ", 
	   final_grade:"ಅಂತಿಮ ಶ್ರೇಣಿ", 
	   advisor:"ಸಲಹೆಗಾರ", 
	   grade_level:"ಗ್ರೇಡ್ ಮಟ್ಟ", 
	   specific_mark:"ನಿರ್ದಿಷ್ಟ ಗುರುತು", 
	   track:"ಟ್ರ್ಯಾಕ್", 
	   ethnicity:"ಜನಾಂಗೀಯತೆ", 
	   additional_fields:"ಹೆಚ್ಚುವರಿ ಕ್ಷೇತ್ರಗಳು", 
	   school_sessions:"ಶಾಲಾ ಅವಧಿಗಳು", 
	   gradebook:"ಗ್ರೇಡ್ಬುಕ್", 
	   submit:"ಸಲ್ಲಿಸು", 
	   reset:"ಮರುಹೊಂದಿಸಿ", 
	   show_hide_columns:"ಕಾಲಮ್‌ಗಳನ್ನು ತೋರಿಸಿ/ಮರೆಮಾಡಿ", 
	   select_all:"ಎಲ್ಲವನ್ನು ಆರಿಸು", 
	   student_id:"ವಿದ್ಯಾರ್ಥಿಯ ಐಡಿ", 
	   last_name:"ಕೊನೆಯ ಹೆಸರು", 
	   first_name:"ಮೊದಲ ಹೆಸರು", 
	   start_date:"ಪ್ರಾರಂಭ ದಿನಾಂಕ", 
	   end_date:"ಅಂತಿಮ ದಿನಾಂಕ", 
	   grade_final:"ಗ್ರೇಡ್ ಫೈನಲ್", 
	   percent:"ಶೇಕಡಾ", 
	   credit:"ಕ್ರೆಡಿಟ್", 
	   download_excel:"ಎಕ್ಸೆಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ", 
	   print:"ಮುದ್ರಿಸಿ", 
	   no_data:"ಮಾಹಿತಿ ಇಲ್ಲ.", 
	   view:"ನೋಟ", 
	   showing:"ತೋರಿಸಲಾಗುತ್ತಿದೆ", 
	   of:"ನ", 
	   other_grade:"ಇತರೆ ದರ್ಜೆ", 
	   level:"Level", 
	   date:"ದಿನಾಂಕ", 
	   grade:"ಗ್ರೇಡ್", 
	   enrollment_Change_Status:"Enrollment Change Status", 
	   close:"ಮುಚ್ಚಿ", 
	   select_Enrollment_Status:"ನೋಂದಣಿ ಸ್ಥಿತಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ", 
	   select:"ಆಯ್ಕೆ ಮಾಡಿ...", 
	   cancel:"ರದ್ದುಮಾಡಿ", 
	   save:"ಉಳಿಸಿ", 
	   students:"ವಿದ್ಯಾರ್ಥಿಗಳು", 
	   Course_Status:"ಕೋರ್ಸ್ ಸ್ಥಿತಿ", 
	   Closed_courses:"ಮುಚ್ಚಿದ ಕೋರ್ಸ್‌ಗಳು", 
	   Section_Status:"ವಿಭಾಗದ ಸ್ಥಿತಿ", 
	   Closed_sections:"ಮುಚ್ಚಿದ ವಿಭಾಗಗಳು", 
	   Transferred_From:"ನಿಂದ ವರ್ಗಾಯಿಸಲಾಗಿದೆ", 
	   Graduation_From_Date:"ದಿನಾಂಕದಿಂದ ಪದವಿ", 
	   Graduation_To_Date:"ಇಲ್ಲಿಯವರೆಗೆ ಪದವಿ", 
	   Enrollment_From_Date:"ದಿನಾಂಕದಿಂದ ನೋಂದಣಿ", 
	   Enrollment_To_Date:"ಇಲ್ಲಿಯವರೆಗೆ ದಾಖಲಾತಿ", 
	   Enrollment_Status:"ದಾಖಲಾತಿ ಸ್ಥಿತಿ", 
	   Transfer_From_Date:"ದಿನಾಂಕದಿಂದ ವರ್ಗಾವಣೆ", 
	   Transfer_To_Date:"ದಿನಾಂಕಕ್ಕೆ ವರ್ಗಾಯಿಸಿ", 
	   Custom_Query:"ಕಸ್ಟಮ್ ಪ್ರಶ್ನೆ", 
	   Last_Access_Date:"ಕೊನೆಯ ಪ್ರವೇಶ ದಿನಾಂಕ", 
	   Total_Session_Time:"ಒಟ್ಟು ಸೆಷನ್ ಸಮಯ", 
	   Quality_of_Work:"ಕೆಲಸದ ಗುಣಮಟ್ಟ", 
	   Grade_to_Date:"ದಿನಾಂಕದಿಂದ ಗ್ರೇಡ್", 
	   Overall_Percent:"ಒಟ್ಟಾರೆ ಶೇ", 
	   On_Schedule_Percent:"ವೇಳಾಪಟ್ಟಿಯಲ್ಲಿ ಶೇ", 
	   Activity_Count_Complete:"ಚಟುವಟಿಕೆ ಎಣಿಕೆ ಪೂರ್ಣಗೊಂಡಿದೆ", 
	   Activity_Count_Total:"ಚಟುವಟಿಕೆ ಎಣಿಕೆ ಒಟ್ಟು", 
	   Overdue_Activitie:"ಅವಧಿ ಮೀರಿದ ಚಟುವಟಿಕೆ", 
	   Section_Course_Additional_Fields:"ವಿಭಾಗ/ಕೋರ್ಸ್ ಹೆಚ್ಚುವರಿ ಕ್ಷೇತ್ರಗಳು", 
	   Create_On_Date:"ದಿನಾಂಕದಂದು ರಚಿಸಿ", 
	   Last_Status_Update_Date:"ಕೊನೆಯ ಸ್ಥಿತಿ ನವೀಕರಣ ದಿನಾಂಕ", 
	   Transferred_In:"ಒಳಗೆ ವರ್ಗಾಯಿಸಲಾಗಿದೆ", 
	   Transferred_In_Date:"ದಿನಾಂಕದಲ್ಲಿ ವರ್ಗಾಯಿಸಲಾಗಿದೆ", 
	   email:"ಇಮೇಲ್", 
	   birth_date:"ಹುಟ್ಟಿದ ದಿನಾಂಕ", 
	   course_name:"ಕೋರ್ಸ್ ಹೆಸರು", 
	   section_name:"ವಿಭಾಗದ ಹೆಸರು", 
	   school_name:"ಶಾಲೆಯ ಹೆಸರು", 
	   Graduation_Date:"ಪದವಿ ದಿನಾಂಕ", 
	   Created_on:"ರಂದು ರಚಿಸಲಾಗಿದೆ", 
	   mentor_Advisor:"ಮಾರ್ಗದರ್ಶಕ/ಸಲಹೆಗಾರ", 
	   sections:"ವಿಭಾಗಗಳು", 
	   roster:"ರೋಸ್ಟರ್", 
	   relationship:"ಸಂಬಂಧ", 
	   Email_or_Phone:"ಇಮೇಲ್ ಅಥವಾ ಫೋನ್", 
	   Enter_any_text:"ಯಾವುದೇ ಪಠ್ಯವನ್ನು ನಮೂದಿಸಿ", 
	   Advisor_Success_Manager:"ಸಲಹೆಗಾರ / ಯಶಸ್ಸಿನ ವ್ಯವಸ್ಥಾಪಕ", 
	   User_Id:"ಬಳಕೆದಾರರ ಗುರುತು", 
	   phone_number:"ದೂರವಾಣಿ ಸಂಖ್ಯೆ", 
	   Student_Last_Name:"ವಿದ್ಯಾರ್ಥಿ ಕೊನೆಯ ಹೆಸರು", 
	   Student_First_Name:"ವಿದ್ಯಾರ್ಥಿಯ ಮೊದಲ ಹೆಸರು", 
	   Student_Email:"ವಿದ್ಯಾರ್ಥಿ ಇಮೇಲ್", 
	   credentials:"ರುಜುವಾತುಗಳು", 
	   availability:"ಲಭ್ಯತೆ", 
	   enrollments:"ದಾಖಲಾತಿಗಳು", 
	   Datea_Created_on:"ದಿನಾಂಕವನ್ನು ರಚಿಸಲಾಗಿದೆ", 
	   country:"ದೇಶ", 
	   state:"ರಾಜ್ಯ", 
	   zipcode:"ಪಿನ್ ಕೋಡ್", 
	   Enter_any_zipcode:"ಯಾವುದೇ ಪಿನ್‌ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ", 
	   address:"ವಿಳಾಸ", 
	   zip_Code:"ಪಿನ್ ಕೋಡ್", 
	   Login_Report:"ಲಾಗಿನ್ ವರದಿ", 
	   user_Type:"ಬಳಕೆದಾರರ ಪ್ರಕಾರ", 
	   user_Name:"User Name", 
	   Show_last_log_in_only:"Show last log in only", 
	   Username:"Username", 
	   Date_Time:"Date/Time", 
	   Ip_Address:"Ip Address", 
	   city:"City", 
	   Enrollment_Start_Date:"Enrollment Start Date", 
	   Enrollment_End_Date:"Enrollment End Date", 
	   Completion_Date:"Completion Date", 
	   section_Type:"Section Type", 
	   student_Enrolled:"Student Enrolled", 
	   content_Provider:"Content Provider", 
	   student_Additional_Fields:"Student Additional Fields",
	   type:"Type", 
	   in_Class_Information:"In Class Information", 
	   Enrollment_Summary_Report:"Enrollment Summary Report", 
	   Transferred_From_School:"Transferred From School", 
	   Total_Enrollments:"Total Enrollments", 
	   content_Type:"Content Type", 
	   active_Course_Progress:"Active Course Progress", 
	   Grades:"Grades", 
	   attendance:"Attendance", 
	   student_Absences:"Student Absences", 
	   total_Absence:"Total Absence", 
	   section_Absences:"Section Absences", 
	   Grade_Level_Absences:"Grade Level Absences", 
	   Gender_Absences:"Gender Absences", 
	   Login_credentials:"Login credentials", 
	   names:"Names", 
	   user_status_admin_teacher_parent:"User Status (Admin, Teacher, Parent)", 
	   show_title:"Show Title", 
	   midle_name:"Middle Name", 
	   password:"Password", 
	   parent_name:"Parent Name", 
	   linked_to_parent:"Linked To Parent", 
	   linked_to_student:"Linked To Student", 
	   login_credentials_Report:"Login credentials Report", 
	   app_id:"App Id", 
	   created:"Created", 
	   modified:"Modified", 
	   select_level:"Select level", 
	   select_additional_fields:"Section Additional Fields", 
	   title:"Title", 
	   credits:"Credits", 
	   section_ID:"Section ID", 
	   content:"Content", 
	   course_additional_fields:"Course Additional Fields", 
	   course_id:"Course ID", 
	   communication_summary_report:"Communication Summary Report", 
	   method:"Method", 
	   create_date:"Create Date", 
	   subject:"Subject", 
	   make_from_id:"Make From ID", 
	   make_to:"Make To", 
	   attachments:"Attachments", 
	   comment_and_document_summary_report:"Comment and Document Summary Report", 
	   comment_type:"Comment Type", 
	   flagged:"Flagged", 
	   sharing_target:"Sharing Target", 
	   show_on_transcript:"Show On Transcript", 
	   by:"By", 
	   comment:"Comment", 
	   type_name:"Type Name", 
	   effective_from_date:"Effective From Date", 
	   effective_to_date:"Effective To Date", 
	   count_docs:"Count Docs", 
	   school_calendar_report:"School Calendar Report", 
	   event_Id:"Event Id", 
	   date_start:"Date Start", 
	   date_end:"Date End", 
	   posted_last_name:"Posted Last Name", 
	   posted_first_name:"Posted First Name", 
	   bell_schedule_report:"Bell schedule Report", 
	   period:"Period", 
	   start:"Start", 
	   end:"End", 
	   student_contract_report:"Student Contract Report", 
	   begin_date:"Begin Date", 
	   contracts:"Contracts", 
	   contract_name:"Contract Name", 
	   contract_begin_date:"Contract Begin Date", 
	   contract_end_date:"Contract End Date", 
	   active_enrollments_per_term_report:"Active Enrollments Per Term Report", 
	   entry_date:"Entry Date", 
	   teachers:"Teachers", 
	   term:"Term", 
	  
	   sections:"Sections", 
	   showing_of:"Showing 10 of 20", 
	   filter:"Filter", 
	   students:"Students", 
	   school:"School", 
	   all_school:"All Schools", 
	   student:"Student", 
	   email:"Email", 
	   grade_level:"Grade Level", 
	   status:"Status", 
	   seach_for_a_student_or_id:"Search for a student or ID …", 
	   search:"Search …", 
	   message_student:"Message student", 
	   request_enrollment:"Request Enrollment", 
	   print_schedule:"Print Schedule", 
	   view:"View", 
	   no_data:"No data.", 
	   views:"Views", 
	   enrollment:"Enrollment", 
	   schedule:"Schedule", 
	   transferred_grades:"Transferred Grades", 
	   comments_ocuments:"Comments & Documents", 
	   academic_records:"Academic Records", 
	   compliance_log:"Compliance Log", 
	   unofficial_transcript:"Unofficial Transcript", 
	   iD_card:"ID Card", 
	   student_number_id_information:"Student Number #29561 Information", 
	   student_number:"Student Number", 
	   gender:"Gender", 
	   goes_by:"Goes by", 
	   date_of_birth:"Date of Birth", 
	   ethnicity:"Ethnicity", 
	   mobile:"Mobile", 
	   academic_track:"Academic Track", 
	   learning_path_template:"Learning Path Template", 
	   graduation_date:"Graduation Date", 
	   comments:"Comments", 
	   transfer_information:"Transfer Information", 
	   enrollment_date:"Enrollment Date", 
	   transfer_date:"Transfer Date", 
	   transfer_student:"Transfer Student", 
	   parent_mentor_contact:"Parent / Mentor Contact", 
	   mentor:"Mentor", 
	   parent_phone:"Parent's Phone", 
	   emergency_contact:"Emergency contact", 
	   academic_advisor_ssm:"Academic Advisor / SSM", 
	   student_success_manager:"Student Success Manager", 
	   academic_avisor:"Academic Advisor", 
	   address:"Address", 
	   address_01_Default:"Address 01 (Default)", 
	   street:"Street", 
	   city:"City", 
	   state:"State", 
	   zip:"Zip", 
	   hide_Detailed_information:"Hide Detailed information", 	    
	   current_course_progress:"Current Course Progress", 	    
	   full_Path_Progress:"Full Path Progress", 	    
	   print:"Print", 	    
	   avg_graduation_progress:"Avg. Graduation Progress", 	    
	   GPA:"GPA", 	    
	   graduation_Status:"Graduation Status", 	    
	   on_track:"On Track", 	    
	   show_detailed_information:"Show Detailed information", 	    
	   communication:"Communication", 	    
	   student_advisors:"Student Advisors", 	    
	   country:"Country", 	    
	   grade:"Grade", 	    
	   credits:"Credits", 	    
	   sort:"Sort", 	    
	   course_progress:"Course progress", 	    
	   overall_GPA:"Overall GPA", 	    
	   current_graduation_progress:"Current Graduation Progress", 	    
	   individual_course_progress:"*Individual course progress varies, this is your overall progress", 	    
	   subject:"Subject",
	   online_sections:"Online Sections",
	   course:"Course",
	   section:"Section", 
	   actions:"Actions", 
	   view_event:"View Event", 
	   in_class_section:"In Class Section",
	   calendar:"Calendar", 
	   access_link:"Access link", 
	   online_link:"Online link",
	   launch_course:"Launch Course", 
	   start_class:"Start Class", 
	   level:"Level", 
	   date:"Date", 
	   transferred_in:"Transferred In", 
	   tranferred_grades:"Transferred Grades", 
	   Searchs:"Search", 
	   Search_department_course:"Search department course, src…", 
	   archived:"Archived", 
	   add_comment:"Add Comment", 
	   created_date:"Created date", 
	   by:"By", 
	   type:"Type", 
	   comment:"Comment", 
	   from_date:"From Date", 
	   to_date:"To Date", 
	   documents:"Documents", 
	   edit:"Edit", 
	   delete:"Delete", 
	   communications:"Communications", 
	   add_communications:"Add Communication", 
	   made_from:"Made From", 
	   made_to:"Made To", 
	   means:"Means", 
	   attachments:"Attachments", 
	   content:"Content", 
	   compliance_logs:"Compliance Logs", 
	   messageID:"Message ID", 
	   agree:"Agree", 
	   dateTime:"Date Time", 
	   iPAddress:"IP Address", 
	   add_idit_comment_document:"Add/Edit Comment & Document", 
	   document_type:"Document Type", 
	   show_on_transcript:"Show On Transcript", 
	   select_users_to:"Select users to", 
	   teacher:"Teacher", 
	   parent:"Parent", 
	   flag:"Flag", 
	   none:"None", 
	   link:"Link", 
	   label:"Label", 
	   add_more_link:"Add More Link", 
	   save:"Save", 
	   add_edit_communication:"Add/Edit Communication", 
	   made_by:"Made By", 
	   date_time:"Date/Time", 
	   length:"Length", 
	   select:"Select", 
	   select_users_to_view:"Select users to view communication", 
	   add_more:"Add More", 
	   communication_summary:"Communication Summary", 
	   close:"Close", 
	   new_type:"New Type", 
	   select_user_to_view_comment:"Select users to view comment", 
	   flag_comment:"Flag comment", 
	   teacher_page:"Teacher Page", 
	   edit_information:"Edit information", 
	   phone:"Phone",
	   add_credential:"Add Credential",
	   add_edit_credential:"Add/Edit Credential",
	   first_name:"First Name",
	   midle_name:"Middle Name",
	   last_name:"Last Name",
	   cancel:"Cancel",
	   add_new:"Add New",
	   phone_type:"Phone Type",
	   zipCode:"Zip Code",
	   phone_number:"Phone Number",
	   default:"Default",
	   please_select_country:"Please select Country",
	   student_information:"Student Information",
	   username:"Username",
	   user_directory:"User Directory",
	   add_teacher:"Add Teacher",
	   add_admin:"Add Admin",
	   export_to_excel:"Export to Excel",
	   export_to_pdf:"Export to PDF",
	   send_login_credentials:"Send Login Credentials",
	   search_for_a_user_or_id:"Search for a user or ID …",
	   user:"User",
	   school_admin:"School Admin",
	   change_password:"Change Password",
	   set_password_expiration_date:"Set Password Expiration Date",
	   impersonate_user:"Impersonate User",
	   edit_user_tags:"Edit user tags",
	   add_or_edit_users_schoo_assign:"Add or edit users school assign",
	   assign_content_access:"Assign Content Access",
	   add_student:"Add Student",
	   add_parent_mentor:"Add Parent / Mentor",
	   showing:"Showing",
	   of:"of",
	   school_name:"School Name",
	   edit_user_school_tags:"Edit User-School Tags",
	   personal_information:"Personal Information",
	   contacted_load:"Contacted Load",
	   maximum_of_active_students:"Maximum # of Active Students",
	   teacher_since:"Teacher Since",
	   login_infomation:"Login Information",
	   username:"Username",
	   password :"Password",
	   avatar :"Avatar",
	   teachers :"Teachers",
	   change_status:"Change Status",
	   add_admin:"Add Admin",
	   name:"Name",
	   create_on:"Create On",
	   registrar:"Registrar",
	   birthday:"Birthday",
	   signature:"Signature",
	   photo:"Photo",
	   designated_registrar:"Designated Registrar",
	   track:"Track",
	   select_existing_track:"Select existing track",
	   available:"Available",
	   parent_mentor:"Parent / Mentor",
	   relationship:"Relationship",
	   email_address:"Email Address",
	   academic_mentor:"Academic Mentor",
	   no_data_available_in_table:"No data available in table",
	   primary_language:"Primary Language",
	   add_into_parent_or_mentor:"Add into Parent / Mentor",
	   add_into_phone:"Add into Phone",
	   add_into_address:"Add into Address",
	   select_one:"Select one",
	   login:"Login",
	   plese_select_country:"Please choose country",
	   edit_student:"Edit Student",
	   academic_advisor_or_student_success_manager:"Academic Advisor / Student Success Manager",
	   role:"Role",
	   link_parent:"Link Parent",
	   link_advisor_sms:"Link Advisor/SSM",
	   save_into_parent_mentor:"Save into Parent / Mentor",
	   save_into_parent_phone:"Save into Phone",
	   save_into_parent_address:"Save into Address",
	   bulk_information_update:"Bulk Information Update",
	   enrollments:"Enrollments",
	   email_student:"Email Student",
	   unofficial_transcripts:"Unofficial Transcripts",
	   official_transcripts:"Official Transcripts",
	   email_students_schedule:"Email Student's Schedule",
	   export_students_to_excel:"Export Students to Excel",
	   export_parent_list_to_excel:"Export Parent list to Excel",
	   assign_learning_path_template:"Assign Learning Path Template",
	   promote_student_to_the_next_grade_level:"Promote student to the next grade level",
	   batch_upload_students:"Batch Upload Students",
	   batch_upload_transfer_grades:"Batch Upload Transfer Grades",
	   transfer_apex_only:"Transfer (APEX Only)",
	   transfer_content_providers:"Transfer (All Content Providers)",
	   batch_enrollments:"Batch Enrollments",
	   send_message:"Send Message",
	   impersonate:"Impersonate",
	   change_login_credentials:"Change Login Credentials",
	   request_enrollment:"Request Enrollment",
	   send_weekly_status_report:"Send Weekly Progress Report",
	   please_select_student:"Please select Students.",
	   student_status_will_be_changed_to_status_withdraw:"Student status will be changed to 111, and all enrollments will be withdrawn.  Are you sure you want to continue?",
	   student_status_will_be_changed_to_status:"Student status will be changed to 111. Are you sure you want to continue?",
	   value:"Value",
	   student_success_manager_or_acdemic:"Student Success Manager / Academic Advisor",
	   enroll_students_to_section:"Enroll Students To Section",
	   department:"Department",
	   refresh:"Refresh",
	   select_department:"Select department",
	   select_course:"Select course",
	   select_section:"Select Section",
	   start_date:"Start Date",
	   end_date:"End Date",
	   ID:"ID",
	   action:"Action",
	   enrollment_period:"Enrollment period",
	   select_a_course_to_register_ilp:"Select a course to register ilp",
	   period:"Period",
	   credit:"Credit",
	   year:"Year",
	   enroll:"Enroll",
	   recipient_transcript:"Recipient Transcript",
	   select_all_or_unselect_all:"select all / unselect all",
	   include_in_progress_sections:"Include In Progress Sections",
	   show_satisfaction_of_program:"Show Satisfaction of Program",
	   show_total_credit:"Show Total Credits",
	   show_student_info:"Show Student Info",
	   show_academic_info:"Show Academic Info",
	   show_school_names_from_orther_grades:"Show school names from other grades",
	   show_school_contact:"Show school contact",
	   include_transferred_grades_in_gpa:"Include Transferred Grades in GPA",
	   include_in_progress_grade:"Include In Progress Grade",
	   include_grade_scales:"Include Grade Scales",
	   show_graduation_date:"Show Graduation Date",
	   show_weighted_gpa:"Show Weighted GPA",
	   show_grade_level_gpa:"Show Grade Level GPA",
	   show_comletion_date:"Show Completion Date",
	   show_withdraw_classes:"Show Withdrawn Classes",
	   show_withdraw_date:"Show Withdrawn Date",
	   show_transfered_in_classes:"Show transferred in classes",
	   show_digital_seal:"Show Digital Seal",
	   show_singnature:"Show Signature",
	   group_by:"Group By",
	   school_year:"School Year",
	   school_level:"School Level",
	   notes:"Notes",
	   ok:"Ok",
	   are_you_sure_to_send:"Are you sure to send?",
	   assign_learning_path_templete:"Assign Learning Path Template",
	   assign_student_to_selected_learning:"Assign Student To Selected Learning Path Template",
	   assign:"Assign",
	   are_you_sure_to_promote_to_level:"Are you sure to Promote to next grade level?",
	   data_process:"Data Process",
	   upload_and_import_data:"Upload & Import Data",
	   download_user_information:"Download user information",
	   here:"here",
	   select_student_upload_file:"Select Student Upload File",
	   local_drive:"Local Drive",
	   the_file_is_uploaded:"The file is uploaded",
	   template_name:"Template Name",
	   Here:"Here",
	   sample_file_excel:"sample file excel.",
	   file_type:"File Type",
	   delimited:"Delimited",
	   delimited_chars:"Delimited Chars",
	   fixed_width:"Fixed Width",
	   first_line_header:"First Line Header",
	   loader_field:"Load Field",
	   Header:"Header",
	   sample_data:"Sample Data",
	   column_width:"Colunm Width",
	   save_tamplate:"Save Template",
	   save_and_upload_data:"Save & Upload Data",
	   result:"Result",
	   upload_and_import_data_orther_grade:"Upload & Import Data Other Grade",
	   select_upload_file:"Select Upload File",
	   student_id:"Student ID",
	   uploadAnd_import_data_enrollment:"Upload & Import Data Enrollment",
	   section_id:"Section ID",
	   title:"Title",
	   recipient:"Recipient",
	   same_current_address:"Same as Current Address",
	   add_more_reciptient:"Add more Recipient",
	   issuse_date:"Issue Date",
	   show_total_unapplied_credits:"Show Total Unapplied Credits",
	   reconcile_another_student_record:"Reconcile with Another Student Record",
	   please_choose_one_student_to_reconcile:"Please choose one student to reconcile.",
	   yes:"Yes",
	   no:"No",
	   apex_classroom_sync:"Apex Classroom Sync",
	   next:"Next",
	   apex_classrooms:"APEX Classrooms",
	   online_user_id:"Online User Id",
	   enter_online_user_id:"Enter Online User Id",
	   online_section_id:"Online Section Id",
	   online_section_name:"Online Section Name",
	   online_course_name:"Online Course Name",
	   enrollment_date:"Enrollment Date",
	   back:"Back",
	   import:"Import",
	   offical_transcipt:"Official Transcript",
	   email_schedule:"Email Schedule",
	   reconcile_with_another_records:"Reconcile with Another Record",
	   online_sync_and_update:"Online Progress Sync & Update",
	   download_all_completion_cretification:"Download All Completion Certification",
	   orther_grade:"Other Grades",
	   medical:"Medical",
	   comments_and_documents:"Comments and Documents",
	   contracts:"Contracts",
	   invoices:"Invoices",
	   audit_logs:"Audit Logs",
	   edit_logs:"Edit Logs",
	   grade_to_date:"Grade To Date",
	   quality_of_work:"Quality Of Work",
	   last_access:"Last Access",
	   gradebook:"Gradebook",
	   transfer:"Transfer",
	   completion_certification:"Completion Certification",
	   tranfer_user_school:"Transfer user school",
	   tranfer_to_school:"Transfer To School",
	   tranfer_apex_classrooms:"Transfer APEX Classrooms",
	   course_to_moved:"Course To Moved",
	   current_teacher:"Current Teacher",
	   future_section:"Future Section",
	   future_program:"Future Program",
	   future_teacher:"Future Teacher",
	   enrollment_start_date_end_date:"Enrollment Start Date - End Date",
	   no_more_option:"No more options",
	   create_new:"Create New",
	   transfer_classrooms:"Transfer Classrooms",
	   tyler_synchronization_for_az_school:"Tyler Synchronization for AZ Schools",
	   synchronize:"Synchronize",
	   individual_course_progress_varies:"Individual course progress varies. This is your overall progress toward graduation.",
	   edit_ilp:"Edit ILP",
	   add_academic_record:"Add Academic Record",
	   edit_all_records:"Edit All Records",
	   search_corse_department_src:"Search course, department, src…",
	   message_id:"Message ID",
	   add_new_contract:"Add New Contract",
	   contract_id:"Contract ID",
	   contract_name:"Contract Name",
	   first_date:"First Date",
	   last_date:"Last Date",
	   amount_per_period:"Amount Per Period",
	   terminating_status:"Terminating Status",
	   payment_history:"Payment History",
	   record_payment:"Record Payment",
	   payment_method:"Payment Method",
	   invoice_id:"Invoice ID",
	   show_all:"Show All",
	   invoice_date:"Invoice Date",
	   from:"From…",
	   to:"To…",
	   amount:"Amount",
	   paid:"Paid",
	   due:"Due",
	   date_paid:"Date Paid",
	   apply_payments:"Apply Payments",
	   mark_as_paid:"Mark As Paid",
	   void:"Void",
	   audit_log:"Audit Log",
	   object:"Object",
	   changes_made:"Changes Made",
	   create_time:"Create Time",
	   time_stamp:"Time Stamp",
	   user_creare:"User Create",
	   edit_log:"Edit Log",
	   field_name:"Field Name",
	   old_value:"Old Value",
	   new_value:"New Value",
	   date_time_update:"Date/Time Update",
	   updater:"Updater",
	   add_edit_academic_records:"Add/Edit Academic Record",
	   select_flag:"Select Flag ...",
	   edit_all_tranferred_grades:"Edit All Tranferred Grades",
	   save_records:"Save Records",
	   possible_credits:"Possible Credits",
	   select_level:"Select level",
	   select_grade_level:"Select grade level",
	   select_status:"Select status",
	   add_more_row:"Add More Row",
	   full_screen:"Full Screen",
	   course_code:"Course code",
	   add_order_grades:"Add Other Grades",
	   select_credit:"Select credit",
	   select_default:"Select default",
	   credits_possible:"Credits possible",
	   select_possible_credit:"Select possible credit",
	   product:"Product",
	   fromn:"From",
	   ton:"To",
	   last_invoice_date:"Last Invoice Date",
	   please_select_stu:"Please select Student",
	   payer:"Payer",
	   amount_per_billing_period:"Amount Per Billing Period",
	   price_unit:"Price Unit",
	   billing_period:"Billing Period",
	   automatic_renewal:"Automatic Renewal",
	   automatic_payment:"Automatic Billing",
	   contract_template:"Contract Template",
	   accept:"Accept",
	   reject:"Reject",
	   duration_of_period:"Duration (# of periods)",
	   payment_id:"Payment ID",
	   payment_date:"Payment Date",
	   payment_amount:"Payment Amount",
	   applied:"Applied",
	   available:"Available",
	   unApply:"UnApply",
	   refund:"Refund",
	   add_new_teacher:"Add New Teacher",
	   change_teacher_status:"Change Teacher Status",
	   search_for_a_teacher_or_id:"Search for a teacher or ID …",
	   flags:"Flags",
	   tags:"Tags",
	   allowed:"Allowed",
	   message_teacher:"Message Teacher",
	   impersonate_teacher:"Impersonate Teacher",
	   add_teacher_qualification:"Add Teacher Qualification",
	   profile:"Profile",
	   teacher_schedule:"Teacher Schedule",
	   qualifications:"Qualifications",
	   student_actions:"Student Actions",
	   linking_parents_to:"Linking Parents to",
	   select_do:"Select ...",
	   see_edit_logs:"See Edit logs",
	   see_qualifications:"See Qualifications",
	   link_academic_advisor:"Link Academic Advisor",
	   student_success:"Student Success",
	   linking_academic_advisor_or_student_success:"Linking Academic Advisor / Student Success to",
	   staff:"Staff",
	   teacher_status:"Teacher Status",
	   school_admin_status:"School Admin Status",
	   global_user_directory:"Global User Directory",
	   edit_teacher:"Edit Teacher",
	   contracted:"Contracted",
	   add_comments_and_documents:"Add Comments and Documents",
	   edit_comments_and_documents:"Edit Comments and Documents",
	   parents_or_mentor:"Parents / Mentor",
	   send_mail:"Send Mail",
	   are_you_sure_to_delete_this_teacher:"Are you sure to delete this Teacher.",
	   edit_user_password:"Edit Username & Password",
	   add_qualifications:"Add Qualifications",
	   please_select_a_least_on_teacher:"Please select at least one teacher.",
	   edit_parent_mentor:"Edit Parent / Mentor",
	   parent_mentor_information:"Parent / Mentor Information",
	   send:"Send",
	   are_you_surse_to_delete_this_parent:"Are you sure to delete this  Parent.",
	   home:"Home",	   
	   //auto_promotion:"Auto Promotion",
	   auto_promotion:"Student Grade Level Promotion",
	   Promote:"Promote",
	   search_for_a_name:"Search for a name …",
	   download_to_excel:"Download to Excel",
	   download_to_pdf:"Download to Pdf",
	   User_ID:"User ID",
	   User_type:"User type",
	   communication_log:"Communication Log",
	   Student_Status:"Student Status",
	   Users:"Users",
	   Staff_Reassignment:"Staff Reassignment",
	   Select_Staff:"Select Staff",
	   select_asset_type_to_reassign:"select asset type to reassign",
	   transfer_all_to:"Transfer all to",
	   transfer_selectively:"Transfer selectively",
	   remove_all:"Remove all",
	   remove_selectively:"Remove selectively",
	   Event:"Event",
	   Time:"Time",
	   Participants:"Participants",
	   new_staff:"New Staff",
	   Remove:"Remove",
	   Profile_Page:"Profile Page",
	   settings:"Settings",
	   security:"Security",
	   timezone:"Timezone",
	   notifications:"Notifications",
	   check_for_feature_availability_at_your_school:"Check for feature availability at your school.",
	   current_password:"Current Password",
	   new_password:"New Password",
	   confirm_password:"Confirm Password",
	   updte_password:"Update Password",
	   change_timezone:"Change Timezone",
	   time_zone:"Time zone",
	   please_select_time_zone:"Please select time zone",
	   notification_settings:"Notification Settings",
	   level_of_urgency:"Level of Urgency",
	   email_destination:"Email Destination",
	   SMS_Destination:"SMS Destination",
	   app:"App",
	   please_select_level_of_urgency:"Please select level of urgency",  
	   reset_filters:"Reset filters",
	   batch_data_update:"Student Data Update", 
	   view_roles:"View Roles", 
	   administrator_information:"Administrator Information", 
	   account_reation_date:"Account Creation Date", 
	   expiration_date:"Expiration date", 
	   schools:"Schools", 
	   advisees:"Advisees", 
	   message:"Message", 
	   see_comments_and_documents:"See Comments and Documents", 
	   restore_APEX_Classrooms:"Restore APEX Classrooms", 
	   teacher_information:"Teacher Information", 
	   teacher_number:"Teacher Number", 
	   departmens:"Departments", 
	   global_capacity:"Global Capacity", 
	   local_contracted_load:"Local Contracted Load", 
	   parents:"Parents", 
	   parent_information:"Parent Information", 
	   linked_students:"Linked Students", 
	   link_student:"Link Student", 
	   unlink_student:"Unlink Student", 
	   search_dot:"Search…", 
	   view_local:"View local", 
	   view_global:"View global", 
	   resource:"Resource", 
	   current_grade:"Current Grade", 
	   affiliation:"Affiliation", 
	   current_assignment:"Current Assignment", 
	   total_assignments:"Total assignmentst", 
	   percent_completed:"Percent Completed", 
	   semester:"semester", 
	   graduation_year:"Graduation Year", 
	   student_name:"Student Name", 
	   credits_earned:"Credits Earned", 
	   exit:"exit", 
	   engagement_type:"Engagement type", 
	   college_admitted:"College admitted", 
	   college_attending:"College attending", 
	   major:"Major", 
	   report_card:"Report Card", 
	   academic_term:"Academic Term", 
	   show_average:"Show Average", 
	   school_information:"School Information", 
	   school_misc_configuration:"School Misc Configuration", 
	   school_tags:"School Tags", 
	   role_tags:"Role Tags", 
	   content_integration:"Content Integration", 
	   user_roles:"User Roles", 
	   communication_user_rules:"Communication User Rules", 
	   school_administrators:"School Administrators", 
	   school_year_configuration:"School Year Configuration", 
	   A_R_payment_configuration:"A/R Payment Configuration", 
	   facility:"Facility", 
	   enrollment_rules:"Enrollment Rules", 
	   student_contract_rules:"Student Contract Rules", 
	   products:"Products", 
	   notification_templates:"Notification Templates", 
	   transcript_viewer_options:"Transcript Viewer Options", 
	   feature_configuration:"Feature Configuration", 
	   feature_settings:"Feature Settings", 
	   communication_rules:"Communication Rules", 
	   object_state:"Object State", 
	   departments:"Departments", 
	   grading_scales:"Grading Scales", 
	   grading_periods:"Grading Periods", 
	   academic_tracks:"Academic Tracks", 
	   learning_path_templates:"Learning Path Templates", 
	   grade_book_activity_descriptions:"Grade Book Activity Descriptions", 
	   academic_terms:"Academic Terms", 
	   academic_system:"Academic System", 
	   address_line_1:"Address Line 1", 
	   country_code:"Country Code", 
	   address_line_2:"Address Line 2", 
	   school_title:"School Title", 
	   CEEB_code:"CEEB Code", 
	   zip_postal_code:"Zip/Postal Code", 
	   state_province:"State/Province", 
	   website:"Website", 
	   subdomain:"Subdomain", 
	   success_manager:"Success Manager", 
	   school_logo:"School Logo", 
	   digital_seal:"Digital Seal", 
	   password_exception_rule:"Password Exception Rule", 
	   change_password_first_login:"Change password first login", 
	   password_expires_after_days:"Password expires after days", 
	   enforcement_of_teachers_load:"Enforcement of Teacher's Load", 
	   in_house_handling_of_transcript_requests:"In House Handling of Transcript Requests", 
	   display_mobile_app_link:"Display Mobile App Link", 
	   display_weekly_progress_goal:"Display Weekly Progress Goal", 
	   turn_on_notification:"Turn On Notification", 
	   classic_letter:"Classic Letter", 
	   automatic_parent_account_creation:"Automatic Parent Account Creation", 
	   default_parent_account_status:"Default Parent Account Status", 
	   default_time_zone:"Default Time Zone", 
	   link_to_transcript_vendor_help:"Link to Transcript Vendor Help", 
	   link_to_transcript_vendor:"Link to Transcript Vendor", 
	   link_for_help_system:"Link for Help System", 
	   student_enrollment_limit:"Student Enrollment Limit", 
	   default_section_type:"Default Section Type", 
	   default_section_capacity:"Default Section Capacity", 
	   transcript_template:"Transcript Template", 
	   edit_security_school_tags:"Edit Security School Tags", 
	   security_school_tags:"Security School Tags", 
	   tags_name:"Tags Name", 
	   edit_role_tags:"Edit Role Tags", 
	   add_school_based_tags:"Add School Based Tags", 
	   description:"Description", 
	   applied_to_roles:"Applied To Roles", 
	   teacher:"Teacher", 
	   edit_security_role_tags_for:"Edit Security Role Tags for", 
	   school_admins:"School Admins", 
	   school_begin_date:"School Begin Date", 
	   school_end_date:"School End Date", 
	   automatic_control_of_teacher_s_load:"Automatic Control Of Teacher's Load", 
	   A_R_payment_gateway_configuration:"A/R Payment Gateway Configuration", 
	   payment_processing_vendor:"Payment Processing Vendor", 
	   secret_key:"Secret Key", 
	   publishable_key:"Publishable Key", 
	   account_id:"Account ID", 
	   updating_tudents:"Updating Students", 
	   delete_selected_records:"Delete Selected Records", 
	   attribute_name:"Attribute Name", 
	   applied_for:"Applied For", 
	   add_school:"Add School", 
	   overview:"Overview", 
	   search_for_school:"Search for school…", 
	   search_for_student:"Search for student…", 
	   attribute_type:"Attribute Type", 
	   select_school_group:"Select School Group", 
	   access_rights:"Access Rights", 
	   create:"Create", 
	   read:"Read", 
	   facility_management:"Facility Management", 
	   facility_name:"Facility Name", 
	   capacity:"Capacity", 
	   enrollment_allowance_period_days:"Enrollment Allowance Period (days)", 
	   maximum_enrollment_duration_days:"Maximum Enrollment Duration (days)", 
	   start_date_of_the_week:"Start Date of the Week", 
	   end_date_of_the_week:"End Date of the Week", 
	   lookup_name:"Lookup Name", 
	   duration:"Duration", 
	   time_unit:"Time Unit", 
	   round_up_to_end_of_time_unit:"Round Up to End of Time Unit", 
	   product_name:"Product Name", 
	   product_ID:"Product ID", 
	   price_offer:"Price Offer", 
	   price:"Price", 
	   frequency:"Frequency", 
	   effective_from:"Effective From", 
	   effective_to:"Effective To", 
	   active:"Active", 
	   drag_drop_to_text_cursor_in_content:"Drag & drop to text cursor in content", 
	   event_type:"Event Type", 
	   notification_rule:"Notification Rule", 
	   level_or_ugency:"Level or Ugency", 
	   user_role:"User Role", 
	   edit_security_user_tags:"Edit Security User Tags", 
	   content_access:"Content Access", 
	   content_access_for:"Content Access for", 
	   add_new_access:"Add New Access", 
	   date_assigned:"Date Assigned", 
	   enrollment_request:"Enrollment Request", 
	   enrollment_request_for:"Enrollment Request for", 
	   mentors:"Mentors", 
	   options:"Options", 
	   department_name:"Department Name", 
	   universal_department:"Universal Department", 
	   open:"Open", 
	   min_point:"Min Point", 
	   max_point:"Max Point", 
	   grade_point:"Grade Point", 
	   honors:"Honors", 
	   college:"College", 
	   order:"Order", 
	   start_time:"Start Time", 
	   end_time:"End Time", 
	   period_name:"Period Name", 
	   grading_periods_head:"Grading Periods Head", 
	   grading_period:"Grading Period", 
	   weight:"Weight", 
	   track_name:"Track Name", 
	   academic_track_requirement:"Academic Track Requirement", 
	   of_required_credits:"# of Required Credits", 
	   individual_learning_plan_template:"Individual Learning Plan Template", 
	   ILP_name:"ILP Name", 
	   remove_requirement:"Remove Requirement", 
	   reset_requirement:"Reset Requirement", 
	   add_requirement:"Add Requirement", 
	   must_end_date:"Must End Date", 
	   courses_open_date:"Courses Open Date", 
	   signup_end_date:"Signup End Date", 
	   signup_start_date:"Signup Start Date", 
	   section_period:"Section Period", 
	   
	   weeks:"Weeks", 
	   search_for_a_section_or_id:"Search for a section or ID …", 
	   search_for_a_deft:"Search for a dept…", 	   
	    launch_course:"Launch course", 
	   start_class:"Start Class", 	   
	   weekly_progress_goal:"Weekly Progress Goal", 	 
	   send_message_to_all_section_students:"Send Message to All Section Students", 
	   monitor_live_sessions:"Monitor Live Sessions", 
	   average_section_grade:"Average Section Grade", 	   
	   resources:"Resources", 
	   activities:"activities", 	   
	   course_attendance_today:"Course Attendance Today", 	   
	   staffs:"Staffs", 
	   units:"Units", 
	   view_all_15_resources:"View all 15 resources", 
	   Class_discussions:"Class discussions", 
	   recent_discussions:"Recent Discussions", 	   
	   go_to_class_discussions:"Go to class discussions", 
	   show_my_class_attendance:"Show my class attendance", 
	   add_section:"Add Section",
	   add_global_section:"Add Global Section",
	   close_section:"Close Sections",
	   open_section:"Open Sections",
	   batch_upload:"Batch Upload",
	   finalize:"Finalize",
	   add_tearcger:"Add Teacher(s)",
	   remove_tearcger:"Remove Teacher(s)",
	   uploadSectionStatusUpdates:"Upload Section Status Updates",
	   status_count:"Status Count",
	   reactivate:"Reactivate",
	   clone:"Clone",
	   enroll_into_Section:"Enroll into Section",
	   bulk_enrollment:"Bulk Enrollment",
	   general_Information:"General Information",
	   online_content_source:"Online Content Source",
	   second_teacher:"Second Teacher",
	   today:"today",
	   calendar:"Calendar",
	   week:"week",
	   month:"Month",
	   section_progress:"Section Progress",
	   complete:"complete",
	   section_title:"Section Title",
	   enter_section_title:"Enter section title",
	   select_teacher:"Select teacher",
	   select_weeks:"Select weeks",
	   select_credits:"Select credits",
	   select_type:"Select type",
	   global_section:"Global Section",
	   enrollment_capacity:"Enrollment Capacity",
	   enter_enrollment_capacity:"Enter enrollment capacity",
	   in_class_information:"In Class Information",
	   Start:"Start",
	   End:"End",
	   recurrencePattern:"Recurrence Pattern",
	   recurrenceFrequency:"Recurrence Frequency",
	   Weekly:"Weekly",
	   Monthly:"Monthly",
	   Recur_every:"Recur every",
	   Weeks_on:"Weeks on",
	   day_of_week:"Day Of Week",
	   daily_period:"Daily Period",
	   select_daily_period:"Select daily period",
	   Day:"Day",
	   The:"The",
	   of_every:"of every",
	   month_s:"month(s)",
	   add:"Add",
	   course_prequisites :"Course prerequisites",
	   select_status:"Select status",
	   select_school:"Select Schools",
	   select_period:"Select Period",
	   room_number:"Room Number",
	   select_room_number:"Select Room Number",
	   Service:"Service",
	   enter_url:"Enter Url",
	   edit_section:"Edit Section",
	   activity_templates:"Activity templates",
	   select_activity_templates:"Select activity template",
	   link_section:"Link Section",
	   select_link_section:"Select link section",
	   please_select_sections:"Please select sections.",
	   if_you_change_your_status_of_inactivity:"If you change your status of inactivity, the student will be affected.",
	   closing_the_global_section_will_cause:"Closing the global section will cause closure in all schools, and withdrawal of all students in them. Please click Confirm if you want to proceed.",
	   upload_import_data:"Upload & Import Data",
	   here:"Here",
	   no_data_avalable_in_table:"No data available in table",
	   add_teacher_to_multiple_section:"Add Teacher(S) To Multiple Sections",
	   select_teachers_to_add_to_multiple_section:"Select teachers to add to multiple selections",
	   selected:"Selected",
	   selected_all:"Select All",
	   deselected_all:"Deselect All",
	   remove_teacher_from_multiple_section:"Remove Teacher(S) From Multiple Sections",
	   select_teacher_to_remove_to:"Select teachers to remove to multiple selections",
	   process_removal:"Process Removal",	   
	   clone_section:"Clone Section",
	   enroll_student:"Enroll Student",
	   enroll_student_to:"Enroll Students to",
	   name:"Name",
	   search_for_a_student_or_id:"Search for a student or ID …",
	   confirmation_of_enrollment:"CONFIRMATION OF ENROLLMENT",
	   please_review_and_confirm_enrollments_for:"Please review and confirm enrollments for",
	   confirm:"Confirm",
	   //enroll_students_to_section:"ENROLL STUDENTS TO SECTION",
	   enrollment_period:"Enrollment period",
	   days:"days",
	    no_data_avalible:"No data available.",
	   number_of_primary_teacher:"Number of Primary Teachers",
	   secondary_teachers:"Secondary Teachers",
	   department_head:"Department Head",
	   section_enroll:"Section Enroll",
	   load_from_file:"Load from File",
	   see_sections:"See Sections",
	   change_enrollment_status:"Change Enrollment Status",
	   mentor_s:"Mentor(s)",
	   overdue_activities:"Overdue Activities",
	   total_session_time_and_last_log:"Total Session Time and last log",
	   course_name_on_transcript:"Course Name on Transcript",
	   edit_other_grades:"Edit Other Grades",
	   save_as:"Save As",
	   account_receivable_dashboard:"Account Receivable Dashboard",
	   key_performance_indicators:"Key Performance Indicators",
	   a_r_dashboard:"A/R Dashboard",
	   payments_credits:"Payments / Credits",
	   contract_templates:"Contract Templates",
	   master_contracts:"Master Contracts",
	   a_r_configuration:"A/R Configuration",
	   a_r_processing:"A/R Processing",
	   aging:"Aging",
	   receivable:"Receivable",
	   account_receivable_by_program:"Account Receivable by Program",
	   request_detail:"Request Detail",
	   request_information:"Request Information",
	   requested_by:"Requested By",
	   approved_by:"Approved By",
	   approve:"Approve",
	   phone_name:"Phone Name",
	   phone_carrier:"Phone Carrier",
	   area_code:"Area Code",
	   address_lable:"Address Lable",
	   address_default:"Address Default",
	   new_photo:"New Photo",
	   current_of_wweeks:"Current # of weeks",
	   select_enrollment_period:"Select Enrollment Period",
	   enter_rejection_reason:"Enter rejection reason...",
	   comments_and_documents:"Comments & Documents",
	   enrollment_history:"Enrollment History",
	   request_extension_for:"Request Extension for",
	   extended_of_weeks:"Extended # of weeks",
	   current_enrollment_status:"Current Enrollment Status",
	   select_extension_option:"Select Extension Option",
	   extend_current_enrollment_until:"Extend current enrollment until",
	   transfer_to_new_section:"Transfer to new Section",
	   transcript_requests:"Transcript Requests",
	   person_requesting_transcript:"Person Requesting Transcript",
	   telephone_number:"Telephone Number",
	   number_of_copies:"Number of Copies",
	   special_instructions:"Special Instructions",
	   last_school_attendance:"Last School Attendance",
	   year_last_attended:"Year Last Attended",
	   current_address:"Current Address",
	   relationship_to_student:"Relationship To Student",
	   method_of_delivery:"Method of Delivery",
	   instructions:"*Instructions",
	   previous_requests:"Previous requests",
	   additional_info:"Additional Info",
	   receive:"Receive",
	   process:"Process",
	   add_to_school_group:"Add To School Group",
	   submit_romote:"Submit Promote",
	   next_grade_level:"Next Grade Level",
	   please_select_a_school_for_promotion_and_transfer:"Please select a school for promotion and transfer",
	   write_off:"Write Off",
	   amount_due:"Amount Due",
	   open_amount:"Open Amount",
	   payment_application:"Payment Application",
	   use_credit_openBalance:"Use Credit $111",
	   payment_amount_usd:"Payment Amount (USD)",
	   check_number:"Check Number",
	   confirmation_number:"Confirmation Number",
	   apply_payment:"Apply Payment",
	   amount_paid:"Amount Paid",
	   applied_payment:"Applied Payment",
	   payer_id:"Payer ID",
	   view_detail:"View Detail",
	   master_contract:"Master Contract",
	   copy:"Copy",
	   contract_user_detail:"Contract User Detail",
	   follow_product_cost:"Follow Product Cost",
	   default_cost:"Default Cost",
	   offered_cost:"Offered Cost",
	   contract_detail:"Contract Detail",
	   contract_template_name:"Contract Template Name",
	   master_contract_name:"Master Contract Name",
	   view_students:"View Students ", 
	   make_payment:"Make Payment", 
	   parent_page:"Parent Page", 
	   edit_parent:"Edit Parent", 
	   edit_profile:"Edit Profile", 
	   account_receivable_configuration:"Account Receivable Configuration", 
	   invoice_generation_date:"Invoice Generation Date", 
	   invoice_generation:"Invoice Generation", 
	   number_of_days_until_due_date:"Number of Days until Due Date", 
	   account_receivable_processing:"Account Receivable Processing", 
	   generate_invoices:"Generate Invoices", 
	   process_automatic_payments:"Process Automatic Payments", 
	   send_late_notices:"Send Late Notices", 
	   course:"Course", 
	   copy_courses:"Copy Courses", 
	   copy_to_school:"Copy To School", 
	   originating_program_code:"Originating Program Code", 
	   destinating_program_code:"Destinating Program Code", 
	   status_error:"Status/Error", 
	   add_prerequisite:"Add Prerequisite", 
	   group_name:"Group Name", 
	   enter_group_name:"Enter Group Name", 
	   select_a_department_to_display_courses:"Select a department to display courses", 
	   edit_tranferred_grades:"Edit Other Grades", 
	   showing_num_records:"Showing 000 records", 
	   edit_all_other_grades:"Edit All Other Grades", 
	   upload_student_documents:"Upload Student Documents", 
	   select_an_official_transcript_option:"Select an official transcript option", 
	   for_schools_or_personal_copy:"For Schools or Personal Copy", 
	   for_student_use_send_to_another_school_or_to_verify_enrollment:"For student use, send to another school, or to verify enrollment.", 
	   request_official_transcript:"Request Official Transcript", 
	   PARCHMENT_for_colleges_or_universities:"PARCHMENT For Colleges or Universities", 
	   for_application_to_a_college_university_and_to_verify_completion_of_your_diploma:"For application to a college/university and to verify completion of your diploma.", 
	   request_transcript:"Request Transcript", 
	   Learn_more_about_how_to_use_PARCHMENT:"Learn more about how to use PARCHMENT", 
	   print_PDF:"Print PDF", 
	   user_school:"User School", 
	   filter:"Filter", 
	   GENERAL:"GENERAL", 
	   STUDENT_INFO:"STUDENT INFO", 
	   list:"List", 
	   last_school_name:"Last School Name", 
	   TEACHER_INFO:"TEACHER INFO", 
	   contracted_load:"Contracted Load", 
	   ARENT_INFO:"PARENT INFO", 
	   add_credential:"Add Credential", 
	   edit_credential:"Edit Credential", 
	   add_comment_document:"Add Comment & Document", 
	   add_comment_document_for:"Add Comment & Document for", 
	   state_province:"State/ Province", 
	   post_code:"Post Code", 
	   linking_students_to:"Linking Students to", 
	   change_expiration_date:"Change Expiration Date", 
	   expiry_date:"Expiry Date", 
	   please_select_department:"Please select Department.", 
	   please_select_course:"Please select Course.", 
	   please_select_title:"Please enter Title.", 
	   please_select_primary_teacher:"Please select Primary Teacher.", 
	   please_select_weeks:"Please select Weeks.", 
	   please_select_level:"Please select Level.", 
	   please_select_credits:"Please select credits.", 
	   please_select_type:"Please select Type.", 
	   please_select_daily_period:"Please select Daily Period.", 
	   please_enter_link_section:"Please enter link section.", 
	   please_enter_first_name:"Please enter First Name.", 
	   please_enter_last_name:"Please enter Last Name.", 
	   please_enter_contracted:"Please enter Contracted.", 
	   please_enter_email:"Please enter Email.", 
	   please_enter_phone:"Please enter Phone.", 
	   please_enter_username:"Please enter Username.", 
	   please_enter_password:"Please enter password.", 
	   please_enter_status:"Please select status.", 
	   save_successful:"Save Successful!.", 
	   please_add_student_address:"Please add student address.", 
	   please_enter_email_address:"Please enter Email Address.", 
	   please_select_relationship:"Please select relationship.", 
	   please_select_parent_status:"Please select Parent Status.", 
	   please_enter_label:"Please enter Label.", 
	   please_enter_address:"Please enter Address.", 
	   please_enter_city:"ದಯವಿಟ್ಟು ನಗರವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_state:"ದಯವಿಟ್ಟು ರಾಜ್ಯವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_zip_code:"ದಯವಿಟ್ಟು ಪಿನ್ ಕೋಡ್ ನಮೂದಿಸಿ.", 
	   please_select_date_of_birth:"ದಯವಿಟ್ಟು ಹುಟ್ಟಿದ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_select_track:"ದಯವಿಟ್ಟು ಟ್ರ್ಯಾಕ್ ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_graduation_date:"ದಯವಿಟ್ಟು ಪದವಿ ದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_country:"ದಯವಿಟ್ಟು ದೇಶವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_phone_number:"ದಯವಿಟ್ಟು ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_parent_first_name:"ದಯವಿಟ್ಟು ಪೋಷಕರ ಮೊದಲ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_parent_last_name:"ದಯವಿಟ್ಟು ಪೋಷಕರ ಕೊನೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_parent_email_address:"ದಯವಿಟ್ಟು ಪೋಷಕ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_parent_username:"ದಯವಿಟ್ಟು ಪೋಷಕ ಬಳಕೆದಾರ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_parent_relationship:"ದಯವಿಟ್ಟು ಪೋಷಕ ಸಂಬಂಧವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_phone_label:"ದಯವಿಟ್ಟು ಫೋನ್ ಲೇಬಲ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   student_address_canot_be_empty:"ವಿದ್ಯಾರ್ಥಿ ವಿಳಾಸ ಖಾಲಿ ಇರುವಂತಿಲ್ಲ.", 
	   please_select_document_type:"ದಯವಿಟ್ಟು ಡಾಕ್ಯುಮೆಂಟ್ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_new_type:"ದಯವಿಟ್ಟು ಹೊಸ ಪ್ರಕಾರವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_comment:"ದಯವಿಟ್ಟು ಕಾಮೆಂಟ್ ನಮೂದಿಸಿ.", 
	   link_is_not_a_valid_url:"ಲಿಂಕ್ ಮಾನ್ಯವಾದ url ಅಲ್ಲ.", 
	   please_enter_link_and_label:"ದಯವಿಟ್ಟು ಲಿಂಕ್ ಮತ್ತು ಲೇಬಲ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   are_you_sure_to_delete_this_student:"ಈ ವಿದ್ಯಾರ್ಥಿಯನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ.", 
	   please_select_gender:"ದಯವಿಟ್ಟು ಲಿಂಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   school_contracted_load:"ಶಾಲೆಯ ಗುತ್ತಿಗೆ ಹೊರೆ", 
	   global_contracted_load:"ಜಾಗತಿಕ ಗುತ್ತಿಗೆ ಲೋಡ್", 
	   please_enter_label_for_attachments:"ಲಗತ್ತುಗಳಿಗಾಗಿ ದಯವಿಟ್ಟು ಲೇಬಲ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_section:"ದಯವಿಟ್ಟು ವಿಭಾಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   enrollment_completed_successfully:"ದಾಖಲಾತಿ ಯಶಸ್ವಿಯಾಗಿ ಪೂರ್ಣಗೊಂಡಿದೆ.", 
	   delete_this_comment:"ಈ ಕಾಮೆಂಟ್ ಅಳಿಸುವುದೇ?", 
	   please_enter_course_name:"ದಯವಿಟ್ಟು ಕೋರ್ಸ್ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_credits_possible:"ದಯವಿಟ್ಟು ಸಾಧ್ಯವಿರುವ ಕ್ರೆಡಿಟ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   can_save_record:"ದಾಖಲೆಯನ್ನು ಉಳಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ", 
	   are_you_sure_to_delete_this_tranferred_grade:"ಈ ವರ್ಗಾವಣೆಗೊಂಡ ಗ್ರೇಡ್ ಅನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?", 
	   are_you_sure_to_delete_num_tranferred_grade:"11 ವರ್ಗಾವಣೆಗೊಂಡ ಗ್ರೇಡ್ ಅನ್ನು ಅಳಿಸಲು ನೀವು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?", 
	   please_select_tranferred_grade:"ದಯವಿಟ್ಟು ವರ್ಗಾಯಿಸಿದ ದರ್ಜೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_ente_subject:"ದಯವಿಟ್ಟು ವಿಷಯವನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_made_to:"ದಯವಿಟ್ಟು ಮಾಡಿದ್ದು ಆಯ್ಕೆಮಾಡಿ.", 
	   delete_this_communication:"ಈ ಸಂವಹನವನ್ನು ಅಳಿಸುವುದೇ?", 
	   please_select_school:"ದಯವಿಟ್ಟು ಶಾಲೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_name:"ದಯವಿಟ್ಟು ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_group_name:"ದಯವಿಟ್ಟು ಗುಂಪಿನ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   you_have_some_form_errors_please_check_above:"ನೀವು ಕೆಲವು ಫಾರ್ಮ್ ದೋಷಗಳನ್ನು ಹೊಂದಿರುವಿರಿ. ದಯವಿಟ್ಟು ಮೇಲೆ ಪರಿಶೀಲಿಸಿ.", 
	   please_select_recipient:"ದಯವಿಟ್ಟು ಸ್ವೀಕರಿಸುವವರನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_description:"ದಯವಿಟ್ಟು ವಿವರಣೆಯನ್ನು ನಮೂದಿಸಿ.", 
	   delete_this_resource:"ಈ ಸಂಪನ್ಮೂಲವನ್ನು ಅಳಿಸುವುದೇ?", 
	   please_enter_activity_name:"ದಯವಿಟ್ಟು ಚಟುವಟಿಕೆಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_activity_type:"ದಯವಿಟ್ಟು ಚಟುವಟಿಕೆಯ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_max_score:"ದಯವಿಟ್ಟು ಗರಿಷ್ಠ ಸ್ಕೋರ್ ನಮೂದಿಸಿ.", 
	   please_enter_due_date:"ದಯವಿಟ್ಟು ಅಂತಿಮ ದಿನಾಂಕವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_unit_name:"ದಯವಿಟ್ಟು ಘಟಕದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   are_you_sure_to_clear_this_unit:"ಈ ಘಟಕವನ್ನು ತೆರವುಗೊಳಿಸುವುದು ಖಚಿತವೇ?", 
	   please_enter_score:"ದಯವಿಟ್ಟು ಸ್ಕೋರ್ ನಮೂದಿಸಿ.", 
	   delete_this_credential:"ಈ ರುಜುವಾತು ಅಳಿಸುವುದೇ?", 
	   plase_select_period:"ದಯವಿಟ್ಟು ಅವಧಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ", 
	   plase_select_start_date:"ದಯವಿಟ್ಟು ಪ್ರಾರಂಭ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ", 
	   plase_select_end_date:"ದಯವಿಟ್ಟು ಅಂತಿಮ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ", 
	   select_to_register_course_to_students_individual_learning_path_view:"ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ವೈಯಕ್ತಿಕ ಕಲಿಕೆಯ ಮಾರ್ಗ ವೀಕ್ಷಣೆಯನ್ನು ನೋಂದಾಯಿಸಲು ಆಯ್ಕೆಮಾಡಿ", 
	   delete_this_request:"ಈ ವಿನಂತಿಯನ್ನು ಅಳಿಸುವುದೇ?", 
	   please_enter_fname:"ದಯವಿಟ್ಟು fname ಅನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_lname:"ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_birthday:"ದಯವಿಟ್ಟು ಜನ್ಮದಿನವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_address:"ದಯವಿಟ್ಟು ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_zip:"ದಯವಿಟ್ಟು ಜಿಪ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_country:"ದಯವಿಟ್ಟು ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_ethnicity:"ದಯವಿಟ್ಟು ಜನಾಂಗೀಯತೆಯನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_grade:"ದಯವಿಟ್ಟು ಗ್ರೇಡ್ ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_mobile:"ದಯವಿಟ್ಟು ಮೊಬೈಲ್ ನಮೂದಿಸಿ.", 
	   please_enter_hear_about_us:"ದಯವಿಟ್ಟು ನಮ್ಮ ಬಗ್ಗೆ ಕೇಳಲು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_program_of_interest:"ದಯವಿಟ್ಟು ಆಸಕ್ತಿಯ ಕಾರ್ಯಕ್ರಮವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   please_enter_course_level:"ದಯವಿಟ್ಟು ಕೋರ್ಸ್ ಮಟ್ಟವನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_guardian_1_name:"ದಯವಿಟ್ಟು ಗಾರ್ಡಿಯನ್ 1 ಹೆಸರನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_guardian_1_email:"ದಯವಿಟ್ಟು ಗಾರ್ಡಿಯನ್ 1 ಇಮೇಲ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_guardian_1_home_phone:"ದಯವಿಟ್ಟು ಗಾರ್ಡಿಯನ್ 1 ಹೋಮ್ ಫೋನ್ ಅನ್ನು ನಮೂದಿಸಿ.", 
	   please_enter_guardian_1_relation:"ದಯವಿಟ್ಟು ಗಾರ್ಡಿಯನ್ 1 ಸಂಬಂಧವನ್ನು ನಮೂದಿಸಿ.", 
	   please_select_parents:"ದಯವಿಟ್ಟು ಪೋಷಕರನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   transfer_classroom:"ತರಗತಿಯನ್ನು ವರ್ಗಾಯಿಸಿ", 
	   please_choose_one_section_to_transfer:"ವರ್ಗಾಯಿಸಲು ದಯವಿಟ್ಟು ಒಂದು ವಿಭಾಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   transfer:"ವರ್ಗಾವಣೆ", 
	   assigning_multiple_users_to_a_school_or_school_group:"ಶಾಲೆ ಅಥವಾ ಶಾಲೆಯ ಗುಂಪಿಗೆ ಬಹು ಬಳಕೆದಾರರನ್ನು ನಿಯೋಜಿಸುವುದು", 
	   add_to_school_or_school_group:"ಶಾಲೆ ಅಥವಾ ಶಾಲಾ ಗುಂಪಿಗೆ ಸೇರಿಸಿ", 
	   please_select_school_or_school_group:"ದಯವಿಟ್ಟು ಶಾಲೆ ಅಥವಾ ಶಾಲೆಯ ಗುಂಪನ್ನು ಆಯ್ಕೆಮಾಡಿ.", 
	   print_student_progress_report:"ವಿದ್ಯಾರ್ಥಿಗಳ ಪ್ರಗತಿ ವರದಿಯನ್ನು ಮುದ್ರಿಸಿ", 
	  
 },

}

//export const languagesArray = Object.keys(languages)

export default languages
